/* eslint-disable no-unused-vars */
function bpmpi_config() {
  function getQueryString(field) {
    var href = window.location.href;
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
  }
  var env = getQueryString("env");
  return {
    onReady: function () {
      // Evento indicando quando a inicialização do script terminou.            
      window._3ds.onReady3ds();
    },
    onSuccess: function (e) {
      // Cartão elegível para autenticação, e portador autenticou com sucesso.
     /* var cavv = e.Cavv;
      var xid = e.Xid;
      var eci = e.Eci;
      var version = e.Version;
      var referenceId = e.ReferenceId;*/
      window._3ds.set3dsAuthentication(e);
    },
    onFailure: function (e) {
      // Cartão elegível para autenticação, porém o portador finalizou com falha.
      /*var xid = e.Xid;
      var eci = e.Eci;
      var version = e.Version;
      var referenceId = e.ReferenceId;*/
      window._3ds.onFailure(e);     
    },
    onUnenrolled: function (e) {
      // Cartão não elegível para autenticação (não autenticável).
      /* var xid = e.Xid;
      var eci = e.Eci;
      var version = e.Version;
      var referenceId = e.ReferenceId; */
      window._3ds.onUnenrolled(e);            
    },
    onDisabled: function () {
      // Loja não requer autenticação do portador (classe "bpmpi_auth" false -> autenticação desabilitada).
    },
    onError: function (e) {
      // Erro no processo de autenticação.
      /*var xid = e.Xid;
      var eci = e.Eci;
      var returnCode = e.ReturnCode;
      var returnMessage = e.ReturnMessage;
      var referenceId = e.ReferenceId;*/
      window._3ds.onError(e);     
    },
    onUnsupportedBrand: function (e) {
      // Bandeira não suportada para autenticação.
      /*var returnCode = e.ReturnCode;
      var returnMessage = e.ReturnMessage;*/
      window._3ds.onUnsupportedBrand(e);        
    },
    Environment: /* env ? env : */ "PRD",
    Debug: false
  };
}

(function() {
  'use strict';

  angular
    .module('b2c_ingressos', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'angular-loading-bar', 'ui.mask', 'LocalStorageModule', 'angular-google-analytics', 'ImageZoom', 'ui.bootstrap-slider', 'ngclipboard']);

})();

(function () {
    angular
            .module('b2c_ingressos')
            .controller('TimespanController', _timespanController);

    /** @ngInject */
    function _timespanController($scope, $location, MyFunctions) {
        /* jshint validthis:true */
        var vm = this;
        vm.today = new Date();
        vm.date = new Date();
        vm.endDate = new Date();
        vm.pesquisar = function () {
            $scope.$parent.$parent.vm.search(vm.date, vm.endDate);
        };
        var parameters = $location.search();
        if (angular.isDefined(parameters) && parameters !== null) {
            if (parameters.endDate !== null && parameters.endDate !== "" && angular.isDefined(parameters.endDate)) {               
                vm.endDate = MyFunctions.stringToDate(parameters.endDate);                
            }
            if (parameters.date !== null && parameters.date !== "" && angular.isDefined(parameters.date)) {
                if (vm.resetCarrinho) vm.reset();                
                vm.date = MyFunctions.stringToDate(parameters.date);            
            }
        }

    }
})();
/**
 * Created by welker on 18/04/17.
 */

/**
 * @typedef {import("../../../types/properties").PropertiesType} PropertiesType
 * @typedef {import("../../../types/ingresso").IngressoType} IngressoType
 */

(function () {
    angular
            .module('b2c_ingressos')
            .controller('CalendarioController', _calendarioController);

    /**
     * @ngInject
     * @param {PropertiesType} Properties
     */
    function _calendarioController($scope, $state, $location, MyFunctions, BackEnd, ErrorHandler, Tracking, Properties, CalendarService, Cart, $log) {
        /* jshint validthis:true */
        var vm = this;

        vm.today = MyFunctions.stringToDate(MyFunctions.dateToString(new Date()));
        vm.tomorrow = MyFunctions.addDays(vm.today, 1);

        vm.dt2 = MyFunctions.addDays(new Date(), -31);
        //vm.dt2 = vm.today;
        vm.initialDate = new Date();
        vm.minDate = new Date();
        if (Properties.naoEscolheData_Dias !== null && angular.isDefined(Properties.naoEscolheData_Dias))
            vm.minDate = MyFunctions.addDays(vm.minDate, Properties.naoEscolheData_Dias);
        vm.valuesByDate = {};
        var parameters = $location.search();
        var clearCache = false;
        if (angular.isDefined(parameters) && parameters !== null) {
            clearCache = parameters.limpacache ? true : false;
        }
        var _calendarDate = null;
        if (angular.isDefined(parameters) && parameters !== null && parameters.calendarDate) {
            _calendarDate = parameters.calendarDate;
        }
        if (parameters.ingToken !== null && parameters.ingToken !== "" && angular.isDefined(parameters.ingToken)) {
            vm._ingToken = parameters.ingToken;
        }
        function isSameOrigin() {
          try {
            // Tenta acessar algo simples do topo
            var same = window.top.location.hostname === window.location.hostname;
            return same;
          } catch (e) {
            // Se der erro, é porque são origens diferentes
            return false;
          }
        }

        vm.pesquisar = function () {
          if($scope.$parent == null || $scope.$parent.$parent == null || $scope.$parent.$parent.vm == null) {
            var url = $location.absUrl();
            url = url.replace('calendario.html', '');
            // Remove o hashbang (#! ou #/) se houver
            url = url.replace(/#\/?/, '');
            var urlObj = new URL(url, window.location.origin);
            // Remove parâmetro date anterior (se houver)
            urlObj.searchParams.delete('date');
            // Adiciona o novo parâmetro
            urlObj.searchParams.append('date', MyFunctions.dateToString(vm.dt2));
            // Gera a nova URL limpa
            url = urlObj.toString();
            if($location.absUrl().indexOf('#/') >= 0){
              url = url.replace(window.location.origin + '/', window.location.origin + '/#/');
            }            

            if(isSameOrigin()) {
              if(window.top !== window){
                window.top.location.href = url;
                return;
              }
              window.location.href = url;
            } else {
              window.open(url, '_blank');
            }
            return;
          }
          $scope.$parent.$parent.vm.searchInReset(vm.dt2);
        };


        /**
         * Usado para desativar botão de Pesquisar quando a data não for válida.
         * Precisa ativar esse funcionamento pelas Properties no campo `calendarioExigeDataValida`.
         */
        vm.isSelectedDateValid = function () {
            return Properties.calendarioExigeDataValida && !!vm.disabledDate(vm.dt2, 'day');
        };

        $scope.$on("updateCalendar", function($event, date) {
            $log.debug($event);
            vm.dt2 = date;
        });
        var isFirstOpen = true;
        Tracking.addListener(Tracking.types.ShowProducts,
            function (ps, date) {
                $log.debug(ps,date);
                if(isFirstOpen){
                    isFirstOpen = false;
                    vm.dt2 = Cart.minDate(); //vm.today;
                }
                if(MyFunctions.dateToString(vm.dt2) != date)
                    vm.dt2 = MyFunctions.stringToDate(date);
            }
        );

        vm.verificarDatas = function (dateByType) {
          var datasFechadas = [];
          var datasAbertas = [];
          var primeiraDataDisponivel = null;

          dateByType.forEach(function (item) {
            if (item.type === "Parque Aberto") {
              datasAbertas = datasAbertas.concat(item.properties.dates);
            } else if (item.type === "Parque Fechado") {
              datasFechadas = datasFechadas.concat(item.properties.dates);
            }
          });

          for (var i = 0; i < datasAbertas.length; i++) {
            var data = datasAbertas[i];
            var estaFechada = datasFechadas.includes(data);
            if (!estaFechada && !primeiraDataDisponivel) {
              primeiraDataDisponivel = data;
            }
          }
          return primeiraDataDisponivel;
        };

        vm.isLoadDates = false;
        vm.datesByType = [];
        CalendarService.calendarMessages(vm.datesByType, function(){
            var _dt2 = Properties.calendarioNaoIniciado ? MyFunctions.addDays(new Date(), -1) : Cart.minDate();
            if(Properties.dataAbertura && Properties.dataAbertura > _dt2) _dt2 = Properties.dataAbertura;
            else if (Properties.desativarHoje) _dt2 = vm.tomorrow;
            try {
              var _date = Properties.buscaProximaDataValida && vm.verificarDatas(
                vm.datesByType
              );
              if(_calendarDate) _dt2 = MyFunctions.stringToDate(_calendarDate);
              if (_date) _dt2 = MyFunctions.stringToDate(_date);
            } catch (error) {
                $log.info("data incorreta", _calendarDate);
            }
            vm.isLoadDates = true;
            vm.dt2 = _dt2;
        });
        /*
        BackEnd.execute2({'method': 'calendarMessages', 'clearCache': clearCache},
                function (data) {
                    function haveItem(arrItem, param) {
                        return arrItem.some(function (i) {
                            return i.type === param;
                        });
                    }
                    for (var i = 0; i < data.length; i++) {
                        var date = data[i];
                        var dateType = date.tipo || "none";
                        var hasType = haveItem(vm.datesByType, dateType);
                        if (!hasType)
                            vm.datesByType.push({type: dateType, properties: date});
                        else {
                            var _arr = vm.datesByType.filter(function(a){
                                return a.type == dateType;
                            });
                            _arr[0].properties.dates = _arr[0].properties.dates.concat(date.dates);
                        }
                    }
                    var _dt2 = Properties.calendarioNaoIniciado ? MyFunctions.addDays(new Date(), -1) : vm.today;
                    if(Properties.dataAbertura && Properties.dataAbertura > _dt2) _dt2 = Properties.dataAbertura;
                    else if (Properties.desativarHoje) _dt2 = vm.tomorrow;
                    try {
                        if(_calendarDate) _dt2 = MyFunctions.stringToDate(_calendarDate);
                    } catch (error) {
                        $log.info("data incorreta", _calendarDate);
                    }
                    vm.dt2 = _dt2;
                },
                function (err) {
                    ErrorHandler.showError(err);
                }
        );*/

        vm.searchValuesByDate = function () {
            var params = {"method": "valuesByDate",
               'initialDate': MyFunctions.dateToString(vm.initialDate),
               'finalDate': MyFunctions.dateToString(MyFunctions.addDays(vm.initialDate, 42)),
               'clearCache': clearCache
            };
            if(angular.isDefined(vm._ingToken))
                params.ingToken = vm._ingToken;
            // var dialog = Dialogs.wait();
            BackEnd.execute2(params, function (data) {
                    // dialog.close();
                    vm.valuesByDate = data;

                },
                function (err) {
                    // dialog.close();
                    ErrorHandler.showError(err);
                }
            );
        };

        vm.text = function (date, rows) {
            if (MyFunctions.dateToString(vm.initialDate) !== MyFunctions.dateToString(rows[0][0].date)) {
                vm.initialDate = rows[0][0].date;
                vm.searchValuesByDate();
            }
            Properties.r$=Properties.r$ || "R$";
            if (vm.valuesByDate[MyFunctions.dateToString(date)] == null) return "-";
            return Properties.r$ + (vm.valuesByDate[MyFunctions.dateToString(date)] / 100).toFixed(2).replace(".", ",").replace(",00", "");
        };

        /** @return {string} */
        vm.getDayClass = function(date, mode){
          return CalendarService.getDayClass(vm.datesByType, vm.today, date, mode);
        }
        vm.disabledDate = function (date, mode) {
            return CalendarService.disabledDate(vm.datesByType, vm.today, date, mode);
        }
        vm.diferenciaTemporadas = function(tipo){
            return MyFunctions.diferenciaTemporadas(vm.datesByType, tipo);
        };
    }
})();

/**
 * @typedef {import("../../../types/properties").PropertiesType} PropertiesType
 * @typedef {import("../../../types/ingresso").IngressoType} IngressoType
 */

(function() {
    'use strict';

    angular
        .module('b2c_ingressos')
        .factory('CalendarService', CalendarService);
    /**
     * @ngInject
     * @param {PropertiesType} Properties
     */
    function CalendarService(BackEnd, $location, ErrorHandler, MyFunctions, Properties) {
        var parameters = $location.search();
        var clearCache = false;
        if (angular.isDefined(parameters) && parameters !== null) {
            clearCache = parameters.limpacache ? true : false;
        }

        function _calendarMessages(datesByType, success, error) {
            datesByType = datesByType || [];
            success = success || function(){};
            error = error || ErrorHandler.showError;
            BackEnd.execute2({'method': 'calendarMessages', 'clearCache': clearCache},
                function (data) {
                    function haveItem(arrItem, param) {
                        return arrItem.some(function (i) {
                            return i.type === param;
                        });
                    }
                    for (var i = 0; i < data.length; i++) {
                        var date = data[i];
                        var dateType = date.tipo || "none";
                        var hasType = haveItem(datesByType, dateType);
                        if (!hasType)
                            datesByType.push({type: dateType, properties: date});
                        else {
                            var _arr = datesByType.filter(function(a){
                                return a.type == dateType;
                            });
                            _arr[0].properties.dates = _arr[0].properties.dates.concat(date.dates);
                        }
                    }
                    success();
                },
                error
            );
        }

        function _getDayClass(datesByType, today, date, mode) {
            if (mode !== 'day') { return ''; }
            var classes = [];
            today = today || new Date();
            if (date < today) {
                classes.push('old');
            }
            if (date.toString() === today.toString()) {
                classes.push('calendar-today');
            }
            for (var i = 0; i < datesByType.length; i++) {
                var dateType = datesByType[i];

                if (Properties.maxMesesCalendario && Number.isInteger(Number())) {
                    var maxDate = new Date();
                    maxDate.setMonth(maxDate.getMonth() + Properties.maxMesesCalendario);
                    if (date > maxDate) {
                        classes.push('closed');
                    }
                }
                if (dateType.properties.dates.indexOf(MyFunctions.dateToString(date)) < 0) {
                    continue;
                }
                var normalizedType = dateType.type.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                var classMatch = normalizedType.match(/(aberto|black|especial|promocional|alta|baixa|em breve|super|data evento|media|reduzido)/i);
                if (classMatch) {
                  classes.push(classMatch[0].replace(/ /g, "-"));
                }
                if (normalizedType.match(/em breve/)) {
                    classes.push('closed');
                }
                if (normalizedType.match(/esgotado/)) {
                    classes.push('closed');
                    classes.push('esgotado');
                }
                if (normalizedType.match(/restrito/)) {
                    classes.push('closed');
                    classes.push('restrito');
                }
                if (normalizedType.match(/fechado/)) {
                    classes.push('closed');
                }
            }
            return classes.join(' ');
        }

        function _disabledDate(datesByType, today, date, mode) {
            datesByType = datesByType || [];
            today = today || new Date();
            if(mode == 'month' && date.getFullYear() == today.getFullYear() && date.getMonth() == today.getMonth())
               return false;
            if(mode == 'year' && date.getFullYear() == today.getFullYear())
               return false;
            if (date < today) return true;
            if(Properties.dataAbertura && Properties.dataAbertura > date) return true;
            return _getDayClass(datesByType, today, date,mode).indexOf("closed") >= 0;
        }

        return {
            init: function(datesByTypes){
                _calendarMessages(datesByTypes);
            },
            calendarMessages: _calendarMessages,
            getDayClass: _getDayClass,
            disabledDate: _disabledDate
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('HospedagemPesquisaController', HospedagemPesquisaController);

    /** @ngInject */
    function HospedagemPesquisaController(MyFunctions, Dialogs, Search, ScrollTo, localStorageService, $location, ErrorHandler) {
        var vm = this;
        Search.setSelectHotel(null);
        ScrollTo.scrollTo("hospedagem-main");
        function activeParameters() {
            var parameters = $location.search();
            
            if (angular.isUndefined(parameters) || parameters === null)
                return;

            var search = {};
            if (angular.isDefined(parameters.a) && parameters.a !== null && parameters.a.length > 0 && !isNaN(parseInt(parameters.a, 10)))
                    search.adt = parameters.a;
            if (angular.isDefined(parameters.c1) && parameters.c1 !== null && parameters.c1.length > 0 && !isNaN(parseInt(parameters.c1, 10)))
                    search.colo = parameters.c1;     
            if (angular.isDefined(parameters.c3) && parameters.c3 !== null && parameters.c3.length > 0 && !isNaN(parseInt(parameters.c3, 10)))
                    search.chd = parameters.c3;
            if (parameters.destino)
                search.destino = parameters.destino;
            if (parameters.destino == "false")
                search.destino = false;
            if (parameters.tipoHospedagem) {
                search.tipoHotel = parameters.tipoHospedagem.toLowerCase();
            }
            if (parameters.hotelPath)
                search.hotelPath = parameters.hotelPath.replace(/~2F/g, '/');
            var pesquisar = false;
            if (angular.isDefined(parameters.d) && parameters.d !== null && parameters.d.length > 0) {
                var parsedStringDate = parameters.d.replace(/~2F/g, '/');
                var checkin = MyFunctions.stringToDate(parsedStringDate);
                if (checkin.getTime() >= MyFunctions.stringToDate(MyFunctions.dateToString(new Date())).getTime()) {
                    search.date = checkin;
                    if (angular.isDefined(parameters.df) && parameters.df !== null && parameters.df.length > 0) {
                        var parsedStringEndDate = parameters.df.replace(/~2F/g, '/');
                        var endDate = MyFunctions.stringToDate(parsedStringEndDate);
                        if (search.date.getTime() >= endDate.getTime())
                            endDate = MyFunctions.addDays(search.date, 2);
                        search.endDate = endDate;
                        search.noites = MyFunctions.diasEntre(search.date, search.endDate);
                    }
                }
                pesquisar = true;
            }
            var searchs = Search.getSearch();
            if (angular.isDefined(searchs) && searchs !== null && searchs.length > 0) {
                var search1 = searchs[0];
                angular.merge(search1, search);
                search = search1;
            }
            if (search.adt === null || angular.isUndefined(search.adt) || search.adt === 0)
                search.adt = "2";
            if (search.quartos === null || angular.isUndefined(search.quartos) || search.quartos === 0)
                search.quartos = "1";
            Search.setSearch([search]);
            if (pesquisar) {
                Search.getHoteis().then(function (/*hoteis*/) {
                    var dialog = Dialogs.wait();
                    //Search.executeLazySearch(Search.createConsulta(Search.getSearch(),0),                     
                    Search.executeSearch(Search.createConsulta(Search.getSearch(), 0),
                            function (data) {
                                dialog.close();
                                if (angular.isUndefined(data) || data.length === 0) {
                                    Dialogs.again();
                                    return;
                                }                               
                                Search.showStepHotel(search.hotelPath);
                            },
                            function (error) {
                                dialog.close();
                                ErrorHandler.showError(error);
                            }
                    );
                });
            }
        }

        vm.search = function (objs) {
            vm.obj = objs[0];
            vm.aptos = objs;
            vm.getHoteis(objs[0]);
        };

        vm.getHoteis = function (search) {
            var checkin = "";
            var colo = 0;
            var chd = 0;
            var terceiraIdade = 0;
            var days = 0;
            if (angular.isDefined(search.date) && search.date !== null &&
                    angular.isDefined(search.endDate) && search.endDate !== null &&
                    search.endDate.getTime() > search.date.getTime()) {
                checkin = MyFunctions.dateToString(search.date);
                days = MyFunctions.diasEntre(search.date, search.endDate);
                if (angular.isDefined(search.chd) && search.chd > 0) {
                    chd = search.chd;
                }
                if (angular.isDefined(search.terceiraIdade) && search.terceiraIdade > 0) {
                    terceiraIdade = search.terceiraIdade;
                }

                var parametrosConsultaHoteis = {
                    'method': 'hoteisAvailabilityAndPrice',
                    "adulto": search.adt,
                    "colo": colo.toString(),
                    "chd2": chd.toString(),
                    "terceiraIdade": terceiraIdade.toString(),
                    "checkin": checkin,
                    "checkout": MyFunctions.dateToString(search.endDate),
                    "noites": days.toString()
                };
                localStorageService.set('parametrosConsulta', parametrosConsultaHoteis);
                localStorageService.remove('resultPesquisa');
                Search.showStepHotel();
            }
        };

        activeParameters();

    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('HospedagemHoteisController', HospedagemHoteisController);

    /** @ngInject */
    function HospedagemHoteisController($log, $uibModal, Properties, MyFunctions, Search, Dialogs, ErrorHandler, $state, localStorageService, $window, $filter, ScrollTo, Auth) {
        var vm = this;
        resetHotelSearch();
        vm.isSearching = Search.isSearching;
        vm.personsAsString = Search.personsAsString;
        var containerWidth = parseInt($window.innerWidth);
        vm.verificaDialogChd = Properties.usaIdadePorCrianca;
        vm.aptoIndex = 0;
        var searchs = Search.getSearch();
        if (searchs === null || angular.isUndefined(searchs) || searchs.length === 0) {
            $state.go("hospedagemPesquisa");
        }

        vm.consulta = Search.createConsulta(searchs, vm.aptoIndex);
        
        vm.searchs = Search.getSearch();
        vm.search = vm.searchs[0];
        vm.adt = Search.adultos();
        vm.chd = Search.criancas();
        vm.colo = Search.colos();

        ScrollTo.scrollTo("hospedagem-main");
        Search.setSelectHotel(null);

        /* vm.orderHotelsByPrice = function (a, b) {
         if(angular.isUndefined(a)) return 0;
         if(angular.isUndefined(b)) return 1;
         return a.item.value - b.item.value;
         };*/
        var orderUhsByPrice = function (a, b) {
            return a.value - b.value;
        };

        function resetHotelSearch(){
            var searchsReset = Search.getSearch();
            searchsReset[0].hotelPath = null; 
            Search.setSearch(searchsReset);
        }
        
        vm.searchVertical = function (search) {
            var parametrosConsultaHoteis = {
                'method': 'hoteisAvailabilityAndPrice',
                "adulto": search[0].adt,
                "colo": search[0].colo === null || angular.isUndefined(search[0].colo) ? "0" : search[0].colo.toString(),
                "chd2": search[0].chd === null || angular.isUndefined(search[0].chd) ? "0" : search[0].chd.toString(),
                "checkin": MyFunctions.dateToString(search[0].date),
                "checkout": MyFunctions.dateToString(search[0].endDate),
                "noites": MyFunctions.diasEntre(search[0].date, search[0].endDate).toString()
            };
            localStorageService.set('parametrosConsulta', parametrosConsultaHoteis);
            localStorageService.remove('resultPesquisa');
            $state.reload();
        };

        /*====================================================================*/
        /*------------------------ Functions filtros itens -------------------*/
        function limpaItensRepetidos(array) {
            var arrayLimpo = [];
            for (var i = 0; i < array.length; i++) {
                var auxI = array[i];
                var encontrou = false;
                for (var j = 0; j < arrayLimpo.length; j++) {
                    var auxJ = arrayLimpo[j];
                    if (auxJ.nome === auxI.nome) {
                        encontrou = true;
                        break;
                    }
                }
                if (!encontrou) {
                    arrayLimpo.push(auxI);
                }
            }
            return arrayLimpo;
        }

        function buscaItensHoteis() {
            vm.ItensComodidades = [];
            vm.itensLazer = [];
            vm.ItensEsportivos = [];
            vm.ItensSeguranca = [];
            vm.allItens = [];

            for (var h = 0; h < vm.hoteis.length; h++) {
                for (var c = 0; c < vm.hoteis[h].item.comodidades.length; c++) {
                    if (vm.hoteis[h].item.comodidades[c].imagem !== "") {
                        if (vm.hoteis[h].item.comodidades[c].categoria === 'Comodidades') {
                            vm.ItensComodidades.push(vm.hoteis[h].item.comodidades[c]);
                        }
                        if (vm.hoteis[h].item.comodidades[c].categoria === 'Lazer') {
                            vm.itensLazer.push(vm.hoteis[h].item.comodidades[c]);
                        }
                        if (vm.hoteis[h].item.comodidades[c].categoria === 'Esportivas') {
                            vm.ItensEsportivos.push(vm.hoteis[h].item.comodidades[c]);
                        }
                        if (vm.hoteis[h].item.comodidades[c].categoria === 'Segurança') {
                            vm.ItensSeguranca.push(vm.hoteis[h].item.comodidades[c]);
                        }
                    }
                }
            }
            vm.allItens.push(limpaItensRepetidos(vm.ItensComodidades));
            vm.allItens.push(limpaItensRepetidos(vm.itensLazer));
            vm.allItens.push(limpaItensRepetidos(vm.ItensEsportivos));
            vm.allItens.push(limpaItensRepetidos(vm.ItensSeguranca));

        }
        function updatePriceRange() {
            angular.forEach(vm.hoteis, function (hotel) {
                var total = hotel.item.value / 100;
                if (total > vm.hotelValueMax) {
                    vm.hotelValueMax = total;
                }
                if (total < vm.hotelValueMin) {
                    vm.hotelValueMin = total;
                }
            });
            vm.rangePrecoHotel[0] = vm.hotelValueMin - 5;
            vm.rangePrecoHotel[1] = vm.hotelValueMax + 5;
            vm.hotelValueMin -= 10;
            vm.hotelValueMax += 10;
        }
        /*------------------------ Functions filtros itens -------------------*/
        /*====================================================================*/

        var dialog = Dialogs.wait();        
        Search.executeSearch(vm.consulta,
                function (data) {
                    dialog.close();
                    if (angular.isUndefined(data) || data.length === 0) {
                        Dialogs.again();
                        $state.go("hospedagemPesquisa");
                        return;
                    }   
                    vm.hoteis = data;                    
                    vm.hoteis.forEach(function (hotel) {
                        if (hotel.item.localizacao && hotel.item.localizacao.indexOf("http") === 0) {
                            hotel.item.linkmap = hotel.item.localizacao;
                        }
                        hotel.result.sort(orderUhsByPrice);
                    });
                    localStorageService.remove('resultPesquisa');
                    localStorageService.set('resultPesquisa', vm.hoteis);
                    vm.isSearching = Search.isSearching;
                    activate();
                    
                },
                function (error) {
                    dialog.close();
                    ErrorHandler.showError(error);
                },
                function () { //OnFullComplete
                    vm.isSearching = Search.isSearching;
                    vm.allTiposEmpreendimentos = vm.buscaTiposEmpreendimentos();
                    vm.allDestinos = vm.buscaTiposDestinos();
                    vm.hoteis = vm.hoteis.filter(function(h){
                        if(h.item.unavailable && angular.isUndefined(h.item.unavailableMsg))
                            return false;                        
                        return true;
                    });
                    buscaItensHoteis();
                    updatePriceRange();
                }
        );
        
        function activate() {

            vm.foto = _foto;

            if (containerWidth <= 1024) {
                vm.rowFiltersHoteisIsOpen_mobile = true;
            }

            vm.selectHotel = function (hotel) {
                // vm.selectedHotel = hotel;
                Search.setSelectHotel(hotel);
                $state.go("hospedagemApartamentos");
                // for (var i = 0; i < vm.aptos.length; i++) {
                //     vm.aptos[i].active = false;
                // }
                // vm.aptos[0].active = true;
                // vm.uhs = hotel.result;
                //
                // $log.debug(vm.uhs);
                // if (vm.aptos.length > 1)
                //     Dialogs.info("Selecione o 1º apartamento.");
            };


            /*================================================================*/
            /*------------------------ Filtros de Destinos -------------------*/
            vm.buscaTiposDestinos = function () {
                vm.allDestinos = [];
                angular.forEach(vm.hoteis, function (hotel) {
                    if (angular.isDefined(hotel.item.customData.destino)) {
                        vm.allDestinos.push({
                            nome: hotel.item.customData.destino,
                            imagem: "services/icon-maps.png"
                        });
                    }
                });

                return limpaItensRepetidos(vm.allDestinos);
            };

            vm.allDestinos = vm.buscaTiposDestinos();

            vm.arrayFiltrosDestinos = [];
            if (angular.isDefined(searchs) && angular.isDefined(searchs[0].destino)) {
                vm.arrayFiltrosDestinos.push({
                    nome: searchs[0].destino,
                    imagem: "services/icon-maps.png"
                });
            }
            vm.addfiltroDestinos = function (filtro) {
                if (vm.arrayFiltrosDestinos.indexOf(filtro) < 0) {
                    vm.arrayFiltrosDestinos.push(filtro);
                }
            };

            vm.filtrarDestinos = function (hotel) {
                if (vm.arrayFiltrosDestinos.length === 0) {
                    return true;
                }
                var result = false;
                angular.forEach(vm.arrayFiltrosDestinos, function (filtro) {
                    if (filtro.nome === hotel.item.customData.destino) {
                        result = true;
                        return;
                    }
                });
                return result;
            };

            vm.limparFiltroDestino = function (filtro) {
                vm.arrayFiltrosDestinos.splice(vm.arrayFiltrosDestinos.indexOf(filtro));
            };

            vm.limparFiltrosDestinos = function () {
                vm.arrayFiltrosDestinos = [];
            };
            /*------------------------ Filtros de Destinos -------------------*/
            /*================================================================*/



            /*====================================================================*/
            /*------------------------ Filtros de Tipos --------------------------*/
            vm.buscaTiposEmpreendimentos = function () {
                vm.allTiposEmpreendimentos = [];
                for (var h = 0; h < vm.hoteis.length; h++) {
                    if (vm.hoteis[h].item.customData.tipo === 'Hotel' || vm.hoteis[h].item.customData.tipo === 'Hoteis' || vm.hoteis[h].item.customData.tipo === 'Hotéis' || vm.hoteis[h].item.customData.tipo === 'hotel' || vm.hoteis[h].item.customData.tipo === 'hoteis' || vm.hoteis[h].item.customData.tipo === 'hotéis') {
                        vm.allTiposEmpreendimentos.push({
                            nome: vm.hoteis[h].item.customData.tipo,
                            imagem: "services/icon-hotel.png"
                        });
                    }
                    if (vm.hoteis[h].item.customData.tipo === 'Temporada') {
                        vm.allTiposEmpreendimentos.push({
                            nome: vm.hoteis[h].item.customData.tipo,
                            imagem: "services/icon-flats.png"
                        });
                    }
                    if (vm.hoteis[h].item.customData.tipo === 'Condominio' || vm.hoteis[h].item.customData.tipo === 'Condomínio' || vm.hoteis[h].item.customData.tipo === 'condominio' || vm.hoteis[h].item.customData.tipo === 'condomínio') {
                        vm.allTiposEmpreendimentos.push({
                            nome: vm.hoteis[h].item.customData.tipo,
                            imagem: "services/icon-condominium.png"
                        });
                    }
                    if (vm.hoteis[h].item.customData.tipo === 'Flats' || vm.hoteis[h].item.customData.tipo === 'Flat' || vm.hoteis[h].item.customData.tipo === 'flats' || vm.hoteis[h].item.customData.tipo === 'flat') {
                        vm.allTiposEmpreendimentos.push({
                            nome: vm.hoteis[h].item.customData.tipo,
                            imagem: "services/icon-flats.png"
                        });
                    }
                    if (vm.hoteis[h].item.customData.tipo === 'Chale' || vm.hoteis[h].item.customData.tipo === 'Chales' || vm.hoteis[h].item.customData.tipo === 'Chalé' || vm.hoteis[h].item.customData.tipo === 'Chalés' || vm.hoteis[h].item.customData.tipo === 'chale' || vm.hoteis[h].item.customData.tipo === 'chales' || vm.hoteis[h].item.customData.tipo === 'chalé' || vm.hoteis[h].item.customData.tipo === 'chalés') {
                        vm.allTiposEmpreendimentos.push({
                            nome: vm.hoteis[h].item.customData.tipo,
                            imagem: "services/icon-chale.png"
                        });
                    }
                    if (vm.hoteis[h].item.customData.tipo === 'Camping' || vm.hoteis[h].item.customData.tipo === 'camping' || vm.hoteis[h].item.customData.tipo === 'Acampamento' || vm.hoteis[h].item.customData.tipo === 'acampamento') {
                        vm.allTiposEmpreendimentos.push({
                            nome: vm.hoteis[h].item.customData.tipo,
                            imagem: "services/icon-camping.png"
                        });
                    }
                    if (vm.hoteis[h].item.customData.tipo === 'Casas' || vm.hoteis[h].item.customData.tipo === 'casas') {
                        vm.allTiposEmpreendimentos.push({
                            nome: vm.hoteis[h].item.customData.tipo,
                            imagem: "services/icon-house.png"
                        });
                    }
                    if (vm.hoteis[h].item.customData.tipo === 'Pousadas' || vm.hoteis[h].item.customData.tipo === 'pousadas' || vm.hoteis[h].item.customData.tipo === 'Pousada' || vm.hoteis[h].item.customData.tipo === 'pousada') {
                        vm.allTiposEmpreendimentos.push({
                            nome: vm.hoteis[h].item.customData.tipo,
                            imagem: "services/icon-pousadas.png"
                        });
                    }
                }
                return limpaItensRepetidos(vm.allTiposEmpreendimentos);
            };
            vm.allTiposEmpreendimentos = vm.buscaTiposEmpreendimentos();

            vm.arrayFiltrosEmpreendimentos = [];
            vm.addfiltroEmpreendimentos = function (filtro) {
                if (vm.arrayFiltrosEmpreendimentos.indexOf(filtro) < 0) {
                    vm.arrayFiltrosEmpreendimentos.push(filtro);
                }
            };

            vm.filtrarEmpreendimentos = function (hotel) {
                if (vm.arrayFiltrosEmpreendimentos.length === 0) {
                    return true;
                }
                var result = false;
                angular.forEach(vm.arrayFiltrosEmpreendimentos, function (filtro) {
                    if (filtro.nome === hotel.item.customData.tipo) {
                        result = true;
                        return;
                    }
                });
                return result;
            };

            vm.limparFiltroEmpreendimento = function (filtro) {
                vm.arrayFiltrosEmpreendimentos.splice(vm.arrayFiltrosEmpreendimentos.indexOf(filtro));
            };

            vm.limparFiltrosEmpreendimentos = function () {
                vm.arrayFiltrosEmpreendimentos = [];
            };
            /*------------------------ Filtros de Tipos --------------------------*/
            /*====================================================================*/


            /*====================================================================*/
            /*------------------------ Filtros de Itens --------------------------*/

            buscaItensHoteis();

            vm.arrayFiltrosHoteis = [];
            vm.addfiltroHoteis = function (filtro) {
                if (vm.arrayFiltrosHoteis.indexOf(filtro) < 0) {
                    vm.arrayFiltrosHoteis.push(filtro);
                }
            };

            vm.notResults = false;
            vm.filtrarHoteis = function (hotel) {
                var result = true;
                angular.forEach(vm.arrayFiltrosHoteis, function (filter) {
                    var comodidade = hotel.item.comodidades.filter(function (comodidade) {
                        return comodidade.nome.toLocaleLowerCase() === filter.nome.toLocaleLowerCase();
                    });
                    if (comodidade.length === 0)
                        result = false;
                });
                return result;
            };

            vm.limparFiltroHoteis = function (filtro) {
                vm.arrayFiltrosHoteis.splice(vm.arrayFiltrosHoteis.indexOf(filtro));
            };

            vm.limparFiltrosHoteis = function () {
                vm.arrayFiltrosHoteis = [];
            };
            /*------------------------ Filtros de Itens --------------------------*/
            /*====================================================================*/


            /*====================================================================*/
            /*------------------------ Functions Layout and Filter ---------------*/
            vm.hotelValueMax = -1;
            vm.hotelValueMin = 100000000;
            vm.rangePrecoHotel = [-1, 100000000];
            //updatePriceRange();

            vm.precoHotel = function (hotel) {
                var total = hotel.item.value / 100;
                if (total >= vm.rangePrecoHotel[0] && total <= vm.rangePrecoHotel[1]) {
                    return true;
                } else {
                    return false;
                }
            };

            /*
             * Conta a quantidade de únidades disponíveis no hotel e verifica de acordo com quantidade de apartamentos disponiveis
             * @param {objeto}
             * @returns {boolean}
             */
            vm.verificaUnidades = function (hotel) {
                if(Properties.onlyBudget){
                    return true;
                }
                if(hotel.item.unavailable) return true;
                var unidades = 0;
                for (var i = 0; i < hotel.result.length; i++) {
                    unidades += hotel.result[i].amount;
                }
                if (searchs.length > unidades) {
                    return false;
                }
                return true;
            };

            /*
             * Conta a quantidade de únidades disponíveis do hotel e retorna msg
             * @param {objeto}
             * @returns {String}
             */
            vm.ultimasUnidades = function (hotel) {
                var unidades = 0;
                for (var i = 0; i < hotel.result.length; i++) {
                    unidades += hotel.result[i].amount;
                }

                if (unidades > 5) {
                    hotel.unidadesShow = false;
                    return unidades;
                } else if (unidades > 3) {
                    hotel.unidadesShow = true;
                } else if (unidades >= 1 && unidades <= 3) {
                    hotel.unidadesShow = true;
                    hotel.unidadesShowClass = true;
                }
                if (unidades === 1) {
                    return "Última unidade";
                }

                return "apenas " + unidades + " unidades";
            };


            /*
             * Ordena preço do min para o max
             * @returns {orderBy}
             */
            function ordenaPorMenorPreco(a, b) {
                return a.item.value - b.item.value;
            }
            /*
             * Ordena preço do max para o min
             * @returns {orderBy}
             */
            function ordenaPorMaiorPreco(a, b) {
                return b.item.value - a.item.value;
            }
            /**
             * Verifica a ordem a ser ordenada
             * @param {object} orderBy
             */
            vm.ordernarPrecos = function (orderBy) {
                if (orderBy === 'MenorParaMaior') {
                    vm.hoteis = vm.hoteis.sort(ordenaPorMenorPreco);
                } else if (orderBy === 'MaiorParaMenor') {
                    vm.hoteis = vm.hoteis.sort(ordenaPorMaiorPreco);
                }
                if (containerWidth <= 1024) {
                    vm.rowFiltersHoteisIsOpen_mobile = !vm.rowFiltersHoteisIsOpen_mobile;
                }
            };

            vm.pagamentoParcelado = function (paymentMethods, value) {
                var max = -1;
                angular.forEach(paymentMethods, function (method) { //pegar bandeira de cartão com mais vezes no parcelamento
                    if (method > max) {
                        max = method;
                    }
                });
                return max + "x de " + $filter('currency')(value / 100 / max, 'R$ ');
            };


            /**
             * @return boolean
             */
            vm.temJurosParcelado = function(hotel){
              // console.debug(hotel);
              if(!hotel.item.paymentMethodsAdjustments || (hotel.item.paymentMethodsAdjustments && hotel.item.paymentMethodsAdjustments.length <= 0 )){
                return false;
              }
              var temJuros = false;
              hotel.item.paymentMethodsAdjustments.forEach(function(method){
                if(method.type === 'acrescimo'){
                  temJuros = true;
                }
              })
              return temJuros;
            };

            /**
             * @return {string|false} Texto
             * pronto do melhor desconto. Caso não haja,
             * retorna false.
             */
            vm.getMelhorDesconto = function(hotel){
              var melhorDesconto = Search.getBestPaymentDiscount(hotel.item);
              if(!melhorDesconto) return false;
              return $filter('currency')(Number(melhorDesconto.value) / 100, 'R$ ') + (melhorDesconto.paymentTypes.includes('pix') ? (' no PIX') : (' em ' + melhorDesconto.installments + 'x'));
            }
            vm.getBestPaymentDiscount = Search.getBestPaymentDiscount;
            
            vm.getMaiorPagamentoParcelado = function (hotel){
              var maxNumParcelas = -1;
              var maxAjuste = null;
              angular.forEach(hotel.item.paymentMethods, function (method) {
                if (Number(method) > maxNumParcelas) {
                  maxNumParcelas = Number(method);
                }
              });
              if(hotel.item.paymentMethodsAdjustments && hotel.item.paymentMethodsAdjustments.length){
                hotel.item.paymentMethodsAdjustments.forEach(function(adjustment){
                  if(Number(adjustment.installments) === maxNumParcelas && Number(adjustment.value) > Number(hotel.item.value)){
                    maxAjuste = adjustment;
                  }
                });
              }
              if(maxAjuste){
                return maxNumParcelas + "x de " + $filter('currency')(Number(maxAjuste.value) / 100 / maxNumParcelas, 'R$ ');
              }
              return maxNumParcelas + "x de " + $filter('currency')(Number(hotel.item.value) / 100 / maxNumParcelas, 'R$ ');
            };
            /*------------------------ Functions Layout and Filter ---------------*/
            /*====================================================================*/

            /*----------------------- Functions Budgets ---------------------------*/
            vm.hasBudget = false;
            vm.updateHasBudget = function(){
                for (var index = 0; index < vm.hoteis.length; index++) {
                    var h = vm.hoteis[index];
                    if(h._selected) {
                        vm.hasBudget = true;
                        return;
                    } 
                }
                vm.hasBudget = false;
            };
            vm.sendBudgets = function(){
                var budgets = [];
                for (var i = 0; i < vm.hoteis.length; i++) {
                    var h = vm.hoteis[i];
                    if(h._selected) {
                        h._selected = false;
                        budgets.push(h.result[0]);
                    }
                }
                vm.updateHasBudget();
                var person = Auth.getPerson() || Auth.getUser();
                if(person !== null && angular.isDefined(person)){
                    person.forSave = false;
                    Search.sendBudgets(person, budgets);
                } else {
                    Dialogs.getClient(null, function(client){
                        Auth.setPerson(client);
                        Search.sendBudgets(client, budgets);
                    });
                }
            };

            /*====================================================================*/
            /*----------------------- Functions Modais ---------------------------*/
            vm.openModalMaisDetalhesHotel = function (hotel) {
                var _item = hotel.item;
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: "app/hospedagem/hoteis/modais/openModalMaisDetalhesHotel.html",
                    bindToController: true,
                    controller: _ItemModalController,
                    controllerAs: "vm",
                    size: 'lg',
                    resolve: {
                        item: function () {
                            return _item;
                        },
                        hotel: function () {
                            return hotel;
                        },
                        parent: function () {
                            return vm;
                        }
                    }
                });
                modalInstance.result.then(function () {
                    vm.selectHotel(hotel);
                }, function () {
                    $log.info('Modal dismissed at: ' + new Date());
                });
            };

            function _foto(item) {
                if (angular.isUndefined(item.foto) || item.foto === null || angular.isUndefined(item.foto.length) || item.foto.length === 0) {
                    return "./assets/images/not-imagem.jpg";
                } else {
                    return item.foto.split("|")[0].split("\\").join("/");
                }
            }

            vm.modalGaleria = function (item) {
                if (angular.isUndefined(item.foto) || item.foto.length === 0)
                    return;
                var fotos = item.foto.split("\\").join("/").split("|");
                Dialogs.galeria(function () {
                    return item.service;
                }, function () {
                    return fotos;
                }, {});
            };

            /** @ngInject */
            function _ItemModalController($uibModalInstance, item, hotel, parent) {
                /*jshint validthis:true */
                var vm = this;
                vm.item = item;
                vm.hotel = hotel;
                vm.parent = parent;
                vm.close = function () {
                    $uibModalInstance.dismiss();
                };
                vm.ok = function () {
                    $uibModalInstance.close('close');
                };
            }

            vm.openModalEditarDadosHospedagem = function () {
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/components/xsBarraFooter/modais/openModalEditarDadosHospedagem.html",
                    bindToController: true,
                    controller: _ModalEditarDadosHospedagemController,
                    controllerAs: "vm",
                    size: 'lg',
                    resolve: {
                        search: function () {
                            return Search.getSearch();
                        }
                    }
                });
            };

            /** @ngInject */
            function _ModalEditarDadosHospedagemController($uibModalInstance, $state, moment, MyFunctions) {
                /*jshint validthis:true */
                var vm = this;
                vm.adt = Search.adultos();
                vm.chd = Search.criancas();
                var aptos = Search.getSearch();
                vm.dates = {
                    date: moment(aptos[0].date).toDate(),
                    endDate: moment(aptos[0].endDate).toDate()
                };
                vm.noites = aptos[0].noites;

                vm.activeDate = false;
                vm.activeEndDate = false;
                vm.handleDate = function () {
                    vm.activeDate = true;
                };

                vm.handleEndDate = function () {
                    vm.nextDay = MyFunctions.addDays(vm.dates.date, 1);
                    if (vm.dates.endDate < vm.nextDay)
                        vm.dates.endDate = vm.nextDay;
                    vm.activeEndDate = true;
                };

                vm.dismiss = function () {
                    $uibModalInstance.dismiss();
                };
                vm.search = function () {
                    var search = Search.getSearch();
                    if (search.length == 1) {
                        search[0].adt = vm.adt;
                        search[0].chd = vm.chd;
                    }
                    search[0].quartos = vm.quartos;
                    search[0].date = vm.dates.date;
                    search[0].endDate = vm.dates.endDate;
                    search[0].noites = MyFunctions.diasEntre(search[0].date, search[0].endDate);
                    Search.setSearch(search);
                    $uibModalInstance.close('close');
                };
                vm.search2 = function (search) {
                    var parametrosConsultaHoteis = {
                        'method': 'hoteisAvailabilityAndPrice',
                        "adulto": search[0].adt,
                        "colo": search[0].colo === null || angular.isUndefined(search[0].colo) ? "0" : search[0].colo.toString(),
                        "chd2": search[0].chd === null || angular.isUndefined(search[0].chd) ? "0" : search[0].chd.toString(),
                        "checkin": MyFunctions.dateToString(search[0].date),
                        "checkout": MyFunctions.dateToString(search[0].endDate),
                        "noites": MyFunctions.diasEntre(search[0].date, search[0].endDate).toString()
                    };
                    localStorageService.set('parametrosConsulta', parametrosConsultaHoteis);
                    localStorageService.remove('resultPesquisa');
                    $state.reload();
                    $uibModalInstance.close('close');
                };
            }


            /*----------------------- Functions Modais ---------------------------*/
            /*====================================================================*/

        }
    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('HospedagemIdentificacaoController', HospedagemIdentificacaoController);

    /** @ngInject */
    function HospedagemIdentificacaoController($window, Search, BackEnd, ErrorHandler, MyFunctions, ScrollTo, $state, $uibModal, $timeout, $log, Tracking, Properties) {
        var vm = this;
        vm.containerWidth = parseInt($window.innerWidth);
        vm.personsAsString = Search.personsAsString;
        vm.showDestaque = false;
        vm.podeDestacar = true;
        vm.showOtherPersons = !Properties.permitePularAcompanhantes;
        vm.showMemo = Properties.showReservationMemo;
        vm.showInputMemo = false;
        vm.memoText = ""
        vm.setShowOtherPersons = function(value){
            vm.showOtherPersons = value;
        }

        vm.directScroll = function (id_scroll) {
            ScrollTo.scrollTo(id_scroll);
        };
        /**
         * Retira o foco do carrinho
         */
        vm.offDestaqueCarrinho = function () {
            vm.showDestaque = false;
            vm.podeDestacar = false;
        };

        vm.reservarAgora = function () {
            vm.showDestaque = false;
            vm.reservarAgoraShow = true;
            vm.directScroll('reservarAgoraShow');
        };


        vm.offDestaqueCarrinho();
        vm.reservarAgora();

        var hotel = Search.getSelectHotel();
        if (hotel === null || angular.isUndefined(hotel))
            $state.go("hospedagemHoteis");
        vm.uhs = Search.getSelectsUh();
        if (vm.uhs === null || angular.isUndefined(vm.uhs) || vm.uhs.length === 0) {
            $state.go("hospedagemApartamentos");
        }
        vm.findCep = function(hospede){
            BackEnd.findcep(hospede.zipCode, function (address) {
                if (address !== null) {
                    hospede.street0 = address.street0 || hospede.street0;
                    hospede.street1 = address.street1 || hospede.street1;
                    hospede.city = address.city || hospede.city;
                    hospede.state = address.state;
                }
            });
        };


        angular.forEach(vm.uhs, function (uh) {
            uh.checkout = uh.checkout || MyFunctions.dateToString(MyFunctions.addDays(MyFunctions.stringToDate(uh.checkin), uh.modulesAmount));
            Search.calculatePrice(hotel, uh, function () {
                Search.notifyListeners();
                if (vm.containerWidth > 1024 && vm.podeDestacar) {
                        $timeout(function () { vm.showDestaque = true; }, 2000);
                }
            });
        });
        ScrollTo.scrollTo("hospedagem-main");

        vm.sizeWidthMobileBreadcrumb = vm.containerWidth <= 968 ? vm.containerWidth + 'px' : '100%';

        vm.nomeHotel = hotel.item.service;

        vm.toDate = function () {
            var date = new Date();
            var dia = date.getDate();
            var mes = date.getMonth() + 1;
            var ano = date.getFullYear();
            return [dia, mes, ano].join('/');
        };

        vm.verificaFormHospedeFirst = function (uh, position) {
            if (uh.index > 0)
                return false;
            return position === 0 ? true : false;
        };
        vm.verificaFormHospede = function (uh, position) {
            if (uh.index > 0)
                return true;
            return position > 0 ? true : false;
        };

        vm.firstName = function (hospede) {
            if (angular.isUndefined(hospede.name) || hospede.name === null || hospede.name === "") {
                return hospede.placeholder;
            } else {
                var first = hospede.name.split(" ");
                return first[0];
            }
        };

        vm.iconHospedeFeliz = 'assets/images/layout/icone-hospede-feliz.png';
        vm.iconHospedeapreensivoUp = 'assets/images/layout/icone-hospede-apreensivo-left.png';
        vm.iconHospedeapreensivoLefth = 'assets/images/layout/icone-hospede-apreensivo-up.png';
        vm.iconHospedeTriste = 'assets/images/layout/icone-hospede-triste.png';

        function verificaMobileEmote() {
            return vm.containerWidth >= 968 ? vm.iconHospedeapreensivoUp : vm.iconHospedeapreensivoLefth;
        }

        vm.functionAllHospedes = function (uh) {
            var arrayAllHospedes = [];
            for (var i = 0; i < uh.persons.length; i++) {
                var each = {
                    position: (i + 1 ),
                    placeholder: (i + 1 ) + "ª Hospede",
                    icon: 'fa fa-male',
                    emote: verificaMobileEmote(),
                    status: i === 0 ? 'check-active' : 'no-check',
                    categoria: uh.persons[i].tag,
                    tag: uh.persons[i].tag,
                    statusButton: 'no-check'
                };
                if (i === 0 && uh.index === 0) {
                    each.email = "";
                    each.cellPhone = "";
                    each.birth = '';
                    each.pagamento = [];
                }
                arrayAllHospedes.push(each);
            }

            // for (var adt = 0; adt < uh._adultos; adt++) {
            //     var each = {
            //         position: (arrayAllHospedes.length + 1 ),
            //         placeholder: (arrayAllHospedes.length + 1 ) + "ª Hospede",
            //         icon: 'fa fa-male',
            //         emote: verificaMobileEmote(),
            //         status: adt === 0 ? 'check-active' : 'no-check',
            //         categoria: 'Adulto',
            //         tag: 'adulto',
            //         statusButton: 'no-check'
            //     };
            //     if (adt === 0 && uh.index === 0) {
            //         each.email = "";
            //         each.cellPhone = "";
            //         each.birth = '';
            //         each.mailing = 'true';
            //         each.pagamento = [];
            //     }
            //     arrayAllHospedes.push(each);
            // }
            // for (var ter = 0; ter < uh._terceiraIdade; ter++) {
            //     arrayAllHospedes.push({
            //         position: (arrayAllHospedes.length + 1 ),
            //         placeholder: (arrayAllHospedes.length + 1 )+ "ª Hospede",
            //         //dataNascimento: '',
            //         icon: 'fa fa-male',
            //         emote: verificaMobileEmote(),
            //         status:'no-check',
            //         categoria: 'Terceira Idade',
            //         tag: 'Terceira Idade',
            //         statusButton: 'no-check'
            //     });
            // }
            // for (var chd = 0; chd < uh._chd; chd++) {
            //     arrayAllHospedes.push({
            //         position: (arrayAllHospedes.length + 1 ),
            //         placeholder: (arrayAllHospedes.length + 1 ) + "ª Hospede",
            //         //dataNascimento: '',
            //         icon: 'fa fa-child',
            //         emote: verificaMobileEmote(),
            //         status: 'no-check',
            //         categoria: 'Criança',
            //         tag: 'chd2',
            //         statusButton: 'no-check'
            //     });
            // }

            // for (var col = 0; col < uh._colo; col++) {
            //     arrayAllHospedes.push({
            //         position: (arrayAllHospedes.length + 1 ),
            //         placeholder: (arrayAllHospedes.length + 1 ) + "ª Hospede",
            //         //dataNascimento: '',
            //         icon: 'fa fa-child',
            //         emote: verificaMobileEmote(),
            //         status: 'no-check',
            //         categoria: 'Colo',
            //         tag: 'colo',
            //         statusButton: 'no-check'
            //     });
            // }
            if(arrayAllHospedes.length > 0){
                var e = arrayAllHospedes[0];
                e.status ='check-active';
                if(uh.index === 0) {
                    e.email = "";
                    e.cellPhone = "";
                    e.birth = '';
                    e.pagamento = [];
                }
            }
            return arrayAllHospedes;
        };

        for (var index = 0; index < vm.uhs.length; index++) {
            var uh = vm.uhs[index];
            uh.index = index;
            uh.show = index === 0;
            uh.allHospedes = vm.functionAllHospedes(uh);
        }

        vm.concluirAgora = function(uh){
            for(var i = 1; i < uh.allHospedes.length; i++){
                //console.log(uh.allHospedes[i]);
                vm.formSalvarHospedes(uh, uh.allHospedes[i]);
            }
        }

        vm.concluirReserva = function(){
            var items = [];
            for (var index = 0; index < vm.uhs.length; index++) {
                var each = vm.uhs[index];
                each.persons = [];
                for (var index2 = 0; index2 < each.allHospedes.length; index2++) {
                    var h = each.allHospedes[index2];
                    var p = angular.copy(h);
                    if (angular.isUndefined(p.name) || p.name === null || p.name === "")
                        p.name = "__Nao informado";
                    each.persons.push(p);
                }
                each.memo = vm.memoText;
                items.push(Search.toMinimalItem(each));
            }
            var item = {
                "items": JSON.stringify(items),
                "person": items[0].persons[0]
            };

            Search.createReservation(item, function (result) {
                Tracking.buyReservations(vm.uhs);
                openModalIndentificacaoConclusao(result);
            });
        }

        vm.formSalvarHospedes = function (uh, hospede) {
            if (hospede.position <= uh.allHospedes.length) {
                if (verificaCampos(hospede, uh.index === 0 && hospede.position === 1)) {
                    uh.allHospedes[hospede.position - 1].emote = vm.iconHospedeFeliz;
                    uh.allHospedes[hospede.position - 1].verificInputs = false;
                    uh.allHospedes[hospede.position - 1].statusButton = 'check';

                    if (hospede.position < uh.allHospedes.length) {
                        uh.allHospedes[hospede.position].status = 'check-active';
                    }
                    if (hospede.position === uh.allHospedes.length) { //Todos os Hóspedes preenchidos
                        if (uh.index === vm.uhs.length - 1) {
                            if(vm.showMemo){
                                vm.showInputMemo = true;
                            }else {
                                vm.concluirReserva();
                            }
                        } else {
                            vm.uhs[uh.index + 1].show = true;
                        }
                    }
                } else {
                    uh.allHospedes[hospede.position - 1].emote = vm.iconHospedeTriste;
                    uh.allHospedes[hospede.position - 1].verificInputs = true;
                }
            }
        };

        function verifyAge(age) {
          var anoNascimento = parseInt(age.substring(4, 8), 10);
          var mesNascimento = parseInt(age.substring(2, 4), 10) - 1;
          var diaNascimento = parseInt(age.substring(0, 2), 10);

          var dataNascimento = new Date(
            anoNascimento,
            mesNascimento,
            diaNascimento
          );

          var dataAtual = new Date();

          var milissegundos = dataAtual - dataNascimento;

          var idadeEmAnos = Math.floor(
            milissegundos / (365.25 * 24 * 60 * 60 * 1000)
          );

          return idadeEmAnos >= 18;
        }

        function verificaCampos(hospede, first) {
            if (first) {
                if (angular.isUndefined(hospede.email) || hospede.email === null) {
                    return false;
                }
                var regExEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!regExEmail.test(hospede.email))
                    return false;
                if (angular.isUndefined(hospede.cellPhone) || hospede.cellPhone === null) {
                    return false;
                }
            } else if (Properties.naoValidaAcompanhantes) {
                return true;
            }
            var regExBirth = /^[0-9]{8}$/g;
            if (Properties.nascimentoRequerido) {
                if (!regExBirth.test(hospede.birth))
                    return false;
            }

            if(!Properties.naoValidaDados){
                for (var k in hospede) {
                    if (typeof hospede[k] === 'function')
                        continue;
                    if (hospede[k] === null || hospede[k] === "")
                        return false;
                }
            }

            if (!Properties.aceitaPrimeiroHospedeMenorDeIdade && first) {
              if (verifyAge(hospede.birth)) {
                return true;
              } else {
                ErrorHandler.showError(
                  "Compra permitida apenas para maiores de 18 anos."
                );
                return false;
              }
            }

            return true;
        }




        function openModalIndentificacaoConclusao(_reserva) {
            $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/identificacao/modais/openModalIndentificacaoConclusao.html",
                bindToController: true,
                controller: ItemModalControllerIndentificacaoConclusao,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    item: function () {
                        return _reserva;
                    }
                }
            });
        }

        /** @ngInject */
        function ItemModalControllerIndentificacaoConclusao($uibModalInstance, item) {
            var vm = this;
            vm.item = item[0];
            vm.irParaTelaPagamento = function () {
                vm.close();
                $state.go("hospedagemPagamento");
            };
            vm.close = function () {
                $uibModalInstance.close('close');
            };
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('HospedagemIngressosController', HospedagemIngressosController);

    /** @ngInject */
    function HospedagemIngressosController($log, MyFunctions, $state, $uibModal, BackEnd, Search, localStorageService, ScrollTo, Dialogs, ErrorHandler) {

        var vm = this;
        vm.uhs = Search.getSelectsUh();
        vm.uh = Search.getSelectsUh()[0];
        vm.consulta = localStorageService.get("parametrosConsulta");
        vm.selectedHotel = Search.getSelectHotel();
        vm.toDate = new Date();
        buscarTodosIngressos(vm.consulta.checkin);

        
        ScrollTo.scrollTo("hospedagem-main");

        vm.directScroll = function (id_scroll) {
            ScrollTo.scrollTo(id_scroll);
        };
        
        function buscarTodosIngressos(dataInicial) {
            vm.ingressos = [];
            var dialog = Dialogs.wait();
            BackEnd.execute2({
                "method": "getProductsToReservation",
                "date": dataInicial
                //"date": MyFunctions.dateToString(vm.toDate)
            }, function (data) {
                dialog.close();
                vm.ingressos = data;
                $log.debug("vm.ingressos: ", vm.ingressos);
            }, function (error) {
                dialog.close();
                ErrorHandler.showError(error);
            });
        }

        /**
         * Calcula quantidade de hospedes
         */
        vm.countAdultos = 0;
        vm.countChds = 0;
        vm.countColos = 0;
        vm.countAllHospedes = 0;
        angular.forEach(vm.uhs, function (apart) {
            vm.countAdultos += apart._adultos;
            vm.countChds += apart._chd;
            vm.countColos += apart._colo;
            vm.countAllHospedes += (apart._adultos + apart._chd + apart._colo);
        });

        vm.diariasDisponiveis = [];
        vm.consulta.noites++;
        for (var ingresso = 1; ingresso <= vm.consulta.noites; ingresso++) {
            vm.diariasDisponiveis.push({
                position: ingresso,
                date: MyFunctions.addDays(MyFunctions.stringToDate(vm.consulta.checkin), ingresso - 1),
                status: ''
            });
        }
        vm.msgInfoCompra = vm.consulta.noites <= 4 ? true : false;
        vm.msgParabens = false;

        vm.validarPrimeiroDia = function (objDia) {
            //var stringDate = MyFunctions.dateToString(objDia.date);
            //buscarTodosIngressos(stringDate);
            
            if (angular.isUndefined(objDia)) {
                objDia = vm.diariasDisponiveis[0];
            }

            angular.forEach(vm.diariasDisponiveis, function (value) {
                value.status = '';
            });
            objDia.status = 'active';

            vm.countDiasUso = objDia.position;
            vm.msgInfoCompra = false;
            vm.msgParabens = vm.consulta.noites <= 4 ? true : false;

            vm.combos = [
                {name: 'Ingressos para 1 dia', adultos: vm.countAdultos, chd: vm.countChds, colos: vm.countColos, allHospedes: vm.countAllHospedes, days: 1, firstDay: objDia.date, lastDay: MyFunctions.addDays(objDia.date, 0), arrayDaysUse: criarArrayDaysUse(objDia.date, 1), value: 0, percentual: 0, desconto: 0, imagem: 'assets/images/ingressos/img-ingresso-7.jpg'},
                {name: 'Ingressos para 2 dias', adultos: vm.countAdultos, chd: vm.countChds, colos: vm.countColos, allHospedes: vm.countAllHospedes, days: 2, firstDay: objDia.date, lastDay: MyFunctions.addDays(objDia.date, 1), arrayDaysUse: criarArrayDaysUse(objDia.date, 2), value: 0, percentual: 0, desconto: 0, imagem: 'assets/images/ingressos/img-ingresso-2.jpg'},
                {name: 'Ingressos para 3 dias', adultos: vm.countAdultos, chd: vm.countChds, colos: vm.countColos, allHospedes: vm.countAllHospedes, days: 3, firstDay: objDia.date, lastDay: MyFunctions.addDays(objDia.date, 2), arrayDaysUse: criarArrayDaysUse(objDia.date, 3), value: 0, percentual: 0, desconto: 0, imagem: 'assets/images/ingressos/img-ingresso-5.jpg'},
                {name: 'Ingressos para 4 dias', adultos: vm.countAdultos, chd: vm.countChds, colos: vm.countColos, allHospedes: vm.countAllHospedes, days: 4, firstDay: objDia.date, lastDay: MyFunctions.addDays(objDia.date, 3), arrayDaysUse: criarArrayDaysUse(objDia.date, 4), value: 0, percentual: 0, desconto: 0, imagem: 'assets/images/ingressos/img-ingresso-4.jpg'}
            ];

            vm.exibirIngressosDisponiveis(objDia);
        };

        function criarArrayDaysUse(date, days) {
            var arrayDates = [];
            for (var i = 1; i <= days; i++) {
                arrayDates.push({date: MyFunctions.addDays(date, i - 1)});
            }
            return arrayDates;
        }



        vm.showIngressosDisponiveis = false;
        vm.exibirIngressosDisponiveis = function (objDia) {
            vm.firstDay = objDia;
            vm.showIngressosDisponiveis = true;

            ScrollTo.scrollTo("ingressos_disponiveis");
            agrupamentoIngresso(objDia);
        };


        function agrupamentoIngresso(firstDay) {
            vm.ingressosDisponiveis = [];
            vm.ingressosAgrupados = [];
            var count = vm.diariasDisponiveis.length - firstDay.position + 1;

            for (var j = 0; j < vm.ingressos.length; j++) {
                var element = vm.ingressos[j];
                if (element.days <= count) {
                    vm.ingressosDisponiveis.push(element);
                }
            }

            angular.forEach(vm.combos, function (combo) {
                combo.produtos = [];
                angular.forEach(vm.ingressosDisponiveis, function (ingresso) {
                    if (combo.days != ingresso.days) {
                        return;
                    }
                    if (ingresso.years == 'adulto' && vm.countAdultos > 0) {
                        ingresso.amount = vm.countAdultos;
                        combo.produtos.push(ingresso);
                        combo.value = combo.value + (ingresso.value * ingresso.amount);
                    }
                    if (ingresso.years == 'crianca' && vm.countChds > 0) {
                        ingresso.amount = vm.countChds;
                        combo.produtos.push(ingresso);
                        combo.value = combo.value + (ingresso.value * ingresso.amount);
                    }
                    if (ingresso.years == 'infantil' && vm.countColos > 0) {
                        ingresso.amount = vm.countColos;
                        combo.produtos.push(ingresso);
                        combo.value = combo.value + (ingresso.value * ingresso.amount);
                    }
                });
            });

            vm.maxEconomiaPercentual = 0;
            vm.maxEconomiaDesconto = 0;
            for (var c = 0; c < vm.combos.length; c++) {
                if (vm.combos[c].days > 1) {
                    var valuePrevious = vm.combos[0].value * (c + 1);
                    vm.combos[c].percentual = ((vm.combos[c].value - valuePrevious) / valuePrevious) * 100;
                    vm.combos[c].desconto = vm.combos[c].value - valuePrevious;

                    vm.maxEconomiaPercentual = ((vm.combos[c].value - valuePrevious) / valuePrevious) * 100;
                    vm.maxEconomiaDesconto = vm.combos[c].value - valuePrevious;
                }
            }
        }

        vm.validarPrimeiroDoUsoDoIngresso = function (objDia) {//off

            angular.forEach(vm.diariasDisponiveis, function (value) {
                value.status = '';
            });

            objDia.status = 'active';

            for (var y = 0; y < vm.diariasDisponiveis.length; y++) {
                if (y < objDia.position - 1) {
                    vm.diariasDisponiveis[y].dayUse = 'off';
                } else if (y < vm.countDiasUso + objDia.position - 1) {
                    vm.diariasDisponiveis[y].dayUse = 'on';
                } else {
                    vm.diariasDisponiveis[y].dayUse = 'off';
                }
            }
        };

        vm.semDiversaoDeIngressos = function () {
            $state.go('hospedagemIdentificacao');
        };

        /*====================================================================*/
        /*----------------------- Functions Modais ---------------------------*/
        vm.openModalConfirmacaoIngressos = function (_comboDayUse) {

            var confirmeCombo = $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/ingressos/modais/openModalConfirmacaoIngressos.html",
                bindToController: true,
                controller: _ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    comboDayUse: function () {
                        return _comboDayUse;
                    },
                    parent: function () {
                        return vm;
                    }
                }
            });
            confirmeCombo.result.then(function () {
                var products = [];
                for (var i = 0; i < _comboDayUse.produtos.length; i++) {
                    var p = _comboDayUse.produtos[i];
                    products.push({
                        path: p.path,
                        amount: p.amount + "",
                        date: MyFunctions.dateToString(_comboDayUse.firstDay)
                    });
                }
                vm.uh.products = products;
                var value = parseInt(vm.uh.value + "", 10);
                vm.uh.value = value + parseInt(_comboDayUse.value + "", 10);

                vm.uh.productsValue = _comboDayUse.value;

                //Search.addSelectUh(vm.uh);
                $state.go('hospedagemIdentificacao');
            });
        };
        /** @ngInject */
        function _ItemModalController($uibModalInstance, parent, comboDayUse) {

            var vm = this;
            vm.parent = parent;
            vm.comboDayUse = comboDayUse;

            vm.close = function () {
                $uibModalInstance.dismiss();
            };
            vm.ok = function () {
                $uibModalInstance.close('close');
            };
        }
        /*----------------------- Functions Modais ---------------------------*/
        /*====================================================================*/
    }
})();

(function() {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('HospedagemPagamentoController', HospedagemPagamentoController);

    /** @ngInject */
    function HospedagemPagamentoController($http, $timeout, $scope, $stateParams, $log, BackEnd, $window, $uibModal, ScrollTo, Search, ErrorHandler,
                Tracking, $state, $cardType, Dialogs, Auth, Properties, localStorageService, PaymentService, $filter,MyFunctions) {
        /* jshint validthis:true */
        var vm = this;
        vm.activeTab = null;
        vm.paymentMethod = {};

        //vm.consulta = localStorageService.get("parametrosConsulta");
        vm.hotel = Search.getSelectHotel();
        vm.apartamentos = Search.getLastReservation();
        //vm.lastReservation = Search.getLastReservation();
        vm.paymentMethods = [];
        vm.depositAccounts = null;
        vm.cardNumber = {};
        vm.showPaymentCardAddress = (!!(Properties._3ds) && Properties.show3dsCardAddress) || Properties.showPaymentCardAddress;
        vm.has3ds  = !!(Properties._3ds);
        vm.reservaPagoComCPFouCPNJ = Properties.reservaPagoComCPFouCPNJ || false;

        vm.tabs = {
            cartaodecredito : { active: false },
            fastcash: { active:false },
            fastCashTransferencia : { active: false },
            fastCashDeposito : { active: false },
            pagamentoHotel : { active: false },
            pagseguro : { active: false },
            deposito : { active: false },
            boleto : { active: false },
            gerencianetBoleto : { active: false },
            granitoCredito : { active: false },
            granitoDebito : { active: false },
            paypal : { active: false },
            koin: { active: false },
            pix: { active: false },
            picpay: { active: false }
        };

        ScrollTo.scrollTo("hospedagem-main");
        //$log.debug("vm.consulta: ", vm.consulta);
        //$log.debug("vm.hotel: ", vm.hotel);
        //$log.debug("vm.apartamentos: ", vm.apartamentos);

        /**
         *  watches
         */
        $scope.$watch('vm.paid.cardNumber', function(newValue, oldValue) {
            if (angular.isUndefined(newValue) || newValue === null)
                return;
            if (angular.isDefined(oldValue) && newValue === oldValue)
                return;
            var c = $cardType.cardType(vm.paid.cardNumber);
            if (vm.paid.cardNumber.length > 8 && (c === "" || angular.isUndefined(c) || c === null)) {
                ErrorHandler.showError("O número do cartão nao é valido ou não é aceito. Verifique o número digitado.");
            }
            vm.paid.cardType = (c === "" || angular.isUndefined(c) ? null : c);
            if (vm.paid.cardType !== null && angular.isUndefined(vm.paymentMethods[vm.paid.cardType]) || vm.paymentMethods[vm.paid.cardType] === null) {
                Dialogs.info("A bandeira do seu cartão '" + vm.paid.cardType + "' não é aceita pelo site. Por favor utilize outro cartão.");
                vm.paid.cardType = null;
            }
            atualizaParcelas();
        });
        vm.selectTab = function(index) {
            vm.activeTab = index;
            angular.forEach(vm.tabs, function(value, key){
                vm.tabs[key].active = false;
            });
            vm.tabs[index].active = true;
            /*
            if(index == "koin") {
                if(angular.isUndefined(vm.koin)){
                    vm.koin = {};
                    $scope.$watch('vm.koin.terms', function(){
                        if(vm.koin.terms) {
                            var dialog = Dialogs.wait();
                            BackEnd.execute2({
                                method:"koinGetInstalltments",
                                amount: vm.totalPagamento * 100,
                                reservationPath: "reservations/" + vm.apartamentos[0].id
                            },
                            function(data){
                                dialog.close();
                                vm.koinParcelas = data.installmentOptions;
                                angular.forEach(vm.koinParcelas, function(p){
                                    p.description += " = " + $filter('currency')(p.orderValue,"R$ ");
                                    if(p.orderValue !== p.originalValue)
                                        p.description = p.description + ' (com juros)';
                                });
                            },
                            function(error) {
                                dialog.close();
                                ErrorHandler.showError(error);
                            }
                            );
                        }
                    });
                }
                $window.GetKoinFraudID = $window.GetKoinFraudID || function(){};
                $window.GetKoinFraudID(function (guid) {vm.koinFraud = guid;});
            }*/
            if(index == "granitoCredito" || index == "granitoDebito"){
                if(index == "granitoCredito") atualizaParcelas("granitoCredito");
                vm.granitoToken = null;
                vm.granitoType = index;
                $http.get(Properties.urlGranito + "?type=" + index).success(function (data) {
                    vm.granitoToken = data;
                    var ambiente = Properties.ambienteGranito || 'prd';
                    $window.loadIFrame(ambiente, data);
                    $timeout(function(){
                        $window.configurePaymentMethod(function(result){
                            if(angular.isDefined(result) && result !== null && result !== "null")
                                functions.pagarComGranito(JSON.parse(result));
                            else
                                ScrollTo.scrollTo("pago_iframe");
                        });
                    },4000);
                }).error(function (error) {
                    ErrorHandler.showError(error);
                });
            }
            if (index == "deposito") {
                depositAccounts();
            }
            if(index == "fastcash"){
                if(angular.isUndefined(vm.paid.tipoPagamento))
                    vm.paid.tipoPagamento = "deposito";
                if(Auth.isLoggedIn()){
                    var u = Auth.getUser();
                    vm.paid.name = u.name;
                    vm.paid.email = u.email;
                    vm.paid.document = u.cpf;
                    vm.paid.phone = u.cellPhone;
                }
            }
        };
        function depositAccounts() {
            if(vm.depositAccounts !== null)
                return;
            vm.depositAccounts =[];
            var dialog = Dialogs.wait();
            BackEnd.execute2({
                "method": "depositAccounts",
                "reservation": "reservations/" + vm.apartamentos[0].id
                },
                function(result) {
                    dialog.close();
                    vm.depositAccounts = result;
                },
                function(error) {
                    dialog.close();
                    ErrorHandler.showError(error);
                }
            );
        }

        function preparePaid(paid){
            delete paid.vencimentoCartaoMes;
            delete paid.vencimentoCartaoAno;
            delete paid.paymentMethods;
            delete paid.produtos;
            delete paid.timespan;
            delete paid.travelersAmount;
            delete paid.value2;
            delete paid.uh;
            delete paid.pensao;
            delete paid.serviceName;
            delete paid.checkin;
            delete paid.days;
            delete paid.hotelName;
            delete paid.checkout;
            var fingerPrintID = localStorageService.cookieGet("fingerPrintID");
            if(angular.isDefined(fingerPrintID) && fingerPrintID !== "" && fingerPrintID !== null) {
                paid.fingerPrint = fingerPrintID + "";
            }
            return paid;
        }
        vm.findZipCodeAddress = MyFunctions.findZipCodeAddress;

        function checkisNotValid(value){
            return angular.isUndefined(value) || value == ""  || value == null;
        }


        var functions = {
            findReservationById: function(apto) {
                var params = {
                  method: "brokerRequestData",
                  id: apto.id,
                  token: apto.token
                };

                if ($stateParams.chave) params.chave = $stateParams.chave;
                if ($stateParams.token) params.token = $stateParams.token;

                BackEnd.execute2(params, function(data) {
                    vm.paid = data;
                    delete apto.boletoValue;
                    delete apto.boletoDescontoValue;
                    angular.merge(apto, data);
                    angular.forEach(apto.travelersAmount.split(","), function(line) {
                        var prop = line.split("=")[0].trim().toLowerCase();
                        if (prop == 'criança')
                            prop = 'crianca';
                        if (prop == 'terceira idade')
                            prop = 'terceiraIdade';
                        apto[prop] = line.split("=")[1].trim();
                    });
                    if(angular.isDefined(data.count) && data.count != null && data.count > 0){
                      Object.keys(data.paymentMethods).forEach(function(key) {
                        if (typeof data.paymentMethods[key] === 'number' && data.paymentMethods[key] > parseInt(data.count, 10)) {
                          data.paymentMethods[key] = parseInt(data.count, 10);
                        }
                      });
                    }
                    angular.merge(vm.paymentMethods, data.paymentMethods);
                    if(vm.paymentMethods.master !== null && angular.isDefined(vm.paymentMethods.master))
                        vm.paymentMethods.mastercard = vm.paymentMethods.master; // considera master como mastercard.
                    if(data.estrangeiro && angular.isDefined(vm.paymentMethods.pix) && !Properties.pixEstrangeiro)
                        delete vm.paymentMethods.pix                    
                    var tab = null;
                    if (vm.paymentMethods.pix !== null && angular.isDefined(vm.paymentMethods.pix)) {
                        tab = "pix";
                        vm.tabs.pix.active = true;
                    } else if (vm.paymentMethods.visa !== null && angular.isDefined(vm.paymentMethods.visa)) {
                        tab = "cartaodecredito";
                    } else if (vm.paymentMethods.boleto !== null && angular.isDefined(vm.paymentMethods.boleto)) {
                        tab = "boleto";
                    } else if (vm.paymentMethods.deposito !== null && angular.isDefined(vm.paymentMethods.deposito)) {
                        tab = "deposito";
                    } else if (vm.paymentMethods.fastCashTransferencia !== null && angular.isDefined(vm.paymentMethods.fastCashTransferencia)) {
                        tab = "fastcash";
                    } else if (vm.paymentMethods.fastCashDeposito !== null && angular.isDefined(vm.paymentMethods.fastCashDeposito)) {
                        tab = "fastcash";
                    } else if (vm.paymentMethods.pagamentoHotel !== null && angular.isDefined(vm.paymentMethods.pagamentoHotel)) {
                        tab = "pagamentoHotel";
                    } else if (vm.paymentMethods.pagseguro !== null && angular.isDefined(vm.paymentMethods.pagseguro)) {
                        tab = "pagseguro";
                    } else if (vm.paymentMethods.gerencianetBoleto !== null && angular.isDefined(vm.paymentMethods.gerencianetBoleto)) {
                        tab = "gerencianetBoleto";
                    } else if(vm.paymentMethods.granitoCredito !== null && angular.isDefined(vm.paymentMethods.granitoCredito)){
                        tab = "granitoCredito";
                    } else if(vm.paymentMethods.granitoDebito !== null && angular.isDefined(vm.paymentMethods.granitoDebito)){
                        tab = "granitoDebito";
                    }  else if (vm.paymentMethods.paypal !== null && angular.isDefined(vm.paymentMethods.paypal)) {
                        tab = "paypal";
                    /*} else if(vm.paymentMethods.koin !== null && angular.isDefined(vm.paymentMethods.koin)){
                        tab = "koin";*/
                    } else if (vm.paymentMethods.picpay !== null && angular.isDefined(vm.paymentMethods.picpay)) {
                        tab = "picpay";
                    } else {
                        if(vm.paymentMethods.length > 0) {
                            tab = Object.keys(vm.paymentMethods)[0];
                        } else $log.error("PaymentMethods não configurado.");
                    }
                    vm.totalPagamento = vm.calculaTotalPagamento();
                    vm.discount = vm.getDescount();
                    vm.selectTab(tab);
                    // $timeout( function(){}, 1000);
                    $log.debug(apto);
                });
            },
            /*----------------------- Funçoes de Pagamento  ----------------------*/
            pagarComCartao: function() {
                if (!vm.paid.customer) {
                    Dialogs.info("Você não preencheu o nome impresso no cartão.");
                    return;
                }
                if (!vm.paid.cardNumber) {
                    Dialogs.info("Você não preencheu o número impresso no cartão.");
                    return;
                }
                if (!vm.paid.securityCode) {
                    Dialogs.info("Você não preencheu o codigo de segurança.");
                    return;
                }
                if (!vm.paid.vencimentoCartaoMes || !vm.paid.vencimentoCartaoAno) {
                    Dialogs.info("Você não preencheu a data de validade.");
                    return;
                }
                if (!vm.paid.cardType) {
                    Dialogs.info("O número do cartão deve estar incorreto. Verifique o número digitado.");
                    return;
                }
                if (!vm.paid.count) {
                    Dialogs.info("Você não escolheu a quantidade de parcelas.");
                    return;
                }
                if (!vm.paid.personCpf && !vm.paid.estrangeiro) {
                    Dialogs.info("Você não escolheu O cpf do titular do cartão.");
                    return;
                }
                if (angular.isUndefined(vm.paymentMethods[vm.paid.cardType]) || vm.paymentMethods[vm.paid.cardType] === null) {
                    Dialogs.info("A bandeira do seu cartão não é aceita pelo site. Utilize outro cartão");
                    return;
                }
                if(vm.showPaymentCardAddress){
                    if(checkisNotValid(vm.userCard)) {
                        Dialogs.info("Por favor preencher dados de cobrança fatura");
                        return
                    }
                    var userData = ['email','cellPhone','street0','street1','address','city','state','zipCode'];
                    for(var i = 0; i < userData.length; i++){
                        if(checkisNotValid(vm.userCard[userData[i]]) && (userData[i] === 'cellPhone' || userData[i] === 'email' )){
                            Dialogs.info("Por favor preencher dados completos.");
                            return;
                        }
                        if(checkisNotValid(vm.userCard[userData[i]])){
                            Dialogs.info("Por favor preencher endereço completo.");
                            return;
                        }
                    }
                }
                //vm.paid.reservationId = vm.paid.id;
                var paid = angular.copy(vm.paid);
                paid.reservationValue = Number(paid.reservationValue);
                paid.value = (getPriceWithAdjustments(paid,paid.cardType, paid.count)).toString();
                paid.cardNumber = paid.cardNumber.replace(/\s/g, '');
                paid.reservationPath = "reservations/" + paid.reservationId;
                paid.goodThru = vm.paid.vencimentoCartaoMes + "/" + vm.paid.vencimentoCartaoAno;
                vm.paid.vencimentoCartaoMes = vm.paid.vencimentoCartaoAno = null;
                paid = preparePaid(paid);
                vm.paid.customer = vm.paid.cardNumber = vm.paid.securityCode = vm.paid.goodThru = null;
                if(Properties.token && !vm.has3ds) {
                    PaymentService.createToken(paid,
                        function(_result){
                            paid.cardNumber = _result.token;
                            paid.goodThru = _result.card.due_date;
                            paid.securityCode = _result.card.cvv;
                            paid.customData =  paid.customData || {};
                            paid.customData.card_number = _result.card.card_number;
                            _paid(paid);
                        }
                    );
                } else if(vm.has3ds){
                    // var user = null;
                    // if(Auth.isLoggedIn())
                    //     user = Auth.getUser();
                    // else if(Auth.getPerson() !== null && angular.isDefined(Auth.getPerson()))
                    //     user = Auth.getPerson();
                    if(Properties.show3dsCardAddress){
                        var u = {};
                        angular.copy(vm.userCard, u);
                        u.street0 += " " + u.address;
                        paid._user = u;
                    }
                    //TODO: considerar tokenização mesmo com o 3DS.
                   PaymentService.payUsing3ds(_paid, paid, paid.reservationPath);
                } else {
                    _paid(paid);
                }

                function _paid(paid) {
                    var dialog = Dialogs.wait();
                    if (vm.apartamentos.length === 1) {
                        BackEnd.execute2({
                                "method": "paidWithCreditCard",
                                "paid": paid
                            },
                            function(data) {
                                dialog.close();
                                if (angular.isDefined(data.paymentUrl) && data.paymentUrl !== null && data.paymentUrl.indexOf("http") == 0) {
                                    Dialogs.iframe_authenticate(data.paymentUrl);
                                    return;
                                }
                                vm.paid.result = data;
                                vm.paid.voucher = data.voucher;
                                vm.paid.voucherId = data.voucherId;
                                vm.paid.voucherToken = data.voucherToken;
                                angular.merge(vm.apartamentos[0], vm.paid);
                                Dialogs.info("Pagamento efetuado com sucesso. Imprima seu voucher.");
                                Search.setLastReservation(vm.apartamentos);
                                Tracking.checkoutReservations(vm.apartamentos);
                                $state.go("hospedagemConfirmacao");
                            },
                            function(error) {
                                dialog.close();
                                ErrorHandler.showError(error);
                            }
                        );
                    } else {
                        paid.reservations = [];
                        var value = 0;
                        for (var i = 0; i < vm.apartamentos.length; i++) {
                            var apto = vm.apartamentos[i];
                            paid.reservations.push({ id: apto.reservationId, value: getPriceWithAdjustments(apto,paid.cardType, paid.count) });
                            value += getPriceWithAdjustments(apto,paid.cardType, paid.count);
                        }
                        paid.reservationValue = value;
                        paid.value = value;
                        BackEnd.execute2({
                                "method": "paidGroupWithCreditCard",
                                "groupPath": "travelGroups/" + vm.apartamentos[0].group,
                                "paid": paid
                            },
                            function(result) {
                                dialog.close();
                                var data = result[0];
                                if (angular.isDefined(data.paymentUrl) && data.paymentUrl !== null && data.paymentUrl.indexOf("http") == 0) {
                                    Dialogs.iframe_authenticate(data.paymentUrl);
                                    return;
                                }
                                vm.paid.result = data;
                                vm.paid.voucher = data.voucher;
                                vm.paid.voucherId = data.voucherId;
                                vm.paid.voucherToken = data.voucherToken;
                                angular.merge(apto, vm.paid);
                                Dialogs.info("Pagamento efetuado com sucesso. Imprima seu voucher.");
                                Search.setLastReservation(vm.apartamentos);
                                Tracking.checkoutReservations(vm.apartamentos);
                                $state.go("hospedagemConfirmacao");
                            },
                            function(error) {
                                dialog.close();
                                ErrorHandler.showError(error);
                            }
                        );
                    }
                }
            },
            gerarBoleto: function() {
                var hasError = false;
                angular.forEach(vm.apartamentos, function(apto) {
                    if (hasError)
                        return;
                    if (!apto.personCpf) {
                        hasError = true;
                        Dialogs.info("Você não escolheu O CPF do responsável pelo boleto.");
                        return;
                    }
                    var dialog = Dialogs.wait();
                    var paid = {
                        "method": "reservationBoleto",
                        "reservationPath": "reservations/" + apto.reservationId,
                        "cpf": apto.personCpf,
                        "amount": "1"
                    };
                    paid.value = apto.value;
                    if (angular.isDefined(apto.boletoValue) && apto.boletoValue !== null && apto.boletoValue > 0) {
                        paid.value = apto.boletoValue + "";
                    }
                    BackEnd.execute2(paid,
                        function(data) {
                            dialog.close();
                            vm.paid.result = data;
                            vm.paid.boleto = data.boleto;
                            vm.paid.boletoToken = data.boletoToken;
                            angular.merge(apto, vm.paid);
                            Dialogs.info("Boleto emitido com sucesso. Imprima seu boleto na proxima tela.");
                            Search.setLastReservation(vm.apartamentos);
                            Tracking.checkoutReservations(vm.apartamentos);
                            $state.go("hospedagemConfirmacao");
                        },
                        function(error) {
                            dialog.close();
                            ErrorHandler.showError(error);
                        });
                });
            },
            gerencianetBoleto: function(){
                var hasError = false;
                angular.forEach(vm.apartamentos, function(apto) {
                    if (hasError)
                        return;
                    if (!apto.personCpf) {
                        hasError = true;
                        Dialogs.info("Você não escolheu O CPF do responsável pelo boleto.");
                        return;
                    }
                    var dialog = Dialogs.wait();
                    var paid = {
                        "method": "createGerencianetBoleto",
                        "reservationPath": "reservations/" + apto.reservationId,
                        "cpf": apto.personCpf,
                        "amount": "1"
                    };
                    BackEnd.execute2(paid,
                        function(data) {
                            dialog.close();
                            vm.paid.result = data;
                            vm.paid.paymentUrl = data.paymentUrl;
                            angular.merge(apto, vm.paid);
                            Dialogs.info("Boleto emitido com sucesso. Imprima seu boleto na proxima tela.");
                            Search.setLastReservation(vm.apartamentos);
                            Tracking.checkoutReservations(vm.apartamentos);
                            $state.go("hospedagemConfirmacao");
                        },
                        function(error) {
                            dialog.close();
                            ErrorHandler.showError(error);
                        });
                });
            },
            gerarWebPayment: function(paymentMethod) {
                var count = 1;
                    function execute(apto){
                        var dialog = Dialogs.wait();
                        var paid = {
                            "method": "createWebGatewayUrl",
                            "reservationPath": "reservations/" + apto.reservationId,
                            "cpf": apto.personCpf,
                            "webGateway": vm.activeTab,
                            "value" : (getPriceWithAdjustments(apto,paymentMethod, 1)).toString(),
                            "reservationValue" : getPriceWithAdjustments(apto,paymentMethod, 1)
                        };

                        BackEnd.execute2(paid,
                            function(data) {
                                dialog.close();
                                vm.paid.result = data;
                                vm.paid.webGateway = vm.activeTab;
                                vm.paid.paymentUrl = data.paymentUrl;
                                angular.merge(apto, vm.paid);
                                if(vm.apartamentos.length > 1 && count < vm.apartamentos.length){
                                   execute(vm.apartamentos[count]);
                                   count++;
                                }else {
                                    Search.setLastReservation(vm.apartamentos);
                                    if(vm.apartamentos.length === 1){
                                        Dialogs.info("Obrigado pela compra. O link de pagamento está na próxima tela.");
                                    }
                                    if (!Properties.trackingLazyBuy) Tracking.checkoutReservations(vm.apartamentos);
                                    $state.go("hospedagemConfirmacao");
                                }
                            },
                            function(error) {
                                dialog.close();
                                ErrorHandler.showError(error);
                            });
                    }
                    execute(vm.apartamentos[0]);
                },
            sendDepositMail: function(){
                angular.forEach(vm.apartamentos, function(apto) {
                    var dialog = Dialogs.wait();
                    var paid = {
                        "method": "sendDepositMail",
                        "reservationPath": "reservations/" + apto.reservationId
                    };
                    paid.value = apto.value;
                    BackEnd.execute2(paid,
                        function() {
                            dialog.close();
                            angular.merge(apto, vm.paid);
                            Search.setLastReservation(vm.apartamentos);
                            Tracking.checkoutReservations(vm.apartamentos);
                            Dialogs.info("Obrigado pela compra. O voucher será enviado após recebermos a confirmação de depósito. As instruções para depósito estão no seu e-mail.");
                            $state.go("hospedagemConfirmacao");
                        },
                        function(error) {
                            dialog.close();
                            ErrorHandler.showError(error);
                        });
                });
            },
            fastCash: function(){
                if (vm.paid.tipoPagamento == 'transferencia'){
                    if (angular.isUndefined(vm.paid.agency) || vm.paid.agency === null) {
                        ErrorHandler.showError("Agência bancaria do pagante não informada.");
                        return false;
                    }
                    if (angular.isUndefined(vm.paid.account)|| vm.paid.account === null) {
                        ErrorHandler.showError("Conta bancária do pagante não informada.");
                        return false;
                    }
                }
                if (vm.paid.tipoPagamento == 'deposito'){
                    if (vm.paid.banco == 8 || vm.paid.banco == 9) {
                        vm.paid.banco = null;
                        ErrorHandler.showError("Banco não informado. Selecione um banco.");
                    }
                }
                if(vm.apartamentos.length > 1) {
                    ErrorHandler.showError("Apenas disponível para um único apartamento");
                    return;
                }
                var apto = vm.apartamentos[0];
                var dialog = Dialogs.wait();
                var paid = angular.copy(vm.paid);
                BackEnd.execute2(
                    {
                        "method": "createFastCashTransaction",
                        "reservationPath": "reservations/" + apto.reservationId,
                        "paymentAsString": paid
                    },
                    function(){
                        dialog.close();
                        Search.setLastReservation(vm.apartamentos);
                        Tracking.checkoutReservations(vm.apartamentos);
                        Dialogs.info("Obrigado pela compra. O voucher será enviado após recebermos a confirmação de depósito. As instruções para depósito estão no seu e-mail.");
                        $state.go("hospedagemConfirmacao");
                    },
                    function(error) {
                        dialog.close();
                        ErrorHandler.showError(error);
                    }
                );
            },
            pagarComGranito: function(result) {
                var paid = angular.copy(vm.paid);
                paid.cardNumber = result.nonce;
                paid.cardType = "Granito";
                paid.reservationPath = "reservations/" + paid.reservationId;
                //paid.goodThru = vm.paid.vencimentoCartaoMes + "/" + vm.paid.vencimentoCartaoAno;
                //vm.paid.vencimentoCartaoMes = vm.paid.vencimentoCartaoAno = null;
                paid = preparePaid(paid);
                //vm.paid.customer = vm.paid.cardNumber = vm.paid.securityCode = vm.paid.goodThru = null;

                var dialog = Dialogs.wait();
                if (vm.apartamentos.length === 1) {
                    BackEnd.execute2({
                            "method": "paidWithCreditCard",
                            "paid": paid
                        },
                        function(data) {
                            dialog.close();
                            vm.paid.result = data;
                            vm.paid.voucher = data.voucher;
                            vm.paid.voucherId = data.voucherId;
                            vm.paid.voucherToken = data.voucherToken;
                            angular.merge(vm.apartamentos[0], vm.paid);
                            Dialogs.info("Pagamento efetuado com sucesso. Imprima seu voucher.");
                            Search.setLastReservation(vm.apartamentos);
                            Tracking.checkoutReservations(vm.apartamentos);
                            $state.go("hospedagemConfirmacao");
                        },
                        function(error) {
                            dialog.close();
                            ErrorHandler.showError(error);
                        }
                    );
                } else {
                    paid.reservations = [];
                    var value = 0;
                    for (var i = 0; i < vm.apartamentos.length; i++) {
                        var apto = vm.apartamentos[i];
                        paid.reservations.push({ id: apto.reservationId, value: apto.reservationValue });
                        value += apto.reservationValue;
                    }
                    paid.value = value;
                    BackEnd.execute2({
                            "method": "paidGroupWithCreditCard",
                            "groupPath": "travelGroups/" + vm.apartamentos[0].group,
                            "paid": paid
                        },
                        function(result) {
                            dialog.close();
                            var data = result[0];
                            vm.paid.result = data;
                            vm.paid.voucher = data.voucher;
                            vm.paid.voucherId = data.voucherId;
                            vm.paid.voucherToken = data.voucherToken;
                            angular.merge(apto, vm.paid);
                            Dialogs.info("Pagamento efetuado com sucesso. Imprima seu voucher.");
                            Search.setLastReservation(vm.apartamentos);
                            Tracking.checkoutReservations(vm.apartamentos);
                            $state.go("hospedagemConfirmacao");
                        },
                        function(error) {
                            dialog.close();
                            ErrorHandler.showError(error);
                        }
                    );
                }
            },
            /*pagarComKoin: function(){
                var paid = angular.copy(vm.paid);
                var dialog = Dialogs.wait();

                paid.reservationPath = "reservations/" + paid.reservationId;
                BackEnd.execute2({
                    "method": "koinCreateBoleto",
                    "amount": vm.paid.value,
                    "reservationPath": "reservations/" + paid.reservationId,
                    "fraudId": vm.koinFraud,
                    "paymentType": vm.koin.installment.paymentType,
                    "parcelas": vm.koin.installment.installments
                    },
                    function(data) {
                        dialog.close();
                        vm.paid.resultKoin = data;
                        if(data.Code == '312' || data.Code == '314'){
                            angular.merge(vm.apartamentos[0], vm.paid);
                            Dialogs.info(data.Message, undefined, undefined, function(){
                                Search.setLastReservation(vm.apartamentos);
                                Tracking.checkoutReservations(vm.apartamentos);
                                $state.go("hospedagemConfirmacao");
                            });
                            return;
                        } else {
                            vm.paid.result = data;
                            vm.paid.voucher = data.voucher;
                            vm.paid.voucherId = data.voucherId;
                            vm.paid.voucherToken = data.voucherToken;
                            angular.merge(vm.apartamentos[0], vm.paid);
                            Dialogs.info("Seu pedido foi aprovado pela Koin e sua reserva foi efetuada com sucesso.", undefined, undefined, function(){
                                Search.setLastReservation(vm.apartamentos);
                                Tracking.checkoutReservations(vm.apartamentos);
                                $state.go("hospedagemConfirmacao");
                            });
                        }
                    },
                    function(error) {
                        dialog.close();
                        ErrorHandler.showError(error);
                    }
                );
            }*/
            /*----------------------- /Funçoes de Pagamento  ----------------------*/

        };
        vm.quantidadeDeParcelas = [];

        function atualizaParcelas(cardType) {
            if (angular.isUndefined(vm.paid) || vm.paid === null)
                return;
            cardType = cardType || vm.paid.cardType;
            if (angular.isUndefined(cardType) || cardType === null)
                return;
            var parcelas = vm.paymentMethods[cardType];
            vm.quantidadeDeParcelas = [];
            for (var i = 1; i <= parcelas; i++) {
                var parcela = {
                  parcelas: i,
                  valor: vm.totalPagamento / i
                };
                var adjustment = calcTotalPaymentDiscount(cardType, i);

                if(adjustment && adjustment.totalInstallmentValue){
                  parcela.valor = Number(adjustment.totalInstallmentValue) / 100;
                  parcela.description = '(com ' + (adjustment.type === 'desconto' ? 'desc.' : 'juros') + ')';
                }
                vm.quantidadeDeParcelas.push(parcela);
            }
        }

        if (angular.isDefined($stateParams.ids) && $stateParams.ids !== null && $stateParams.ids !== "") {
            vm.apartamentos = [];
            angular.forEach($stateParams.ids.split(","), function(id) {
                vm.apartamentos.push({
                    id: id
                });
            });
        }

        angular.forEach(vm.apartamentos, function(apto) {
            functions.findReservationById(apto); // ToDO: usar token nessa pesquisa
        });



        /*====================================================================*/
        /*------------------------ Functions Modal FastCash -------------------------*/

        vm.openModalFastCash = function() {
            $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/pagamento/modais/modalBancosFastCash.html",
                bindToController: true,
                controller: function($uibModalInstance, agencia){
                    var vm = this;
                    vm.agencia = agencia || 1;
                    vm.close = function() {
                        $uibModalInstance.close('close');
                    };
                },
                controllerAs: "vm",
                size: 'md',
                resolve: {
                    agencia: function() {
                        return vm.paid.banco;
                    }
                }
            });
        };


        /*------------------------ / Functions Modal FastCash -------------------------*/
        /*====================================================================*/



        /*====================================================================*/
        /*------------------------ Functions Layout and Filter ---------------*/
        vm.termosCompra = false;
        vm.politicas = false;
        vm.tooltipIsOpenTermos = false;
        vm.tooltipIsOpenPoliticas = false;
        vm.comprar = function() {
            if (!vm.termosCompra) {
                vm.tooltipIsOpenTermos = true;
                return;
            }
            if (vm.activeTab === 'cartaodecredito')
                functions.pagarComCartao();
            if (vm.activeTab === 'boleto')
                functions.gerarBoleto();
            if (vm.activeTab == 'pagseguro' || vm.activeTab == 'paypal' || vm.activeTab == 'pix' || vm.activeTab == 'picpay')
                functions.gerarWebPayment(vm.activeTab);
            if (vm.activeTab === 'deposito')
                functions.sendDepositMail();
            if (vm.activeTab === "fastcash")
                functions.fastCash();
            if (vm.activeTab === "gerencianetBoleto")
                functions.gerencianetBoleto();
            if (vm.activeTab === 'granitoCredito' || vm.activeTab === 'granitoDebito')
                $window.sendPaymentMethodNonce();
            /*if (vm.activeTab === 'koin')
                functions.pagarComKoin();*/
        };
        /*------------------------ Functions Layout and Filter ---------------*/
        /*====================================================================*/



        /*====================================================================*/
        /*------------------------ Functions Auxiliares ----------------------*/
        vm.directScroll = function(id_scroll) {
            ScrollTo.scrollTo(id_scroll);
        };
        /*------------------------ Functions Auxiliares ----------------------*/
        /*====================================================================*/



        /*====================================================================*/
        /*----------------------- Functions Modais ---------------------------*/
        vm.openModal = function(_title, _url) {
            $uibModal.open({
                animation: true,
                templateUrl: _url,
                bindToController: true,
                controller: ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    item: function() {
                        return _title;
                    }
                }
            });
        };
        vm.openModalInfoCartao = function() {
            var _item = "Pagamento via Cartão";
            var url = "app/hospedagem/pagamento/modais/openModalInfoCartao.html";
            vm.openModal(_item, url);
        };

        vm.openModalInfoBoleto = function() {
            var _item = "Pagamento via Boleto";
            var _url = "app/hospedagem/pagamento/modais/openModalInfoBoleto.html";
            vm.openModal(_item, _url);
        };

        vm.openModalInfoTransferencia = function() {
            var _item = "Transferência Bancaria";
            var _url = "app/hospedagem/pagamento/modais/openModalInfoTransferencia.html";
            vm.openModal(_item, _url);
        };

        vm.openModalInfoDeposito = function() {
            var _item = "Deposito Bancario";
            var _url =  "app/hospedagem/pagamento/modais/openModalInfoDeposito.html";
            vm.openModal(_item, _url);
        };

        vm.openModalInfoPagamentoHotel = function() {
            var _item = "Pagamento no Hotel";
            var _url = "app/hospedagem/pagamento/modais/openModalInfoPagamentoHotel.html";
            vm.openModal(_item, _url);
        };

        vm.openModalInfoPagSeguro = function() {
            var _item = "Pagamento via PagSeguro";
            var _url = "app/hospedagem/pagamento/modais/openModalInfoPagSeguro.html";
            vm.openModal(_item, _url);
        };
        vm.openModalInfoPix = function() {
            var _item = "Pagamento via Pix";
            var _url = "app/hospedagem/pagamento/modais/openModalInfoPix.html";
            vm.openModal(_item, _url);
        };
        vm.openModalInfoPicPay = function() {
            var _item = "Pagamento via PicPay";
            var _url = "app/hospedagem/pagamento/modais/openModalInfoPicPay.html";
            vm.openModal(_item, _url);
        };

        /** @ngInject */
        function ItemModalController($uibModalInstance, item) {
            var vm = this;
            vm.item = item;
            vm.close = function() {
                $uibModalInstance.close('close');
            };
        }

        /*----------------------- Functions Modais ---------------------------*/
        /*====================================================================*/


        /*====================================================================*/
        /*------------------------ Functions carrinho ------------------------*/

        vm.calculaTotalPagamento = function() {
            // var somaValoresApartamentos = 0;
            // var reservationPaidValue = vm.paid ? vm.paid.reservationPaidValue || 0 : 0;
            // for (var i = 0; i < vm.apartamentos.length; i++) {
            //     var apto = vm.apartamentos[i];
            //     if (apto.reservationValue !== null && angular.isDefined(apto.reservationValue) && apto.reservationValue !== "")
            //         somaValoresApartamentos += apto.reservationValue;
            //     if (angular.isDefined(apto.produtosValue) && apto.produtosValue !== null && apto.produtosValue !== "")
            //         somaValoresApartamentos += apto.produtosValue;
            // }
            // return (somaValoresApartamentos - reservationPaidValue) / 100;
            return Number(vm.paid ? vm.paid.value : 0) / 100;
        };
        //vm.totalPagamento = vm.calculaTotalPagamento();
        /*------------------------ Functions carrinho ------------------------*/
        /*====================================================================*/


      /*-- paymentMethodsAdjustments --*/
      /*===============================*/

      /**
       * Verifica se existe descontos ou acréscimos.
       * @return boolean
       */
      function hasPaymentMethodsAdjustments(){
        return (vm.paid && vm.paid.paymentMethodsAdjustments && vm.paid.paymentMethodsAdjustments.length);
      }

      /**
       * @param {string} method
       * @param {number} installments
       * @return {number} O valor total com ajustes aplicados.
       */
      function getPriceWithAdjustments(apto,method, installments){
        var aptoReservationValue = angular.copy(apto.value);
        if(!hasPaymentMethodsAdjustments()){
          return aptoReservationValue;
        }
        var adjustment = calcPaymentDiscount(apto,method, installments);
        if(!adjustment){
          return aptoReservationValue;
        }
        return Number(adjustment.value);
      }
      function calcPaymentDiscount(apto,method, installments){
          if(!apto.paymentMethodsAdjustments){
              return false
          }
          var adjustment = apto.paymentMethodsAdjustments.find(function(item){
              if(!item.paymentTypes.includes(method)){
                return false;
              }
              if(Number(item.installments) !== Number(installments)){
                return false;
              }
              return true;
            });
          if(adjustment){
             return adjustment;
          }
          return false
    }
    vm.getTotalPriceWithAdjustments = function(method, installments){
        if(!hasPaymentMethodsAdjustments()){
          return vm.calculaTotalPagamento();
        }
        var adjustment = calcTotalPaymentDiscount(method, installments)
        if(!adjustment){
          return vm.calculaTotalPagamento();
        }
        return Number(adjustment.totalValue) / 100;
      }
      function calcTotalPaymentDiscount(method, installments){
          var totalValue = 0, totalInstallmentValue = 0;
          var type = '';
          vm.apartamentos.map(function(apto) {
            if(!apto.paymentMethodsAdjustments){
                return false
            }
            var adjustment = apto.paymentMethodsAdjustments.find(function(item){
                if(!item.paymentTypes.includes(method)){
                  return false;
                }
                if(Number(item.installments) !== Number(installments)){
                  return false;
                }
                return true;
              });
            if(adjustment){
                totalValue += Number(adjustment.value);
                totalInstallmentValue += Number(adjustment.installmentValue);
                type = adjustment.type;
            }
          })
          if(totalValue === 0 || totalInstallmentValue === 0){
            return false;
          }
          return {
            totalValue: totalValue,
            totalInstallmentValue: totalInstallmentValue,
            type: type,
          };
      }

      vm.getDescount = function(){
        var finalValue = 0;
        var paymentMethod;
        vm.apartamentos.map(function(apto) {
            var melhorDesconto = Search.getBestPaymentDiscount(apto);
            if(melhorDesconto){
                finalValue += Number(melhorDesconto.value);
                paymentMethod = melhorDesconto;
            }
        })
        if(finalValue === 0 || angular.isUndefined(paymentMethod) || paymentMethod === null){
            return false
        }
        return {
            paymentType: paymentMethod.paymentTypes.includes('pix') ? ' no PIX' : (' em ' + paymentMethod.installments + 'x'),
            total: finalValue / 100,
            percent: paymentMethod.percent
        }
      }
      /*-- paymentMethodsAdjustments --*/
      /*===============================*/

    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('PaymentConfirmationController', PaymentConfirmationController);

    /** @ngInject */
    function PaymentConfirmationController( $location, BackEnd, Dialogs, ErrorHandler ) {
        var vm = this;
        vm.payment = null;
        vm.qrCodeText

        var params = $location.search();
        var id = params.id;
        var token = params.token;
        var paymentId = params.paymentId;

        if (!id || !token || !paymentId) {
            ErrorHandler.showError("Link Invalido");
            return;
        }

        vm.getStatusClass = function() {
            var status = vm.payment.status.toLowerCase();

            if (status.includes('approved') || status.includes('confirmado')) {
                return 'status-aprovado';
            }
            if (status.includes('pending') || status.includes('aguardando')) {
                return 'status-pendente';
            }
            if (status.includes('cancelled') || status.includes('cancelado')) {
                return 'status-cancelado';
            }
            if (status.includes('pago') || status.includes('paid')) {
                return 'status-pago';
            }
            return '';
        };

        vm.copiado = false;
        vm.copiarCodigoPix = function(codigo) {
            navigator.clipboard.writeText(codigo).then(function() {
                vm.copiado = true;
                
                setTimeout(function() {
                    vm.$apply(function() {
                        vm.copiado = false;
                    });
                }, 3000);
            }).catch(function(err) {

                ErrorHandler.showError(err);
               
                var textarea = document.createElement('textarea');
                textarea.value = codigo;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                vm.copiado = true;
                setTimeout(function() {
                    vm.$apply(function() {
                        vm.copiado = false;
                    });
                }, 3000);
            });
        };
        vm.confirmPayment = function () {
        var params = {
            method: 'groupById',
            token: token,
            groupPath: 'travelGroups/' + id,
            paymentId: paymentId
        };
        var dialog = Dialogs.wait();
        BackEnd.execute(
          params,
          function (data) {
            dialog.close();
            if (angular.isUndefined(data) || data == null) {
                ErrorHandler.showError("Falha ao Carregar Link de Pagamento");
            } else {
                vm.payment = data;
                if(vm.payment.qrcode) vm.qrCodeText = vm.payment.qrcode
            }
          },
          function (error) {
            dialog.close();
            ErrorHandler.showError(error);
          }
        );
      };
      vm.confirmPayment()
    }
})();
(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('HospedagemConfirmacaoController', HospedagemConfirmacaoController);

    /** @ngInject */
    function HospedagemConfirmacaoController(
      // $state,
      localStorageService,
      ScrollTo,
      Properties,
      Search,
      Dialogs,
      $stateParams,
      BackEnd,
      ErrorHandler,
      Tracking
    ) {
      var vm = this;
      vm.reservaId = $stateParams.id;
      vm.voucherUrl = vm.boletoUrl = vm.paymentUrl = vm.qrcode = null;
      vm.consulta = localStorageService.get("parametrosConsulta");
      vm.hotel = localStorageService.get("hotelSelecionado");
      vm.qrcodeUrlBase =
        Properties.qrcode || Properties.serverUrl || Properties.serverBase;
      vm.apartamentos = localStorageService.get("ApartametosSelecionandos");
      vm.hospedes = localStorageService.get("allHospedes");
      vm.pagamento = localStorageService.get("modoPagamento");
      // vm.apartamentos = null;
      vm.multiCodes = [];

      ScrollTo.scrollTo("hospedagem-main");
      vm.linkCopySuccess = function () {
        Dialogs.info(
          'Utilize a opção "Pix copia e cola" do seu banco',
          "Copiado com sucesso"
        );
      };

      vm.totalAdultos = 0;
      vm.totalChd = 0;
      vm.totalColo = 0;
      angular.forEach(vm.hospedes, function (hospede) {
        if (hospede.categoria === "Adulto") {
          vm.totalAdultos++;
        }
        if (hospede.categoria === "Criança") {
          vm.totalChd++;
        }
        if (hospede.categoria === "Colo") {
          vm.totalColo++;
        }
      });

      vm.verifyPayment = function () {
        var params = { method: "verifyPayment", path: vm.apartamentos[0].path };
        var dialog = Dialogs.wait();
        BackEnd.execute(
          params,
          function (data) {
            dialog.close();
            if (
              angular.isUndefined(data) ||
              data == null ||
              data.status != "aguardando"
            ) {
              // dispara o tracking de compra aprovada do pix se estiver pago
              if (Properties.trackingLazyBuy) Tracking.checkoutReservations(vm.apartamentos);
              Dialogs.info(
                "Pagamento efetuado com sucesso. Imprima seu voucher."
              );
              Search.setLastReservation(vm.apartamentos);
              vm.apartamentos = null;
              vm.qrcode = null;
              loadReservation(vm.apartamentos[0].id, vm.apartamentos[0].token);
              // initialize();
            } else Dialogs.info(data.mensagem || "Aguardando a confirmacao");
          },
          function (error) {
            dialog.close();
            ErrorHandler.showError(error);
          }
        );
      };

      function initialize() {
        vm.voucher = vm.apartamentos[0];
        vm.voucher.voucherId = vm.voucher.voucherId || vm.voucher.voucher;
        if (
          angular.isDefined(vm.voucher.voucherId) &&
          vm.voucher.voucherId !== null &&
          vm.voucher.voucherId !== ""
        )
          vm.voucherUrl =
            Properties.pdfAddress +
            "?method=receiptAsByte&receipt=" +
            vm.voucher.voucherId +
            "&token=" +
            vm.voucher.voucherToken;
        else if (
          angular.isDefined(vm.voucher.boleto) &&
          vm.voucher.boleto !== null
        )
          vm.boletoUrl =
            Properties.pdfAddress +
            "?method=boletoAsByte&reservation=reservations/" +
            vm.voucher.reservationId +
            "&boleto=" +
            vm.voucher.boleto +
            "&token=" +
            vm.voucher.boletoToken;
        else if (
          angular.isDefined(vm.voucher.paymentUrl) &&
          vm.voucher.paymentUrl !== null
        )
          vm.paymentUrl = vm.voucher.paymentUrl;
        else if (
          (angular.isDefined(vm.voucher.result) &&
            vm.voucher.result !== null) ||
          (angular.isDefined(vm.voucher.qrcode) && vm.voucher.qrcode !== null)
        ) {
          for (var i = 0; i < vm.apartamentos.length; i++) {
            vm.apto = vm.apartamentos[i];
            if (
              angular.isDefined(vm.apto.result) &&
              angular.isDefined(vm.apto.result.qrcode) &&
              vm.apto.result.qrcode !== null
            ) {
              vm.qrcode = vm.apto.result.qrcode;
            } else if (
              angular.isDefined(vm.apto.qrcode) &&
              vm.apto.qrcode !== null
            ) {
              vm.qrcode = vm.apto.qrcode;
            }
            vm.multiCodes.push(vm.qrcode);
          }
        }
        /*
            // verifica compra pela Koin
            if (angular.isDefined(vm.voucher.resultKoin) && vm.voucher.resultKoin !== null && vm.voucher.resultKoin !== "") {
                vm.koin = true;
                if (vm.voucher.resultKoin.Code == '312' || vm.voucher.resultKoin.Code == '314') {
                    vm.koinWait = true;
                }
            }*/
      }
      var loadReservation =  function(id, token) {
        var dialog = Dialogs.wait();
        BackEnd.execute(
          {
            method: "reservationById",
            reservationPath: "reservations/" + id,
            token: token,
          },
          function (data) {
            vm.apartamentos = [data];
            dialog.close();
            for (var i = 0; i < vm.apartamentos.length; i++) {
              var _a = vm.apartamentos[i];
              if(_a.status =='Cancelada') {
                Dialogs.info("Reserva Cancelada");
                return;
              }
            }
            if (vm.apartamentos.length > 1) {
              Dialogs.info(
                "Efetue o cada pagamento separadamente.",
                "ATENÇÃO: Foi gerado um QR-code separadamente para o pagamento de cada reserva."
              );
            }
            initialize();
          },
          function (err) {
            dialog.close();
            ErrorHandler.showError(err);
          }
        );
      };
      if (
        angular.isDefined($stateParams.id) &&
        $stateParams.id.length > 0 &&
        angular.isDefined($stateParams.token) &&
        $stateParams.token.length > 0
      ) {
        loadReservation($stateParams.id, $stateParams.token);
      } else {
        vm.apartamentos = Search.getLastReservation();
        if (vm.apartamentos.length > 1) {
          Dialogs.info(
            "Efetue o cada pagamento separadamente.",
            "ATENÇÃO: Foi gerado um QR-code separadamente para o pagamento de cada reserva."
          );
        }
        initialize();
      }
      //nao descomentar em produção
      //vm.voucherUrl = "https://";
      //vm.boletoUrl = "https://";
      //vm.paymentUrl = "https://";
      //vm.koinWait = true;
      //vm.koin = true;
      //vm.voucher ={resultKoin:{ Code : "314"}};
    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('HospedagemCarrinhoController', HospedagemCarrinhoController);

    /** @ngInject */
    function HospedagemCarrinhoController($state, Search, Properties, MyFunctions, $scope, $uibModal, localStorageService, Dialogs ) {
        var vm = this;
        vm.personsAsString = Search.personsAsString;
        vm.solicitacaoReservaShow = Properties.solicitacaoReservaShow;
        vm.checkCarregandoSolicitacao = false;

        vm.reservarAgora = function () {
            $scope.$parent.vm.reservarAgora();
        };
        vm.cupomIsValid = false;
        var lastCupomAsString = null;
        vm.clearCupom = function() {
            lastCupomAsString = vm.cupomCodKey = vm.cupomCode = vm.cupomKey = null;
            localStorageService.remove("cupom");
            vm.cupomIsValid = false;
            calculatePrices(Search.getSelectsUh());
            /*
            Search.getSelectsUh().forEach(function(uh){
                if(uh.oldValue){
                    uh.value = uh.oldValue;
                    delete uh.customData.cupomAsString;
                }
            });
            */
        };
        vm.validCupom = function () {
            var uhs = Search.getSelectsUh();
            if(angular.isUndefined(uhs) || uhs === null || uhs.length == 0) {
                lastCupomAsString = "";
                return;
            }

            var cupomAsString = null;
            // Código unico
            if (angular.isDefined(vm.cupomCodKey) && vm.cupomCodKey !== null && vm.cupomCodKey !== "") {
                var split = vm.cupomCodKey.split("-");
                vm.cupomCode = split[0];
                if(split.length > 1 || !Properties.naoUtilizaKey)
                    vm.cupomKey = (split.length > 1) ? split[1] : vm.cupomCode;
                else
                    vm.cupomKey = null;
            }
            // Código sem analise de chave
            if (angular.isDefined(vm.cupomCode) && vm.cupomCode !== null && vm.cupomCode !== "") {
                cupomAsString = vm.cupomCode + "|" + (vm.cupomKey === undefined || vm.cupomKey == null ? "" : vm.cupomKey);
                if (lastCupomAsString == cupomAsString) return;
            }
            lastCupomAsString = cupomAsString;
            /*if (Properties.naoUtilizaKey === null || angular.isUndefined(Properties.naoUtilizaKey) || !Properties.naoUtilizaKey) {
                if (angular.isUndefined(vm.cupomCode) || vm.cupomCode === null || vm.cupomCode === "" || angular.isUndefined(vm.cupomKey) || vm.cupomKey === null || vm.cupomKey === "") {
                    Dialogs.info("Cupom incorreto");
                    return;
                } else {
                }
            } */
            if (angular.isUndefined(vm.cupomCode) || vm.cupomCode === null || vm.cupomCode === "") {
                Dialogs.info("Cupom incorreto");
                return;
            }
            calculatePrices(uhs);
        };
        function calculatePrices(uhs){
            var copy = {};
            function _calPrice(callback) {
                angular.copy(uhs[i], copy);
                if (!copy.customData) copy.customData = {}
                  copy.customData.cupomAsString = lastCupomAsString;
                Search.calculatePrice(vm.selectedHotel, copy, callback, false);
            }
            var i = 0;
            _calPrice(function callBack() {
                var uh = uhs[i];
                uh.customData.cupomAsString = copy.customData.cupomAsString;
                vm.cupomIsValid = lastCupomAsString != null && lastCupomAsString != "";
                var oldValue = uhs[i].value;
                uh.value = copy.value;
                uh.oldValue = oldValue;
                uh.boletoValue = copy.boletoValue;
                uh.boletoDescontoValue = copy.boletoDescontoValue;
                vm.totalPagamento = Search.totalValue();
                uh.paymentMethodsAdjustments = copy.paymentMethodsAdjustments;
                vm.descount = vm.getDescount(uhs);
                i++;
                if (i < uhs.length)
                    _calPrice(callBack);
            });
        }

        vm.getDescount = function(aptos){
            var finalValue = 0;
            var paymentMethod;

            aptos.map(function (apto) {
                  var melhorDesconto = Search.getBestPaymentDiscount(apto);
                  if(melhorDesconto){
                    finalValue += Number(melhorDesconto.value);
                    paymentMethod = melhorDesconto;
                  }
            })
            if(finalValue === 0 || angular.isUndefined(paymentMethod) || paymentMethod === null){
                return false
            }
            return {
                paymentType: paymentMethod.paymentTypes.includes('pix') ? ' no PIX' : (' em ' + paymentMethod.installments + 'x'),
                total: finalValue / 100,
                percent: paymentMethod.percent
            }
          }

        vm.update = function () {
            vm.aptos = Search.getSelectsUh();
            if (vm.aptos === null || angular.isUndefined(vm.aptos) || vm.aptos.length === 0)
                vm.aptos = Search.getSearch();
            vm.selectedHotel = Search.getSelectHotel();
            var search0 = vm.aptos[0];
            if (search0.date !== null && angular.isDefined(search0.date))
                vm.checkin = MyFunctions.dateToString(search0.date);
            else
                vm.checkin = search0.checkin;
            if (search0.endDate !== null && angular.isDefined(search0.endDate))
                vm.checkout = MyFunctions.dateToString(search0.endDate);
            else
                vm.checkout = search0.checkout;

            vm.days = MyFunctions.diasEntre(MyFunctions.stringToDate(vm.checkin), MyFunctions.stringToDate(vm.checkout));
            vm.totalPagamento = Search.totalValue();
            vm.descount = vm.getDescount(vm.aptos);
            if ($state.current.name === "hospedagemIdentificacao") {
                var cupomFromUrl = localStorageService.get("cupom");
                if (angular.isUndefined(cupomFromUrl) || cupomFromUrl == null && cupomFromUrl == "") {
                    vm.aptos.forEach(function(uh) {
                        if(uh.customData && uh.customData.cupomAsString != null && uh.customData.cupomAsString != ""){
                            cupomFromUrl = uh.customData.cupomAsString;
                            cupomFromUrl = cupomFromUrl.replace("|","-");
                        }
                    });
                }
                if (angular.isDefined(cupomFromUrl) && cupomFromUrl !== null && cupomFromUrl !== "") {
                    vm.cupomCodKey = cupomFromUrl;
                    var split = cupomFromUrl.split("-");
                    vm.cupomCode = split[0];
                    if (split.length > 1 || Properties.naoUtilizaKey) {
                        vm.cupomKey = split[1];
                    }
                    vm.validCupom();
                }
            }
        };

        vm.update();
        vm.showCupom = $state.current.name === "hospedagemIdentificacao";




        vm.modalSolicitacaoReserva = function (_item, days, valor) {
            $scope.$parent.vm.offDestaqueCarrinho();

            var item = {};
            item.apts = _item;
            item.checkin = _item[0].checkin;
            item.checkout = _item[0].checkout;
            item.hotelName = _item[0].hotelName;
            item.days = days;
            item.totalPagamento = valor;

            $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/carrinho/modais/openModalSolicitacaoReserva.html",
                bindToController: true,
                controller: _ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    item: function () {
                        return item;
                    },
                    parent: function () {
                        return vm;
                    }
                }
            });
        };
        vm.modalSucessoSolicitacaoReserva = function (item, user) {
            vm.item = {dados: item, cliente: user};
            $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/carrinho/modais/openModalSucessoSolicitacaoReserva.html",
                bindToController: true,
                controller: _ItemModalController,
                controllerAs: "vm",
                size: 'md',
                resolve: {
                    item: function () {
                        return vm.item;
                    },
                    parent: function () {
                        return vm;
                    }
                }
            });
        };

        /** @ngInject */
        function _ItemModalController($uibModalInstance, item, parent, BackEnd, ErrorHandler) {
            /* jshint validthis:true */
            var vm = this;
            vm.item = item;
            vm.parent = parent;

            vm.criarSolicitacaoReserva = function (user) {
                vm.checkCarregandoSolicitacao = true;
                var somaAdultos = 0;
                var somaChds = 0;
                var somaColos = 0;
                var apartamentos = "";
                angular.forEach(item.apts, function (apt) {
                    var auxAdult = angular.isDefined(apt._adultos) ? apt._adultos : 0;
                    var auxChds = angular.isDefined(apt._chd) ? apt._chd : 0;
                    var auxcolos = angular.isDefined(apt._colo) ? apt._colo : 0;

                    somaAdultos += auxAdult;
                    somaChds += auxChds;
                    somaColos += auxcolos;
                    apartamentos += "Apartamento: " + apt.service + " com " +
                      "Adultos: " + auxAdult + ", " +
                      "Crianças: " + auxChds + ", " +
                      "Colos: " + auxcolos + ";  ";
                });

                var dadosReserva = {
                    "method": "createAttendance",
                    "type": "Cliente Site",
                    "memorando": "Quantidade Apartamentos: " + item.apts.length + " = " + apartamentos,
                    "adulto": somaAdultos,
                    "chd2": somaChds,
                    "colo": somaColos,
                    "hotel": item.hotelName,
                    "nome": user.name,
                    "email": user.email,
                    "telefone": user.cellPhone,
                    "date": item.checkin,
                    "endDate": item.checkout
                };

                BackEnd.execute(dadosReserva, function () {
                    vm.checkCarregandoSolicitacao = false;
                    vm.parent.modalSucessoSolicitacaoReserva(item, user);
                    vm.close();
                }, function (error) {
                    vm.checkCarregandoSolicitacao = false;
                    ErrorHandler.showError(error);
                });
            };

            vm.close = function () {
                $uibModalInstance.dismiss();
            };
            vm.ok = function () {
                $uibModalInstance.close('close');
            };
        }

        Search.selectUhListener(vm.update);
    }
})();

/**
 * Created by Welker on 29/09/2016.
 * <xs-vitrine ingressos-controller="vm"></xs-vitrine>
 * <div xs-vitrine ingressos-controller="vm"></div>
 *
 * Atributos:
 * - ingressos-controller: instancia do ingresso controller
 * - 
 * 
 * Exemplo:
 * <xs-vitrine ingressos-controller="vm"></xs-vitrine>
 */
(function () {
    'use strict';

    angular
            .module("b2c_ingressos")
            .directive("xsVitrine", xsVitrine);


    function xsVitrine() {
        return {
            restrict: 'EA', 
            scope:{
                ingressosController: '=',
            },
            templateUrl: 'app/components/xsVitrine/xsVitrine.html',
            controller: xsVitrineController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /** @ngInject */
    function xsVitrineController(BackEnd, ErrorHandler, Dialogs, Properties) {
        var vm = this;
        vm.productsVitrine = [];
        vm.loadingProducts = false;
        vm.selecionarDataPeloProdutoVitrine = vm.ingressosController.selecionarDataPeloProdutoVitrine;
        vm.fetchVitrine = function () {
            vm.loadingProducts = true;
            var params = {
                method: 'getAllProducts',
                tagProduto: 'Vitrine B2C'
            };
            BackEnd.execute(params, function (res) {
                res.sort(function (a, b) {
                    var orderA = Number(a.order);
                    var orderB = Number(b.order);
                    if (orderA > orderB) return 1;
                    if (orderA < orderB) return -1;
                    return 0;
                });
                vm.productsVitrine = res;
                vm.loadingProducts = false;
            }, function (error) {
                ErrorHandler.showError(error);
                vm.loadingProducts = false;
            });
        }
        vm.verMaisDetalhesProduto = function(product) {
            Dialogs.openProductDetais(product, vm.ingressosController);
        }

        
        if (Properties.showCalendarOnIngToken && vm.ingressosController._ingToken != null) {
            vm.ingressosController.openDatePickerModalMobile(vm.ingressosController.lastDate);
        } else {
            vm.fetchVitrine();
        }
        
    }
})();
(function() {
    'use strict';

    angular
      .module('b2c_ingressos')
      .controller('SelectNextHourController', SelectNextHourController);

    /** @ngInject */
    function SelectNextHourController($scope, Properties) {
      var vm = this;
      vm.showOnlyOneSchedule = Properties.showOnlyOneSchedule;
      vm.product = $scope.$parent.vm.products[0];
      vm.product.amount = vm.product.amount || 1;
      vm.showFewProducts = false;

      vm.product.schedules.forEach(function (e) {
        if (e.available <= 10) {
          vm.showFewProducts = true;
        }
      });
      if(vm.product.products !== null && angular.isDefined(vm.product.products)) {
        vm.products = vm.product.products;
      }

      vm.selectHour = function (product, hour, keyS, keyP) {
        if(hour.available <= 0) return;

        vm.products.forEach(function (el, key) {
          if (key === keyP) {
            product.schedule = hour.schedule;
            product.available = hour.available;
          }
          if (key !== keyP) {
            el.schedule = el.schedules[keyS].schedule;
            el.available = el.schedules[keyS].available;
          }
        });

      };

      /* END hide earlier tickets if it's today */
      vm.verifyHourAvaliable = function(e) {
        if (e.available && e.available <= 10) return "*";
      }


      vm.updateProductsSchedule = function(){
        var schedule = vm.pSchedule.schedule;
        for(var i = 0; vm.products.length > i ; i++){
           if(vm.products[i].schedules.length>0){
              vm.products[i].schedule = schedule;
           }
        }
        //console.log(vm.products);
      }
    }

  })();

(function() {
    'use strict';

    angular
      .module('b2c_ingressos')
      .controller('SelectHourController', SelectHourController);

    /** @ngInject */
    function SelectHourController($scope, Properties) {
      var vm = this;
      vm.showOnlyOneSchedule = Properties.showOnlyOneSchedule;
      vm.product = $scope.$parent.vm.products[0];
      vm.product.amount = vm.product.amount || 1;
      vm.showFewProducts = false;

      vm.product.schedules.forEach(function (e) {
        if (e.available <= 10) {
          vm.showFewProducts = true;
        }
      });
      if(vm.product.products !== null && angular.isDefined(vm.product.products)) {
        vm.products = vm.product.products;
        if(vm.showOnlyOneSchedule){
          var pSchedules = vm.products.filter(function (p) {
            return p.schedules && p.schedules.length>0;
          });
          if(pSchedules.length > 0) vm.pSchedule = pSchedules[0];
        }
      }

      vm.selectHour = function (product, hour) {
        if(hour.available <= 0) return;
        product.schedule = hour.schedule;
        product.available = hour.available;
        if(vm.product.path != product.path) vm.product.available = hour.available;
      };
      /**
       * BEGIN hide earlier tickets if it's today
       * and applying Properties.minHoursOfAdvancePurchase
       */

      var now = new Date();
      var isToday = vm.product.date && vm.product.date.getDate() === now.getDate()
        && vm.product.date.getMonth() === now.getMonth()
        && vm.product.date.getFullYear() === now.getFullYear();
      var showEarlierTickets = function(){
        if(!angular.isDefined(Properties.showEarlierTickets)){
            return false;
        }
        return Properties.showEarlierTickets !== false;
      }
      var getMinHoursOfAdvancePurchase = function(){
        if(!angular.isDefined(Properties.minHoursOfAdvancePurchase)){
          return 0;
        }
        return Number(Properties.minHoursOfAdvancePurchase);
      }
      function getFilteredSchedules(schedules){
        return schedules.filter(function(schedule){
          if(getMinHoursOfAdvancePurchase()){
            return ( now.getHours() + getMinHoursOfAdvancePurchase() ) < Number(schedule.schedule.replace(/:[0-9]{2}/,''))
          }
          return now.getHours() < Number(schedule.schedule.replace(/:[0-9]{2}/,''));
        });
      }

      if(isToday && !showEarlierTickets()){
        if(vm.products){
          vm.products.forEach(function(product){
            if(product.scheduleType != "code")
              product.schedules = getFilteredSchedules(product.schedules);
          });
          return;
        }
        if(vm.product && vm.product.scheduleType != "code"){
          vm.product.schedules = getFilteredSchedules(vm.product.schedules);
        }
      }
      /* END hide earlier tickets if it's today */
      vm.verifyHourAvaliable = function(e) {
        if (e.available && e.available <= 10) return "*";

      }


      vm.updateProductsSchedule = function(){
        var schedule = vm.pSchedule.schedule;
        for(var i = 0; vm.products.length > i ; i++){
           if(vm.products[i].schedules.length>0){
              vm.products[i].schedule = schedule;
           }
        }
        //console.log(vm.products);
      }
    }

  })();

(function() {
    'use strict';

    angular
      .module('b2c_ingressos')
      .controller('SelectComboDatesHourController', SelectComboDatesHourController);

    /** @ngInject */
    function SelectComboDatesHourController($scope, MyFunctions, Properties, BackEnd, ErrorHandler, Dialogs) {
      var vm = this;
      vm.product = $scope.$parent.vm.products[0];
      vm.product.amount = vm.product.amount || 1;
      vm.firstDateDisabled = Properties.setarPrimeiraDataDoCombo || false;

      if(vm.product.products !== null && angular.isDefined(vm.product.products)) {
        vm.products = vm.product.products;
      }

      angular.forEach(vm.product.products, function (p) {
        if (p._date) delete p._date;
        if (p.schedule) p.schedule = "";
        p._searchSchedules = false;
      });


      function getHour(p, date) {
        if (typeof date === 'string' || date instanceof String || date == null || angular.isUndefined(date)) return; //ignora se a date já for uma string
        p._searchSchedules = false;
        p.schedule = null;
        var d = Dialogs.wait("Buscando opções");
        BackEnd.execute(
          {
            method: "schedules",
            product: p.path,
            date: MyFunctions.dateToString(date),
          },
          function (data) {
                p._searchSchedules = true;
                if(data.length > 0) p.schedule = '';
                p.schedules = data;
                d.close();
          },
          function(error){
            p._searchSchedules = false;
            d.close();
            ErrorHandler.showError(error);
          }
        );
      }
      vm.errorMessage = function() {
        if(vm.product.products == null) return null;
        for (var i = 0; i < vm.product.products.length; i++) {
          var p = vm.product.products[i];
          if(p._date == null || angular.isUndefined(p._date)) return "Selecione a data do " + (p.shortName || p.name);
          if(p.schedules == null || p.schedules.length == 0) continue;
          if(p.schedule == null || angular.isUndefined(p.schedule) || p.schedule == "") return "Selecione a opção do " + (p.shortName || p.name);
        }
        return null;
      };

      angular.forEach(vm.product.products, function (child) {
        $scope.$watch(
          function () {
            return child._date;
          },
          function (newDate, oldDate) {
            if (newDate !== oldDate) {
              child.schedule = null;
              getHour(child, newDate);
            }
          }
        );
      });

      vm.minDate = vm.product.date;
      vm.maxDate = MyFunctions.addDays(vm.minDate, Properties.maxDaysInCombo || 31);
      vm.customClass = function(date, mode, p) {
        if(vm.dateDisabled(date, mode, p)) return "closed";
        return $scope.$parent.vm.options._parent_vm.getDayClass(date, mode);
      };
      if(vm.product.products && vm.product.products.length > 0){
        var _dialog = Dialogs.wait("Buscando datas disponíveis");
        var i = vm.product.products.length;
        var dialogClose = function() {
          i--;
          if(i <= 0) _dialog.close();
        }
        angular.forEach(vm.product.products, function (child) {
          child.availableDates = MyFunctions.availableDatesForProduct(child.path, MyFunctions.dateToString(vm.minDate), Properties.maxDaysInCombo || 31, undefined, dialogClose);
        });
      }
      vm.dateDisabled = function(date, mode, p) {
        if (mode === 'day') {
          if(p && p.availableDates && p.availableDates.indexOf(MyFunctions.dateToString(date)) < 0) return true;
          // var c2 = vm.product.products.filter(function(c){
          //   if(c._date === null) return false;
          //   return MyFunctions.dateToString(date) == MyFunctions.dateToString(c._date);
          // });
          // if(c2.length > 0) return true;
        }
        return $scope.$parent.vm.options._parent_vm.disabledDate(date, mode);
      };

      vm.selectHour = function (product, hour) {
        product.schedule = hour.schedule;
        if (vm.product.path != product.path)
          vm.product.available = hour.available;
      };
      vm.calculatePrice = function(){
        $scope.$parent.vm.calculatePrice();
      }

      if (vm.firstDateDisabled) {
        vm.products[0]._date = vm.product.date;
        vm.products[0]._searchSchedules = true;
      }

      vm.openDatePickerModal = function(product) {
        Dialogs.datePickerDialog("Selecione a Data", product._date || vm.minDate, function(date) {
          product._date = date;
        }, {}, {
          minDate: vm.minDate,
          maxDate: vm.maxDate,
          customClass: function(date,mode){
            return vm.customClass(date, mode, product);
          },
          dateDisabled: function(date,mode){
            return vm.dateDisabled(date, mode, product);
          }
        });
      };


    }

  })();

(function() {
    'use strict';

    angular
      .module('b2c_ingressos')
      .controller('SelectComboDatesController', SelectComboDatesController);

    /** @ngInject */
    function SelectComboDatesController($scope, MyFunctions, Properties, Dialogs) {
      var vm = this;
      vm.product = $scope.$parent.vm.products[0];
      vm.product.amount = vm.product.amount || 1;
      if(vm.product.products !== null && angular.isDefined(vm.product.products)) {
        vm.products = vm.product.products;
      }
      vm.product._children = [];
      angular.forEach(vm.products, function(p , i){
          vm.product._children.push({ path: p.path, _date: i == 0 ? vm.product.date : null, name: p.shortName || p.name });
      });
      vm.minDate = vm.product.date;
      vm.maxDate = MyFunctions.addDays(vm.minDate, Properties.maxDaysInCombo || 31);
      vm.customClass = $scope.$parent.vm.options._parent_vm.getDayClass;
      vm.dateDisabled = function(date, mode) {
        if (mode === 'day') {
          var c2 = vm.product._children.filter(function(c){
            if(c._date === null) return false;
            return MyFunctions.dateToString(date) == MyFunctions.dateToString(c._date);
          });
          if(c2.length > 0) return true;
        }
        return $scope.$parent.vm.options._parent_vm.disabledDate(date, mode);
      };
      if(Properties.autoSelectProductComboDates){
        var _lastDate = null;
        angular.forEach(vm.product._children, function(p){
          if(_lastDate == null || p._date != null) {
            _lastDate = p._date;
            return;
          }
          _lastDate = MyFunctions.addDays(_lastDate, 1);
          for (var i = 0; i < 5; i++) {
            if(!vm.dateDisabled(_lastDate, 'day')) {
              p._date = _lastDate;
              return
            }
            _lastDate = MyFunctions.addDays(_lastDate, 1);
          }
        });
      }

      vm.openDatePickerModal = function(product) {
        Dialogs.datePickerDialog(
          "Selecione a Data",
          product._date || vm.minDate,
          function (date) {
            product._date = date;
          },
          {},
          {
            minDate: vm.minDate,
            maxDate: vm.maxDate,
            customClass: vm.customClass,
            dateDisabled: vm.dateDisabled,
          }
        );
      };

    }

  })();

(function() {
    'use strict';

    angular
      .module("b2c_ingressos")
      .controller("SelectSameHourController", SelectSameHourController);

    /** @ngInject */
    function SelectSameHourController($scope) {
      var vm = this;
      vm.product = $scope.$parent.vm.products[0];
      vm.product.amount = vm.product.amount || 1;
      if (
        vm.product.products !== null &&
        angular.isDefined(vm.product.products)
      ) {
        vm.products = vm.product.products;

        var pItem = [];

        vm.products.forEach(function (prod1, i) {
          prod1.schedules.forEach(function (e) {
            vm.products.forEach(function (prod2, i2) {
              prod2.schedules.forEach(function (e1) {
                if (i !== i2) return;
                if (
                  !pItem.some(function (o) {
                    return o.schedule === e.schedule;
                  }) &&
                  e.schedule === e1.schedule
                ) {
                  if (Number(e.available) < Number(e1.available)) {
                    pItem.push(e);
                  } else {
                    pItem.push(e1);
                  }
                }
              });
            });
          });
        });

        vm.product.schedules = pItem;

        if (pItem.length > 0) vm.pSchedule = vm.product;
      }

      vm.selectHour = function (product, hour) {
        if (hour.available <= 0) return;
        product.schedule = hour.schedule;
        product.available = hour.available;
        if (vm.product.path != product.path)
          vm.product.available = hour.available;

        vm.updateProductsSchedule(hour.schedule)
      };

      vm.updateProductsSchedule = function (schedule) {
        for (var i = 0; vm.products.length > i; i++) {
          if (vm.products[i].schedules.length > 0) {
            vm.products[i].schedule = schedule;
          }
        }
      };
    }

  })();

(function() {
    'use strict';
  
    angular
      .module('b2c_ingressos')
      .controller('FreteController', FreteController);
  
    /** @ngInject */
    function FreteController(BackEnd, Dialogs, ErrorHandler, $scope) {        
        var vm = this;
        vm.cep = null;
        vm.product = $scope.$parent.vm.products[0];
        vm.searchFrete = function(){            
            var params = { 
                "method": "correiosGetPriceTime", 
                "zipcode": vm.cep, 
                "productPath": vm.product.path,
                "amount": vm.product.amount || 1
            };
            var dialog = Dialogs.wait();
            BackEnd.execute(params,
                function(data) {                        
                    dialog.close();
                    vm.product.amount = vm.product.amount || 1;
                    vm.fretes = data;
                }, function(error) {
                    dialog.close();
                    ErrorHandler.showError(error);
                }
            );
        };
    }

  })();
  
(function() {
    'use strict';

    angular
      .module('b2c_ingressos')
      .controller('SelectFirstDayController', SelectFirstDayController);

    /** @ngInject */
    function SelectFirstDayController($scope, MyFunctions) {
        var vm = this;
        vm.product = $scope.$parent.vm.products[0];
        vm.product.amount = vm.product.amount || 1;
        vm.minDate = vm.product.date;
        vm.product.date = null;
        MyFunctions.availableDatesForProduct(vm.product.path, MyFunctions.dateToString(vm.minDate), 90, undefined,
            function(dates){
              if(dates != null && angular.isDefined(dates))
                vm.product.date = MyFunctions.stringToDate(dates[0]);
            }
        );

    }

})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('HospedagemApartamentosController', HospedagemApartamentosController);

    /** @ngInject */
    function HospedagemApartamentosController($log, $window, ErrorHandler, BackEnd, localStorageService, Properties, MyFunctions, Search, $uibModal, Dialogs, $state, ScrollTo, $filter, Tracking) {
        var vm = this;
        vm.personsAsString = Search.personsAsString;
        var searchs = Search.getSearch();
        vm.containerWidth = parseInt($window.innerWidth);
        vm.showSearhHorizontal = false;
        vm.ordenarPorValor = 'MenorParaMaior';

        if (searchs === null || angular.isUndefined(searchs) || searchs.length === 0) {
            $state.go("hospedagemPesquisa");
        }
        vm.toPreviousState = function () {
            if (Properties.singlehotel)
                $state.go("hospedagemPesquisa");
            else
                $state.go("hospedagemHoteis");
        };
        vm.searchHorizontal = function (search, hoteis) {
            searchs = search;
            var parametrosConsultaHoteis = {
                'method': 'hoteisAvailabilityAndPrice',
                "adulto": search[0].adt,
                "colo": search[0].colo === null || angular.isUndefined(search[0].colo) ? "0" : search[0].colo.toString(),
                "chd2": search[0].chd === null || angular.isUndefined(search[0].chd) ? "0" : search[0].chd.toString(),
                "checkin": MyFunctions.dateToString(search[0].date),
                "checkout": MyFunctions.dateToString(search[0].endDate),
                "noites": MyFunctions.diasEntre(search[0].date, search[0].endDate).toString()
            };
            localStorageService.set('parametrosConsulta', parametrosConsultaHoteis);
            localStorageService.remove('resultPesquisa');
            if(hoteis === null || hoteis.length == 0) {
                vm.toPreviousState();
                return;
            }
            if(hoteis.length == 1){
                if(hoteis[0].item.hotelPath == vm.selectedHotel.item.hotelPath){
                    var h = hoteis[0];
                    if(h.item.unavailable){
                        Dialogs.again(null, h.item.unavailableMsg);
                        vm.toPreviousState();
                        return;
                    }
                    Search.setSelectHotel(h);
                    //vm.selectedHotel = Search.getSelectHotel();
                    //adjustMap();
                    $state.reload();
                } else {
                    vm.toPreviousState();
                }
            } else
                vm.toPreviousState();
        };

        var _h = Search.getSelectHotel();
        if (_h === null || angular.isUndefined(_h)) {
            $state.go("hospedagemHoteis");
        }
        if (_h.result === null || angular.isUndefined(_h.result)) {
            $state.go("hospedagemPesquisa");
        }
        if(_h.item.unavailable){
            /*Dialogs.again(null, _h.item.unavailableMsg); // removido para apresentar o erro na lista de hotesi indisponíveis.
            vm.toPreviousState();*/
            $state.go("hospedagemHoteis");
            return;
        }
        vm.selectedHotel = _h;
        function adjustMap(){
            if (vm.selectedHotel.item.localizacao && vm.selectedHotel.item.localizacao.indexOf("http") === 0) {
                vm.selectedHotel.item.linkmap = vm.selectedHotel.item.localizacao;
            }
        }
        adjustMap();



        function createConsulta(searchs, index) {
            var search0 = searchs[0];
            var search = searchs[index];
            var checkin = "";
            var chd = 0;
            var colo = 0;
            var terceiraIdade = 0;
            var days = 0;
            if (angular.isDefined(search0.date) && search0.date !== null && angular.isDefined(search0.endDate) && search0.endDate !== null && search0.endDate.getTime() > search0.date.getTime()) {
                checkin = MyFunctions.dateToString(search0.date);
                days = MyFunctions.diasEntre(search0.date, search0.endDate);
                if (angular.isDefined(search.chd) && search.chd > 0) {
                    chd = search.chd;
                }
                if (angular.isDefined(search.colo) && search.colo > 0) {
                    colo = search.colo;
                }
                if (angular.isDefined(search.terceiraIdade) && search.terceiraIdade > 0) {
                    terceiraIdade = search.terceiraIdade;
                }

                var parametrosConsultaHoteis = {
                    'method': 'hoteisAvailabilityAndPrice',
                    "adulto": search.adt,
                    "chd2": chd.toString(),
                    "colo": colo.toString(),
                    "terceiraIdade": terceiraIdade.toString(),
                    "checkin": checkin,
                    "checkout": MyFunctions.dateToString(search0.endDate),
                    "noites": days.toString()
                };
                return parametrosConsultaHoteis;
            }
            return null;
        }

        vm.index = 0;
        vm.consulta = createConsulta(searchs, vm.index);
        if (vm.selectedHotel === null || angular.isUndefined(vm.selectedHotel)) {
            $state.go("hospedagemHoteis");
        }
        vm.formatSearchLink = function(value){
            return value.replace(/&/g,'%26');
        };

        vm.selectedHotel.perm = $state.href("hospedagemPesquisa", {}, {absolute: true}) + "?hotelPath=" + vm.selectedHotel.item.hotelPath + "&a=" + vm.consulta.adulto + "&c1=" + vm.consulta.colo + "&c3=" + vm.consulta.chd2 + "&d=" + vm.consulta.checkin + "&df=" + vm.consulta.checkout;
        vm.whatsappSearchLink = "https://api.whatsapp.com/send?text=" + vm.formatSearchLink(vm.selectedHotel.perm);
        vm.allAdt = Search.adultos();
        vm.allChd = Search.criancas();
        vm.allColo = Search.colos();

        vm.adt = vm.consulta.adulto;
        vm.chd = vm.consulta.chd;
        vm.colo = vm.consulta.colo;

        ScrollTo.scrollTo("hospedagem-main");

        vm.foto = _foto;
        vm.uhs = vm.selectedHotel.result;
        vm.uhs = vm.uhs.sort(ordenaPorMenorPreco);
        Search.clearSelectsUh(); //Limpa UHs Selecionadas

        if (searchs.length > 1) {

            var msgAdultos = vm.consulta.adulto;
            msgAdultos += vm.consulta.adulto > 1 ? " adultos" : " adulto";
            var message = "Agora selecione o " + (vm.index + 1) + "º apartamento ( " + msgAdultos;

            if (vm.consulta.chd2 > 0) {
                var msgCriancas = vm.consulta.chd2;
                msgCriancas += vm.consulta.chd2 > 1 ? " crianças" : " criança";
                message += " e " + msgCriancas;
            }

            if (vm.consulta.colo > 0) {
                var msgColos = vm.consulta.colo;
                msgColos += vm.consulta.colo > 1 ? " colos" : " colo";
                message += " e " + msgColos;
            }
            if (vm.consulta.terceiraIdade > 0) {
                message += " e " + vm.consulta.terceiraIdade + " Melhor Idade";
            }
            message += " )";
            Dialogs.info(message);
        }

        try {
            Tracking.selectHotel(vm.selectedHotel);
        } catch (error) {
            $log.debug(error);
        }

        /*====================================================================*/
        /*------------------------ Filtros de Itens --------------------------*/
        function limpaItensRepetidos(array) {
            var arrayLimpo = [];
            for (var i = 0; i < array.length; i++) {
                var auxI = array[i];
                var encontrou = false;
                for (var j = 0; j < arrayLimpo.length; j++) {
                    var auxJ = array[j];
                    if (auxJ.nome === auxI.nome) {
                        encontrou = true;
                        break;
                    }
                }
                if (!encontrou) {
                    arrayLimpo.push(auxI);
                }
            }
            return arrayLimpo;
        }

        vm.buscaItensAptos = function () {
            vm.ItensAptoComodidades = [];
            vm.ItensAptoLazer = [];
            vm.ItensAptoEsportivos = [];
            vm.ItensAptoSeguranca = [];
            vm.allItens = [];

            for (var uh = 0; uh < vm.uhs.length; uh++) {
                for (var c = 0; c < vm.uhs[uh].comodidades.length; c++) {
                    if (vm.uhs[uh].comodidades[c].imagem !== "") {
                        if (vm.uhs[uh].comodidades[c].categoria === 'Comodidades') {
                            vm.ItensAptoComodidades.push(vm.uhs[uh].comodidades[c]);
                        }
                        if (vm.uhs[uh].comodidades[c].categoria === 'Lazer') {
                            vm.ItensAptoLazer.push(vm.uhs[uh].comodidades[c]);
                        }
                        if (vm.uhs[uh].comodidades[c].categoria === 'Esportivas') {
                            vm.ItensAptoEsportivos.push(vm.uhs[uh].comodidades[c]);
                        }
                        if (vm.uhs[uh].comodidades[c].categoria === 'Segurança') {
                            vm.ItensAptoSeguranca.push(vm.uhs[uh].comodidades[c]);
                        }
                    }
                }
            }
            vm.allItens.push(limpaItensRepetidos(vm.ItensAptoComodidades));
            vm.allItens.push(limpaItensRepetidos(vm.ItensAptoLazer));
            vm.allItens.push(limpaItensRepetidos(vm.ItensAptoEsportivos));
            vm.allItens.push(limpaItensRepetidos(vm.ItensAptoSeguranca));

            return vm.allItens;
        };
        vm.allItens = vm.buscaItensAptos();

        vm.arrayFiltrosAptos = [];
        vm.addfiltroAptos = function (filtro) {
            if (vm.arrayFiltrosAptos.indexOf(filtro) < 0) {
                vm.arrayFiltrosAptos.push(filtro);
            }
        };

        vm.filtrarAptos = function (apto) {
            var result = true;
            angular.forEach(vm.arrayFiltrosAptos, function (filter) {
                var comodidade = apto.comodidades.filter(function (comodidade) {
                    return comodidade.nome.toLocaleLowerCase() === filter.nome.toLocaleLowerCase();
                });
                if (comodidade.length === 0)
                    result = false;
            });
            return result;
        };

        vm.limparFiltroApto = function (filtro) {
            vm.arrayFiltrosAptos.splice(vm.arrayFiltrosAptos.indexOf(filtro), 1);
        };

        vm.limparFiltrosAptos = function () {
            vm.arrayFiltrosAptos = [];
            vm.uhs = vm.selectedHotel.result;
        };
        /*------------------------ Filtros de Itens --------------------------*/
        /*====================================================================*/

        //vm.checkPensao = "";
        //vm.meals = [];
        var tarifaPath = vm.selectedHotel.result[0].servicePath;
        var params1 = {
          "method": "mealPath",
          "hotel": vm.selectedHotel.item.hotelPath,
          "date": vm.consulta.checkin,
          "endDate": vm.consulta.checkout
        };
        if (tarifaPath) params1.rate = tarifaPath;
        BackEnd.execute(params1, function (data) {
            vm.uhs.forEach(function (uh) {
                uh.meals = [];
                if(data.length == 0) return;
                if (angular.isDefined(uh.included) && uh.included !== null) {
                    for (var i = 0; i < uh.included.length; i++) {
                        if (uh.mealType == uh.included[i].service) {
                            uh.included.splice(i);
                            break;
                        }
                    }
                }
                function calculateUhWithMeal(uh, meal, callback) {
                  var clone = {};
                  angular.copy(meal, clone);
                  uh.meals.push(clone);
                  if (uh.mealType == meal.service) {
                    uh.meal = meal;
                    var mealPath = meal.pathAsString;
                    if (angular.isDefined(uh.hotelPath) && mealPath.indexOf(uh.hotelPath) < 0)
                    mealPath = uh.hotelPath + "|" + mealPath;
                  uh.mealPath = mealPath;
                  clone.value = uh.value;
                  callback();
                    } else
                        calculateValueWithMeal(uh, clone, true, callback, true);
                }

                var j = 0;
                function calcNext(){
                    j++;
                    if(j < data.length)
                        calculateUhWithMeal(uh, data[j], calcNext);
                }
                calculateUhWithMeal(uh, data[j], calcNext);

            });
            findExtras();
        },
                ErrorHandler.showError);


        vm.mealIconClass = function (meal) {
            if (meal.service.toLowerCase().indexOf("almoço") >= 0)
                return 'cafe-e-almoco';
            else if (meal.service.toLowerCase().indexOf("jantar") >= 0)
                return 'cafe-e-jantar';
            else if (meal.service.toLowerCase().indexOf("completa") >= 0)
                return 'pensao-completa';
            return 'cafe-da-manha';
        };

        vm.selectMeal = function (item, meal) {
            if (angular.isDefined(item.meal) && item.meal !== null && angular.isDefined(item.included) && item.included !== null) {
                for (var i = 0; i < item.included.length; i++) {
                    if (item.mealType == item.included[i].service) {
                        item.included.splice(i);
                        break;
                    }
                }
            }
            item.mealType = meal.service;
            item.meal = meal;
            var path = meal.pathAsString;
            if (angular.isDefined(item.hotelPath) && path.indexOf(item.hotelPath) < 0)
                path = item.hotelPath + "|" + path;
            item.mealPath = path;
            item.mealType = meal.service;
            item.value = null;
            item.boletoValue = null;
            item.boletoDescontoValue = null;
            calculatePrice(vm.selectedHotel, item, function(result){

              meal.value = item.value;
                if (angular.isDefined(item.paymentMethods.visa)) {
                  item.paymentMethods.visa = result.maxFinancialLength || item.paymentMethods.visa;
                }
                defineFilterPrice();
            });
        };

        function calculateValueWithMeal (apto, meal, hideError, callback, cache) {
            callback = callback || function(){};
            var item = {};
            angular.copy(apto, item);
            item.mealType = meal.service;
            item.meal = meal;
            var path = meal.pathAsString;
            if (angular.isDefined(item.hotelPath) && path.indexOf(item.hotelPath) < 0)
                path = item.hotelPath + "|" + path;
            item.mealPath = path;
            item.mealType = meal.service;
            item.value = null;
            item.boletoValue = null;
            item.boletoDescontoValue = null;
            var onError = null;
            if (hideError) {
                onError = function () {
                    apto.meals.splice(apto.meals.indexOf(meal), 1);
                    //meal.value = "Nao disponivel";
                    callback();
                };
            }

            calculatePrice(null, item, function () {

                meal.value = item.value;
                defineFilterPrice();
                callback();
            }, true, onError, cache);

        }
        var calculatePrice = Search.calculatePrice;

        // ================== Implementação da escolha de extras ========================== //
        function findExtras() {
            var days = MyFunctions.diasEntre(MyFunctions.stringToDate(vm.consulta.checkin), MyFunctions.stringToDate(vm.consulta.checkout));
            //aptoSelect
            BackEnd.execute({
                "method": "extras",
                "service": vm.selectedHotel.result[0].servicePath,
                "hotel": vm.selectedHotel.result[0].hotelPath,
                "date": vm.consulta.checkin,
                "noites": days + ""
            },
                function (data) {
                    vm.extras = data;
                    var extrasByTag = [];
                    angular.forEach(vm.extras, function (extra) {
                        if (angular.isUndefined(extra.typeTag) || extra.typeTag === null || extra.typeTag === "")
                            extra.typeTag = extra.tag;
                        var elementByTag = extrasByTag.find(function (el) {
                            if (el.tag == extra.typeTag)
                                return true;
                            return false;
                        });
                        if (angular.isUndefined(elementByTag) || elementByTag === null)
                            extrasByTag.push({"tag": extra.typeTag, "extras": [extra]});
                        else
                            elementByTag.extras.push(extra);
                    });
                    angular.forEach(vm.uhs, function (uh) {
                        uh.extrasByTag = [];
                        angular.copy(extrasByTag, uh.extrasByTag);
                    });
                },
                    ErrorHandler.showError
                );
        }
        vm.toggleExtra = function (apto, extra) {
            var uh = apto;
            if (angular.isUndefined(uh.included) || uh.included === null)
                uh.included = [];
            if (extra.checked)
                uh.included.push(extra);
            else
                uh.included.pop(extra);
            calculatePrice(vm.selectedHotel, uh, defineFilterPrice);
        };
        vm.infoExtras = function(info){
            Dialogs.info(info);
        };

        // ================== /Implementação da escolha de extras ========================== //

        vm.selectUh = function (uh) {
            if (angular.isUndefined(uh.meals) || uh.meals === null || uh.meals.length === 0 || (uh.mealPath !== null && angular.isDefined(uh.mealPath) && angular.isDefined(uh.mealType) && uh.mealType !== null)) {
                uh.checkout = vm.consulta.checkout;
                uh._adultos = parseInt(vm.consulta.adulto, 10);
                uh._chd = parseInt(vm.consulta.chd2, 10);
                uh._colo = parseInt(vm.consulta.colo, 10);
                uh._terceiraIdade = parseInt(vm.consulta.terceiraIdade, 10);
                uh.amount--;
                Search.addSelectUh(uh);
                try {
                    Tracking.selectUH(uh);
                } catch (error) {
                    $log.debug(error);
                }
                vm.aptoSelect(uh);
                //Search.toNextStep();
                //$state.go("hospedagemIdentificacao");
            }
        };

        vm.aptoSelect = function (uh) {
            var apto = searchs[vm.index];
            apto.selectedUh = {};
            angular.copy(uh, apto.selectedUh);
            if (searchs.length > vm.index + 1) {
                apto.active = false;
                var uhs = vm.uhs;
                vm.uhs = [];
                for (var i = 0; i < uhs.length; i++) {
                    var _uh = {};
                    angular.copy(uhs[i], _uh);
                    _uh.value = null;
                    _uh.oldValue = null;
                    _uh.boletoValue = null;
                    _uh.persons = [];
                    var j = 0;
                    for (j = 0; j < searchs[vm.index + 1].adt; j++) {
                        _uh.persons.push({
                            tag: "Adulto"
                        });
                    }
                    for (j = 0; j < searchs[vm.index + 1].chd; j++) {
                        _uh.persons.push({
                            tag: "Criança"
                        });
                    }
                    for (j = 0; j < searchs[vm.index + 1].colo; j++) {
                        _uh.persons.push({
                            tag: "Colo"
                        });
                    }
                    for (j = 0; j < searchs[vm.index + 1].terceiraIdade; j++) {
                        _uh.persons.push({
                            tag: "terceiraIdade"
                        });
                    }
                    vm.uhs.push(_uh);
                    calculatePrice(vm.selectedHotel, _uh, function (_uh) {
                        delete _uh.hide;
                        _uh.meals.forEach(function (meal) {
                            if (_uh.mealType == meal.service) {
                                _uh.meal = meal;
                                meal.value = _uh.value;
                            } else {
                                calculateValueWithMeal(_uh, meal);
                            }
                        });
                        defineFilterPrice();
                    }, false, function (erro, _uh) {
                        _uh.hide = true;
                    });
                }
                searchs[vm.index + 1].active = true;
                vm.index++;
                vm.consulta = createConsulta(searchs, vm.index);
                //vm.totalPagamento = Search.totalValue();

                var msgAdultos = vm.consulta.adulto;
                msgAdultos += vm.consulta.adulto > 1 ? " adultos" : " adulto";
                var message = "Agora selecione o " + (vm.index + 1) + "º apartamento ( " + msgAdultos;

                if (vm.consulta.chd2 > 0) {
                    var msgCriancas = vm.consulta.chd2;
                    msgCriancas += vm.consulta.chd2 > 1 ? " crianças" : " criança";
                    message += " e " + msgCriancas;
                }

                if (vm.consulta.colo > 0) {
                    var msgColos = vm.consulta.colo;
                    msgColos += vm.consulta.colo > 1 ? " colos" : " colo";
                    message += " e " + msgColos;
                }
                if (vm.consulta.terceiraIdade > 0) {
                    message += " e " + vm.consulta.terceiraIdade + " Melhor Idade";
                }
                message += " )";

                Dialogs.info(message);
            } else {
                Search.toNextStep();
            }
        };


        /*====================================================================*/
        /*------------------------ Functions Layout --------------------------*/
        function defineFilterPrice() {
            vm.aptoValueMax = -1;
            vm.aptoValueMin = 100000000;

            angular.forEach(vm.uhs, function (apto) {
                var total = apto.value / 100;
                if (total > vm.aptoValueMax) {
                    vm.aptoValueMax = total;
                }
                if (total < vm.aptoValueMin) {
                    vm.aptoValueMin = total;
                }
            });
            vm.aptoValueMin -= 10;
            vm.aptoValueMax += 10;
            vm.rangePrecoApto = [vm.aptoValueMin, vm.aptoValueMax];
            vm.aptoValueMin -= 10;
            vm.aptoValueMax += 10;
        }
        defineFilterPrice();

        vm.precoApto = function (apto) {
            if (apto.value === null)
                return true;
            var total = apto.value / 100;
            if (total >= vm.rangePrecoApto[0] && total <= vm.rangePrecoApto[1]) {
                return true;
            } else {
                return false;
            }
        };

        /*
         * Ordena preço do menor para o maior
         * @returns {orderBy}
         */
        function ordenaPorMenorPreco(a, b) {
            return a.value - b.value;
        }
        /*
         * Ordena preço do maior para o menor
         * @returns {orderBy}
         */
        function ordenaPorMaiorPreco(a, b) {
            return b.value - a.value;
        }
        /**
         * Verifica a ordem a ser ordenada
         * @param {object} orderBy
         */
        vm.ordernarPrecos = function (orderBy) {
            if (orderBy === 'MenorParaMaior') {
                vm.uhs = vm.uhs.sort(ordenaPorMenorPreco);
            } else if (orderBy === 'MaiorParaMenor') {
                vm.uhs = vm.uhs.sort(ordenaPorMaiorPreco);
            }
        };

        vm.directScroll = function (id_scroll) {
            ScrollTo.scrollTo(id_scroll);
        };

        vm.pagamentoParcelado = function (paymentMethods, value) {
            var maior = -1;
            angular.forEach(paymentMethods, function (method) { //pegar bandeira de cartão com mais vezes no parcelamento
                if (method > maior) {
                    maior = method;
                }
            });
            return maior + "x de " + $filter('currency')(value / 100 / maior, 'R$ ');
        };


        /**
         * @return boolean
         */
        vm.temJurosParcelado = function(apto){
          if(!apto.paymentMethodsAdjustments || (apto.paymentMethodsAdjustments && !apto.paymentMethodsAdjustments.length <= 0)){
            return false;
          }
          var temJuros = false;
          apto.paymentMethodsAdjustments.forEach(function(method){
            if(method.type === 'acrescimo'){
              temJuros = true;
            }
          })
          return temJuros;
        };

        /**
         * @return {string|false} Texto
         * pronto do melhor desconto. Caso não haja,
         * retorna false.
         */
        vm.getMelhorDesconto = function(apto){
          var melhorDesconto = Search.getBestPaymentDiscount(apto);
          if(!melhorDesconto) return false
          return $filter('currency')(Number(melhorDesconto.value) / 100, 'R$ ') + (melhorDesconto.paymentTypes.includes('pix') ? (' no PIX') : (' em ' + melhorDesconto.installments + 'x'));
        }
        vm.getBestPaymentDiscount = Search.getBestPaymentDiscount;


        vm.getMaiorPagamentoParcelado = function (apto){
          var maxNumParcelas = -1;
          var maxAjuste = null;
          angular.forEach(apto.paymentMethods, function (method) {
            if (Number(method) > maxNumParcelas) {
              maxNumParcelas = Number(method);
            }
          });

          if(apto.paymentMethodsAdjustments && apto.paymentMethodsAdjustments.length){
            apto.paymentMethodsAdjustments.forEach(function(adjustment){
              if(Number(adjustment.installments) === maxNumParcelas && Number(adjustment.value) > Number(apto.value)){
                maxAjuste = adjustment;
              }
            });
          }
          if(maxAjuste){
            return maxNumParcelas + "x de " + $filter('currency')(Number(maxAjuste.value) / 100 / maxNumParcelas, 'R$ ');
          }
          return maxNumParcelas + "x de " + $filter('currency')(Number(apto.value) / 100 / maxNumParcelas, 'R$ ');
        };

        /*------------------------ Functions Layout and Filter ---------------*/
        /*====================================================================*/



        /*====================================================================*/
        /*----------------------- modais controlles e functions* -------------*/
        vm.openModalMaisDetalhesApartamento = function (_item) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/apartamentos/modais/openModalMaisDetalhesApartamento.html",
                bindToController: true,
                controller: _ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    item: function () {
                        return _item;
                    },
                    parent: function () {
                        return vm;
                    }
                }
            });
            modalInstance.result.then(function () {
                vm.selectUh(_item);
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        vm.modalInformativoHotel = function (_item) {
            var item = _item;
            $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/hotel/modais/openModalInformativoHotel.html",
                bindToController: true,
                controller: _ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    item: function () {
                        return item;
                    },
                    parent: function () {
                        return vm;
                    }
                }
            });
        };

        vm.modalCompartilhar = function (_item) {
            var item = _item;
            $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/apartamentos/modais/openModalCompartilhar.html",
                bindToController: true,
                controller: _ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    item: function () {
                        return item;
                    },
                    parent: function () {
                        return vm;
                    }
                }
            });
        };

        vm.modalInformativo = function (politica, _item) {
            var item = [];
            item.text = angular.isDefined(_item) ? _item : "";
            item.politica = angular.isDefined(politica) ? politica : "";

            /*var modalInstance =*/ $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/hotel/modais/openModalInformativo.html",
                bindToController: true,
                controller: _ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    item: function () {
                        return item;
                    },
                    parent: function () {
                        return vm;
                    }
                }
            });
        };

        vm.openModalCarrinhoApartamentos = function (_item) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/hoteis/modais/openModalCarrinhoApartamentos.html",
                bindToController: true,
                controller: _ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    item: function () {
                        return _item;
                    },
                    parent: function () {
                        return vm;
                    }
                }
            });
            modalInstance.result.then(function () {
                vm.selectUh(_item);
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        function _foto(item) {
            if (angular.isUndefined(item.foto) || item.foto === null || angular.isUndefined(item.foto.length) || item.foto.length === 0) {
                return "./assets/images/not-imagem.jpg";
            } else {
                return item.foto.split("|")[0].split("\\").join("/");
            }
        }

        vm.modalGaleria = function (item) {
            if (angular.isUndefined(item.foto) || item.foto.length === 0)
                return;
            var fotos = item.foto.split("\\").join("/").split("|");
            Dialogs.galeria(function () {
                return item.service;
            }, function () {
                return fotos;
            }, {});
        };

        vm.arrayImagensHotel = function () {
            var item = vm.selectedHotel.item;
            if (angular.isUndefined(item.foto) || item.foto.length === 0) {
                return;
            }
            var fotos = item.foto.split("\\").join("/").split("|");
            return fotos;
        };

        /** @ngInject */
        function _ItemModalController($uibModalInstance, item, parent) {
            var vm = this;
            vm.item = item;
            vm.parent = parent;

            vm.close = function () {
                $uibModalInstance.dismiss();
            };
            vm.ok = function () {
                $uibModalInstance.close('close');
            };
        }
        /*----------------------- Functions Modais ---------------------------*/
        /*====================================================================*/
    }
})();

(function(){
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('ConfirmacaoContaController', ConfirmacaoController);

    /** @ngInject */
    function ConfirmacaoController($state, $stateParams, Cart) {
        var vm = this;   

        vm.newBill = function(){
            $state.go("ingressos");
        };

        if (angular.isDefined($stateParams.id) && $stateParams.id !== null && $stateParams.id !== "") {                                        
            if(angular.isDefined($stateParams.locator) && $stateParams.locator !== null && $stateParams.locator !== ""){
                var lb = Cart.getLastBill();
                if(lb === null || angular.isUndefined(lb) || lb.id !== $stateParams.id)
                    Cart.setLastBill({id: $stateParams.id, localizador: $stateParams.locator});
            }
            vm.billId = $stateParams.id;
            Cart.setProducts([]);
        }
    }

})();
/**
 * Created by Danillo on 31/08/2016.
 *
 * <xs-search-bar-holder xs-id-holder="id" xs-search="search()"></xs-search-bar>
 * <div xs-search-bar-holder xs-id-holder="id" xs-search="search()"></div>
 *
 * Atributos:
 * - xs-search-bar-holder: função executada pelo botão nova compra; *
 * Exemplo:
 * <xs-search-bar-holder xs-id-holder="id"  xs-search="search()" template-url="app/myOrderForm.html"></xs-search-bar>
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .directive('xsSearchBarHolder', xsSearchBarHolder);

    function xsSearchBarHolder($document, $compile) {
        return {
            restrict: 'EA',
            scope: {
                xsSearch: '='
            },
            link: function (scope, element, attrs) {
                var queryResult = $document[0].getElementById(attrs.xsIdHolder);
                var el = angular.element(queryResult);
                
                var _templateUrl = "";
                if(angular.isDefined(attrs.templateUrl) && attrs.templateUrl !== null){
                   _templateUrl = attrs.templateUrl; 
                }
                
                el.html('');
                el.append($compile('<xs-search-bar xs-search="vm.xsSearch" template-url="' + _templateUrl + '"></xs-search-bar>')(scope));
            },
            controller: xsSearchBarHolderController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /** @ngInject */
    function xsSearchBarHolderController() {
        var vm = this;
        vm.searchBarHolder = "SearchBarHolder";
    }

})();

/**
 * Created by Danillo on 31/08/2016.
 *
 * <xs-search-bar xs-search="search()"></xs-search-bar>
 * <div xs-search-bar xs-search="search()"></div>
 *
 * Atributos:
 * - xs-search: função executada pelo botão nova compra;
 * - template-url: url do template alternativo a ser utilizado (Opcional);
 *
 * Exemplo:
 * <xs-search-bar xs-search="search()" template-url="app/myOrderForm.html"></xs-search-bar>
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .directive('xsSearchBar', xsSearchBar);

    function xsSearchBar() {

        return {
            restrict: 'EA',
            scope: {
                xsSearch: '='
            },
            templateUrl: function (elem, attr) {
                if (angular.isDefined(attr.templateUrl) && attr.templateUrl !== "")
                    return attr.templateUrl;
                return 'app/components/xsSearchBar/xsSearchBar.html';
            },
            controller: xsSearchBarController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /** @ngInject */
    function xsSearchBarController($scope, Properties, Search, MyFunctions, Dialogs, localStorageService, ErrorHandler, moment, $state) {
        /*jshint validthis:true */
        var vm = this;
        vm.verificaDialogChd = Properties.usaIdadePorCrianca;
        vm.maxAdultos = Properties.maxAdultos || 10;
        vm.activeDate = false;
        vm.activeEndDate = false;
        vm.today = new Date();
        if(Properties.dataAbertura)
            vm.today = Properties.dataAbertura;
        if(Properties.antecipacaoMinima)
            vm.today = MyFunctions.addDays(vm.today, Properties.antecipacaoMinima);        
        vm.dates= {
            date: vm.today,
            endDate: MyFunctions.addDays(vm.today, 1)
        };
        vm.quartos = '1';
        vm.adt = '2';
        vm.obj = {};
        vm.obj.date = vm.dates.date;
        vm.obj.endDate = vm.dates.endDate;
        vm.obj.adt = vm.adt;
        vm.obj.chd = vm.chd;
        vm.obj.colo = vm.colo;
        vm.obj.terceiraIdade = vm.terceiraIdade;
        vm.obj.quartos = vm.quartos;
        vm.aptos = [vm.obj];
        vm.currentHoteis = [vm.obj];
        vm.showHotelFilter = Properties.filtroHoteis;

        vm.handleDate = function () {
            vm.activeDate = true;
        };

        vm.handleEndDate = function () {
            vm.nextDay = MyFunctions.addDays(vm.dates.date, 1);
            if (vm.dates.endDate < vm.nextDay)
                vm.dates.endDate = vm.nextDay;
            vm.activeEndDate = true;
        };

        vm.openDatePickerModal = function () {
            Dialogs.datePickerDialog("Data de Entrada", vm.dates.date, function (date) {
                vm.dates.date = date;
                vm.openEndDatePickerModal();
            });
        };
        vm.openEndDatePickerModal = function () {
            Dialogs.datePickerDialog("Data de Saída", vm.dates.endDate, function (date) {
                vm.dates.endDate = date;
            });
        };
        vm.openChdDialog = function () {
            Dialogs.openChdDialog();
        }
        vm.verificaAdultos = false;
        vm.verificaCriancas = false;
        vm.verificaColos = false;
        vm.ckecksQuantidadesQuartos = function () {
            if (vm.quartos > 1) {
                vm.verificaAdultos = true;
                vm.verificaCriancas = true;
                vm.verificaColos = true;
            } else {
                vm.verificaAdultos = false;
                vm.verificaCriancas = false;
                vm.verificaColos = false;
            }
        };

        function setLastSearch() {
            if (vm.aptos.length == 1) {
                vm.aptos[0].adt = vm.adt;
                vm.aptos[0].chd = vm.chd;
                vm.aptos[0].colo = vm.colo;
                vm.aptos[0].terceiraIdade = vm.terceiraIdade;
            }
            vm.aptos[0].quartos = vm.quartos;
            vm.aptos[0].date = vm.dates.date;
            if (vm.dates.endDate <= vm.dates.date)
                vm.dates.endDate = MyFunctions.addDays(vm.dates.date, 1);
            vm.aptos[0].endDate = vm.dates.endDate;
            vm.aptos[0].noites = MyFunctions.diasEntre(vm.aptos[0].date, vm.aptos[0].endDate);
            Search.setSearch(vm.aptos);
        }
        vm.search = function (){
            if(angular.isUndefined(vm.selectedHotel) || vm.selectedHotel === null || vm.selectedHotel.id == '0'){
                defaultSearch();
            }else {
                hotelSearch();
            }
        }
        function hotelSearch(){
            var objParams = { hotelPath: vm.selectedHotel.path, a: vm.adt, c1: vm.colo, c3: vm.chd,
                d: MyFunctions.dateToString(vm.dates.date), df: MyFunctions.dateToString(vm.dates.endDate) };
            $state.go('hospedagemPesquisa', objParams);

        }
        function defaultSearch() {
            localStorageService.remove('lastResult');
            vm.aptos.sort(
                    function (a0, a1) {
                        var a = parseInt(a0.adt, 10) + parseInt(a0.chd === "" ? "0" : a0.chd, 10) + parseInt(a0.colo === "" ? "0" : a0.colo, 10) + parseInt(a0.terceiraIdade === "" ? "0" : a0.terceiraIdade, 10);
                        var b = parseInt(a1.adt, 10) + parseInt(a1.chd === "" ? "0" : a1.chd, 10) + parseInt(a1.colo === "" ? "0" : a1.colo, 10) + parseInt(a0.terceiraIdade === "" ? "0" : a0.terceiraIdade, 10);
                        return b > a ? 1 : -1;
                    }
            );
            for (var i = 0; i < vm.aptos.length; i++) {
                var apto = vm.aptos[i];
                apto.index = i;
            }

            var dialog = Dialogs.wait();
            setLastSearch();
            Search.executeSearch(Search.createConsulta(Search.getSearch(), 0),
                    function (data) {
                        dialog.close();
                        //if (angular.isUndefined(data) || data === null || data.length === 0) {
                            //Dialogs.again();
                            //return;
                       // }
                        vm.xsSearch(vm.aptos, data);
                    },
                    function (error) {
                        dialog.close();
                        ErrorHandler.showError(error);
                    }
            );
        }

        $scope.$watch('vm.quartos', function (newValue) {
            if (vm.aptos.length < newValue) {
                for (var i = vm.aptos.length; i < newValue; i++) {
                    vm.aptos.push({
                        adt: "1",
                        chd: "",
                        colo: "",
                        terceiraIdade: ""
                    });
                }
            } else if (vm.aptos.length > newValue) {
                while (vm.aptos.length > newValue) {
                    vm.aptos.pop();
                }
            }
        });

        var lastSearch = Search.getSearch();
        // localStorageService.get("_xs_search_aptos");
        if (angular.isDefined(lastSearch) && lastSearch !== null) {
            vm.aptos = lastSearch;
            vm.adt = vm.aptos[0].adt;
            vm.chd = vm.aptos[0].chd;
            vm.colo = vm.aptos[0].colo;
            vm.terceiraIdade = vm.aptos[0].terceiraIdade;

            var date = moment(vm.aptos[0].date).toDate();
            if (date > new Date()){
                vm.dates.date = date;
            }
            var endDate = moment(vm.aptos[0].endDate).toDate();
            if (angular.isUndefined(vm.aptos[0].endDate) || vm.aptos[0].endDate === null)
                endDate = MyFunctions.addDays(date, 1);
            if (endDate > vm.dates.date)
                vm.dates.endDate = endDate;
            vm.quartos = vm.aptos[0].quartos;
            vm.ckecksQuantidadesQuartos();
        } else {
            vm.firstDay = new Date();
            if(angular.isDefined(Properties.firstDayWeekToSearch) && Properties.firstDayWeekToSearch !== null) {
                while(vm.firstDay.getDay() != Properties.firstDayWeekToSearch){
                    vm.firstDay = MyFunctions.addDays(vm.firstDay, 1);
                }
            }
            vm.nextDay = MyFunctions.addDays(vm.firstDay, 1);
            if(angular.isDefined(Properties.lastDayWeekToSearch) && Properties.lastDayWeekToSearch !== null) {
                while(vm.nextDay.getDay() != Properties.lastDayWeekToSearch){
                    vm.nextDay = MyFunctions.addDays(vm.nextDay, 1);
                }
            }
            vm.dates.date = vm.firstDay;
            vm.dates.endDate = vm.nextDay;
            setLastSearch();
        }

        function getAvailableHoteis(){
           var hoteis = localStorageService.get('hoteis');
           if(hoteis == null || angular.isUndefined(hoteis) || hoteis == ""){
            Search.getHoteis().then(function (value) {
                value.unshift({name: "Todos Hoteis", id: "0" })
                vm.currentHoteis = value;
                vm.selectedHotel = vm.currentHoteis[0];
            }, function (error) {
                ErrorHandler.showError(error);
            });
           }else {
            hoteis.unshift({name: "Todos Hoteis", id: "0" })
            vm.currentHoteis = hoteis;
            vm.selectedHotel = vm.currentHoteis[0];
           }
        }

        if(Properties.filtroHoteis){
            getAvailableHoteis();
        }

    }
})();

/**
 * Created by Welker on 29/09/2016.
 * <xs-save-person xs-person="objPerson" xs-save="funcSave()"></xs-save-person>
 * <div xs-save-person xs-person="objPerson" xs-save="funcSave()"></div>
 *
 * Atributos:
 * - xs-person: objeto que representa a pessoa que será cadastrada;
 * - xs-save: função que salva a pessoa;
 *
 * Exemplo:
 * <xs-save-person xs-person="vm.hospede" xs-save="vm.saveHospede()"></xs-save-person>
 */
(function () {
    'use strict';

    angular
            .module("b2c_ingressos")
            .directive("xsSavePerson", xsSavePerson);


    function xsSavePerson() {
        return {
            restrict: 'EA',
            scope: {
                xsObjPerson: '=',
                xsSave: '='
            },
            //link: function (scope, element, attrs, controller) {
            //
            //},
            templateUrl: 'app/components/xsSavePerson/xsSavePerson.html',
            controller: xsSavePersonController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /** @ngInject */
    function xsSavePersonController(BackEnd, ErrorHandler) {
        var vm = this;

        vm.findByCpf = function (cpf) {
            BackEnd.execute({
                'method': 'findPersonByCpf',
                "cpf": cpf
            }, function (data) {
                vm.xsObjPerson = data;
            }, function (err) {
                ErrorHandler.showError(err);
            });
        };

        vm.findZipCode = function (zipCode) {
            // vm.hospede.city / vm.hospede.state
            BackEnd.execute({
                'method': 'findZipcode',
                "zipcode": zipCode
            }, function (data) {
                if (angular.isDefined(data.tipo_logradouro) && angular.isDefined(data.logradouro)) {
                    vm.xsObjPerson.street0 = data.tipo_logradouro + " " + data.logradouro;
                }
                if (angular.isDefined(data.bairro)) {
                    vm.xsObjPerson.street1 = data.bairro;
                }
                vm.xsObjPerson.city = data.cidade;
                vm.xsObjPerson.state = data.uf;
            }, function (err) {
                ErrorHandler.showError(err);
            });
        };
    }
})();

/**
 * Created by Danillo on 31/08/2016.
 *
 * <xs-payment xs-complete="vm.pagamentoEfetuado" xs-products="vm.products"></xs-payment>
 * <div xs-payment xs-complete="vm.pagamentoEfetuado" xs-products="vm.products"></div>
 *
 * Atributos:
 * - xs-change: na alteração da diretiva o componente atualiza;
 * - xs-products: função que retorna os produtos (obrigatorio);
 * - xs-complete: função que será chamada quando o pagamento for efetuado com sucesso. Passa como parametro o retorno da venda (Importante);
 * - template-url: url do template alternativo a ser utilizado (Opcional);
 *
 * Exemplo:
 * <xs-payment xs-products="vm.products" xs-complete="vm.pagamentoEfetuado" template-url="app/myForm.html"></xs-payment>
 */

/**
 * @typedef {import("../../../types/properties").PropertiesType} PropertiesType
 * @typedef {import("../../../types/ingresso").IngressoType} IngressoType
 */

(function() {
    'use strict';

    angular
        .module('b2c_ingressos')
        .directive('xsPayment', xsPayment);

    function xsPayment() {

        return {
            restrict: 'EA',
            scope: {
                xsChange: '=',
                xsProducts: '&',
                xsCupom: '&',
                xsTotalValue: '=',
                xsPaidValue: '=',
                xsComplete: '=',
                xsCustomPrices: '='
            },
            templateUrl: function(elem, attr) {
                if (angular.isDefined(attr.templateUrl))
                    return attr.templateUrl;
                return 'app/components/xsPayment/xsPayment.html';
            },
            link: function(scope, element, attrs, controller) {
                /*This method will be called whet the 'objectToInject' value is changes*/
                scope.$watch('vm.xsChange', function(value) {
                    /*Checking if the given value is not undefined*/
                    if (value) {
                        controller.paymentMethods2();
                        controller.checkSameDayProduct();
                    }
                });
            },
            controller: xsPaymentController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /**
     * @param {PropertiesType} Properties
     * @ngInject
     */
    function xsPaymentController($filter, $log, $state, Auth, BackEnd, MyFunctions, ErrorHandler, Tracking, $scope, $rootScope, $window, Dialogs, $cardType, Properties, localStorageService, PaymentService) {
        /* jslint validthis:true */
        var vm = this;
        vm.xsComplete = vm.xsComplete || function() {};
        //vm.xsTotalValue = vm.xsTotalValue;
        vm.xsPaidValue = vm.xsPaidValue || 0;
        vm.paymentMethods = null;
        vm.pagseguroId = "";
        var gerencianetToken = "";
        vm.gerencianetInstallments = [];
        var gnCheckout = null;
        var gerencianetBrand = '';
        var cupom = "";
        var cupomCod = "";
        var cupomKey;
        vm._ccutils={hasNotCC:false,list:['visa','mastercard','master','elo','dinners','diners','hipercard','amex'], list_recurring:['visa_r','mastercard_r','master_r','elo_r','dinners_r','diners_r','hipercard_r','amex_r']}
        vm.brands = [];
        vm.financialLength = [];
        vm.fixedCardInstallments = Properties.parcelasFixasCartao;
        vm.Need3dsVerify = Properties._3ds;
        vm.showSameDayProductMesssage = false;
        vm.terms = false;

        vm.showPaymentCardAddress = !!Properties._3ds && Properties.show3dsCardAddress;
        vm.has3DS = function(){
            return !!(Properties._3ds);
        }
        vm.ignoreCpf = function() {
            if (!Auth.isLoggedIn())
                return false;
            var user = Auth.getUser();
            if (angular.isDefined(user.customData) && user.customData.estrangeiro === 'true')
                return true;
            return false;
        };

        vm.personEstrangeiro = function() {
           if (!Auth.isLoggedIn()) return false;
           var user = Auth.getUser();
           if (
             angular.isDefined(user.customData) &&
             user.customData.estrangeiro === "true"
           )
             return true;
           return false;
        }

        vm.user = Auth.getUser();

        function getFinalPrice(_numberOfInstallments){
            var paymentMethodAdjustment = priceAdjustment(_numberOfInstallments);
            if(paymentMethodAdjustment && paymentMethodAdjustment.value){
                return Number(paymentMethodAdjustment.value);
            }
            return vm.xsTotalValue;
        }

        $rootScope.abrirObrigatorioModalPoliticas = function () {
            if (!Properties.obrigatorioModalPoliticas || vm.terms) return;
            Dialogs.politicas(
                function () { vm.terms = false },
                function () { vm.terms = !Properties.obrigatorioModalPoliticasNaoAceitar }
            );
        };

        vm.allPaymentMethods = function() {
          var list = allPaymentMethodsAdjustments();

          if(!list) return []

          var adjustments = list;

          var conditionsMap = {};

          if (Array.isArray(adjustments)) {
            adjustments.forEach(function (c) {
              if (c.type === "acrescimo") return;

              var obj = {
                paymentMethod: c,
                installments: parseInt(c.installments),
                percent: c.percent,
                type: c.type,
              };

              if (conditionsMap[c.percent]) {
                if (
                  obj.installments >
                  conditionsMap[c.percent].installments
                ) {
                  conditionsMap[c.percent] = obj;
                }
              } else {
                conditionsMap[c.percent] = obj;
              }
            });
          }
          return Object.values(conditionsMap);
        }

        vm.findPaymentMethodByType = function (data, paymentType) {
          for (var key in data) {
            if (data.hasOwnProperty(key)) {
              var paymentMethod = data[key].paymentMethod;

              if (vm._ccutils.list.indexOf(paymentType) >= 0)
                if (paymentMethod.paymentTypes.includes(paymentType)) {
                  return paymentMethod.installments > 1
                    ? "Em até " + paymentMethod.installments + "x com desconto"
                    : "À vista com desconto";
                }

               if (vm._ccutils.list.indexOf(paymentType) < 0)
                 if (paymentMethod.paymentTypes.includes(paymentType)) {
                   return paymentMethod.percent+' Desconto';
                 }
            }
          }

          return null;
        };

        vm.totalGeral = function(parcelas) {
            var result = vm.xsTotalValue;
            if(hasPaymentMethodsAdjustments() && hasPaymentTypeSelected()){
              if(vm.paymentTypeCard && parcelas === undefined && vm.paymentMethod.length === null) {
                Object.keys(vm.paymentMethods).forEach(function (method) {
                  if(vm._ccutils.list.indexOf(method) >= 0 && vm._ccutils.list.indexOf(vm.paymentMethod.type) < 0) {
                    vm.paymentMethod.type = method;
                  }
                });

                if (vm._ccutils.list.indexOf(vm.paymentMethod.type) >= 0)
                  result = getFinalPrice(1);
              } else {
                if (
                  vm._ccutils.list.indexOf(vm.paymentMethod.type) < 0 &&
                  vm._ccutils.list_recurring.indexOf((vm.paymentMethod.type) < 0)
                ) {
                  vm.paymentMethod.length = 1;
                }
                  result = getFinalPrice(parcelas || vm.paymentMethod.length);
              }
            }
            if (angular.isUndefined(vm.xsPaidValue) || vm.xsPaidValue === null || vm.xsPaidValue === 0)
              return result;
            return result - vm.xsPaidValue;
        };

        function allPaymentMethodsAdjustments(){
          if(!vm.xsCustomPrices) return false;
          var pas = vm.xsCustomPrices.paymentMethodsAdjustments();
          return pas;
        }

        function hasPaymentMethodsAdjustments(){
          if(!vm.xsCustomPrices) return false;
          var pas = vm.xsCustomPrices.paymentMethodsAdjustments();
          return !!(pas);
        }

        function hasPaymentTypeSelected(){
          return !!(vm.paymentMethod && vm.paymentMethod.type);
        }

        if (angular.isDefined($window.$gn) && $window.$gn !== null) {
            $window.$gn.ready(function(checkout) {
                gnCheckout = checkout;
            });
        }
        vm.checkSameDayProduct = function(){

            var today = new Date();
            var products = vm.xsProducts();
            for(var i = 0; i < products.length; i++){
                    var product_date = new Date(products[i].date)
                    if(MyFunctions.datesAreOnSameDay(product_date,today)){
                        vm.showSameDayProductMesssage = true;
                        return;
                    }
            }
            vm.showSameDayProductMesssage = false;
            return;
        }

        vm.findZipCodeAddress = MyFunctions.findZipCodeAddress;

        vm.paymentMethods2 = function(callback) {
            callback = callback || function(){};
            vm.paymentMethod = { type: null };
            var oldBill = localStorageService.cookieGet("bill_remark");
            if (angular.isDefined(oldBill) && oldBill !== null && angular.isDefined(oldBill.id) && oldBill.id > 0) {
                if (vm.xsTotalValue <= vm.xsPaidValue) {
                    vm.paymentMethods = { remarcacao: 1 };
                    vm.brands = [];
                    vm.brands.push({ name: "remarcacao", active: false });
                    vm.selectType("remarcacao", 0);
                    return;
                }
            }

            var produtosAsString = MyFunctions.productosToString(vm.xsProducts());
            var couponAsString = "";
            cupom = vm.xsCupom();
            if (angular.isDefined(cupom) && cupom !== null) {
                var split = cupom.split("-");
                cupomCod = split[0];
                if (split.length > 1) {
                    cupomKey = split[1];
                }
            }
            if (cupomCod) {
                couponAsString = cupomCod + "|" + (cupomKey === undefined || cupomKey == null ? "" : cupomKey); // "|" + cupomKey;
            }
            var user = null;
            if(Auth.isLoggedIn())
                user = Auth.getUser();
            else if(Auth.getPerson() !== null && angular.isDefined(Auth.getPerson()))
                user = Auth.getPerson();
            var params1 = {
                "method": "paymentMethods",
                "personAsString": user,
                "productsArray": produtosAsString
            };
            if(couponAsString) params1.couponAsString = couponAsString;
            var bookingAgency = localStorageService.cookieGet("bookingAgency");
            if(bookingAgency)
              params1.toAgencyPath = bookingAgency;
            BackEnd.execute(params1,
                function(data) {
                    if (oldBill !== null) {
                        // visa: 3, mastercard: 3, elo: 3, diners: 3, amex: 3
                        var data2 = {};
                        var _arr = ["visa", "mastercard", "elo", "diners", "amex", "hipercard", "master"];
                        angular.forEach(data, function(value, key) {
                            if (_arr.indexOf(key.toLowerCase()) >= 0) {
                                data2[key] = 1;
                            }
                        });
                        data = data2;
                    }
                    vm.paymentMethods = data;
                    if (vm.brands.length <= 0) {
                        for (var type in vm.paymentMethods) {
                            if (type !== "email") {
                                vm.brands.push({ name: type, active: false });
                            }
                        }
                        // Meio de pagamento gerencianet (fictício);
                        if (angular.isDefined(vm.paymentMethods.gerencianet) && vm.paymentMethods.gerencianet !== null) {
                            vm.paymentMethods.gerencianetVisa = vm.paymentMethods.gerencianet;
                            vm.paymentMethods.gerencianetMaster = vm.paymentMethods.gerencianet;
                            delete vm.paymentMethods.gerencianet;
                            vm.brands.push({ name: 'gerencianetvisa', active: false });
                            vm.brands.push({ name: 'gerencianetMaster', active: false });
                        }
                    }
                    if (angular.isDefined(vm.paymentMethods.email)) {
                        delete vm.paymentMethods.email;
                    }
                    var typeDefault = vm.brands.find(function (b) { return b.name === Properties.defaultPaymentMethod; });

                    if (typeDefault) {
                        vm.selectType(
                            typeDefault.name,
                            vm.brands.indexOf(typeDefault)
                        );
                    } else {
                        vm.selectType(vm.brands[0].name, 0);
                    }

                    callback();
                    /*for (var key in vm.paymentMethods) {
                        if (vm.paymentMethods.hasOwnProperty(key)) {
                            vm.selectType(key, 0);
                            break;
                        }
                    }*/
                });
        };

        function getPagseguroPaymentMethods() {
            vm.pagSeguroPaymentMethods = [];
            getPagSeguroPayment().getPaymentMethods({
                amount: vm.totalGeral() / 100,
                success: function(response) {
                    if (response.error) {
                        ErrorHandler.showError(response.error);
                    }
                    var target = response.paymentMethods["CREDIT_CARD"].options;
                    for (var key in target) {
                        vm.pagSeguroPaymentMethods.push(target[key]);
                    }

                    if (vm.paymentMethod.code !== null || vm.paymentMethod.code !== "" || vm.paymentMethod.goodThru !== null || vm.paymentMethod.goodThru !== "" || vm.paymentMethod.cardNumber !== null || vm.paymentMethod.cardNumber !== "" || vm.paymentMethod.cardNumber.length < 16) {
                        getPagseguroBrand(); // Chama a função que busca a bandeira se for pagseguro
                    }
                },
                error: function(error) {
                    ErrorHandler.showError(error.errors);
                    $log.debug(error);
                },
                complete: function(response) { //tratamento comum para todas chamadas
                    $log.debug(response);
                }
            });
        }

        vm.getInstallments = function() {
            if (vm.pagseguroBrand === null || vm.pagseguroBrand.name === null)
                return;
            var modal = Dialogs.wait();
            getPagSeguroPayment().getInstallments({
                amount: vm.totalGeral() / 100,
                brand: vm.pagseguroBrand.name,
                maxInstallmentNoInterest: 0,
                success: function(response) {
                    vm.pagseguroInstallments = response.installments[vm.pagseguroBrand.name];
                },
                error: function(error) {
                    try {
                        modal.close();
                        $log.debug(error);
                        ErrorHandler.showError(error.errors);
                    } catch (error1) {
                        $log.debug(error1);
                    }
                },
                complete: function() {
                    try {
                        modal.close();
                    } catch (error) {
                        $log.debug(error);
                    }
                }
            });
        };

        vm.installmentText = function(i) {
            if (i.quantity === 1) {
                return i.quantity + "x de " + $filter('currency')(i.installmentAmount, 'R$ ') + " = " + $filter('currency')(i.totalAmount, 'R$ ');
            }
            return i.quantity + "x de " + $filter('currency')(i.installmentAmount, 'R$ ') + " = " + $filter('currency')(i.totalAmount, 'R$ ') + " (Com Juros)";
        };

        vm.gerencianetInstallmentText = function(i) {
            if (i.installment === 1 || i.installment === '1') {
                return i.installment + "x de " + i.currency + " = " + i.currency;
            }
            var total = (parseInt(i.value) * parseInt(i.installment)) / 100;
            return i.installment + "x de " + i.currency + " = " + $filter('currency')(total) + " (Com Juros)";
        };

        function getPagseguroCardToken() {

            if (vm.paymentMethod.code === null || vm.paymentMethod.code === "")
                return;
            if (vm.paymentMethod.goodThru === null || vm.paymentMethod.goodThru === "")
                return;
            if (vm.paymentMethod.cardNumber === null || vm.paymentMethod.cardNumber === "" || vm.paymentMethod.cardNumber.length < 16)
                return;

            var pattern = eval(/ /g);
            vm.paymentMethod.cardNumber = vm.paymentMethod.cardNumber.replace(pattern, "");

            getPagSeguroPayment().createCardToken({
                cardNumber: vm.paymentMethod.cardNumber,
                brand: vm.pagseguroBrand.name,
                cvv: vm.paymentMethod.code,
                expirationMonth: vm.paymentMethod.goodThru.substring(0, 2),
                expirationYear: "20" + vm.paymentMethod.goodThru.substring(2).replace("/", ""),
                success: function(response) {
                    vm.pagseguroCardToken = response.card.token;
                    if (vm.senderHash === null || vm.senderHash === 0 || angular.isUndefined(vm.senderHash)) {
                        vm.senderHash = getPagSeguroPayment().getSenderHash();
                    }
                    vm.getInstallments();
                },
                error: function(error) {
                    ErrorHandler.showError(JSON.stringify(error.errors));
                    //$log.debug("cardToken", error.errors);
                },
                complete: function() {}
            });

        }

        function getPagseguroBrand() {
            if (angular.isUndefined(vm.paymentMethod.cardNumber) || vm.paymentMethod.cardNumber === "")
                return;
            var normalizedCardBin = vm.paymentMethod.cardNumber.replace(" ", "");
            normalizedCardBin = normalizedCardBin.substring(0, 6);

            getPagSeguroPayment().getBrand({
                cardBin: normalizedCardBin,
                success: function(response) {
                    vm.pagseguroBrand = response.brand;
                    getPagseguroCardToken(); // Chama a função que cria o token de cartão de crédito
                },
                error: function(error) {
                    ErrorHandler.showError("Dados incorretos, verifique os dados informados.");
                    //ErrorHandler.showError(error.errors);
                    $log.debug(error);
                },
                complete: function() {
                    //$log.debug("complete");
                }
            });
        }

        var getGerencianetToken = function(params) {
            // var dateArray = params.goodThru.split("/");
            params.month = params.goodThru.substring(0, 2);
            params.year = params.goodThru.substring(2);
            gnCheckout.getPaymentToken({
                brand: params.brand.toLowerCase(), // bandeira do cartão
                number: params.number, // número do cartão
                cvv: params.code, // código de segurança
                expiration_month: params.month, // mês de vencimento
                expiration_year: params.year // ano de vencimento
            }, function(error, response) {
                if (error) {
                    var errorMsg = "Erro de Token - " + error;
                    $log.debug(errorMsg);
                    ErrorHandler.showError(error);
                } else {
                    gerencianetToken = response.data.payment_token;
                    $log.debug("Gerencianet Token", gerencianetToken);
                }
            });
        };

        var gerencianetInstallments = function(type) {
            var valor = vm.totalGeral();

            if (type === 'gerencianetVisa')
                gerencianetBrand = 'Visa';
            if (type === 'gerencianetMaster')
                gerencianetBrand = 'Mastercard';
            gnCheckout.getInstallments(valor, gerencianetBrand, function(error, response) {
                vm.financialLength = [];
                if (error) {
                    // Trata o erro ocorrido
                    ErrorHandler.showError(error);
                } else {
                    var maxParcela = response.data.installments.length;
                    $log.debug("installments", maxParcela);
                    for (var i = 1; i <= maxParcela; i++) {
                        vm.financialLength.push(i);
                    }
                    vm.gerencianetInstallments = response.data.installments;
                    $log.debug("installments", vm.financialLength);
                }
            });
        };


        /**
         * Verifica Bandeira do Cartao
         */
        vm.verificaBandeiraCartao = function() {
            if (vm.paymentMethod.type == "debito") return;
            if (vm.paymentMethod.type == "pagsegurotransparente") return;
            if (angular.isUndefined(vm.paymentMethod.cardNumber) || vm.paymentMethod.cardNumber === null || vm.paymentMethod.cardNumber.length <= 8) {
                return;
            }
            var card = $cardType.cardType(vm.paymentMethod.cardNumber);
            vm.paymentMethod.cardType = (card === "" || angular.isUndefined(card) ? null : card);
            if (!vm.paymentMethod.cardNumber.length < 12) {
                var brand = vm.brands.filter(function(e, i) {
                    e._position = i;
                    return e.name == vm.paymentMethod.cardType || (e.name == "master" && vm.paymentMethod.cardType == "mastercard");
                });
                if (brand !== null && brand.length > 0) {
                  if(vm.paymentTypeCard_r === true) {
                    vm.paymentMethod.type = vm.paymentMethod.cardType+'_r';
                  } else {
                    vm.paymentMethod.type = vm.paymentMethod.cardType;
                  }
                  vm.selectType(vm.paymentMethod.type, brand[0]._position);
                }
            }
        };

          $scope.$watch("vm.paymentTypeCard", function() {
            if (vm.paymentTypeCard) {
              for (var j = 0; j < vm.brands.length; j++) {
                vm.brands[j].active = false;
              }
              if (!vm.paymentTypeCard_r) {
                for (var type in vm.paymentMethods) {
                  if (vm._ccutils.list.indexOf(type) > 0) {
                    vm.paymentMethod.type = type;
                  }
                }
              }

              vm.paymentTypeCard_r = false;

                if (
                  vm._ccutils.list_recurring.indexOf(vm.paymentMethod.type) >= 0
                ) {
                  vm.paymentMethod.type = vm.paymentMethod.type.slice(0, -2);
                  updateFinancialLength();
                } else {
                  vm.paymentMethod.length = null;
                }
            }
          });

          $scope.$watch("vm.paymentTypeCard_r", function () {
            if (vm.paymentTypeCard_r) {
              for (var j = 0; j < vm.brands.length; j++) {
                vm.brands[j].active = false;
              }

              if (!vm.paymentTypeCard) {
                for (var type in vm.paymentMethods) {
                  if (vm._ccutils.list_recurring.indexOf(type+"_r") > 0) {
                    vm.paymentMethod.type = type;
                  }
                }
              }

              vm.paymentTypeCard = false;

              if (vm._ccutils.list.indexOf(vm.paymentMethod.type) >= 0) {
                vm.paymentMethod.type = vm.paymentMethod.type+'_r';
                updateFinancialLength();
              }
            }
          });



        vm.selectType = function(key, index) {
          for (var j = 0; j < vm.brands.length; j++) {
            vm.brands[j].active = false;
          }

          vm.brands[index].active = true;

              if (vm._ccutils.list.indexOf(key) >= 0) {
                vm.paymentTypeCard = true;
              }

              if (vm._ccutils.list_recurring.indexOf(key) >= 0) {
                vm.paymentTypeCard_r = true;
              }
              if (
                vm._ccutils.list.indexOf(key) < 0 &&
                vm._ccutils.list_recurring.indexOf(key) < 0
              ) {

                vm.paymentTypeCard = false;
                vm.paymentTypeCard_r = false;

                vm.paymentMethod.cardNumber = '';
                vm.paymentMethod.code = '';
                vm.paymentMethod.goodThru = '';

              }
              vm.brands[index].active = true;

              var aliases = {
                mastercard: "master",
                master: "mastercard",
              };

              var resolvedType =
                aliases[key.toLowerCase()] || null;

              if (
                !vm.paymentMethods[key.toLowerCase()] &&
                resolvedType !== null
              ) {
                vm.paymentMethod.type = resolvedType;
              } else {
                vm.paymentMethod.type = key
              }

              // vm.paymentMethod.type = key;


            if (vm.paymentMethod.type === "pagsegurotransparente") { // Verifica se é pagamento com Pagseguro
                vm.pagseguroTotalValue = vm.totalGeral() / 100;
                if (vm.pagseguroId === "" || vm.pagseguroId.length <= 0) { // Verifica se o ID de sessão já está setado
                    BackEnd.getPagseguroSessionId(function(data) {
                        getPagSeguroPayment().setSessionId(data); // Seta o ID de sessão
                        vm.pagseguroId = data;
                        getPagseguroPaymentMethods(); // Chama a função que busca as formas de pagamento
                    });
                } else {
                    getPagseguroPaymentMethods();
                }
            } else if (vm.paymentMethod.type === "mercadopagotransparente") {
                //initMercadoPago();
            } else if (vm.paymentMethod.type === "gerencianetVisa" || vm.paymentMethod.type === "gerencianetMaster") {
                vm.gerencianetTotalValue = vm.totalGeral() / 100;
                gerencianetInstallments(vm.paymentMethod.type);
            } else {
                updateFinancialLength(); // Se não for pagseguro atualiza a quantidade de parcelas
            }
        }

        function getPagSeguroPayment() {
            if ($window.PagSeguroDirectPayment === null || angular.isUndefined($window.PagSeguroDirectPayment))
                    return null;
            return $window.PagSeguroDirectPayment;
        }

        function _listenerPagSeguro(new_value) { // Monitora o número do cartão de crédito
            if (vm.paymentMethod == null || angular.isUndefined(vm.paymentMethod)) return;
            if (vm.paymentMethod.type === "pagsegurotransparente" &&
                angular.isDefined(new_value) && new_value !== null && new_value.length > 0 ) {
                vm.pagseguroInstallments = [];
                if (vm.paymentMethod.code === null || angular.isUndefined(vm.paymentMethod.code) || vm.paymentMethod.code.length < 3)
                    return;
                if (vm.paymentMethod.goodThru === null ||  angular.isUndefined(vm.paymentMethod.goodThru))
                    return;
                if (vm.paymentMethod.cardNumber === null ||  angular.isUndefined(vm.paymentMethod.cardNumber) || vm.paymentMethod.cardNumber.length < 16)
                    return;

                getPagseguroBrand(); // Chama a função que busca a bandeira se for pagseguro
            }
        }
        $scope.$watch('vm.paymentMethod.goodThru', _listenerPagSeguro);
        $scope.$watch('vm.paymentMethod.code', _listenerPagSeguro);
        $scope.$watch('vm.paymentMethod.cardNumber', _listenerPagSeguro);

        $scope.$watch('vm.paymentMethod.length', function(new_value) {
            if (angular.isDefined(new_value) && new_value !== null) {
                if (vm.paymentMethod.type === "pagsegurotransparente") {
                    vm.pagseguroTotalValue = vm.paymentMethod.length.totalAmount;
                    vm.installmentQuantity = vm.paymentMethod.length.quantity;
                }
                if (vm.paymentMethod.type === "gerencianetVisa" || vm.paymentMethod.type === "gerencianetMaster") {
                    var params = {
                        brand: gerencianetBrand,
                        number: vm.paymentMethod.cardNumber.replace(/ /g, ""),
                        code: vm.paymentMethod.code,
                        goodThru: vm.paymentMethod.goodThru
                    };
                    vm.gerencianetTotalValue = vm.paymentMethod.length.value;
                    vm.installmentQuantity = vm.paymentMethod.length.installment;
                    getGerencianetToken(params);
                    vm.paymentMethods.gerencianet = vm.paymentMethods.gerencianetVisa;
                    // delete vm.paymentMethods.gerencianetVisa;
                    // delete vm.paymentMethods.gerencianetMaster;
                }
            }
        });

        function priceAdjustment(n){
            if(angular.isUndefined(vm.xsCustomPrices) || vm.xsCustomPrices == null) return null;
            var arr = vm.xsCustomPrices.paymentMethodsAdjustments();
            if(angular.isUndefined(arr) || arr == null || arr.length == 0) return null;
            arr = arr.filter(function(obj){
                if(!obj.paymentTypes.includes(vm.paymentMethod.type)) return false;
                return obj.installments == n;
            });
            if(angular.isUndefined(arr) || arr == null || arr.length == 0) return null;
            return arr[0];
        }

        vm.parcelas = function(n) {
            var pa = priceAdjustment(n);
            if(pa != null) {
                var value = pa.installmentValue / 100;
                return n + "x de " + $filter('currency')(value, 'R$ ') + " com " + pa.type;
            }
            var amount = (vm.totalGeral(n) / n) / 100;
            if(angular.isDefined(vm.xsCustomPrices) && vm.xsCustomPrices != null) {
              var arr = vm.xsCustomPrices.paymentMethodsAdjustments();
              if(angular.isDefined(arr) && arr !== null && arr.length > 0) {
                return n + "x de " + $filter('currency')(amount, 'R$ ') + " sem juros";
              }
            }
            return n + "x de " + $filter('currency')(amount, 'R$ ');
        };

        vm.financialLength = null;

        function updateFinancialLength() {
            if (angular.isUndefined(vm.paymentMethods))
                return;

            vm.financialLength = [];
            var maxParcela = null;
            try {
                if(vm.paymentTypeCard_r) {
                  maxParcela = vm.paymentMethods['recorrencia'];
                } else {
                  maxParcela =
                      vm.paymentMethods[vm.paymentMethod.type.toLowerCase()];

                }
            } catch (err) {
                maxParcela = 1;
            }

            for (var i = 1; i <= maxParcela; i++) {
                vm.financialLength.push(i);
            }

            if(vm.paymentTypeCard_r || vm.paymentMethod.cardNumber && vm.paymentMethod.cardNumber.length < 12) {
               vm.financialLength.shift();
            }
            if(maxParcela == 1 || vm.paymentMethod.length == null || vm.paymentMethod.length === 0){
                vm.paymentMethod.length = 1;
            }
            if(vm.fixedCardInstallments !== null && angular.isDefined(vm.fixedCardInstallments) && vm.fixedCardInstallments <= maxParcela){
                vm.paymentMethod.length = vm.fixedCardInstallments;
            }

        }
        vm.showParcels = function(val){
            return (vm.fixedCardInstallments && vm.fixedCardInstallments == val) || !vm.fixedCardInstallments;
        }

        var mercadoPagoDialog = null;
        function afterMercadoPagoToken(response){
            if(mercadoPagoDialog != null) mercadoPagoDialog.close();
            if(response == null) return;
            $log.info(response);
            vm.paymentMethod = {
                type: "mercadopagotransparente",
                length: response._installments || 1,
                personName: response.cardholder.name,
                cardNumber: response.id,
                code: "XXX",
                goodThru: vm.paymentMercadoPago.goodThruMonth + vm.paymentMercadoPago.goodThruYear,
                personCpf: response.cardholder.identification.number,
                value: vm.totalGeral(),
                customData: {
                    card_number : response.first_six_digits + "XXXXXX" + response.last_four_digits,
                    brand: response._brand
                }
            };
            vm.purchase();
        }

        vm.bloqueiaClickNasBandeiras = function (key) {
          if (Properties.bloqueiaClickNasBandeiras) {
            if (vm._ccutils.list.indexOf(key) >= 0) {
              return false;
            }
            if (vm._ccutils.list_recurring.indexOf(key + "_r") >= 0) {
              return false;
            }
          }

          return true
        }

        vm.initMercadoPago = function() {
            vm.user = Auth.getUser();
            $window.initMercadoPago(afterMercadoPagoToken);
            vm.paymentMercadoPago = {
                description: "ingressos",
            };
        };
        vm.purchaseMercadoPago = function(){
            mercadoPagoDialog = Dialogs.wait();
            $window.doMercadoPagoPay();
        };

        function checkisNotValid(value){
            return angular.isUndefined(value) || value == ""  || value == null;
        }

        vm.verifyCardActive = function () {
            if (!vm.paymentMethods) return false;

            if (vm.paymentMethods.visa) return true;
            if (vm.paymentMethods.mastercard) return true;
            if (vm.paymentMethods.elo) return true;
            if (vm.paymentMethods.diners) return true;
            if (vm.paymentMethods.amex) return true;
            if (vm.paymentMethods.hipercard) return true;
            if (vm.paymentMethods.master) return true;

            return false;
        }

        vm.isInvalidCard = function() {
            var paymentMethod = vm.paymentMethod;

            if (angular.isDefined(Properties.checkLogin) && Properties.checkLogin) {
                var userLogin = Auth.getUser();

                if (angular.isDefined(paymentMethod) && !paymentMethod.personName && userLogin !== null && angular.isDefined(userLogin.name)) {
                    if(userLogin.name.length > 30) paymentMethod.personName = userLogin.name.substring(0, 30);
                    else
                        paymentMethod.personName = userLogin.name;
                }
                if (angular.isDefined(paymentMethod) && !paymentMethod.personCpf && userLogin !== null && angular.isDefined(userLogin.cpf)) {
                    paymentMethod.personCpf = userLogin.cpf;
                }
            }
            if (angular.isUndefined(paymentMethod) || !paymentMethod.type)
                return "Selecione uma Forma de Pagamento";

            if(['pix', 'picpay', 'pagseguro', 'PayPal', 'Parque', 'remarcacao',  'Boleto', 'boleto', 'gerencianetBoleto', 'deposito', 'mercadopagotransparente' ].indexOf(paymentMethod.type) >= 0) {
            //if (paymentMethod.type === 'mercadopagotransparente' ) {
                return vm.terms ? false : "Aceite os termos de compra.";
            }
            /*if (paymentMethod.type === 'pix' || paymentMethod.type === 'pagseguro' || paymentMethod.type === 'PayPal' || paymentMethod.type === 'Parque' || paymentMethod.type === 'remarcacao') {
                if (!vm.terms)
                    return "Aceite os termos de compra.";
                return false;
            }
            if (vm.paymentMethod.type === "Boleto" || vm.paymentMethod.type === "boleto" || vm.paymentMethod.type === "gerencianetBoleto" || vm.paymentMethod.type === "deposito") {
                return vm.terms ? false : "Aceite os termos de compra.";
            }*/
            if(vm.showPaymentCardAddress){
                if(checkisNotValid(vm.userCard)) {
                    return "Por favor preencher dados de cobrança fatura";
                }
                var userData = ['email','cellPhone','street0','street1','address','city','state','zipCode'];
                for(var i = 0; i < userData.length; i++){
                    if(checkisNotValid(vm.userCard[userData[i]]) && (/*userData[i] === 'cellPhone' ||*/ userData[i] === 'email' )){
                        return "Por favor preencher dados completos.";
                    }
                    if(checkisNotValid(vm.userCard[userData[i]])){
                        return "Por favor preencher endereço completo.";
                    }
                }
            }
            if (!paymentMethod.personName)
                return "Informe o Nome do Titular";
            if(!vm.ignoreCpf()){
                if (!paymentMethod.personCpf) {
                    return "Informe o CPF do titular";
                } else if(!MyFunctions.cpfValidator(paymentMethod.personCpf)){
                    return "Informe um CPF válido";
                }
            }
            if (angular.isUndefined(paymentMethod.cardNumber) || paymentMethod.cardNumber === "")
                return "Informe o Número do Cartão";
            if(!MyFunctions.cardNumberValidator(paymentMethod.cardNumber))
                return "Numero de cartão invalido";
            else {
                var brand = $cardType.cardType(paymentMethod.cardNumber);
                if (brand == null || brand == ""){
                    return "Numero do cartao invalido";
                } else {
                    var brands = vm.brands.filter(function(e, i) {
                        e._position = i;
                        return e.name == brand || (e.name == "master" && brand == "mastercard");
                    });
                    if(brands == null || brands.length == 0)
                        return "Cartão nao aceito no site"
                }
            }
            if (!paymentMethod.code)
                return "Informe o Código do Cartão";
            if (!paymentMethod.goodThru)
                return "Informe a Validade do Cartão";
            if (parseInt(paymentMethod.goodThru.substring(0,2),10) > 12)
                return "Mês da Validade do Cartão está incorreto";
            if (angular.isUndefined(paymentMethod.length) || paymentMethod.length <= 0)
                return "Escolha o Número de Parcelas";
            if (!vm.terms)
                return "Aceite os termos de compra.";
            return false;
        };

        vm.isProcessing = false;
        //var firstTry = true;


        vm.showPaymentMethod = function(key){
            if(key !== 'pix'){
                return true;
            }
            if(Properties.pixEstrangeiro) {
              return true;
            }
            var user = null;
            if(Auth.isLoggedIn())
                user = Auth.getUser();
            if(Auth.getPerson() !== null && angular.isDefined(Auth.getPerson()))
                user = Auth.getPerson();
            if (user !== null && angular.isDefined(user.customData) && user.customData.estrangeiro === 'true')
                return false;
            return true;
        }

        $scope.$watch("vm.getDadosUser()", function (newValue) {
          if (newValue !== null && vm.Need3dsVerify && vm.Need3dsVerify.enable) {
            vm.userCard = {};
            vm.userCard.cellPhone = newValue.cellPhone;
            vm.userCard.email = newValue.email;
            vm.userCard.zipCode = newValue.zipCode;
            vm.userCard.street0 = newValue.street0;
            vm.userCard.address = newValue.address;
            if (Properties.PreencheComplemento3dsComNumero) {
              vm.userCard.address = newValue.number;
            }
            vm.userCard.street1 = newValue.street1;
            vm.userCard.city = newValue.city;
            vm.userCard.state = newValue.state.toLowerCase();
          }
        });


        vm.getDadosUser = function () {
            var user = null;
            if (Auth.isLoggedIn()) user = Auth.getUser();
            if (
              Auth.getPerson() !== null &&
              angular.isDefined(Auth.getPerson())
            )
              user = Auth.getPerson();

            return user
        }

        vm.purchase = function() {
            // var totalGeral = vm.totalGeral();
            // var installmentsAmount = vm.paymentMethod.length;

            var device = {
              user_agent: navigator.userAgent,
              color_depth: screen.colorDepth,
              type: 'BROWSER',
              java_enabled: navigator.javaEnabled(),
              language: navigator.language,
              screen_height: screen.height,
              screen_width: screen.width,
              time_zone_offset: new Date().getTimezoneOffset(),
            };

            var user = null;
            if(Auth.isLoggedIn())
                user = Auth.getUser();
            else if(Auth.getPerson() !== null && angular.isDefined(Auth.getPerson()))
                user = Auth.getPerson();
            if (user === null) {
                Dialogs.info("Por favor efetue login.");
                return;
            }
            if (!vm.terms) {
                Dialogs.info("Você não aceitou os termos de compra.");
                return;
            }
            var methodName = "buy";
            var webGateway = "";
            if(Properties.buyWithPaymentLink) {
                methodName = "buyWithPaymentLink";
            } else if (vm.paymentMethod.type === "Boleto" || vm.paymentMethod.type === "boleto") {
                methodName = "buyWithBoleto";
            } else if (vm.paymentMethod.type === "deposito") {
                methodName = "buyWithDeposito";
            } else if (vm.paymentMethod.type === "gerencianetBoleto") {
                methodName = "buyWithBoletoGerencianet";
            } else if (vm.paymentMethod.type === "PayPal") {
                methodName = "buyWithWebGateway";
                webGateway = "PayPal";
            } else if (vm.paymentMethod.type === "Parque") {
                methodName = "buyToPaymentInSupplier";
            } else if (vm.paymentMethod.type === "pagseguro") {
                methodName = "buyWithWebGateway";
                webGateway = "PagSeguro";
            } else if (vm.paymentMethod.type === "pix") {
                methodName = "buyWithWebGateway";
                webGateway = "Pix";
            } else if (vm.paymentMethod.type === "picpay") {
                methodName = "buyWithWebGateway";
                webGateway = "PicPay";
            } else if (vm.paymentMethod.type === "pagsegurotransparente") {
                if (vm.pagseguroCardToken === null || angular.isUndefined(vm.pagseguroCardToken) ||
                    vm.senderHash === null || angular.isUndefined(vm.senderHash) ||
                    vm.pagseguroBrand.name === null || angular.isUndefined(vm.pagseguroBrand.name)) {
                    alert("Servidor não encontrado. O acesso a internet está limitado/bloqueado.");
                    return;
                }
                vm.pagSeguroPaymentMethod = {
                    type: "pagseguro",
                    length: vm.paymentMethod.length,
                    personName: vm.paymentMethod.personName,
                    cardNumber: vm.pagseguroCardToken + ";" + vm.senderHash + ";" + vm.pagseguroBrand.name,
                    code: vm.paymentMethod.code,
                    goodThru: vm.paymentMethod.goodThru,
                    personCpf: vm.paymentMethod.personCpf
                };
                vm.isInvalidCard();
            } else if (vm.paymentMethod.type === "mercadopagotransparente") {
                $log.debug(vm.paymentMethod);
            } else { // Pagamento com cartao
                if (vm.paymentMethod.cardNumber === null || vm.paymentMethod.cardNumber === "")
                    vm.paymentMethod.cardNumber = vm.paymentMethod.cardNumber2;
                vm.isInvalidCard();
            }
            vm.paymentMethod.value = vm.totalGeral();
            //var buyValue =  vm.paymentMethod.value;
            //var oldBuyValue = vm.totalGeralSemDesconto();
            var produtosAsString = MyFunctions.productosToString(vm.xsProducts());
            var couponAsString = null;

            cupom = vm.xsCupom();
            if (angular.isDefined(cupom) && cupom !== null) {
                var split = cupom.split("-");
                cupomCod = split[0];
                if (split.length > 1) {
                    cupomKey = split[1];
                }
            }
            if (cupomCod) {
                couponAsString = cupomCod + "|" + (cupomKey === undefined || cupomKey == null ? "" : cupomKey); // "|" + cupomKey;
            }
            var paymentMethod = vm.paymentMethod;
            if (vm.paymentMethod.type === "pagsegurotransparente") {
                paymentMethod = vm.pagSeguroPaymentMethod;
                var installmentsObj = paymentMethod.length;
                paymentMethod.length = null;
                paymentMethod.length = installmentsObj.quantity;
                paymentMethod.value = vm.paymentMethod.value; //(installmentsObj.totalAmount * 100);
            }
            if (vm.paymentMethod.type === "mercadopagotransparente") {
                paymentMethod = angular.copy(paymentMethod);
                paymentMethod.type = paymentMethod.customData.brand;
            }
            if (vm.paymentMethod.type === "gerencianetVisa" || vm.paymentMethod.type === "gerencianetMaster") {
                paymentMethod = {
                    type: gerencianetBrand,
                    length: vm.paymentMethod.length.installment,
                    personName: vm.paymentMethod.personName,
                    cardNumber: gerencianetToken,
                    code: vm.paymentMethod.code,
                    goodThru: vm.paymentMethod.goodThru,
                    personCpf: vm.paymentMethod.personCpf,
                    value: vm.totalGeral()
                };
            }
            var oldBill = localStorageService.cookieGet("bill_remark");
            if (angular.isDefined(oldBill) && oldBill !== null && angular.isDefined(oldBill.id) && oldBill.id > 0) {
                paymentMethod.oldBill = {
                    first: oldBill.id + "",
                    second: oldBill.token,
                    third: oldBill.value
                };
                if (paymentMethod.value <= 0) methodName = "remarkBill";
            }
            //Passa FingerPrint para o servidor
            var fingerPrintID = localStorageService.cookieGet("fingerPrintID");
            if (angular.isDefined(fingerPrintID) && fingerPrintID !== "" && fingerPrintID !== null) {
                paymentMethod.fingerPrint = fingerPrintID + "";
            }

            if(vm.paymentTypeCard_r) {
              paymentMethod.type = vm.paymentMethod.type.slice(0, -2);
              paymentMethod.recurring = true;
            }
            paymentMethod.clientDeviceData = device;


            var params = {
              method: methodName,
              productsArray: produtosAsString,
              personAsString: {
                id: user.id,
                forSave: false,
              },
              paymentMethodAsString: paymentMethod,
              dateAsString: MyFunctions.dateToString(vm.date),
              couponAsString: couponAsString,
              webGateway: webGateway
            };
            if (angular.isUndefined(user.id)) {
                params.personAsString = user;
                params.personAsString.forSave = true;
            }
            if (angular.isDefined(params.paymentMethodAsString.cardNumber))
                params.paymentMethodAsString.cardNumber = params.paymentMethodAsString.cardNumber.replace(/ /g, '');
            if (vm.paymentMethod.type !== "pagsegurotransparente") {
                vm.paymentMethod = {
                    type: vm.paymentMethod.type
                };
            }
            if (localStorageService.cookieGet("bookingAgency") !== null && localStorageService.cookieGet("bookingAgency") !== "")
                params.toAgencyPath = localStorageService.cookieGet("bookingAgency");
            // Influencer
            var influencer = Auth.getSalesInfluencer();
            if (influencer !== null){
                params.salesInfluencer = influencer.influencer;
                params.salesInfluencerToken = influencer.influencertoken;
            }

            //REcaptcha
            if (angular.isDefined($window.getRecaptcharToken)) params._recaptchar = $window.getRecaptcharToken();

            if(methodName === 'buy' && vm.has3DS()){
                if(Properties.show3dsCardAddress){
                    var u = {};
                    angular.copy(vm.userCard, u);
                    u.street0 += " " + u.address;
                    params.paymentMethodAsString._user = u;
                }
                PaymentService.payUsing3ds(_paid, params);
            } else if (methodName === "buy" && Properties.token) {
                var paid = paymentMethod;
                if(angular.isUndefined(paid.cardType) || paid.cardType == null || paid.cardType == "") paid.cardType = paid.type;
                PaymentService.createToken(paid,
                    function(_result) {
                        paid.cardNumber = _result.token;
                        paid.goodThru = _result.card.due_date;
                        paid.code = _result.card.cvv;
                        paid.token2 = _result.token2;
                        paid.customData =  paid.customData || {};
                        paid.customData.card_number = _result.card.card_number;
                        _paid(params);
                    }
                );
            } else {
                _paid(params);
            }

            function _paid(params) {
                vm.isProcessing = true;
                var dialog = Dialogs.wait();
                BackEnd.execute(params,
                    function(data) {
                        vm.isProcessing = false;
                        dialog.close();
                        data.products = vm.xsProducts();
                        data.value = paymentMethod.value;
                        data.cupom = couponAsString;
                        if (angular.isUndefined(data) || data === null || angular.isUndefined(data.id) || data.id === null) {
                            ErrorHandler.showError("Aguardando Confirmação do pagamento. Você receberá um e-mail após a conclusão.");
                            $state.go("compras");
                            return;
                        }
                        if(params.webGateway != "Pix" ||
                            angular.isUndefined(Properties.trackingLazyBuy) ||
                            Properties.trackingLazyBuy == null ||
                            !Properties.trackingLazyBuy)
                              Tracking.buy(data);
                        if (angular.isDefined(params.paymentMethodAsString.oldBill) && params.paymentMethodAsString.oldBill !== null) {
                            data.token = data.token || params.paymentMethodAsString.oldBill.second;
                        }
                        vm.xsComplete(data);
                    },
                    function(error, status) {
                        $log.debug(status);
                        vm.isProcessing = false;
                        dialog.close();
                        if(status == 403 && angular.isDefined(error.aviso)){
                            if(error && error.aviso != ""){
                                Dialogs.info(error.aviso, "", {}, function(){
                                    openCodeDialog(params);
                                });
                            } else
                                openCodeDialog(params);
                            return;
                        }
                        Tracking.buyError(error);
                        if (angular.isUndefined(error) || error === null) {
                            ErrorHandler.showError("Aguardando Confirmação do pagamento. Você receberá um e-mail após a conclusão.");
                            $state.go("compras");
                            return;
                        }
                         if(error && error.erro && error.erro.includes('RJ - NAO AUTORIZADO')) ErrorHandler.showError("Transação não efetivada - Sua transação não foi aprovada. Para sua segurança indicamos que utilize outro cartão ou metodo de pagamento.");
                         else ErrorHandler.showError(error);
                    }
                );
            }
            function openCodeDialog(params){
                var atm = Properties.authCodeMessage || "Para confirmar a compra informe o codigo enviado para seu whatsapp";
                Dialogs.answer(atm, function(data){
                    if(data != null && angular.isDefined(data)){
                        params.paymentMethodAsString.authCod = data;
                        _paid(params);
                    }
                }, { title: "Informe o código", size:"sm" });
            }
        };

        Tracking.addListener(Tracking.types.OnChangeCart, function(){
            if(!vm.paymentMethods) return;
            var oldPayment = vm.paymentMethod;
            vm.paymentMethods2(function(){
                if(vm.paymentMethods[oldPayment.type] > 0){
                    if(oldPayment.length && vm.paymentMethods[oldPayment.type] < oldPayment.length) oldPayment.length = null;
                    vm.paymentMethod = oldPayment;
                    vm.brands.forEach(function(b, index) {
                        if(b.name == oldPayment.type) {
                            vm.selectType(b.name, index);
                            updateFinancialLength();
                        }
                    });
                } else
                    oldPayment.length = null;
            });

        });
    }

})();

/**
 * Created by Danillo on 31/08/2016.
 *
 * <xs-marcacao xs-complete="vm.loginEfetuado()"></xs-marcacao>
 * <div xs-marcacao xs-complete="vm.loginEfetuado()"></div>
 *
 * Atributos:
 * - xs-complete: função que será chamada quando o pagamento for efetuado com sucesso (Importante);
 * - template-url: url do template alternativo a ser utilizado (Opcional);
 *
 * Exemplo:
 * <xs-marcacao xs-complete="vm.pagamentoEfetuado()" template-url="app/myForm.html"></xs-marcacao>
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .directive('xsMarcacao', xsMarcacao);

    function xsMarcacao() {

        return {
            restrict: 'EA',
            scope: {
                xsComplete: '&'
            },
            templateUrl: function (elem, attr) {
                if (angular.isDefined(attr.templateUrl))
                    return attr.templateUrl;
                return 'app/components/xsMarcacao/xsMarcacao.html';
            },
            controller: xsMarcacaoController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /** @ngInject */
    function xsMarcacaoController() {
        var vm = this;
        vm.xsComplete = vm.xsComplete || function () {
        };

        vm.mesasA = [
            {
                "amount": "0",
                "id": "01",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Laranja",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-A.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 6 Lugares"
            },
            {
                "amount": "0",
                "id": "02",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Laranja",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-A.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 4 Lugares"
            },
            {
                "amount": "0",
                "id": "03",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Laranja",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-A.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 6 Lugares"
            },
            {
                "amount": "0",
                "id": "04",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Laranja",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-A.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 4 Lugares"
            },
            {
                "amount": "0",
                "id": "05",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Laranja",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-A.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 6 Lugares"
            },
            {
                "amount": "0",
                "id": "06",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Laranja",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-A.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 4 Lugares"
            }
        ];
        vm.mesasB = [
            {
                "amount": "0",
                "id": "26",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Roxa",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-B.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "27",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Roxa",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-B.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 6 Lugares"
            },
            {
                "amount": "0",
                "id": "28",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Roxa",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-B.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "29",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Roxa",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-B.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 6 Lugares"
            },
            {
                "amount": "0",
                "id": "30",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Roxa",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-B.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 6 Lugares"
            },
            {
                "amount": "0",
                "id": "31",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Roxa",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-B.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 4 Lugares"
            }
        ];
        vm.mesasC = [
            {
                "amount": "0",
                "id": "54",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Amarela",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-C.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "55",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Amalera",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-C.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 4 Lugares"
            },
            {
                "amount": "0",
                "id": "56",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Amalera",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-C.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 6 Lugares"
            },
            {
                "amount": "0",
                "id": "57",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Amalera",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-C.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 4 Lugares"
            },
            {
                "amount": "0",
                "id": "58",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Amalera",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-C.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 4 Lugares"
            },
            {
                "amount": "0",
                "id": "090",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Amalera",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-C.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            }
        ];
        vm.mesasD = [
            {
                "amount": "0",
                "id": "085",
                "htmlMemo": "",
                "memo": "",
                "name": "Tipo D",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-D.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "086",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Amalera",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-D.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "087",
                "htmlMemo": "",
                "memo": "",
                "name": "Tipo D",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-D.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "088",
                "htmlMemo": "",
                "memo": "",
                "name": "Tipo D",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-D.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "089",
                "htmlMemo": "",
                "memo": "",
                "name": "Tipo D",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-D.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "090",
                "htmlMemo": "",
                "memo": "",
                "name": "Tipo D",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-D.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            }
        ];
        vm.mesasE = [
            {
                "amount": "0",
                "id": "085",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Verde",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-E.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "086",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Verde",
                "value": "false",
                "sold": true,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-E.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "087",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Verde",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-E.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "088",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Verde",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-E.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "089",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Verde",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-E.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            },
            {
                "amount": "0",
                "id": "090",
                "htmlMemo": "",
                "memo": "",
                "name": "Área Verde",
                "value": "false",
                "sold": false,
                "path": "",
                "image": "arcaparque/img/icons/icon-ingresso-E.png",
                "years": "",
                "type": "Mesa",
                "table": "Ingressos",
                "shortName": "Mesa 8 Lugares"
            }
        ];


    }

})();

/**
 * Created by Danillo on 31/08/2016.
 *
 * <xs-register xs-complete="vm.loginEfetuado()"></xs-register>
 * <div xs-register xs-complete="vm.loginEfetuado()"></div>
 *
 * Atributos:
 * - xs-complete: função que será chamada quando o registro for efetuado com sucesso (Importante);
 * - template-url: url do template alternativo a ser utilizado (Opcional);
 * - xs-registre-person: função que será chamada para salvar a pessoa (Opcional);
 * - xs-has-registre-person: true quando a função for passada;
 * Exemplo:
 * <xs-register xs-complete="vm.registroEfetuado()" template-url="app/myRegisterForm.html"></xs-register>
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .directive('xsRegister', xsRegister);

    function xsRegister() {

        return {
            restrict: 'EA',
            scope: {
                xsChange: '=',
                xsComplete: '&',
                xsRegistrePerson: '&',
                xsHasRegistrePerson: '='
            },
            templateUrl: function (elem, attr) {
                if (angular.isDefined(attr.templateUrl))
                    return attr.templateUrl;
                return 'app/components/xsRegister/xsRegister.html';
            },
            link: function(scope, element, attrs, controller) {
                /*This method will be called whet the 'objectToInject' value is changes*/
                scope.$watch('vm.xsChange', function(value) {
                    /*Checking if the given value is not undefined*/
                    if (value) {
                        controller.loginIsOn(value);
                    }
                });
            },
            controller: xsRegisterController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /** @ngInject */
    function xsRegisterController(Properties, $http, BackEnd, ErrorHandler, Auth, GoogleAuth, FacebookAuth,Dialogs, Tracking,MyFunctions) {

        /* jshint validthis:true */
        var vm = this;

        vm.brandUrl = "https://upload.wikimedia.org/wikipedia/commons/thumb";
        vm.paisesBrand = null;
        vm.paisesBrand = [];
        vm.paisesBrandNoTopo = [];
        function loadPaisesBrand () {
            if(vm.paisesBrand.length > 0) return;
            var loadImage = function (obj, index) {
                if(!vm.paisesBrand) return
                var img = new Image();
                img.onerror = function () {
                    vm.paisesBrand[index].needLabel = true;
                };
                img.src = vm.brandUrl + obj.img;
            }
            $http.get("assets/paises.json").then(function (response) {
                var paisesNoTopo = [
                    'Brasil', 'Argentina', 'Uruguai',
                    'Paraguai', 'Chile', 'Estados Unidos'
                ];
                vm.paisesBrand = Object.values(response.data);
                vm.paisesBrand.forEach(function (el, i)  {
                    if(el.ddi == 55) vm.DDIbrandSelected = el;
                    loadImage(el, i);
                });
                paisesNoTopo.forEach(function (pais) {
                    var paisBrand = vm.paisesBrand.find(function (p) {
                        return p.pais === pais;
                    });
                    if (paisBrand) {
                        vm.paisesBrandNoTopo.push(paisBrand);
                    }
                });
            });
        }
        vm.init = Properties.needDropdownBrands ? function(){ loadPaisesBrand(); } : function() {};

        vm.xsComplete = vm.xsComplete || function () {};
        vm.resetUser = function(){
            vm.user = {customData: {estrangeiro: 'false'}};
        };
        vm.terms = false;
        vm.resetUser();
        vm.isSearched = false;
        vm.isOldUser = false;
        if (Auth.isLoggedIn()) {
            vm.user = Auth.getUser();
            vm.user.customData = vm.user.customData || {};
            vm.user.customData.estrangeiro = vm.user.customData.estrangeiro || 'false';
        }
        Auth.addListener(function () {
            vm.resetUser();
        });


        vm.selectCountry = function (pais) {
          vm.DDIbrandSelected = pais;
          vm.openDropdownBrands = false;
        };

        vm.getWhatsappMask = function () {
            var defaultValue = '(99) 9?9999-9999';
            if (!vm.DDIbrandSelected) return defaultValue;

            switch (vm.DDIbrandSelected.ddi) {
                case 55: return '(99) 9?9999-9999';
                case 54: return String(vm.user.cellPhone).match(/^911/) ? '9 99 9999-9999' : '9 9999 99-9999';

                default: return defaultValue;
            }
        }

        vm.disableInputIfUserExists = function(inputId){
          if(!Properties.disabledEditAccountInputs){
            return false;
          }
          return Auth.isLoggedIn() && Properties.disabledEditAccountInputs.includes(inputId);
        };
        vm.verifyDate = function(){
            if(angular.isUndefined(vm.user.birth)) return;
            if(vm.user.birth === "") return;
            if(vm.user.birth.length < 8) return;
            var dateParts = [
                vm.user.birth.substring(0,2),
                vm.user.birth.substring(2,4),
                vm.user.birth.substring(4)
                ];
            if (dateParts[0].length == 2 && (dateParts[0] < 1 || dateParts[0] > 31)) {
                ErrorHandler.showError("Data de nascimento " +  dateParts[0] + "/" + dateParts[1] + "/" + dateParts[2] + " Incorreta");
                vm.user.birth = null;
                return;
            }
            if (dateParts[1].length == 2 && (dateParts[1] < 1 || dateParts[1] > 12)) {
                ErrorHandler.showError("Data de nascimento " +  dateParts[0] + "/" + dateParts[1] + "/" + dateParts[2] +  " Incorreta");
                vm.user.birth = null;
                return;
            }
        };
        var hasVerifyNumber = false;
        function verifyNumber() {
          hasVerifyNumber = true;
        }
        vm.noPassword = Properties.noPassword;

        vm.handleSavePerson = function () {
          hasVerifyNumber = false;
          if (vm.xsHasRegistrePerson || vm.xsHasRegistrePerson == "true") {
            if (vm.DDIbrandSelected && vm.DDIbrandSelected.ddi)
              vm.user.countryPhoneCode = vm.DDIbrandSelected.ddi + "";

            var user1 = angular.copy(vm.user);

            if (user1.countryPhoneCode && user1.countryPhoneCode.indexOf("+") < 0)
              user1.countryPhoneCode = "+" + user1.countryPhoneCode;
            if (vm.isOldUser) {
              if (MyFunctions.checkAge(user1.birth)) {
                Auth.setPerson(user1);
                Tracking.login(user1);
                Auth.alterPerson(user1, vm.xsComplete);
                return;
              } else {
                ErrorHandler.showError("Compra permitida apenas para maiores de 18 anos.");
                return;
              }
            }
            if (MyFunctions.checkAge(user1.birth)) {
              Auth.findOrCreatePerson(user1, vm.xsComplete);
            } else {
              ErrorHandler.showError("Compra permitida apenas para maiores de 18 anos.");
              return;
            }
          } else {
            if (vm.DDIbrandSelected && vm.DDIbrandSelected.ddi)
              vm.user.countryPhoneCode = vm.DDIbrandSelected.ddi + "";
            var user = angular.copy(vm.user);
            if (user === null) {
              ErrorHandler.showError("Cadastre uma pessoa.");
              return;
            }
            if (!Properties.noPassword) {
              if (
                user.password !== vm.password ||
                vm.password === null ||
                angular.isUndefined(vm.password)
              ) {
                ErrorHandler.showError("Senhas não conferem.");
                return;
              }
            }
            Auth.savePerson(user, vm.xsComplete);
          }
        };


        vm.savePerson = function () {
          if (Properties.verifyNumberAndEmail && !hasVerifyNumber) {
            Dialogs.whatsConfirm(vm.handleSavePerson, verifyNumber, vm.user);
          } else {
            vm.handleSavePerson();
          }
        };

        if (vm.xsHasRegistrePerson || vm.xsHasRegistrePerson == "true") {
            vm.savePerson = function () {
              if (Properties.verifyNumberAndEmail && !hasVerifyNumber) {
                Dialogs.whatsConfirm(
                  vm.handleSavePerson,
                  verifyNumber,
                  vm.user
                );
              } else {
              vm.handleSavePerson();
            }
          }
        }




        vm.findCep = function () {
            BackEnd.findcep(vm.user.zipCode, function (address) {
                if (address !== null) {
                    vm.user.street0 = address.street0;
                    vm.user.street1 = address.street1;
                    vm.user.city = address.city;
                    vm.user.state = address.state;
                }
            });
        };

        vm.countNumberCEP = function (validacaoForm) {
            if (vm.user.zipCode.length < 8) return;
            if (!validacaoForm) {
                _findZipcode(function(){});
            } else {
                var dialog = Dialogs.wait();
                _findZipcode(function(result){
                    dialog.close();
                    if(angular.isDefined(result)){
                        // ErrorHandler.showError(result);
                        Dialogs.confirm("Deseja preencher o endereço? <br> Sim para confirmar. Não para tentar novamente",
                        function(){
                           Dialogs.getAddress("Endereço", function(userAddress){
                            setAddress(userAddress);
                            vm.invalidZipCode = false;
                           })
                        }, {
                            size: 'md',
                            title: "CEP Inválido!",
                            templateUrl: 'app/components/xsRegister/modals/cep_confirm.html',
                        }, function(){
                            //console.log("Dismiss");
                        });
                    }
                });
            }
        };

        vm.invalidZipCode = true;

        function setAddress(address){
            vm.user.street0 = address.street0;
            vm.user.street1 = address.street1;
            vm.user.city = address.city;
            vm.user.state = address.state;
        }
        function _findZipcode (_onResult) {
            vm.invalidZipCode = true;
            if(vm.user.zipCode == "00000-000" || vm.user.zipCode == "00000000") {
                _onResult("CEP Inválido! Por favor verifique o CEP e tente novamente.");
                return;
            }
            BackEnd.findcep(vm.user.zipCode, function (address) {
                if (address === null || angular.isUndefined(address) || angular.isUndefined(address.city) || angular.isUndefined(address.state)){
                   _onResult("CEP Inválido! Por favor verifique o CEP e tente novamente.");
                   return;
                }
                setAddress(address);
                vm.invalidZipCode = false;
                _onResult();
            }, function (erro) {
                _onResult();
                ErrorHandler.showError(erro);
            });
        }

        var poslogin  = function(user, id_token){
            vm.disabled = {};
            user.customData = user.customData || {};
            user.customData.estrangeiro = user.customData.estrangeiro || 'false';
            vm.user = user;
            vm.user.google_token = id_token;
            vm.isOldUser = vm.user.id && vm.user.id !== 0 ? true: false;
            var userDataRequired = ['cellPhone','cpf','birth','zipCode'];
            if(vm.isOldUser) {
                for(var i = 0; i < userDataRequired.length; i++){
                    vm.disabled[userDataRequired[i]] = vm.user[userDataRequired[i]] ? true : false;
                }
            }
            vm.isSearched = true;
        };

        vm.loginIsOn = function(value){
            GoogleAuth.canGoogleSignIn(value, poslogin);
            FacebookAuth.canFacebookSignIn(value, poslogin);
        };

        vm.disabled = {};
        vm.findbyEmail = function(){
            if(!Auth.isValidEmail(vm.user.email)){
                ErrorHandler.showError("Email " + vm.user.email + " está invalido");
                return;
            }
            Auth.setUser(null);
            Auth.setPerson(null);
            var dialog = Dialogs.wait();
            BackEnd.execute(
                {
                    "method": "personByMail",
                    "email": vm.user.email,
                },
                function(data){
                    poslogin(data);
                    dialog.close();
                },
                function (error) {
                    dialog.close();
                    ErrorHandler.showError(error);
                }
            );
        };

    }

})();

/**
 * Created by Danillo on 17/08/2016.
 *
 * <xs-person person="vm.person"></xs-person>
 * <div xs-person person="vm.person"></div>
 *
 * Atributos:
 * - person: objeto pessoa (Obrigatorio);
 * - xs-person-save: função que será chamada no on_clik do botão cadastrar (Importante);
 * - template-url: url do template alternativo a ser utilizado (Opcional);
 *
 * Exemplo:
 * <xs-person person="vm.person" xs-person-save="vm.savePerson(vm.person)" template-url="app/components/person/person2.html"></xs-person>
 */

(function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .directive('xsPerson', xsPerson);

    /** @ngInject */
    function xsPerson() {

        return {
            restrict: 'EA',
            scope:{
                person:'=',
                xsPersonSave:'&'
            },
            templateUrl: function(elem, attr) {
                if(angular.isDefined(attr.templateUrl))
                    return attr.templateUrl;
                return 'app/components/xsPerson/xsPerson.html';
            },
            link: function ($scope, Properties) {
                $scope.properties = Properties;
                $scope.savePerson =  function(){
                    $scope.xsPersonCadastrar();
                };                
            }
        };
    }
})();

/**
 * Created by Danillo on 31/08/2016.
 *
 * <xs-confirm xs-ordered="objOrder" xs-newbuy="newBuy()"></xs-confirm>
 * <div xs-confirm xs-ordered="objOrder" xs-newbuy="newBuy()"></div>
 *
 * Atributos:
 * - xs-ordered: valor do pedido gerado;
 * - xs-newbuy: função executada pelo botão nova compra (Opcional);
 * - template-url: url do template alternativo a ser utilizado (Opcional);
 *
 * Exemplo:
 * <xs-confirm xs-ordered="objOrder" xs-newbuy="newBuy()" template-url="app/myOrderForm.html"></xs-confirm>
 */

/**
 * @typedef {import("../../../types/properties").PropertiesType} PropertiesType
 */

(function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .directive('xsConfirm', xsConfirm);

    function xsConfirm() {

        return {
            restrict: 'EA',
            scope:{
                xsOrdered:'=',
                xsNewbuy:'&'
            },
            link: function (scope, element, attrs, controller) {
                /*This method will be called whet the 'objectToInject' value is changes*/
                scope.$watch('vm.xsOrdered', function (value) {
                    /*Checking if the given value is not undefined*/
                    if(value>0){
                        controller.searchOrdered();
                    }
                });
            },
            templateUrl: function(elem, attr) {
                if(angular.isDefined(attr.templateUrl)) return attr.templateUrl;
                 return 'app/components/xsConfirm/xsConfirm.html';
            },
            controller: xsConfirmController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /**
     * @param {PropertiesType} Properties
     * @ngInject
    */
    function xsConfirmController(Cart, $state, Dialogs, Properties, BackEnd, Auth, ErrorHandler, ScrollTo, Tracking, localStorageService){
         /* jslint validthis:true */
        var vm = this;
        vm.host = $state.href(Properties.defaultState, {}, {absolute: true});
        vm.pdfAddress = Properties.pdfAddress || Properties.serverUrl || Properties.serverBase;
        vm.qrcode = Properties.qrcode || Properties.serverUrl || Properties.serverBase;
        vm.voucherLink = "";
        vm.reservations = [];
        vm.reservation = {};
        var p = null;
        if(Auth.isLoggedIn())
            p = Auth.getUser();
        else if(Auth.getPerson() !== null && angular.isDefined(Auth.getPerson()))
            p = Auth.getPerson();
        if(p && p.customData) vm.host = $state.href(Properties.defaultState, {}, {absolute: true}) + "?influencer=" + p.id + "&influencertoken=" + p.customData.influencertoken;

        vm.linkCopySuccess = function(){
            Dialogs.info('Utilize a opção "Pix copia e cola" do seu banco', "Copiado com sucesso");
        };
        vm.verifyPayment = function(){
            var params = { "method": "verifyPayment", "path": vm.reservation.path };
            var dialog = Dialogs.wait();
            BackEnd.execute(params, function(data) {
                dialog.close();
                if(angular.isUndefined(data) || data == null || data.status != "aguardando") {
                    // dispara o tracking de compra aprovada do pix se estiver pago
                    if(Properties.trackingLazyBuy) Tracking.buy(vm.reservation);
                    vm.reservation = null;
                    vm.searchOrdered();
                } else
                    Dialogs.info(data.mensagem || "Aguardando a confirmacao");
            },
            function(error) {
                dialog.close();
                ErrorHandler.showError(error);
            });
        };
        function _prepare(){
            if (vm.reservation.paymentType && vm.reservation.paymentType != "Pix" && vm.reservation.paymentType.indexOf("Pix") == 0)
                vm.reservation.paymentType = "Pix";
            if (angular.isDefined(Properties.listaAcesso) && Properties.listaAcesso === true){
                vm.voucherLink = Properties.homeAddress + '/lista?billPath=bills/' + vm.reservation.id + '&token=' + vm.reservation.voucherToken + '&method=receiptAsByte&receipt=' + vm.reservation.voucher + "&loc=" + vm.reservation.locator;
                //https://www.snowland.com.br/ingressos/lista?billPath=bills%2F382399&token=AYpZGKdkH3hp2&method=receiptAsByte&receipt=261576
                //https://www.snowland.com.br/ingressos/lista?billPath=bills%2F274695&token=93C49098C98FC9982A98EECB70838B18A2CC9119%20&method=receiptAsByte&receipt=391974
                //{{vm.pdfAddress}}?method=receiptAsByte&receipt={{vm.reservation.voucher}}&id={{vm.reservation.id}}&token={{vm.reservation.voucherToken}}
            } else {
                vm.voucherLink = vm.pdfAddress + "?method=receiptAsByte&receipt=" + vm.reservation.voucher + "&id=" + vm.reservation.id + "&token=" + vm.reservation.voucherToken + "&loc=" + vm.reservation.locator;
            }
            // if(angular.isDefined(vm.reservation.paymentUrl) && vm.reservation.paymentUrl.indexOf("http") == 0 && !vm.reservation.qrcode){
            //     Dialogs.iframe(vm.reservation.paymentUrl);
            // }
            ScrollTo.scrollTo("main-content");
            stateGoListaEntrada();
        }
        function _billById(id, localizador){
            var params = { "method": "billById", "billPath": "bills/" + id, "token": localizador };
            BackEnd.execute(params, function(data) {
                vm.reservation = data;
                _prepare();
            });
        }
        vm.searchOrdered = function() {
            if(vm.reservation && vm.reservation.id == vm.xsOrdered){
                return;
            }
            var p = null;
            if(Auth.isLoggedIn())
                p = Auth.getUser();
            else if(Auth.getPerson() !== null && angular.isDefined(Auth.getPerson()))
                p = Auth.getPerson();

            if(p && p.customData)
                vm.influencerUrl = $state.href(Properties.defaultState, {}, {absolute: true}) + "?influencer=" + p.id + "&influencertoken=" + p.customData.influencertoken;
            var lastBill = Cart.getLastBill();
            if(lastBill && lastBill.id == parseInt(vm.xsOrdered, 10)){
                _billById(lastBill.id, lastBill.localizador || lastBill.token);
                return;
            }
            if(p === null || angular.isUndefined(p)) $state.go("compras");
            if(p.customData === null || angular.isUndefined(p.customData)) {
                $state.go("compras");
                return;
            }
            var params = { "method": "userReservations", "userId": p.id, "token": p.customData.token };
            BackEnd.execute(params, function(data) {
                vm.reservations = data;
                if(angular.isDefined(vm.xsOrdered) && vm.xsOrdered !== null) {
                    vm.reservation = vm.reservations.filter(function (r) {
                        return r.id == parseInt(vm.xsOrdered, 10);
                    })[0];
                } else {
                    vm.reservation = vm.reservations[0];
                }
               _prepare();
            });
        };
        vm.stateGoHome = function () {
            $state.go(localStorageService.get('_lojaAgency') || 'ingressos');
        };
        function stateGoListaEntrada () {
            if (!Properties.forcarListaEntradaSePago) return;
            if (!vm.voucherLink.includes('lista')) return;
            if(vm.reservation.qrcode && !vm.reservation.voucher && vm.reservation.paymentType == 'Pix') {
                return;
            }
            if (vm.voucherLink.includes('undefined')) return;
            window.history.pushState({}, '', window.location.href.replace(/\/confirmacao.+$/i, '/') + vm.voucherLink);
        }
    }
})();

// Teste confirmação PAGO -> http://localhost:3000/confirmacao/1740040/SFRYTZK3
// Teste confirmação PIX -> http://localhost:3000/confirmacao/1741494/1B47515C65E2A81191C1A1E94F3EE591BA133791
// Teste LISTA -> http://localhost:3000/lista?billPath=bills%2F1740040&token=24C691E7F2EC3737894103985517A695AA5CBC04&method=receiptAsByte

/**
 * Created by Danillo on 31/08/2016.
 *
 * <xs-login xs-complete="vm.loginEfetuado()"></xs-login>
 * <div xs-login xs-complete="vm.loginEfetuado()"></div>
 *
 * Atributos:
 * - xs-complete: função que será chamada quando o login for efetuado com sucesso (Importante);
 * - template-url: url do template alternativo a ser utilizado (Opcional);
 *
 * Exemplo:
 * <xs-login xs-complete="vm.loginEfetuado()" template-url="app/myLoginForm.html"></xs-login>
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .directive('xsLogin', xsLogin);

    function xsLogin() {

        return {
            restrict: 'EA',
            scope: {
                xsComplete: '&'
            },
            templateUrl: function (elem, attr) {
                if (angular.isDefined(attr.templateUrl))
                    return attr.templateUrl;
                return 'app/components/xsLogin/xsLogin.html';
            },
            controller: xsLoginController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /** @ngInject */
    function xsLoginController(BackEnd, Properties, Auth, Tracking, ScrollTo, Dialogs, ErrorHandler, $state, $location) {
        /* jslint validthis:true */
        var vm = this;
        vm.xsComplete = vm.xsComplete || function () {};
        vm.mostraCadastro = false;

        vm.email = "";
        vm.maskPattern = "";


        vm.user = null;
        if (Auth.isLoggedIn()) {
            vm.user = Auth.getUser();
        }

        vm.logout = function () {
            Auth.logout();
            vm.user = null;
        };

        vm.next = function () {
            Tracking.login(vm.user);
            vm.xsComplete();
        };

        vm.showCadastro = function () {
            Auth.logout();
            vm.user = null;
            vm.mostraCadastro = true;
            ScrollTo.scrollTo("cadastro");
        };

        vm.isCpf = function (input) {
          if (input === undefined) return;
          return /^\d{11}$/.test(input.replace(/\D/g, ""));
        };

        vm.updateMask = function () {
          if (vm.isCpf(vm.email)) {
            vm.maskPattern = "999.999.999-99";
          } else {
            vm.maskPattern = "";
          }
        };

        function login(id, email, password) {
          var params = {
            method: "login",
            password: password,
          };
          if (password === null || password === undefined || password === "") {
            Dialogs.info("Informe seu código de acesso");
            return;
          }

          if(id !== null && angular.isDefined(id) && id !== "")
            params.personId = id;
          if(email !== null && angular.isDefined(email) && email !== "") {
            email = email.trim().toLowerCase();
            if(vm.isCpf(email)) {
              email = email.replace(/\D/g, "");
            }
            params.email = email;
          }
          if(params.personId === undefined && params.email === undefined) {
            Dialogs.info("Informe seu e-mail ou cpf.");
            return;
          }
          var dialog = Dialogs.wait();
          BackEnd.execute(params,
            function (data) {
                dialog.close();
                Auth.setUser(data);
                Tracking.login(data);
                vm.xsComplete();
            },
            function (error) {
                dialog.close();
                ErrorHandler.showError(error);
            });
        }

        vm.login = function () {
            login(null, vm.email, vm.password);
        };

        vm.forgetPass = function () {
            if (vm.email === null || vm.email === "") {
                Dialogs.info("Informe seu e-mail ou cpf.");
                return;
            }
            var dialog = Dialogs.wait();
            vm.email = (vm.email || "").trim().toLowerCase();
            if(vm.isCpf(vm.email)) {
              vm.email = vm.email.replace(/\D/g, "");
            }
            BackEnd.execute({"method": "forgetPass", "email": vm.email}, function () {
                dialog.close();
                Dialogs.info("Novo código de acesso enviado para seu e-mail.");
              },
              function (err) {
                  dialog.close();
                  ErrorHandler.showError(err);
              });
        };

        vm.cadastrar = function () {
            vm.xsComplete();
        };
        vm.sendMailToLogin = function(){
            var dialog = Dialogs.wait();
            BackEnd.execute({ "method": "verifyExistsEmail", "email": vm.email, "lojaUrl" : $state.href('login', {}, {absolute: true}) }, function () {
                dialog.close();
                var message = Properties.sendMailCodeMessage || "Link para acesso está no seu e-mail.";
                Dialogs.info(message);
                vm.showCode = true;
            },
            function (err) {
                dialog.close();
                ErrorHandler.showError(err);
            });
        };

        var query = $location.search();
        if(angular.isDefined(query.personId) && query.personId !== null && angular.isDefined(query.token) && query.token !== null) {
            login(query.personId, null, query.token);
        }





    }

})();

/**
 * Created by Danillo on 31/08/2016.
 *
 * <xs-breadcrump xs-step="4"></xs-breadcrump>
 * <div xs-breadcrump xs-step="4"></div>
 *
 * Atributos:
 * - xs-step: na alteração da diretiva o componente atualiza;
 *
 * Exemplo:
 * <xs-breadcrump xs-step="4"></xs-breadcrump>
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .directive('xsBreadcrump', xsBreadcrump);

    function xsBreadcrump() {
        return {
            restrict: 'EA',
            scope: {
                xsStep: '='
            },
            templateUrl: function (elem, attr) {
                if (angular.isDefined(attr.templateUrl))
                    return attr.templateUrl;
                return 'app/components/xsBreadcrumb/xsBreadcrumb.html';
            },
            controller: xsBreadcrumpController,
            controllerAs: 'vm',
            bindToController: true
        };
    }


    /** @ngInject */
    function xsBreadcrumpController($window, Search, Properties) {
        /* jslint validthis:true */
        var vm = this;

        var containerWidth = parseInt($window.innerWidth);
        vm.sizeWidthMobileBreadcrumb = containerWidth <= 968 ? containerWidth - 25 + 'px' : '100%';
        
        vm.verificaSinglehotel = Properties.singlehotel;
        
        vm.xsStep = vm.xsStep || 0;
        vm.reservationSteps = Search.getSteps();       
    }

})();

/**
 * Created by Danillo on 31/08/2016.
 *
 * <xs-barra-footer xs-complete="vm.pagamentoEfetuado" xs-products="vm.products"></xs-barra-footer>
 * <div xs-barra-footer xs-complete="vm.pagamentoEfetuado" xs-products="vm.products"></div>
 *
 * Atributos:
 * - xs-change: na alteração da diretiva o componente atualiza;
 * - xs-products: função que retorna os produtos (obrigatorio);
 * - xs-complete: função que será chamada quando o pagamento for efetuado com sucesso.
 *      Passa como parametro o retorno da venda (Importante);
 * - template-url: url do template alternativo a ser utilizado (Opcional);
 *
 * Exemplo:
 * <xs-barra-footer xs-products="vm.products" xs-complete="vm.pagamentoEfetuado" template-url="app/myForm.html"></xs-barra-footer>
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .directive('xsBarraFooter', xsBarraFooter);

    function xsBarraFooter() {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: function (elem, attr) {
                if (angular.isDefined(attr.templateUrl))
                    return attr.templateUrl;
                return 'app/components/xsBarraFooter/xsBarraFooter.html';
            },
            controller: xsBarraFooterController,
            controllerAs: 'vm',
            bindToController: true
        };
    }


    /** @ngInject */
    function xsBarraFooterController($filter, $log, $state, Auth, Search, localStorageService, BackEnd, MyFunctions, ErrorHandler, Tracking, $uibModal, moment, $timeout, Dialogs) {
        /* jslint validthis:true */
        var vm = this;
        vm.tooltipIsOpen = false;
        $timeout(function(){
                vm.tooltipIsOpen = true;
                $timeout(function(){
                    vm.tooltipIsOpen = false;
                },5000);
        },4000);
        
        vm.aptoIndex = 0;
        vm.searchs = Search.getSearch();
        vm.search = vm.searchs[0];
        vm.adt = Search.adultos();
        vm.chd = Search.criancas();
        vm.colo = Search.colos();
        vm.terceiraIdade = Search.terceiraIdade();
        vm.selectHotel = Search.getSelectHotel();

        vm.consulta = Search.createConsulta(vm.searchs , vm.aptoIndex);

        vm.getHoteis = function () {
            var search = Search.getSearch();
            var checkin = "";
            var chd = 0;
            var colo = 0;
            var terceiraIdade = 0;
            var days = 0;
            if (search[0].date !== null && search[0].endDate.getTime() > search[0].date.getTime()) {
                checkin = MyFunctions.dateToString(search[0].date);
                days = MyFunctions.diasEntre(search[0].date, search[0].endDate);
                if (angular.isDefined(search[0].chd) && search[0].chd > 0) {
                    chd = search[0].chd;
                }
                if (angular.isDefined(search[0].colo) && search[0].colo > 0) {
                    colo = search[0].colo;
                }
                if (angular.isDefined(search[0].terceiraIdade) && search[0].terceiraIdade > 0) {
                    terceiraIdade = search[0].terceiraIdade;
                }
                var parametrosConsultaHoteis = {
                    'method': 'hoteisAvailabilityAndPrice',
                    "adulto": search[0].adt,
                    "chd2": chd.toString(),
                    "colo": colo.toString(),
                    "terceiraIdade": terceiraIdade.toString(),
                    "checkin": checkin,
                    "checkout": MyFunctions.dateToString(search[0].endDate),
                    "noites": days.toString()
                };
                localStorageService.set('parametrosConsulta', parametrosConsultaHoteis);
                localStorageService.remove('resultPesquisa');
                Search.showStepHotel();                
            }
        };
        
       vm.foto = function (item) {
            if (angular.isUndefined(item.foto) || item.foto === null || angular.isUndefined(item.foto.length) || item.foto.length === 0) {
                return "/assets/images/not-imagem.jpg";
            } else {
                return item.foto.split("|")[0].split("\\").join("/");
            }
        };

        vm.modalGaleria = function (item) {
            if (angular.isUndefined(item.foto) || item.foto.length === 0)
                return;
            var fotos = item.foto.split("\\").join("/").split("|");
            Dialogs.galeria(function () {
                return item.service;
            }, function () {
                return fotos;
            }, {});
        };
        
        vm.openModalMaisDetalhesHotel = function(){
            var _item = vm.selectHotel.item;
            $uibModal.open({
                animation: true,
                templateUrl: "app/hospedagem/hoteis/modais/openModalMaisDetalhesHotel.html",
                bindToController: true,
                controller: _ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    item: function () {
                        return _item;
                    },
                    parent: function () {
                        return vm;
                    }
                }
            });                
        };
        
         /** @ngInject */
        function _ItemModalController($uibModalInstance, item, parent, Properties) {
            var vm = this;
            vm.item = item;
            vm.parent = parent;
            vm.verificaHotelUnico = Properties.singlehotel;
            vm.close = function () {
                $uibModalInstance.dismiss();
            };
            vm.ok = function () {
                $uibModalInstance.close('close');
            };
        }

        function _openModal(template) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: template,
                bindToController: true,
                controller: ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    search: function () {
                        return Search.getSearch();
                    }
                }
            });
            modalInstance.result.then(function () {
                vm.getHoteis();
            }, function () {
                $log.debug('Modal dismissed at: ' + new Date());
            });
        }

        vm.openModalNomeHotel = function () {
            var template = "app/components/xsBarraFooter/modais/openModalNomeHotel.html";
            _openModal(template);
        };
        vm.openModalDataHospedagem = function () {
            _openModal("app/components/xsBarraFooter/modais/openModalDataHospedagem.html");
        };
        vm.openModalCountQuartos = function () {
            _openModal("app/components/xsBarraFooter/modais/openModalCountQuartos.html");
        };
        vm.openModalCountAdultosCriancas = function () {
            _openModal("app/components/xsBarraFooter/modais/openModalCountAdultosCriancas.html");
        };
        vm.openModalEditarDadosHospedagem = function () {
            _openModal("app/components/xsBarraFooter/modais/openModalEditarDadosHospedagem.html");
        };

        /** @ngInject */
        function ItemModalController($uibModalInstance) {
            var vm = this;
            vm.adt = Search.adultos();
            vm.chd = Search.criancas();
            vm.colo = Search.colos();
            vm.terceiraIdade = Search.terceiraIdade();
            var aptos = Search.getSearch();
            vm.dates = {
                date: moment(aptos[0].date).toDate(),
                endDate: moment(aptos[0].endDate).toDate()
            };
            vm.noites = aptos[0].noites;

            vm.activeDate = false;
            vm.activeEndDate = false;
            vm.handleDate = function () {
                vm.activeDate = true;
            };

            vm.handleEndDate = function () {
                vm.nextDay = MyFunctions.addDays(vm.dates.date, 1);
                if (vm.dates.endDate < vm.nextDay)
                    vm.dates.endDate = vm.nextDay;
                vm.activeEndDate = true;
            };

            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };
            vm.search = function () {
                var search = Search.getSearch();
                if (search.length == 1) {
                    search[0].adt = vm.adt;
                    search[0].chd = vm.chd;
                    search[0].colo = vm.colo;
                    search[0].terceiraIdade = vm.terceiraIdade;
                }
                search[0].quartos = vm.quartos;
                search[0].date = vm.dates.date;
                search[0].endDate = vm.dates.endDate;
                search[0].noites = MyFunctions.diasEntre(search[0].date, search[0].endDate);
                Search.setSearch(search);
                $uibModalInstance.close('close');
            };
            vm.search2 = function () {
                $uibModalInstance.close('close');
            };

        }

        /* modal carrinho */
        var modalCarrinho = null;
        vm.showHiddenCarrinho = function() {
            if(modalCarrinho !== null) {
                modalCarrinho.close();
                return;
            }
            modalCarrinho = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/xsBarraFooter/modais/modalCarrinho.html',
                bindToController: true,
                controller: function($uibModalInstance){
                    var vm = this;
                    vm.close = function(){
                        $uibModalInstance.dismiss();
                    };
                },
                controllerAs: "vm",
                size: 'lg',
                windowTopClass: 'modal-carrinho',
                windowClass: 'modal-carrinho'               
            });
            modalCarrinho.result.then(function () {
                modalCarrinho = null;
            }, function () {
                modalCarrinho = null;
            });
        };
    }

})();

/**
 * Created by Danillo on 17/07/2016.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('Tracking', Tracking);

    /** @ngInject */
    function Tracking($log) {
        var listeners = {
            pageView: [],
            showProducts: [],
            showCart: [],
            login: [],
            loginError: [],
            addToCart: [],
            removeFromCart: [],
            addItem: [],
            removeItem: [],
            onChangeCart: [],
            buy: [],
            buyError: [],
            //Hospedagem
            searchDate: [],
            showHotel: [],
            selectHotel: [],
            openPaymentLink: [],
            pagarCartao: [],
            selectUH: [],
            buyReservations: [],
            checkoutReservations: []
        };
        var _addListener = function (type, listener) {
            listeners[type].push(listener);
        };

        var _removeListener = function (type, listener) {
            listeners[type].pop(listener);
        };

        function _notifyListeners(type, data, data2) {
            var _listeners = listeners[type];
            angular.forEach(_listeners, function (listener) {
                try {
                    listener(data, data2);
                } catch (error) {
                    $log.error(error);
                }
            });
        }
        var _pageView = function (data) {
            _notifyListeners(_types.PageView, data);
        };
        var _showProducts = function (data, data2) {
            _notifyListeners(_types.ShowProducts, data, data2);
        };
        var _showCart = function (data) {
            _notifyListeners(_types.showCart, data);
        };
        var _addToCart = function (data) {
            _notifyListeners(_types.AddToCart, data);
        };
        var _removeFromCart = function (data) {
            _notifyListeners(_types.RemoveFromCart, data);
        };
        var _addItem = function (data) {
            _notifyListeners(_types.AddItem, data);
        };
        var _removeItem = function (data) {
            _notifyListeners(_types.RemoveItem, data);
        };
        var _onChangeCart = function (data){
            _notifyListeners(_types.OnChangeCart, data);
        };
        var _login = function (data) {
            _notifyListeners(_types.Login, data);
        };
        var _loginError = function (data) {
            _notifyListeners(_types.LoginError, data);
        };
        var _buy = function (data) {
            _notifyListeners(_types.Buy, data);
        };
        var _openPaymentLink = function (data) {
            _notifyListeners(_types.OpenPaymentLink, data);
        };
        var _pagarCartao = function (data) {
            _notifyListeners(_types.PagarCartao, data);
        };
        var _buyError = function (data) {
            _notifyListeners(_types.BuyError, data);
        };
        var _searchDate = function (data) {
            _notifyListeners(_types.SearchDate, data);
        };
        var _showHotel = function (data) {
            _notifyListeners(_types.ShowHotel, data);
        };
        var _selectHotel = function (data) {
            _notifyListeners(_types.SelectHotel, data);
        };
        var _selectUH = function (data) {
            _notifyListeners(_types.SelectUH, data);
        };
        var _buyReservations = function (data) {
            _notifyListeners(_types.BuyReservations, data);
        };
        var _checkoutReservations = function (data) {
            _notifyListeners(_types.CheckoutReservations, data);
        };
        var _types = {
            ShowProducts: 'showProducts',
            AddToCart: 'addToCart',
            RemoveFromCart: 'removeFromCart',
            RemoveItem: 'removeItem',
            AddItem: 'addItem',
            showCart: 'showCart',
            OnChangeCart: 'onChangeCart',
            Login: 'login',
            LoginError: 'loginError',
            Buy: 'buy',
            OpenPaymentLink: 'openPaymentLink',
            PagarCartao: 'pagarCartao',
            BuyError: 'buyError',
            PageView: 'pageView',
            SearchDate: 'searchDate',
            ShowHotel: 'showHotel',
            SelectHotel: 'selectHotel',
            SelectUH: 'selectUH',
            BuyReservations: 'buyReservations',
            CheckoutReservations: 'checkoutReservations'
        };
        return {
            types: _types,
            addListener: _addListener,
            removeListener: _removeListener,
            pageView: _pageView,
            showProducts: _showProducts,
            showCart: _showCart,
            addToCart: _addToCart,
            removeFromCart: _removeFromCart,
            removeItem: _removeItem,
            onChangeCart: _onChangeCart,
            addItem: _addItem,
            login: _login,
            loginError: _loginError,
            buy: _buy,
            openPaymentLink: _openPaymentLink,
            pagarCartao: _pagarCartao,
            buyError: _buyError,
            searchDate: _searchDate,
            showHotel: _showHotel,
            selectHotel: _selectHotel,
            selectUH: _selectUH,
            buyReservations: _buyReservations,
            checkoutReservations: _checkoutReservations
        };
    }
})();

/**
 * Created by Danillo on 08/07/2017.
 *
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .directive('xsPaidButton', xsPaidButton);

    function xsPaidButton() {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: function (elem, attr) {
                if (angular.isDefined(attr.templateUrl))
                    return attr.templateUrl;
                return 'app/components/search/xsPaidButton.html';
            },
            controller: xsPaidButtonController,
            controllerAs: 'vm',
            bindToController: true
        };
    }


    /** @ngInject */
    function xsPaidButtonController($state, Search, BackEnd, $log) {
        /* jslint validthis:true */
        var vm = this;        
        vm.lastReservation = Search.getLastReservation();

        function findReservationById(apto) {
            if(angular.isUndefined(apto) || apto === null || angular.isUndefined(apto.id) || apto.id === null){
                Search.setLastReservation(null);
                vm.show = false;
                return;
            }
            BackEnd.execute2({
                "method": "brokerRequestData",
                "id": apto.id
            }, function (data) {
                $log.debug(data);
            }, function(data){
                $log.debug(data);
                if(angular.isDefined(data.erro) && data.erro !== null && data.erro === "requisicao ja cancelada"){
                    Search.setLastReservation(null);
                    vm.show = false;
                }
            });
        }

        if(angular.isDefined(vm.lastReservation) && vm.lastReservation !== null){
            vm.ids = "";
            vm.amount = 0;
            for (var j = 0; j < vm.lastReservation.length; j++) {
                var el = vm.lastReservation[j];
                findReservationById(el);
            }
            for (var i = 0; i < vm.lastReservation.length; i++) {
                var r = vm.lastReservation[i];
                if(r.voucher) continue;
                if(vm.ids !== "") vm.ids += ",";
                
                vm.ids += r.id;
                vm.show = true;
                vm.amount++;
            }
        }
    }

})();

/**
 * Created by Danillo on 12/06/2017.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('Search', searchService);

    /** @ngInject */
    function searchService(Properties, localStorageService, BackEnd, ErrorHandler, Dialogs, $state, $rootScope, $q, $log, $timeout, $window, moment, MyFunctions, Tracking) {
        var _searchs = null;
        var _selectHotel = null;
        var _selectsUh = null;
        var _selectUhListeners = [];
        var _reservation = null;
        var _hoteis = null;
        var _steps = [];
        var isSearching = false;
        if (!Properties.singlehotel)
            _steps.push({
                title: 'Hotéis',
                subTitle: 'Escolher',
                description: "Escolha do Hotel",
                route: 'hospedagemHoteis',
                click: true
            });
        _steps.push({
            title: 'Apartamentos',
            subTitle: 'Escolher',
            description: "Escolha do Apartamento",
            route: 'hospedagemApartamentos',
            click: true
        });
        _steps.push({
            title: 'Dados Hóspedes',
            subTitle: 'Informar',
            description: "Identificação dos Hóspedes",
            route: 'hospedagemIdentificacao',
            click: true
        });

        function _getSearch() {
            if (_searchs === null) {
                _searchs = localStorageService.get("_xs_search_aptos");
                if (angular.isDefined(_searchs) && _searchs !== null && _searchs.length >= 0) {
                    _searchs[0].date = moment(_searchs[0].date).toDate();
                    _searchs[0].endDate = moment(_searchs[0].endDate).toDate();
                }
            }
            return angular.isUndefined(_searchs) || _searchs === null || _searchs.length === 0 ? null : _searchs;
        }

        function _setSearch(searchs) {
            localStorageService.set("_xs_search_aptos", searchs);
            localStorageService.remove('lastResult');
            _setSelectHotel(null);
            _searchs = searchs;
        }

        function _notifyListeners() {
            angular.forEach(_selectUhListeners, function (listener) {
                listener();
            });
        }

        function _getSelectsUh() {
            if (_selectsUh === null || angular.isUndefined(_selectsUh)) {
                _selectsUh = localStorageService.get("_uhsSelecionada");
            }
            if (_selectsUh === null || angular.isUndefined(_selectsUh))
                _selectsUh = [];
            return _selectsUh;
        }

        function _setLastReservation(reservation) {
            _reservation = reservation;
            localStorageService.set("_last_reservation", _reservation);
        }
        function _sendBudgets(client, items, onComplete) {
            var budgets = [];
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                budgets.push(_toMinimalItem(item));
            }
            var params = {
                method: "addBudgets",
                person: client,
                item: JSON.stringify(budgets)
            };
            onComplete = onComplete || function () {
                //var message = Properties.sendBudgetMessage || "Orçamento solicitado. Você está a um passo da sua viagem! Em breve entraremos em contato!";
                //Dialogs.info(message);
                $state.go("orcamentoconfirmacao");
            };
            var dialog = Dialogs.wait();
            BackEnd.execute(
                    params,
                    function (data) {
                        dialog.close();
                        onComplete(data);
                    },
                    function (error) {
                        dialog.close();
                        ErrorHandler.showError(error);
                    }
            );

        }
        function _createReservation(item, onComplete) {
            item.method = "simpleBook";
            if (localStorageService.cookieGet("bookingAgency") !== null && localStorageService.cookieGet("bookingAgency") !== "")
                item.toAgencyPath = localStorageService.cookieGet("bookingAgency");
            //REcaptcha
            if (angular.isDefined($window.getRecaptcharToken)) item._recaptchar = $window.getRecaptcharToken();
            onComplete = onComplete || function () {};
            var dialog = Dialogs.wait();
            BackEnd.execute(
                    item,
                    function (data) {
                        dialog.close();
                        _setLastReservation(data);
                        onComplete(data);
                    },
                    function (error) {
                        Tracking.buyError(error);
                        dialog.close();
                        ErrorHandler.showError(error);
                    }
            );
        }
        function _toMinimalItem(item) {
            var minimalItem = {};
            minimalItem.persons = [];
            for (var i = 0; i < item.persons.length; i++) {
                var p = angular.copy(item.persons[i]);
                if (angular.isDefined(p.birth) && p.birth instanceof Date)
                    p.birth = MyFunctions.dateToString(p.birth);
                if (p.tag === 'Criança')
                    p.tag = "Crianca";
                if (p.tag === 'Terceira Idade')
                    p.tag = 'terceiraIdade';
                var properties = ["position", "placeholder", "icon", "emote", "status", "categoria", "statusButton"];
                for (var j = 0; j < properties.length; j++) {
                    delete p[properties[j]];
                }
                minimalItem.persons.push(p);
            }
            minimalItem.servicePath = item.servicePath;
            minimalItem.servicePathsAsString = item.servicePathsAsString;
            minimalItem.mealPath = item.mealPath;
            minimalItem.modulesAmount = item.modulesAmount;
            minimalItem.checkin = item.checkin;
            minimalItem.value = item.value;
            minimalItem.memo = item.memo && item.memo.replace(/"/g,"");
            if (angular.isDefined(item.included) && item.included !== null) {
                minimalItem.included = [];
                angular.forEach(item.included, function (included) {
                    if (item.mealPath != null && angular.isDefined(item.mealPath)) {
                        if (included.pathAsString.indexOf(item.mealPath) >= 0)
                            return;
                        if (item.mealPath.indexOf(included.pathAsString) >= 0)
                            return;
                    }
                    minimalItem.included.push({"pathAsString": included.pathAsString});
                });
            }
            if (angular.isDefined(item.products) && item.products !== null)
                minimalItem.products = item.products;
            if(angular.isDefined(item.customData) && item.customData !== null) {
                minimalItem.customData = minimalItem.customData || {};
                if(angular.isDefined(item.customData.orcamento) && item.customData.orcamento !== null) {
                    minimalItem.customData.orcamento = item.customData.orcamento;
                }
                if (angular.isDefined(item.customData.cupomAsString) && item.customData.cupomAsString !== null) {
                    minimalItem.customData.cupomAsString = item.customData.cupomAsString;
                }
            }
            return minimalItem;
        }

        function _createConsulta(searchs, index) {
            var search = searchs[index];
            var checkin = "";
            var chd = 0;
            var colo = 0;
            var terceiraIdade = 0;
            var days = 0;
            if (angular.isDefined(search.date) && search.date !== null && angular.isDefined(search.endDate) && search.endDate !== null && search.endDate.getTime() > search.date.getTime()) {

                checkin = MyFunctions.dateToString(search.date);
                days = MyFunctions.diasEntre(search.date, search.endDate);

                if (angular.isDefined(search.chd) && search.chd > 0) {
                    chd = search.chd;
                }
                if (angular.isDefined(search.colo) && search.colo > 0) {
                    colo = search.colo;
                }
                if (angular.isDefined(search.terceiraIdade) && search.terceiraIdade > 0) {
                    terceiraIdade = search.terceiraIdade;
                }

                var parametrosConsultaHoteis = {
                    'method': 'hoteisAvailabilityAndPrice',
                    "adulto": search.adt,
                    "chd2": chd.toString(),
                    "colo": colo.toString(),
                    "terceiraIdade": terceiraIdade.toString(),
                    "chdsAges":search.chdsAges,
                    "checkin": checkin,
                    "checkout": MyFunctions.dateToString(search.endDate),
                    "noites": days.toString()
                };

                if(Properties.unavailable) parametrosConsultaHoteis.unavailable =  "true";

                var hotelPath = searchs[0].hotelPath;
                if (angular.isDefined(hotelPath) && hotelPath !== null && hotelPath !== "") {
                    parametrosConsultaHoteis.hotelPath = hotelPath;
                }
                localStorageService.set('parametrosConsulta', parametrosConsultaHoteis);
                localStorageService.remove('resultPesquisa');

                return parametrosConsultaHoteis;
            }
        }

        var _functionStop = [];
        $rootScope.$on('$stateChangeSuccess', function () {
            for (var i = 0; i < _functionStop.length; i++) {
                _functionStop[i].stop = true;
            }
        });

        function _executeLazySearch(consulta, onComplete, onError, onFullComplete, result) {
            onComplete = onComplete || function () {};
            onError = onError || function () {};
            onFullComplete = onFullComplete || function () {};
            var hoteis = localStorageService.get('hoteis');
            if (hoteis === null || angular.isUndefined(hoteis) || angular.isUndefined(hoteis.length) || hoteis.length === 0) {
                isSearching = false;
                onComplete();
                ErrorHandler.showError("Nenhum Estabelecimento disponível");
                return;
            }
            var _hoteisMap = [];
            consulta.stop = false;
            angular.copy(hoteis, _hoteisMap);
            _functionStop.push(consulta);
            consulta.method = "availabilityAndPrice";
            if(Properties.unavailable) consulta.unavailable =  "true";
            if (angular.isDefined(consulta.hotelPath) && consulta.hotelPath !== null && consulta.hotelPath !== "") {
                _hoteisMap = [{path: consulta.hotelPath}];
            }
            function searchByHotel(consulta) {
                consulta.hotel = _hoteisMap[0].path;
                BackEnd.execute(consulta,
                        function (data) {
                            // console.debug('Pesquisa 1 realizada (availabilityAndPrice)');
                            // console.debug(_hoteisMap);
                            $log.debug(data);
                            _hoteisMap = _hoteisMap.slice(1);
                            if (data !== null && data.result !== null && data.result.length > 0) {
                                if (Properties.onlyBudget)
                                    data.onlyBudget = true;
                                if (data.item.localizacao && data.item.localizacao.indexOf("http") === 0) {
                                    data.item.linkmap = data.item.localizacao;
                                }
                                if (result === null) { //Primeiro resultado;
                                    result = [data];
                                    if (_hoteisMap.length === 0) {
                                        var lastResult = {
                                            resultDate: moment(new Date()).add(10, 'minutes').toDate(),
                                            result: result
                                        };
                                        localStorageService.set('lastResult', lastResult);
                                    }
                                    onComplete(result);
                                } else
                                    result.push(data);
                                //Tracking.showHotel(data);
                            }
                            if (_hoteisMap.length > 0) {
                                if (consulta.stop) {
                                    Tracking.searchDate(result);
                                    return;
                                }
                                searchByHotel(consulta);
                            } else {
                                isSearching = false;
                                Tracking.searchDate(result);
                                if (result === null)
                                    onComplete(result);
                                else
                                    onFullComplete(result);
                            }
                        },
                        function (error) {
                            $log.debug(error); // Ignora Erro pois tem hoteis que não tem preço
                            _hoteisMap = _hoteisMap.slice(1);
                            if (_hoteisMap.length > 0) {
                                if (!consulta.stop)
                                    searchByHotel(consulta);
                                else
                                    Tracking.searchDate(result);
                            } else {
                                isSearching = false;
                                Tracking.searchDate(result);
                                onFullComplete(result);
                            }
                        });
              // console.debug(_hoteisMap);
            }
            searchByHotel(consulta);
        }
        var _result = null;
        function _executeSearch(consulta, onComplete, onError, onFullComplete) {
            isSearching = true;
            onComplete = onComplete || function () {};
            onError = onError || function () {};
            if (Properties.onlyBudget) {
                consulta.unavailable = "true";
                consulta.optimized = "true";
            }
            if (Properties.lazyLoadHoteis) {
                _getHoteis().then(function () {
                    _executeLazySearch(consulta, onComplete, onError, onFullComplete, _result);
                }, function () {
                    onError();
                });
                return;
            }
            var oldResult = localStorageService.get('lastResult');
            if (angular.isDefined(oldResult) && oldResult !== null && angular.isDefined(oldResult.resultDate) && oldResult.resultDate !== null) {
                if (moment().isBefore(moment(oldResult.resultDate))) {
                    $timeout(function () {
                        isSearching = false;
                        onComplete(oldResult.result);
                    }, 500);
                    return;
                } else
                    localStorageService.remove('lastResult');
            }
            BackEnd.execute(consulta,
                    function (data) {
                        if (Properties.onlyBudget && angular.isDefined(data) && data !== null) {
                            angular.forEach(data, function (each) {
                                each.onlyBudget = true;
                            });
                        }
                        var lastResult = {
                            resultDate: moment(new Date()).add(10, 'minutes').toDate(),
                            result: data
                        };
                        localStorageService.set('lastResult', lastResult);
                        isSearching = false;
                        /*angular.forEach(data, function(hotel){
                         Tracking.showHotel(hotel);
                         });*/
                        Tracking.searchDate(data);
                        onComplete(data);
                    },
                    function (error) {
                        isSearching = false;
                        onError(error);
                    }
            );
        }


        function _getHoteis() {
            var deferred = $q.defer();
            //var arryHoteis = {};
            if (_hoteis !== null && angular.isDefined(_hoteis) && _hoteis.length > 0) {
                deferred.resolve(_hoteis); //where data is the data you want to get
            } else {
                //insert logic and async calls here
                BackEnd.execute({"method": "hoteis"}, function (data) {
                    if (angular.isDefined(Properties.servicePaths)) {//Verifica se há service Paths
                        data = verificaHoteisPartirServicePaths(data);
                    }

                    _hoteis = data;
                    localStorageService.set('hoteis', data);
                    deferred.resolve(data); //where data is the data you want to get
                },
                        function (error) {//ErrorHandler.showError(error);
                            deferred.reject(error);
                        });
                //after everything is done, do this
            }
            return deferred.promise;
        }

        /**
         * Filtrar hoteis a partir da path. Paths informadas por Properties
         * @param {array} data
         * @returns {Array} Hoteis validados a partir da path
         */
        function verificaHoteisPartirServicePaths(data) {
            var servicePaths = Properties.servicePaths;
            var hoteisValidos = [];

            angular.forEach(servicePaths, function (servicePath) {
                angular.forEach(data, function (hotel) {
                    if (servicePath === hotel.path) {
                        hoteisValidos.push(hotel);
                    }
                });
            });

            return hoteisValidos;
        }


        function _setSelectHotel(hotel) {
            localStorageService.remove("_hotelSelecionado");
            localStorageService.set("_hotelSelecionado", hotel);
            _selectHotel = hotel;
            // remove uhs quando seleciona hotel
            _selectsUh = [];
            localStorageService.remove("_uhsSelecionada");
        }

        function _personsAsString(persons, strAdtp) {
        var strAdt =  strAdtp ? strAdtp : " Adulto"
        var result = "";
        var adt = 0,
          chd = 0,
          colo = 0,
          chd2 = 0,
          chd1 = 0,
          infantil = 0,
          terceiraIdade = 0;
        persons.sort(function (a, b) {
          return a.tag.localeCompare(b.tag);
        });
        for (var i = 0; i < persons.length; i++) {
          var p = persons[i];
          if (p.tag.toLowerCase() == "adulto") adt++;
          if (p.tag.toLowerCase() == "criança") chd++;
          if (p.tag.toLowerCase() == "chd1") chd1++;
          if (p.tag.toLowerCase() == "chd2") chd2++;
          if (p.tag.toLowerCase() == "colo") colo++;
          if (p.tag.toLowerCase() == "infantil") infantil++;
          if (p.tag.toLowerCase() == "terceiraidade" || p.tag.toLowerCase() == "terceira idade") terceiraIdade++;
        }
        if (adt > 0) result = adt + strAdt + (adt > 1 ? "s" : "");
        if (chd > 0) {
          if (result !== "") result += ", ";
          result += chd + " Criança" + (chd > 1 ? "s" : "");
        }
        if (chd1 > 0) {
          if (result !== "") result += ", ";
          result += chd1 + " Chd1";
        }
        if (chd2 > 0) {
          if (result !== "") result += ", ";
          result += chd2 + " Chd2";
        }
        if (infantil > 0) {
            if (result !== "") result += ", ";
            result += infantil + " Infantil";
          }
        if (colo > 0) {
          if (result !== "") result += ", ";
          result += colo + " Colo" + (colo > 1 ? "s" : "");
        }
        if (terceiraIdade > 0) {
          if (result !== "") result += ", ";
          result += terceiraIdade + " Ter. Idade" + (terceiraIdade > 1 ? "s" : "");
        }
        return result;
        }

        return {
            personsAsString: _personsAsString,
            createConsulta: _createConsulta,
            getHoteis: _getHoteis,
            executeSearch: _executeSearch,
            isSearching: function () {
                return isSearching;
            },
            showStepHotel: function (hotelPath) {
                var index = 0;
                if (!Properties.onlyBudget && !Properties.singlehotel && angular.isDefined(hotelPath) && hotelPath !== null && hotelPath !== "") {
                    index = 1; // pula para segundo passo quando o hotelPath veio no paramentro de busca;
                    delete _getSearch()[0].hotelPath;
                }
                if (_steps[index].route === "hospedagemApartamentos") {
                    var oldResult = localStorageService.get('lastResult');
                    if(oldResult == null){
                        Dialogs.again();
                        return;
                    }
                    _setSelectHotel(oldResult.result[0]);
                }
                $state.go(_steps[index].route, {}, {reload: _steps[index].route});
                //$state.go(_steps[0].route);
            },
            setSteps: function (steps) {
                _steps = steps;
            },
            getSteps: function () {
                return _steps;
            },
            toNextStep: function () {
                for (var i = 0; i < _steps.length; i++) {
                    var state = _steps[i];
                    if ($state.current.name === state.route) {
                        $state.go(_steps[i + 1].route);
                    }
                }
            },
            getSearch: _getSearch,
            setSearch: _setSearch,
            getSelectHotel: function () {
                if (_selectHotel === null) {
                    _selectHotel = localStorageService.get("_hotelSelecionado");
                }
                return _selectHotel;
            },
            setSelectHotel: _setSelectHotel,
            getLastReservation: function () {
                if (_reservation === null) {
                    _reservation = localStorageService.get("_last_reservation");
                }
                return _reservation;
            },
            setLastReservation: _setLastReservation,
            getSelectsUh: _getSelectsUh,
            addSelectUh: function (uh) {
                if (_selectsUh === null || angular.isUndefined(_selectsUh))
                    _selectsUh = [];
                _selectsUh.push(uh);
                localStorageService.remove("_uhsSelecionada");
                localStorageService.set("_uhsSelecionada", _selectsUh);
                _notifyListeners();
            },
            clearSelectsUh: function () {
                localStorageService.remove("_uhsSelecionada");
                _selectsUh = [];
                _notifyListeners();
            },
            selectUhListener: function (listener) {
                _selectUhListeners.push(listener);
            },
            notifyListeners: _notifyListeners,
            adultos: function () {
                var searchs = _getSearch();
                if (angular.isUndefined(searchs) || searchs === null)
                    return 0;
                var adt = 0;
                for (var i = 0; i < searchs.length; i++) {
                    var el = searchs[i];
                    adt += parseInt(el.adt, 10);
                }
                return adt;
            },
            criancas: function () {
                var searchs = _getSearch();
                if (angular.isUndefined(searchs) || searchs === null)
                    return 0;
                var chd = 0;
                for (var i = 0; i < searchs.length; i++) {
                    var el = searchs[i];
                    if (angular.isDefined(el.chd) && el.chd !== null && el.chd !== "")
                        chd += parseInt(el.chd, 10);
                }
                return chd;
            },
            colos: function () {
                var searchs = _getSearch();
                if (angular.isUndefined(searchs) || searchs === null)
                    return 0;
                var colo = 0;
                for (var i = 0; i < searchs.length; i++) {
                    var el = searchs[i];
                    if (angular.isDefined(el.colo) && el.colo !== null && el.colo !== "")
                        colo += parseInt(el.colo, 10);
                }
                return colo;
            },
            terceiraIdade: function () {
                var searchs = _getSearch();
                if (angular.isUndefined(searchs) || searchs === null)
                    return 0;
                var terceiraIdade = 0;
                for (var i = 0; i < searchs.length; i++) {
                    var el = searchs[i];
                    if (angular.isDefined(el.terceiraIdade) && el.terceiraIdade !== null && el.terceiraIdade !== "")
                    terceiraIdade += parseInt(el.terceiraIdade, 10);
                }
                return terceiraIdade;
            },
            toMinimalItem: _toMinimalItem,
            sendBudgets: _sendBudgets,
            createReservation: _createReservation,
            calculatePrice: function (hotel, item, callback, hideDialog, onError, cache) {
                callback = callback || function () {};
                onError = onError || function (error) {
                    ErrorHandler.showError(error);
                };
                item.value = null;
                item.boletoValue = null;
                item.boletoDescontoValue = null;
                item.promos = null;
                var myitem = _toMinimalItem(item);
                var dialog = null;
                if (hideDialog)
                    dialog = {close: function () {}};
                else
                    dialog = Dialogs.wait();
                var params = {
                        "method": "price",
                        "agencyPath": Properties.operadoraPath,
                        "item": myitem
                    };
                if(cache) params.cache = "true";
                BackEnd.execute(params,
                    function (data) {
                        item.value = data.value;
                        item.oldValue = data.oldValue;
                        item.boletoValue = data.boletoValue;
                        item.boletoDescontoValue = data.boletoDescontoValue;
                        item.promos = data.promos;
                        if (data.maxFinancialLength)
                            item.maxFinancialLength = parseInt(data.maxFinancialLength);
                        if(data.paymentMethodsAdjustments && data.paymentMethodsAdjustments.length > 0)
                            item.paymentMethodsAdjustments  = data.paymentMethodsAdjustments;
                        if (hotel !== null && (angular.isUndefined(hotel.item.value) || hotel.item.value === null || hotel.item.value > item.value)) {
                            hotel.item.value = parseInt(item.value, 10);
                            hotel.item.boletoValue = item.boletoValue;
                            hotel.item.boletoDescontoValue = item.boletoDescontoValue;
                            hotel.item.maxFinancialLength = item.maxFinancialLength;
                            if(item.paymentMethodsAdjustments && item.paymentMethodsAdjustments.length > 0)
                               hotel.item.paymentMethodsAdjustments = item.paymentMethodsAdjustments;
                        }
                        dialog.close();
                        callback(item);
                    },
                    function (error) {
                        dialog.close();
                        onError(error, item);
                    }
                );
            },
            totalValue: function () {
                var searchs = _getSelectsUh();
                if (angular.isUndefined(searchs) || searchs === null)
                    return 0;
                var somaValoresApartametentos = 0;
                for (var i = 0; i < searchs.length; i++) {
                    if (angular.isDefined(searchs[i]) && searchs[i] !== null) {
                        var apto = searchs[i];
                        if (angular.isDefined(apto.value) && apto.value !== null && apto.value !== "")
                            somaValoresApartametentos += parseInt(apto.value, 10);
                        if (angular.isDefined(apto.produtosValue) && apto.produtosValue !== null && apto.produtosValue !== "")
                            somaValoresApartametentos += parseInt(apto.produtosValue, 10);
                    }
                }
                return somaValoresApartametentos / 100;
            },
            getBestPaymentDiscount: function(apto){
                if(!apto.paymentMethodsAdjustments || (apto.paymentMethodsAdjustments && apto.paymentMethodsAdjustments.length <= 0)){
                  return false;
                }
                var paymentDiscount = apto.paymentMethodsAdjustments.filter(function(method){
                  return (method.type === 'desconto');
                })
                if(paymentDiscount.length <= 0){
                  return false;
                }
                paymentDiscount = paymentDiscount.sort(function(a,b){
                  if(Number(a.value) > Number(b.value)){
                    return 1;
                  }
                  if(Number(a.value) < Number(b.value)){
                    return -1;
                  }
                  return 0;
                })[0];
                return paymentDiscount;
              }
        };
    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('ScrollTo', ScrollTo);

    /** @ngInject */
    function ScrollTo($timeout, Properties) {
        var bookmark_offset = 0;

        if (angular.isDefined(Properties.bookmark_offset)) {
            bookmark_offset = Properties.bookmark_offset;
        }

        function _scrollTo(id) {
            $timeout(function () {
                var selector = "[id='" + id + "']";
                var el = angular.element(selector);
                var offset = bookmark_offset;
                if (el.length) {
                    if (el.attr("bookmark-offset")){
                        offset += el.attr("bookmark-offset");
                    }
                    angular.element('html,body').animate({scrollTop: el[0].offsetParent.offsetTop + el[0].offsetTop - offset}, {
                        duration: 'slow',
                        easing: 'swing'
                    });
                }
            }, 30);
        }
        function _scrollToContainer(id, container) {
            $timeout(function () {
                var selector = "[id='" + id + "']";
                var selectorContainer = "[id='" + container + "']";
                var el = angular.element(selector);
                
                var offset = bookmark_offset;
                if (el.length) {
                    if (el.attr("bookmark-offset")){
                        offset += el.attr("bookmark-offset");
                    }
                    angular.element(selectorContainer).animate({scrollTop: el[0].offsetParent.offsetTop + el[0].offsetTop - offset}, {
                        duration: 'slow',
                        easing: 'swing'
                    });
                }
            }, 30);
        }

        return {
            scrollTo: _scrollTo,
            scrollToContainer: _scrollToContainer
        };
    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('PaymentService', paymentService);

    /** @ngInject */
    function paymentService(Properties, Auth, Dialogs, ErrorHandler, $http, BackEnd) {
        function _has3ds(){
          return !!(Properties._3ds);
        }
        if(_has3ds()){
          var el = document.createElement('script');
          el.src = '3ds/BP.Mpi.3ds20.min.js';
          document.querySelector('body').append(el)
          window._3ds = {
            onReady3ds: function(){
              Properties._3ds.load = true;
              window.bpmpi_authenticate();
            },
            /*
            onFailure : function(){
              window._3ds.dialog.close();
              Dialogs.error(
                Properties._3ds.msgFailure ||
                'Transação não Efetivada – Utilizamos autenticação para validação de compra junto ao banco, Tente novamente'
              );
            },
            onUnenrolled: function () {
              window._3ds.dialog.close();
              Dialogs.error(
                Properties._3ds.msgUnenrolled ||
                'Transação não Efetivada – Utilizamos autenticação para validação de compra junto ao banco, seu banco ainda não possua essa tecnologia. Para a sua segurança, indicamos que utilize outro método de pagamento'
                );
            },
            onError: function(){
              window._3ds.dialog.close();
              Dialogs.error(
                Properties._3ds.msgError ||
                'Transação não Efetivada - Erro no sistema durante etapa de autenticação.'
              );
            },
            onUnsupportedBrand : function(){
              window._3ds.dialog.close();
              Dialogs.error(
                Properties._3ds.msgUnsupportedBrand ||
                'Transação não Efetivada – Utilizamos autenticação para validação de compra junto ao banco, bandeira do cartão não suportada para autenticação, Para a sua segurança, indicamos que utilize outro método de pagamento.'
              );
            }*/
          };
        }


        var lastGuid = null;
        function _guid() {
          function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
          }
          lastGuid = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
          return lastGuid
        }
        /*
          Função para tokenizar o cartão
          paid: objeto com os dados do cartão de credito
          success: função callback que recebe os dado tokenizados
          fail: função de erro (opcional)
        */
        function _createToken(paid, success, fail) {
            var goodThru = paid.goodThru;
            if (goodThru.length == 5 || goodThru.length == 4) {
                goodThru = goodThru.replace("/", "");
                goodThru = goodThru.substring(0, 2) + "/20" + goodThru.substring(2,4);
            }
            fail = fail || function(error){ // função de falha
              ErrorHandler.showError(error);
            };
            if(paid.cardType == null || angular.isUndefined(paid.cardType) || paid.cardType == ""){
              fail("bandeira não informada");
              return;
            }

            var user = Auth.getUser();
            var passaporte = null
            if(user) passaporte = user.passaporte

            var body = {
              // body da tokenização
              card: {
                card_holder: paid.customer || paid.personName, //Nome Impresso
                brand: paid.cardType, // bandeira
                card_number: paid.cardNumber, // numero cartão
                cvv: paid.securityCode || paid.code, // codigo de segurança
                due_date: goodThru, // validade cartão mm/yyyy
                card_holder_document: paid.personCpf || passaporte,
              },
            };
            if(angular.isDefined(paid.fingerPrint) && paid.fingerPrint != null)
                body.data = paid.fingerPrint;
            var _success = function(data) { // função de sucesso com tratativa do status
                if(data.status == "failed"){
                  var errMsg = data.message;
                  if(data.acquirer_responses && data.acquirer_responses[0].response)
                      errMsg = data.acquirer_responses[0].response.message;
                  fail(errMsg);
                } else success(data);
            };

            $http({
                method: 'POST',
                url: Properties.token.url,   // url do gateway
                data: body,
                headers:
                {
                  'CompanyId': Properties.token.CompanyId // companyId
                }
                }).success(_success).error(fail);
        }

        function _paywithSecurityToken(_paid,_params){
          var paid = _params.paymentMethodAsString ? _params.paymentMethodAsString : _params;
          _createToken(paid,
              function(_result) {
                  paid.cardNumber = _result.token;
                  paid.goodThru = _result.card.due_date;
                  paid.code = _result.card.cvv;
                  paid.token2 = _result.token2;
                  paid.customData =  paid.customData || {};
                  paid.customData.card_number = _result.card.card_number;
                  _paid(_params);
              }
          );
        }

      function _createLostBill(params) {
        var paidParams = angular.copy(params);
        paidParams.method = "createLostBill";
        if(params.billId){
          var cardNumber = paidParams.cardNumber;
          if(paidParams.customData && paidParams.customData.card_number)
           cardNumber = paidParams.customData.card_number;
           else cardNumber = cardNumber.substring(0,4) + "XXXXXXXX" + cardNumber.substring(12)
          paidParams = {
            method: "registerLostCreditCard",
            billPath: paidParams.billId,
            paymentMethodAsString: {
              personName: paidParams.customer,
              type: paidParams.cardType,
              length: paidParams.count,
              value: paidParams.value,
              cardNumber: cardNumber
            }
          };
        }
        BackEnd.execute(paidParams, function() {}, function() {}, "POST");
    }

        function _get3dsAccessToken(onSuccess, fail, robjectPath){

            fail = fail || function(error){
                ErrorHandler.showError(error);
            };
            var url = Properties.url3ds || Properties.serverUrl.toString().replace('proxy.php','3ds.php');
            $http({
                method: 'POST',
                url: url,
                data: BackEnd.toPayLoad({"robjectPath": robjectPath || ""}),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8', 'Cache-Control': 'no-cache' }
              }).success(onSuccess).error(fail);
        }

        function _remove3dsFields(){
          var div3ds = document.querySelector('div#cielo3ds');
          if(!div3ds){
            return;
          }
          div3ds.childNodes.forEach(function(child){
            child.remove();
          });
          div3ds.remove();
        }

        // https://developercielo.github.io/manual/integracao-javascript
        function _payUsing3ds(_paid,_params, robjectPath){
          var params = _params.paymentMethodAsString ? _params.paymentMethodAsString : _params;
          _createOrUpdate3dsFields(params._user || Auth.getUser());
          window._3ds.onUnenrolled = function(){
            window._3ds.dialog.close();
            if(Properties._3ds.unsupportedCard){
              if(Properties.token){
                _paywithSecurityToken(_paid,_params);
              }else {
                _paid(_params);
              }
            } else {
              if(Properties._3ds.createLostBill) _createLostBill(_params);
              Dialogs.error(
                Properties._3ds.msgUnenrolled ||
                'Transação não Efetivada – Utilizamos autenticação para validação de compra junto ao banco, seu banco ainda não possua essa tecnologia. Para a sua segurança, indicamos que utilize outro método de pagamento'
                );
            }
          };
          window._3ds.onUnsupportedBrand  = function(){
            window._3ds.dialog.close();
            if(Properties._3ds.unsupportedCard){
              if(Properties.token){
                _paywithSecurityToken(_paid,_params);
              } else {
                _paid(_params);
              }
            } else {
              if(Properties._3ds.createLostBill) _createLostBill(_params);
              Dialogs.error(
                Properties._3ds.msgUnsupportedBrand ||
                'Transação não Efetivada – Utilizamos autenticação para validação de compra junto ao banco, bandeira do cartão não suportada para autenticação, Para a sua segurança, indicamos que utilize outro método de pagamento.'
              );
            }
          };
          window._3ds.onError = function(){
            window._3ds.dialog.close();
            if(Properties._3ds.createLostBill) _createLostBill(_params);
            Dialogs.error(
              Properties._3ds.msgError ||
              'Transação não Efetivada - Erro no sistema durante etapa de autenticação.'
            );
          }
          window._3ds.onFailure = function(){
            window._3ds.dialog.close();
            if(Properties._3ds.createLostBill) _createLostBill(_params);
            Dialogs.error(
              Properties._3ds.msgFailure ||
              'Transação não Efetivada – Utilizamos autenticação para validação de compra junto ao banco, Tente novamente'
            );
          }
          window._3ds.set3dsAuthentication = function(values){
            params.externalAuthentication = {
              Cavv: values.Cavv,
              Xid: values.Xid,
              Eci: values.Eci,
              Version: values.Version,
              ReferenceId: values.ReferenceId
            };
            params.paymentId = lastGuid;
            var paidParams = null;
            if(_params.paymentMethodAsString){
              paidParams = _params;
              paidParams.paymentMethodAsString.externalAuthentication = params.externalAuthentication;
              paidParams.paymentMethodAsString.paymentId = params.paymentId;
            } else {
              paidParams = params;
            }
            if(Properties.token) {
              var paymentMethod = paidParams.paymentMethodAsString || paidParams;
               if(angular.isUndefined(paymentMethod.cardType) || paymentMethod.cardType == null || paymentMethod.cardType == "") paymentMethod.cardType = paymentMethod.type;
              _createToken(paymentMethod,
                  function(_result) {
                      paymentMethod.cardNumber = _result.token;
                      paymentMethod.goodThru = _result.card.due_date;
                      paymentMethod.code = _result.card.cvv;
                      paymentMethod.securityCode = _result.card.cvv;
                      paymentMethod.token2 = _result.token2;
                      paymentMethod.customData = paymentMethod.customData || {};
                      paymentMethod.customData.card_number = _result.card.card_number;
                      _paid(paidParams);
                  }
                );
            } else _paid(paidParams);

            _remove3dsFields();
            window._3ds.dialog.close();
          }
          window._3ds.dialog = Dialogs.wait('Autenticando pagamento');
          // Todo: levar em consideração segunda tentativa
          _get3dsAccessToken(function(data){
            if(angular.isUndefined(data) || !data.access_token){
              window._3ds.dialog.close();
              ErrorHandler.showError('Falha ao tentar pegar o token de acesso.');
              return;
            }
            document.querySelector('.bpmpi_accesstoken').value = data.access_token;
            if(Properties._3ds.load){
              window.bpmpi_authenticate();
            }else {
              window.bpmpi_load();
            }
          }, function(error){
            window._3ds.dialog.close();
            ErrorHandler.showError(error);
          }, robjectPath);

          function _createOrUpdate3dsFields(user){
            _remove3dsFields();
            var body = document.querySelector('body');
            var div3ds = document.createElement('div');
            div3ds.id = 'cielo3ds';
            div3ds.style.display = 'none';
            div3ds.style.visibility = 'hidden';



            _fields3ds(user).forEach(function(item){
              var input = document.createElement('input');
              input.type = 'hidden';
              input.className = item.className;
              input.value = item.value;
              div3ds.append(input);
            });
            body.append(div3ds);
          }

          function _fields3ds(user){
            var _r = [
              {
                className: 'bpmpi_auth_notifyonly',
                value: false
              },
              {
                className: 'bpmpi_auth', // se true: submeter autenticação via 3ds
                value: true
              },
              {
                className: 'bpmpi_accesstoken', // Token gerado pela API de Token de Acesso (etapa 1)
                value: null
              },
              {
                className: 'bpmpi_ordernumber', // Código do pedido no estabelecimento [string de até 50 posições]
                value: _guid()
              },
              {
                className: 'bpmpi_currency', // Fixo 'BRL'
                value: 'BRL'
              },
              {
                className: 'bpmpi_totalamount', // number do valor total da transação em centavos
                value: params.value
              },
              {
                className: 'bpmpi_installments', // number de parcelas da transação
                value: params.length ? params.length : params.count
              },
              {
                className: 'bpmpi_paymentmethod', // 'Credit' | 'Debit'
                value: 'Credit'
              },
              {
                className: 'bpmpi_cardnumber', // até 50 posições
                value: params.cardNumber
              },
              {
                className: 'bpmpi_cardexpirationmonth', // Mês do vencimento do cartão: '01' | '02' | etc
                value: params.goodThru.toString().slice(0,2)
              },
              {
                className: 'bpmpi_cardexpirationyear', // Ano do vencimento do cartão: '2026'
                value: params.goodThru.includes('/') ?  '20' + params.goodThru.toString().slice(3,5) : '20' + params.goodThru.toString().slice(2,4)
              },
              {
                className: 'bpmpi_order_productcode', // PHY | CHA | QTC | PAL
                value: 'PHY'
              },
              {
                className: 'bpmpi_merchant_url', // Endereço do site do estabelecimento
                value: Properties.loja3ds || Properties.serverUrl.toString().replace('proxy.php','')
              },
              {
                className: 'bpmpi_billto_contactname', // Nome do contato do endereço de cobrança; max 120
                value: params.personName ? params.personName : params.customer
              },
              {
                className: 'bpmpi_billto_phonenumber', // Telefone de contato do endereço de cobrança; '5511999999999'
                value: user.cellPhone
              },
              {
                className: 'bpmpi_billto_email', // E-mail do contato do endereço de cobrança; max 255
                value: user.email
              },
              {
                className: 'bpmpi_billto_street1', // Logradouro e Número do endereço de cobrança; max 60
                value: user.street0
              },
              {
                className: 'bpmpi_billto_street2', // Complemento e bairro do endereço de cobrança; max 60
                value: user.street1 ? user.street1 : user.street0
              },
              {
                className: 'bpmpi_billto_city', // Cidade do endereço de cobrança; max 50
                value: user.city
              },
              {
                className: 'bpmpi_billto_state',  // Sigla do estado do endereço de cobrança; 'MG'
                value: user.state
              },
              {
                className: 'bpmpi_billto_zipcode', // CEP do endereço de cobrança; 99999999
                value: user.zipCode
              },
              {
                className: 'bpmpi_billto_country',  // País do endereço de cobrança; 'BR'
                value: 'BR'
              },
              {
                className: 'bpmpi_device_channel',  // Canal por onde chegou a transação. Valores possíveis:- Browser - SDK - 3RI
                value: 'Browser'
              }
            ];
            if(Properties._3ds && Properties._3ds.bpmpi_brand_establishment_code){
              //verificar se é cartao Amex
              if(params.cardType && params.cardType.toLowerCase().indexOf('amex') > -1){
                _r.push({
                  className: 'bpmpi_brand_establishment_code', // Código EC Amex
                  value: Properties._3ds.bpmpi_brand_establishment_code
                });
              }
            }
            return _r;
          }
        }
        return {
            get3dsAccessToken: _get3dsAccessToken,
            payUsing3ds: _payUsing3ds,
            has3ds: _has3ds,
            createToken: _createToken
        };
    }
})();
/*

@SerializedName("payment_id")
		private String paymentId;

		private Customer customer;

		@JsonRequired
		private Payment payment;

		@JsonRequired
		private String description;

		@JsonOptional
		@SerializedName("capture_transaction")
		private CaptureTransaction captureTransaction;

		@JsonOptional
		@SerializedName("cancel_transaction")
        private CancelTransaction cancelTransaction;
        */

/**
 * Created by Danillo on 26/07/2021.
 */

 (function () {
    'use strict';
    angular
    .module('b2c_ingressos')
    .directive('xsFormInput', xsFormInput);

    /** @ngInject **/
    function xsFormInput($compile) {
        return {
        template: '<div class="form-group" ng-hide="input.type==\'hidden\'"><label class="col-xs-12 control-label">{{input.name}}: </label></div>',
        replace: true,
        link: function(scope, element) {
                var el = angular.element('<span class="col-xs-12"/>');
                switch (scope.input.type) {
                case 'text':
                    el.append('<input class="form-control" type="text" ng-model="input.value" ng-required="input.required" ng-readonly="input.readonly" />');
                    break;
                case 'phone':
                    el.append(
                      '<input name="cellPhone" tabindex="4" type="text" id="cellPhone" value="" class="form-control" ng-model="input.value" ui-mask="(99) 9?9999-9999" autocomplete="tel" ui-mask-placeholder ng-required="input.required" />'
                    );
                    break;
                case 'memo':
                    el.append('<textarea class="form-control" type="text" ng-model="input.value" ng-required="input.required" col="3"></textarea>');
                    break;
                case 'list':
                    el.append('<select class="form-control" ng-model="input.value" ng-options="item.value as item.show for item in input.values" ng-required="input.required" ng-change="input.onChange()"></select>');
                    break;
                case 'amount':
                    el.append('<input class="form-control" type="number" ng-model="input.value" ng-required="input.required"/>');
                    //el.append('<input class="form-control" type="text" ng-model="input.value" ng-numbers-only ng-required="input.required" />');
                    break;
                case 'value':
                    el.append('<input class="form-control" type="number" ng-model="input.value" min="0.00" max="90000.00" step="0.01" ng-required="input.required"/>');
                    break;
                case 'cpf':
                    el.append(
                      '<input title="Digite o CPF" type="text" class="form-control" id="CPF" ui-mask="999.999.999-99" placeholder="Digite o seu CPF" ui-mask-placeholder ng-model="input.value" ng-required="input.required"/>'
                    );
                    break;
                case 'license_plate':
                    el.append(
                      '<input type="text" class="form-control" ng-model="input.value" ng-change="input.value = vm.normalizeLicensePlate(input.value)" ng-required="input.required" placeholder="Digite a placa do carro" maxlength="8" />' +
                      '<label ng-if="input.value && vm.isLicensePlateInValid(input.value)" class="label-error">Digite uma placa valida nos padroes ABC1234 ou ABC1D23.</label>'
                    );
                    break;
                case 'hour':
                    el.append('<uib-timepicker ng-model="input.value" ng-required="input.required" show-spinners="false"></uib-timepicker>');
                    break;
                case 'hidden':
                    el.append('<input type="hidden" ng-model="input.value"/>');
                    break;
                case 'date':
                    var html = '<div class="input-group">' +
                    '<input type="text" class="form-control" name="formDate" ng-model="input.value" uib-datepicker-popup="dd/MM/yyyy" is-open="input.activeDate" ng-click="input.activeDate=true" ng-required="input.required">' +
                    '<span class="input-group-addon">' +
                    '<a href="" ng-click="input.activeDate=!input.activeDate"><span class="fa fa-calendar"></span></a>' +
                    '</span>' +
                    '</div>' +
                    '<label ng-if="vm.isDateInValid(input.value)" class="label-error">Coloque uma data valida!</label>';
                    el.append(html);
                    break;
                case 'checkbox':
                    el.append('<input type="checkbox" ng-model="input.value"/>');
                    break;
                }
                $compile(el)(scope);
                element.append(el);
            }
        };
    }

    angular
            .module('b2c_ingressos')
            .factory('ProductDialog', productDialog);

    /** @ngInject */
    function productDialog($uibModal, MyFunctions, BackEnd, ErrorHandler) {
        function _openProductDialog(_product, _products, _okPress, myOptions) {
            _okPress = _okPress || function(){ return true; };
            var opts = {};
            angular.merge(opts, {
                animation: true,
                templateUrl: 'app/components/productDialog/productDialog.html',
                size: 'md',
                windowTopClass: 'modal-product',
                windowClass: 'modal-product'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = _dialogsCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                product: function(){ return _product; },
                products: function(){ return _products; },
                okPress: function(){ return _okPress; }
            };
            return $uibModal.open(opts);
        }

        /** @ngInject */
        function _dialogsCtrl($uibModalInstance, product, products, okPress, Properties, moment) {
            /*jshint validthis:true */
            var vm = this;
            vm.product = product;
            vm.products = products || [];
            vm.inputs = [];
            var hasAditional = vm.product.form.filter(function(input){
                return input.contains_additional;
            });
            if (hasAditional.length) {
                BackEnd.execute({
                    method: "forms",
                    productsArray: MyFunctions.productosToString([vm.product])
                }, function (result) {
                    var forms = result.filter(function (f) {
                        return f.path == vm.product.path;
                    });
                    if (forms.length > 0)
                        vm.product.form = Object.values(forms[0].form);
                    load();
                },
                    ErrorHandler.showError);
            } else
                load();

            function load() {
                angular.forEach(vm.product.form, function (input) {
                    if (Properties.formNotUsedLastValue) delete input.value;
                    if (input.type === 'license_plate' && input.value) {
                        input.value = vm.normalizeLicensePlate(input.value);
                    }
                    if (input.contains_additional) {
                        input.onChange = function () {
                            if (input.additionalInput) {
                                input.additionalInput.value = null;
                                var additionals = input.values.filter(function (v) { return v.value == input.value });
                                if (additionals.length > 0)
                                    input.additionalInput.value = additionals[0].additonal_value;
                            }
                        };
                        input.additionalInput = {
                            name: input.additional_name,
                            property: input.additional_property,
                            type: "text",
                            readonly: true
                        };
                    }
                    vm.inputs.push(input);
                    if (input.additionalInput) vm.inputs.push(input.additionalInput);
                });
            }

            vm.isInValid = function(){
                for (var i = 0; i < vm.inputs.length; i++) {
                    var input = vm.inputs[i];
                    if(!input.required) continue;
                    if(angular.isUndefined(input.value)) return true;
                    if(input.value === null) return true;
                    if(input.value === "")  return true;
                    if(input.type === "license_plate" && vm.isLicensePlateInValid(input.value)) return true;
                }
                return false;
            };

            vm.normalizeLicensePlate = function(value) {
                if (angular.isUndefined(value) || value === null) return value;
                return (value + '')
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, '')
                    .slice(0, 7);
            };

            vm.isLicensePlateInValid = function(value) {
                if(value === null) return true;
                if(value === "") return true;
                if(angular.isUndefined(value)) return true;

                var normalizedValue = vm.normalizeLicensePlate(value);
                var isOldPlate = /^[A-Z]{3}[0-9]{4}$/.test(normalizedValue);
                var isMercosulPlate = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(normalizedValue);

                return !(isOldPlate || isMercosulPlate);
            };


            vm.isDateInValid = function(value){

                if(value === null) return true;
                if(value === "")  return true;
                if(value === undefined)  return true;
                if (!moment(value).isValid()) return true;

                return false;
            };

            vm.close =  function(){
                var cd = product._customData || {};
                angular.forEach(vm.inputs, function(input) {
                    if(input.value) {
                        switch (input.type) {
                            case "date":
                                cd[input.property] = MyFunctions.dateToString(input.value);
                                break;
                            case "hour":
                                cd[input.property] = MyFunctions.timeToString(input.value);
                                break;
                            case "amount":
                                cd[input.property] = input.value + "";
                                break;
                            case "value":
                                cd[input.property] = input.value + "";
                                break;
                            default:
                                cd[input.property] = input.value;
                        }
                    }
                });
                product._customData = cd;
                if(okPress()) $uibModalInstance.close('OK');
            };

            vm.dismiss = function () {
                vm.product.amount = 0;
                $uibModalInstance.dismiss();
            };
        }

        function _openUpSellDialog(_product, _products, _okPress, _dimissPress, myOptions) {
            _okPress = _okPress || function(){ return true; };
            var opts = {};
            angular.merge(opts, {
                animation: true,
                templateUrl:"app/ingressos/modais/dialog-upsell-ticket.html",
                size: 'md',
                windowTopClass: 'modal-product',
                windowClass: 'modal-product'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = _dialogsUpsellCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                product: function(){ return _product; },
                products: function(){ return _products; },
                okPress: function(){ return _okPress; },
                dimissPress: function(){ return _dimissPress; }
            };
            return $uibModal.open(opts);
        }

        /** @ngInject */
        function _dialogsUpsellCtrl($uibModalInstance, product, products,  okPress, dimissPress) {
          /*jshint validthis:true */
          var vm = this;
          vm.product = product;
          vm.upsellproducts = products;

          vm.addProduct = function (newProd) {
            okPress(newProd);
            $uibModalInstance.close("OK");
          };

          vm.close = function () {
            vm.product.amount = 0;
            $uibModalInstance.dismiss();
          };

          vm.dismiss = function () {
            vm.product.amount = 1;
            okPress(vm.product);
            dimissPress(vm.product);
            $uibModalInstance.close("OK");
          };
        }

        function _needToOpen(product){
            return product.form !== null && angular.isDefined(product.form) && product.form != {} && (Array.isArray(product.form) && product.form.length > 0);
        }

        return {
            need: _needToOpen,
            open: _openProductDialog,
            upSell: _openUpSellDialog
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('b2c_ingressos')
        .factory('Usuario', UsuarioRepository);

    function UsuarioRepository($resource, Properties) {
        return $resource(Properties.serverUrl + '/usuarios/:id', {id: '@_id'}, {
            save: {method:'PUT', isArray: false}
        });
    }
})();
/**
 * @typedef {import("../../../types/properties").PropertiesType} PropertiesType
 * @typedef {import("../../../types/ingresso").IngressoType} IngressoType
 */

(function (){
  'use strict';

  angular
    .module('b2c_ingressos')
    .controller('multiTrackersController', multiTrackersController);

  /**
   * @param {PropertiesType} Properties
   * @ngInject
  */
  function multiTrackersController (Properties, Tracking, $state, $timeout, $window, MyFunctions, Cart, moment, Auth) {
    /* jshint validthis:true */
    //var vm = this;

    var trackers = Properties.trackers;
    if (!trackers) return;

    window.dataLayer = window.dataLayer || [];
    var gtag = window.gtag || function (){window.dataLayer.push(arguments);};
    $timeout(function() {start()},1000);

    function start () {
      addOptions();
      if (trackers.gTagDataLayerOnly) {
        addGTAGListeners();
        return;
      }
      _startAskSuiteChat();
      _startGoogleAnalytics();
      _startMetaPixel();
      _startTikTokAds();
      _startAskSuiteTracker();
      _startPinterestTag();
      // _setListeners();  os listeners são registrados no inclusão dos scripts
    }

    function _startGoogleAnalytics () {
      if (!trackers.google) return;

      var codes = [];

      if (typeof trackers.google === 'string') {
        codes.push(trackers.google);
      } else {
        codes = trackers.google;
      }
      var hasGTM = false;
      var hasGTAG = false;
      codes.forEach(function (code){
        if (code.match(/^(g|aw|ua)-.+$/i)) {
          _createGoogleGTag(code);
          hasGTAG = true;
        }
        if (code.match(/^gtm-.+$/i)) {
          _createGoogleGTMTag(code);
          hasGTM = true;
        }
      });
      if(hasGTM) addGTMListeners();
      if(hasGTAG) addGTAGListeners();

    }

    function _startMetaPixel () {
      var ids = trackers.meta || trackers.facebook;
      if (!ids) { return; }
      var codes = [];

      if(ids === true) { /// para casos do meta pixel sendo inserido pelo GTM
        addMetaListeners();
        return;
      }
      if (typeof ids === 'string') {
        codes.push(ids);
      } else {
        codes = ids;
      }

      codes.forEach(function (id){
        var scriptTag = document.createElement('script');

        scriptTag.innerHTML = "!function(f,b,e,v,n,t,s)\n" +
          "{if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n" +
          "n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n" +
          "if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n" +
          "n.queue=[];t=b.createElement(e);t.async=!0;\n" +
          "t.src=v;s=b.getElementsByTagName(e)[0];\n" +
          's.parentNode.insertBefore(t,s)}(window, document,\'script\',\n' +
          '\'https://connect.facebook.net/en_US/fbevents.js\');\n' +
          'fbq(\'init\', \'' + id + '\');' +
          'fbq(\'track\', \'PageView\');';

        document.head.append(scriptTag);
      });

      // console.debug('Iniciado Meta Pixel: ' + id);
      addMetaListeners();
    }

    function _startAskSuiteChat () {
      if (!trackers.askSuiteChat) { return; }

      var scriptTag = document.createElement('script');
      scriptTag.id = 'script-infochat';
      scriptTag.src = 'https://cdn.asksuite.com/infochat.js?dataConfig=https://control.asksuite.com/api/companies/'
        + trackers.askSuiteChat;

      document.body.append(scriptTag);
      // console.debug('Iniciado AskSuite Chat');
    }

    function _startAskSuiteTracker () {
      if (!trackers.askSuiteTracker) { return; }
      $window.trackingAskSuites = function (data) {
        setTimeout(function(){
          window.dataLayer.push(data);
        }, 1000);
      }
      var scriptTag = document.createElement('script');
      scriptTag.src = 'https://pixel.asksuite.com/asktag.js';
      document.body.append(scriptTag);
      // console.debug('Iniciado AskSuite Tracker');

      //askSuites     //TODO: Possobilitar enviar para a asksuites apenas as vendas com a agencia da asksuites
      Tracking.addListener(Tracking.types.Buy, function (data) {
        $window.trackingAskSuites({
          ecommerce: {
            currencyCode: 'BRL',
            purchase: {
              actionField: {
                id: 'TC' + data.id,
                revenue: data.value / 100,
                tax: '0',
                shipping: '0',
                affiliation: '',
                coupon: ''
              },
              products: _askSuiteProductsToItems(data.products)
            }
          }
        });
      });
    }

    function _startTikTokAds () {
      var id = trackers.tikTokAds;
      if (!id) { return; }

      var scriptTag = document.createElement('script');

      scriptTag.innerHTML = '!function(w,d,t){' +
        'w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=[\'page\',\'track\',\'identify\',\'instances\',\'debug\',\'on\',\'off\',\'once\',\'ready\',\'alias\',\'group\',\'enableCookie\',\'disableCookie\'],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i=\'https://analytics.tiktok.com/i18n/pixel/events.js\';ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement(\'script\');o.type=\'text/javascript\',o.async=!0,o.src=i+\'?sdkid=\'+e+\'&lib=\'+t;var a=document.getElementsByTagName(\'script\')[0];a.parentNode.insertBefore(o,a)};' +
        'ttq.load(\'' + id + '\');' +
        'ttq.page();' +
        '}(window,document,\'ttq\');';

      document.body.append(scriptTag);
      // console.debug('Iniciado TikTokAds: ' + id);
      addTikTokAddListeners();
    }

    function _startPinterestTag () {
      var id = trackers.pinterest;
      if (!id) { return; }

      var scriptTag = document.createElement('script');

      scriptTag.innerHTML = "!function(e){if(!window.pintrk){window.pintrk = function () {"
      + "window.pintrk.queue.push(Array.prototype.slice.call(arguments))};"
      + "var n=window.pintrk;n.queue=[],n.version=\"3.0\";"
      + "var t=document.createElement(\"script\");t.async=!0,t.src=e;"
      + "var r=document.getElementsByTagName(\"script\")[0];"
      + "r.parentNode.insertBefore(t,r)}}(\"https://s.pinimg.com/ct/core.js\");"
      + "pintrk('load', '" + id + "', {em: '<user_email_address>'});"
      + "pintrk('page');";

      document.body.append(scriptTag);
      // console.debug('Iniciado Pinterest Tag: ' + id);
      addPinterestListeners();
    }

    function _createGoogleGTag (gCode) {
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + gCode;
      document.head.append(script);
      window.gtag = gtag;
      gtag('js', new Date());

      var utmParams = new URLSearchParams(window.location.search);

      gtag('config', gCode, {
        campaignSource: utmParams.get('utm_source') || undefined,
        campaignMedium: utmParams.get('utm_medium') || undefined,
        campaignName: utmParams.get('utm_campaign') || undefined,
        campaignContent: utmParams.get('utm_content') || undefined
      });
      // console.debug('Iniciado GTAG: ' + gCode);
    }

    function _createGoogleGTMTag (gtmCode) {

      var scriptHeadTag = document.createElement('script');

      scriptHeadTag.innerText = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n' +
        'new Date().getTime(),event:\'gtm.js\'});' +
        'var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!==\'dataLayer\'?\'&l=\'+l:\'\';' +
        'j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;' +
        'f.parentNode.insertBefore(j,f);' +
        '})(window,document,\'script\',\'dataLayer\',\''+gtmCode+'\');';

      var noscriptBodyTag = document.createElement('noscript');
      var iframeTag = document.createElement('iframe');

      iframeTag.src = 'https://www.googletagmanager.com/ns.html?id=' + gtmCode;

      noscriptBodyTag.append(iframeTag);
      document.body.append(noscriptBodyTag);
      document.head.append(scriptHeadTag);
      // console.debug('Iniciado GTM: ' + gtmCode);
    }

    /* movido para a inclusão dos scripts
    function _setListeners () {
      //Google
      var hasGTag = !!trackers.google;
      if (hasGTag) addGTAGListeners();

      // Facebook/Meta
      var hasMeta = !!trackers.meta || !!trackers.facebook;
      if (hasMeta) addMetaListeners();
    }
    */


    // documentação https://developers.google.com/analytics/devguides/collection/ga4/reference/events
    function addGTAGListeners() {
      var lastState = $state.current.url;
      Tracking.addListener(Tracking.types.PageView, function () {
        if (lastState === $state.current.url) {
          return;
        }
        lastState = $state.current.url;
        gtag('event', 'screen_view', {
          'screen_name': lastState
        });
      });
      Tracking.addListener(Tracking.types.ShowProducts, function (products, date) {
        gtag('event', 'view_item_list', {
          items: _googleProductsToItems(products, date)
        });
      });

      Tracking.addListener(Tracking.types.Login, function (user) {
        gtag('event', 'login', { user_id: user ? user.id : "" });
      });

      Tracking.addListener(Tracking.types.AddToCart, function (product) {
        gtag('event', 'view_item', {
          currency: 'BRL',
          value: (product.amount * product.value) / 100,
          items: [_googleProductToItem(product)]
        });
        gtag('event', 'add_to_cart', {
          currency: 'BRL',
          value: (product.amount * product.value) / 100,
          items: [_googleProductToItem(product)]
        });
      });
      Tracking.addListener(Tracking.types.RemoveFromCart, function (product) {
        gtag('event', 'remove_from_cart', {
          currency: 'BRL',
          value: product.value / 100,
          items: [_googleProductToItem(product)]
        });
      });

      Tracking.addListener(Tracking.types.showCart, function (data) {
        gtag('event', 'begin_checkout', addCustomData({
          currency: 'BRL',
          value: Number(Cart.getTotalValue()) / 100,
          items: _googleProductsToItems(data)
        }));
      });
      Tracking.addListener(Tracking.types.Buy, function (data) {
        var value = (data.value) / 100;
        gtag('event', 'purchase', addCustomData({
          transaction_id: data.id,
          value: value,
          currency: 'BRL',
          items: _googleProductsToItems(data.products)
        }));
      });

      // HOTÉIS
      var lastItem = "";
      Tracking.addListener(Tracking.types.SearchDate, function (result) {
        var items = [];
        angular.forEach(result, function(h){
          items.push(_googleHotelToItem(h.result[0]));
        });
        //var item = _googleHotelToItem(result[0].result[0]);
        if(lastItem == JSON.stringify(items[0])) return;
        lastItem = JSON.stringify(items[0]);
        gtag('event', 'view_item_list', {
          items: items
        });
      });
      Tracking.addListener(Tracking.types.ShowHotel, function (result) {
        var items = [];
        angular.forEach(result.result,function(uh){
          items.push(_googleHotelToItem(uh));
        })
        gtag('event', 'view_item', {
          currency: 'BRL',
          value: result.result[0].value / 100,
          items: items
        });
      });
      Tracking.addListener(Tracking.types.SelectHotel, function (result) {
        gtag("event", "begin_checkout", addCustomData({
          currency: "BRL",
          value: result.result[0].value / 100,
          items: [_googleHotelToItem(result.result[0])],
        }));
      });
      Tracking.addListener(Tracking.types.SelectUH, function (result) {
        gtag("event", "add_to_cart", {
          currency: "BRL",
          value: result.value / 100,
          items: [_googleHotelToItem(result)],
        });
      });
      Tracking.addListener(Tracking.types.BuyReservations, function () {
        gtag("event", "login", {
          method: "Identificação"
        });
      });
      Tracking.addListener(Tracking.types.CheckoutReservations, function (data) {
        var items = [];
        var total = 0.0;
        var discountValue = null;
        for (var i = 0; i < data.length; i++) {
          var r = data[i];
          if (
            r.webGateway === "pix" &&
            r.paymentMethodsAdjustments.length > 0 &&
            Properties.registraDescontoPixGTM
          ) {
            r.paymentMethodsAdjustments.forEach(function (element) {
              if (element.paymentTypes.includes("pix")) {
                discountValue = element.value;
              }
            });
          }
          items.push({
            item_id: "R" + r.id,
            item_name: r.hotelName,
            price: parseInt(discountValue || r.value, 10) / 100,
            currency: "BRL",
            quantity: 1,
          });
          total += parseInt(discountValue || r.value, 10) / 100;
        }
        gtag('event', 'purchase', addCustomData({
          transaction_id: 'R' + data[0].id,
          value: total,
          currency: 'BRL',
          items: items
        }));
      });
    }

    function addGTMListeners() {
      function sendEvent(tipo, name, obj){
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
          event: name,
          ecommerce: obj
        });
      }
      /*var lastState = $state.current.url;
      Tracking.addListener(Tracking.types.PageView, function () {
        if (lastState === $state.current.url) {
          return;
        }
        lastState = $state.current.url;
        sendEvent('event', 'screen_view', {
          'screen_name': lastState
        });
      });*/
      Tracking.addListener(Tracking.types.ShowProducts, function (products, date) {
        sendEvent('event', 'view_item_list', {
          items: _googleProductsToItems(products, date)
        });
      });

      Tracking.addListener(Tracking.types.Login, function (user) {
        sendEvent('event', 'login' , addCustomData({
          user_id: user ? user.id : ""
        }));
      });

      Tracking.addListener(Tracking.types.AddToCart, function (product) {
        sendEvent('event', 'view_item', {
          currency: 'BRL',
          value: (product.amount * product.value) / 100,
          items: [_googleProductToItem(product)]
        });
        sendEvent('event', 'add_to_cart', {
          currency: 'BRL',
          value: (product.amount * product.value) / 100,
          items: [_googleProductToItem(product)]
        });
      });
      Tracking.addListener(Tracking.types.RemoveFromCart, function (product) {
        sendEvent('event', 'remove_from_cart', {
          currency: 'BRL',
          value: product.value / 100,
          items: [_googleProductToItem(product)]
        });
      });

      Tracking.addListener(Tracking.types.showCart, function (data) {
        sendEvent('event', 'begin_checkout', addCustomData({
          currency: 'BRL',
          value: Number(Cart.getTotalValue()) / 100,
          items: _googleProductsToItems(data)
        }));
      });
      Tracking.addListener(Tracking.types.Buy, function (data) {
        var value = (data.value) / 100;
        sendEvent('event', 'purchase', addCustomData({
          transaction_id: data.id,
          value: value,
          currency: 'BRL',
          items: _googleProductsToItems(data.products)
        }));
      });

      // HOTÉIS
      var lastItem = "";
      Tracking.addListener(Tracking.types.SearchDate, function (result) {
        var items = [];
        angular.forEach(result, function(h){
          items.push(_googleHotelToItem(h.result[0]));
        });
        //var item = _googleHotelToItem(result[0].result[0]);
        if(lastItem == JSON.stringify(items[0])) return;
        lastItem = JSON.stringify(items[0]);
        sendEvent('event', 'view_item_list', {
          items: items
        });
      });
      Tracking.addListener(Tracking.types.ShowHotel, function (result) {
        var items = [];
        angular.forEach(result.result,function(uh){
          items.push(_googleHotelToItem(uh));
        })
        sendEvent('event', 'view_item', {
          currency: 'BRL',
          value: result.result[0].value / 100,
          items: items
        });
      });
      Tracking.addListener(Tracking.types.SelectHotel, function (result) {
        sendEvent("event", "begin_checkout", addCustomData({
          currency: "BRL",
          value: result.result[0].value / 100,
          items: [_googleHotelToItem(result.result[0])],
        }));
      });
      Tracking.addListener(Tracking.types.SelectUH, function (result) {
        sendEvent("event", "add_to_cart", {
          currency: "BRL",
          value: result.value / 100,
          items: [_googleHotelToItem(result)],
        });
      });
      Tracking.addListener(Tracking.types.BuyReservations, function () {
        sendEvent("event", "login", {
          method: "Identificação"
        });
      });

      Tracking.addListener(Tracking.types.CheckoutReservations, function (data) {
        var items = [];
        var total = 0.0;
        var discountValue = null;
        for (var i = 0; i < data.length; i++) {
          var r = data[i];
          if (
            r.webGateway === "pix" &&
            r.paymentMethodsAdjustments.length > 0 &&
            Properties.registraDescontoPixGTM
          ) {
            r.paymentMethodsAdjustments.forEach(function (element) {
              if (element.paymentTypes.includes("pix")) {
                discountValue = element.value;
              }
            });
          }
          items.push({
            item_id: "R" + r.id,
            item_name: r.hotelName,
            price: parseInt(discountValue || r.value, 10) / 100,
            currency: "BRL",
            quantity: 1,
          });
          total += parseInt(discountValue || r.value, 10) / 100;
        }
        sendEvent('event', 'purchase', addCustomData({
          transaction_id: 'R' + data[0].id,
          value: total,
          currency: 'BRL',
          items: items
        }));
      });
    }

    function addTikTokAddListeners () {
      Tracking.addListener(Tracking.types.AddToCart, function (product) {
        ttq.track('AddToCart', {
          content_id: product.id,
          content_name: product.name,
          content_category: product.category,
          content_type: 'product',
          value: (product.amount * product.value) / 100,
          currency: 'BRL'
        });
      });
      Tracking.addListener(Tracking.types.showCart, function (data) {
        var content_ids = [];
        var value = 0;
        data.forEach(function (product) {
          content_ids.push(product.id);
          value += (product.amount * product.value) / 100;
        });
        ttq.track('InitiateCheckout', {
          content_ids: content_ids,
          content_type: 'product',
          value: value,
          currency: 'BRL'
        });
      });
      Tracking.addListener(Tracking.types.ShowProducts, function (products, date) {
        var content_ids = [];
        var value = 0;
        products.forEach(function (product) {
          content_ids.push(product.id);
          value += (product.amount * product.value) / 100;
        });
        ttq.track('ViewContent', {
          content_ids: content_ids,
          content_type: 'product',
          value: value,
          currency: 'BRL',
          date: date
        });
      });
      Tracking.addListener(Tracking.types.Login, function (data) {
        ttq.track('CompleteRegistration', {
          content_name: data.name,
          currency:"BRL",
          status: true,
          value: Cart.getTotalValue() / 100
        });
      });
      Tracking.addListener(Tracking.types.Buy, function (data) {
        ttq.track('Purchase', {
          content_id: data.id,
          content_name: 'Compra',
          content_type: 'product',
          value: (data.value) / 100,
          currency: 'BRL'
        });
      });
    }

    function addMetaListeners() {
      // Tracking Conversão Facebook
      // Produtos https://developers.facebook.com/docs/meta-pixel/reference?locale=pt_BR#object-properties
      // Especifica da parte de hotel https://developers.facebook.com/docs/marketing-api/hotel-ads/events/?locale=pt_BR
      function _fbq (event, name, obj){
        var fbq = $window.fbq || function () {};
        fbq(event, name, obj);
      }
      var lastState = $state.current.url;
      Tracking.addListener(Tracking.types.PageView, function () {
        if (lastState === $state.current.url) return;
        lastState = $state.current.url;
        //_fbq('track', 'PageView');
      });
      Tracking.addListener(Tracking.types.ShowProducts, function (products, date) {
        var item = _facebookProducts(products);
        item.search_string = date
        _fbq('track', 'Search', item);
      });
      Tracking.addListener(Tracking.types.Login, function (data) {
        _fbq('track', 'CompleteRegistration', {
          content_name: data.name,
          currency:"BRL",
          status: true,
          value: Cart.getTotalValue() / 100
        });
      });
      Tracking.addListener(Tracking.types.AddToCart, function (product) {
        _fbq('track', 'AddToCart', _facebookProducts([product]));
      });
      Tracking.addListener(Tracking.types.showCart, function (data) {
        _fbq('track', 'InitiateCheckout', _facebookProducts(data));
      });
      Tracking.addListener(Tracking.types.Buy, function (data) {
        var content = _facebookProducts(data.products);
        content.value = parseInt(data.value, 10) / 100;
        content.order_id = data.id;
        _fbq('track', 'Purchase', content);
      });

      var lastItem = "";
      Tracking.addListener(Tracking.types.SearchDate, function (result) {
        var item = _facebookHotelItem(result[0].result[0]);
        if(lastItem == JSON.stringify(item)) return;
        lastItem = JSON.stringify(item);
        // This sample assumes the FB Pixel base code is already loaded
        _fbq('track', 'Search', item);
      });

      /*
      Tracking.addListener(Tracking.types.ShowHotel, function (result) {
           _fbq('track', 'ShowHotel' , _facebookHotelItem(result.result[0]));
      });
      */
      Tracking.addListener(Tracking.types.SelectHotel, function (result) {
        _fbq('track', 'ViewContent', _facebookHotelItem(result.result[0]));
      });

      Tracking.addListener(Tracking.types.SelectUH, function (result) {
        _fbq('track', 'InitiateCheckout', _facebookHotelItem(result));
      });

      Tracking.addListener(Tracking.types.BuyReservations, function (result) {
        _fbq('track', 'CompleteRegistration', _facebookHotelItem(result));
      });

      Tracking.addListener(Tracking.types.CheckoutReservations, function (data) {
        var contents = [];
        var total = 0.0;
        var discountValue = null;
        for (var i = 0; i < data.length; i++) {
          var r = data[i];
           if (
             r.webGateway === "pix" &&
             r.paymentMethodsAdjustments.length > 0 && Properties.registraDescontoPixGTM
           ) {
             r.paymentMethodsAdjustments.forEach(function (element) {
               if (element.paymentTypes.includes("pix")) {
                 discountValue = element.value;
               }
             });
           }
          contents.push({
            id: "R" + r.id,
            quantity: 1,
            item_price: parseInt(discountValue || r.value, 10) / 100,
          });
          total += parseInt(discountValue || r.value, 10) / 100;
        }
        _fbq('track', 'Purchase', {
          value: total,
          currency: 'BRL',
          contents: contents,
          content_type: 'product'
        });
      });
    }

    function addPinterestListeners () {
      Tracking.addListener(Tracking.types.PageView, function () {
        pintrk('track', 'pagevisit');
      });
      Tracking.addListener(Tracking.types.AddToCart, function (product) {
        pintrk('track', 'addtocart', {
          value: (product.amount * product.value) / 100,
          currency: 'BRL',
          content_id: product.id,
          content_name: product.name,
          content_category: product.category,
          content_type: 'product'
        });
      });
      Tracking.addListener(Tracking.types.ShowProducts, function (products) {
        var content_ids = [];
        var value = 0;
        products.forEach(function (product) {
          content_ids.push(product.id);
          value += (product.amount * product.value) / 100;
        });
        pintrk('track', 'viewcontent', {
          value: value,
          currency: 'BRL',
          content_ids: content_ids,
          content_type: 'product'
        });
      });
      Tracking.addListener(Tracking.types.Login, function (data) {
        pintrk('track', 'signup', {
          content_name: data.name,
          currency:"BRL",
          status: true,
          value: Cart.getTotalValue() / 100
        });
      });
      Tracking.addListener(Tracking.types.showCart, function (data) {
        var content_ids = [];
        var value = 0;
        data.forEach(function (product) {
          content_ids.push(product.id);
          value += (product.amount * product.value) / 100;
        });
        pintrk('track', 'checkout', {
          value: value,
          currency: 'BRL',
          content_ids: content_ids,
          content_type: 'product'
        });
      });
      Tracking.addListener(Tracking.types.Buy, function (data) {
        var content_ids = [];
        var value = 0;
        data.products.forEach(function (product) {
          content_ids.push(product.id);
          value += (product.amount * product.value) / 100;
        });
        pintrk('track', 'checkout', {
          value: value,
          currency: 'BRL',
          content_ids: content_ids,
          content_type: 'product'
        });
      });
    }

    function _facebookProducts(products) {
      var r = {
        value: 0,
        currency: "BRL",
        content_ids: [],
        contents: [],
        content_type: "product",
        num_items: 1,
      };
      if(products == null || angular.isUndefined(products) || products.length == 0)
        return r;
      r.num_items = products.length;
      for (var i = 0; i < products.length; i++) {
        var product = products[i];
        r.content_ids.push(product.id);
        var item = {
          id: product.id,
          quantity: Number(product.amount || 1),
          content_name: product.name, //obrigatorio
          content_type: product.years || "default",
          value: parseInt(product.value, 10) / 100,
          currency: "BRL",
        };
        r.contents.push(item);
        r.value = r.value + (item.value * item.quantity);
      }
      return r;
    }

    function _facebookHotelItem(hotel) {
      var checkin = MyFunctions.stringToDate(hotel.checkin);
      var checkout = MyFunctions.addDays(checkin, hotel.modulesAmount);
      var cidade = "Brasil";
      var uf = cidade;
      if (hotel.customData && hotel.customData.destino) {
        cidade = hotel.customData.destino.split("/")[0];
        uf = hotel.customData.destino.split("/")[1];
      }
      var item = {
        // Fire the 'Search' event on the search results page
        // IF YOU CHOOSE NOT TO USE A RECOMMENDED PARAM, THEN REMOVE IT, DON'T LEAVE IT EMPTY
        // REQUIRED: DO NOT change this, must be set to 'hotel'
        content_type: 'hotel',
        // HIGHLY RECOMMENDED: checkin date
        // Allows you to target people based on their travel dates (using a booking window)
        // Improves the landing experience with travel dates filled in (using template tags)
        // use YYYYMMDD, YYYY-MM-DD, YYYY-MM-DDThh:mmTZD or YYYY-MM-DDThh:mm:ssTZD
        checkin_date: moment(checkin).format("YYYY-MM-DD"),
        // HIGHLY RECOMMENDED: checkout date
        // use YYYYMMDD, YYYY-MM-DD, YYYY-MM-DDThh:mmTZD or YYYY-MM-DDThh:mm:ssTZD
        checkout_date: moment(checkout).format("YYYY-MM-DD"),
        // RECOMMENDED: content ids - include eg top 5 search results
        //content_ids: '["1"]',
        // REQUIRED: city, don't use abbreviations
        city: cidade,
        // REQUIRED: region, don't use abbreviations
        region: uf,
        // REQUIRED: country, don't use abbreviations
        country: 'Brasil',
        // RECOMMENDED: number of adults
        // num_adults: hotel._adultos,
        // RECOMMENDED: number of children
        // num_children: hotel._chd
      };
      if(hotel._adultos) item.num_adults = hotel._adultos;
      if(hotel._chd) item.num_children = hotel._chd;
      return item;
    }

    function _googleHotelToItem(hotel) {
      var checkin = MyFunctions.stringToDate(hotel.checkin);
      var checkout = MyFunctions.addDays(checkin, hotel.modulesAmount);
      var cidade = 'Brasil';
      var uf = cidade;
      if (hotel.customData && hotel.customData.destino) {
        cidade = hotel.customData.destino.split('/')[0];
        uf = hotel.customData.destino.split('/')[1];
      }

      return {
        item_id: hotel.itemPath,
        item_name: hotel.hotelName,
        price: hotel.value / 100,
        currency: 'BRL',
        item_category: hotel.service,

        // propriedades personalizadas
        hotel_checkin_date: moment(checkin).format('YYYY-MM-DD'),
        hotel_checkout_date: moment(checkout).format('YYYY-MM-DD'),
        hotel_city: cidade,
        hotel_region: uf
      };

    }
    function _googleProductToItem (product, date) {
      return {
        item_id: product.id, //obrigatorio
        item_name: product.name, //obrigatorio
        item_variant: product.years || "default",
        price: product.value / 100,
        currency: 'BRL',
        item_category: product.type,
        item_list_id: product.category,
        item_list_name: product.category,
        item_category2 : angular.isDefined(product.faixaetaria) ? product.faixaetaria : "",
        item_category3 : (angular.isDefined(product.date) ? MyFunctions.dateToString(product.date) : date),
        quantity: Number(product.amount || 1)
      };
    }
    function _askSuiteProductToItem (product) {
      return {
        id: product.id,
        name: product.name,
        price: (product.value) / 100,
        category: product.type,
        quantity: Number(product.amount)
      };
    }

    function _googleProductsToItems (products, date) {
      if(products == null || angular.isUndefined(products)) return [];
      return products.map(function (p) {
        return _googleProductToItem(p, date);
      });
    }
    function _askSuiteProductsToItems (products) {
      if(products == null || angular.isUndefined(products)) return [];
      return products.map(function (p) {
        return _askSuiteProductToItem(p);
      });
    }

    // function _cartTotal (products) {
    //   var total = 0;
    //   products.forEach(function (p){
    //     var value = Number(p.value) * Number(p.amount);
    //     total += value;
    //   });
    //   return (total) / 100;
    // }

    function addCustomData (eventData) {
      if (!trackers.options) return eventData;
      var user = Auth.getUser();
      if (trackers.options.ga4GuestData && user) {
        eventData.guestData = {
          id: user.id,
          name: user.name,
          phone: user.cellPhone || user.phone,
          email: user.email,
          zipCode: user.zipCode,
          cpf: user.cpf,
          mailing: user.mailing,
          birthDate: user.birth
        };
      }
      return eventData;
    }

    function addOptions () {
      if (!trackers.options) return;
      if (trackers.options.askSuiteDisableGaSpy) {
        window.AskPixelObject = { options: { disableGaSpy: true } };
      }
    }
  }
})();

/**
 * Created by Danillo on 27/06/2016.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('MenuController', MenuController);

    /** @ngInject */
    function MenuController($state, $scope, ScrollTo, Auth, Properties, $log, $location, localStorageService, $filter) {
        var vm = this;
        vm.isCollapsed = false;
        vm.autoHideMenu = !(Properties.disableHideMenu);

        var parameters = $location.search();
        if (angular.isDefined(parameters.agency) && parameters.agency.length > 0) {
            localStorageService.cookie.set("agency", parameters.agency, 0.2);
        } else {
            localStorageService.cookie.remove("agency");
        }
        var cookieTime = Properties.cookieAgencyTime || 2; 
        var bA = null;
        if (angular.isDefined(parameters.bookingagency) && parameters.bookingagency.length > 0) {
            bA = parameters.bookingagency;
        }
        if (angular.isDefined(parameters.bookingAgency) && parameters.bookingAgency.length > 0) {
            bA = parameters.bookingAgency;
        }
        if(bA != null){
            if (Array.isArray(bA)) bA = bA[0];            
            localStorageService.cookie.set("bookingAgency", bA, cookieTime);
        }
        if (angular.isDefined(parameters.cupom) && parameters.cupom.length > 0) {
            var c = parameters.cupom;
            if (Array.isArray(c)) c = c[0];
            localStorageService.set("cupom", c, cookieTime);
        } else {
            var cupomFromStorage = localStorageService.get("cupom");
            if (cupomFromStorage !== null || angular.isDefined(cupomFromStorage)) {
                localStorageService.remove("cupom");
            }
        }
        if (angular.isDefined(parameters.clientId) && parameters.clientId.length > 0) {
            localStorageService.set("partnerClientId", parameters.clientId);
        }
        if (angular.isDefined(parameters.influencer) && parameters.influencer.length > 0 &&
            angular.isDefined(parameters.influencertoken) && parameters.influencertoken.length > 0) {
                Auth.setSalesInfluencer(parameters.influencer, parameters.influencertoken);
        }
        var ingToken = null;
        if (angular.isDefined(parameters.ingToken) && parameters.ingToken.length > 0) {
            ingToken = parameters.ingToken;
            localStorageService.cookie.set("ingToken", parameters.ingToken, 1 / 48 /* 30 minutos */); // tornar esse tempo parametrizado.
            angular.forEach(vm.opcoes, function(s) {
                s.name2 = s.name + "({ingToken: '" + parameters.ingToken + "'})";
            });
        } else {
            localStorageService.cookie.remove("ingToken");
        }

        vm.opcoes = [];

        angular.forEach($state.get(), function (state) {
            if (state.data && state.data.neverShow)
                return;
            if (Properties.disableStates.indexOf(state.name) >= 0)
                return;
            if(ingToken)
                state.name2 = state.name + "({ingToken: '" + ingToken + "'})";
            if (state.name)
                vm.opcoes.push(state);
        });
        vm.auth = Auth;
        vm.logoff = function () {
            Auth.logout();
            if(ingToken && Properties.defaultState)
                $state.go(Properties.defaultState, {ingToken: ingToken });
            else
                $location.path("/");
        };
        vm.scrollTo = ScrollTo.scrollTo;

        vm.normalizeLink = function (state) {
            if (angular.isUndefined(state)){
                return;
            }
            if (state.name === "cadastrar" && vm.auth.isLoggedIn()){
                return "Cadastro";
            }
            if (state.name === "hospedagemPesquisa") {
                return "Hospedagem";
            }
            if (state.name === "login") {
                return "Minhas Compras";
            }

            return $filter('capitalize')(state.name);
        };

        vm.lojasAgencies = Properties.lojasAgencies || [];
        vm.selectedAgency = localStorageService.get("_lojaAgency") || 'serragaucha';
        vm.selectAgency = function (agency) {
            vm.lastDate = undefined;
            var lojaAgency = Properties.lojasAgencies.find(function (loja) {
                return loja.url === agency;
            });
            Properties.isBarraBuscaOpen = vm.barraBuscaOpenned;
            if (!vm.lastDate) {
                Properties.selecionarDataAoSairDaVitrine = true;
            }
            vm.isCollapsed = false;
            $state.go(lojaAgency ? lojaAgency.nome : 'ingressos');
        }
        vm.isLojaAgencyEscondida = function () {
            var lojasEscondidas = Properties.lojasAgenciesEscondidas;
            if (!Array.isArray(lojasEscondidas)) {
                return false;
            }
            var url = String($state.current.url);
            url = url.replace(/^\//, '');
            url = url.replace(/\?.*$/, '');
            return lojasEscondidas.includes(url);
        }

        /*var id = null;
        $scope.$watch('vm.isCollapsed', function () {
            if (vm.isCollapsed && vm.autoHideMenu) {
                id = setTimeout(function () {
                    id = null;
                    vm.isCollapsed = false;
                }, 4500);
            } else if(id)
              clearTimeout(id)
        });*/
    }
})();

(function() {
    'use strict';

    angular
        .module('b2c_ingressos')
        .factory('MyFunctions', MyFunctions);

    function MyFunctions(moment, BackEnd, ErrorHandler, Properties, Dialogs) {
        function stringToDate(strDate) { // "01/10/2020" = "01/01/20"
            if (strDate === null || angular.isUndefined(strDate))
                return null;
            var d = moment(strDate, ['DD/MM/YYYY', 'DD/MM/YY', 'YYYY-MM-DD'], true);
            if(d.isValid())
                return d.toDate();
            // deprecated   (retirar quando não for mais necessário)
            var dateParts = strDate.split("/");
            if (dateParts[2].length == 2)
                dateParts[2] = "20" + dateParts[2];
            return new Date(parseInt(dateParts[2], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[0], 10));
        }

        function dateToString(date) {
            if (angular.isUndefined(date) || date === null)
                return null;
            var month = (date.getMonth() + 1) + "";
            if (month.length == 1)
                month = "0" + month;
            var day = date.getDate() + "";
            if (day.length == 1)
                day = "0" + day;
            return day + "/" + month + "/" + date.getFullYear();
        }
        function timeToString(date) {
            if (angular.isUndefined(date) || date === null)
                return null;
            return moment(date).format("HH:mm A");
        }
        function timesToString(date){
            if (angular.isUndefined(date) || date === null)
                return null;
            return moment(date).format("HH:mm");
        }
        function productosToString(products) {
            var result = [];
            if(angular.isDefined(products) && products !== null) {
                var withToken = products.length < 6; //inibi o envio do token quando a quantidade de produtos é alta para não estourar o tamanho da mensagem.
                for (var i = 0; i < products.length; i++) {
                    var p = products[i];
                    if (p.amount <= 0) continue;
                    var product = {
                        path: ((p.type == "Combo" ? "productCombos/" : "products/") + p.id),
                        date: dateToString(p.date),
                        amount: p.amount + "",
                    };
                    if(angular.isDefined(p.schedule) && p.schedule !== null && p.schedule !== "")
                        product.schedule = p.schedule;
                    if(p.products != null && angular.isDefined(p.products)) {
                        var schedules = [];

                        for (var j = 0; j < p.products.length; j++) {
                            var p2 = p.products[j];

                            if(angular.isDefined(p2.schedule) && p2.schedule !== null) {
                              var a = { path: p2.path, schedule: p2.schedule };
                              if (p2._date) a.date = p2._date;
                              schedules.push(a);
                            } else if (p2._date) {
                                product.children = product.children || [];
                                product.children.push({ "path": p2.path, "date": p2._date });
                            }
                        }
                        if(schedules.length > 0) product.schedules = schedules;
                    }

                    if(p._children != null && angular.isDefined(p._children) && p._children.length > 0){
                        var children = [];
                        for (var m = 0; m < p._children.length; m++) {
                            var c = p._children[m];
                            children.push({ "path": c.path, "date": dateToString(c._date) });
                        }
                        product.children = children;
                    }
                    if(product.children) {
                      angular.forEach(product.children, function(child) { // seleciona data do produto igual a menor dos filhos
                        if (child.date && child.date !== null && stringToDate(product.date) > stringToDate(child.date)) {
                            product.date = child.date;
                        }
                      });
                    }
                    if(angular.isDefined(p.frete) && p.frete !== null)
                        product.frete = p.frete;
                    if(withToken && angular.isDefined(p.token) && p.token !== null && p.token !== "")
                        product.token = p.token;
                    if (p.type == "Combo" && angular.isDefined(p.categories) && p.categories !== null && p.categories.length !== 0) {
                        var categories = [];
                        p.categories.forEach(function(cat){
                            var options = cat.options.filter(function(o){return o.selected});
                            if(options.length <= 0) return;
                            var ps = [];
                            options.forEach(function(o){
                                ps.push({
                                    "path": o.path,
                                    "date": p.date ? dateToString(p.date): null,
                                });
                            });
                            categories.push({
                                "tag": cat.name,
                                "products": ps
                            });
                        });
                        /*var categories = {};
                        for (var k = 0; k < p.categories.length; k++) {
                            var categoryProducts = [];
                            for (var l = 0; l < p.categories[k].options.length; l++) {
                                categoryProducts.push({
                                    path: "products/" + p.categories[k].options[l].id
                                });
                            }
                            categories[p.categories[k].name] = categoryProducts;
                        }*/
                        product.categories = categories;
                    }

                    if (angular.isDefined(p.espacoPath) && p.espacoPath !== null) {
                        product.space = p.espacoPath;
                    }
                    if(angular.isDefined(p._customData) && p._customData !== null){
                        product.customData = p._customData;
                    }
                    result.push(product);
                }
            }
            return JSON.stringify(result);
        }

        var isMobile = {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
            },
            any: function() {
                return isMobile.Android() || isMobile.iOS() || isMobile.BlackBerry() || isMobile.Opera() || isMobile.Windows();
            }
        };

        function addDays(data, days) {
            if(data == null) return data;
            return moment(data).add(days, 'day').toDate();
        }

        function addMonths(data, month) {
            if(data == null) return data;
            return moment(data).add(month, 'month').toDate();
        }

        function diasEntre(data1, data2) {
            var dif =
                Date.UTC(data1.getYear(), data1.getMonth(), data1.getDate(), 0, 0, 0) - Date.UTC(data2.getYear(), data2.getMonth(), data2.getDate(), 0, 0, 0);
            return Math.abs((dif / 1000 / 60 / 60 / 24));
        }

        function firstDayOfMonth(data){
            return moment(data).date(1).toDate();
        }

         function _checkAge (age) {

           if (
             !Properties.bloquearCompraMenorIdade &&
             !Properties.aceitaPrimeiroHospedeMenorDeIdade ||
             Properties.permiteMenordeIdade
            ) {
              if (Properties.permiteMenordeIdade) Properties.permiteMenordeIdade = undefined
              return true;
           }

           if (age === undefined || age === null) {
             return false;
           }

           var dataNascimento = moment(age, "DDMMYYYY");

           if (!dataNascimento.isValid()) {
             return false;
           }

           dataNascimento = dataNascimento.toDate();

           var dataAtual = new Date();

           var milissegundos = dataAtual - dataNascimento;

           var idadeEmAnos = Math.floor(
             milissegundos / (365.25 * 24 * 60 * 60 * 1000)
           );

           if (idadeEmAnos < 18) {
             return false;
           }

           return true;
         }

        function _availableDatesForProduct(productPath , minDate, tempoDeValidade, maxDate, callback) {
            minDate = minDate || dateToString(new Date());
            maxDate = maxDate || addMonths(stringToDate(minDate), tempoDeValidade || Properties.mesesDeBuscaDisponibilidade || 12);
            callback = callback || function(){};
            var params = {
                method: "getAvailableDatesForProduct",
                toAgencyPath: "agencies/" + Properties.agency,
                date: minDate,
                endDate: dateToString(maxDate),
                ignoreSalesDate: "true",
                productPath: productPath,
                clearCache: Properties.clearCache
            };
            var result = [];
            BackEnd.execute(params, function (data) {
                angular.forEach(data, function(d){
                    result.push(d);
                });
                callback(result);
            }, function (error) {
                callback();
                ErrorHandler.showError(error);
            });
            return result;
        }
        var _cardNumberValidator = (function(array) {
            return function luhn (number) {
              if (typeof number !== 'string') throw new TypeError('Expected string input')
              if (!number) return false
              var length = number.length
              var bit = 1
              var sum = 0
              var value

              while (length) {
                value = parseInt(number.charAt(--length), 10)
                bit ^= 1
                sum += bit ? array[value] : value
              }

              return sum % 10 === 0
            }
          }([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]))

          function _cpfValidator(cpf){
            cpf = cpf.replace(/\D/g, '');
            if(cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
            var result = true;
            [9,10].forEach(function(j){
                var soma = 0, r;
                cpf.split(/(?=)/).splice(0,j).forEach(function(e, i){
                    soma += parseInt(e) * ((j+2)-(i+1));
                });
                r = soma % 11;
                r = (r <2)?0:11-r;
                if(r != cpf.substring(j, j+1)) result = false;
            });
            return result;
          }

          var _findZipCodeAddress = function (inputValue) {
            if (inputValue.zipCode.length < 8) return;
            if (inputValue) {
                _findZipcode(function(){});
            } else {
                var dialog = Dialogs.wait();
                _findZipcode(function(result){
                    dialog.close();
                    if(angular.isDefined(result)){
                        ErrorHandler.showError(result);
                    }
                });
            }

            function _findZipcode (_onResult) {
                if(inputValue.zipCode == "00000-000" || inputValue.zipCode == "00000000") {
                    _onResult("CEP Inválido! Por favor verifique o CEP e tente novamente.");
                    return;
                }
                BackEnd.findcep(inputValue.zipCode, function (address) {
                    if (address === null || angular.isUndefined(address) || angular.isUndefined(address.city) || angular.isUndefined(address.state)){
                       _onResult("CEP Inválido! Por favor verifique o CEP e tente novamente.");
                       return;
                    }
                    inputValue.street0 = address.street0;
                    inputValue.street1 = address.street1;
                    inputValue.city = address.city;
                    inputValue.state = address.state.toLowerCase();
                    _onResult();
                }, function (erro) {
                    _onResult();
                    ErrorHandler.showError(erro);
                });
            }

        };

        function _datesAreOnSameDay(first, second) {
            return first.getFullYear() === second.getFullYear() &&
            first.getMonth() === second.getMonth() &&
            first.getDate() === second.getDate();
        }

        function _diferenciaTemporadas(datesByTypes, tipo){
            function _contains(regEx){
                if(datesByTypes.length == 0) return false;
                return datesByTypes.filter(function(d){
                            return d.type.match(regEx);
                          }).length > 0;
                        }
            if(datesByTypes && datesByTypes.length > 0 && tipo){
                switch (tipo.toLowerCase()) {
                    case 'aberto':
                        if(Properties.diaAbertoFixo) return true;
                        if(datesByTypes.length == 0) return true;
                        var _op = datesByTypes.filter(function(d){
                            return d.type.match(/(Aberto)/i);
                        });
                        if(_op.length > 0) return true; // se calendarMessages tem categoria aberto
                        if(datesByTypes.length > 1) return false; // se tem mais de uma categoria
                        _op = datesByTypes.filter(function(d){
                            return d.type.match(/(Fechado)/i);
                        });
                        return _op.length==1; // se a unica categoria é fechado
                    case 'promo':
                        return _contains(/(Promoção)/i);
                    case 'black':
                        return _contains(/(Black)/i);
                    case 'alta':
                        return _contains(/(Alta)/i);
                    case 'baixa':
                        return _contains(/(Baixa)/i);
                    case 'especial':
                        return _contains(/(Especial)/i);
                    case 'media':
                        return _contains(/(M[eé]dia)/i);
                    case 'super':
                        return _contains(/(Super)/i);
                    case 'esgotado':
                        return _contains(/(Esgotado)/i);
                    case 'restrito':
                        return _contains(/(Restrito)/i);
                    case 'reduzido':
                        return _contains(/(Reduzido)/i);                        
                    default:
                        break;
                }
            }
            return !!datesByTypes.length;
        }

        return {
          stringToDate: stringToDate,
          dateToString: dateToString,
          timeToString: timeToString,
          timesToString: timesToString,
          datesAreOnSameDay: _datesAreOnSameDay,
          productosToString: productosToString,
          isMobile: isMobile.any,
          addDays: addDays,
          addMonths: addMonths,
          diasEntre: diasEntre,
          firstDayOfMonth: firstDayOfMonth,
          availableDatesForProduct: _availableDatesForProduct,
          cardNumberValidator: _cardNumberValidator,
          cpfValidator: _cpfValidator,
          findZipCodeAddress: _findZipCodeAddress,
          diferenciaTemporadas: _diferenciaTemporadas,
          checkAge: _checkAge,
        };
    }
})();

/**
 * Created by Danillo on 31/10/2016.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('Dialogs', dialogsService);

    /** @ngInject */
    function dialogsService($uibModal, $log, $timeout, Properties) {
        function _galeria(_title, _fotos, myOptions) {
            var opts = {};
            angular.merge(opts, {
                animation: true,
                templateUrl: 'app/components/dialogs/foto.html',
                size: 'lg',
                windowTopClass: 'modal-galeria',
                windowClass: 'modal-galeria'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsGalleryModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                title: _title,
                fotos: _fotos
            };
            return $uibModal.open(opts);
        }

        /** @ngInject */
        function dialogsGalleryModalCtrl($uibModalInstance, title, fotos) {
            /*jshint validthis:true */
            var vm = this;
            vm.title = title || "Fotos";
            vm.fotos = fotos || [];

            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };
        }

        function _iframe(url, callback, myOptions) {
            var opts = {};
            callback = callback || function(){};
            angular.merge(opts, {
                animation: true,
                templateUrl: 'app/components/dialogs/iframe.html',
                size: 'md',
                windowTopClass: 'modal-info',
                windowClass: 'modal-info'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsIframeModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                callback: callback,
                url: function () {
                    return url;
                }
            };
            return $uibModal.open(opts);
        }

        function _iframe_authenticate(url, callback, myOptions) {
            var opts = {};
            callback = callback || function(){};
            angular.merge(opts, {
                animation: true,
                templateUrl: 'app/components/dialogs/iframe_authenticate.html',
                size: 'md',
                windowTopClass: 'modal-info',
                windowClass: 'modal-info'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsIframeModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                callback: callback,
                url: function () {
                    return url;
                }
            };
            return $uibModal.open(opts);
        }

        /** @ngInject */
        function dialogsIframeModalCtrl($uibModalInstance, url, callback) {
            /*jshint validthis:true */
            var vm = this;
            vm.url = url;
            vm.callback = callback;
            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };
            vm.close = function () {
                $uibModalInstance.close('OK');
            };
        }

        function _info(message, title, myOptions, callback) {
            var opts = {};
            callback = callback || function(){};
            angular.merge(opts, {
                animation: true,
                templateUrl: 'app/components/dialogs/info.html',
                size: 'xs',
                windowTopClass: 'modal-info',
                windowClass: 'modal-info'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsInfoModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                message: function () {
                    return message;
                },
                title: function () {
                    return title || "Importante";
                }
            };
            //return $uibModal.open(opts);
            var modalInstance = $uibModal.open(opts);
            modalInstance.result.then(function (result) {
                $log.debug(result);
            }, function () {
                callback();
            });

            return modalInstance;
        }

        function _again(title, msg, myOptions) {
            var opts = {};
            angular.merge(opts, {
                animation: true,
                templateUrl: 'app/components/dialogs/again.html',
                size: 'lg',
                windowTopClass: 'modal-again',
                windowClass: 'modal-again'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsInfoModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                message: function () {
                    return msg;
                },
                title: function () {
                    return title || "Tente Novamente";
                }
            };
            return $uibModal.open(opts);
        }

        /** @ngInject */
        function dialogsInfoModalCtrl($uibModalInstance, message, title) {
            /*jshint validthis:true */
            var vm = this;
            vm.message = message;
            vm.title = title;
            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };
            vm.close = function () {
                $uibModalInstance.close('OK');
            };
        }

        function _error(message, myOptions) {
            var opts = {};
            angular.merge(opts, {
                animation: true,
                backdrop: 'static',
                keyboard: false,
                templateUrl: 'app/components/dialogs/error.html',
                size: 'sm',
                windowTopClass: 'modal-error',
                windowClass: 'modal-error'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsErrorModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                message: function () {
                    return message;
                }
            };
            return $uibModal.open(opts);
        }

        /** @ngInject */
        function dialogsErrorModalCtrl($uibModalInstance, message) {
            /*jshint validthis:true */
            var vm = this;
            vm.message = message;

            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };
            vm.close = function () {
                $uibModalInstance.close('OK');
            };
        }

        function _confirm(message, success, myOptions, dismiss) {
            var opts = {};
            dismiss = dismiss || function(){};
            angular.merge(opts, {
                animation: true,
                backdrop: 'static',
                keyboard: false,
                templateUrl: 'app/components/dialogs/confirm.html',
                size: 'sm',
                windowTopClass: 'modal-confirm',
                windowClass: 'modal-confirm'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsInfoModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                message: function () {
                    return message;
                },
                title: function () {
                    return opts.title || "Pergunta";
                }
            };
            var modalInstance = $uibModal.open(opts);
            modalInstance.result.then(function () {
                success();
            }, function () {
                dismiss();
                //$log.info('Modal dismissed at: ' + new Date());
            });
            return modalInstance;
        }

        function _wait(message, _getProgress, myOptions) {
            var opts = {};
            angular.merge(opts, {
                animation: true,
                backdrop: 'static',
                keyboard: false,
                templateUrl: 'app/components/dialogs/wait.html',
                size: 'sm',
                windowTopClass: 'modal-wait',
                windowClass: 'modal-wait'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsWaitModalCtrl;
            opts.controllerAs = 'vm';
            var _setProgress = function() {
            };
            opts.resolve = {
                message: function(){
                    return message;
                },
                getProgress: _getProgress,
                setProgress: _setProgress
            };
            var modal = $uibModal.open(opts);
            //modal._id = Math.random().toString(36).substr(2, 9);
            modal._realClose = modal.close;
            modal.close = function() {
                //$log.debug("modal.fakeClose");
                if(modal._isOpen)
                        modal._realClose();
                else
                {
                    //$log.debug("modal.close: timeout");
                    $timeout(function(){
                        modal._realClose();
                    }, 200);
                }
            };
            modal.opened.then(function(){
                modal._isOpen = true;
                //$log.debug("modal.opened", message);
            });
            modal.rendered.then(function(){
                modal._isOpen = true;
                //$log.debug("modal.rendered", message);
            });
            return modal;
        }

        /** @ngInject */
        function dialogsWaitModalCtrl($scope, $uibModalInstance, $interval, message) {
            /*jshint validthis:true */
            var vm = this;
            var actualProgress = 0;
            var invert = false;
            var arr = [1, 3, 5, 9, 13, 17, 25, 33, 41, 51, 61, 71, 85, 88, 92, 96, 99];
            vm.message = null;
            vm.progress = arr[0];
            var _firstClose = false;
            vm.getProgress = vm.getProgress || function () {
                if(_firstClose) return vm.progress;
                if(invert) {
                    actualProgress--;
                    if (actualProgress === 0) {
                        invert = false;
                    }
                } else {
                    actualProgress++;
                    if (actualProgress > arr.length)
                        invert = true;
                }
                return arr[actualProgress];
            };
            vm.getMessage = vm.getMessage || function () {
                return null;
            };
            vm.message = message;
            $interval(function () {
                vm.progress = vm.getProgress();
            }, 800);
            /*$scope.$on('modal.closing', function(event) {
                $log.debug("modal.closing");
                if(!_firstClose) {
                    event.preventDefault();
                    vm.progress = 100;
                    _firstClose = true;
                     $interval($uibModalInstance.close,400);
                }
            });*/
        }

        function _answer(question, success, myOptions) {
            var opts = {};
            angular.merge(opts, {
                animation: true,
                backdrop: 'static',
                keyboard: false,
                templateUrl: 'app/components/dialogs/answer.html',
                size: 'md',
                windowTopClass: 'modal-answer',
                windowClass: 'modal-answer'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsAnswerModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                title: function () {
                    return myOptions.title;
                },
                question: function () {
                    return question;
                }
            };
            var modalInstance = $uibModal.open(opts);
            modalInstance.result.then(function (data) {
                success(data);
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
            return modalInstance;
        }

        /** @ngInject */
        function dialogsAnswerModalCtrl($uibModalInstance, title, question) {
            /*jshint validthis:true */
            var vm = this;
            vm.answer = null;
            vm.question = question;
            vm.title = title;
            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };
            vm.close = function () {
                if (angular.isUndefined(vm.answer) || vm.answer === null || vm.answer === "")
                    return;
                $uibModalInstance.close(vm.answer);
            };
        }

        function _datePickerDialog(_title, _initialDate, success, myOptions, dateOptions) {
            var opts = {};
            angular.merge(opts, {
                animation: true,
                templateUrl: 'app/components/dialogs/datePickerDialog.html',
                size: 'sm',
                windowTopClass: 'modal-datepicker',
                windowClass: 'modal-datepicker'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = datePickerDialogModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                title: function () {
                    return _title;
                },
                date: function () {
                    return _initialDate || new Date();
                },
                dateOptions :function () {
                    return dateOptions || {};
                }
            };
            var modalInstance = $uibModal.open(opts);
            modalInstance.result.then(function (result) {
                success(result);
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
            return modalInstance;
        }

        /** @ngInject */
        function datePickerDialogModalCtrl($uibModalInstance, title, date, dateOptions) {
            /*jshint validthis:true */
            var vm = this;
            vm.title = title || "Data";
            vm.date = date || new Date();
            vm.options = {
                minDate: dateOptions.minDate || new Date(),
                customClass: function(){},
                dateDisabled: function(){}
            };
            angular.merge(vm.options, dateOptions);
            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };

            vm.close = function () {
                if (angular.isUndefined(vm.date) || vm.date === null || vm.date === "")
                    return;
                $uibModalInstance.close(vm.date);
            };
        }

        function _getClient(title, success, myOptions) {
            var opts = {};
            angular.merge(opts, {
              animation: true,
              backdrop: 'static',
              keyboard: false,
              templateUrl: 'app/components/dialogs/modal-cliente.html',
              size: 'md',
              windowTopClass: 'modal-answer',
              windowClass: 'modal-answer'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsClienteModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                title: function () {
                return title;
              }
            };
            var modalInstance = $uibModal.open(opts);
            modalInstance.result.then(function (cliente) {
              success(cliente);
            }, function () {
              $log.info('Modal dismissed at: ' + new Date());
            });
            return modalInstance;
          }

          /** @ngInject */
        function dialogsClienteModalCtrl($uibModalInstance, title) {
        /*jshint validthis:true */
            var vm = this;
            vm.answer = null;
            vm.cliente = {};
            vm.title = title || "Informe seus dados";
            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };
            vm.close = function () {
                if (angular.isUndefined(vm.cliente.name) || vm.cliente.name === null || vm.cliente.name === "")
                    return;
                if (angular.isUndefined(vm.cliente.email) || vm.cliente.email === null || vm.cliente.email === "")
                    return;
                $uibModalInstance.close(vm.cliente);
            };

        }


        function _form(products, title, _data, success, myOptions, dateOptions) {
            var opts = {};
            if(angular.isUndefined(myOptions.templateUrl)  || myOptions.templateUrl === null) {
                _error("Propriedade 'templateUrl' nao informada");
                return;
            }
            angular.merge(opts, {
              animation: true,
              backdrop: 'static',
              keyboard: false,
              //templateUrl: 'app/components/dialogs/modal-cliente.html',
              size: 'md',
              windowTopClass: 'modal-answer',
              windowClass: 'modal-answer'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsFormModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                products: function (){
                    return products;
                },
                title: function () {
                    return title;
                },
                data: function(){
                  return _data || {};
                },
                dateOptions: function(){
                    return dateOptions || {};
                }
            };
            var modalInstance = $uibModal.open(opts);
            modalInstance.result.then(function (data) {
                var products = data.products || undefined;
                delete data.products;
                success(data, products);
            });
            return modalInstance;
          }

          /** @ngInject */
        function dialogsFormModalCtrl($uibModalInstance, Properties, products, title, data, $scope, MyFunctions, BackEnd, ErrorHandler, dateOptions) {
        /*jshint validthis:true */
            var vm = this;
            vm.answer = null;
            angular.forEach(products, function(p){ p.amount = p.amount || 1});
            vm.products = products;
            vm.product = products[0];
            vm.data = data || {};
            vm.options = {
                minDate: Properties.getAllProducts ? new Date() : MyFunctions.addDays(new Date(), Properties.naoEscolheData_Dias || 1),
                customClass: function(){},
                dateDisabled: function(){}
            };
            angular.merge(vm.options, dateOptions);
            vm.tomorrow = MyFunctions.addDays(vm.data.date,1);
            vm.afterTomorrow = MyFunctions.addDays(vm.tomorrow,1);
            $scope.$watch('vm.product.date', function(_new, _old){
                if(_new && _new != _old && vm.data.date != _new) {
                    vm.data.date = _new;
                }
            });
            $scope.$watch('vm.data.date', function(_new, _old){
                vm.tomorrow = MyFunctions.addDays(vm.data.date,1);
                vm.afterTomorrow = MyFunctions.addDays(vm.tomorrow,1);
                if(_new && vm.product.needExtraData == "hora" && _new != _old) {
                    //console.log("Produto precisa de horario");
                    BackEnd.execute({ method: "schedules",
                                      product: vm.product.path,
                                      date: MyFunctions.dateToString(_new)
                                    },
                        function(data) {
                            vm.product.schedules = data;
                            vm.product.schedule = null;
                        }
                    );
                }
            });
            $scope.$watch("vm.product.termosAceite", function (newValue) {
              if (newValue) {
                vm.initScrollCheck();
              }
            });
            vm.scrollAtBottom = !Properties.bloqueiaTermosAceite || true;

            vm.initScrollCheck = function () {
              if (Properties.bloqueiaTermosAceite === true)
                $timeout(function () {
                  var termosDiv = document.getElementById("termosAceite");

                  if (!termosDiv) return;

                  if (termosDiv.scrollHeight <= termosDiv.clientHeight) {
                    vm.scrollAtBottom = true;
                  } else {
                    termosDiv.addEventListener("scroll", vm.checkScroll);
                    vm.checkScroll();
                  }
                }, 0);
            };

            vm.checkScroll = function () {
              var div = document.getElementById("termosAceite");
              if (!div) return;
              vm.scrollAtBottom = div.scrollHeight - div.scrollTop <= div.clientHeight;
              $scope.$apply();
            };

            vm.title = title || "Informe seus dados";
            vm.openDatePickerModal = function (searchDate, nameKey) {
                _datePickerDialog("Selecione a Data", searchDate, function (date) {
                    vm.data[nameKey] = date;
                });
            };
            vm.dismiss = function () {
                vm.product.amount = 0;
                $uibModalInstance.dismiss();
            };
            vm.close = function () {
                if (vm.product.type == "Combo" && angular.isDefined(vm.product.products)) {
                    var maxDate = null;
                    for (var index = 0; index < vm.product.products.length; index++) {
                        var element = vm.product.products[index];
                        if(maxDate == null || maxDate < element._date) maxDate = element._date;
                        var date = MyFunctions.dateToString(element._date);
                        element._date = date;
                        if (element.schedule == "" || element.schedule == null) {
                            delete element.schedule;
                        }
                    }
                    vm.data.date = maxDate;
                }
                vm.data.products = vm.products;
                $uibModalInstance.close(vm.data);
            };

            vm.invalidSchedule = function () {
                if (vm.product.type == "Combo") { // valida combo
                    for (var i = 0; i < vm.product.products.length; i++) {
                        var child = vm.product.products[i];
                        if(vm.product.select_date && child._date == null) return true;
                        if(child._searchSchedules != null && !child._searchSchedules) return true;
                        if (angular.isUndefined(child.schedules) || child.schedules.length == 0) continue; // pula produtos que não requerem hora
                        if (child.schedule == "" || child.schedule == undefined) {
                            return true;
                        }
                    }
                } else { //valida produto
                    if(angular.isUndefined(vm.product.schedules) || vm.product.schedules.length == 0){
                        return false;
                    }
                    return vm.product.schedule == "" ||  vm.product.schedule == null || vm.product.schedule == undefined;
                }
                return false;
            };
            vm.price = null;
            vm.calculatePrice = function(){
                if(vm.product.amount === undefined || vm.product.amount == 0) return;
                if(vm.invalidSchedule()) {
                    if(vm.price != null) vm.price = null;
                    return;
                }
                vm.price = null;
                var ps = angular.copy(vm.products);
                ps.forEach(function(p) {
                    if(p.products!= null && angular.isDefined(p.products)) {
                        p.products.forEach(function(c) {
                            if(c._date) {
                                if (c._date > p.date) p.date = c._date;
                                c._date = MyFunctions.dateToString(c._date);
                            }
                        });
                    }
                });
                var params = {
                    "method": "billPrice",
                    "couponAsString": "",
                    "productsArray": MyFunctions.productosToString(ps)
                };
                var d = _wait("Calculando");
                BackEnd.execute(params,
                    function(data) {
                        d.close();
                        vm.price = data.value;
                        /*
                        vm.totalValue = data.value;
                        vm.initialValue = data.value;
                        vm.oldValue = data.oldValue;
                        vm.descValue = data.descValue;
                        vm.freteValue = data.freteValue;
                        vm.productUpdated = data.products;
                        vm.paymentMethodsAdjustments = data.paymentMethodsAdjustments;
                        */

                    },
                    function(err) {
                        d.close();
                        ErrorHandler.showError(err);
                    });

            };
        }
         function _openChdDialog(chds, terceiraidades) {
             var opts = {};
            angular.merge(opts, {
                animation: true,
                templateUrl: 'app/components/dialogs/modal_chd.html',
                size: 'md',
                windowTopClass: 'modal-chd',
                windowClass: 'modal-chd'
            });
            opts.bindToController = true;
            opts.controller = modalChdCtrl,
            opts.controllerAs = 'vm';
            opts.resolve = {
                    chds: function () {
                      return chds;
                    },
                    terceiraidades: function () {
                        return terceiraidades;
                    }
                };
             var modalInstance = $uibModal.open(opts);
            //  .result.then(function (result) {
            //      var search = Search._getSearch();
            //  });
             return modalInstance;

        }

        /** @ngInject */
        function modalChdCtrl($uibModalInstance, $scope, Search, Properties) {
             /*jshint validthis:true */
            var vm = this;
            var search = Search.getSearch();
            var valores = [];
            valores = search[0].chdsAges ? search[0].chdsAges : [];
            vm.idades = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
            vm.idades2 = [];
            vm.chds = [];
            vm.terceiraidades = [];
            vm.notUseTerId = Properties.notUseTerId;
            if (valores.length > 0) {
                for (var i = 0; i < valores.length; i++){
                    if (valores[i] < 18) {
                        vm.chds.push({idade: valores[i]});
                    } else {
                        vm.terceiraidades.push({idade: valores[i]});
                    }
                }
            }
            for (var id = 0; id < 40; id++) {
                vm.idades2.push(id+60);
            }
            $scope.$watch('vm.chd',function(newValue){
                if (vm.chds.length < newValue) {
                    for (var i = vm.chds.length; i < newValue; i++) {
                      vm.chds.push({idade:""});
                    }
                } else if (vm.chds.length > newValue) {
                    vm.chds.length = newValue;
                }
            });
            $scope.$watch('vm.terceiraidade',function(newValue){
                if (vm.terceiraidades.length < newValue) {
                    for (var i = vm.terceiraidades.length; i < newValue; i++) {
                        vm.terceiraidades.push({ idade: "" });
                    }
                } else if (vm.terceiraidades.length > newValue) {
                    vm.terceiraidades.length = newValue;
                }
            });
            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };
            vm.ok = function () {
                var j, el;
                search[0].chdsAges = [];
                for (j = 0; j < vm.chds.length; j++) {
                    el = vm.chds[j];
                    //vm.chdAges.push(el);
                    search[0].chdsAges.push(el.idade + "" );
                    if (angular.isUndefined(el.idade) || el.idade === "" || el.idade === null) return;
                }
                for (j = 0; j < vm.terceiraidades.length; j++) {
                    el = vm.terceiraidades[j];
                    //vm.chdAges.push(el);
                    search[0].chdsAges.push(el.idade + "" );
                    if (angular.isUndefined(el.idade) || el.idade === "" || el.idade === null) return;
                }

                $uibModalInstance.close([search]);
            };

        }


        function _getAddress(title, success, myOptions) {
            var opts = {};
            angular.merge(opts, {
              animation: true,
              backdrop: 'static',
              keyboard: false,
              templateUrl: 'app/components/dialogs/modal_address.html',
              size: 'md',
              windowTopClass: 'modal-answer',
              windowClass: 'modal-answer'
            }, angular.isUndefined(myOptions) ? {} : myOptions);
            opts.bindToController = true;
            opts.controller = dialogsAddressModalCtrl;
            opts.controllerAs = 'vm';
            opts.resolve = {
                title: function () {
                return title;
              }
            };
            var modalInstance = $uibModal.open(opts);
            modalInstance.result.then(function (user) {
              success(user);
            }, function () {
              $log.info('Modal dismissed at: ' + new Date());
            });
            return modalInstance;
          }

          /** @ngInject */
        function dialogsAddressModalCtrl($uibModalInstance, title) {
        /*jshint validthis:true */
            var vm = this;
            vm.user = {};
            vm.title = title || "Informe seus dados";
            vm.dismiss = function () {
                $uibModalInstance.dismiss();
            };
            vm.close = function () {
                $uibModalInstance.close(vm.user);
            };

        }

        function _openProductDetais (_product, ingressosController){
            return $uibModal.open({
                animation: true,
                templateUrl: Properties.maisDetalhesIngressoTemplateUrl || 'app/new_ingressos/modais/mais-detalhes-ingresso.html',
                bindToController: true,
                controller: modalCtrl,
                controllerAs: 'vm',
                size: 'big',
                resolve: {
                    product: function() {
                        return _product;
                    },
                    parent: function() {
                        return ingressosController;
                    }
                }
            });
        }

        /** @ngInject */
        function modalCtrl($uibModalInstance, product, parent) {
            /* jshint validthis:true */
            var vm = this;
            vm.product = product;
            vm.parent = parent;

            vm.close = function() {
                $uibModalInstance.close('close');
            };
        }

        function _politicas (_okPress, _dismiss, myOptions) {
            /*jshint validthis:true */
            var vm = this;
            vm.Properties = Properties;
            _okPress = _okPress || function(){ return true };
            _dismiss = _dismiss || function(){ return false };
            var opts = {};
            angular.merge(
              opts,
              {
                animation: true,
                templateUrl: "app/ingressos/modais/dialog-politicas.html",
                size: "md",
                windowTopClass: "modal-product",
                windowClass: "modal-product",
              },
              myOptions ? myOptions : {}
            );
            opts.bindToController = true;
            opts.controller = _politicasController;
            opts.controllerAs = 'vm';
            opts.resolve = {
                okPress: function(){ return _okPress; },
                dismiss: function(){ return _dismiss; },
            };
            return $uibModal.open(opts);
        }

        function _openConfirmWhatsAppDialog(_okPress, _dismiss, _user, myOptions) {
            _okPress = _okPress || function(){ return true; };
            var opts = {};
            angular.merge(
              opts,
              {
                animation: true,
                templateUrl:
                  "app/ingressos/modais/dialog-confirm-whatsapp.html",
                size: "md",
                windowTopClass: "modal-product",
                windowClass: "modal-product",
              },
              angular.isUndefined(myOptions) ? {} : myOptions
            );
            opts.bindToController = true;
            opts.controller = _confirmWhatsAppController;
            opts.controllerAs = 'vm';
            opts.resolve = {
                okPress: function(){ return _okPress; },
                dismiss: function(){ return _dismiss; },
                user: function(){ return _user; },
            };
            return $uibModal.open(opts);
        }

        /** @ngInject */
        function _politicasController(
            $uibModalInstance,
            okPress,
            dismiss
        ) {
          /*jshint validthis:true */
          var vm = this;
          vm.close = function () {
            dismiss();
            $uibModalInstance.dismiss();
          };
          vm.dismiss = function () {
            okPress();
            $uibModalInstance.close("OK");
          };
        }

                /** @ngInject */
        function _confirmWhatsAppController(
          $uibModalInstance,
          okPress,
          dismiss,
          user
        ) {
          /*jshint validthis:true */
          var vm = this;
          vm.userDetails = user;

          vm.close = function () {
            dismiss();
            $uibModalInstance.dismiss();
          };

          vm.dismiss = function () {
            okPress();
            $uibModalInstance.close("OK");
          };
        }

        return {
          iframe: _iframe,
          info: _info,
          again: _again,
          wait: _wait,
          error: _error,
          confirm: _confirm,
          galeria: _galeria,
          answer: _answer,
          datePickerDialog: _datePickerDialog,
          getClient: _getClient,
          form: _form,
          iframe_authenticate: _iframe_authenticate,
          openChdDialog: _openChdDialog,
          getAddress: _getAddress,
          openProductDetais: _openProductDetais,
          whatsConfirm: _openConfirmWhatsAppDialog,
          politicas: _politicas,
        };
    }
})();

/**
 * Created by Danillo on 05/09/2016.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('Cart', CartService);

    function CartService(localStorageService, moment, MyFunctions, Properties) {
        var _products = [];

        var _getTotalAmount = function () {
            var _totalAmount = 0;
            for (var i = 0; i < _products.length; i++) {
                var p = _products[i];
                _totalAmount += parseInt(p.amount,10);
            }
            return _totalAmount;
        };
        var _getTotalValue = function () {
            var _total = 0;
            for (var i = 0; i < _products.length; i++) {
                var p = _products[i];
                _total += (parseInt(p.value, 10) * parseInt(p.amount, 10));
            }
            return _total;
        };

        var _setProducts = function (arrayProducts) {
            _products = arrayProducts;
            localStorageService.set("_cart", {resultDate: moment(new Date()).add(1, 'days').toDate(), products: _products});
        };
        var _ingToken = localStorageService.get("_ingToken");
        var _setIngToken = function(ingToken){
            if(_ingToken != ingToken){
                _setProducts([]);
                if(ingToken == null) {
                    localStorageService.remove("_ingToken")
                } else localStorageService.set("_ingToken", ingToken);
            }
        }

        var _addProduct = function (product) {
            var isFound = false;
            for (var i = 0; i < _products.length; i++) {
                var p = _products[i];
                if (product.id == p.id) {
                    isFound = true;
                    p.amount++;
                    break;
                }
            }
            if (!isFound) {
                product.amount = 1;
                _products.push(product);
            }
        };
        var _removeProduct = function (product) {
            for (var i = 0; i < _products.length; i++) {
                var p = _products[i];
                if (product.id == p.id) {
                    if (product.amount > 0) {
                        p.amount--;
                    } else {
                        _products.splice(i, 1);
                    }
                }
            }
        };
        var _getProducts = function () {
            return _products;
        };
        function _getAmount(p) {
            if(_products == null || _products.length == 0) return 0;
            var result = 0;
            for (var i = 0; i < _products.length; i++) {
                var p1 = _products[i];
                if(p1.id == p.id && MyFunctions.dateToString(p1.date) == MyFunctions.dateToString(p.date)) result += p1.amount;
            }
            return result;
        }
        function _getProductById(id) {
            if(_products == null || _products.length == 0) return null;
            for (var i = 0; i < _products.length; i++) {
                var p1 = _products[i];
                if(p1.id == id) return p1;
            }
            return null;
        }
        function loadProducts() {
            if(Properties.noLoadCart) localStorageService.remove('_cart');
            else {
                var oldResult = localStorageService.get('_cart');
                if (angular.isDefined(oldResult) && oldResult !== null && angular.isDefined(oldResult.resultDate) && oldResult.resultDate !== null) {
                    if (moment().isBefore(moment(oldResult.resultDate))) {
                        angular.forEach(oldResult.products, function (p) {
                            p.date = moment(p.date).toDate();
                            if (p._children) {
                                p._children.forEach(function (c) {
                                    if (c._date) c._date = moment(c._date).toDate();
                                });
                            }
                        });
                        var now = MyFunctions.stringToDate(MyFunctions.dateToString(new Date()));
                        // Discarta carrinho se houver algum produto anterior a data atual
                        if (oldResult.products.filter(function (p) { return p.date < now; }).length > 0) {
                            localStorageService.remove('_cart');
                        } else _products = oldResult.products;
                        _products = _products.filter(function (p) {
                            return p.date >= now;
                        });
                        angular.forEach(_products, function (p) {
                            p._totalAmount = _getAmount(p);
                        });
                    }
                    else
                        localStorageService.remove('_cart');
                }
            }
            isLoad = true;
        }
        var isLoad = false;
        loadProducts();
        var _lastBill = null;
        function _setLastBill (bill){
            _lastBill = bill;
            localStorageService.set("_lastBill", bill);
        }
        function _getLastBill (){
            if( _lastBill == null);
                _lastBill = localStorageService.get("_lastBill");
            return _lastBill;
        }
        function _minDate(){
            var result = null;
            if(!isLoad) loadProducts();
            var ps = _getProducts();
            if(ps == null || ps.length == 0) return new Date();
            for (var i = 0; i < ps.length; i++) {
                var p = ps[i];
                var d = p.date;
                if(p.products && p.products.length >0){
                    for (var j = 0; j < p.products.length; j++) {
                        var p2 = p.products[j];
                        if(p2._date) {
                            var d2 = MyFunctions.stringToDate(p2._date);
                            if(d2 < d) d = d2;
                        }
                    }
                }
                if(result == null || result > d) result = d;
            }
            return result;
        }
        function _hasExclusive(p1, func) {
          if (_products == null || _products.length === 0) return false;
          for (var i = 0; i < _products.length; i++) {
            var p2 = _products[i];
            if (p2.vendaExclusiva !== "true") continue;
            if (func(p1, p2)) continue;

            return true;
          }

          return false;
        }


        return {
            setIngToken: _setIngToken,
            addProduct: _addProduct,
            removeProduct: _removeProduct,
            getProducts: _getProducts,
            minDate: _minDate,
            hasExclusive: _hasExclusive,
            getProductById: _getProductById,
            getAmount: _getAmount,
            getTotalAmount: _getTotalAmount,
            getTotalValue: _getTotalValue,
            setProducts: _setProducts,
            setLastBill: _setLastBill,
            getLastBill: _getLastBill
        };
    }
})();

/**
 * Created by Danillo on 27/06/2016.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('FooterController', FooterController);

    /** @ngInject */
    function FooterController(ScrollTo, $timeout, localStorageService) {
        var vm = this;
         
        vm.directScroll = function (id_scroll) {
            ScrollTo.scrollTo(id_scroll);
        };
        vm.hasBookingAgency = false;
        function ready() {
            vm.isready = true;
            $timeout(function() {
                var ba = localStorageService.cookie.get("bookingAgency");
                if(angular.isDefined(ba) && ba !== null){
                    vm.hasBookingAgency = true;
                }
            }, 500);
        }
        ready();
    }
})();

/**
 * Created by Danillo on 16/11/2015.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('ErrorHandler', ErrorHandler);

    /** @ngInject */
    function ErrorHandler(Dialogs) {
        var showError = function (error) {
            if (angular.isUndefined(error) || error === null) {
                Dialogs.error("Conexão Recusada");
            } else if (angular.isString(error)) {
                Dialogs.error(error);
            } else if (angular.isDefined(error.aviso)) {
                Dialogs.info(error.aviso);
            } else if (angular.isDefined(error.data) && error.data !== null && angular.isDefined(error.data.aviso)) {
                Dialogs.info(error.data.aviso);
            } else if (angular.isDefined(error.erro)) {
                Dialogs.error(error.erro);
            } else if (angular.isDefined(error.data) && error.data !== null && angular.isDefined(error.data.erro)) {
                Dialogs.error(error.data.erro);
            } else {
                if (error.data === null && error.status == -1) {
                    error.data = "Conexão recusada";
                }
                Dialogs.error(error.data);
            }
        };
        return {
            showError: showError
        };
    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('GoogleAuth', GoogleAuth);

    /** @ngInject */
    function GoogleAuth($window, BackEnd, ErrorHandler, Dialogs) {        
        var _onSuccess = null;        
        $window._onGoogleSignIn = function (googleUser) {
            var id_token = googleUser.getAuthResponse().id_token;
            var profile = googleUser.getBasicProfile();
            var dialog = Dialogs.wait();   
            BackEnd.execute({
                method: "googleLogin",
                person: {
                    name: profile.getName(),
                    email: profile.getEmail(),
                    googleIdToken: id_token
                }
            }, function (user) {
               dialog.close();
                if(_onSuccess) _onSuccess(user, id_token);
            }, function (erro) {
               dialog.close();
               ErrorHandler.showError(erro);
            });
            /*console.log('ID_Token: ' + id_token);
            console.log('ID: ' + profile.getId()); 
            console.log('Name: ' + profile.getName());
            console.log('Image URL: ' + profile.getImageUrl());
            console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.*/
        };
        $window._canGoogleSignIn = false;
        this.canGoogleSignIn =  function(value, onSuccess){
            $window._canGoogleSignIn =  value;    
            _onSuccess = onSuccess;
            if(value) { 
                var arrays = document.getElementsByClassName("abcRioButtonContentWrapper");
                //console.log(arrays);
                angular.forEach(arrays[0].children, function(c) {
                    if(c.tagName == "SPAN"){
                        c.innerText = "Entrar com o Google";
                    }
                });
                //abcRioButtonContentWrapper 
            }
        };
        return this;
    }
})();
(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('FacebookAuth', FacebookAuth);

    /** @ngInject */
    function FacebookAuth($window, BackEnd, ErrorHandler, Properties, Dialogs) {
        var _onSuccess = null;
        $window._onFacebookSignIn = function (response) {
            var dialog = Dialogs.wait();
            BackEnd.execute({
                method: "facebookLogin",
                person: {
                    name: response.name,
                    email: response.email,
                    facebookToken: response.accessToken
                }
            }, function (user) {
                dialog.close();
                if(_onSuccess) _onSuccess(user, response.accessToken);
            }, function (erro) {
                dialog.close();
                ErrorHandler.showError(erro);
            });                
        };
        $window._canFacebookSignIn = false;
        this.canFacebookSignIn =  function(value, onSuccess){
            $window._canFacebookSignIn = value;
            _onSuccess = onSuccess;
        };
        if(Properties.facebookappId) {
            $window._onFacebookInit = function(FB){
                FB.init({
                    appId      : Properties.facebookappId,
                    cookie     : true,
                    xfbml      : true,
                    version    : 'v10.0'
                });     
                FB.AppEvents.logPageView();                
            };
        }
        return this;
    }
})();
(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .factory('Auth', Auth);

    function Auth(localStorageService, $timeout, moment, Dialogs, BackEnd, ErrorHandler, Tracking, Properties) {

        var listeners = [];

        var _notifyListeners = function (data) {
            angular.forEach(listeners, function (listener) {
                listener(data);
            });
        };

        var user = null;
        if (localStorageService.get('user') !== null) {
            user = localStorageService.get('user');
        }
        var _setUser = function (_user) {
            localStorageService.remove('user');
            user = _user;
            localStorageService.set('user', _user);
        };

        var _savePerson = function (user, onComplete) {
            if (user === null) {
                ErrorHandler.showError("Cadastre uma pessoa.");
                return;
            }
            if (user.email === null || angular.isUndefined(user.email)) {
                ErrorHandler.showError("Email não informado.");
                return;
            }
            if (user.name === null || angular.isUndefined(user.name)) {
                ErrorHandler.showError("Informe o nome completo.");
                return;
            }
            if (!Properties.cpfNaoObrigatorio) {
                if ((user.cpf === null || angular.isUndefined(user.cpf)) && (angular.isUndefined(user.customData) || user.customData.estrangeiro !== "true")) {
                    ErrorHandler.showError("CPF não informado.");
                    return;
                }
            }
            if (!Properties.dataNascimentoNaoObrigatoria) {
                if (user.birth === null || angular.isUndefined(user.birth)) {
                    ErrorHandler.showError("Data de nascimento não informada.");
                    return;
                }
            }
            if ((user.cellPhone === null || angular.isUndefined(user.cellPhone) || user.cellPhone.length === 0) && (user.homePhone === null || angular.isUndefined(user.homePhone) || user.homePhone.length === 0)) {
                ErrorHandler.showError("Celular não informado.");
                return;
            }
            if (Properties.cidadeRequerida || Properties.enderecoRequerido) {
                if (user.city === null || angular.isUndefined(user.city) || user.city.length === 0) {
                    ErrorHandler.showError("Cidade não informada.");
                    return;
                }
                if ((user.state === null || angular.isUndefined(user.state) || user.state.length != 2) && (angular.isUndefined(user.customData) || user.customData.estrangeiro != "true")) {
                    ErrorHandler.showError("Estado não informado.");
                    return;
                }
                if ((user.zipCode === null || angular.isUndefined(user.zipCode) || user.zipCode.length === 0) && (angular.isUndefined(user.customData) || user.customData.estrangeiro != "true")) {
                    ErrorHandler.showError("Cep não informado.");
                    return;
                }
            }
            if (Properties.enderecoRequerido) {
                if ((user.street0 === null || angular.isUndefined(user.street0) || user.street0.length === 0) && (angular.isUndefined(user.customData) || user.customData.estrangeiro != "true")) {
                    ErrorHandler.showError("Endereço não informado.");
                    return;
                }
                if ((user.street1 === null || angular.isUndefined(user.street1) || user.street1.length === 0) && (angular.isUndefined(user.customData) || user.customData.estrangeiro != "true")) {
                    ErrorHandler.showError("Bairro não informado.");
                    return;
                }
                if ((user.address2 === null || angular.isUndefined(user.address2) || user.address2.length === 0) && (angular.isUndefined(user.customData) || user.customData.estrangeiro != "true")) {
                    ErrorHandler.showError("Complemento não informado.");
                    return;
                }
            }
            user.forSave = true;
            if (angular.isDefined(user.customData) && user.customData.estrangeiro === "true" && angular.isDefined(user.city)) {
                if (user.city.length > 0) {
                    user.state = "EX";
                }
            }
            var dialog = Dialogs.wait();
            function internalSavePerson(isFirst){
                user.password = encodeURIComponent(user.password);
                user.email = encodeURIComponent(user.email);

                BackEnd.execute(
                  { method: "savePerson", person: user },
                  function (data) {
                    dialog.close();
                    _setUser(data);
                    Dialogs.info("Dados salvos com sucesso.");
                    Tracking.login(_getUser());
                    onComplete();
                  },
                  function (error, status) {
                    if (isFirst && status == 401) {
                      internalSavePerson(false);
                      return;
                    }
                    dialog.close();
                    ErrorHandler.showError(error);
                  }
                );
            }
            internalSavePerson(true);
        };

        var _findOrCreatePerson = function (user, onComplete) {
            var dialog = Dialogs.wait();
            if(angular.isDefined(localStorageService.get("partnerClientId")) && localStorageService.get("partnerClientId") || null){
                user.customData = user.customData || {};
                user.customData.clientId = localStorageService.get("partnerClientId");
            }            
            onComplete = onComplete || function () {};
            function _callServer(isFirst){
                BackEnd.execute({
                    method: "findOrCreatePerson",
                    person: user
                }, function (_user) {
                    dialog.close();
                    if(_user.cellPhone == null && user.cellPhone != null) _user.cellPhone = user.cellPhone;
                    _setUser(_user);
                    _setPerson(_user);
                    Tracking.login(_getUser());
                    onComplete();
                    localStorageService.remove('user');//limpa usuario do cache para obrigar cliente a logar.
                }, function (erro, status) {
                    if(isFirst && status == 401) {
                        $timeout(function(){ _callServer(false);}, 1500);
                        return;
                    }
                    dialog.close();
                    Tracking.loginError(erro);
                    ErrorHandler.showError(erro);
                });
            }
            _callServer(true);
        };
        function _alterPerson(person, onComplete){
            var dialog = Dialogs.wait();
            onComplete = onComplete || function () {};
            BackEnd.execute({
                method: "alterPerson",
                person: person
            }, function (person) {
                dialog.close();
                onComplete(person);
            }, function (erro) {
                dialog.close();
                ErrorHandler.showError(erro);
            });
        }


        var person = null;
        if (localStorageService.get('auth.person') !== null) {
            var p = localStorageService.get('auth.person');
            if (moment().isBefore(moment(p._cookieLimit))) {
                person = p;
            }
        }

        function _setPerson(_person) {
            if (angular.isDefined(_person) && _person !== null) {
                _person._cookieLimit = moment(new Date()).add(3, 'hours').toDate();
            }
            localStorageService.remove('auth.person');
            person = _person;
            localStorageService.set('auth.person', _person);
        }

        function _getUser() {
            if (user === null)
                user = localStorageService.get('user');
            return user;
        }
        function _isValidEmail(email) {
            if(email === null || angular.isUndefined(email)) return false;
            if(email.indexOf("@") < 0) return false;
            var dominio = email.substring(email.indexOf("@") + 1);
            if(dominio.indexOf(".") <= 0) return false;
            if(dominio.indexOf(".") == dominio.length - 1) return false;
            var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if(email.match(mailformat)) {
                return true;
            }
            return false;
        }
        var influencer = null;
        if(localStorageService.cookieGet("influencer") !== null && localStorageService.cookieGet("influencer") !== "" &&
                localStorageService.cookieGet("influencertoken") !== null && localStorageService.cookieGet("influencertoken") !== "") {
            influencer = {
                    influencer: localStorageService.cookieGet("influencer"),
                    influencertoken:localStorageService.cookieGet("influencertoken")
            };
        }
        function _setSalesInfluencer(_influencer, _influencertoken) {
            influencer = null;
            if(_influencer !== null && _influencer !== "" &&
            _influencertoken !== null && _influencertoken !== "") {
                        influencer = { influencer: _influencer, influencertoken: _influencertoken};
            }
            var days = Properties.cookieExpiration || 3;
            localStorageService.cookie.set("influencer", _influencer, days);
            localStorageService.cookie.set("influencertoken", _influencertoken, days);
        }
        function _getSalesInfluencer() {
            return influencer;
        }

        return {
            addListener: function (listener) {
                listeners.push(listener);
            },
            savePerson: _savePerson,
            alterPerson: _alterPerson,
            findOrCreatePerson: _findOrCreatePerson,
            setUser: _setUser,
            isLoggedIn: function () {
                return user && user.id ? true : false;
            },
            getUser: _getUser,
            logout: function () {
                localStorageService.remove('user');
                user = null;
                _notifyListeners(user);
            },
            getPerson: function () {
                return person;
            },
            setPerson: _setPerson,
            isValidEmail: _isValidEmail,
            setSalesInfluencer: _setSalesInfluencer,
            getSalesInfluencer: _getSalesInfluencer
        };
    }
})();

/**
 * Created by Danillo on 23/06/2016.
 */
(function() {
  'use strict';

  angular
    .module('b2c_ingressos')
    .factory('BackEnd', BackEnd);

    function toPayLoad(obj) {
      var query = '',
          name, value;

      for (name in obj) {
          value = obj[name];

         if (value !== undefined && value !== null) {
            if (value instanceof Object) {
              query += encodeURIComponent(name) + '=' + encodeURIComponent(JSON.stringify(value)) + '&';
            } else if (value instanceof Array) {
              query += encodeURIComponent(name) + '=' + encodeURIComponent(JSON.stringify(value)) + '&';
            } else
              query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
          }
      }

      return query.length ? query.substr(0, query.length - 1) : query;
    }

  /** @ngInject */
  function BackEnd($http, ErrorHandler, Properties, localStorageService) {
    var serverUrl = Properties.serverUrl;
    /*if(serverUrl != ""){
      if (localStorageService.cookieGet("agency") !== null && localStorageService.cookieGet("agency") !== "")
        serverUrl = localStorageService.cookieGet("agency") + '/' + serverUrl;
    }*/
    if (angular.isDefined(Properties.serverBase) && Properties.serverBase !== null) {
      serverUrl = Properties.serverBase + serverUrl;
    }

    var serverMethod = 'JSONP';
    if (angular.isDefined(Properties.serverMethod) && Properties.serverMethod !== null) {
      serverMethod = Properties.serverMethod;
    }

    function _execute(params, onSuccess, onFail, _serverMethod, _url) {
      onSuccess = onSuccess || function() {};
      onFail = onFail || ErrorHandler.showError;
      var url = serverUrl;
      _serverMethod = _serverMethod || serverMethod;
      if(_serverMethod == 'JSONP'){
        params.callback = "JSON_CALLBACK";
      } else {
        var agency = localStorageService.cookieGet("agency") || Properties.agency;
        if(Properties.nginx === null || angular.isUndefined(Properties.nginx) || !Properties.nginx){
          url += "/" + agency + "/" + params.method;
        }
      }
      url = _url || url;
      var success = function(data) {
        if (angular.isDefined(data) && angular.isDefined(data.erro)) {
          onFail(data);
          return;
        }
        onSuccess(data);
      };
      if(_serverMethod == 'POST'){
        $http({
          method: 'POST',
          url: url,
          data: toPayLoad(params),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8', 'Cache-Control': 'no-cache' }
        }).success(success).error(onFail);
      } else {
        $http({
          method: _serverMethod,
          url: url,
          params: params,
          headers: { 'Cache-Control': 'no-cache' }
        }).
        success(success).
        error(onFail);
      }
    }
    function _execute2(params, onSuccess, onFail, _url, _serverMethod) {
      var serverUrl = _url || Properties.serverUrl;
      if (angular.isDefined(Properties.serverBase) && Properties.serverBase !== null) {
        serverUrl = Properties.serverBase + serverUrl;
      }

      onSuccess = onSuccess || function() {};
      onFail = onFail || ErrorHandler.showError;
      var url = serverUrl;
      _serverMethod = _serverMethod || serverMethod
      if(_serverMethod == 'JSONP'){
        params.callback = "JSON_CALLBACK";
      } else {
        var agency = localStorageService.cookieGet("agency") || Properties.agency;
        if(Properties.nginx === null || angular.isUndefined(Properties.nginx) || !Properties.nginx){
          url += "/" + agency + "/" + params.method;
        }
        //url += "/" + Properties.agency + "/" + params.method;
      }
      var success = function(data) {
        if (angular.isDefined(data) && angular.isDefined(data.erro)) {
          onFail(data);
          return;
        }
        onSuccess(data);
      };
      if(_serverMethod == 'POST') {
        $http({
          method: 'POST',
          url: url,
          data: toPayLoad(params),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8', 'Cache-Control': 'no-cache'}
        }).success(success).error(onFail);
      } else {
        $http({
          method: _serverMethod,
          url: url,
          params: params,
          headers: { 'Cache-Control': 'no-cache' }
        }).
        success(success).
        error(onFail);
      }
    }

    function _findCep(zipCode, onSuccess) {
      onSuccess = onSuccess || function() {};
      if (zipCode === null || zipCode.length < 8) {
        ErrorHandler.showError("cep invalido");
        return;
      }
      if(zipCode == "00000-000" || zipCode == "00000000") {
        ErrorHandler.showError("cep invalido");
        return;
      }
      _execute({
          "method": "zipcode",
          "zipcode": zipCode
        }, function(data) {
          if (data.resultado === 0) {
            ErrorHandler.showError("cep não encontrado");
            return;
          }
          var address = {};
          if (data.resultado == 1) {
            address.street0 = data.tipo_logradouro + " " + data.logradouro;
            address.street1 = data.bairro;
          }
          address.city = data.cidade;
          address.state = data.uf;
          onSuccess(address);
        },
        ErrorHandler.showError);
    }

    function _getPagseguroSessionId(onSuccess, onFail) {
      onSuccess = onSuccess || function() {};
      onFail = onFail || ErrorHandler.showError;
      //"https://ws.pagseguro.uol.com.br/v2/sessions"
      $http.get(Properties.pagSeguroUrl).success(function (data) {
        onSuccess(data);
      }).error(function () {
        onFail("Não foi possível  se conectar ao Pagseguro!");
      });
    }

    return {
      execute: _execute,
      execute2: _execute2,
      findcep: _findCep,
      getPagseguroSessionId: _getPagseguroSessionId,
      toPayLoad: toPayLoad
    };
  }
})();

/**
 * Created by Danillo on 16/11/2020.
 */
(function() {
    'use strict';
  
    angular
      .module('b2c_ingressos')
      .controller('TrocarDatasController', TrocarDatasController);
  
    /** @ngInject */
    function TrocarDatasController($stateParams, $location, BackEnd, Dialogs, moment, ErrorHandler, MyFunctions, Properties) {
        var vm = this;
        function init(){
            var dialog = Dialogs.wait();
            BackEnd.execute({ "method": "billProducts", "billPath": "bills/" + vm.id, "token": vm.locator },
                function(data) {
                    vm.products = data;
                    dialog.close();
                    angular.forEach(vm.products, function (p) {
                        var adjustDates = false;
                        p._date = MyFunctions.stringToDate(p.date);
                        p._minDate = new Date();
                        p._name = p.shortName || p.name;
                        if(p.deliveryDate) adjustDates = true;                    
                        if(p.produtos && p.select_date) {
                            angular.forEach(p.produtos, function (p2) {                                
                                p2._name = p2.shortName || p2.name;
                                if(p2.deliveryDate) {
                                    adjustDates = true;
                                    p2._date = MyFunctions.stringToDate(p2.date);
                                }
                                vm.availabledates[p2.path] = null;
                            });
                        } else {
                            vm.availabledates[p.path] = null;
                        }                                        
                        if(adjustDates) vm.adjustDates(p);
                    });
                    calendarDate();
                    loadAvailableDate();
                },
                function(err){
                    dialog.close();
                    ErrorHandler.showError(err);
                });
        }
        vm.handleDate = function (p) {
            if(p.deliveryDate) return;
            p._activeDate = true;
        };
        vm.adjustDates = function(p) {
            p._minDate = null;
            p._dates = [];
            angular.forEach(p.produtos, function (p2) {
                if(p2._date) {
                    p._dates.push(MyFunctions.dateToString(p2._date));
                    if(Properties.maxDaysInCombo) {
                        p._minDate = p._minDate || p2._date;
                        if(p2._date < p._minDate) p._minDate = p2._date;
                        p._maxDate = MyFunctions.addDays(p._minDate, Properties.maxDaysInCombo);
                    }
                }
                
            });
        };
        vm.datesByType = [];  
        vm.urlVoucher = null;
        vm.availabledates = {}; 
        vm.today = new Date();       
        function calendarDate() {
            BackEnd.execute2({'method': 'calendarMessages'},
                function (data) {
                    function haveItem(arrItem, param) {
                        return arrItem.some(function (i) {
                            return i.type === param;
                        });
                    }
                    for (var i = 0; i < data.length; i++) {
                        var date = data[i];
                        var dateType = date.tipo || "none";
                        var hasType = haveItem(vm.datesByType, dateType);
                        if (!hasType)
                            vm.datesByType.push({type: dateType, properties: date});
                    }
                    //vm.dt2 = new Date();
                    vm.dt2 = vm.today;                   
                },
                function (err) {
                    ErrorHandler.showError(err);
                }
            );             
        }      
        vm.getDayClass = function (date, mode, item) {
            if (mode === 'day') {
                if (date < vm.today)
                    return 'old';          
                var dateAsString = MyFunctions.dateToString(date);                         
                for (var i = 0; i < vm.datesByType.length; i++) {
                    var dateType = vm.datesByType[i];
                    if (dateType.properties.dates.indexOf(dateAsString) >= 0) {
                        if (dateType.type.match(/Fechado/)) {
                            return 'closed';
                        }                       
                    }
                }
                var _availableDates = vm.availabledates[item.path];
                if(_availableDates != null && _availableDates.indexOf(dateAsString) < 0)
                    return 'unavailable';                 
            }
            return '';
        };
        
        vm.disabledDate = function (date, mode, item) {
            if (mode === 'day') {                
                var dateAsString = MyFunctions.dateToString(date);
                var _availableDates = vm.availabledates[item.path];
                if(_availableDates != null && _availableDates.indexOf(dateAsString) < 0)
                    return true;
                if(item !== null && angular.isDefined(item)) {                    
                    if(MyFunctions.dateToString(item._date) == dateAsString)
                        return true;
                    if(Properties.comboWithDiferentDates && item._dates != null && item._dates.indexOf(dateAsString) >= 0) 
                        return true;   
                    if(item.due && moment(item.due).toDate()< date)
                        return true;
                }
                for (var i = 0; i < vm.datesByType.length; i++) {
                    if (date < vm.today)
                        return true;
                    var dateType = vm.datesByType[i];
                    if (dateType.properties.dates.indexOf(dateAsString) >= 0) {
                        if (dateType.type.match(/Fechado/)) 
                            return true;                        
                    }                    
                }
            }
            return false;
        };
        
        
        function loadAvailableDate() {
            angular.forEach(vm.availabledates , function(value, key){     
                var maxDate = null;
                angular.forEach(vm.products, function (p) {
                   if(p.due !== null && angular.isDefined(p.due) && p.due !== "" && p.path == key) 
                    maxDate = moment(p.due).toDate();
                });
                vm.availabledates[key] = MyFunctions.availableDatesForProduct(key, null, null, maxDate);
            });
        }

        vm.save = function(){
            var products = [];
            angular.forEach(vm.products, function(p){
                if(p.produtos && p.select_date) {
                    angular.forEach(p.produtos, function(p2){
                        if(!p2.deliveryDate && angular.isDefined(p2._date) && p2._date !== null && p2._date !== "" )
                            products.push({entry: p2.entry, date: MyFunctions.dateToString(p2._date) });
                    });
                } else {
                    if(!p.deliveryDate && angular.isDefined(p._date) && p._date !== null && p._date !== "")
                        products.push({entry: p.entry, date: MyFunctions.dateToString(p._date) });
                }
            });
            if(products.length == 0){
                Dialogs.info("Nenhuma nova data selecionada.");
                return;
            }
            var dialog = Dialogs.wait();
            BackEnd.execute({ 
                    "method": "saveBillDates", 
                    "billPath": "bills/" + vm.id, 
                    "token": vm.locator, 
                    "products": JSON.stringify(products) 
                },
                function(bill) {  
                    dialog.close();
                    Dialogs.info("Datas alteradas com sucesso. Imprima seu novo voucher.", null, {windowClass: 'modal-info-success'}, function() {                        
                        vm.urlVoucher = Properties.pdfAddress + "?method=receiptAsByte&receipt=" + bill.voucher + "&id=" + bill.id + "&token=" + bill.voucherToken;                        
                    });
                },
                function(err){
                    dialog.close();
                    ErrorHandler.showError(err);
                });
        };

        if (angular.isDefined($stateParams.id) && $stateParams.id.length > 0 &&
            angular.isDefined($stateParams.token) && $stateParams.token.length > 0) {
            vm.id = $stateParams.id;
            vm.locator = $stateParams.token;
            init();
        } else {
            $location.path("/");
            return;
        }
    }
  })();
/**
 * Created by Danillo on 16/11/2020.
 */
(function() {
    'use strict';

    angular
      .module('b2c_ingressos')
      .controller('ReagendamentoController', ReagendamentoController);

    /** @ngInject */
    function ReagendamentoController($state, $stateParams, $location, localStorageService, BackEnd, Dialogs, moment, ErrorHandler, MyFunctions, Properties) {
        var vm = this;
        vm.originalDate = null;
        vm.date = null;
        vm.canRemarkDate = true;
        vm.availabledates = [];
        vm.datesByType = [];
        vm.urlVoucher = null;
        vm.today = new Date();
        vm.bill = null;
        vm.newPrice = 0;
        vm.diffPrice = 0;
        function init(){
            var dialog = Dialogs.wait();
            BackEnd.execute({ "method": "billProducts", "billPath": "bills/" + vm.id, "token": vm.locator },
                function(data) {
                    vm.products = data;
                    dialog.close();
                    var grouped = {};
                    angular.forEach(vm.products, function(p) {
                      var _name = p.shortName || p.name;
                      if (!grouped[_name]) {
                        grouped[_name] = 0;
                      }
                      grouped[_name] += parseInt(p.amount,10) || 1;
                    });
                    var summary = Object.keys(grouped).map(function(name) {
                      return grouped[name] + 'x ' + name;
                    }).join(', ');
                    vm.productsSummary = summary;
                    vm.date = MyFunctions.stringToDate(vm.products[0].date);
                    vm.originalDate = vm.products[0].date;
                    angular.forEach(vm.products, function (p) {
                        if(p.deliveryDate) vm.canRemarkDate = false;
                        if(p.produtos && p.select_date) {
                            angular.forEach(p.produtos, function (p2) {
                                p2._name = p2.shortName || p2.name;
                                if(p2.deliveryDate) {
                                    vm.canRemarkDate = false;
                                }
                            });
                        }
                    });
                    calendarDate();
                    loadAvailableDate();
                },
                function(err){
                    dialog.close();
                    ErrorHandler.showError(err);
                }
            );
            BackEnd.execute({ "method": "billById", "billPath": "bills/" + vm.id, "token": vm.locator }, 
                function(data) {
                    if(data.permiteReagendamentoConta != "true"){
                        Dialogs.info("Reagendamento não permitido para esta conta (" + vm.id + ").");
                        $location.path("/");
                        return;
                    }
                    if(data.pagamento != "pago"){
                        Dialogs.info("A Conta #" + vm.id + " possui valor em aberto. Reagendamento não permitido.");
                        $location.path("/");
                        return;
                    }
                    vm.bill = data;
                }
            );
            // ToDo: encontrar conta por id e token
            // ToDo: calcular diferença de valores
            // ToDo: abrir tela de pagamento se houver diferença a pagar
        }


        vm.handleDate = function () {
            vm.activeDate = true;
        };
        vm.adjustDates = function(p) {
            p._minDate = null;
            p._dates = [];
            angular.forEach(p.produtos, function (p2) {
                if(p2._date) {
                    p._dates.push(MyFunctions.dateToString(p2._date));
                    if(Properties.maxDaysInCombo) {
                        p._minDate = p._minDate || p2._date;
                        if(p2._date < p._minDate) p._minDate = p2._date;
                        p._maxDate = MyFunctions.addDays(p._minDate, Properties.maxDaysInCombo);
                    }
                }

            });
        };

        function calendarDate() {
            BackEnd.execute2({'method': 'calendarMessages'},
                function (data) {
                    function haveItem(arrItem, param) {
                        return arrItem.some(function (i) {
                            return i.type === param;
                        });
                    }
                    for (var i = 0; i < data.length; i++) {
                        var date = data[i];
                        var dateType = date.tipo || "none";
                        var hasType = haveItem(vm.datesByType, dateType);
                        if (!hasType)
                            vm.datesByType.push({type: dateType, properties: date});
                    }
                    //vm.dt2 = new Date();
                    vm.dt2 = vm.today;
                },
                function (err) {
                    ErrorHandler.showError(err);
                }
            );
        }
        function calendarDateConfig(date) {
            var dateAsString = MyFunctions.dateToString(date);
            var _availableDates = vm.availabledates;
            if (date < vm.today || dateAsString == vm.originalDate)
                return [ true, 'closed old'];

            if(_availableDates != null && _availableDates.indexOf(dateAsString) < 0)
                return [ true, 'closed unavailable'];
            for (var i = 0; i < vm.datesByType.length; i++) {
                var dateType = vm.datesByType[i];
                if (dateType.properties.dates.indexOf(dateAsString) >= 0) {
                    var normalizedType = dateType.type.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                    if (normalizedType.match(/fechado/)) return [true, 'closed'];
                    if(normalizedType.match(/em breve/)) return [true, 'closed em-breve'];
                    if (normalizedType.match(/esgotado/)) return [true, 'closed esgotado'];
                    if (normalizedType.match(/restrito/)) return [true, 'closed restrito'];                    
                }
            }
            return [false, ''];
        }
        vm.getDayClass = function (date, mode) {
            if (mode === 'day') {
                return calendarDateConfig(date)[1];                
            }
            return '';
        };

        vm.disabledDate = function (date, mode) {
            if (mode === 'day') {
                return calendarDateConfig(date)[0];
            }
            return false;
        };

        function loadAvailableDate() {
          var productsPaths = [];
          vm.availabledates = [];
          angular.forEach(vm.products, function (p) {
              if(productsPaths.indexOf(p.path) >= 0) return;
              productsPaths.push(p.path);
              MyFunctions.availableDatesForProduct(p.path, null, null, null, function(availabledates){
                if(availabledates == null) return;
                if(vm.availabledates.length == 0) {
                  vm.availabledates = availabledates;
                  return;
                }
                vm.availabledates = vm.availabledates.filter(function(date) {
                    return availabledates.indexOf(date) !== -1;
                });
              });              
          });
        }

        /**
         * Abrir data piker
         * @returns {undefined}
         */
        vm.openDatePickerModal = function() {
            Dialogs.datePickerDialog("Nova data da visita", vm.date, function(date) {
                vm.date = date;
                vm.calculateDiffPrice();
            }, {},{
                minDate: vm.today,
                customClass: vm.getDayClass,
                dateDisabled: vm.disabledDate
            });
        };


        vm.calculateDiffPrice = function() {
            var ps = vm.products;
            angular.forEach(ps, function(p){
                p.date = vm.date;
                if(p.produtos) {
                    angular.forEach(p.produtos, function(p2){                        
                        p2.date = vm.date;
                    });
                }
            });
            var params = {
                "method": "billPrice",
                "productsArray": MyFunctions.productosToString(ps),
                "oldBillPath": "bills/" + vm.id,
                "oldBillToken": vm.locator
            };
            var dialog = Dialogs.wait();
            BackEnd.execute2(params,
                function (data) {
                    dialog.close();
                    data.value = parseInt(data.value,10);
                    vm.newPrice = data;
                    if(vm.bill.value != data.value) {
                        vm.diffPrice = data.value - vm.bill.value;
                    } else {
                        vm.diffPrice = 0;
                    }
                }, function (err) {
                    dialog.close();
                    ErrorHandler.showError(err);
                });
        };

        vm.save = function(){
            if(vm.date == null){
                Dialogs.info("Nenhuma nova data selecionada.");
                return;
            }
            var dialog = Dialogs.wait();
            BackEnd.execute({
                    "method": "alterBillDates",
                    "billPath": "bills/" + vm.id,
                    "token": vm.locator,
                    "dateAsString": MyFunctions.dateToString(vm.date),
                    "diffPrice": vm.diffPrice
                },
                function(bill) {
                    dialog.close();
                    localStorageService.cookie.remove("bill_remark_dates");
                    if(vm.diffPrice<=0) {
                        Dialogs.info("Datas alteradas com sucesso. Imprima seu novo voucher.", null, {windowClass: 'modal-info-success'}, function() {
                            vm.urlVoucher = Properties.pdfAddress + "?method=receiptAsByte&receipt=" + bill.voucher + "&id=" + bill.id + "&token=" + bill.voucherToken;
                        });
                    } else {
                        Dialogs.info("A data foi alterada. Por favor, realize o pagamento da diferença para gerar o novo voucher.", null, {windowClass: 'modal-info-success'}, function() {
                            if(bill.paymentUrl == null || angular.isUndefined(bill.paymentUrl)) {
                                $state.go("compras");
                                return;
                            }
                            window.location.href = bill.paymentUrl;
                        });
                    }
                },
                function(err){
                    dialog.close();
                    ErrorHandler.showError(err);
                    init();
                });
        };
        vm.id = null;
        vm.locator = null;
        var oldBill = localStorageService.cookie.get("bill_remark_dates");
        if(oldBill != null ) {
          vm.id = oldBill.id;
          vm.locator = oldBill.token;
        } else if (angular.isDefined($stateParams.id) && $stateParams.id.length > 0 &&
            angular.isDefined($stateParams.token) && $stateParams.token.length > 0) {
            vm.id = $stateParams.id;
            vm.locator = $stateParams.token;
        }
        if(vm.id == null || vm.locator == null) {
            $location.path("/");
            return;
        }
        init();
    }
  })();

(function(){
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('ReservarOrcamentoController', ReservarOrcamentoController);

    /** @ngInject */
    function ReservarOrcamentoController(BackEnd, Search, $state, $stateParams, ErrorHandler){
        var vm = this;

        vm.itemId = null;
        function getItem(itemId, person, token){  
            BackEnd.execute({
                "method": "createItemPerson",
                "person": person,
                "item": itemId,
                "token": token
            },
            function (data) {               
                vm.itemId = itemId;          
                vm.item = data;
                vm.select(vm.item);
              },
              ErrorHandler.showError              
            );

        }
        function adt(item){
            var adt = 0;
            for (var i = 0; i < item.persons.length; i++) {
                var t = item.persons[i];
                if (angular.isUndefined(t.tag) || t.tag == "Adulto") adt++;
            }
            return adt;
        }
        function chd(item){
            var chd = 0;
            for (var i = 0; i < item.persons.length; i++) {
                var t = item.persons[i];
                if (t.tag == "Criança")  chd++;
            }
            return chd;
        }

        function colo(item){
            var colo = 0;
            for (var i = 0; i < item.persons.length; i++) {
                var t = item.persons[i];
                if (t.tag == "Colo")  colo++;
            }
            return colo;
        }  

        vm.select = function(){                                    
            var hotel = { "item": {
                service : vm.item.hotelName
            }};
            Search.setSelectHotel(hotel);
            vm.item._adultos = adt(vm.item);
            vm.item._chd = chd(vm.item);
            vm.item._colo = colo(vm.item);
            if(angular.isUndefined(vm.item.customData) || vm.item.customData === null)
                vm.item.customData = {};
            vm.item.customData.orcamento = vm.itemId;
            Search.addSelectUh(vm.item);
            $state.go("hospedagemIdentificacao");            
        };
        
        init();

        function init(){
            if (angular.isDefined($stateParams.id) && $stateParams.id !== null && $stateParams.id !== "") {
                getItem($stateParams.id, $stateParams.person, $stateParams.token);
            }
        }

    }

}());
(function() {
    'use strict';

    angular
      .module('b2c_ingressos')
      .controller('SEOController', SEOController);

    /** @ngInject */
    function SEOController($http, $state, Tracking, $log){
      /* jshint validthis:true */
      //var vm = this;
      var allRoutes = {};

      $http.get('routes.json').success(function (data){
        if(angular.isUndefined(data) || data == null || !data || data == {}){
          return;
        }
        allRoutes = data;
        setAttributeRoutes();
      }).error(function (error){
        $log.debug(error);
      });

      function setAttributeRoutes(){
          var title = document.querySelector('title');
          var titleMeta = document.querySelector('meta[name="title"]');
          var description = document.querySelector('meta[name="description"]');
          var keywords = document.querySelector('meta[name="keywords"]');
          var canonical = document.querySelector('link[rel="canonical"]');

          function update() {
            var route = Object.assign(
              allRoutes.default,
              allRoutes[$state.current.url.replaceAll(/\?.*/g,'')]
            );

            if(angular.isUndefined(route) || route == null) return;
            if(route.title) {
              title.textContent = route.title;
              titleMeta.setAttribute('content',route.title);
            }
            if(route.description) description.setAttribute('content',route.description);
            if(route.keywords) keywords.setAttribute('content',route.keywords);
            if(angular.isDefined(canonical) && canonical !== null && route.canonical)
              canonical.setAttribute('href',route.canonical);
          }
          Tracking.addListener(Tracking.types.PageView, function(){
            update();
          });
          update();
      }
    }
  }
)();
(function() {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('PromocoesController', PromocoesController);

    /** @ngInject **/
    function PromocoesController($uibModal, Search, BackEnd, ErrorHandler, MyFunctions, Dialogs, $log, $state) {
        var vm = this;
        vm.promocoes = [];
        vm.dates = [];
        var calculatePrice = Search.calculatePrice;

        function adt(item) {
            var adt = 0;
            for (var i = 0; i < item.persons.length; i++) {
                var t = item.persons[i];
                if (angular.isUndefined(t.tag) || t.tag == "Adulto")
                    adt++;
            }
            return adt;
        }

        function personsByTag(item, tag) {
            var amount = 0;
            for (var i = 0; i < item.persons.length; i++) {
                var t = item.persons[i];
                if (t.tag == tag) amount++;
            }
            return amount;
        }

        function chd(item) {
            return personsByTag(item, "Criança");
        }

        function colo(item) {
            return personsByTag(item, "Colo");
        }
        function terceiraIdade(item) {
            return personsByTag(item, "Terceira Idade");
        }

        for (var i = 0; i < 12; i++) {
            var month = MyFunctions.firstDayOfMonth(new Date());
            vm.dates.push(MyFunctions.addMonths(month, i));
        }
        vm.hasPromocao = function(date) {
            if (vm.promocoes === null || vm.promocoes.length == 0) return false;
            var pp = vm.promocoes.filter(function(p) {
                var checkin = MyFunctions.stringToDate(p.checkin);
                var checkout = MyFunctions.stringToDate(p.checkout);
                if (date.getMonth() != checkin.getMonth() && date.getMonth() != checkout.getMonth())
                    return false;
                return true;
            });
            return pp !== null && pp.length > 0;
        };
        vm.toogleMonth = function(mes) {
            if (mes == vm.mesEscolhido)
                vm.mesEscolhido = null;
            else
                vm.mesEscolhido = mes;
            createGroups();
        };
        vm.filterMonth = function(p) {
            if (vm.mesEscolhido === null || angular.isUndefined(vm.mesEscolhido))
                return true;
            var checkin = MyFunctions.stringToDate(p.checkin);
            var checkout = MyFunctions.stringToDate(p.checkout);
            if (vm.mesEscolhido.getMonth() != checkin.getMonth() && vm.mesEscolhido.getMonth() != checkout.getMonth())
                return false;
            return true;
        };
        function createGroups() {
            var i = 0;
            var group = [];
            vm.promocoesGroup = [];
            vm.promocoes.sort(function (a, b) {
              return parseInt(b.order, 10) - parseInt(a.order, 10);
            });

            angular.forEach(vm.promocoes, function (p) {
                if(!vm.filterMonth(p))
                    return;
                group.push(p);
                i++;
                if (i % 4 == 0) {
                    vm.promocoesGroup.push(group);
                    group = [];
                }
            });
            if (group.length > 0){
              vm.promocoesGroup.push(group);
            }

        }
        vm.modalGaleria = function(pacote) {
            var item = pacote.item;
            var fotos = [];
            if (angular.isDefined(pacote.pictureUrl) && pacote.pictureUrl !== null)
                fotos.push(pacote.pictureUrl);
            if (angular.isDefined(item.foto) && item.foto.length === 0) {
                fotos = fotos.concat(item.foto.split("\\").join("/").split("|"));
            }

            Dialogs.galeria(function() {
                return item.service;
            }, function() {
                return fotos;
            }, {});
        };
        vm.picture = function(p) {
            if (angular.isDefined(p.pictureUrl) && p.pictureUrl !== "" && p.pictureUrl !== null)
                return p.pictureUrl;
            if (angular.isDefined(p.hotelFotos) && p.hotelFotos.length > 0)
                return p.hotelFotos[0];
            return p.uhFoto;
        };

        vm.openModalCountAdultosCriancas = function(p, success) {
            success = success || function(item) {
                $log.debug(p, item);
            };
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: "app/components/xsBarraFooter/modais/openModalCountAdultosCriancas.html",
                bindToController: true,
                controller: ItemModalController,
                controllerAs: "vm",
                size: 'lg',
                resolve: {
                    pacote: function() {
                        return p;
                    }
                }
            });
            modalInstance.result.then(function(persons) {
                p.item.persons = persons;
                travelersAmount2(p);
                calculatePrice(null, p.item, success);
            });
        };
        /** @ngInject */
        function ItemModalController($uibModalInstance, pacote) {
            var vm = this;
            vm.searchButtonText = "Continuar";
            vm.adt = adt(pacote.item);
            vm.chd = chd(pacote.item);
            vm.colo = colo(pacote.item);
            vm.terceiraIdade = terceiraIdade(pacote.item);
            vm.dates = {
                date: pacote.checkin,
                endDate: pacote.checkout
            };
            vm.dismiss = function() {
                $uibModalInstance.dismiss();
            };
            vm.search = function() {
                var persons = [];
                var i = 0;
                for (i = 0; i < vm.adt; i++) {
                    persons.push({ tag: "Adulto" });
                }
                for (i = 0; i < vm.chd; i++) {
                    persons.push({ tag: "Criança" });
                }
                for (i = 0; i < vm.colo; i++) {
                    persons.push({ tag: "Colo" });
                }
                for (i = 0; i < vm.terceiraIdade; i++) {
                    persons.push({ tag: "Terceira Idade" });
                }
                pacote.travelersAmount = vm.adt + " Adultos";
                if (vm.chd > 0)
                    pacote.travelersAmount += " " + vm.chd + " Crianças";
                if (vm.colo > 0)
                    pacote.travelersAmount += " " + vm.colo + " Colos";
                if (vm.terceiraIdade > 0)
                    pacote.travelersAmount += " " + vm.terceiraIdade + " Melhor Idade";
                pacote.item.value = null;
                $uibModalInstance.close(persons);
            };
        }

        function travelersAmount2(pacote) {
            var ta = adt(pacote.item) + " Adultos";
            var _chd = chd(pacote.item);
            if (_chd > 0) {
                ta += ", " + _chd + " CHD";
            }
            var _colo = colo(pacote.item);
            if (_colo > 0) {
                ta += ", " + _colo + " COL";
            }
            var _terIdade = terceiraIdade(pacote.item);
            if (_terIdade > 0) {
                ta += ", " + _terIdade + " terceiraidade";
            }
            if (ta.length > 10) ta = ta.replace("Adultos", "ADT");
            pacote.travelersAmount2 = ta;
        }

        vm.select = function(p) {
            if (angular.isUndefined(p.item))
                return;
            vm.openModalCountAdultosCriancas(p, function() {
                var p2 = {};
                angular.copy(p, p2);
                p2.item.service = p2.hotel;
                Search.setSelectHotel(p2);
                p.item._adultos = adt(p.item);
                p.item._chd = chd(p.item);
                p.item._colo = colo(p.item);
                p.item._terceiraIdade = terceiraIdade(p.item);
                Search.addSelectUh(p.item);
                $state.go("hospedagemIdentificacao");
            });
        };

        /*
         * foto
         * memorando
         * texto
         * ordem
         */


        activate();
        ////////////////
        function getItem(pacote, callback) {
            callback = callback || function() {};
            var persons = [];
            pacote._checkin = MyFunctions.stringToDate(pacote.checkin);
            pacote._checkout = MyFunctions.stringToDate(pacote.checkout);
            angular.forEach(pacote.travelers, function(t) {
                persons.push({ tag: t.tipo === null || angular.isUndefined(t.tipo) ? "Adulto" : t.tipo });
            });
            BackEnd.execute({
                    "method": "createItem",
                    "item": pacote.path
                },
                function(data) {
                    pacote.item = data;
                    pacote.item.persons = persons;
                    travelersAmount2(pacote);
                    callback();
                },
                function(error) {
                    pacote.erro = error;
                    callback();
                }
            );

        }

        function ordernaDataCheckin(data1, data2) {
            var dt1 = data1.checkin.split('/')
            var dt2 = data2.checkin.split('/')
            return new Date(dt1[1] + '/' + dt1[0] + '/' + dt1[2]) - new Date(dt2[1] + '/' + dt2[0] + '/' + dt2[2])
        }

        function activate() {
            var dialogs = Dialogs.wait();
            BackEnd.execute({
                    "method": "findBudgetToPromotional",
                    "dateAsString": MyFunctions.dateToString(new Date())
                },
                function(data) {
                    dialogs.close();
                    vm.promocoes = data;
                    vm.promocoes.sort(ordernaDataCheckin);
                    angular.forEach(vm.promocoes, function(p){
                        var ch = p.travelersAmount;
                        p.travelersAmount = ch.replace("Criança", "Crianças");
                    });
                    createGroups();
                    var i = 0;
                    var getItensRecusive = function() {
                        if (i >= vm.promocoes.length)
                            return;
                        getItem(vm.promocoes[i++], getItensRecusive);
                    };
                    getItensRecusive();
                },
                function(err) {
                    dialogs.close();
                    ErrorHandler.showError(err);
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .controller('PromocaoController', PromocaoController);

    /** @ngInject **/
    function PromocaoController($location, $stateParams, Search, BackEnd, ErrorHandler, Dialogs, $state) {
        var vm = this;
        
        if (angular.isUndefined($stateParams.id) || $stateParams.id === null || $stateParams.id === "") {
            ErrorHandler.showError("Link Incorreto!");
            return;
        }
        
        var idOferta = $stateParams.id;
        var searchPersons = $location.search().persons;
        
        executeCreateItem();
        function executeCreateItem(){
            var parametros = {};
            
            parametros.method = "createItem";
            parametros.item = idOferta;
            
            var dialog = Dialogs.wait();
            BackEnd.execute(
                    parametros,
                    function (data) {
                        dialog.close();
                        data.persons = JSON.parse(searchPersons);
                        vm.executeOferta(data); 
                    },
                    function (error) {
                        dialog.close();
                        ErrorHandler.showError(error);
                    }
            );
        }


        vm.executeOferta = function (oferta) {
            var hotel = {"item": {service: oferta.hotelName}};
            
            Search.setSelectHotel(hotel);

            oferta._adultos = adt(oferta);
            oferta._chd = chd(oferta);
            oferta._colo = colo(oferta);

            Search.calculatePrice(null, oferta, function(){
                Search.addSelectUh(oferta);
                $state.go("hospedagemIdentificacao");
            });

        };

        function adt(item) {
            var adt = 0;
            for (var i = 0; i < item.persons.length; i++) {
                var t = item.persons[i];
                if (angular.isUndefined(t.tag) || t.tag == "Adulto") {
                    adt++;
                }
            }
            return adt;
        }

        function chd(item) {
            var chd = 0;
            for (var i = 0; i < item.persons.length; i++) {
                var t = item.persons[i];
                if (t.tag == "Criança") {
                    chd++;
                }
            }
            return chd;
        }

        function colo(item) {
            var colo = 0;
            for (var i = 0; i < item.persons.length; i++) {
                var t = item.persons[i];
                if (t.tag == "Colo") {
                    colo++;
                }
            }
            return colo;
        }


    }

})();
(function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('ProdutosController', ProdutosController);

    /** @ngInject */
    function ProdutosController() {
        // var vm = this;

        // vm.step = 0;
        // vm.serverAddress = serverAddress();
        // vm.enderecoRequerido = HM.properties.enderecoRequerido;
        // vm.totalComCupom = null;
        // vm.amounts = ['0'];
        // vm.produtos =[];
        // vm.produtoSelecionado = null;
        // vm.search = {persons: "1 pessoa"};
        // vm.ingToken = null;
        // var parameters = $location.search();
        // if(parameters.ingToken != null && parameters.ingToken.length > 0) {
        //     vm.ingToken =  parameters.ingToken;
        // }
        //
        // vm.pluralize = function (name, count) {
        //     if (count === undefined || count === 1 || count === "1") return name;
        //     return name + 's';
        // };
        // vm.productName = function(produto){
        //     if(produto === null) return "";
        //     return produto.shortName != null && produto.shortName.length > 0 ? produto.shortName : produto.name;
        // }
        // vm.extraProductValue = function(produto){
        //     if(produto.amount == 0) return produto.value;
        //     return produto.amount * produto.value;
        // }
        // vm.clearAdicional = function(produto){
        //     if(!produto.enable) produto.amount = 0;
        //     else produto.amount = 1;
        // }
        // vm.scrollTo = function(to) {
        //     $timeout(function () {
        //         var value = to;
        //         if(value == 'step2a' && vm.produtosExtras.length == 0) value = 'step2';
        //         var selector = "[id='" + value + "']";
        //         var el = angular.element(selector);
        //         var offset = 0;
        //         if (el.length) {
        //             if (el.attr("bookmark-offset"))
        //                 offset = el.attr("bookmark-offset");
        //             angular.element('html,body').animate({scrollTop: el[0].offsetTop - offset}, {
        //                 duration: 'slow',
        //                 easing: 'swing'
        //             });
        //         }
        //     }, 18);
        // };
        // /// trackAnalitcs
        // var getCarrinho = function(){
        //     var cart = [];
        //     if(vm.produtoSelecionado != null) cart.push(vm.produtoSelecionado);
        //     return cart;
        // }
        //
        // var addProductToGA = function(cart){
        //     if (ga === null) return;
        //     for(var i = 0; i < cart.length; i++) {
        //         var produto = cart[i];
        //         ga('ec:addProduct', {'id': produto.id,'name': produto.name,'variant': produto.type,'price': produto.value /100, 'quantity': produto.amount });
        //     }
        // }
        // vm.trackCheckout = function(){
        //     if(ga === null) return;
        //     var cart = getCarrinho();
        //     addProductToGA(cart);
        //     ga('ec:setAction','checkout', {'step': 1});
        //     ga('send', 'pageview');
        // }
        // vm.trackTerms = function(){
        //     if(ga === null) return;
        //     var cart = getCarrinho();
        //     addProductToGA(cart);
        //     ga('ec:setAction','checkout', { 'step': 2 });
        //     ga('send', 'pageview');
        // }
        //
        // var trackLogin = function() {
        //     if (ga === null) return;
        //     var cart = getCarrinho();
        //     addProductToGA(cart);
        //     ga('ec:setAction','checkout', { 'step': 3 });
        //     ga('send', 'pageview');
        // };
        //
        // var trackComprar = function(){
        //     if (ga === null) return;
        //     var cart = getCarrinho();
        //     addProductToGA(cart);
        //     ga('ec:setAction','checkout', { 'step': 4 });
        //     ga('send', 'pageview');
        // }
        //
        // var trackTransaction = function(id, value, bandeira, coupon){
        //     if (ga === null) return;
        //     var cart = getCarrinho();
        //     addProductToGA(cart);
        //     ga('ec:setAction', 'purchase', {
        //         'id': 'C' + id,
        //         'revenue': value / 100,
        //         'option': bandeira,
        //         'coupon': coupon // User added a coupon at checkout.
        //     });
        //     ga('send', 'pageview');
        // }
        // ///
        //
        // vm.showWait = false;
        // vm.$on('handleShowWait', function(event, args) {
        //     vm.showWait = args.value;
        // });
        // vm.$on('handleChangeServer', function(event, args) {
        //     vm.limparCarrinho();
        //     vm.step=0;
        // });
        //
        // vm.selectProduto = function(produto){
        //     if(ga !== null){
        //         ga('ec:addProduct', {
        //             'id': produto.id,
        //             'name': produto.name,
        //             'variant': produto.type,
        //             'price': produto.value /100,
        //             'quantity': 1
        //         });
        //         ga('ec:setAction', 'add');
        //     }
        //     produto.amount = 1;
        //     vm.produtoSelecionado = produto;
        //     vm.step = 2;
        //     vm.scrollTo('step2');
        //     vm.trackCheckout();
        //     paymentMethods2();
        // }
        // vm.wait = true;
        // vm.productsByTag = function() {
        //     vm.wait = true;
        //     vm.produtos = [];
        //     vm.produtoSelecionado = null;
        //     vm.$emit('showWait', {value: true});
        //     vm.$emit('trackEvent', {category: 'BuscaProduto',name: vm.date});
        //     var params1 = { "callback": "JSON_CALLBACK", "method": "getPassaportes", "ingToken": vm.ingToken};
        //     $http({method: 'JSONP', url: serverAddress() + HM.properties.execute, params: params1 }).
        //         success(function(data, status) {
        //             if(data.erro != null){
        //                 vm.produtos = [];
        //                 vm.wait = false;
        //                 alert(data.erro);
        //             } else {
        //                 vm.produtos = data;
        //                 if (ga != null) {
        //                     for (var j = 0; j < vm.produtos.length; j++) {
        //                         var produto = vm.produtos[j];
        //                         ga('ec:addImpression', {  // Provide product details in an impressionFieldObject.
        //                             'id': produto.id,
        //                             'name': produto.name,
        //                             'variant': produto.type,
        //                             'price': produto.value / 100,
        //                             //'list': 'Busca Por Data', // Product list (string).
        //                             'position': j + 1  // Product position (number).
        //                         });
        //                     }
        //                     ga('send', 'pageview');
        //                 }
        //                 vm.wait = false;
        //             }
        //             vm.$emit('showWait', {value: false});
        //         }).error(function(data, status) {
        //             alert(data.erro);
        //             vm.wait = false;
        //             vm.$emit('showWait', {value: false});
        //         });
        // }
        //
        // vm.image = function(produto){
        //     return ((produto.image == null || produto.image.length == 0)? "logo2.png" : produto.image.split("|")[0].split("\\").join("/"));
        // }
        //
        // vm.limparCarrinho = function(){
        //     vm.produtoSelecionado = null;
        // }
        //
        // vm.quantidadeGeral = function(){
        //     return vm.produtoSelecionado == null ? 0 : 1;
        // }
        //
        // vm.totalGeral = function(date){
        //     return vm.produtoSelecionado == null ? 0 : (vm.produtoSelecionado.amount * vm.produtoSelecionado.value);
        // }
        //
        // vm.findCep = function(){
        //     findCep(vm, $http, vm.user);
        // }
        //
        // vm.login = function(){
        //     vm.$emit('showWait', {value: true});
        //     vm.$emit('trackEvent', {category: 'login',name: vm.email});
        //     login($http, $cookieStore, vm.email, vm.password, function(){
        //         vm.step=4;
        //         vm.user = HM.properties.user;
        //         vm.logado = true;
        //         vm.$emit('showWait', {value: false});
        //         vm.$emit('loginLogoff', HM.properties.user);
        //         vm.showLoginForm=false;
        //         vm.showClienteLogado=true;
        //         vm.scrollTo('step4');
        //         trackLogin();
        //     }, function(){
        //         vm.$emit('showWait', {value: false, error: 'Email ou senha incorretos.'});
        //     });
        // }
        //
        // vm.forgetPass = function(){
        //     vm.$emit('showWait', {value: true});
        //     var onSuccess = function(){
        //         vm.$emit('showWait', {value: false});
        //         alert("email enviado");
        //     };
        //     var onError =  function(){
        //         vm.$emit('showWait', {value: false, error: "Email não encontrado."});
        //     };
        //     forgetPass($http, vm.email, onSuccess, onError);
        // }
        //
        // vm.savePerson = function(){
        //     vm.$emit('showWait', {value: true});
        //     vm.$emit('trackEvent', {category: 'SalvarPessoa',name: vm.user.name});
        //     savePerson($http, $cookieStore, vm.user, vm.password, function(){
        //         vm.step=4;
        //         vm.user = HM.properties.user;
        //         vm.logado = true;
        //         vm.showNewUserForm = false;
        //         vm.showClienteLogado=true;
        //         vm.$emit('showWait', {value: false});
        //         vm.scrollTo('step4');
        //         trackLogin();
        //     }, function(){
        //         vm.$emit('showWait', {value: false, error: "Ocorreu um erro. Tente novamente."});
        //     });
        // }
        //
        // var productosToString = function(){
        //     var result = "";
        //     var produto = vm.produtoSelecionado;
        //     result += produto.id + "," + produto.amount + "," + dateToString(new Date());
        //     if(produto.type == "Combo") result += ",c";
        //     return result;
        // }
        // vm.$watch('step', function (new_value, old_value) {
        //     if(new_value >= 4) {
        //         paymentMethods2();
        //     }
        // });
        //
        //
        // var paymentMethods2 = function(){
        //     var produtosAsString = productosToString();
        //     var params1 = { "callback": "JSON_CALLBACK", "method": "paymentMethods", "productsArray": produtosAsString, "cupomAsString": vm.cupomCod + "|" + vm.cupomKey };
        //     vm.$emit('showWait', {value: true});
        //     vm.$emit('trackEvent', {category: 'FormaDePagamento',name: produtosAsString});
        //     $http({method: 'JSONP', url: serverAddress() + HM.properties.execute, params: params1 }).
        //         success(function(data, status) {
        //             if(data.erro != null){
        //                 vm.$emit('showWait', {value: false, error: data.erro});
        //                 alert(data.erro);
        //             } else {
        //                 vm.$emit('showWait', {value: false});
        //                 vm.paymentMethods =  data;
        //             }
        //         }).error(function(data, status) {
        //             vm.$emit('showWait', {value: false, error: "Falha de comunicação."});
        //             alert("Falha de comunicação.")
        //         });
        // }
        //
        // vm.parcelas = function(n){
        //     var amount =  (vm.totalGeral() / n) / 100
        //     return n + "x de " + $filter('currency')(amount,'R$ ');
        // }
        //
        // vm.financialLength = function() {
        //     var result = [];
        //     if(vm.paymentMethods == null || vm.paymentMethods == undefined) return result;
        //     var maxParcela = null;
        //     try
        //     {
        //         maxParcela = vm.paymentMethods[vm.paymentMethod.type.toLowerCase()];
        //     }
        //     catch(err)
        //     {
        //         maxParcela = 1;
        //     }
        //     for(var i=1;i<= maxParcela; i++){
        //         result.push(i);
        //     }
        //     return result;
        // }
        //
        // var firstTry = true;
        // vm.comprar  = function() {
        //     if(vm.user == null){
        //         alert("Por favor efetue login.");
        //         return;
        //     }
        //     if(!vm.aceitoTerms) {
        //         alert("Você não aceitou os termos de compra.");
        //         return;
        //     }
        //     var methodName = "buy";
        //     if(vm.paymentMethod.type == "Boleto") {
        //         methodName = "buyWithBoleto";
        //     } else if(vm.paymentMethod.type == "PayPal") {
        //         methodName = "buyWithPayPal";
        //     } else {
        //         if(vm.paymentMethod.cardNumber == null || vm.paymentMethod.cardNumber == "") vm.paymentMethod.cardNumber = vm.paymentMethod.cardNumber2;
        //         if(!validateCard(vm.paymentMethod)) {
        //             return;
        //         }
        //     }
        //     vm.paymentMethod.value = vm.totalGeral();
        //     var buyValue =  vm.paymentMethod.value;
        //     var produtosAsString = productosToString();
        //     var couponAsString = null;
        //     if(vm.cupomCod && vm.cupomKey){
        //         couponAsString = vm.cupomCod + "|" + vm.cupomKey;
        //     }
        //     var params1 = { "callback": "JSON_CALLBACK", "method": methodName, "productsArray": produtosAsString, "personAsString": {id: vm.user.id, forSave: false}, "paymentMethodAsString": vm.paymentMethod, "dateAsString": dateToString(vm.date), "couponAsString": couponAsString };
        //     vm.paymentMethod = {
        //         type: vm.paymentMethod.type, length: vm.paymentMethod.length, personName:"", cardNumber:"", code:"", goodThru:""
        //     };
        //     vm.$emit('showWait', {value: true});
        //     if(firstTry){
        //         trackComprar();
        //         firstTry = false;
        //     }
        //     $http({method: 'JSONP', url: serverAddress() + HM.properties.execute, params: params1 }).
        //         success(function(data, status) {
        //             if(data.erro != null){
        //                 vm.$emit('showWait', {value: false, error: data.erro});
        //                 alert(data.erro);
        //             } else if(data.id == null ) {
        //                 vm.$emit('showWait', {value: false, error: "Falha de comunicação. Transação não efetuada."});
        //                 alert("Falha de comunicação. Transação não efetuada.");
        //             } else {
        //                 vm.$emit('showWait', {value: false});
        //                 vm.$emit('trackEvent', {category: 'Compra', name: vm.user.name, value: (buyValue / 100) });
        //                 trackTransaction(data.id, buyValue, vm.paymentMethod.type, couponAsString);
        //                 $location.path("/reservations").search({"path": data.path });
        //             }
        //         }).error(function(data, status) {
        //             vm.$emit('showWait', {value: false, error: "Falha de comunicação. Transação não efetuada."});
        //             alert("Falha de comunicação. Transação não efetuada.");
        //         });
        // }
        // vm.productsByTag();
    }

})();

/**
 * Created on 13/02/2020.
 */

 (function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('PrePagamentoController', PrePagamentoController);

	/** @ngInject */
    function PrePagamentoController($location, $filter, $cardType, ErrorHandler, Properties, Dialogs, localStorageService, $http) {
        var vm = this;

        vm.noRequiredCpf = Properties.noRequiredCpf;
        vm.pdfAddress = Properties.pdfAddress;
        vm.id = null;
        vm.cardType = null;
        vm.cardTypes = ["Visa", "Mastercard"];
        vm.aceitoTerms = false;
        vm.brands = [];
        var serverUrl = Properties.prepagamentoServer || Properties.token.url;
        if (Properties.paidBillCardTypes !== null) vm.cardTypes = Properties.paidBillCardTypes;
        vm.isPaid = false;
        var parameters = $location.search();
        if (parameters.id !== null && angular.isDefined(parameters.id) && parameters.id.length > 0) vm.id = parameters.id;
        if (parameters.count !== null && angular.isDefined(parameters.count) && parameters.count.length > 0) vm.count = parameters.count;
        if (parameters.cardType !== null && angular.isDefined(parameters.cardType) && parameters.cardType.length > 0) vm.cardTypes = [parameters.cardType];
        if (vm.id === null || vm.id <= 0 || parameters.token == null || angular.isUndefined(parameters.token)) {
            ErrorHandler.showError("Link invalido.");
            return;
        }

        vm.selectPaidType = function (paidType) {
            var index = vm.brands.indexOf(paidType);
            if (index == -1)
                return;
            for (var i = 0; i < vm.brands.length; i++) {
                if (i == index) continue;
                vm.brands[i].active = false;
            }
            paidType.active = true;
            vm.paid.cardType = paidType.name;
        };

        vm.parcelas = function (n) {
            if (n === null || angular.isUndefined(n)) return '';
            if (vm.paid === null || vm.paid.value === null) return '';
            var amount = (vm.paid.value / n) / 100;
            return n + "x de " + $filter('currency')(amount, 'R$ ');
        };
        //vm.arrParcelas = [1];
        var dialog = Dialogs.wait("Buscando dados");

        $http.get(serverUrl + "requestLinkData?id=" + parameters.id + "&token=" + parameters.token).success(function (data) {
            dialog.close();
            vm.paid = data;
            if (data.erro != null) {
                ErrorHandler.showError(data.erro);
                return;
            }
            if (vm.paid.count !== null) {
                vm.arrParcelas = [];
                for (var index = 0; index < vm.paid.count; index++) {
                    vm.arrParcelas.push(index + 1);
                }
            } else vm.arrParcelas = [1];

            vm.brands = [];
            if (angular.isDefined(data.cardType) && (vm.cardTypes === null || vm.cardTypes.indexOf(data.cardType) < 0)) {
                vm.cardTypes = [data.cardType];
                vm.brands.push({ name: data.cardType, active: false });
                vm.selectPaidType(vm.brands[0]);
            } else if (angular.isDefined(data.cardType)) {
                vm.brands.push({ name: data.cardType, active: false });
                vm.selectPaidType(vm.brands[0]);
            } else {
                angular.forEach(vm.cardTypes, function (c) {
                    vm.brands.push({ name: c, active: false });
                });
            }
            data.id = data.id.toString();
            // data.total2 = $filter('currency')(data.total / 100, 'R$ ');
            // data.value2 = $filter('currency')(data.value / 100, 'R$ ');
        }).error(function (error) {
            dialog.close();
            ErrorHandler.showError(error);
        });

        vm.verificaBandeiraCartao = function () {
            if (vm.paid.cardType == "debito") return;
            if (vm.paid.cardType == "pagsegurotransparente") return;
            if (angular.isUndefined(vm.paid.cardNumber) || vm.paid.cardNumber === null || vm.paid.cardNumber.length <= 8) {
                return;
            }
            var card = $cardType.cardType(vm.paid.cardNumber);
            var cardType = (card === "" || angular.isUndefined(card) ? null : card);
            if (cardType != vm.paid.cardType && cardType.toLowerCase() != vm.paid.cardType.toLowerCase()) {
                var b = vm.brands.filter(function (e) {
                    return e.name == cardType || e.name.toLowerCase() == cardType.toLowerCase();
                });
                if (b.length > 0)
                    vm.selectPaidType(b[0]);
            }
        };

        vm.doSubmit = function () {
            if (!vm.aceitoTerms) {
                Dialogs.info("Você não aceitou os termos de compra.");
                return false;
            }
            if (!vm.paid.customer) {
                Dialogs.info("Você não preencheu o nome impresso no cartão.");
                return false;
            }
            if (!vm.paid.cardNumber) {
                Dialogs.info("Você não preencheu o número impresso no cartão.");
                return false;
            }
            if (!vm.paid.securityCode) {
                Dialogs.info("Você não preencheu o codigo de segurança.");
                return false;
            }
            if (!vm.paid.goodThru) {
                Dialogs.info("Você não preencheu a data de validade.");
                return false;
            }
            if (!vm.paid.cardType) {
                Dialogs.info("Você não escolheu a Bandeira do cartão.");
                return false;
            }
            if (!vm.paid.count) {
                Dialogs.info("Você não escolheu a quantidade de parcelas.");
                return false;
            }
            //vm.paid.id = vm.paid.id;
            var paid = angular.copy(vm.paid);
            paid.count = paid.count + "";
            paid.cardNumber = paid.cardNumber.replace(/ /g, '');
            vm.paid.customer = vm.paid.cardNumber = vm.paid.securityCode = vm.paid.goodThru = null;
            //Passa FingerPrint para o servidor
            var fingerPrintID = localStorageService.cookieGet("fingerPrintID");
            if (angular.isDefined(fingerPrintID) && fingerPrintID !== "" && fingerPrintID !== null) {
                paid.fingerPrint = fingerPrintID + "";
            }
            var dialog = Dialogs.wait();

            $http({
                method: 'POST',
                url: serverUrl + "paidRequestLinkWithCreditCard",
                data: paid,
            }).success(function (data) {
                dialog.close();
                if (data.erro != null) {
                    ErrorHandler.showError(data.erro);
                    return;
                }
                Dialogs.info("Pagamento efetuado com sucesso.");
                vm.token = data.token;
                vm.isPaid = true;
            }).error(function (error) {
                dialog.close();
                ErrorHandler.showError(error);
            });
        };
    }
})();

(function () {

  angular
    .module("b2c_ingressos")
    .controller("bannerController", bannerController);

  /** @ngInject */
  function bannerController(Properties) {
    var vm = this;
    vm.headerImageBanner = Properties.headerImageBanner || false;
    var lojaagency = Properties.lojaAgency;

    vm.desktop = null;
    vm.mobile = null;


    function loadImage(src, success, error) {
      //delete p.image;
      var img = new Image();
      img.onload = success;
      img.onerror = error;
      img.src = src;
    }

    if (lojaagency) {
      if (lojaagency !== undefined) {
        lojaagency = lojaagency + "_";
      }

      vm.desktop =
        Properties.headerImageBanner.desktop.substr(0, Properties.headerImageBanner.linkLenght) +
        lojaagency +
        "desktop.jpg";
      vm.mobile =
        Properties.headerImageBanner.mobile.substr(0, Properties.headerImageBanner.linkLenght) +
        lojaagency +
        "mobile.jpg";
    }

    if(vm.headerImageBanner && vm.headerImageBanner.desktop) {
      loadImage(
        vm.desktop,
        function () {
          vm.headerImageBanner.desktop = vm.desktop;
        },
        function () {
          vm.headerImageBanner.desktop =
            vm.headerImageBanner.desktop.substr(0, Properties.headerImageBanner.linkLenght) +
            "desktop.jpg";
        }
      );
    }
    if(vm.headerImageBanner && vm.headerImageBanner.mobile) {
      loadImage(
        vm.mobile,
        function () {
          vm.headerImageBanner.mobile = vm.mobile;
        },
        function () {
          vm.headerImageBanner.mobile =
            vm.headerImageBanner.mobile.substr(0, Properties.headerImageBanner.linkLenght) +
            "mobile.jpg";
        }
      );
    }
  }
})();

/**
 * Created by Danillo on 27/06/2016.
 */

(function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('PagamentoReservaController', pagamentoReservaController);

    /** @ngInject */
    function pagamentoReservaController($location, $filter, $state ,$cardType, $window ,BackEnd, Tracking, ErrorHandler, Properties, /*$log,*/ Dialogs, localStorageService, PaymentService, MyFunctions) {
        /* jshint validthis:true */
        var vm = this;
        var parameters = $location.search();
        vm.noRequiredCpf = Properties.noRequiredCpf;
        vm.pdfAddress = Properties.pdfAddress;
        vm.redirectToCheckin = (parameters.next === "true");
        vm.reservationId = null;
        vm.cardType = null;
        vm.cardTypes = [];
        vm.aceitoTerms = false;
        vm.brands = [];
        vm.produtos = "";
        if(Properties.paidBillCardTypes!== null) vm.cardTypes = Properties.paidBillCardTypes;
        vm.isPaid = false;
        vm.voucher = {};
        vm.count = null;
        vm.arrParcelas = [];
        vm.produtosValue = null;
        vm.mensagensParcela = "";
        vm.chave = "";
        var token = "";
        vm.showPaymentCardAddress = !!(Properties._3ds && Properties._3ds.pagarReserva) && Properties.show3dsCardAddress;
        vm.has3DS = function(){ return !!(Properties._3ds && Properties._3ds.pagarReserva); }
        if(parameters.id !== null && angular.isDefined(parameters.id) && parameters.id.length > 0) vm.reservationId = parameters.id;
        if(parameters.count !== null && angular.isDefined(parameters.count) && parameters.count.length > 0) vm.count = parameters.count;
        if(parameters.cardType !== null && angular.isDefined(parameters.cardType) && parameters.cardType.length > 0) vm.cardTypes = [parameters.cardType];
        if(parameters.chave !== null && angular.isDefined(parameters.chave) && parameters.chave.length > 0) vm.chave = parameters.chave;
        if(parameters.token !== null && angular.isDefined(parameters.token) && parameters.token.length > 0) token = parameters.token;
        if(vm.reservationId === null || vm.reservationId <= 0) {
            ErrorHandler.showError("Link invalido.");
            return;
        }

        function financialLength(paidType) {
            if(angular.isDefined(vm.count) && vm.count !== null) return;
            if ((vm.arrParcelas.length <= 1) && (angular.isDefined(vm.paid.paymentMethods) && vm.paid.paymentMethods !== null)) {
                if ((paidType.name === "Visa") && (angular.isDefined(vm.paid.paymentMethods.visa) && vm.paid.paymentMethods.visa !== null)) {
                    for (var i = 1; i < vm.paid.paymentMethods.visa; i++) {
                        vm.arrParcelas.push(i +1);
                    }
                }
                if ((paidType.name === "Master") && (angular.isDefined(vm.paid.paymentMethods.mastercard) && vm.paid.paymentMethods.mastercard !== null)) {
                    for (var j = 1; j < vm.paid.paymentMethods.mastercard; j++) {
                        //console.log(vm.paid.paymentMethods.mastercard);
                        vm.arrParcelas.push(j +1);
                    }
                }
                if ((paidType.name === "Amex") && (angular.isDefined(vm.paid.paymentMethods.amex) && vm.paid.paymentMethods.amex !== null)) {
                    for (var k = 1; k < vm.paid.paymentMethods.amex; k++) {
                        vm.arrParcelas.push(k +1);
                    }
                }
                if ((paidType.name === "Diners") && (angular.isDefined(vm.paid.paymentMethods.diners) && vm.paid.paymentMethods.diners !== null)) {
                    for (var l = 1; l < vm.paid.paymentMethods.diners; l++) {
                        vm.arrParcelas.push(l +1);
                    }
                }
                if ((paidType.name === "Elo") && (angular.isDefined(vm.paid.paymentMethods.elo) && vm.paid.paymentMethods.elo !== null)) {
                    for (var m = 1; m < vm.paid.paymentMethods.elo; m++) {
                        vm.arrParcelas.push(m +1);
                    }
                }
                if ((paidType.name === "HiperCard") && (angular.isDefined(vm.paid.paymentMethods.hipercard) && vm.paid.paymentMethods.hipercard !== null)) {
                    for (var n = 1; n < vm.paid.paymentMethods.hipercard; n++) {
                        vm.arrParcelas.push(n +1);
                    }
                }
            }
        }

        vm.verificaBandeiraCartao = function () {
            if (angular.isUndefined(vm.paid.cardNumber) || vm.paid.cardNumber === null || vm.paid.cardNumber.length <= 8) {
                return;
            }
            var listCardTypes = [];
            angular.forEach(vm.cardTypes, function(c){
                if(listCardTypes.indexOf(c.toLowerCase()) == -1)
                    listCardTypes.push(c.toLowerCase());
            });
            //if(vm.paid.cardType = vm.paid.cardType || "";
            var _selectedCardType = vm.paid.cardType;
            if(_selectedCardType && listCardTypes.indexOf(_selectedCardType.toLowerCase()) < 0) return;
            var card = $cardType.cardType(vm.paid.cardNumber);
            var cardType = (card === "" || angular.isUndefined(card) ? null : card);
            if(!_selectedCardType || (cardType != _selectedCardType && cardType.toLowerCase() != _selectedCardType.toLowerCase())) {
                var b = vm.brands.filter(function(e) {
                    return e.name == cardType || e.name.toLowerCase() == cardType.toLowerCase() ||
                    (e.name.toLowerCase() == "master" && cardType.toLowerCase() == "mastercard");
                });
                if(b.length>0) vm.selectPaidType(b[0]);
            }
        };

        vm.selectPaidType = function (paidType) {
            var index = vm.brands.indexOf(paidType);
            var i = 0;
            var brandsLength = vm.brands.length;
            for (i; i < brandsLength; i++) {
               vm.brands[i].active = false;
            }
            vm.brands[index].active = true;
            vm.paid.cardType = paidType.name.toLowerCase();

            financialLength(paidType);
        };

        function calcTotalPaymentDiscount(method, installments) {
          installments = installments || 1;
          var _p = vm.paid;
          if (!_p.paymentMethodsAdjustments) {
            return false;
          }
          var adjustment = _p.paymentMethodsAdjustments.find(function (
            item
          ) {
            if (!item.paymentTypes.includes(method)) {
              return false;
            }
            vm.paid.value / 100;
            if (Number(item.installments) !== Number(installments)) {
              return false;
            }
            return true;
          });
          if (adjustment) {
            return {
              installments: Number(adjustment.installments),
              totalValue: Number(adjustment.value),
              totalInstallmentValue: Number(
                adjustment.installmentValue
              ),
              percent: adjustment.percent,
              type: adjustment.type,
            };
          }
          return false;
        }
        vm.parcelas = function (n) {
          if (n === null || angular.isUndefined(n)) return "";
          if (vm.paid === null || vm.paid.value === null) return "";
          var result;
          var amount;
          var cardBrands = vm.paid.cardType;
          if (vm.paid.recurring === "true")
            cardBrands = vm.paid.cardType + "_r";

          var adjustment = calcTotalPaymentDiscount(cardBrands, n);
          if (adjustment) {
            result =
              n +
              "x de " +
              $filter("currency")(
                Number(adjustment.totalInstallmentValue) / 100,
                "R$ "
              );
            if (adjustment.installments > 1)
              result +=
                " => " +
                $filter("currency")(Number(adjustment.totalValue) / 100, "R$ ");
            return (
              result +
              (adjustment.type === "desconto"
                ? " (com " + adjustment.percent + " desconto)"
                : " (com " + adjustment.percent + " acréscimo)")
            );
          }

          amount = vm.paid.value / n / 100;
          result = n + " x de " + $filter("currency")(amount, "R$ ");
          if (n > 1)
            result += " => " + $filter("currency")(vm.paid.value / 100, "R$ ");
          return result;
        };
        function setBrandTypes(paymentMethods){
            if (angular.isDefined(paymentMethods.visa) && paymentMethods.visa !== null)
                vm.brands.push({name: "Visa", active: false});
            if (angular.isDefined(paymentMethods.mastercard) && paymentMethods.mastercard !== null)
                vm.brands.push({name: "Master", active: false});
            if (angular.isDefined(paymentMethods.amex) && paymentMethods.amex !== null)
                vm.brands.push({name: "Amex", active: false});
            if (angular.isDefined(paymentMethods.diners) && paymentMethods.diners !== null)
                vm.brands.push({name: "Diners", active: false});
            if (angular.isDefined(paymentMethods.elo) && paymentMethods.elo !== null)
                vm.brands.push({name: "Elo", active: false});
            if (angular.isDefined(paymentMethods.hipercard) && paymentMethods.hipercard !== null)
                vm.brands.push({name:"HiperCard", active: false});
        }
        vm.personEstrangeiro = function() {
           if(vm.paid && vm.paid.estrangeiro == "true") return true;
           return false;
        }

        //vm.arrParcelas = [1];
        BackEnd.execute2({ "method": "brokerRequestData", "id": vm.reservationId, "key": vm.chave, "token": token }, function(data) {
                vm.paid = data;
                if(vm.paid.getnetClient){
                    var setClientId = window.setClientId || function(){};
                    setClientId(vm.paid.getnetClient);
                }

                // $log.debug(data);
                vm.mensagensParcela = "";
                if(data.estrangeiro == "true")
                    vm.noRequiredCpf = true;
                if(data.items != null && angular.isDefined(data.items) && data.items.indexOf("[") == 0) {
                    var item = "";
                    angular.forEach(data.items.split(","), function(e){
                        if(e.length > 0) {
                            if(item !== "") item += ", ";
                            item += e.replace(/\]/g,"").replace(/\[/g,"");
                        }
                    });
                    data.items = item;
                }
                if (angular.isDefined(data.produtos) && data.produtos !== null && data.produtos !== "") {
                    vm.produtos = data.produtos;
                    vm.produtosValue = data.produtosValue;
                    vm.parcelaReserva = (parseInt(data.reservationValue) / 100) / data.count;
                    if (vm.count > 3) {
                        vm.parcelaProduto = (parseInt(data.produtosValue) / 100) / 3;
                        vm.mensagensParcela = "* Atenção: serão realizadas duas transações em seu cartão, sendo uma de " + $filter('currency')(data.reservationValue / 100,'R$ ') + " em " + data.count + "x de " + $filter('currency')(vm.parcelaReserva, 'R$ ') + " e outra de " + $filter('currency')(vm.produtosValue / 100,'R$ ') + " em 3x de " + $filter('currency')(vm.parcelaProduto,'R$ ');
                    }
                } else {
                    vm.parcelaReserva = (parseInt(data.reservationValue) / 100) / data.count;
                }
                vm.paid.reservationId = vm.reservationId;
                // $log.debug("vm.paid",data);
                if(angular.isDefined(vm.paid.count) && vm.paid.count !== null){

                  if (hasPaymentMethodsAdjustments()) {
                    vm.arrParcelas = Array.from(
                      { length: Number(vm.paid.count) },
                      function (_, i) {
                        return i + 1 + '';
                      }
                    );
                  } else {
                    vm.arrParcelas = [vm.paid.count];
                  }
                  vm.count = vm.paid.count;
                }
                else if (vm.count !== null && vm.cardTypes.length > 0) {
                    var i = 0;
                    var max = vm.count;
                    for (i; i < max; i++) {
                        vm.arrParcelas.push(i + 1);
                    }

                }
                else {
                    vm.arrParcelas = [1];
                }

                if (data.voucherId !== null && data.value == 0) {
                    vm.voucherId = data.voucherId;
                    vm.voucherToken = data.token;
                    vm.isPaid = true;
                }
                if (data.token !== null) {
                   vm.voucher.token = data.token;
                }
                //vm.brands = [];
                // $log.debug("servidor",data.cardType);
                // $log.debug("URL",parameters.cardType);
                if(angular.isDefined(data.cardType) && (vm.cardTypes===null || vm.cardTypes.indexOf(data.cardType)<0)){
                   vm.cardTypes = [data.cardType];
                   vm.brands.push({name: data.cardType, active: false});
                } else if (angular.isDefined(data.cardType)) {
                   vm.brands.push({name: data.cardType, active:true});
               } else if (angular.isDefined(parameters.cardType) && parameters.cardType.length > 0) {
                   vm.brands.push({name: parameters.cardType, active: true});
                   vm.selectPaidType(vm.brands[0]);
               } else if (angular.isDefined(data.paymentMethods) && data.paymentMethods !== null){
                   setBrandTypes(data.paymentMethods);
                   vm.cardTypes = vm.brands.map(function(brand) {
                        return brand.name.toLowerCase();
                   });
               }

                data.total2 = $filter('currency')(data.total/100, 'R$ ');
                data.value2 = $filter('currency')(data.value/100, 'R$ ');
                vm.carregado = true;
                // $log.debug("vm.cardTypes",vm.cardTypes);
            });

        vm.findZipCodeAddress = MyFunctions.findZipCodeAddress;

        function checkisNotValid(value){
            return angular.isUndefined(value) || value == ""  || value == null;
        }

        function hasPaymentMethodsAdjustments(){
            return (vm.paid && vm.paid.paymentMethodsAdjustments && vm.paid.paymentMethodsAdjustments.length);
        }

         vm.getTotalPriceWithAdjustments = function(method, installments){
            if(!hasPaymentMethodsAdjustments()){
              return vm.paid.value / 100;
            }

            var cardBrands = method;
            if (vm.paid.recurring === "true" && method !== 'pix')
              cardBrands = method + "_r";

            var adjustment = calcTotalPaymentDiscount(cardBrands, installments);

            if (
              !adjustment ||
              (vm.paid.recurring === "true" && vm.paid.cardType !== "pix")
            ) {
              return vm.paid.value / 100;
            }

            return Number(adjustment.totalValue) / 100;
        }


        vm.doSubmit = function() {
            if(!vm.aceitoTerms) {
                alert("Você não aceitou os termos de compra.");
                return false;
            }
            if(!vm.paid.customer) {
                alert("Você não preencheu o nome impresso no cartão.");
                return false;
            }
            if(!vm.paid.cardNumber) {
                alert("Você não preencheu o número impresso no cartão.");
                return false;
            }
            if(!vm.paid.securityCode) {
                alert("Você não preencheu o codigo de segurança.");
                return false;
            }
            if(!vm.paid.goodThru) {
                alert("Você não preencheu a data de validade.");
                return false;
            }
            if(!vm.paid.cardType) {
                alert("Você não escolheu a Bandeira do cartão.");
                return false;
            }
            if(!vm.paid.count) {
                alert("Você não escolheu a quantidade de parcelas.");
                return false;
            }
            if(vm.showPaymentCardAddress && vm.paid.estrangeiro !== "true"){
                if(checkisNotValid(vm.userCard)) {
                    Dialogs.info("Por favor preencher dados de cobrança fatura")
                    return false
                }
                var userData = ['email','cellPhone','street0','street1','address','city','state','zipCode'];
                for(var i = 0; i < userData.length; i++){
                    if(checkisNotValid(vm.userCard[userData[i]]) && (userData[i] === 'cellPhone' || userData[i] === 'email' )){
                        Dialogs.info("Por favor preencher dados completos.");
                        return false
                    }
                    if(checkisNotValid(vm.userCard[userData[i]])){
                        Dialogs.info("Por favor preencher endereço completo.");
                        return false
                    }
                }
            }
            //vm.paid.reservationId = vm.paid.id;
            var paid = angular.copy(vm.paid);
            paid.cardNumber = paid.cardNumber.replace(/ /g,'');
            paid.reservationPath = "reservations/" + paid.reservationId;
            // {"reservationValue":317300,"responsibleCPF":"84683643120","produtos":null,"count":"1","cardType":"visa","total2":"","value2":null,"customer":"TESTE NOVAXS","cardNumber":"5524586443862812","securityCode":"123","goodThru":"1220","reservationPath":"reservations/136151","key":""}
            delete paid.vencimentoCartaoMes;
            delete paid.vencimentoCartaoAno;
            delete paid.paymentMethods;
            delete paid.produtos;
            delete paid.timespan;
            delete paid.travelersAmount;
            delete paid.value2;
            delete paid.uh;
            delete paid.pensao;
            delete paid.serviceName;
            delete paid.checkin;
            delete paid.days;
            delete paid.hotelName;
            delete paid.checkout;
            delete paid.responsibleName;
            delete paid.responsibleId;
            delete paid.responsibleCPF;
            if(angular.isDefined(vm.chave) && vm.chave !== null && vm.chave !== "")
                paid.key = vm.chave;

            if(hasPaymentMethodsAdjustments())
                paid.value = parseInt(Math.round(vm.getTotalPriceWithAdjustments(paid.cardType, paid.count) * 100), 10) + "";
                //Passa FingerPrint para o servidor
            var fingerPrintID = localStorageService.cookieGet("fingerPrintID");
            if(angular.isDefined(fingerPrintID) && fingerPrintID !== "" && fingerPrintID !== null) {
                paid.fingerPrint = fingerPrintID + "";
            }
            vm.paid.customer = vm.paid.cardNumber = vm.paid.securityCode =  vm.paid.goodThru = null;
            if(vm.has3DS() && vm.paid.estrangeiro !== "true"){
                if(Properties.show3dsCardAddress){
                    var u = {};
                    angular.copy(vm.userCard, u);
                    u.street0 += " " + u.address;
                    paid._user = u;
                }
                //TODO: considerar tokenização mesmo com o 3DS.
               PaymentService.payUsing3ds(_paid, paid, paid.reservationPath);
            } else if(Properties.token) {
                PaymentService.createToken(paid,
                    function(_result){
                        paid.cardNumber = _result.token;
                        paid.goodThru = _result.card.due_date;
                        paid.securityCode = _result.card.cvv;
                        paid.customData =  paid.customData || {};
                        paid.customData.card_number = _result.card.card_number;
                        _paid(paid);
                    }
                );
            } else {
                _paid(paid);
            }

            function _paid(paid){
                var dialog = Dialogs.wait();
                vm.showWait = true;
                var _params = { "method": "paidWithCreditCard", "paid": paid };
                //REcaptcha
                if (angular.isDefined($window.getRecaptcharToken)) _params._recaptchar = $window.getRecaptcharToken();
                BackEnd.execute2(_params,
                    function(data) {
                        vm.showWait = false;
                        dialog.close();
                        Tracking.checkoutReservations([{
                          id: vm.reservationId,
                          hotelName: vm.paid.hotelName || vm.paid.serviceName,
                          value: vm.paid.value,
                        }]);
                        if (angular.isDefined(data.paymentUrl) && data.paymentUrl !== null && data.paymentUrl.indexOf("http") == 0) {
                            Dialogs.iframe_authenticate(data.paymentUrl);
                            return;
                        }
                        if(vm.redirectToCheckin){
                            var fraseRedirect = Properties.fraseRedirect || "Pagamento efetuado com sucesso. Por favor preencher os dados";
                            Dialogs.info(fraseRedirect);
                            vm.goRedirectToCheckin();
                        }else {
                            if(angular.isUndefined(data.voucherId) || data.voucherId == null){
                                ErrorHandler.showError("Transacao não efetuada. Atualize a página");
                                return;
                            }
                            var frasePosPagamento = Properties.frasePosPagamento || "Pagamento efetuado com sucesso. Imprima seu voucher";
                            Dialogs.info(frasePosPagamento);
                            vm.voucher = data;
                            vm.voucherId = data.voucherId;
                            vm.voucherToken = data.voucherToken;
                            vm.token = data.token;
                            vm.isPaid = true;
                        }
                    }, function(error){
                        dialog.close();
                        Tracking.buyError(error);
                        ErrorHandler.showError(error);
                    });
            }
        };

        vm.goRedirectToCheckin = function(){
            var token = ""
            for(var key in parameters){
                if(key === 'token'){
                    token = parameters[key];
                    break;
                }
                else if(key.includes('token')){
                    token = key.replace('token', '');
                    break;
                }
            }
            var objParams = { id: parameters.id, token: token };
            $state.go('checkin', objParams);
        }

        vm.normalizePaxes = function () {

                if(angular.isUndefined(vm.paid) || angular.isUndefined(vm.paid.travelersAmount)) return"";
                var result = "";
                var array = vm.paid.travelersAmount.split(",");
                for (var index = 0; index < array.length; index++) {
                    var element = array[index].split("=");
                    if(result !== "") result += ", ";
                    var totalPax = parseInt(element[1].replace(/ /g, ""));
                    result += element[1] + " " + element[0].replace(/ /, "");
                    if(totalPax > 1)
                     result += "s";
                }
                return result;
        };

        vm.formatFlightText = function() {
          if (
            angular.isUndefined(vm.paid) ||
            angular.isUndefined(vm.paid.itemsAdditionals)
          )
            return "";
          if (Array.isArray(vm.paid.itemsAdditionals)) {
            vm.paid.itemsAdditionals = vm.paid.itemsAdditionals[0];
          }

          var regex = /Ida:\s*(\d{2}\/\d{2}\/\d{4})\s*-\s*(\w+)\s*-\s*(.*?)\s*\/\s*(\w+)\s*-\s*(.*?)\],\s*\[Volta:\s*(\d{2}\/\d{2}\/\d{4})\s*-\s*(\w+)\s*-\s*(.*?)\s*\/\s*(\w+)\s*-\s*(.*?)\]/;

          var match = vm.paid.itemsAdditionals.match(regex);

          return 'Ida: ' + match[1] + ' (' + match[2] + ' → ' + match[4] + ') | Volta: ' + match[6] + ' (' + match[7] + ' → ' + match[9] + ')';
        };


    }
})();

/**
 * Created by Danillo on 27/06/2016.
 */

(function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('PagarContaController', PagarContaController);

    /** @ngInject */
    function PagarContaController($state, $location, $filter, $cardType, BackEnd, ErrorHandler, Tracking, Properties, Dialogs, localStorageService, PaymentService, MyFunctions) {
        var vm = this;
        vm.isLinkValid = false;
        vm.noRequiredCpf = Properties.noRequiredCpf;
        vm.forceHideCpfPix = !!Properties.forceHideCpfPix || !!Properties.pixEstrangeiro;
        vm.pdfAddress = Properties.pdfAddress;
        vm.billId = null;
        vm.cardType = null;
        vm.cardTypes = ["Visa", "Mastercard"];
        vm.aceitoTerms = false;
        vm.brands = [];
        vm.showPaymentCardAddress = !!(Properties._3ds && Properties._3ds.pagarConta) && Properties.show3dsCardAddress;
        vm.has3DS = function(){ return !!(Properties._3ds && Properties._3ds.pagarConta); }
        var listCardTypes = ['visa','mastercard','master','elo','dinners','diners','hipercard','amex', 'pix'];
        if(Properties.paidBillCardTypes!== null) vm.cardTypes = Properties.paidBillCardTypes;
        vm.isPaid = false;
        vm.voucher = {};
        var parameters = $location.search();
        if(parameters.id !== null && angular.isDefined(parameters.id) && parameters.id.length > 0) vm.billId = parameters.id;
        if(parameters.token !== null && angular.isDefined(parameters.token) && parameters.token.length > 0) vm.billToken = parameters.token;
        if(parameters.count !== null && angular.isDefined(parameters.count) && parameters.count.length > 0) vm.count = parameters.count;
        if(parameters.cardType !== null && angular.isDefined(parameters.cardType) && parameters.cardType.length > 0) vm.cardTypes = [parameters.cardType];
        if(vm.billId === null || vm.billId <= 0) {
            ErrorHandler.showError("Link invalido.");
            return;
        }

        vm.selectPaidType = function (paidType) {
            var index = vm.brands.indexOf(paidType);
            if(index == -1)
                return;
            for (var i = 0; i < vm.brands.length; i++) {
                if(i == index) continue;
               vm.brands[i].active = false;
            }
            paidType.active = true;
            vm.paid.cardType = paidType.name;
            if(vm.paid.recurring === 'true') {
              vm.paid.count = null;
            }
            if (vm.paid.recurring !== "true" || !vm.paid.recurring) {
              vm.paid.count = null;
            }
        };

        vm.parcelas = function(n){

            if(n === null || angular.isUndefined(n)) return '';
            if(vm.paid === null || vm.paid.value === null) return '';
            var result;
            var amount;
            var cardBrands = vm.paid.cardType;
            if(vm.paid.recurring === 'true')
              cardBrands = vm.paid.cardType+'_r'

            var adjustment = calcTotalPaymentDiscount(cardBrands, n);
            if(adjustment) {
              result =  n + "x de " + $filter('currency')(Number(adjustment.totalInstallmentValue) / 100,'R$ ');
              if (adjustment.installments > 1)
                result += " => " + $filter('currency')(Number(adjustment.totalValue) / 100,'R$ ');
              return  result + (adjustment.type === 'desconto' ? ' (com desconto)': ' (com acréscimo)');
            }

            amount =  (vm.paid.value / n) / 100;
            result = n + " x de " + $filter('currency')(amount,'R$ ');
            if (n > 1)
              result +=
                " => " + $filter("currency")(vm.paid.value / 100, "R$ ");
            return  result;
          }

        vm.parcela = function(n){
            if(n === null || angular.isUndefined(n)) return '';
            if(vm.paid === null || vm.paid.value === null) return '';
            var result;
            var amount;

            amount =  (vm.paid.value / n) / 100;
            result = $filter('currency')(amount,'R$ ');
            if (n > 1)
              result;
            return  result;

          }

        /**
       * Verifica se existe descontos ou acréscimos.
       * @return boolean
       */
        function hasPaymentMethodsAdjustments(){
            return (vm.paid && vm.paid.paymentMethodsAdjustments && vm.paid.paymentMethodsAdjustments.length);
        }



        /**
         * @param {string} method
         * @param {number} installments
         * @return {number} O valor total com ajustes aplicados.
         */
        // function getPriceWithAdjustments(method, installments){
        //     if(!hasPaymentMethodsAdjustments()){
        //     return vm.paid.reservationValue;
        //     }
        //     var adjustment = calcPaymentDiscount(method, installments)
        //     if(!adjustment){
        //     return vm.paid.reservationValue;
        //     }
        //     return Number(adjustment.value);
        // }
        // function calcPaymentDiscount(method, installments){


        //     if(!vm.paid.paymentMethodsAdjustments)
        //         return false;
        //     var adjustment = vm.paid.paymentMethodsAdjustments.find(function(item){
        //         if(!item.paymentTypes.includes(method))
        //             return false;
        //         if(Number(item.installments) !== Number(installments))
        //             return false;
        //         return true;
        //     });
        //     return adjustment;
        // }
        vm.paymentPercent = function findPaymentPercent(method, methodsArray) {
          var foundMethod;
          if (!method || !methodsArray) return;
           foundMethod = methodsArray.find(function (item) {
            if(vm.paid.recurring == "true")  {
                if(method.toLowerCase() == 'pix') return item.paymentTypes.includes(method);
                return item.paymentTypes.includes(method) && item.paymentTypes.includes("recorrencia");
            } else
                return item.paymentTypes.includes(method);
           });

          return foundMethod ? foundMethod.percent : "";
        }
        function calcTotalPaymentDiscount(method, installments){
            installments = installments || 1;
            var _p = vm.paid;
            if(!_p.paymentMethodsAdjustments){
                return false
              }
              var adjustment = _p.paymentMethodsAdjustments.find(function(item){
                if(!item.paymentTypes.includes(method)){
                    return false;
                } vm.paid.value / 100
                if(Number(item.installments) !== Number(installments)){
                  return false;
                }
                return true;
            });
            if(adjustment) {
                return {
                  installments: Number(adjustment.installments),
                  totalValue: Number(adjustment.value),
                  totalInstallmentValue: Number(adjustment.installmentValue),
                  percent: adjustment.percent,
                  type: adjustment.type,
                };
            }
            return false;
        }
        vm.getTotalPriceWithAdjustments = function(method, installments){
            if(!hasPaymentMethodsAdjustments()){
              return vm.paid.value / 100;
            }

            var cardBrands = method;
            if (vm.paid.recurring === "true" && method !== 'pix')
              cardBrands = method + "_r";

            var adjustment = calcTotalPaymentDiscount(cardBrands, installments);

            if (
              !adjustment ||
              (vm.paid.recurring === "true" && vm.paid.cardType !== "pix")
            ) {Dialogs.answer
              return vm.paid.total / 100;
            }

            return Number(adjustment.totalValue) / 100;
        }


        vm.hasDiscount = function(e){
            e = e || vm.paid.cardType;
            var adjustment;
            if (e.brand){
              if (vm.paid.recurring === "true" && e.brand !== 'pix') e.brand = e.brand+'_r'
              adjustment = calcTotalPaymentDiscount(e.brand, 1);
              if(adjustment.percent)
              return adjustment.percent + (adjustment.type === 'desconto' ? ' desconto ': ' com acréscimo ')
            } else {
              adjustment = calcTotalPaymentDiscount(e, vm.paid.count);
              if(adjustment.percent)
              return '('+adjustment.percent + (adjustment.type === 'desconto' ? ' desconto)': ' acréscimo)')
            }
        }


        //vm.arrParcelas = [1];
        var dialog = Dialogs.wait("Buscando dados");
        BackEnd.execute2({ "method": "billBrokerRequestData", "id": vm.billId, "token": vm.billToken },
            function(data) {
                dialog.close();
                if(data.estrangeiro == "true")
                    vm.noRequiredCpf = true;
                vm.paid = data;
                if(vm.paid.getnetClient){
                    var setClientId = window.setClientId || function(){};
                    setClientId(vm.paid.getnetClient);
                }
                if(vm.paid.count !== null) {
                    vm.arrParcelas = [];
                    for (var index = 0; index < vm.paid.count; index++) {
                        vm.arrParcelas.push(index + 1);
                        Dialogs.answer
                    }
                    if (vm.paid.recurring && vm.paid.recurring === 'true') vm.arrParcelas.shift();

                }
                else vm.arrParcelas = [1];
                vm.paid.count = null;
                vm.paid.maxCount = vm.arrParcelas.length;
                if(angular.isDefined(data.voucherId) && data.voucherId !== null && data.value == 0) {
                    vm.voucherId = data.voucherId;
                    vm.isPaid = true;
                    if (data.token !== null)
                        vm.voucher.token = data.token;
                }

                vm.brands = [];Dialogs.answer
                if (angular.isDefined(data.cardTypes) && data.cardTypes.length > 0) {
                    vm.cardTypes = [];
                    angular.forEach(data.cardTypes, function(c){
                        if(listCardTypes.indexOf(c.toLowerCase()) > -1)
                        vm.cardTypes.push(c);
                    });

                    vm.cardTypes.sort(function (a, b) {
                      if (a.toLowerCase() === "pix") return -1;
                      if (b.toLowerCase() === "pix") return 1;
                      return 0;
                    });

                }
                if (angular.isDefined(data.cardType)) {
                    vm.cardTypes = [data.cardType];
                    vm.brands.push({ name: data.cardType, active: false });
                    vm.selectPaidType(vm.brands[0]);
                } else {
                    angular.forEach(vm.cardTypes, function(c){
                        vm.brands.push({name: c, active: false});
                    });
                }

                data.total2 = $filter('currency')(data.total/100, 'R$ ');
                data.value2 = $filter('currency')(data.value/100, 'R$ ');
                vm.isLinkValid = true;
                Tracking.openPaymentLink(vm.paid);
            },
            function(error){
                dialog.close();
                ErrorHandler.showError(error);
            }
        );

        vm.verificaBandeiraCartao = function () {
            if(listCardTypes.indexOf(vm.paid.cardType.toLowerCase()) < 0) return;
            if (angular.isUndefined(vm.paid.cardNumber) || vm.paid.cardNumber === null || vm.paid.cardNumber.length <= 8) {
                return;
            }
            var card = $cardType.cardType(vm.paid.cardNumber);
            var cardType = (card === "" || angular.isUndefined(card) ? null : card);
            if(cardType != vm.paid.cardType && cardType.toLowerCase() != vm.paid.cardType.toLowerCase()) {
                var b = vm.brands.filter(function(e) {
                    return e.name == cardType || e.name.toLowerCase() == cardType.toLowerCase();
                });
                if(b.length>0)
                    vm.selectPaidType(b[0]);
            }
        };
        vm.findZipCodeAddress = MyFunctions.findZipCodeAddress;

        function checkisNotValid(value){
            return angular.isUndefined(value) || value == ""  || value == null;
        }
        vm.doSubmit = function() {
            if(!vm.aceitoTerms) {
                Dialogs.info("Você não aceitou os termos de compra.");
                return false;
            }
            if(!vm.paid.customer) {
                Dialogs.info("Você não preencheu o nome impresso no cartão.");
                return false;
            }
            if(!vm.paid.cardNumber) {
                Dialogs.info("Você não preencheu o número impresso no cartão.");
                return false;
            }
            if(!vm.paid.securityCode) {
                Dialogs.info("Você não preencheu o codigo de segurança.");
                return false;
            }
            if(!vm.paid.goodThru) {
                Dialogs.info("Você não preencheu a data de validade.");
                return false;
            }
            if(!vm.paid.cardType) {
                Dialogs.info("Você não escolheu a Bandeira do cartão.");
                return false;
            }
            if(!vm.paid.count) {
                Dialogs.info("Você não escolheu a quantidade de parcelas.");
                return false;
            }
            if(vm.showPaymentCardAddress){
                if(checkisNotValid(vm.userCard)) {
                    Dialogs.info("Por favor preencher dados de cobrança fatura");
                    return false;
                }
                if(vm.paid.estrangeiro != "true") {
                    var userData = ['email','cellPhone','street0','street1','address','city','state','zipCode'];
                    for(var i = 0; i < userData.length; i++){
                        if(checkisNotValid(vm.userCard[userData[i]]) && (userData[i] === 'cellPhone' || userData[i] === 'email' )){
                            Dialogs.info("Por favor preencher dados completos.");
                            return false;
                        }
                        if(checkisNotValid(vm.userCard[userData[i]])){
                            Dialogs.info("Por favor preencher endereço completo.");
                            return false;
                        }
                    }
                }
            }

            vm.paid.billId = vm.paid.id;
            var paid = angular.copy(vm.paid);


            var device = {
              user_agent: navigator.userAgent,
              color_depth: screen.colorDepth,
              type: "BROWSER",
              java_enabled: navigator.javaEnabled(),
              language: navigator.language,
              screen_height: screen.height,
              screen_width: screen.width,
              time_zone_offset: new Date().getTimezoneOffset(),
            };

            paid.clientDeviceData = device;
            paid.count = paid.count + "";
            paid.cardNumber = paid.cardNumber.replace(/ /g,'');
            if(hasPaymentMethodsAdjustments())
                paid.value = parseInt(Math.round(vm.getTotalPriceWithAdjustments(paid.cardType, paid.count) * 100), 10) + "";

            delete paid.paymentMethodsAdjustments;
            delete paid.cardTypes;
            vm.paid.customer = vm.paid.cardNumber = vm.paid.securityCode =  vm.paid.goodThru = null;
            //Passa FingerPrint para o servidor
            var fingerPrintID = localStorageService.cookieGet("fingerPrintID");
            if(angular.isDefined(fingerPrintID) && fingerPrintID !== "" && fingerPrintID !== null) {
                paid.fingerPrint = fingerPrintID + "";
            }
            if(vm.has3DS()){
                if(Properties.show3dsCardAddress){
                    var u = {};
                    angular.copy(vm.userCard, u);
                    u.street0 += " " + u.address;
                    paid._user = u;
                }
                //TODO: considerar tokenização mesmo com o 3DS.
               PaymentService.payUsing3ds(_paid, paid, "bills/" + vm.billId);
            } else {
                if(angular.isUndefined(paid.cardType) || paid.cardType == null || paid.cardType == "") paid.cardType = paid.type;
                paid.code = paid.securityCode;
                PaymentService.createToken(paid,
                    function(_result) {
                        paid.cardNumber = _result.token;
                        paid.goodThru = _result.card.due_date;
                        paid.securityCode = _result.card.cvv;
                        paid.code = paid.securityCode;
                        paid.token2 = _result.token2;
                        paid.customData =  paid.customData || {};
                        paid.customData.card_number = _result.card.card_number;
                        _paid(paid);
                    }
                );
            }

            function _paid(paid){
                var dialog = Dialogs.wait();
                BackEnd.execute2({ "method": "paidBillWithCreditCard", "paid": paid },
                function(data) {
                    dialog.close();
                    if (angular.isDefined(data.paymentUrl) && data.paymentUrl !== null && data.paymentUrl.indexOf("http") == 0) {
                        Dialogs.iframe_authenticate(data.paymentUrl);
                        return;
                    }
                    var frasePosPagamento = Properties.frasePosPagamento || "Pagamento efetuado com sucesso. Imprima seu voucher";
                    Dialogs.info(frasePosPagamento);
                    vm.voucher = data;
                    vm.voucherId = data.voucherId;
                    vm.isPaid = true;
                    Tracking.buy({id: vm.billId, value: vm.paid.value });
                }, function(error){
                    dialog.close();
                    Tracking.buyError(error);
                    ErrorHandler.showError(error);
                });
            }
        };

        vm.createWebGateway = function() {
            var dialog = Dialogs.wait();
            BackEnd.execute2(
                {
                    "method": "createWebGatewayRequest", "billPath":
                    "bills/" + vm.billId,
                    "cpf": vm.paid.personCpf,
                    "token": vm.billToken,
                    "webGateway": vm.paid.cardType

                },
                function() {
                    dialog.close();
                    var _state = "confirmacaoConta";
                    if(Properties.lojaAgency) {
                        Properties.lojasAgencies.forEach(function(l){
                            if(Properties.lojaAgency == l.url) {
                                var _eachState = $state.get(l.nome + "_" + _state);
                                if(_eachState != null && angular.isDefined(_eachState)) _state = l.nome + "_" + _state;
                            }
                        });

                    }
                    $state.go(_state, { id: vm.billId, locator: vm.billToken || vm.billLoc });
                }, function(error){
                    dialog.close();
                    ErrorHandler.showError(error);
                });
        }
    }
})();

/**
 * @typedef {import("../../types/properties").PropertiesType} PropertiesType
 */

(function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('PagamentoGrupoController', PagamentoGrupoController);

    /**
     * @ngInject
     * @param {PropertiesType} Properties
     */
    function PagamentoGrupoController($location, $filter, $cardType, BackEnd, ErrorHandler, Properties, $log, Dialogs, PaymentService, MyFunctions) {

        var vm = this;
        vm.pdfAddress = Properties.pdfAddress;
        vm.groupRequestPaymentId = null;
        vm.cardType = null;
        vm.cardTypes = [];
        vm.aceitoTerms = false;
        vm.brands = [];
        vm.produtos = "";
        //if (Properties.paidBillCardTypes !== null) vm.cardTypes = Properties.paidBillCardTypes;
        vm.isPaid = false;
        vm.voucher = {};
        vm.count = null;
        vm.arrParcelas = [];
        vm.produtosValue = null;
        vm.mensagensParcela = "";
        vm.chave = "";
        vm.isEditValue = false;
        vm.canEditValue = Properties.groupCanEditValue;
        vm.showPaymentCardAddress = !!(Properties._3ds) && Properties.show3dsCardAddress;
        vm.esconderDetalhesPagamentoGrupo = !!Properties.esconderDetalhesPagamentoGrupo;
        vm.has3DS = function(){
            return !!(Properties._3ds);
        };
        vm.checkEditValue = function () {
            vm.newValue = vm.newValue + "";
            if (vm.newValue == "") {
                vm.isEditValue = false;
                return;
            }
            if (vm.newValue.indexOf(",") < 0) vm.newValue += ",00";
            if (vm.newValue.length - 1 == vm.newValue.indexOf(",")) vm.newValue += "00";
            if (vm.newValue.length - 2 == vm.newValue.indexOf(",")) vm.newValue += "0";
            var v = parseInt(vm.newValue.replace(/\./g, "").replace(/\,/g, ""), 10);
            if (v <= 0) {
                vm.isEditValue = false;
                return;
            }
            if (v > vm.unPaidValue) {
                Dialogs.info("Valor não pode ser maior que " + $filter('currency')(vm.unPaidValue / 100, 'R$ '));
                return;
            }
            vm.paid.value = v;
            vm.isEditValue = false;
        };


        //vm.count = vm.paid.count;
        //setBrandTypes(vm.paid.paymentMethods);
        function init() {
            var parameters = $location.search();
            if (parameters.id !== null && angular.isDefined(parameters.id) && parameters.id.length > 0) vm.groupRequestPaymentId = parameters.id;
            if (parameters.token !== null && angular.isDefined(parameters.token) && parameters.id.length > 0) vm.token = parameters.token;
            if (parameters.count !== null && angular.isDefined(parameters.count) && parameters.count.length > 0) vm.count = parameters.count;
            if (parameters.cardType !== null && angular.isDefined(parameters.cardType) && parameters.cardType.length > 0) vm.cardTypes = [parameters.cardType];
            if (parameters.chave !== null && angular.isDefined(parameters.chave) && parameters.chave.length > 0) vm.chave = parameters.chave;
            if (vm.groupRequestPaymentId === null || vm.groupRequestPaymentId <= 0) {
                Dialogs.error("link invalido");
                return;
            }
            if (parameters.value !== null && angular.isDefined(parameters.value) && parameters.value.length > 0) vm.value = parseInt(parameters.value);
            if(vm.token ==null || angular.isUndefined(vm.token) || vm.token == ""){
                ErrorHandler.showError("token não informado");
                return;
            }
            var dialog = Dialogs.wait();
            BackEnd.execute2({ "method": "groupRequestPayment/"+vm.groupRequestPaymentId, "key": vm.chave, "token": vm.token },
                function(data) {
                    dialog.close();
                    vm.paid = data;
                    if (angular.isDefined(vm.value))
                        vm.paid.value = vm.value;
                    else
                        vm.paid.value = vm.paid.paymentValue - (vm.paid.paidValue || 0);
                    vm.unPaidValue = vm.paid.paymentValue - (vm.paid.paidValue || 0);
                    if (vm.count == null)
                        vm.count = vm.paid.count;
                    else
                        vm.paid.count = vm.count;

                    if (Properties.groupCanEditValue)
                        vm.cardTypes = Properties.paidGroupCardTypes;

                    if (vm.cardTypes.length == 0)
                        vm.cardTypes = [vm.paid.cardType];
                    vm.paid.cardTypes = vm.cardTypes;

                    $log.debug(data.data);

                    vm.mensagensParcela = "";
                    if (vm.paid.items != null && angular.isDefined(vm.paid.items) && vm.paid.items.indexOf("[") == 0) {
                        var item = "";
                        angular.forEach(vm.paid.items.split(","), function (e) {
                            if (e.length > 0) {
                                if (item !== "") item += ", ";
                                item += e.replace(/\]/g, "").replace(/\[/g, "");
                            }
                        });
                        vm.paid.items = item;
                    }
                    vm.paid.groupRequestPaymentId = vm.groupRequestPaymentId;
                    $log.debug("vm.paid", vm.paid);

                    vm.paid.groupValue = vm.paid.paymentValue || 0;
                    if(vm.paid.reservations.length > 0) {
                        /* inicio EXCLUIR RESERVAS CANCELADAS */
                        vm.paid.reservations = vm.paid.reservations.filter(function(reservation){
                            return reservation.status !== 'Cancelada';
                        });
                        /* fim EXCLUIR RESERVAS CANCELADAS */
                        vm.paid.groupValue = 0;
                        vm.paid.reservations.forEach(function(reservation){
                            vm.paid.groupValue += reservation.value;
                        });
                    }

                    if (angular.isDefined(vm.paid.count) && vm.paid.count !== null) {
                        vm.arrParcelas = [];
                        for (var j = 1; j <= vm.paid.count; j++) {
                            vm.arrParcelas.push(j);
                        }
                        vm.count = 1;
                    } else if (vm.count !== null && vm.cardTypes.length > 0) {
                        var i = 0;
                        var max = vm.count;
                        for (i; i < max; i++) {
                            vm.arrParcelas.push(i + 1);
                        }
                    } else {
                        vm.arrParcelas = [1];
                    }
                    if(vm.paid.cardTypes) {
                        angular.forEach(vm.paid.cardTypes, function (c) {
                            vm.brands.push({
                                name: c,
                                active: false
                            });
                        });
                    } else if(vm.paid.cardType) {
                        vm.brands.push({
                            name: vm.paid.cardType,
                            active: false
                        });
                    }
                    vm.selectPaidType(vm.brands[0]);

                    vm.paid.value2 = $filter('currency')(vm.paid.value / 100, 'R$ ');
                    vm.carregado = true;
                    $log.debug("vm.cardTypes", vm.cardTypes);
                }, function (error) {
                    dialog.close();
                    ErrorHandler.showError(error);
                });
        }

        function financialLength(paidType) {
            if (angular.isDefined(vm.count) && vm.count !== null) return;
            if ((vm.arrParcelas.length <= 1) && (angular.isDefined(vm.paid.paymentMethods) && vm.paid.paymentMethods !== null)) {
                if ((paidType.name === "Visa") && (angular.isDefined(vm.paid.paymentMethods.visa) && vm.paid.paymentMethods.visa !== null)) {
                    for (var i = 1; i < vm.paid.paymentMethods.visa; i++) {
                        vm.arrParcelas.push(i + 1);
                    }
                }
                if ((paidType.name === "Master") && (angular.isDefined(vm.paid.paymentMethods.mastercard) && vm.paid.paymentMethods.mastercard !== null)) {
                    for (var j = 1; j < vm.paid.paymentMethods.mastercard; j++) {
                        vm.arrParcelas.push(j + 1);
                    }
                }
                if ((paidType.name === "Amex") && (angular.isDefined(vm.paid.paymentMethods.amex) && vm.paid.paymentMethods.amex !== null)) {
                    for (var k = 1; k < vm.paid.paymentMethods.amex; k++) {
                        vm.arrParcelas.push(k + 1);
                    }
                }
                if ((paidType.name === "Diners") && (angular.isDefined(vm.paid.paymentMethods.diners) && vm.paid.paymentMethods.diners !== null)) {
                    for (var l = 1; l < vm.paid.paymentMethods.diners; l++) {
                        vm.arrParcelas.push(l + 1);
                    }
                }
                if ((paidType.name === "Elo") && (angular.isDefined(vm.paid.paymentMethods.elo) && vm.paid.paymentMethods.elo !== null)) {
                    for (var m = 1; m < vm.paid.paymentMethods.elo; m++) {
                        vm.arrParcelas.push(m + 1);
                    }
                }
            }
        }

        vm.verificaBandeiraCartao = function () {
            if (angular.isUndefined(vm.paid.cardNumber) || vm.paid.cardNumber === null || vm.paid.cardNumber.length <= 8) {
                return;
            }
            var listCardTypes = [];
            angular.forEach(vm.cardTypes, function(c){
                if(listCardTypes.indexOf(c.toLowerCase()) == -1)
                    listCardTypes.push(c.toLowerCase());
            });
            //if(vm.paid.cardType = vm.paid.cardType || "";
            var _selectedCardType = vm.paid.cardType;
            if(_selectedCardType && listCardTypes.indexOf(_selectedCardType.toLowerCase()) < 0) return;
            var card = $cardType.cardType(vm.paid.cardNumber);
            var cardType = (card === "" || angular.isUndefined(card) ? null : card);
            if(!_selectedCardType || (cardType != _selectedCardType && cardType.toLowerCase() != _selectedCardType.toLowerCase())) {
                var b = vm.brands.filter(function(e) {
                    return e.name == cardType || e.name.toLowerCase() == cardType.toLowerCase() ||
                    (e.name.toLowerCase() == "master" && cardType.toLowerCase() == "mastercard");
                });
                if(b.length>0) vm.selectPaidType(b[0]);
            }
        };

        vm.selectPaidType = function (paidType) {
            var index = vm.brands.indexOf(paidType);
            var i = 0;
            var brandsLength = vm.brands.length;
            for (i; i < brandsLength; i++) {
                vm.brands[i].active = false;
            }
            vm.brands[index].active = true;
            vm.paid.cardType = paidType.name.toLowerCase();

            financialLength(paidType);
        };
        vm.parcelas = function (n) {
            if (n === null || angular.isUndefined(n)) return '';
            if (vm.paid === null || vm.paid.value === null) return '';
            var amount = (vm.paid.value / n) / 100;
            if (angular.isDefined(vm.paid.produtos) && vm.paid.produtos !== null && vm.paid.produtos !== "") return n + "x";
            return n + "x de " + $filter('currency')(amount, 'R$ ') + " = " + $filter('currency')(vm.paid.value / 100, 'R$ ');
        };

        //vm.arrParcelas = [1];
        vm.findZipCodeAddress = MyFunctions.findZipCodeAddress;
        
        function checkisNotValid(value){
            return angular.isUndefined(value) || value == ""  || value == null;
        }

        vm.doSubmit = function () {
            if (!vm.aceitoTerms) {
                alert("Você não aceitou os termos de compra.");
                return false;
            }
            if (!vm.paid.customer) {
                alert("Você não preencheu o nome impresso no cartão.");
                return false;
            }
            if (!vm.paid.cardNumber) {
                alert("Você não preencheu o número impresso no cartão.");
                return false;
            }
            if (!vm.paid.securityCode) {
                alert("Você não preencheu o codigo de segurança.");
                return false;
            }
            if (!vm.paid.goodThru) {
                alert("Você não preencheu a data de validade.");
                return false;
            }
            if (!vm.paid.cardType) {
                alert("Você não escolheu a Bandeira do cartão.");
                return false;
            }
            if (!vm.paid.count) {
                alert("Você não escolheu a quantidade de parcelas.");
                return false;
            }
            if(vm.showPaymentCardAddress){
                if(checkisNotValid(vm.userCard)) {
                    Dialogs.info("Por favor preencher dados de cobrança fatura")
                    return false
                }
                var userData = ['email','cellPhone','street0','street1','address','city','state','zipCode'];
                for(var i = 0; i < userData.length; i++){
                    if(checkisNotValid(vm.userCard[userData[i]]) && (userData[i] === 'cellPhone' || userData[i] === 'email' )){
                        Dialogs.info("Por favor preencher dados completos.");
                        return false
                    }
                    if(checkisNotValid(vm.userCard[userData[i]])){
                        Dialogs.info("Por favor preencher endereço completo.");
                        return false
                    }
                }
            }
            vm.showWait = true;
            //vm.paid.groupRequestPaymentId = vm.paid.id;
            var paid = angular.copy(vm.paid);
            paid.cardNumber = paid.cardNumber.replace(/ /g, '');
            // {"reservationValue":317300,"responsibleCPF":"84683643120","produtos":null,"count":"1","cardType":"visa","total2":"","value2":null,"customer":"TESTE NOVAXS","cardNumber":"5524586443862812","securityCode":"123","goodThru":"1220","reservationPath":"reservations/136151","key":""}
            delete paid.vencimentoCartaoMes;
            delete paid.vencimentoCartaoAno;
            delete paid.paymentMethods;
            delete paid.produtos;
            delete paid.timespan;
            delete paid.travelersAmount;
            delete paid.value2;
            delete paid.uh;
            delete paid.pensao;
            delete paid.serviceName;
            delete paid.checkin;
            delete paid.days;
            delete paid.hotelName;
            delete paid.checkout;
            delete paid.responsibleName;
            delete paid.responsibleId;
            delete paid.responsibleCPF;
            if (angular.isDefined(vm.chave) && vm.chave !== null)
                paid.key = vm.chave;
            vm.paid.customer = vm.paid.cardNumber = vm.paid.securityCode = vm.paid.goodThru = null;
            var dialog = Dialogs.wait();
            if(vm.has3DS()){
                if(Properties.show3dsCardAddress){
                    var u = {};                    
                    angular.copy(vm.userCard, u);
                    u.street0 += " " + u.address;
                    paid._user = u;
                }
               PaymentService.payUsing3ds(_paid, paid);
            }else {
                _paid(paid);
            }
            function _paid(paid){
                BackEnd.execute2({ "method": "payGroupRequestPayment/"+vm.groupRequestPaymentId,
                customer: paid.customer,
                cardType: paid.cardType,
                cardNumber: paid.cardNumber,
                securityCode: paid.securityCode,
                goodThru: paid.goodThru,
                value: paid.value,
                count: paid.count
            },
            function (data) {
                dialog.close();
                if (data.mensagem) {
                    Dialogs.info(data.mensagem);
                    vm.isPaid = true;
                    vm.printLink = vm.pdfAddress + "?method=brokerRequestAsByte&brokerPath=" + data.request + "&token=" + data.token;
                } else {
                    Dialogs.error(data.erro);
                }
            }, function(error){
                dialog.close();
                ErrorHandler.showError(error);
            });
            }
        };

        vm.normalizePaxes = function () {
            if (angular.isUndefined(vm.paid) || angular.isUndefined(vm.paid.travelersAmount)) return "";
            var result = "";
            var array = vm.paid.travelersAmount.split(",");
            for (var index = 0; index < array.length; index++) {
                var element = array[index].split("=");
                if (result !== "") result += ", ";
                var totalPax = parseInt(element[1].replace(/ /g, ""));
                result += element[1] + " " + element[0].replace(/ /, "");
                if (totalPax > 1)
                    result += "s";
            }
            return result;
        };

        vm.getValue = function () {
            return (vm.value / 100);
        };

        vm.formatTravelersAmount = function (travelersAmount) {
            var result = "";
            if (!travelersAmount)
                return null;
            result += String(travelersAmount.adulto) + " adulto" + (travelersAmount.adulto > 1 ? "s" : "");
            if (travelersAmount.crianca && travelersAmount.crianca > 0)
                result += ", " + String(travelersAmount.crianca) + " criança" + (travelersAmount.crianca > 1 ? "s" : "");
            if (travelersAmount.colo && travelersAmount.colo > 0)
                result += ", " + String(travelersAmount.colo) + (travelersAmount.colo > 1 ? " crianças de colo" : " criança de colo");
            if (travelersAmount.infantil && travelersAmount.infantil > 0)
                result += ", " + String(travelersAmount.infantil) + (travelersAmount.infantil > 1 ? " infantis" : " infantil");
            if (travelersAmount.terceira_idade && travelersAmount.terceira_idade > 0)
                result += ", " + String(travelersAmount.terceira_idade) + " terceira idade";
            return result;
        };

        init();
    }
})();

(function() {
  'use strict';

  angular
    .module('b2c_ingressos')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($state, Auth) {
    if(!Auth.isLoggedIn()) $state.go("login");
    //var vm = this;

  }
})();

/**
 * Created by Danillo on 27/06/2016.
 */

(function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($location, Properties, $state, Auth, localStorageService) {
        var vm = this;
        vm.complete = function(){
            var parameters = $location.search();
            if(parameters.next)
                $state.go(parameters.next);
            else if(Properties.pageAfterLogin)
                $state.go(Properties.pageAfterLogin);
            else if(Properties.defaultState && localStorageService.cookieGet("ingToken") != null)
                $state.go(Properties.defaultState, {ingToken: localStorageService.cookieGet("ingToken") });
            else {
                $location.path("/");
            }
        };
        if(Auth.isLoggedIn()) vm.complete();
    }
})();

(function() {
    'use strict';
  
    angular
      .module('b2c_ingressos')
      .controller('InfluencerController', InfluencerController);
  
    /** @ngInject */
    function InfluencerController($location, $state, $stateParams, Auth, Properties) {        

        if (angular.isDefined($stateParams.influencer) && $stateParams.influencer.length > 0 &&
           angular.isDefined($stateParams.influencertoken) && $stateParams.influencertoken.length > 0) {
            Auth.setSalesInfluencer($stateParams.influencer, $stateParams.influencertoken);
            if(Properties.defaultState)
               $state.go(Properties.defaultState);
            else  $location.path("/");            
        }
    }
  })();
  
/**
 * Created by Danillo on 21/06/2016.
 */

/**
 * @typedef {import("../../types/properties").PropertiesType} PropertiesType
 * @typedef {import("../../types/ingresso").IngressoType} IngressoType
 */

/**
 * @typedef {Object} CategoriaComboType
 * @property {boolean} active
 * @property {string} category
 * @property {IngressoType[]} combos
 * @property {number} id
 * @property {IngressoType[][]} linhas
 * @property {number} order
 */

(function() {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('IngressosController', IngressosController);

    /**
     * @ngInject
     * @param {PropertiesType} Properties
    */
    function IngressosController($scope, $rootScope, $log, MyFunctions, $window, $timeout, ScrollTo, $uibModal, Cart, $state, BackEnd,
            ErrorHandler, Tracking, Properties, localStorageService, Dialogs, ProductDialog, $location, $filter) {
        /* jshint validthis:true */
        var vm = this;
        vm.containerWidth = parseInt($window.innerWidth);
        vm.Properties = Properties;
        vm.naoEscolheData = Properties.naoEscolheData;
        vm.lojasAgencies = Properties.lojasAgencies;
        vm.naoUtilizaKey = Properties.naoUtilizaKey;
        vm.fraseModal = Properties.fraseModal;
        vm.disableCupom = Properties.disableCupom;
        vm.ultimasUnidadesIngresso = Properties.ultimasUnidadesIngresso;
        vm.activeDate = false;

        /** @type {IngressoType[]} */
        vm.cart = [];
        vm.productsDenied = [];

        /** @type {IngressoType[]} */
        vm.products = [];
        vm.extraProducts = [];
        var previousStep = [];
        vm.totalValue = 0.00;
        vm.oldValue = 0.00;
        vm.initialValue = 0.00;
        vm.visa = false;
        vm.master = false;
        vm.faturar = false;
        vm.boleto = false;
        vm.date = new Date();
        //vm.paymentMethods = {};
        vm.voucher = "";
        vm.cadastro = false;
        vm.loading = false;
        vm.categories = [];
        vm.productsByCategory = {};
        vm.defaultCategory = null;
        vm.totalAmount = 0;
        vm.selectedCategory = '';
        vm.titleClass = 'title-default';
        vm.activeClass = '';
        vm.step = 'selecionaData';
        vm.cupomCodKey = "";
        vm.today = new Date();

        /** @type {CategoriaComboType[]} */
        vm.categoriasCombos = [];
        vm.showCarMobile = false;
        vm.uxIndicativoCategorias = true;
        vm.uxIndicativoAtracoes = true;
        vm.modalSearchDateToday = Properties.modalSearchDateToday || false;
        vm.resetCarrinho = Properties.resetCarrinho; // limpa o carrinho se estiver setado como true - devido não ser permitido comprar para diferentes datas
        vm.oldBill = Properties.oldBill;
        vm.infoSelectDate = false;

        var maxAmountByProduct = Properties.maxAmountProduct || 0;
        var maxAmountProducts = Properties.maxAmountProducts || 999;

        var lastScrollTop = 0;
        var isProgrammaticScroll = false;

        vm._ingToken = null;

        vm.directScroll = function(id_scroll) {
            isProgrammaticScroll = true;
            ScrollTo.scrollTo(id_scroll);
        };

        vm.verificaPoucasUnidade = function(product) {
          if (!vm.ultimasUnidadesIngresso || !product) return false;

          if (vm.ultimasUnidadesIngresso >= product.available) {
            return product.available;
          }
        }

        vm.selectedAgency = localStorageService.get("_lojaAgency") || 'serragaucha';
        vm.selectAgency = function (agency) {
            vm.lastDate = undefined;
            var lojaAgency = Properties.lojasAgencies.find(function (loja) {
                return loja.url === agency;
            });
            Properties.isBarraBuscaOpen = vm.barraBuscaOpenned;
            if (!vm.lastDate) {
                Properties.selecionarDataAoSairDaVitrine = true;
            }
            $state.go(lojaAgency ? lojaAgency.nome : 'ingressos');
        }
        vm.selectCategory = function (selectedCategory) {
            vm.selectedCategory = selectedCategory;
            vm.categoriasCombos.forEach(function (category) {
                if (selectedCategory === category.category) {
                    category.active = true;
                } else {
                    category.active = false;
                }
            });
        }
        vm.temMaisDe1Category = function () {
            return Number(vm.categoriasCombos.length) > 1;
        }
        vm.getSelectedCategory = function () {
            return vm.selectedCategory === 'DESCONTOS' ? 'Descontos' : 'Ingressos';
        }
        vm.getSelectedRegiao = function () {
            var regiao = Properties.lojasAgencies.find(function (loja) {
                return String($state.current.url).includes(loja.url);
            });
            return regiao ? String(regiao.nome) : 'Serra Gaúcha';
        }
        vm.barraBuscaOpenned = !!Properties.isBarraBuscaOpen;
        vm.toggleBarraBuscaOpenned = function () {
            vm.barraBuscaOpenned = !vm.barraBuscaOpenned;
        }
        vm.mostraBarraBusca = function () {
            return !!vm.step.match(/data|produtos/i);
        }
        vm.searchAndCloseBarraBusca = function () {
            vm.barraBuscaOpenned = false;
            if (vm.date) {
                return;
            }
            vm.search(vm.date);
        }

        var isScrolling = null;
        var _scroll = function () {
            if (!vm.barraBuscaOpenned) return;
            if (isScrolling != null) {
              clearTimeout(isScrolling);
              isScrolling = null;
            }

            if (isProgrammaticScroll) {
              return;
            }

            var currentScrollTop = window.scrollY;
            isScrolling = setTimeout(function () {
                if (
                  currentScrollTop > lastScrollTop &&
                  vm.lastDate &&
                  vm.products.length > 0
                ) {
                  vm.barraBuscaOpenned = false;
                  clearTimeout(isScrolling);
                  isScrolling = null;
                }

                lastScrollTop = currentScrollTop;
            }, 100); // Tempo de espera para detectar o "fim" do scroll
        }
        window.addEventListener("scroll", _scroll);
        window.addEventListener("scroll", function() {
            if(window.scrollY == 72 && isProgrammaticScroll == true){
              isProgrammaticScroll = false
            }
        });

        vm.selecionarDataPeloProdutoVitrine = function (produto) {
            defaultProduct = produto.path;
            defaultProductObject = produto;
            vm.openDatePickerModalMobile(vm.lastDate);
        }
        vm.isLojaAgencyEscondida = function () {
            var lojasEscondidas = Properties.lojasAgenciesEscondidas;
            if (!Array.isArray(lojasEscondidas)) {
                return false;
            }
            var url = String($state.current.url);
            url = url.replace(/^\//, '');
            url = url.replace(/\?.*$/, '');
            return lojasEscondidas.includes(url);
        }

        vm.scrollContainer = function(id_scroll, container) {
            isProgrammaticScroll = true;
            ScrollTo.scrollToContainer(id_scroll, container);

        };

        // Verificação para setar data automaticamente (Gramado Pass)
        if (vm.naoEscolheData) {
            if (Properties.naoEscolheData_Dias !== null && angular.isDefined(Properties.naoEscolheData_Dias)) {
                vm.date = MyFunctions.addDays(vm.date, Properties.naoEscolheData_Dias);
            } else {
                vm.date = MyFunctions.addDays(vm.date, 1);
            }
        }
        // ----------------------------------------------------------------------------------

        vm.openDatePickerModal = function(searchDate) {
            Dialogs.datePickerDialog("Selecione a Data", searchDate, function(date) {
                vm.date = date;
                vm.search(vm.date);
            });
        };

        vm.filterExtras = function(product){
            if(Properties.filterSupplierPathExtras){
                for(var i = 0; vm.cart.length > i; i++){
                    if(product.supplierPath == vm.cart[i].supplierPath){
                        return true;
                    }
                 }
                 return false;
            }
            return true
        }
        vm.extraProductsInCart = function(){
            for(var i = 0; vm.extraProducts.length > i; i++){
                if(vm.filterExtras(vm.extraProducts[i])){
                    return true;
                }
             }
             return false;
        }

        /* navegação */
        vm.nextStep = function() {
            function __toProductsStep() {
                previousStep.push(vm.step);
                vm.step = 'produtos';
            }
            function __toExtraOrCart(){
                if (vm.extraProducts.length > 0 && vm.extraProductsInCart()) {
                    vm.step = 'extras';
                    Tracking.showProducts(vm.extraProducts);
                    vm.directScroll("showExtras");
                } else {
                    vm.step = 'carrinho';
                    Tracking.showCart(vm.cart);
                    vm.directScroll("showPagamento");
                }
            }
            if (vm.step === 'selecionaData') {
                if(vendeApenasExtras){
                    getExtraProducts(undefined, function(){
                        if (vm.extraProducts.length > 0)
                            __toExtraOrCart();
                        else
                            __toProductsStep();
                    });
                } else
                    __toProductsStep();
            } else if (vm.step === 'produtos') {

                if (Properties.needPopUpCart) {
                  var cartLength = vm.cart.length > 1 ? "s" : "";
                  Dialogs.confirm(
                    "<br>Você está adquirindo ingresso" + cartLength + "<br> para utilização na data de <br> <b class='validate-date-cart'>"+ MyFunctions.dateToString(vm.date)  +" </b> . <br> Confirma essa informação?",
                    function () {
                      previousStep.push(vm.step);

                      Cart.setProducts(vm.cart);
                      vm.verificaCupomViaURL();

                      if (vm.cart.length <= 0 && !vendeApenasExtras) {
                        Dialogs.info("O carrinho está vazio!");
                      } else {
                          if(Properties.hasEspecialBasket){
                              getExtraProducts(undefined, function(){
                                  __toExtraOrCart();
                              });
                          } else __toExtraOrCart();
                      }
                    },
                    {},
                    function () {
                      return
                    }
                  );
                } else {
                  previousStep.push(vm.step);

                  Cart.setProducts(vm.cart);
                  vm.verificaCupomViaURL();

                  if (vm.cart.length <= 0 && !vendeApenasExtras) {
                    Dialogs.info("O carrinho está vazio!");
                  } else {
                      if(Properties.hasEspecialBasket){
                          getExtraProducts(undefined, function(){
                              __toExtraOrCart();
                          });
                      } else __toExtraOrCart();
                  }
                }
            } else if (vm.step === 'extras') {
                previousStep.push(vm.step);
                vm.step = 'carrinho';
                Tracking.showCart(vm.cart);
                vm.directScroll("showPagamento");
            } else if (vm.step === 'carrinho') {
                previousStep.push(vm.step);
                vm.step = 'identificacao';
            } else if (vm.step === 'identificacao') {
                previousStep.push(vm.step);
                vm.step = 'pagamento';
            } else if (vm.step === 'pagamento') {
                if (angular.isUndefined(vm.billId) || vm.billId === null || vm.billId <= 0) {
                    $state.go("compras");
                    return;
                }
                previousStep = [];
                //vm.step = 'confirmacao';
                //$log.debug($state.href("confirmacaoConta", { id: vm.billId, token: vm.billToken }, {absolute: true}));
                $state.go("confirmacaoConta", { id: vm.billId, locator: vm.billToken || vm.billLoc });
            }

            if (angular.isDefined(uibModal) && uibModal !== null) {
                uibModal.close(); // fecha modal de ajuda caso estejam abertos
            }
        };

        vm.voltar = function() {
            vm.step = previousStep[previousStep.length - 1];
            previousStep.splice(previousStep.length - 1, 1);
            isProgrammaticScroll = true;
            window.scrollTo(0, 0);

        };

        vm.activeStep = function(step) {
            previousStep.push(vm.step);
            vm.step = step;
            isProgrammaticScroll = true;
            window.scrollTo(0, 0);

        };

        vm.comprarMaisExtras = function() {
            if (vm.step === 'carrinho' || vm.step === 'identificacao' || vm.step === 'pagamento') {
                previousStep.push(vm.step);
                vm.step = 'extras';
            }
        };

        vm.comprarMaisIngressos = function() {
            if (vm.step === 'carrinho' || vm.step === 'identificacao' || vm.step === 'pagamento') {
                previousStep.push(vm.step);
                vm.step = 'produtos';
            }
        };

        vm.reset = function() {
            if (!Properties.ingressoParaVariasDatas) {
                vm.products.length = 0;
                vm.extraProducts = [];
                vm.categoriasCombos = [];
                vm.cart.length = 0; // vm.cart = [];
                Cart.setProducts(vm.cart);
                vm.totalValue = 0;
                vm.totalAmount = 0;
                vm.cupomCod = null;
                vm.cupomKey = null;
                vm.cupomCodKey = null;
                vm.isValidCupom = false;
                _oldProducCustomData = null;
            }
            previousStep = [];
            vm.step = 'selecionaData';
        };

        vm.clearCart = function() {
            vm.cart.length = 0; // vm.cart = [];
            vm.products.length = 0;
            Cart.setProducts(vm.cart);
            vm.totalValue = 0;
            vm.totalAmount = 0;
            vm.step = 'produtos';
            previousStep = ['selecionaData'];
            _oldProducCustomData = null;
            isProgrammaticScroll = true;
            if(Properties.addProductDirect) {
              vm.categoriasCombos.forEach(function (categoria) {
                categoria.linhas.forEach(function (ingressos) {
                  ingressos.forEach(function (item) {
                    item.amount = 0;
                  })
                });
              });
            }
            window.scrollTo(0, 0);

        };
        /* end navegação */

        vm.setMenuClass = function(c, i) {
            vm.selectedCategory = c;

            vm.indexIngressos = i;

            var index = i + 1;
            vm.activeClass = "btn-active";
            vm.titleClass = 'title-' + index;
        };

        vm.handleDate = function() {
            vm.activeDate = !vm.activeDate;
        };

        vm.selectDate = function(product, date) {
            if (product.date != date) {
                var p = product.inAnotherDates.filter(function(each) {
                    return each.date == date;
                })[0];
                product.value = p.value;
                product.date = date;
                product.hasSelectedDate = true;
                if (angular.isDefined(product.children) && product.children !== null) {
                    angular.forEach(product.children, function(child) {
                        var p1 = child.inAnotherDates.filter(function(each) {
                            return each.date == date;
                        })[0];
                        child.value = p1.value;
                        child.date = date;
                    });
                }
            }
        };
        vm.loadImage = function(p){
            if(p.imageLoaded) return p.imageLoaded;
            if(angular.isUndefined(p.image) || p.image === null) return;
            var src = p.image;
            //delete p.image;
            var img = new Image();
            img.onload = function() { p.imageLoaded = src; };
            img.onerror = img.onload;
            img.src = src;
        };
        function getProducts(dateToString, addDays, callback) {
            callback = callback || function() {};
            dateToString = dateToString || MyFunctions.dateToString(new Date());
            //            if (vm.resetCarrinho) {
            //                vm.reset();
            //            }
            var params = {
                "method": "getProductsByDate",
                "date": dateToString
            };


            if (vm._ingToken !== null && angular.isDefined(vm._ingToken)) {
                params.ingToken = vm._ingToken;
            }
            if (clearCache) {
                params.clearCache = "true";
            }
            if(Properties.getAllProducts) {
                params.method =  "getAllProducts";
            }
            BackEnd.execute(params, /** @param {IngressoType[]} data */ function(data) {
                vm.lastDate = MyFunctions.stringToDate(dateToString);
                if (angular.isDefined(Properties.supplierPath) && Properties.supplierPath != null) {
                    data = data.filter(function(p) {
                        return p.supplierPath == Properties.supplierPath;
                    });
                }
                if (angular.isDefined(Properties.ticketCategory) && Properties.ticketCategory != null) {
                    data = data.filter(function(p) {
                        return p.category == Properties.ticketCategory;
                    });
                }
                angular.forEach(data, function(p) {
                    if (angular.isDefined(p.order) && p.order !== null && p.order !== "")
                        p.order = parseInt(p.order, 10);
                    if(p.type == "Combo" && p.products && p.products.filter(function(p1){ return p1.select_date; }).length > 0) {
                        p.needExtraData = p.needExtraData || "combo_dates";
                        p.select_date = true;
                        vm.infoSelectDate = true;
                    }
                    p._totalAmount = 0;
                });
                var produtoDestaque = Properties.defaultProduct || defaultProduct;
                if (produtoDestaque != null) {
                    var defaultProductName = String(defaultProductObject ? (defaultProduct.campoadicional1 || defaultProduct.shortName) : '');
                    data = data.sort(function(a, b) {
                        if (a.path === produtoDestaque || a.id === produtoDestaque || a.shortName === defaultProductName) {
                            vm.defaultCategory = a.category;
                            a.order = -9999;
                            a.nivelDestaque = "anchor-destaque";
                            return -1;
                        }
                        if (b.path === produtoDestaque || b.id === produtoDestaque || b.shortName === defaultProductName) {
                            vm.defaultCategory = b.category;
                            b.order = -9999;
                            b.nivelDestaque = "anchor-destaque";
                            return 1;
                        }
                        return 0;
                    });
                }
                if (addDays) {
                    var notFoundProducts = [];
                    for (var index2 = 0; index2 < data.length; index2++) {
                        var p2 = data[index2];
                        p2.date = vm.lastDate;
                        var isFound = false;
                        for (var index = 0; index < vm.products.length; index++) {
                            var p3 = vm.products[index];
                            if (p3.id == p2.id) {
                                if (angular.isUndefined(p3.inAnotherDates)) {
                                    var p4 = angular.copy(p3);
                                    p3.inAnotherDates = [];
                                    p3.inAnotherDates.push(p4);
                                    p3.dates = [];
                                    p3.dates.push(p4.date);
                                }
                                p3.inAnotherDates.push(p2);
                                p3.dates.push(vm.lastDate);
                                isFound = true;
                                break;
                            }
                        }
                        if (!isFound) {
                            notFoundProducts.push(p2);
                            p2.dates = [vm.lastDate];
                            p2.shortName = p2.shortName || p2.name;
                            p2.category = p2.category || "Outros";
                            if (vm.categories.indexOf(p2.category) < 0)
                                vm.categories.push(p2.category);
                            if (angular.isUndefined(vm.productsByCategory[p2.category]))
                                vm.productsByCategory[p2.category] = [];
                            vm.productsByCategory[p2.category].push(p2);
                            vm.products.push(p2);
                        }
                    }
                    if (notFoundProducts.length > 0) {
                        var children = [];
                        angular.forEach(notFoundProducts, function(p2) {
                            p2.amount = 0;
                            if (angular.isUndefined(p2.parent) || p2.parent === null) {
                                var cats = vm.categoriasCombos.filter(function(cc) {
                                    return cc.category == p2.category;
                                });
                                if (cats.length == 0) {
                                    var cat = getCategorizacaoCombos([p2])[0];
                                    cat.id = vm.categoriasCombos.length;
                                    cat.active = false;
                                    vm.categoriasCombos.push(cat);
                                } else {
                                    cats[0].combos.push(p2);
                                    p2.children = [];
                                }
                            } else {
                                children.push(p2);
                            }
                        });
                        angular.forEach(children, function(p2) {
                            var parent = vm.products.filter(function(p) {
                                return p.id == p2.parent;
                            })[0];
                            if (parent !== null && angular.isDefined(parent)) {
                                parent.children = parent.children || [];
                                parent.children.push(p2);
                            }
                        });
                    }
                } else {

                    vm.products = data;
                    vm.productsByCategory = [];
                    vm.categories = [];
                    if (vm.step == 'selecionaData') {
                        vm.nextStep();
                    }

                    Tracking.showProducts(vm.products, dateToString);
                    vm.categoriasCombos = getCategorizacaoCombos(vm.products);

                    angular.forEach(vm.products, function(p) {
                        //for (var j = 0; j < vm.products.length; j++) {
                        //    var p = vm.products[j];
                        p.amount = 0;

                        var category = p.category || "Outros";

                        p.date = vm.lastDate;
                        p.dates = [vm.lastDate];

                        if (vm.categories.indexOf(category) < 0) {
                            vm.categories.push(category);
                        }
                        if (angular.isUndefined(vm.productsByCategory[category])) {
                            vm.productsByCategory[category] = [];
                        }
                        vm.productsByCategory[category].push(p);
                    });

                    if (vm.categories.indexOf("Outros") > 0) {
                        vm.categories.splice(vm.categories.indexOf("Outros"), 1);
                        vm.categories.push("Outros");
                    }

                    var cat = vm.categories[0];
                    if (vm.defaultCategory !== null && vm.categories.indexOf(vm.defaultCategory) >= 0) {
                        cat = vm.defaultCategory;
                        vm.setMenuClass(cat, vm.categories.indexOf(cat));
                    } else {
                        vm.setMenuClass(cat, 0);
                    }
                }
                vm.categoriasCombos = combosPorLinhas(vm.categoriasCombos);
                callback(null);
                vm.directScroll(Properties.idScrollQuandoBuscaIngresso || "showProdutos");

                if (parameters.details === 'show') {
                    var produtoEmDestaque = data.find(function (p) { return Number(p.id) === Number(defaultProduct) });
                    produtoEmDestaque && vm.verMaisDetalhesProduto(produtoEmDestaque);
                }

                // Fim
            }, function(err) {
                vm.lastDate = MyFunctions.stringToDate(dateToString);
                callback(err);
                ErrorHandler.showError(err);
            });
        }


        vm.isLoadDates = false;
        vm.datesByType = [];
        BackEnd.execute2({ 'method': 'calendarMessages' },
            function(data) {
                function haveItem(arrItem, param) {
                    return arrItem.some(function(i) {
                        return i.type === param;
                    });
                }
                for (var i = 0; i < data.length; i++) {
                    var date = data[i];
                    var dateType = date.tipo || "none";
                    var hasType = haveItem(vm.datesByType, dateType);
                    if (!hasType)
                        vm.datesByType.push({ type: dateType, properties: date });
                }
                vm.isLoadDates = true;
                // vm.date = new Date();
            },
            function(err) {
                ErrorHandler.showError(err);
            }
        );

        /**
         * Adiciona class de fechado, aberto, especial nos dias do calendario
         * @param {type} date
         * @param {type} mode
         * @returns {String}
         */
        vm.getDayClass = function(date, mode) {
            if (mode === 'day') {
                for (var i = 0; i < vm.datesByType.length; i++) {
                    if (date < vm.today)
                        return 'old';
                    var dateType = vm.datesByType[i];
                    if (dateType.properties.dates.indexOf(MyFunctions.dateToString(date)) >= 0) {
                        if (dateType.type.match(/Fechado/)) {
                            return 'closed';
                        }
                        if (dateType.type.match(/Em Breve/)) {
                            return 'em-breve';
                        }
                        if (dateType.type.match(/Esgotado/)) {
                            return 'esgotado';
                        }
                        if (dateType.type.match(/Restrito/)) {
                            return  'restrito';
                        }
                        if (dateType.type.match(/Reduzido/)) {
                            return  'reduzido';
                        }
                        if (dateType.type.match(/Aberto/)) {
                            return 'aberto';
                        }
                        if (dateType.type.match(/Black/)) {
                            return 'black';
                        }
                        if (dateType.type.match(/Especial/)) {
                            return 'especial';
                        }
                        if (dateType.type.match(/Promocional/)) {
                            return 'promocional';
                        }
                        if (dateType.type.match(/Alta/)) {
                            return 'alta';
                        }
                        if (dateType.type.match(/Data Evento/)) {
                            return 'data-evento';
                        }
                        if (dateType.type.match(/Baixa/)) {
                            return 'baixa';
                        }
                    }
                }
            }
            return '';
        };
        vm.disabledDate = function(date, mode) {
            if (mode === 'day') {
                for (var i = 0; i < vm.datesByType.length; i++) {
                    var dateNow = vm.today;
                    dateNow.setHours(0);
                    dateNow.setMinutes(0);
                    dateNow.setSeconds(0);
                    dateNow.setMilliseconds(0);
                    if (date < dateNow)
                        return true;
                    if(Properties.dataAbertura && Properties.dataAbertura > date) return true;
                    var dateType = vm.datesByType[i];
                    if (dateType.properties.dates.indexOf(MyFunctions.dateToString(date)) >= 0) {
                        var normalizedType = dateType.type.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                        if (normalizedType.match(/fechado/) || normalizedType.match(/em breve/)
                            || normalizedType.match(/esgotado/) || normalizedType.match(/restrito/)) {
                            return true;
                        }
                    }
                }
            }
            return false;
        };

        function getExtraProducts(_date, callBack) {
            if (angular.isDefined(vm.lastDate)) {
                _date = vm.lastDate;
            } else {
                _date = _date || vm.date;
            }

            callBack = callBack || function() {};
            var dateToString = MyFunctions.dateToString(_date);
            var params = {
                "method": "getProductsExtraByDate",
                "date": dateToString
            };
            if(Properties.hasEspecialBasket){
                params.products = MyFunctions.productosToString(vm.cart);
                params.method = "getBasketProducts";
            }
            params.ingToken = vm._ingToken;
            if (clearCache)
                params.clearCache = "true";
           // var dialogs = Dialogs.wait("Buscando Adicionais");
            BackEnd.execute(params, function(data) {
                //dialogs.close();
                if (angular.isDefined(Properties.supplierPath) && Properties.supplierPath != null) {
                    data = data.filter(function(p) {
                        return p.supplierPath == Properties.supplierPath;
                    });
                }
                vm.extraProducts = data;
                if (vm.extraProducts !== null) {
                    for (var j = 0; j < vm.extraProducts.length; j++) {
                        var p = vm.extraProducts[j];
                        p.amount = 0;
                        p.shortName = p.shortName || p.name;
                        p.image = p.image || 'assets/images/ingressos/not-imagem.jpg';
                        p.isExtra = true;
                    }
                }
                callBack(_date);
               // Tracking.showProducts(vm.extraProducts); movido para o passo "nextStep"
            }, function(err) {
                //dialogs.close();
                callBack(_date);
                ErrorHandler.showError(err);
            });
        }
        /* retirando por dependencia do momentjs
        vm.timerFinisher = function() {
            Dialogs.info("Sua oferta expirou, verifique as novas ofertas", "Sessão expirada", {}, function(){
                vm.search(vm.date, undefined, function() {
                    cartTotal();
                });
            });
        };*/

        vm.firstSearch = true;
        vm.isSearchingProducts = false;
        vm.search = function(date, endDate, _callback) {
            endDate = endDate || date;
            var dias = MyFunctions.diasEntre(date, endDate);
            if (dias > 7) {
                Dialogs.info("Período máximo permitido 7 dias.");
                return;
            }
            _callback = _callback || function() {};
            if(Properties.getAllProducts && !vm.firstSearch) {
                _callback();
                return;
            }
            vm.firstSearch = false;
            vm.isSearchingProducts = true;
            vm.date = date;
            var dateToString = MyFunctions.dateToString(date);
            if (angular.isDefined(endDate)) {
                vm.endDate = endDate;
            }
            var wd = { close: function() {} };
            var _index = 0;
            var callback = function(_err) {
                _index++;
                if (_index <= dias)
                    getProducts(MyFunctions.dateToString(MyFunctions.addDays(date, _index)), true, callback);
                else {
                    vm.isSearchingProducts = false;
                    wd.close();
                    _callback();
                    if(vm.products == null || vm.products.length == 0){
                        vm.firstSearch = true;
                        if(_err !== null && angular.isDefined(_err)) return;
                        Properties.erroSemProduto = Properties.erroSemProduto || "Nenhum produto disponível para a data " + MyFunctions.dateToString(date);
                        Dialogs.info(Properties.erroSemProduto);
                        return;
                    }
                    if (Properties.ignoraDataAtual) {
                        getExtraProducts(date);
                    } else {
                        getExtraProducts();
                    }
                }
            };

            if (!Properties.ignoraDataAtual && dateToString === MyFunctions.dateToString(new Date())) {
              if (vm.modalSearchDateToday == false && !Properties.getAllProducts) {
                Dialogs.confirm(
                  "Você está adquirindo ingressos(s) para utilização na data de HOJE. Confirma essa informação?",
                  function () {
                    wd = Dialogs.wait("Buscando Produtos");
                    getProducts(
                      MyFunctions.dateToString(MyFunctions.addDays(date, _index)),
                      false,
                      callback
                    );
                  },
                  {},
                  function () {
                    vm.firstSearch = true;
                  }
                );
                vm.reset();
              } else {
                 wd = Dialogs.wait("Buscando Produtos");
                 getProducts(
                   MyFunctions.dateToString(MyFunctions.addDays(date, _index)),
                   false,
                   callback
                 );
              }
            } else {
                wd = Dialogs.wait("Buscando Produtos");
                getProducts(MyFunctions.dateToString(MyFunctions.addDays(date, _index)), false, callback);
            }
        };

        vm.searchInReset = function(date) {
            if (vm.resetCarrinho) {
                vm.reset();
            }
            vm.search(date);
        };

        /*====================================================================*/
        /*------------------------- function card produto --------------------*/

        /**
         * Remove produto do card do produto
         */
        vm.productById = Cart.getProductById;
        vm.removeProduct = function(p){
            Cart.removeProduct(p);
            Tracking.removeItem(p);
        };
        vm.removeItem = function(product) {
            if (product == null || angular.isUndefined(product)) return;
            if (product.amount > 0) {
                product.amount -= 1;
            }
            if (product._totalAmount) {
                product._totalAmount -= 1;
            }
            Cart.removeProduct(product);
            Tracking.removeItem(product);
            cartTotal();
            vm.totalAmount = Cart.getTotalAmount();
        };

        /**
         * Adiciona produto do card do produto
         */
        vm.addItem = function(product) {
            if (angular.isUndefined(product.amount) || product.amount === null || product.amount === '0') {
                product.amount = 0;
            }

            if (maxAmountByProduct && product.amount >= maxAmountByProduct) {
                return;
            }
            if (product.maxAmount && product.amount  == product.maxAmount) {
                return;
            }

            product.date = product.date || vm.lastDate;
            product.amount += 1;


            Tracking.addItem(product);

            if(Properties.addProductDirect){
              product._totalAmount = product.amount;
              Cart.removeProduct(product);
              vm.addProductDirect(product);
            }
        };


        function getAvailableDate(product, date) {
            var isFound = false;
            for (var i = 0; i < product._rows.length; i++) {
                var d = product._rows[i];
                if(d.disabled !== null) continue;
                if(product._disableDates.validDates.includes(MyFunctions.dateToString(d.date))) {
                    d.disabled = false;
                    if(d.date == date) isFound = true;
                }
            }
            if(isFound) return;
            angular.forEach(product._rows, function(dt){
                if(dt.disabled !== null) return;
                dt.disabled = !product._disableDates.validDates.includes(MyFunctions.dateToString(dt.date));
            });
            product._disableDates.isLoading = true;
            // var minDate = MyFunctions.addDays(MyFunctions.firstDayOfMonth(date), -13);
            var minDate = date;
            var maxDate = MyFunctions.addDays(minDate, 31 + 14 + 8); // 7 + 31 + 7
            if(minDate < new Date()) minDate = new Date();
            var params = {
                method: "getAvailableDatesForProduct",
                toAgencyPath: "agencies/" + Properties.agency,
                productPath: product.path,
                date: MyFunctions.dateToString(minDate),
                endDate: MyFunctions.dateToString(maxDate)
            };
            BackEnd.execute(params, function (data) {
                product._disableDates.isLoading = false;
                if (product._disableDates.minDate == null || minDate < product._disableDates.minDate)
                    product._disableDates.minDate = minDate;
                if (product._disableDates.maxDate == null || maxDate > product._disableDates.maxDate)
                    product._disableDates.maxDate = maxDate;
               // data.splice(data.indexOf("18/03/2020"),1);
                product._disableDates.validDates = product._disableDates.validDates.concat(data);
                angular.forEach(product._rows, function(dt){
                    if(dt.disabled !== null) return;
                    dt.disabled = !product._disableDates.validDates.includes(MyFunctions.dateToString(dt.date));
                });
            }, function (error) {
                product._disableDates.isLoading = false;
                ErrorHandler.showError(error);
            });
        }
        vm.dateRows = function(rows){
            $log.debug('dateRows', rows);
        };


        function getProductsUpsell(product, result) {
          var dialog = Dialogs.wait();
          var prod = product;
          BackEnd.execute(
            {
              method: "getProductsUpSell",
              productPath: product.path,
              date: MyFunctions.dateToString(vm.date)
            },
            function (data) {
              dialog.close();

              ProductDialog.upSell(product, data, function (newProd) {
                newProd.amount = product.amount;
                newProd.date = product.date;

                result(newProd);
              }, function(prod) {
                vm.productsDenied.push(prod.path);
              });
            },
            function () {
              dialog.close();
              result(prod);
            }
          );


         }

         function isParent(p1, p2) {
           if (p1.path === p2.path) return true;

           var paiFilho = p1.parent === p2.id;
           var filhoPai = p1.id === p2.parent;
           var mesmosPais = p1.parent && p1.parent === p2.parent;

           return paiFilho || filhoPai || mesmosPais;
         }

        function ChildWithoutParent(cart, p) {
          if (!p.parent) return

          if (cart.length === 0 && p.parent) return true;
          var parent = cart.some(function (c) {
              if (c.id === p.parent) return true;
            });

          return !parent;
        }

        /**
         * Adiciona produto direto no carrinho
        */
        var _needUpSell = null;
        var produtoUnico = null;
        /** @param {IngressoType} product */
        vm.addProductUpsell = function(product) {
            if (vm.totalAmount + 1 > maxAmountProducts) return;

            if (product.exigeFornecedorUnico === "true") {
              var productName = '';
              vm.cart.forEach(function (p) {
                if (product.supplierPath !== p.supplierPath) {
                  productName = p.shortName;
                  produtoUnico = true;
                }
              });

              if (produtoUnico) {
                produtoUnico = null;
                return ErrorHandler.showError(
                  "O produto <b>" +
                    product.shortName +
                    "</b> não pode ser vendido em conjunto com o produto <b>" +
                    productName +
                    "</b>. Retire do seu carrinho antes de acrescentar esse produto."
                );
              }
            }

            if (product.vendaExclusiva === "true") {
              vm.cart.forEach(function (p) {
                if (isParent(product, p)) {
                  return;
                }

                produtoUnico = true;
              });

              if (produtoUnico) {
                produtoUnico = null;

                return ErrorHandler.showError(
                  "O produto <b>" +
                    product.shortName +
                    "</b> não pode ser vendido em conjunto com outros produtos. Limpe seu carrinho antes de acrescentar esse produto.");
              }
            } else {
              if (Cart.hasExclusive(product, isParent)) {
                return ErrorHandler.showError(
                  "O produto <b>" +
                    product.shortName +
                    "</b> não pode ser vendido em conjunto com outros produtos. Limpe seu carrinho antes de acrescentar esse produto.");
              }
            }

            if (Properties.requireParentForExclusive)
              if (ChildWithoutParent(vm.cart, product)) {
                return Dialogs.error(
                  "O produto <b>" +
                    product.shortName + "</b> so pode ser adicionado no carrinho após adicionar o produto principal.");
              }


            function internalAdd(newProd) {
              if (newProd) product = newProd;
              if (!Properties.strictAddToCart) {
                product.amount = product.amount || 1;
              }
              product.date = product.date || vm.lastDate;
              var verificaCupomUrl = vm.cart.length == 0;
              vm.addToCart(product);
              if (verificaCupomUrl) vm.verificaCupomViaURL();
              if (
                vm.isValidCupom &&
                angular.isDefined(vm.cupomCod) &&
                vm.cupomCod !== null &&
                angular.isDefined(vm.cupomKey) &&
                vm.cupomKey !== null
              ) {
                vm.validCupom();
              }
              return true;
            }
            function _openwizard(p, telas, i, callBack) {
              if (i >= telas.length) {
                p.needExtraData = p._needExtraData;
                return callBack();
              }
              p.needExtraData = telas[i];
              i++;
              if (p.needExtraData == "formulario") {
                ProductDialog.open(p, vm.cart, function () {
                  return _openwizard(p, telas, i, callBack);
                });
              } else {
                dialogExtraData(p, function () {
                  return _openwizard(p, telas, i, callBack);
                });
              }
            }


            if (!Properties.strictAddToCart && product.minAmount && product.amount < product.minAmount)
              product.amount = Number(product.minAmount);
            product.needExtraData =
              product._needExtraData || product.needExtraData;

            if (product.linkAceite || product.termosAceite) {
              if(angular.isUndefined(product.needExtraData) || product.needExtraData === null) {
                product._aceite = true;
              }

              product.needExtraData = product.needExtraData || "aceite";
              if (product.needExtraData.indexOf("aceite") != 0)
                product.needExtraData = "aceite," + product.needExtraData;
            }

            product._needExtraData = product.needExtraData;
            if (product.date) product.date = vm.date;
            if (ProductDialog.need(product)) {
              if (
                product.needExtraData &&
                product.needExtraData.indexOf(",") > 0
              ) {
                _openwizard(
                  product,
                  product.needExtraData.split(","),
                  0,
                  function () {
                    product.needExtraData = product._needExtraData;
                    return internalAdd();
                  }
                );
              } else if (
                angular.isDefined(product.needExtraData) &&
                product.needExtraData != "formulario"
              ) {

                dialogExtraData(product, function () {
                  ProductDialog.open(product, vm.cart, internalAdd);
                });
              } else ProductDialog.open(product, vm.cart, internalAdd);
            } else if (
              Properties.allProductsNeedExtraData ||
              (angular.isDefined(product.needExtraData) &&
                product.needExtraData !== "" &&
                product.needExtraData != "false")
            ) {
              if (
                product.needExtraData &&
                product.needExtraData.indexOf(",") > 0
              ) {
                _openwizard(
                  product,
                  product.needExtraData.split(","),
                  0,
                  function () {
                    product.needExtraData = product._needExtraData;
                    return internalAdd();
                  }
                );
              } else dialogExtraData(product);
            } else {
              internalAdd();
            }
        }


        var _oldProducCustomData = null;
        var _prodDenied = null
        /** @param {IngressoType} product */
        vm.addProductDirect = function(product) {
          _prodDenied = false
          _needUpSell = false;
          if (
            product.basket_required_strategy &&
            product.basket_required_strategy.length > 0
          ) {
            product.basket_required_strategy.forEach(function (e) {
              if (e.salesStrategy === "UP-SELL") {
                _needUpSell = true;
              }
            });
          }

          if (vm.productsDenied.indexOf(product.path) >= 0 ) {
            _prodDenied = true;
          }

          if (_needUpSell && !_prodDenied) {
            getProductsUpsell(product, vm.addProductUpsell);
          } else vm.addProductUpsell(product);

        };




        vm.valorTotalBox = function(ingresso) {
            var valorTotal = 0;

            if (angular.isDefined(ingresso.amount) && ingresso.amount > 0 && angular.isDefined(ingresso.value) && ingresso.value > 0) {
                valorTotal += ingresso.value / 100 * ingresso.amount;
            }

            angular.forEach(ingresso.children, function(child) {
                if (angular.isDefined(child.amount) && child.amount > 0 && angular.isDefined(child.value) && child.value > 0) {
                    valorTotal += child.value / 100 * child.amount;
                }
            });

            return valorTotal;
        };

        vm.countTotalBox = function(ingresso) {
            var countTotal = 0;

            if (angular.isDefined(ingresso.amount) && ingresso.amount > 0 && angular.isDefined(ingresso.value) && ingresso.value > 0) {
                countTotal += ingresso.amount;
            }

            angular.forEach(ingresso.children, function(child) {
                if (angular.isDefined(child.amount) && child.amount > 0 && angular.isDefined(child.value) && child.value > 0) {
                    countTotal += child.amount;
                }
            });

            return countTotal;
        };

        vm.addExtraProduct = function(product) {
            if (vm.totalAmount + 1 > maxAmountProducts) return;
            //product.amount = 1;
            //product.date = product.date || vm.lastDate;
            product.isExtra = true;
            vm.addProductDirect(product); //vm.addToCart(product);
            //if (vm.isValidCupom && angular.isDefined(vm.cupomCod) && vm.cupomCod !== null && angular.isDefined(vm.cupomKey) && vm.cupomKey !== null)
            //   vm.validCupom();
            /*else
             cartTotal();*/
        };

        /** Verifica se produto tem form */
        vm.productHasForm = function(product){
            return product.form !== null && angular.isDefined(product.form) && product.form != {};
        }
        /**
         * Adicionar produto ou lote de produtos ao carrinho
         * @param {IngressoType} product
         */
        vm.addToCart = function(product) {
            /** @param {IngressoType} _product */
            var addProduct = function(_product) {
                _product.date = _product.date || vm.lastDate;

                if (product.selectedHour) {
                  _product.schedule = product.selectedHour;
                }


                var isFound = false;
                var comboDate = product.type === "Combo" && product.select_date;
                if( _product._aceite || (!comboDate && _product.category !=="Seguros" && (angular.isUndefined(_product.needExtraData) || _product.needExtraData == null || _product.needExtraData == ""))){
                    for (var index = 0; index < vm.cart.length; index++) {
                            var p = vm.cart[index];
                            if (p.id == _product.id && MyFunctions.dateToString(p.date) == MyFunctions.dateToString(_product.date)) {
                                if (maxAmountByProduct && p.amount + _product.amount > maxAmountByProduct) {
                                    Dialogs.info("A quantidade máxima de compras desse produto é " + maxAmountByProduct);
                                    return;
                                }
                                if (p.available && p.amount + _product.amount > p.available) {
                                    Dialogs.info("Quantidade máxima do '" + (p.shortName || p.name) + "' é " + p.available);
                                    return;
                                }
                                if (p.maxAmount && p.amount + _product.amount > p.maxAmount) {
                                    Dialogs.info("Quantidade máxima do '" + (p.shortName || p.name) + "' é " + p.maxAmount);
                                    return;
                                }
                                if(vm.productHasForm(_product)){
                                    var pf = angular.copy(_product);
                                    pf.amount = 1;
                                    vm.cart.push(pf);
                                } else {
                                  if (Properties.addProductDirect){
                                    p.amount = _product.amount;

                                  } else {
                                    p.amount += _product.amount;
                                  }
                                }
                                isFound = true;
                                Cart.setProducts(vm.cart);
                                break;
                            }
                        }
                }

                var maxAmountParent;
                var maxAmountTotalRelatedProducts = 0;

                if (_product.maxAmountParentPath) {
                  maxAmountTotalRelatedProducts += 1;
                  maxAmountParent = _product.maxAmountParentPath;
                } else {
                  angular.forEach(vm.cart, function (ingresso) {
                    if (ingresso.maxAmountParentPath !== undefined) {
                      maxAmountParent = ingresso.maxAmountParentPath;
                    }


                  });
                }
                if (maxAmountParent === _product.path) {
                  maxAmountTotalRelatedProducts += 1;
                }
                var ammount = 0;
                for (var key in vm.cart) {
                  if (Object.hasOwnProperty.call(vm.cart, key)) {
                    var pAmount = vm.cart[key];

                    if(maxAmountParent === pAmount.path) {
                      maxAmountTotalRelatedProducts += 1;
                    }

                    if(pAmount.maxAmountParentPath) {
                      maxAmountTotalRelatedProducts += 1;
                    }

                    if (pAmount.path == _product.path) {
                      ammount += 1;
                      if (_product.amount + ammount > pAmount.maxAmount) {
                        product.amount = 0;
                        ErrorHandler.showError(
                          "So é possivel adicionar " +
                            pAmount.maxAmount +
                            " deste produto!"
                        );
                        return;
                      }
                    }
                  }
                }

                if (maxAmountTotalRelatedProducts >  _product.maxAmount) {
                    ErrorHandler.showError(
                     "So é possivel adicionar " + _product.maxAmount + " de produtos dependentes!"
                   );
                   return;

                }

                if (!isFound) {
                    if (_product.available && _product.amount > _product.available) {
                        Dialogs.info("A quantidade máxima de compras do produto '" + (_product.shortName || _product.name) + "' é " + _product.available);
                        return;
                    }
                    if (_product.maxAmount && _product.amount > _product.maxAmount) {
                        Dialogs.info("A quantidade máxima de compras do produto '" + (_product.shortName || _product.name) + "' é " + _product.maxAmount);
                        return;
                    }
                    var p1 = angular.copy(_product);
                    if(p1.person){
                        var person = p1.person;
                        var dialog = Dialogs.wait();
                        BackEnd.execute({
                            "method": "findOrCreatePerson",
                            "person": person
                            },
                            function(data){
                                dialog.close();
                                p1._customData = p1.customData || {};
                                p1._customData.person = "persons/"+data.id;
                                Tracking.login(person);
                                delete p1.person;
                                Cart.setProducts(vm.cart);
                            },
                            function(err) {
                                dialog.close();
                                Tracking.loginError(err);
                                ErrorHandler.showError(err);
                        });
                    }
                    //p1.date = p1.date || vm.lastDate;
                    vm.cart.push(p1);
                    Cart.setProducts(vm.cart);
                    Tracking.addToCart(_product);
                } else {
                    Tracking.addToCart(_product);
                }

                if(Properties.addProductDirect) {
                  vm.totalAmount = 0
                   angular.forEach(vm.cart, function (p) {
                     vm.totalAmount += parseInt(p.amount);
                   });
                } else {
                  vm.totalAmount += parseInt(_product.amount);
                  _product.amount = 0;
                }

                product._totalAmount = Cart.getAmount(product);
            };

            if (!product.loading) {
                 // TODO: considerar produto de venda exclusiva
                if (vm.totalAmount + product.amount > maxAmountProducts) return;
                if (product.amount > 0) addProduct(product);
                if (angular.isDefined(product.children) && product.children !== null) {
                    for (var index = 0; index < product.children.length; index++) {
                        var child = product.children[index];
                        if (child.amount > 0)
                            addProduct(child);
                    }
                }
            }

            cartTotal();
        };
        vm.getAmount = Cart.getAmount;


        vm.verificaAmountSeniorAdultoIncluso = function(ingresso) {
            var checkSeniors = true;

            if (ingresso.amount > 0) {
                return false;
            }

            ingresso.children.forEach(function(child) {
                if (child.amount > 0) {
                    checkSeniors = false;
                }
            });

            return checkSeniors;
        };

        function dialogExtraData(product, _dialogCallback) {
            var _templateUrl = Properties.templateIngressosExtra || "app/ingressos/modais/dialog-ingresso-extrainfo.html";

            if (angular.isDefined(product.needExtraData) && product.needExtraData !== "true") {
                _templateUrl = product.needExtraData;
                if (product.needExtraData == "frete")
                    _templateUrl = "app/ingressos/modais/dialog-ingresso-frete.html";
                else if (product.needExtraData == "hora")
                  _templateUrl = product.type == "Combo" && product.select_date ?
                      "app/ingressos/modais/dialog-combo-dates-hour.html" :
                      "app/ingressos/modais/dialog-ingresso-hora.html";
                else if(product.needExtraData == "dates")
                  _templateUrl = "app/ingressos/modais/dialog-combo-dates-hour.html" ;
                else if (product.needExtraData == "combo_dates")
                    _templateUrl = "app/ingressos/modais/dialog-combo-dates.html";
                else if (product.needExtraData == "aceite")
                     _templateUrl = "app/ingressos/modais/dialog-aceitar-termos.html";
                else if (product.needExtraData == "primeiro_dia")
                     _templateUrl = "app/ingressos/modais/dialog-ingresso-primeirodia.html";
                else if (product.needExtraData == "horas_iguais")
                     _templateUrl = "app/ingressos/modais/dialogSameHour.html";
                else if (product.needExtraData == "next_hora")
                  _templateUrl =
                    "app/ingressos/modais/dialog-ingresso-proxima-hora.html";
            }
            _oldProducCustomData = _oldProducCustomData || {};
            _oldProducCustomData.date = product.date || vm.lastDate;
            if (Properties.getAllProducts) {
                product._rows = [];
                product._disableDates = product._disableDates || {
                    isLoading: false,
                    minDate: null,
                    maxDate: null,
                    validDates: []
                };
            }
            var products = [];


            if (Properties.unicoPorLancamento && product.category === "Seguros") {
                if (product.amount > 0) {
                    for (var index = 0; index < product.amount; index++) {
                        var p = angular.copy(product);
                        products.push(p);
                        p.amount = 1;
                    }
                } else {
                    angular.forEach(product.children, function (child) {
                        if (angular.isDefined(child.amount)) {
                            for (var index = 0; index < child.amount; index++) {
                                child._rows = [];
                                child._disableDates = product._disableDates || {
                                    isLoading: false,
                                    minDate: null,
                                    maxDate: null,
                                    validDates: []
                                };
                                var p = angular.copy(child);
                                products.push(p);
                                p.amount = 1;
                            }
                        }
                    });
                }
                product = products[0];
            } else {
                product.amount = product.amount || 1;
                products.push(product);
            }
            if (Properties.naoCompartilhaDados) {
                _oldProducCustomData = { HotelTraslado: _oldProducCustomData.HotelTraslado };
            }
            Dialogs.form(products, product.shortName || product.name, _oldProducCustomData,
                function (data) {
                    var _products = products;
                    if (product.type == "Combo" && product.select_date) product.date = data.date;
                    angular.forEach(product.children, function (child) {
                        if (child.amount >= 1) {
                            if (angular.isDefined(data.date) && Properties.naoVerificaQuantidade) {
                                _products = [];
                                child.date = data.date;
                                child._customData = angular.copy(data);
                                if (data.HotelTraslado) {
                                    localStorageService.set('hotel');
                                    if (data.date)
                                        child._customData.DataVooIdaTraslado = MyFunctions.dateToString(data.date);
                                    if (data.DataVooVoltaTraslado)
                                        child._customData.DataVooVoltaTraslado = MyFunctions.dateToString(data.DataVooVoltaTraslado);
                                    if (data.HoraVooIdaTraslado)
                                        child._customData.HoraVooIdaTraslado = MyFunctions.timesToString(data.HoraVooIdaTraslado);
                                    if (data.HoraVooVoltaTraslado)
                                        child._customData.HoraVooVoltaTraslado = MyFunctions.timesToString(data.HoraVooVoltaTraslado);
                                }

                                if (Properties.unicoPorLancamento && child.category === "Seguros") {
                                    angular.forEach(products, function (p) {
                                        var prod = angular.copy(p);
                                        _products.push(prod);
                                        prod.amount = 1;
                                        prod.date = data.date;
                                    });
                                } else {
                                    _products.push(child);
                                }
                                //delete child._customData.date;
                            }
                        }
                    });
                    if (angular.isDefined(data) && data !== null) {
                        _oldProducCustomData = angular.copy(data);
                        product._customData = angular.copy(data);
                        if (product._customData.HotelTraslado || product._customData.HoraVooIdaTraslado) {
                            if (data.date)
                                product._customData.DataVooIdaTraslado = MyFunctions.dateToString(data.date);
                            if (data.DataVooVoltaTraslado)
                                product._customData.DataVooVoltaTraslado = MyFunctions.dateToString(data.DataVooVoltaTraslado);
                            if (data.HoraVooIdaTraslado)
                                product._customData.HoraVooIdaTraslado = MyFunctions.timesToString(data.HoraVooIdaTraslado);
                            if (data.HoraVooVoltaTraslado)
                                product._customData.HoraVooVoltaTraslado = MyFunctions.timesToString(data.HoraVooVoltaTraslado);
                        }
                        if (angular.isDefined(data.date) && angular.isDefined(data.endDate) && !Properties.naoVerificaQuantidade) {
                            _products = [];
                            product.date = data.date;
                            product.amount = data.amount || product.amount;
                            for (var i = 0; i < MyFunctions.diasEntre(data.date, data.endDate); i++) {
                                var p2 = angular.copy(product);
                                p2.date = MyFunctions.addDays(p2.date, i);
                                // p2.customData = angular.copy(data);
                                delete p2._customData.date;
                                delete p2._customData.endDate;
                                _products.push(p2);
                            }
                        } else if (angular.isDefined(data.date) && (Properties.naoVerificaQuantidade || product.amount > 0)) {
                            _products = [];
                            product.date = data.date;
                            angular.forEach(product.children, function (child) {
                                if (angular.isDefined(child.date)) {
                                    child.date = data.date;
                                }
                            });
                            if (Properties.unicoPorLancamento && product.category === "Seguros") {
                                angular.forEach(products, function (p) {
                                    var prod = angular.copy(p);
                                    _products.push(prod);
                                    prod.amount = 1;
                                    prod.date = data.date;
                                });
                            } else {
                                _products.push(product);
                            }
                            delete product._customData.date;
                            if (Properties.naoCompartilhaDados) {
                                _oldProducCustomData = { HotelTraslado: _oldProducCustomData.HotelTraslado };
                            }
                        }
                    }
                    angular.forEach(_products, function (p) {
                        if (Properties.naoVerificaQuantidade && p.amount < 1) {
                            if (data.amount !== null && angular.isDefined(data.amount)) {
                                p.amount = data.amount;
                                p.date = data.date;
                                data.amount = 1;
                            }
                        }
                        p.date = p.date || vm.lastDate;
                    });
                    function _addProducts(_products){
                        var verificaCupomUrl = vm.cart.length == 0;
                        angular.forEach(_products, function (p) {
                            vm.addToCart(p);
                        });
                        if (verificaCupomUrl) vm.verificaCupomViaURL();
                        if (vm.isValidCupom && angular.isDefined(vm.cupomCod) && vm.cupomCod !== null && angular.isDefined(vm.cupomKey) && vm.cupomKey !== null) {
                            vm.validCupom();
                        }
                    }
                    _dialogCallback = _dialogCallback || _addProducts;
                    _dialogCallback(_products);
                }, { templateUrl: _templateUrl },
                {
                    dateDisabled: function (date, mode) {
                        if (mode != "day") return false;
                        if (Properties.getAllProducts) {
                            if (product._disableDates.validDates.includes(MyFunctions.dateToString(date)))
                                return false;
                            if (product._disableDates.minDate <= date && product._disableDates.maxDate >= date)
                                return !product._disableDates.validDates.includes(MyFunctions.dateToString(date));
                            if (product._disableDates.isLoading) return null;
                            getAvailableDate(product, date);
                            return null;
                        }
                        else
                            return false;
                    },
                    _parent_vm: vm
                }
            );
        }

        /**
         * 1 Formata nomes e imagens
         * 2 Validações de nomes, imagens e criacao de array object para children
         * 3 Adicionando os childrens a partir do id e parent
         * @param {array} products
         * @returns {array} products formatados
         */
        function getCategorizacaoCombos(products) {
            var comboProducts = [];

            angular.forEach(products, function(product) { // validações de nomes, imagens e criacao de array object para children
                product.shortName = product.shortName || product.name;
                product.image = product.image || 'assets/images/ingressos/not-imagem.jpg';
                product.category = product.category || "Produtos";

                if (angular.isUndefined(product.parent)) {
                    comboProducts.push(product);
                    product.children = [];
                    product.amount = 0;
                }
            });

            angular.forEach(products, function(product) { // adicionando os childrens a partir do id e parent
                if (angular.isDefined(product.parent) && product.parent !== null) {
                    angular.forEach(comboProducts, function(parent) {
                        if (parent.id === product.parent) {
                            product.amount = 0;
                            parent.children.push(product);
                            return;
                        }
                    });
                }
            });

            var combosCategorizados = separarCombosPorCategoria(comboProducts);
            return combosCategorizados;
        }


        /**
         * Separa combos por categoria
         * @param {array} combos
         * @returns {array} combos separados por categoria
         */
        function separarCombosPorCategoria(combos) {
            if (angular.isUndefined(combos) || combos === null || combos.length == 0) return [];
            var combosOrdenados = ordernarCombos(combos);
            var result = [];

            angular.forEach(combosOrdenados, function(combo) { // monta o array de categorias com id, active, category
                if (angular.isDefined(combo.category)) {
                    var each = result.filter(function(cat) {
                        return cat.category == combo.category;
                    })[0];
                    if (each === null || angular.isUndefined(each)) {
                        result.push({
                            id: result.length,
                            active: false,
                            category: combo.category
                        });
                    }
                }
            });
            if (result.length > 0) {
                result[0].active = true;
                if (vm.defaultCategory !== null && vm.defaultCategory !== "") {
                    result[0].active = false;
                    var _result = result.filter(function(cat) {
                        return cat.category == vm.defaultCategory;
                    });
                    if (_result.length > 0) {
                        _result[0].active = true;
                    }
                }
            }


            angular.forEach(result, function(category) {
                category.combos = [];
                angular.forEach(combosOrdenados, function(combo) {
                    if (combo.category === category.category) {
                        category.combos.push(combo);
                    }
                    if (angular.isUndefined(combo.order)) {
                        combo.order = 0;
                    }
                });
            });

            return result;
        }


        /**
         * Ordena combos por nome
         * @param {array} combos desordenados
         * @returns {array} combos ordenados
         */
        function ordernarCombos(combos) {
            var combosOrdenados = combos.sort(function(a, b) {
                // Coloca o defaultProduct como primeiro
                if (defaultProduct != null) {
                    if (a.path == defaultProduct || a.id == defaultProduct) {
                        vm.defaultCategory = a.category;
                        return -1;
                    }
                    if (b.path == defaultProduct || b.id == defaultProduct) {
                        vm.defaultCategory = b.category;
                        return 1;
                    }
                }

                var nameA = a.category.toLowerCase();
                var nameB = b.category.toLowerCase();

                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });

            return combosOrdenados;
        }

        function orderCategories(categoriasCombos) {
            angular.forEach(categoriasCombos, function(c1) {
                if (angular.isUndefined(c1.order)) c1.order = 999999;
                angular.forEach(c1.combos, function(c) {
                    if (angular.isDefined(c.order) && c.order !== null && c.order !== '') {
                        if (c.order < c1.order) c1.order = c.order;
                    }
                });
            });
            return categoriasCombos.sort(function(c1, c2) {
                var order1 = c1.order;
                var order2 = c2.order;
                if (order2 > order1)
                    return -1;
                if (order2 < order1)
                    return 1;
                return 0;
            });
        }

        function combosPorLinhas(categoriasCombos) {
            if (categoriasCombos.length == 0) return categoriasCombos;

            categoriasCombos = orderCategories(categoriasCombos);
            var amountByLine = vm.amountByLine || 4;
            angular.forEach(categoriasCombos, function(categoria) {
                categoria.combos = categoria.combos.sort(function(a, b) {
                    if (angular.isDefined(a.order) && a.order !== null && a.order !== "")
                        a.order = parseInt(a.order, 10);
                    if (angular.isDefined(b.order) && b.order !== null && b.order !== "")
                        b.order = parseInt(b.order, 10);
                    if (angular.isUndefined(a.order)) return -1;
                    if (angular.isUndefined(b.order)) return 1;
                    return a.order - b.order;
                });
                categoria.active = false;
                var linhas = [];
                var linha = [];
                angular.forEach(categoria.combos, function(combo) {
                    if (linha.length == amountByLine) {
                        linhas.push(linha);
                        linha = [];
                    }
                    linha.push(combo);
                });
                linhas.push(linha);
                categoria.linhas = linhas;
            });
            categoriasCombos[0].active = true;
            if (vm.defaultCategory !== null && vm.defaultCategory !== "") {
                categoriasCombos[0].active = false;
                (categoriasCombos.filter(function(cat) {
                    return cat.category == vm.defaultCategory;
                })[0] || categoriasCombos[0]).active = true;
            }
            return categoriasCombos;
        }
        /*------------------------- function card produto --------------------*/
        /*====================================================================*/



        /*====================================================================*/
        /*---------------- function card produto carrinho --------------------*/
        vm.addItemInCart = function(produto) {
            if (vm.totalAmount + 1 > maxAmountProducts) return;
            if (maxAmountByProduct && produto.amount >= maxAmountByProduct)
                return;
            var ps = vm.cart.filter(function(p) {
                        return (p.id == produto.id && MyFunctions.dateToString(p.date) == MyFunctions.dateToString(produto.date));
                    });
            if(ps.length == 0) return;
            var p = ps[0];
            if (p.available && p.amount + 1 > p.available) {
                Dialogs.info("A quantidade máxima de compras do produto '" + (p.shortName || p.name) + "' é " + p.available);
                return;
            }
            if(p.maxAmount && p.amount + 1 > p.maxAmount) {
                Dialogs.info("A quantidade máxima de compras do produto '" + (p.shortName || p.name) + "' é " + p.maxAmount);
                return;
            }
            p.amount += 1;
            vm.totalAmount += 1;

            if (vm.isValidCupom && angular.isDefined(vm.cupomCod) && vm.cupomCod !== null && angular.isDefined(vm.cupomKey) && vm.cupomKey !== null) {
                vm.validCupom();
            } else {
                cartTotal();
            }
            Cart.setProducts(vm.cart);
            Tracking.onChangeCart(vm.cart);
            var item = {};
            angular.copy(produto, item);
            item.amount=1;
            Tracking.addToCart(item);
        };

        vm.removeItemInCart = function(product) {
            if (product.amount <= 1) {
                return;
            }
            if(product.minAmount && product.minAmount > product.amount -1){
                return;
            }
            var ps = vm.cart.filter(function(p) {
                return (p.id == product.id && MyFunctions.dateToString(p.date) == MyFunctions.dateToString(product.date));
            });
            if(ps.length == 0) return;
            ps[0].amount -= 1;
            vm.totalAmount -= 1;
            if (vm.isValidCupom && angular.isDefined(vm.cupomCod) && vm.cupomCod !== null && angular.isDefined(vm.cupomKey) && vm.cupomKey !== null) {
                vm.validCupom();
            } else {
                cartTotal();
            }
            Cart.setProducts(vm.cart);
            Tracking.onChangeCart(vm.cart);
            var item = {};
            angular.copy(product, item);
            item.amount=1;
            Tracking.removeFromCart(item);
        };

        vm.removeItemFromCart = function(index, product) {
            vm.products.forEach(function(p) {
                if (p.name === product.name) {
                    p.amount = 0;
                }
            });


            function verifyExtraProducts() {
              var newCart = [];
              var params = {};

              params.products = MyFunctions.productosToString(
                vm.cart
              );
              params.method = "getBasketProducts";
              params.date = MyFunctions.dateToString(vm.date);

              BackEnd.execute(params, function(data) {
              if (angular.isDefined(Properties.supplierPath) && Properties.supplierPath != null) {
                  data = data.filter(function(p) {
                      return p.supplierPath == Properties.supplierPath;
                  });
              }

              vm.cart.forEach(function (el) {
                if (el.isExtra) {
                  data.forEach(function (extra) {
                    if (extra.path !== el.path) {
                      return;
                    } else {
                      newCart.push(el);
                    }
                  });
                } else {
                  newCart.push(el);
                }
              });
              vm.cart = newCart;


              if (newCart.length === 0) {
                vm.clearCart();
              }

              vm.extraProducts = data;
              if (vm.extraProducts !== null) {
                for (var j = 0; j < vm.extraProducts.length; j++) {
                    var p = vm.extraProducts[j];
                    p.amount = 0;
                    p.shortName = p.shortName || p.name;
                    p.image = p.image || 'assets/images/ingressos/not-imagem.jpg';
                    p.isExtra = true;
                }
              }


              Cart.setProducts(vm.cart);
              Tracking.onChangeCart(vm.cart);
              Tracking.removeFromCart(product);
            }, function(err) {
                ErrorHandler.showError(err);
            })

            }

            vm.cart.splice(index, 1);
            vm.totalAmount -= product.amount;

            if (vm.isValidCupom && angular.isDefined(vm.cupomCod) && vm.cupomCod !== null && angular.isDefined(vm.cupomKey) && vm.cupomKey !== null) {
                vm.validCupom();
            } else {
                cartTotal();
            }

            if (vm.extraProducts.length >= 0) {
                verificaIngressosCarrinho();
            }


            if(!Properties.hasEspecialBasket) {
              Cart.setProducts(vm.cart);
              Tracking.onChangeCart(vm.cart);
              Tracking.removeFromCart(product);
            } else {
              verifyExtraProducts();
            }


        };

        function verificaIngressosCarrinho() {
            var verificaIngressosCarrinho = false;
            for (var i = 0; i < vm.cart.length; i++) {
                if (!vm.cart[i].isExtra) {
                    verificaIngressosCarrinho = true;
                    break;
                }
            }
            if (!verificaIngressosCarrinho && !vendeApenasExtras) {
                Dialogs.info("Seu Carrinho ficou vazio! Estamos retornando para área de produtos.");
                vm.clearCart();
            }
        }

        vm.removeCupom = function() {
            delete vm.cupomCodKey;
            delete vm.cupomKey;
            delete vm.cupomCod;
            vm.isValidCupom = false;
            cartTotal();
        };

        $scope.$watch('vm.cupomCod', function(_new, _old) {
            if(_old == _new) return;
            // if(!vm.isValidCupom) return;
            vm.isValidCupom = false;
            if (vm.cupomKey && vm.cupomCodKey != vm.cupomCod + "-" + vm.cupomKey) {
                vm.cupomCodKey = vm.cupomCod + "-" + vm.cupomKey;
            }
            if (angular.isDefined(vm.oldValue) && vm.oldValue !== null) {
                vm.totalValue = vm.oldValue;
                vm.oldValue = null;
            }
        });

        $scope.$watch('vm.cupomKey', function(_new, _old) {
            if(_old == _new) return;
            // if(!vm.isValidCupom) return;
            vm.isValidCupom = false;
            if (vm.cupomKey && vm.cupomCodKey != vm.cupomCod + "-" + vm.cupomKey)
                vm.cupomCodKey = vm.cupomCod + "-" + vm.cupomKey;
            if (angular.isDefined(vm.oldValue) && vm.oldValue !== null) {
                vm.totalValue = vm.oldValue;
                vm.oldValue = null;
            }
        });

        function listenerCupomCodKey(_new, _old) {
            if(_old == _new) return;
            //if(!vm.isValidCupom) return;
            vm.isValidCupom = false;
            if(_new == null){
                vm.cupomCod = null;
                vm.cupomKey = null;
            } else if(vm.cupomCodKey.indexOf("-") > 0){
                var arr = vm.cupomCodKey.split("-");
                if(vm.cupomCod != arr[0]) vm.cupomCod = arr[0];
                if(vm.cupomKey != arr[1]) vm.cupomKey = arr[1];
            } else if(vm.cupomCod != vm.cupomCodKey) {
                vm.cupomKey = null;
                vm.cupomCod = vm.cupomCodKey;
            }
            if (angular.isDefined(vm.oldValue) && vm.oldValue !== null) {
                vm.totalValue = vm.oldValue;
                vm.oldValue = null;
            }
        }

        $scope.$watch('vm.cupomCodKey', listenerCupomCodKey);

        $scope.$watch('vm.cart.length', function(){
            if(vm.cart.length == 0){
                vm.totalValue = 0;
                vm.oldValue = 0;
            }
        })

        vm.validCupom = function() {
            /*
            if (angular.isDefined(vm.cupomCodKey) && vm.cupomCodKey !== null && vm.cupomCodKey !== "") {
                var split = vm.cupomCodKey.split("-");
                if(vm.cupomCod != split[0]) vm.cupomCod = split[0];
                if (split.length > 1 && vm.cupomKey != split[1])
                    vm.cupomKey = split[1];
            } else {
                if(vm.cupomCod) vm.cupomCodKey = vm.cupomCod + (vm.cupomKey ?  "-" + vm.cupomKey : "");
            }*/
            if(vm.cart.length == 0) return;
            if (Properties.naoUtilizaKey === null || angular.isUndefined(Properties.naoUtilizaKey) || !Properties.naoUtilizaKey) {
                if (angular.isUndefined(vm.cupomCod) || vm.cupomCod === null || vm.cupomCod === "" || angular.isUndefined(vm.cupomKey) || vm.cupomKey === null || vm.cupomKey === "") {
                    Dialogs.info("Cupom incorreto");
                    return;
                } else {
                    if (angular.isUndefined(vm.cupomCod) || vm.cupomCod === null || vm.cupomCod === "") {
                        Dialogs.info("Cupom incorreto");
                        return;
                    }
                }
            }

            if (Array.isArray(vm.cupomCod)) {
              vm.cupomCod = String(vm.cupomCod[0]).replace("-", "|");
            }
            if (Array.isArray(vm.cupomCodKey)) {
              vm.cupomCodKey = String(vm.cupomCodKey[0]).replace("-", "|");
            }

            var produtosAsString = MyFunctions.productosToString(vm.cart);
            var dialog = Dialogs.wait();
            var _cupomAsString = "";
            if(vm.cupomCod) _cupomAsString = vm.cupomCod + "|" + (vm.cupomKey === undefined || vm.cupomKey == null ? "" : vm.cupomKey);
            _cupomAsString = _cupomAsString
              .replace(/\|$/, "")
              .replace("-", "|");
            var params = {
              "method": "validCupom",
              "cupomAsString": _cupomAsString,
              "productsArray": produtosAsString
            };
            var bookingAgency = localStorageService.cookieGet("bookingAgency");
            if(bookingAgency)
              params.toAgencyPath = bookingAgency;
            var lastValues = {
                totalValue: vm.totalValue,
                oldValue: vm.oldValue,
                descValue: vm.descValue,
                freteValue: vm.freteValue,
                feeValue: vm.feeValue,
                paymentMethodsAdjustments: vm.paymentMethodsAdjustments
            };
            vm.totalValue = null;
            vm.oldValue = null;
            vm.descValue = null;
            vm.freteValue = null;
            vm.feeValue = null;
            vm.paymentMethodsAdjustments = null;
            function errFunc(err) {
                vm.isValidCupom = false;
                vm.totalValue = lastValues.totalValue;
                //vm.oldValue = lastValues.oldValue;
                //vm.descValue = lastValues.descValue;
                vm.freteValue = lastValues.freteValue;
                vm.feeValue = lastValues.feeValue;
                vm.paymentMethodsAdjustments = lastValues.paymentMethodsAdjustments;
                dialog.close();
                ErrorHandler.showError(err);
                cartTotal();
            }
            BackEnd.execute(params,
                function(data) {
                    dialog.close();
                    if(angular.isUndefined(data) || data === null || angular.isUndefined(data.value) || data.value === null){
                        errFunc({aviso:"cupom incorreto"});
                        return;
                    }
                    vm.isValidCupom = true;
                    vm.totalValue = data.value;
                    vm.paymentMethodsAdjustments = data.paymentMethodsAdjustments;
                    vm.oldValue = data.oldValue;
                    vm.descValue = data.descValue;
                },
                errFunc
                );
        };


        vm.getCupom = function() {
            if(!vm.isValidCupom) return null;
            if(vm.cupomCodKey) return vm.cupomCodKey;
            if(vm.cupomCod) return vm.cupomCod + (vm.cupomKey != null && vm.cupomKey != "" ?  "-" + vm.cupomKey : "");
            return null;
        };

        function cartTotal() {
            var _couponAsString = null;
            if (vm.cart.length == 0) {
                vm.totalValue = null;
                return;
            }
            if (Properties.naoUtilizaKey === null || angular.isUndefined(Properties.naoUtilizaKey) || !Properties.naoUtilizaKey) {
                if (vm.isValidCupom && angular.isDefined(vm.cupomCod) && vm.cupomCod !== null && vm.cupomCod !== "" && angular.isDefined(vm.cupomKey) && vm.cupomKey !== null && vm.cupomKey !== "") {
                    _couponAsString = vm.cupomCod + "|" + (vm.cupomKey === undefined || vm.cupomKey == null ? "" : vm.cupomKey);
                }
            } else {
                if (vm.isValidCupom && angular.isDefined(vm.cupomCod) && vm.cupomCod !== null && vm.cupomCod !== "")
                    _couponAsString = vm.cupomCod + "|" + (vm.cupomKey === undefined || vm.cupomKey == null ? "" : vm.cupomKey);
            }
            var produtosAsString = MyFunctions.productosToString(vm.cart);
            var params = {
                "method": "billPrice",
                "couponAsString": _couponAsString,
                "productsArray": produtosAsString
            };
            var bookingAgency = localStorageService.cookieGet("bookingAgency");
            if(bookingAgency)
              params.toAgencyPath = bookingAgency;
            vm.totalValue = null;
            vm.oldValue = null;
            vm.descValue = null;
            vm.freteValue = null;
            vm.feeValue = null;
            vm.productUpdated = null;
            vm.paymentMethodsAdjustments = null;
            var d = Dialogs.wait("Calculando");
            BackEnd.execute(params,
                function(data) {
                    d.close();
                    vm.totalValue = data.value;
                    vm.initialValue = data.value;
                    vm.oldValue = data.oldValue;
                    vm.descValue = data.descValue;
                    vm.freteValue = data.freteValue;
                    vm.feeValue = data.feeValue;
                    vm.productUpdated = data.products;
                    vm.paymentMethodsAdjustments = data.paymentMethodsAdjustments;

                    angular.forEach(vm.productUpdated, function(prod){
                        angular.forEach(vm.cart, function(p) {
                            if (prod.path === p.path
                                // && prod.amount == p.amount
                                && prod.date === MyFunctions.dateToString(p.date)
                                && prod.value != p.value) {
                                if(p.fee == null || angular.isUndefined(p.fee) ||
                                    parseInt(p.fee) + parseInt(p.value) != parseInt(prod.value))
                                    p.value = prod.value;
                            }
                        });
                    });
                    Cart.setProducts(vm.cart);
                },
                function(err) {
                    d.close();
                    ErrorHandler.showError(err);
                });
        }

        /**
         * Aplicar o paymentMethodsAdjustments,
         * personalizando os valores conforme
         * as condições de pagamento, caso tenha.
         */
       $scope.$watch("vm.paymentMethodsAdjustments", function (/*_new, _old*/) {
        vm.conditionsArray = vm.customPrices.getAllConditionsTexts();
       });

        vm.customPrices = {
          paymentMethodsAdjustments: function () {
            return vm.paymentMethodsAdjustments;
          },
          /*
          hasPaymentMethodsAdjustments: function(){
            return !!(vm.paymentMethodsAdjustments && vm.paymentMethodsAdjustments.length);
          },*/

          /**
           * @returns {string[]}
           */
          getAllConditionsTexts: function () {
              function getPaymentMethodText(c) {
                var text = '';
                if (['master', 'mastercard', 'visa', 'amex', 'hipercard', 'elo'].some(function(pt) {
                  return c.paymentTypes.includes(pt);
                })) {
                  if (c.installments > 1) {
                    text = "em até " + c.installments + "x no CC";
                  }
                  if (c.installments == 1) {
                    text = " à vista no CC ";
                  }
                } else {
                  text = 'no ' + c.paymentTypes.join(',');
                }
                return text;
              }
            var conditions = [];
            var adjustments = vm.paymentMethodsAdjustments;

            var conditionsMap = {};

            if (Array.isArray(adjustments)) {
              adjustments.forEach(function (c) {
                if (c.type === "acrescimo") return;

                var obj = {
                  value: $filter("currency")(c.value / 100, "R$ "),
                  paymentMethod: getPaymentMethodText(c),
                  installments: parseInt(c.installments),
                  percent: c.percent,
                  type: c.type,
                };

                if (conditionsMap[c.percent]) {
                  if (
                    obj.installments > conditionsMap[c.percent].installments
                  ) {
                    conditionsMap[c.percent] = obj;
                  }

                } else {
                  conditionsMap[c.percent] = obj;
                }
              });
            }
            conditions = Object.values(conditionsMap);
            return conditions;
          },
        };



        function FilhoSemPai(cart) {
          return cart.some(function (p) {
            if (!p.parent) return false;

            var paiExiste = cart.some(function (c) {
              return c.id === p.parent && c.vendaExclusiva === "true";
            });

            return !paiExiste;
          });
        }

        /**
         * Efetuar pagamento
         */
        vm.initialPurchase = function() {
            if (vm.cart.length > 0) {
              if (Properties.requireParentForExclusive)
                if (FilhoSemPai(vm.cart)) {
                  return Dialogs.error("Existe um ingresso dependente no carrinho sem o produto principal.");
                }
                Cart.setProducts(vm.cart);
                vm.verificaCupomViaURL();

                var pulaExtras = Cart.getProducts().every(function (p) {
                    return p.naoVendeExtras === 'true';
                });

                vm.nextStep();
                if (pulaExtras) vm.nextStep();
            } else {
                Dialogs.info("O carrinho está vazio!");
            }
        };

        /*---------------- function card produto carrinho --------------------*/
        /*====================================================================*/


        /**
         * Verifica se foi passado algum cupom como parametro na URL
         */
        vm.verificaCupomViaURL = function() {
            var cupomFromUrl = localStorageService.get("cupom");
            if (cupomFromUrl !== null && cupomFromUrl !== "") {
                vm.cupomCodKey = cupomFromUrl;
                listenerCupomCodKey(vm.cupomCodKey, null);
                vm.validCupom();
            } else {
                cartTotal();
            }
        };

        vm.registroEfetuado = function() {
            $rootScope.abrirObrigatorioModalPoliticas();
            vm.step = 'pagamento';
            vm.pagamento = true;
        };

        vm.showPagamento = function() {
            vm.nextStep();
            vm.pagamento = true;
        };

        vm.isFinalStep = function() {
            return vm.step === 'pagamento';
        };

        vm.endPurchase = function(data) {
            if (angular.isDefined(data)) {
                if (angular.isDefined(data.id)) vm.billId = data.id;
                if (angular.isDefined(data.localizador)) vm.billLoc = data.localizador;
                if (angular.isDefined(data.token)) vm.billToken = data.token;
                // if(angular.isUndefined(data.qrcode) || data.qrcode === null || data.qrcode === "") {
                //     if (angular.isDefined(data.paymentUrl) && data.paymentUrl !== null && data.paymentUrl.indexOf("http") == 0) {
                //         Cart.setLastBill(data);
                //         Dialogs.iframe(data.paymentUrl);
                //         return;
                //     }
                // }
                Cart.setLastBill(data);
                if (angular.isDefined(data.externalPaymentUrl) && data.externalPaymentUrl !== null && data.externalPaymentUrl.indexOf("http") == 0) {
                    window.location.href = data.externalPaymentUrl;
                    Dialogs.iframe_authenticate(data.externalPaymentUrl);
                    return;
                }

            }
            vm.nextStep();
            try {
                localStorageService.cookie.remove("bill_remark");
            } catch (error) { $log.error(error); }
        };

        vm.openInfo = function(product) {
            var _product = product;
            $uibModal.open({
                animation: true,
                templateUrl: 'modal-content',
                bindToController: true,
                controller: modalCtrl,
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    product: function() {
                        return _product;
                    },
                    parent: function() {
                        return vm;
                    }
                }
            });
        };

        vm.onpenModalInfoSimple = function(product) {
            var _product = product;
            $uibModal.open({
                animation: true,
                templateUrl: Properties.maisDetalhesIngressoTemplateUrl || 'app/new_ingressos/modais/mais-detalhes-ingresso.html',
                bindToController: true,
                controller: modalCtrl,
                controllerAs: 'vm',
                size: 'big',
                resolve: {
                    product: function() {
                        return _product;
                    },
                    parent: function() {
                        return vm;
                    }
                }
            });
        };


        vm.openModalHelpTicket = function() {
            var _product = "";
            $uibModal.open({
                animation: true,
                templateUrl: 'app/new_ingressos/modais/ajuda-ingressos.html',
                bindToController: true,
                controller: modalCtrl,
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    product: function() {
                        return _product;
                    },
                    parent: function() {
                        return vm;
                    }
                }
            });
        };

        var uibModal = null;
        /** @param {IngressoType} product */
        vm.verMaisDetalhesProduto = function(product) {
            var _product = product;
            uibModal = Dialogs.openProductDetais(_product, vm);
            // uibModal = $uibModal.open({
            //     animation: true,
            //     templateUrl: Properties.maisDetalhesIngressoTemplateUrl || 'app/new_ingressos/modais/mais-detalhes-ingresso.html',
            //     bindToController: true,
            //     controller: modalCtrl,
            //     controllerAs: 'vm',
            //     size: 'big',
            //     resolve: {
            //         product: function() {
            //             return _product;
            //         },
            //         parent: function() {
            //             return vm;
            //         }
            //     }
            // });
        };


        /**
         * Pesquisa automaticamente se vier data na URL
         */
        if (angular.isUndefined(vm.oldBill) || vm.oldBill === null) {
            vm.oldBill = localStorageService.cookieGet("bill_remark");
        }
        var parameters = $location.search();

        var clearCache = false;
        var defaultProduct = null;
        var defaultProductObject = undefined;
        var vendeApenasExtras = false;
        if (angular.isDefined(parameters) && parameters !== null) {
            if (parameters.category !== null && parameters.category !== "" && angular.isDefined(parameters.category)) {
                vm.defaultCategory = parameters.category;
            }
            if (parameters.categoria !== null && parameters.categoria !== "" && angular.isDefined(parameters.categoria)) {
                vm.defaultCategory = parameters.categoria;
            }
            if (parameters.product !== null && parameters.product !== "" && angular.isDefined(parameters.product)) {
                defaultProduct = parameters.product;
            }
            if (parameters.ingToken !== null && parameters.ingToken !== "" && angular.isDefined(parameters.ingToken)) {
                vm._ingToken = parameters.ingToken;
            }
            Cart.setIngToken(vm._ingToken);
            clearCache = parameters.limpacache ? true : false;
            Properties.clearCache = clearCache;
            if (parameters.endDate !== null && parameters.endDate !== "" && angular.isDefined(parameters.endDate)) {
                //if (vm.resetCarrinho) vm.reset();
                vm.endDate = MyFunctions.stringToDate(parameters.endDate);
            } else vm.endDate = null;
            vendeApenasExtras = angular.isDefined(parameters.extras) && parameters.extras == "true";
            if (parameters.date !== null && parameters.date !== "" && angular.isDefined(parameters.date)) {
                if (vm.resetCarrinho) vm.reset();
                vm.date = MyFunctions.stringToDate(parameters.date);
                getExtraProducts(vm.date, function(_date) {
                    vm.date = _date || vm.date;
                    vm.search(vm.date, vm.endDate, function(){
                        $scope.$broadcast("updateCalendar", vm.date);
                    });
                    if (vendeApenasExtras) {
                        vm.nextStep();
                        vm.nextStep();
                    }
                });
            }
            if(parameters.cart !== null && parameters.cart !== ""
                && angular.isDefined(parameters.cart) && parameters.cart[0] == "[") {
                var c = JSON.parse(parameters.cart);
                vm.clearCart();
                try {
                    /*var dialog = Dialogs.wait("aguarde", null, {
                        windowTopClass: 'modal-wait super-modal',
                        windowClass: 'modal-wait super-modal'
                    });*/
                    var searchAndAddProducts = function(c, i, callBack) {
                        callBack = callBack || function(){
                            searchAndAddProducts(c, ++i, callBack);
                        }
                        if(c.length <= i) {
                           // dialog.close();
                            vm.nextStep();
                            vm.nextStep();
                            Dialogs.info("Carrinho carregado com sucesso.");
                            return;
                        }
                        //var i = 0;
                        var el = c[i];
                        vm.date = MyFunctions.stringToDate(el.date);
                        if(el.itens == null || angular.isUndefined(el.itens) || el.itens.length == 0){
                            callBack();
                        }
                        vm.search(vm.date, null, function(){
                            for (var j = 0; j < el.itens.length; j++) {
                                if(vm.products == null) continue;
                                var p = el.itens[j];
                                if(p.amount == null || angular.isUndefined(p.amount) || p.amount == 0)
                                    continue;
                                var products = vm.products.filter(function(p2){
                                    return p.path == p2.path;
                                });
                                if(products.length == 0) continue;
                                var p3 = products[0];
                                p3.amount = p.amount;
                                vm.addProductDirect(p3);
                            }
                            callBack();
                        });
                    }
                    c.sort(function(a,b) { return MyFunctions.stringToDate(a.date) - MyFunctions.stringToDate(b.date)});
                    searchAndAddProducts(c, 0);
                } catch (error) {
                    // dialog.close();
                    $log.error(error);
                }
            }
        }

        vm.cart = Cart.getProducts();

        vm.getProductAmmount = function (product) {
          if(vm.cart.length === 0) return
          var result = vm.cart.filter(function(item) {
            return item.path === product.path
          });
          return result[0];
        }


        if (vm.cart.length > 0) {
            vm.date = Cart.minDate();
            vm.endDate = Cart.minDate();
            vm.totalAmount = 0;
            angular.forEach(vm.cart, function(p) {
                // if (vm.date > p.date) {
                //     vm.date = p.date;
                // }
                // if (vm.endDate < p.date) {
                //     vm.endDate = p.date;
                // }
                vm.totalAmount += parseInt(p.amount);
            });

            vm.search(vm.date, vm.endDate, function() {
                cartTotal();
                $timeout(vm.verificaCupomViaURL, 1000);
            });
            /*cartTotal({ close: function () {
                $log.debug("Janela não fecha");
            } });*/
        } else  $timeout(vm.verificaCupomViaURL, 1000);

        vm.showHiddenCarMobile = function() {
            if (vm.showCarMobile === false) {
                vm.showCarMobile = true;
            } else {
                vm.showCarMobile = false;
            }

            if (uibModal !== null) {
                uibModal.close();
            }
        };

        /**
         * Abrir data piker em dispositivos moveis
         * @returns {undefined}
         */
        vm.openDatePickerModalMobile = function(_dataEscolhida) {
            Dialogs.datePickerDialog("Data de Entrada", _dataEscolhida, function(date) {
                vm.dataEscolhidaActive = date;
                if (vm.resetCarrinho) {
                    vm.reset();
                }
                vm.search(vm.dataEscolhidaActive);
            }, {},{
                customClass: vm.getDayClass,
                dateDisabled: vm.disabledDate
            });
        };
        vm.diferenciaTemporadas =  function(tipo){
          return MyFunctions.diferenciaTemporadas(vm.datesByType, tipo);
        };

    }

    /** @ngInject */
    function modalCtrl($uibModalInstance, product, parent) {
        /* jshint validthis:true */
        var vm = this;
        vm.product = product;
        vm.parent = parent;

        vm.close = function() {
            $uibModalInstance.close('close');
        };
    }

})();

(function () {
    'use strict';

    angular
            .module("b2c_ingressos")
            .controller("CupomController", cupomController);
    /* pagina de cupom só funciona se tiver o couponAgencyPath ou couponAgencyPaths definido em Properties
      Exemplo:
      couponAgencyPath: "agencies/XX"
      ou
      couponAgencyPaths: [
        {route: "nome-para-rota", path: "agencies/XX", name: "Nome para exibir", img: "caminho/para/imagem.png", advantagePath: "advantages/XX"}
      ]
      A propriedade route é obrigatória se for usar o couponAgencyPaths
      A propriedade path é obrigatória
      A propriedade name é opcional, se não existir será usado o nome retornado na verificação do cupom
      A propriedade img é opcional, se existir será exibida na tela de seleção do cupom
      A propriedade advantagePath é opcional, se existir será usado na verificação do cupom
    */


    /** @ngInject */
    function cupomController(BackEnd, $location, $log, $scope, $filter, $state, MyFunctions, Properties, ErrorHandler, Auth, Dialogs, CalendarService) {
        /* jslint validthis:true */
        var vm = this;
        vm.cupons = [];
        vm.qtdCupons = 0;
        vm.arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
        vm.isValidCupons = false;
        vm.step = 1;
        vm.user = {};

        vm.today = new Date();
        vm.date = new Date();
        vm.voucherUrl = "";
        //vm.amounts = [0, 1, 2, 3, 4, 5];
        vm.notIsFree = false;
        vm.errorMessage = "";
        vm.showClienteLogado = true;
        vm.produtosExtras = [];
        vm.cart = [];
        vm.pagamento = false;
        vm.couponAgencyPaths = Properties.couponAgencyPaths || [];

        vm.datesByType = [];
        CalendarService.init(vm.datesByType);
        vm.getDayClass = function(date, mode){
            return CalendarService.getDayClass(vm.datesByType, vm.today, date, mode);
        }
        vm.disabledDate = function (date, mode) {
            return CalendarService.disabledDate(vm.datesByType, vm.today, date, mode);
        }


        function getCouponAgencyPathFromRoute(){
            if(Properties.couponAgencyPaths && $state.params.name){
                var path = '';
                vm.couponAgencyPaths.forEach(function(item){
                    if($state.params.name === item.route){
                        path = item.path;
                        $scope.couponAgency = item;
                    }
                });
                if(path){
                    return path;
                }else{
                    ErrorHandler.showError("Empreendimento incorreto.");
                    return undefined;
                }
            }
            if(vm.couponAgencyPaths.length){
              return '';
            }
            if(Properties.couponAgencyPath){
              return Properties.couponAgencyPath;
            }
            if(Properties.couponAgencyPath == undefined && vm.couponAgencyPaths.length == 0){
              return '';
            }
            $log.info("Fornecedor de cupom não informado.");
            ErrorHandler.showError("Link incorreto.");
            return undefined;
        }

        var couponAgencyPath = getCouponAgencyPathFromRoute();
        if(couponAgencyPath === undefined) {
            $state.go(Properties.defaultState);
            return;
        }
        vm.setCouponAgencyPath = function(item){
            vm.couponAgency = item;
            couponAgencyPath = item.path;
        };

        vm.disableForm = function(){
            return !couponAgencyPath;
        };

        var parameters = $location.search();
        if (parameters.q !== null && angular.isDefined(parameters.q) && parameters.q.length > 0) {
            vm.qtdCupons = parseInt(parameters.q, 10);
        }
        if (parameters.cupom !== null && angular.isDefined(parameters.cupom) && parameters.cupom.length > 0) {
            var split = parameters.cupom.split("-");
            vm.cupons = [];
            for (var i = 0; i < vm.qtdCupons; i++) {
                vm.cupons.push({cod: split[0], key: split.length > 1 ? split[1] : ""});
            }
        } else {
            vm.qtdCupons = 1;
            vm.cupons.push({cod: "", key: ""});
        }
        if (parameters.d !== null && angular.isDefined(parameters.d) && parameters.d.length > 0) {
            vm.date = MyFunctions.stringToDate(parameters.d);
        }

        $scope.$watch('vm.qtdCupons', function (newValue, oldValue) {
            if (angular.equals(newValue, oldValue))
                return;
            var len = parseInt(newValue);
            if (len > 0) {
                if ((angular.isUndefined(parameters.q) || parameters.q === "") && (angular.isUndefined(parameters.cupom) || parameters.cupom === "")) {
                    vm.cupons = [];
                    for (var i = 0; i < vm.qtdCupons; i++) {
                        vm.cupons.push({cod: "", key: ""});
                    }
                } else {
                    var qtd = vm.cupons.length;

                    if (len > qtd) {
                        for (var j = qtd + 1; j <= len; j++) {
                            vm.cupons.push({cod: "", key: ""});
                        }
                    }
                    if (len < qtd) {
                        for (var k = qtd; k > len; k--) {
                            vm.cupons.pop();
                        }
                    }
                }


            }
        });
        vm.verMaisDetalhesProduto = function (product) {
          Dialogs.openProductDetais(product, vm.ingressosController);
        };
        vm.nextStep = function (index) {
            vm.step = index + 1;
            if (vm.step == 2 && vm.produtosExtras.length <= 0)
                vm.step = 3;
            if (vm.step == 4) {
                vm.step++;
            }
        };

        vm.backStep = function () {
            if (vm.step == 5) {
                vm.step--;
            }
            if (vm.step === 3 && vm.produtosExtras.length >= 0) {
                for (var i = 0; i < vm.cart.length; i++) {
                    var produto = vm.cart[i];
                    for (var j = 0; j < vm.produtosExtras.length; j++) {
                        var produtoExtra = vm.produtosExtras[j];
                        if (produto.name === produtoExtra.name) {
                            produtoExtra.amount = produto.amount;
                        }
                    }
                }
            }
            vm.step -= 1;
            if (vm.step === 1) {
                vm.isValidCupons = false;
            }
            if (vm.step == 2 && vm.produtosExtras.length <= 0) {
                vm.isValidCupons = false;
                vm.step = 1;
            }
        };

        function validateCard(paymentMethod) {
            if (!paymentMethod.cardNumber) {
                alert("Você não preencheu o número do cartão.");
                return false;
            }
            if (!paymentMethod.code) {
                alert("Você não preencheu o código de segurança.");
                return false;
            }
            if (!paymentMethod.goodThru) {
                alert("Você não preencheu a data de validade.");
                return false;
            }
            if (!paymentMethod.personName) {
                alert("Você não preencheu o nome impresso no cartão.");
                return false;
            }
            if (!paymentMethod.type) {
                alert("Você não selecionou a bandeira.");
                return false;
            }
            if (!paymentMethod.personCpf) {
                alert("CPF do titular não informado");
                return false;
            }
            return true;
        }


        vm.verifyCupons = function () {
            for (var i = 0; i < vm.cupons.length; i++) {
                var coupom = vm.cupons[i];
                coupom.valid = null;
                coupom.errorMessage = null;
            }
            vm.isValidCupons = false;
            var cuponsAsString = vm.cuponsAsString();
            var params1 = {"method": "verificaCupons",
                "cupons": cuponsAsString,
                "date": MyFunctions.dateToString(vm.date),
                "couponAgencyPath":couponAgencyPath
            };
            BackEnd.execute2(params1, function (data) {
                vm.isValidCupons = true;
                vm.cart = [];
                for (var i = 0; i < data.length; i++) {
                    var coupom = data[i];
                    vm.isValidCupons = vm.isValidCupons && coupom.valid == 'true';
                    vm.notIsFree = vm.notIsFree || coupom.free == 'false';
                    var cupomValue = parseInt(coupom.value);

                    var hasProduct = containsProduct(coupom.productName);
                    if (hasProduct) {
                        var index = cartIndex(coupom.productName);
                        vm.cart[index].amount += 1;
                        vm.cart[index].value = (vm.cart[index].amount * vm.cart[index].value);
                    } else {
                        vm.cart.push({name: coupom.productName, amount: 1, value: cupomValue});
                    }

                }
                vm.cupons = data;
                Properties.permiteMenordeIdade = data[0].permiteMenorDeIdade;

                if (vm.isValidCupons) {
                    getProductsExtraByDate();
                } else {
                    return;
                }
            },
            function (err) {
                ErrorHandler.showError(err);
            });
        };

        vm.finishLogin = function () {
            vm.user = Auth.getUser();
            if (vm.totalGeral() === 0) {
                vm.createVoucher();
            } else {
                vm.getPaymentMethods();
                vm.pagamento = true;
            }
        }

        var getProductsExtraByDate = function () {
            if(Properties.ocultaExtrasNoCupom) {
                vm.nextStep(vm.step);
                return;
            }
            var params1 = {
                "method": "getProductsExtraByDate",
                "date": MyFunctions.dateToString(vm.date)
            };
            BackEnd.execute2(params1, function (data) {
                    vm.produtosExtras = data;
                    vm.nextStep(vm.step);
                },
                function (err) {
                    ErrorHandler.showError(err);
                });
        };

        function cartIndex(productName) {
            for (var i = 0; i < vm.cart.length; i++) {
                var item = vm.cart[i];
                if (item.name === productName)
                    return i;
            }
        }

        function containsProduct(productName) {
            return vm.cart.some(function (item) {
                return item.name === productName;
            });
        }

        vm.addRemoveProduto = function (i, produto) {
            var amountBefore = parseInt(produto.amount);
            var productName = produto.shortName ? produto.shortName : produto.name;
            if (produto.amount == "0")
                produto.amount = 0;
            produto.amount = produto.amount + i;
            if (produto.amount <= 0)
                produto.amount = '0';
            if (produto.amount > 5)
                produto.amount = 5;
            if (produto.amount > amountBefore) {
                // Adiciona um produto ao carrinho
                var hasProduct = containsProduct(productName);
                if (hasProduct) {
                    vm.cart.splice(cartIndex(productName), 1);
                }
                var productValue = vm.extraProductValue(produto);
                vm.cart.push({name: productName, amount: produto.amount, value: productValue});
            } else {
                var _cartIndex = cartIndex(productName);
                if (vm.cart[_cartIndex].amount > 1) {
                    vm.cart[_cartIndex].amount -= 1;
                    vm.cart[_cartIndex].value = (vm.cart[_cartIndex].amount * parseInt(produto.value));
                    $log.debug(vm.cart[_cartIndex]);
                } else {
                    vm.cart.splice(_cartIndex, 1);
                }
            }

        };

        vm.extraProductValue = function (produto) {
            if (produto.amount == 0)
                return produto.value;
            return produto.amount * produto.value;
        };

        function productosExtrasToString() {
            var result = "";
            for (var j = 0; j < vm.produtosExtras.length; j++) {
                var produto = vm.produtosExtras[j];
                if (produto.amount > 0) {
                    vm.notIsFree = true;
                    if (result != "")
                        result += ";";
                    result += produto.id + "," + produto.amount + "," + MyFunctions.dateToString(vm.date);
                    if (produto.type == "Combo")
                        result += ",c";
                }
            }
            for (var i = 0; i < vm.cupons.length; i++) {
                var coupom = vm.cupons[i];
                if (result != "")
                    result += ";";
                result += coupom.rid + ",1," + MyFunctions.dateToString(vm.date) + "," + coupom.type;
            }
            return result;
        }

        vm.getPaymentMethods = function () {
            var params1 = {"method": "paymentMethods", "productsArray": productosExtrasToString()};
            // $scope.$emit('trackEvent', {category: 'FormaDePagamento',name: produtosAsString});

            BackEnd.execute2(params1, function (data) {
                vm.paymentMethods = data;
                //vm.nextStep(vm.step);
                vm.showClienteLogado = true;
            },
                    function (err) {
                        ErrorHandler.showError(err);
                    });
        };

        vm.totalGeral = function () {
            var valor = 0;
            for (var i = 0; i < vm.cupons.length; i++) {
                var coupom = vm.cupons[i];
                valor += parseInt(coupom.value);
            }
            for (var j = 0; j < vm.produtosExtras.length; j++) {
                var produto = vm.produtosExtras[j];
                if (produto.amount > 0) {
                    valor += parseInt(produto.value) * produto.amount;
                }
            }
            return valor;
        };

        vm.parcelas = function (n) {
            var amount = (vm.totalGeral() / n) / 100;
            return n + "x de " + $filter('currency')(amount, 'R$ ');
        };

        vm.financialLength = function () {
            var result = [];
            if (vm.paymentMethods === null || angular.isUndefined(vm.paymentMethods))
                return result;
            var maxParcela = null;
            try
            {
                maxParcela = vm.paymentMethods[vm.paymentMethod.type.toLowerCase()];
            } catch (err)
            {
                maxParcela = 1;
            }
            for (var i = 1; i <= maxParcela; i++) {
                result.push(i);
            }
            return result;
        };
        vm.cuponsAsString = function() {
            var cupons = [];
            for (var i = 0; i < vm.cupons.length; i++) {
                var cupom = vm.cupons[i];
                cupons.push({ cod: cupom.cod, key: cupom.key, path: cupom.path, advantagePath: cupom.advantagePath });
            }
            return encodeURIComponent(angular.toJson(cupons));
        };

        vm.disableButton = function () {
          if( Object.keys(vm.user).length === 0) {
            return true;
          }


          if (!vm.pagamento && vm.totalGeral()) {
            return true;
          }
        }

        vm.createVoucher = function () {
            if (angular.isDefined(vm.paymentMethod) && vm.paymentMethod !== null) {
                vm.paymentMethod.value = vm.totalGeral();
                vm.paymentMethod.cardNumber = vm.paymentMethod.cardNumber.replace(/ /g, "");

                if (vm.notIsFree && !validateCard(vm.paymentMethod)) {
                    return;
                }
            }

            //var produtosAsString = productosExtrasToString();

            function produtosToString() {
                var result = "";
                for (var j = 0; j < vm.produtosExtras.length; j++) {
                    var produto = vm.produtosExtras[j];
                    if (produto.amount > 0) {
                        vm.notIsFree = true;
                        if (result !== "")
                            result += ";";
                        result += produto.id + "," + produto.amount + "," + MyFunctions.dateToString(vm.date);
                        if (produto.type == "Combo")
                            result += ",c";
                    }
                }
                // for (var i=0;i<vm.cupons.length;i++){
                //     var coupom = vm.cupons[i];
                //     if(result != "") result += ";";
                //     result += coupom.rid + ",1," + MyFunctions.dateToString(vm.date) + "," + coupom.type;
                // }
                return result;
            }
            var produtosAsString = produtosToString();
            var cuponsAsString = vm.cuponsAsString();
            var params1 = {"method": "createVoucher", "person": vm.user,
                "date": MyFunctions.dateToString(vm.date), "cupons":cuponsAsString, "personAsString": {id: vm.user.id, forSave: false},
                "paymentMethodAsString": vm.paymentMethod, "productsArray": produtosAsString, "couponAgencyPath": couponAgencyPath};
            if (angular.isDefined(vm.paymentMethod) && vm.paymentMethod !== null) {
                vm.paymentMethod = {
                    type: vm.paymentMethod.type
                };
            }
            var dialog = Dialogs.wait();
            BackEnd.execute2(params1, function (data) {
                dialog.close();
                if (angular.isDefined(Properties.listaAcesso) && Properties.listaAcesso === true) {
                    vm.voucherUrl = Properties.homeAddress + '/lista?billPath=bills/' + data.id + "&token=" + data.token + "&method=receiptAsByte&receipt=" + data.voucher;

                } else {
                    vm.voucherUrl = Properties.pdfAddress + "?method=receiptAsByte&receipt=" + data.voucher + "&id=" + data.id + "&token=" + data.token;
                }
                $log.debug(vm.voucherUrl);
                vm.nextStep(5);
            }, function (err) {
                dialog.close();
                ErrorHandler.showError(err);
            });
        };



    }
})();
// Bloco Teste Cupons B2C dá direito ao ingresso Produto Teste (TESTE-TESTE321)
// Bloco Teste B2C Desconto dá desconto de R$ 15 no Produto Teste (TEST-TESTE123)

(function() {
  'use strict';

  angular
    .module('b2c_ingressos')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($state, Auth) {
    if(!Auth.isLoggedIn()) $state.go("login");
    var vm = this;
      vm.user = Auth.getUser();
  }
})();

/**
 * Created by Danillo on 27/06/2016.
 */

(function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('ComprasController', ComprasController);

    /** @ngInject */
    function ComprasController($state, $location, Auth, BackEnd, Properties, ErrorHandler, Dialogs, $window, localStorageService) {
        var vm = this;
        var _user = null;
        if(!Auth.isLoggedIn()) {
            _user  = Auth.getPerson();
            if(_user == null || angular.isUndefined(_user)) {
                $state.go("login",{"next": "compras"});
                return;
            }
        } else
            _user = Auth.getUser();
        vm.user = _user;
        if(Properties.saleInfluencerInfo) {
            if(vm.user.customData.influencer !== ""  && vm.user.customData.influencer !== null && angular.isDefined(vm.user.customData.influencer)) {
                vm.saleInfluencerInfo = Properties.saleInfluencerInfo;
                vm.user.influencerUrl = $state.href(Properties.saleInfluencerState || 'parceiro', {
                    influencertoken: vm.user.customData.influencer,
                    influencer: vm.user.id
                }, {absolute: true}); // + vm.user.customData.influencer + "/" + vm.user.id;
            }
        }
        vm.linkCopySuccess = function(){
            Dialogs.info("Link copiado com sucesso.", "Compartilhe");
        };
        var containerWidth = parseInt($window.innerWidth);
        vm.pdfAddress = Properties.pdfAddress || Properties.serverUrl || Properties.serverBase;
        vm.myReservations = true;
        vm.reservations = [];
        vm.waitImage = false;
        vm.lastReservation = {};
        vm.lastVoucherLink = "";
        vm.voucherLink = "";
        vm.naoEscolheData = Properties.naoEscolheData;

        vm.justifiedTabs = containerWidth > 978 ? true : false;

        vm.orderByType = 'numero';
        vm.reverse = false;
        vm.ordenarPor = function(orderByType){
            vm.reverse = (vm.orderByType === orderByType) ? !vm.reverse : false;
            vm.orderByType = orderByType;
        };

        vm.mySales = null;
        vm.showSales = function(){
            var dialog = Dialogs.wait();
            BackEnd.execute(
                { "method": "salesInfluencer", "salesInfluencer": _user.id , "token": _user.customData.token },
                function(data) {
                    dialog.close();
                    vm.mySales = data;
                },
                function(error){
                    dialog.close();
                    ErrorHandler.showError(error);
                }
            );
        };

        vm.setVoucherLink = function (reservation) {
            var voucherLink = "";
            if (angular.isDefined(Properties.listaAcesso) && Properties.listaAcesso === true){
                voucherLink = Properties.homeAddress + '/lista?billPath=bills/' + reservation.id + "&token=" + reservation.voucherToken + "&method=receiptAsByte&receipt=" + reservation.voucher;
            }else{
                voucherLink = vm.pdfAddress + "?method=receiptAsByte&receipt=" + reservation.voucher + "&id=" + reservation.id + "&token=" + reservation.voucherToken + "&loc=" + reservation.locator;
            }
            return voucherLink ;
        };
        function reagendar(b, state, cookieKey){
            cookieKey = cookieKey || "bill_remark"
            if(b.path.indexOf("bills") != 0) return;
            Dialogs.confirm('Remarcacao', function(){
                    Properties.oldBill = {
                        id: b.id,
                        token: b.reagendamentoToken,
                        value: b.reagendamentoValue
                    };
                    localStorageService.cookie.set(cookieKey, Properties.oldBill, 0.021); // cookie de meia hora.
                    $state.go(state);
                }, {templateUrl: 'app/components/dialogs/remarcacao.html', size: 'lg'});
        }
        vm.reAgendar = function(b){
          reagendar(b, "ingressos");
        };
        vm.reAgendarConta = function(b){
          reagendar(b, "reagendamento", "bill_remark_dates");
        }

        vm.cancel = function(b){
            var params = null;
           if(b.path.indexOf("reservations") == 0)
                params = { "method": "userCancelReservation", "reservationPath": b.path , "token": b.token }
           else
                params = { "method": "userCancelBill", "billPath": b.path , "token": b.token }
           Dialogs.confirm('Cancelar Compra? Essa ação é irreversivel.', function(){
               var dialog = Dialogs.wait();
                BackEnd.execute(
                    params,
                    function() {
                        dialog.close();
                        vm.reservations = [];
                        refresh();
                    },
                    function(error){
                        dialog.close();
                        ErrorHandler.showError(error);
                    }
                );
            }, {title: 'Cancelar Compra'});
        };

        vm.trocarDatas = function(b){
            if(b.path.indexOf("bills") != 0) return;
            $state.go("trocarDatas", {id: b.id, token: b.localizador || b.token});
        };
        vm.agendarDatas = function(b){
            if(b.path.indexOf("bills") != 0) return;
            $state.go("agendarDatas", {id: b.id, token: b.localizador || b.token});
        };

        var refresh = function() {
            var dialogs = Dialogs.wait();
            vm.reservations = [];
            vm.lastReservation = null;
            if(_user === null || angular.isUndefined(_user)) $state.go("login",{"next": "compras"});
            if(_user.customData === null || angular.isUndefined(_user.customData)) $state.go("login",{"next": "compras"});
            BackEnd.execute({ "method": "userReservations", "userId": _user.id , "token": _user.customData.token },
                function(data) {
                    dialogs.close();
                    vm.reservations = data;
                    var parameters = $location.search();
                    if (parameters !== null){
                        if(parameters.id !== null) {
                            vm.lastReservation = vm.reservations.filter(function(r){
                                return r.id == parseInt(parameters.id, 10);
                            })[0];
                            vm.myReservations = false;
                        } else if(parameters.path !== null) {
                            vm.lastReservation = vm.reservations.filter(function(r){
                                return r.path == parameters.path;
                            })[0];
                            vm.myReservations = false;
                        }
                    }
                    vm.reservations.sort(function(a, b){
                        return b.created - a.created;
                    });
                    if(vm.lastReservation === null || angular.isUndefined(vm.lastReservation) || vm.lastReservation.id === null || angular.isUndefined(vm.lastReservation.id))
                        vm.lastReservation = vm.reservations[0];

                    if (angular.isDefined(Properties.listaAcesso) && Properties.listaAcesso === true){
                        vm.lastVoucherLink = Properties.serverUrl.replace('proxy.php','') + "lista?billPath=bills/" + vm.lastReservation.id + "&token=" + vm.lastReservation.voucherToken + "&method=receiptAsByte&receipt=" + vm.lastReservation.voucher + "&loc=" + vm.lastReservation.locator;
                        //vm.voucherLink = "https://www.snowland.com.br/ingressos/lista?billPath=bills/" + vm.reservations[i].id + "&token=" + vm.reservations[i].voucherToken + " &method=receiptAsByte&receipt=" + vm.reservations[i].voucher;
                    }else{
                        vm.lastVoucherLink = vm.pdfAddress + "?method=receiptAsByte&id=" + vm.lastReservation.id + "&token=" + vm.lastReservation.voucherToken + "&method=receiptAsByte&receipt=" + vm.lastReservation.voucher + "&loc=" + vm.lastReservation.locator;
                        //vm.voucherLink = vm.pdfAddress + "?method=receiptAsByte&receipt=" + vm.reservation[i].voucher + "&id=" + vm.reservation[i].id + "&token=" + vm.reservation[i].voucherToken;
                    }

                    vm.waitImage = false;
                },
                function (err) {
                    dialogs.close();
                    ErrorHandler.showError(err);
                    if(err && (err.aviso == 'Código inválido'
                        || err.aviso == 'Token não informado' || err.erro == 'Código inválido'
                        || err.aviso == "Sessão expirada")){
                        Auth.logout();
                        $state.go("login",{"next": "compras"});
                    }
                });
        };
        refresh();
    }
})();

/**
 * Created by Danillo on 13/01/2023.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .run(_fingerPrintConfig);

    /** @ngInject */
    function _fingerPrintConfig($timeout, $window, localStorageService) {
        $timeout(function(){
            var fid = $window._fingerPrintID;
            if(fid) localStorageService.cookie.set("fingerPrintID", fid, 1);
        }, 2000);
    }
})();
/**
 * Created by Danillo on 16/11/2020.
 */
(function() {
    'use strict';
  
    angular
      .module('b2c_ingressos')
      .controller('dialogsGetPictureCtrl', dialogsGetPictureCtrl);  
    
        /** @ngInject */
        function dialogsGetPictureCtrl($uibModalInstance, item, $scope, $log) {
            /*jshint validthis:true */
            var vm = this;
            vm.item = item;   
            
            var videoTracks;
            vm.loadCamera = function(id){
                //Verifica se o navegador pode capturar mídia
                if (navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices.getUserMedia(
                        {
                            audio: false, 
                            video: {
                                facingMode: 'user'
                                //verificar se funciona obrigar o tamanho da foto
                                //, width: {exact: 640}, height: {exact: 480}
                                }
                        }
                    ).then( function(stream) {                        
                        //Captura elemento de veo                     
                        var video = document.querySelector(id);
                        //As opções abaixo são necessárias para o funcionamento correto no iOS
                        video.setAttribute('autoplay', '');
                        video.setAttribute('muted', '');
                        video.setAttribute('playsinline', '');            //--
                        //Definir o elemento vídeo a carregar o capturado pela webcam
                        video.srcObject = stream;
                        videoTracks = stream.getVideoTracks();                        
                        item.cameraCarregada = true;
                        //vm.openCamera();
                        $scope.$apply();
                    })
                    .catch(function(/*error*/) {
                        alert("Oooopps... Falhou :'(");
                        $uibModalInstance.dismiss();
                    });
                }            
            };
            vm.takeSnapShot = function(idOrigem){
                //Captura elemento de vídeo
                var video = document.querySelector(idOrigem);
                
                //Criando um canvas que vai guardar a imagem temporariamente
                var canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                var ctx = canvas.getContext('2d');
                
                //Desenhando e convertendo as dimensões
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                
                //Criando o JPG
                var dataURI = canvas.toDataURL('image/jpeg'); //O resultado é um BASE64 de uma imagem.
                //video.parentNode.removeChild(video);
                item.cameraCarregada = false;
                vm.foto = dataURI;                              
            };
            vm.resetCamera = function(){
                vm.foto = null;
                item.cameraCarregada = true;
            };

            function stopvideo()
            {
                try {
                    videoTracks.forEach(function(track) {track.stop();});                    
                } catch (error) { 
                    $log.debug(error);                   
                }
            }
            vm.dismiss = function () {
                stopvideo();
                $uibModalInstance.dismiss();
            };
            vm.close = function () {
                item.foto = vm.foto;
                stopvideo();
                $uibModalInstance.close('OK');           
            };
            vm.loadCamera('#webCamera');            
        }
})();
/**
 * Created by Danillo on 16/11/2020.
 */
(function() {
    'use strict';

    angular
      .module('b2c_ingressos')
      .controller('AgendarDatasController', AgendarDatasController);

    /** @ngInject */
    function AgendarDatasController($stateParams, $location, $state, BackEnd, Dialogs, ErrorHandler, MyFunctions, Properties, $uibModal) {
        var vm = this;
        function init(){
            var dialog = Dialogs.wait();
            BackEnd.execute({ "method": "billProducts", "billPath": "bills/" + vm.id, "token": vm.locator },
                function(data) {
                    vm.initialized = true;
                    vm.products = [];
                    dialog.close();
                    angular.forEach(data, function (p) {
                        if(Properties.agendamentoComparaPessoa && p.person)
                            p.servicePersonName = p.servicePersonName || p.person.name;
                        if(p.socio != "true") return;
                        if(p.produtos) {
                            angular.forEach(p.produtos, function (p2) {
                                var code = {
                                    entry: p2.entry,
                                    path: p2.path,
                                    tempoDeValidade: p2.tempoDeValidade,
                                    codigoBarras: p2.codigoBarras,
                                    servicePersonName: p2.servicePersonName,
                                    _buydate: p2.date,
                                    _name: p2.shortName || p2.name,
                                    _notAgendados: Properties.agendaSocioMaxAmount || 1,
                                    _datasAgendadas: [],
                                    dates: []
                                };
                                code.needPicture = Properties.agendamentoNeedPicture && !p2.foto;
                                if(Properties.agendamentoNeedPerson && !p2.foto) code.person = {};
                                if(p2.person) {
                                    code._disablePerson = true;
                                    code.person = p2.person;
                                    code.servicePersonName = p2.servicePersonName || p2.person.name;
                                }
                                vm.products.push(code);
                            });
                        } else {
                            var code = {
                               entry: p.entry,
                               path: p.path,
                               tempoDeValidade: p.tempoDeValidade,
                               codigoBarras: p.codigoBarras,
                               servicePersonName: p.servicePersonName,
                               _buydate: p.date,
                               _name: p.shortName || p.name,
                               _notAgendados: Properties.agendaSocioMaxAmount || 1,
                               _datasAgendadas: [],
                               dates: []
                            };
                            code.needPicture = Properties.agendamentoNeedPicture && !p.foto;
                            if(Properties.agendamentoNeedPerson && !p.foto) code.person = {};
                            if(p.person) {
                                code._disablePerson = true;
                                code.person = p.person;
                                code.servicePersonName = p.servicePersonName || p.person.name;
                            }
                            vm.products.push(code);
                        }
                    });

                    angular.forEach(data, function (p) {
                        if(p.socio == "true") return;
                        if(p.produtos) {
                            angular.forEach(p.produtos, function (p2) {
                                if(p2.deliveryDate) return;
                                if(MyFunctions.stringToDate(p2.date) < vm.today) return;
                                angular.forEach(vm.products, function(_p){
                                    if(Properties.agendamentoComparaPessoa) {
                                        if(_p.servicePersonName == p2.servicePersonName){
                                            _p._notAgendados--;
                                            _p._datasAgendadas.push(p2.date);
                                        }
                                    } else {
                                        if(_p.codigoBarras == p2.codigoBarras){
                                            _p._notAgendados--;
                                            _p._datasAgendadas.push(p2.date);
                                        }
                                    }
                                });
                            });
                        } else {
                            if(p.deliveryDate) return;
                            if(MyFunctions.stringToDate(p.date) < vm.today) return;
                            angular.forEach(vm.products, function(_p){
                                if(Properties.agendamentoComparaPessoa) {
                                    if(_p.servicePersonName == p.servicePersonName){
                                        _p._notAgendados--;
                                        _p._datasAgendadas.push(p.date);
                                    }
                                } else {
                                    if(_p.codigoBarras == p.codigoBarras){
                                        _p._notAgendados--;
                                        _p._datasAgendadas.push(p.date);
                                    }
                                }
                            });
                        }
                    });
                    angular.forEach(vm.products, function (p) {
                        if(Properties.agendamentoPrimeiroDia && p._datasAgendadas.length == 0){
                            p.dates.push({_date: MyFunctions.stringToDate(p._buydate)});
                            p._notAgendados--;
                        }
                        for (var i = 0; i < p._notAgendados; i++) {
                                p.dates.push({});
                        }
                    });

                    if(vm.products.length == 0) {
                        Dialogs.info("Nenhum item que permite agendamento foi encontrado nessa conta. Em caso de dúvidas entre em contato com nessa central", null, null, function() {
                            $location.path("/");
                        });
                        return;
                    }

                    calendarDate();
                    angular.forEach(vm.products, function(p){
                        p.availableDates = MyFunctions.availableDatesForProduct(p.path, p._datasAgendadas[0], p.tempoDeValidade);
                    });
                },
                function(err){
                    dialog.close();
                    ErrorHandler.showError(err);
                });

        }
        vm.openCamera = function(item){
            var opts = {
                animation: true,
                templateUrl: 'app/agendarDatas/webcam.html',
                size: 'md',
                windowTopClass: 'dialog-webcam',
                windowClass: 'dialog-webcam',
                bindToController: true,
                controllerAs: 'vm',
                controller: 'dialogsGetPictureCtrl',
                resolve: {
                    item: function () {
                        return item;
                    }
                }
            };
           $uibModal.open(opts);
        };
        vm.handleDate = function (p) {
          if (p.limitSchedulingSocio <= p.amountShedulingSocio) return ErrorHandler.showError("Limite de Agendados para esse produto foi atingido, tente outro produto.");
          if (p.deliveryDate) return;
          p._activeDate = true;
        };

        vm.fetchSchedules = function (p, d) {
          if (d._date) {
            BackEnd.execute(
              {
                method: "schedules",
                product: p.path,
                date: MyFunctions.dateToString(d._date),
              },
              function (data) {
                d.schedules = data;
                d.schedule = null;
              }
            );
          }
        };

        vm.adjustDates = function(p) {
            p._minDate = null;
            p._dates = [];
            angular.forEach(p.produtos, function (p2) {
                if(p2._date) {
                    p._dates.push(MyFunctions.dateToString(p2._date));
                    if(Properties.maxDaysInCombo) {
                        p._minDate = p._minDate || p2._date;
                        if(p2._date < p._minDate) p._minDate = p2._date;
                        p._maxDate = MyFunctions.addDays(p._minDate, Properties.maxDaysInCombo);
                    }
                }

            });
        };
        vm.initialized = false;
        vm.datesByType = [];
        vm.urlVoucher = null;
        vm.today = new Date();
        var unavailableDates = [];
        function calendarDate() {
            BackEnd.execute2({'method': 'calendarMessages'},
                function (data) {
                    function haveItem(arrItem, param) {
                        return arrItem.some(function (i) {
                            return i.type === param;
                        });
                    }
                    for (var i = 0; i < data.length; i++) {
                        var date = data[i];
                        var dateType = date.tipo || "none";
                        var hasType = haveItem(vm.datesByType, dateType);
                        if (!hasType)
                            vm.datesByType.push({type: dateType, properties: date});
                    }
                    //vm.dt2 = new Date();
                    vm.dt2 = vm.today;
                },
                function (err) {
                    ErrorHandler.showError(err);
                }
            );
        }
        vm.getDayClass = function (date, mode) {
            if (mode === 'day') {
                if (date < vm.today)
                    return 'old';
                for (var i = 0; i < vm.datesByType.length; i++) {
                    var dateType = vm.datesByType[i];
                    if (dateType.properties.dates.indexOf(MyFunctions.dateToString(date)) >= 0) {
                        if (dateType.type.match(/Fechado/)) {
                            return 'closed';
                        }
                        if (dateType.type.match(/Aberto/)) {
                            return 'aberto';
                        }
                        if (dateType.type.match(/Black/)) {
                            return 'black';
                        }
                        if (dateType.type.match(/Especial/)) {
                            return 'especial';
                        }
                        if (dateType.type.match(/Promocional/)) {
                            return 'promocional';
                        }
                        if (dateType.type.match(/Alta/)) {
                            return 'alta';
                        }
                        if (dateType.type.match(/Data Evento/)) {
                            return 'data-evento';
                        }
                        if (dateType.type.match(/Baixa/)) {
                            return 'baixa';
                        }
                    }
                }
                if(unavailableDates.indexOf(MyFunctions.dateToString(date)) >= 0)
                    return 'unavailable';
            }
            return '';
        };

        vm.disabledDate = function (date, mode, item) {
            if (mode === 'day') {
                var dateAsString = MyFunctions.dateToString(date);
                if(unavailableDates.indexOf(dateAsString) >= 0)
                    return true;
                if(item !== null && angular.isDefined(item)) {
                    if(MyFunctions.dateToString(item._date) == MyFunctions.dateToString(date))
                        return true;
                    if(item._datasAgendadas != null && item._datasAgendadas.indexOf(dateAsString) >= 0)
                        return true;
                    if(item.availableDates.indexOf(dateAsString) < 0)
                        return true;
                    if(item.dates != null){
                        var isfound = item.dates.filter(function(d){
                            return MyFunctions.dateToString(d._date) == MyFunctions.dateToString(date);
                        }).length;
                        if(isfound) return true;
                    }
                }
                for (var i = 0; i < vm.datesByType.length; i++) {
                    if (date < vm.today)
                        return true;
                    var dateType = vm.datesByType[i];
                    if (dateType.properties.dates.indexOf(dateAsString) >= 0) {
                        if (dateType.type.match(/Fechado/))
                            return true;
                    }
                }
            }
            return false;
        };
        vm.invalidForm = function(){
            //var isValid = false;
            var hasDate = false;
            for (var i = 0; i < vm.products.length; i++) {
                var p = vm.products[i];
                if(p.dates.length == 0) continue;
                var d = p.dates[0];
                if(p.person && !p.person.name) return true;
                if(d._date !== null && angular.isDefined(d._date)){
                    hasDate = true;
                    if(p.needPicture && (p.foto === null || angular.isUndefined(p.foto)))
                        return true;
                }
            }
            return !hasDate;
        };
        vm.save = function(){
          var needData = null;
          var hasLimit = null;
            var products = [];
            angular.forEach(vm.products, function(p){
                if (p.limitSchedulingSocio <= p.amountShedulingSocio)
                  return hasLimit = true;
                angular.forEach(p.dates, function(d, index){
                    if(d._date) {

                        var item = { entry: p.entry, codigoBarras: p.codigoBarras, date: MyFunctions.dateToString(d._date)};
                        if(p.person && p.person.name) item.person = p.person;
                        if(index == 0 && p.foto) item.foto = p.foto;

                        if (d.schedules && d.schedules.length > 0) {
                          if(d.schedule == null) {
                            return needData = true;
                          }
                          item.schedule = d.schedule;
                        }
                        products.push(item);
                    }
                });
            });
            if (needData) {
              needData = null;
              ErrorHandler.showError("Adicione o Horario da Data.");
              return
            }
            if (hasLimit){
              hasLimit = null;
              ErrorHandler.showError(
                "Limite de Agendados para esse produto foi atingido, tente outro produto."
              );
              return
            }
            var dialog = Dialogs.wait();
            BackEnd.execute({
                    "method": "addDaysToSocio",
                    "billPath": "bills/" + vm.id,
                    "token": vm.locator,
                    "products": JSON.stringify(products)
                },
                function(bill) {
                    dialog.close();
                    if(angular.isUndefined(bill) || bill == null) {
                        ErrorHandler.showError("Ocorreu um erro");
                        return;
                    }
                    Dialogs.info("Agendamento feito com sucesso", null, null, function() {
                        $state.reload();
                    });
                },
                function(err){
                    dialog.close();
                    ErrorHandler.showError(err);
                },
                "POST",
                Properties.addDaysToSocioUrl
                );
        };

        if (angular.isDefined($stateParams.id) && $stateParams.id.length > 0 &&
            angular.isDefined($stateParams.token) && $stateParams.token.length > 0) {
            vm.id = $stateParams.id;
            vm.locator = $stateParams.token;
            init();
        } else {
            $state.go("agendamento");
            return;
        }
    }
  })();

/**
 * Created by Danillo on 16/11/2020.
 */
(function () {
  "use strict";

  angular
    .module("b2c_ingressos")
    .controller("AgendamentoController", AgendamentoController);

  /** @ngInject */
  function AgendamentoController(
    $state,
    BackEnd,
    Dialogs,
    ErrorHandler,
    MyFunctions,
    Properties
  ) {
    var vm = this;
    var agendarState = Properties.agendarState || "agendarDatas";
    function init() {
      vm.buscas = {
        localizador: function () {
          var dialog = Dialogs.wait();
          BackEnd.execute2(
            { method: "billByLocator", locator: vm.localizador },
            function (data) {
              dialog.close();
              $state.go(agendarState, { id: data.id, token: data.locator });
            },
            function (error) {
              dialog.close();
              ErrorHandler.showError(error);
            }
          );
        },
        cpf: function () {
          var dialog = Dialogs.wait();
          BackEnd.execute(
            { method: "billByCPF", id: vm.id, cpf: vm.cpf },
            function (data) {
              dialog.close();
              $state.go(agendarState, { id: data.id, token: data.locator });
            },
            function (error) {
              dialog.close();
              ErrorHandler.showError(error);
            }
          );
        },
        email: function () {
          var dialog = Dialogs.wait();
          BackEnd.execute(
            { method: "billByEmail", id: vm.id, email: vm.email },
            function (data) {
              dialog.close();
              $state.go(agendarState, { id: data.id, token: data.locator });
            },
            function (error) {
              dialog.close();
              ErrorHandler.showError(error);
            }
          );
        },
        externo: function () {
          var dialog = Dialogs.wait();
          BackEnd.execute(
            {
              method: "createBillByTicketCode",
              code: vm.ingresso,
              date: MyFunctions.dateToString(vm.date),
            },
            function (bill) {
              dialog.close();
              if (angular.isUndefined(bill) || bill == null) {
                ErrorHandler.showError("Ocorreu um erro");
                return;
              }
              Dialogs.info(
                "Agendamento efetuado com sucesso.",
                null,
                null,
                function () {
                  vm.ingresso = "";
                  vm.date = null;
                  //vm.urlVoucher = Properties.pdfAddress + "?method=receiptAsByte&receipt=" + bill.voucher + "&id=" + bill.id + "&token=" + bill.voucherToken;
                }
              );
              //$state.go("agendarDatas", { id: data.id, token: data.locator });
            },
            function (error) {
              dialog.close();
              ErrorHandler.showError(error);
            }
          );
        },
      };
      vm.buscaConta = function () {
        vm.buscas[vm.campo]();
      };
      vm.handleDate = function () {
        vm._activeDate = true;
      };
      vm.datesByType = [];
      function calendarDate() {
        BackEnd.execute2(
          { method: "calendarMessages" },
          function (data) {
            function haveItem(arrItem, param) {
              return arrItem.some(function (i) {
                return i.type === param;
              });
            }
            for (var i = 0; i < data.length; i++) {
              var date = data[i];
              var dateType = date.tipo || "none";
              var hasType = haveItem(vm.datesByType, dateType);
              if (!hasType)
                vm.datesByType.push({ type: dateType, properties: date });
            }
            //vm.dt2 = new Date();
            vm.dt2 = vm.today;
          },
          function (err) {
            ErrorHandler.showError(err);
          }
        );
      }
      vm.getDayClass = function (date, mode) {
        if (mode === "day") {
          if (date < vm.today) return "old";
          for (var i = 0; i < vm.datesByType.length; i++) {
            var dateType = vm.datesByType[i];

            if (
              dateType.properties.dates.indexOf(
                MyFunctions.dateToString(date)
              ) >= 0
            ) {
              if (dateType.type.match(/Fechado/)) {
                return "closed";
              }
              if (dateType.type.match(/Aberto/)) {
                return "aberto";
              }
              if (dateType.type.match(/Black/)) {
                return 'black';
              }
              if (dateType.type.match(/Especial/)) {
                return "especial";
              }
              if (dateType.type.match(/Promocional/)) {
                return "promocional";
              }
              if (dateType.type.match(/Alta/)) {
                return "alta";
              }
              if (dateType.type.match(/Data Evento/)) {
                return 'data-evento';
              }
              if (dateType.type.match(/Baixa/)) {
                return "baixa";
              }
            }
          }
        }
        return "";
      };
      vm.disabledDate = function (date, mode) {
        if (mode === "day") {
          var dateAsString = MyFunctions.dateToString(date);
          for (var i = 0; i < vm.datesByType.length; i++) {
            if (date < vm.today) return true;
            var dateType = vm.datesByType[i];
            if (dateType.properties.dates.indexOf(dateAsString) >= 0) {
              if (dateType.type.match(/Fechado/)) return true;
            }
          }
        }
        return false;
      };
      calendarDate();
      vm.campo = "localizador";
      vm.ingresso = null;
      vm.id = null;
      vm.localizador = null;
      vm.email = null;
      vm.cpf = null;
      vm._activeDate = false;
    }
    /// initialize
    init();
  }
})();

(function(){
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('WebCheckinController', WebCheckinController);

    /** @ngInject */
    function WebCheckinController(Properties, $location, BackEnd, ErrorHandler, $state){
        /* jslint validthis:true */
        var vm = this;
        vm.qrcode = Properties.qrcode || Properties.serverUrl || Properties.serverBase;

        init();

        function init(){
            vm.getUrlBarcode = function(){
                var url =  encodeURIComponent($location.absUrl());
                return vm.qrcode + "?method=qrcode&code=qr&hidenumbers=true&text=" + url;
                //return "https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=" + url;
            };
            vm.buscaReserva = function(){
                var campoverificador = vm.cpf;
                if(vm.campo == 'email') campoverificador = vm.email;
                BackEnd.execute(
                    {
                        "method": "findReservation",
                        "id": vm.localizador,
                        "campoverificador": campoverificador
                    },
                    function (data) {
                        $state.go("checkin", {id: data.id, token: data.token });
                    },
                    function (erro) {
                        ErrorHandler.showError(erro);
                    });
            };
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('CheckinController', CheckinController);

    /** @ngInject */
    function CheckinController($stateParams, $state, $timeout, BackEnd, ErrorHandler, Dialogs, Properties){
        /** jshint validthis:true */
        var vm = this;
        vm.redirectToPagarReserva = ($stateParams.next === "true");
        function getReservationData(){
            BackEnd.execute(
                {
                    "method": "checkinData",
                    "person": vm.personId,
                    "id": vm.id,
                    "token": vm.token
                },
                function (data) {                                   
                    vm.reservation = data;  
                    vm.traveler = vm.reservation.travelers[0];
                    if(vm.traveler.name === null || vm.traveler.name === "")
                        vm.lock.nome = false;
                    if(vm.traveler.email !== null && angular.isDefined(vm.traveler.email) && vm.traveler.email !== "")
                        vm.lock.email = true;
                    if(vm.traveler.cpf !== null && angular.isDefined(vm.traveler.cpf) && vm.traveler.cpf !== "")
                        vm.lock.cpf = true;
                    if(angular.isDefined(vm.traveler.rg) && vm.traveler.rg !== null && vm.traveler.rg !== "") {
                        if(vm.traveler.rg.indexOf(" ") > 0){
                            vm.traveler.rg0 = vm.traveler.rg.substring(0, vm.traveler.rg.indexOf(" ")).trim();
                            vm.traveler.rg1 = vm.traveler.rg.substring(vm.traveler.rg.indexOf(" ")).trim();
                        } else {
                            vm.traveler.rg0 = vm.traveler.rg;
                        }
                    }
                    vm.traveler.customData = vm.traveler.customData || {};
                    vm.traveler.customData.nacionalidade  = vm.traveler.customData.nacionalidade || "Brasileiro";
                    vm.traveler.customData.country  = vm.traveler.customData.country || "Brasil";                    
                    if(angular.isDefined(vm.traveler.city) && vm.traveler.city !== null && vm.traveler.city !== "") {
                        vm.traveler.customData.procedencia  = vm.traveler.customData.procedencia || vm.traveler.city + "/" + vm.traveler.state;
                        vm.traveler.customData.destino = vm.traveler.customData.destino || vm.traveler.customData.procedencia;
                    }
                    vm.travelers = vm.reservation.travelers;
                    angular.forEach(vm.reservation.travelers, function(t, i){
                        if(i == 0) return;
                        t.rg = t.rg || t.cpf;                        
                    }) ;   
                    vm.notCheckin = true;         
                },
                function(error){
                    ErrorHandler.showError(error);
                    if(vm.redirectToPagarReserva){
                        vm.goToPagarReserva();
                    } 
                }          
            );
        }
        
        init();

        function init(){
            vm.travelers = [];            
            vm.lock = {
                nome:true,
                email:false,
                cpf:false
            };
            vm.findCep = function(){
                BackEnd.findcep(vm.traveler.zipCode, function (address) {
                    if (address !== null) {
                        vm.traveler.street0 = address.street0 || vm.traveler.street0;
                        vm.traveler.street1 = address.street1 || vm.traveler.street1;
                        vm.traveler.city = address.city || vm.traveler.city;
                        vm.traveler.state = address.state;
                    }
                });
            };
            vm.salvar = function(){
                vm.traveler.rg = vm.traveler.rg0 + " " + vm.traveler.rg1;
                var dialog = Dialogs.wait();
                BackEnd.execute(
                    {
                        "method": "checkin",
                        "id": vm.id,
                        "token": vm.token,
                        "travelers": JSON.stringify(vm.travelers)
                    },
                    function () {               
                        dialog.close();
                        if(vm.redirectToPagarReserva){
                            //console.log("redirect to Pagar Reserva");
                            vm.goToPagarReserva();
                        }else {
                            Dialogs.info("Checkin Efetuado com sucesso.");
                            vm.notCheckin = false;
                            vm.checkin = true;
                            vm.voucherLink = Properties.pdfAddress + "?method=receiptAsByte&id=" + vm.id + "&token=" + vm.reservation.voucherToken + "&method=receiptAsByte&receipt=" + vm.reservation.voucher;
                            if(Properties.checkinKioske) {
                                $timeout(function () {                            
                                   $state.go("webcheckin");
                                }, 3000);
                        }
                        }
                        
                    },
                    function(error){
                        dialog.close();
                        ErrorHandler.showError(error);    
                    }
                );
            };
            if (angular.isDefined($stateParams.id) && $stateParams.id !== null && $stateParams.id !== "") 
                vm.id = $stateParams.id;                       
            if (angular.isDefined($stateParams.token) && $stateParams.token !== null && $stateParams.token !== "") 
                vm.token = $stateParams.token;
            getReservationData();    
        }

        vm.goToPagarReserva = function(){
            var chave = ($stateParams.chave !== null && angular.isDefined($stateParams.chave) && $stateParams.chave.length > 0) ? $stateParams.chave : "";
            $state.go('pagamentoreserva', {id: $stateParams.id, token: $stateParams.token, chave: chave });
        }

    }

}());
/**
 * Created by Danillo on 23/06/2016.
 */

(function () {
    'use strict';

    angular
        .module('b2c_ingressos')
        .controller('AccountController', AccountController);

    /** @ngInject */
    function AccountController($state, Properties) {
        var vm = this;
        vm.registroEfetuado = function(){
             $state.go(Properties.defaultState);
        };
    }
})();
(function() {
  'use strict';

  angular
    .module('b2c_ingressos')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $state, $log, Tracking, $window, moment, Properties, localStorageService) {

    localStorageService.cookieGet = function(key) {
      var cookie = localStorageService.cookie.get(key);
      if(cookie === "false" || cookie === false) return null;
      return cookie;
    }

    var listeners = {};
    // track pageview on state change
    listeners.$stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function() {
      Tracking.pageView();
    });

    listeners.$stateChangeStart = $rootScope.$on("$stateChangeStart",
      function(event, toState /*, toParams, fromState, fromParams*/ ) {
        if (angular.isUndefined(toState.data)) return;
        if (Properties.disableStates.indexOf(toState.name) >= 0) {
          event.preventDefault();
          $state.go(Properties.defaultState);
        }
      });

    //Config dayjs to suport customFormat
    //if($window.dayjs_plugin_customParseFormat)
    moment.extend($window.dayjs_plugin_customParseFormat);

    $rootScope.$on('$destroy', listeners);
    $log.debug('runBlock end');
  }

})();

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider,$urlMatcherFactoryProvider, Properties) {
        $urlMatcherFactoryProvider.caseInsensitive(true);
        function myroute(stateName, outerPath) {
            if (Properties.defaultState == stateName) {
                if(angular.isUndefined(outerPath) || outerPath === null || "" === outerPath)
                    return "/";
                return "/" + outerPath;
            }
            if(angular.isUndefined(outerPath) || outerPath === null || "" === outerPath)
                return "/" + stateName;
            return "/" + stateName + "/" + outerPath;
        }
        $stateProvider
          .state("ingressos", {
            url: myroute("ingressos") + "?cart&ingToken",
            templateUrl: function () {
              if (angular.isDefined(Properties.templateIngressos)) {
                return Properties.templateIngressos;
              }
              return "app/ingressos/ingressos.html";
            },
            controller: "IngressosController",
            controllerAs: "vm",
            data: {
              alwaysShow: true,
            },
          })
          .state("confirmacaoConta", {
            url: myroute("ingressos", "confirmacao/:id/:locator"),
            templateUrl: "app/ingressos/confirmacao/confirmacao.html",
            controller: "ConfirmacaoContaController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("eventos", {
            url: myroute("eventos"),
            templateUrl: "app/eventos/eventos.html",
            controller: "EventosController",
            controllerAs: "vm",
            data: {
              alwaysShow: true,
            },
          })
          .state("passaportes", {
            url: myroute("passaportes"),
            templateUrl: "app/produtos/produtos.html",
            controller: "ProdutosController",
            controllerAs: "vm",
            data: {
              alwaysShow: true,
            },
          })
          .state("cadastrar", {
            url: myroute("account"),
            templateUrl: "app/account/account.html",
            controller: "AccountController",
            controllerAs: "vm",
            data: {
              neverShow: true,
              // login: false
            },
          })
          .state("login", {
            url: myroute("login") + "?next",
            templateUrl: "app/login/login.html",
            controller: "LoginController",
            controllerAs: "vm",
            data: {
              login: false,
              params: { next: "compras" },
            },
          })
          .state("compras", {
            url: "/compras",
            templateUrl: "app/compras/compras.html",
            controller: "ComprasController",
            controllerAs: "vm",
            data: {
              login: true,
            },
          })
          .state("pagarconta", {
            url: "/pagarConta",
            templateUrl: "app/pagarconta/pagarconta.html",
            controller: "PagarContaController",
            controllerAs: "vm",
            data: {
              neverShow: false,
            },
          })
          // Passos da hospedagem
          .state("hospedagemPesquisa", {
            url: myroute("hospedagem") + "?hotelPath&d&df&a&c3",
            templateUrl: "app/hospedagem/pesquisa/hospedagem-pesquisa.html",
            controller: "HospedagemPesquisaController",
            controllerAs: "vm",
            data: {
              alwaysShow: true,
              login: false,
            },
            params: {
              hotelPath: { type: "string", raw: true },
              d: { type: "string", raw: true },
              df: { type: "string", raw: true },
            },
          })
          .state("hospedagemHoteis", {
            url: myroute("hospedagem/hoteis"),
            templateUrl: "app/hospedagem/hoteis/hospedagem-hoteis.html",
            controller: "HospedagemHoteisController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("hospedagemApartamentos", {
            url: myroute("hospedagem/apartamentos"),
            templateUrl:
              "app/hospedagem/apartamentos/hospedagem-apartamentos.html",
            controller: "HospedagemApartamentosController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("hospedagemIngressos", {
            url: myroute("hospedagem/ingressos"),
            templateUrl: "app/hospedagem/ingressos/hospedagem-ingressos.html",
            controller: "HospedagemIngressosController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("hospedagemIdentificacao", {
            url: myroute("hospedagem/identificacao"),
            templateUrl:
              "app/hospedagem/identificacao/hospedagem-identificacao.html",
            controller: "HospedagemIdentificacaoController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("hospedagemPagamento", {
            url: myroute("hospedagem/pagamento/:ids?cardType&token&chave&next"),
            templateUrl: "app/hospedagem/pagamento/pagamento.html",
            controller: "HospedagemPagamentoController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("hospedagemConfirmacao", {
            url: myroute("hospedagem/confirmacao?id&token"),
            templateUrl:
              "app/hospedagem/confirmacao/hospedagem-confirmacao.html",
            controller: "HospedagemConfirmacaoController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("hospedagemConfirmacaoPagamento", {
            url: myroute("hospedagem-grupo/confirmacao?id&token&paymentId"),
            templateUrl:
              "app/hospedagem/confirmacaopagamento/confirmacao.html",
            controller: "PaymentConfirmationController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          // End Passos da hospedagem
          .state("pagamentoreserva", {
            url: myroute("pagarReserva") + "?id&cardType&token&chave&next",
            templateUrl: "app/pagamentoreserva/pagamentoreserva.html",
            controller: "PagamentoReservaController",
            controllerAs: "vm",
            data: {
              neverShow: false,
            },
          })
          .state("pagamentogrupo", {
            url: myroute("pagarGrupo"),
            templateUrl: "app/pagamentogrupo/pagamentogrupo.html",
            controller: "PagamentoGrupoController",
            controllerAs: "vm",
            data: {
              neverShow: false,
            },
          })
          .state("cupom", {
            url: myroute("cupom"),
            templateUrl: "app/cupom/cupom.html",
            controller: "CupomController",
            controllerAs: "vm",
            data: {
              neverShow: false,
            },
          })
          .state("cupomName", {
            url: myroute("cupom", ":name?"),
            templateUrl: "app/cupom/cupom.html",
            controller: "CupomController",
            controllerAs: "vm",
            data: {
              neverShow: false,
            },
          })
          .state("promocao", {
            url: myroute("promocao/:id"),
            templateUrl: "app/promocao/promocao.html",
            controller: "PromocaoController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("orcamento", {
            url: "/orcamento/:id/:person/:token",
            templateUrl: "app/reservarorcamento/reservarorcamento.html",
            controller: "ReservarOrcamentoController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("orcamentoconfirmacao", {
            url: "/orcamento/orcamentoconfirmacao",
            templateUrl: "app/reservarorcamento/orcamentoConfirmacao.html",
            controller: "ReservarOrcamentoController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("webcheckin", {
            url: myroute("webcheckin"),
            templateUrl: "app/checkin/webcheckin.html",
            controller: "WebCheckinController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("checkin", {
            url: myroute("checkin") + "?id&cardType&token&chave&next",
            templateUrl: "app/checkin/checkin.html",
            controller: "CheckinController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("trocarDatas", {
            url: "/trocardatas/:id/:token",
            templateUrl: "app/trocarDatas/trocarDatas.html",
            controller: "TrocarDatasController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("reagendamento", {
            url: "/reagendamento/:id/:token",
            templateUrl: "app/reagendamento/reagendamento.html",
            controller: "ReagendamentoController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("agendamento", {
            url: myroute("agendamento"),
            templateUrl: "app/agendarDatas/agendamento.html",
            controller: "AgendamentoController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("agendarDatas", {
            url: "/agendarDatas/:id/:token",
            templateUrl: "app/agendarDatas/agendarDatas.html",
            controller: "AgendarDatasController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          })
          .state("listadeentrada", {
            url: "/listadeentrada",
            templateUrl: "app/listadeentrada/accesslist-template.html",
            controller: "AccessListController",
            controllerAs: "vm",
            data: {
              alwaysShow: false,
            },
          })
          .state(Properties.saleInfluencerState || "parceiro", {
            url:
              "/" +
              (Properties.saleInfluencerState || "parceiro") +
              "/:influencertoken/:influencer",
            template: "<h1>aguarde</h1>",
            controller: "InfluencerController",
            controllerAs: "vm",
            data: {
              neverShow: true,
            },
          });
        if (angular.isUndefined(Properties.hasExtraControllers) || !Properties.hasExtraControllers)
            $urlRouterProvider.otherwise('/');
    }
})();

/**
 * Created by Danillo on 27/06/2016.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .filter('capitalize', capitalize);

    /** @ngInject */
    function capitalize() {
        return function (input) {
            if (angular.isUndefined(input) || input === null || input.length === 0)
                return "";
            if (input.length === 1)
                return input.toUpperCase();
            return input.charAt(0).toUpperCase() + input.substr(1).toLowerCase();
        };
    }

    angular
            .module('b2c_ingressos')
            .filter('urlEncode', urlEncode);
    /** @ngInject */
    function urlEncode($window) {
        return function (input) {
            if (input) {
                return $window.encodeURIComponent(input);
            }
            return "";
        };
    }

    angular
            .module('b2c_ingressos')
            .filter('toHtml', stringToHtml);

    /** @ngInject */
    function stringToHtml($sce) {
        return function (input) {
            return $sce.trustAsHtml(input);
        };
    }

    angular
            .module('b2c_ingressos')
            .filter('ellipsis', ellipsis);

    /** @ngInject */
    function ellipsis() {
        return function (input, len) {
            var size = 0;
            if (angular.isUndefined(len) || len === null || len <= 0) {
                size = 180;
            } else {
                size = len;
            }

            if (angular.isUndefined(input) || input === null) {
                input = "";
                return input;
            }
            if (input.length <= size)
                return input;
            return  input.substring(0, size) + "...";
        };
    }

    angular
            .module('b2c_ingressos')
            .filter('pluralize', pluralize);


    function pluralize() {
        return function (input, name) {
            if (angular.isUndefined(input) || input === 1 || input === "1")
                return input + " " + name;
            if (input === 0 || input === "0")
                return "Nenhum " + name;

            return input + " " + name + 's';
        };
    }

    angular
            .module('b2c_ingressos')
            .filter('noSpace', noSpace);
    /** @ngInject */
    function noSpace() {
        return function (input, char) {
            if (input) {
                char = char || ""
                return input.replace(/ /g, char).replace("%20", char);
            }
            return "";
        };
    }

    angular

})();

/**
 * Created by Danillo on 26/12/2015.
 */

(function() {
  'use strict';

  angular
    .module('b2c_ingressos')
    .directive('ngEnter', ngEnter);

  /** @ngInject **/
  function ngEnter() {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter);
          });
          event.preventDefault();
        }
      });
    };
  }


    angular
        .module('b2c_ingressos')
        .directive('ngNumbersOnly', ngNumbersOnly);
    /** @ngInject **/
    function ngNumbersOnly() {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text.replace(/[^0-9]/g, '');
                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    return undefined;
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }

  angular
    .module('b2c_ingressos')
    .directive('ngLazyInclude', ngLazyInclude);

  /** @ngInject **/
  function ngLazyInclude($timeout,$compile) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var timeout = 1000;
        if(attrs.timeout)
          timeout = parseInt(attrs.timeout);
        $timeout(function(){
          element.append($compile("<div ng-include=\"" + attrs.ngLazyInclude +  "\"></div>")(scope));
        },timeout);

      }
    };
  }

  angular
    .module('b2c_ingressos')
    .directive('creditCardValidator', creditCardValidator);

    /** @ngInject **/
  function creditCardValidator($cardType) {

    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, controller) {
        controller.$validators.creditCard = function (modelValue, viewValue) {
          var _card = modelValue || viewValue;
          return _card && $cardType.cardType(_card);
        };

      }
    };
  }


  angular
  .module('b2c_ingressos')
  .directive('ngLazyLoadImg', ngLazyLoadImg);

  //<img ng-lazy-load-img="https://urlimg" timeout="500" />
  /** @ngInject **/
  function ngLazyLoadImg($timeout) {
    return {
      required: 'ngLazyLoadImg',
      link: function (scope, element, attrs) {
        if(!attrs.ngLazyLoadImg) return;
        var timeout = 1000;
        if(attrs.timeout)
          timeout = parseInt(attrs.timeout);
        $timeout(function(){
          element[0].src = attrs.ngLazyLoadImg;
        },timeout);
      }
    };
  }

  angular
  .module('b2c_ingressos')
  .directive('cpfValidator', cpfValidator);

  /** @ngInject **/
  function cpfValidator(MyFunctions) {

    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, controller) {
        controller.$validators.cpf = function (modelValue, viewValue) {
          var _cpf = modelValue || viewValue;
          return _cpf && MyFunctions.cpfValidator(_cpf);
        };

      }
    };
  }


  angular.module("b2c_ingressos").directive("ageValidator", ageValidator);

  /** @ngInject **/
  function ageValidator(MyFunctions) {

    return {
      restrict: "A",
      require: "ngModel",
      link: function (scope, element, attrs, controller) {
        controller.$validators.age = function (modelValue, viewValue) {
          var _age = modelValue || viewValue;
          return _age && MyFunctions.checkAge(_age);
        };
      },
    };
  }

  angular.module("b2c_ingressos").directive("button", buttonTranslate);

  /** @ngInject **/
  function buttonTranslate() {
    return {
      restrict: 'E',
      link: function(scope, element) {
        element.attr('translate', 'no');
        element.addClass('notranslate');
      }
    };
  }

  angular.module("b2c_ingressos").directive("qrCode", qrCode);

  /** @ngInject **/
  function qrCode() {
  return {
    restrict: 'E',
    scope: {
      value: '@'
    },
    template: '<div></div>',
    link: function(scope, element, attrs) {
      var div = element.find('div')[0];

      function gerarQRCode() {
        if (scope.value) {
          div.innerHTML = ''; // limpa o conteúdo anterior
          new QRCode(div, {
            text: scope.value,
            width: 200,
            height: 200
          });
        }
      }

      gerarQRCode();
      scope.$watch('value', gerarQRCode);
    }
  };
}

})();

(function() {
'use strict';

    angular
        .module('b2c_ingressos')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(Properties, Tracking, localStorageService, $state, $window) {
        /* jshint validthis:true */
        var vm = this;
        vm.bodyClass = "";
        Tracking.addListener(Tracking.types.PageView,
            function () {
                vm.bodyClass = $state.current.name;
                if(vm.bodyClass == "cupomName")
                    vm.bodyClass = "cupom";
            }
        );

        function renoveRecaptcha () {
            $window.getReCaptcha = $window.getReCaptcha || function () {};
            $window.getReCaptcha();
        }

        Tracking.addListener(Tracking.types.Login, renoveRecaptcha);
        Tracking.addListener(Tracking.types.LoginError, renoveRecaptcha);
        Tracking.addListener(Tracking.types.BuyReservations, renoveRecaptcha);
        Tracking.addListener(Tracking.types.CheckoutReservations, renoveRecaptcha);
        Tracking.addListener(Tracking.types.Buy, renoveRecaptcha);
        Tracking.addListener(Tracking.types.BuyError, renoveRecaptcha);
        vm.showCookies = false;
        if(Properties.showCookiesWarning)  {
            if(localStorageService.cookieGet("cookieTermsAccepted") != true)
                vm.showCookies = Properties.showCookiesWarning;
        }
        vm.closeCookiesBar = function(){
            localStorageService.cookie.set("cookieTermsAccepted", true);
            vm.showCookies = false;
        };
        function ready(){
            vm.isready = true;
        }
        ready();
    }

})();

/* global dayjs:false CardType:false */
(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .constant('moment', dayjs) // alternar com o daysjs
            .constant('$cardType', CardType)
            .constant('clientName', "Nova XS")
            ;

})();

(function() {
    'use strict';

    angular
        .module('b2c_ingressos')
        .config(config);

    /** @ngInject */
    function config($logProvider, $locationProvider, localStorageServiceProvider, uibDatepickerConfig, uibDatepickerPopupConfig, $httpProvider, $windowProvider, $compileProvider, Properties) {
        // Enable log
        $logProvider.debugEnabled(false);
        $compileProvider.debugInfoEnabled(false);       

        var prefix = Properties.serverBase || Properties.serverUrl || "b2c";
        prefix = prefix.replace("https://","").replace("proxy.php","b2c").replace("www.","")
            .replace(".com","").replace(".br","")
            .replace(/\./g,"_").replace(/\//g,"_");

        localStorageServiceProvider.setPrefix(prefix);
        //localStorageServiceProvider.setPrefix('b2c');
        // rippleConfig (feedback click button)
        //rippleConfig.rippleOpacity = 0.2;
		//rippleConfig.rippleDelay = 100;
		//rippleConfig.mobileTouch = false; // False (default): Mobile use ONLY click || True: mobile use touchstart and touchend

        //uibDatepickerConfig/uibDatepickerPopupConfig default Config
        uibDatepickerConfig.showWeeks = false;
        uibDatepickerPopupConfig.datepickerPopup = "dd/MM/yyyy";
        uibDatepickerPopupConfig.currentText = "Hoje";
        uibDatepickerPopupConfig.clearText = "Limpar";
        uibDatepickerPopupConfig.closeText = "OK";

        // Configure the cookie timeout
        localStorageServiceProvider.setStorageCookie(Properties.cookieTime, '/', false);

        // Config ui-router to Html5 mode
        $locationProvider.html5Mode(!Properties.html5Off);
       
        function addRecaptch(data){
            try {
                return data !== null && angular.isDefined(data) && angular.isString(data) 
                    && (data.indexOf("findOrCreatePerson") >= 0 || data.indexOf("paidBillWithCreditCard") >= 0 ||
                    data.indexOf("personByMail") >= 0);
            } catch (error) {
                return false;
            }
        }
        function renoveRecaptcha (w) {
            w.getReCaptcha = w.getReCaptcha || function () {};
            w.getReCaptcha();            
        }
        var _window = $windowProvider.$get();
        $httpProvider.interceptors.push(function ($q) {
            var _data = null;
            return {
                'request': function (config) {
                    if(config.method == 'POST') {                        
                        if(addRecaptch(config.data)) {
                            _data = config.data;                            
                            _window.getRecaptcharToken = _window.getRecaptcharToken || function(){return "";};
                            config.data += "&_recaptchar=" + _window.getRecaptcharToken(); 
                        }                                                    
                    }
                    return config || $q.when(config);                                        
                },
                // On response success
                'response': function (response) {
                    // console.log(response); // Contains the data from the response.
                    if(_data && _data.indexOf("personByMail") >= 0) {
                        _data =null;
                        
                        renoveRecaptcha(_window);
                    }
                    // Return the response or promise.
                    return response || $q.when(response);
                },
                // On response failture
                'responseError': function (rejection) {
                    // console.log(rejection); // Contains the data about the error.
                    if(_data && (_data.indexOf("personByMail") >= 0 || _data.indexOf("findOrCreatePerson") >= 0)) {
                        _data = null;
                        renoveRecaptcha(_window);
                    }
                    // Return the promise rejection.
                    return $q.reject(rejection);
                }              
            };
        });

    }

})();

(function() {
    'use strict';
    angular
        .module('b2c_ingressos')
        .constant('Properties', {
            serverUrl: 'https://hoteisquintadosol.com/reservas/proxy.php',
            agency: '12394',
            pdfAddress: 'https://hoteisquintadosol.com/reservas/proxy.php',
            serverMethod: 'POST',
            cidadeRequerida: false,
            cpfNaoObrigatorio: true,
            naoUtilizaKey: true,
            nginx: true,
            html5Off: true,
            lazyLoadHoteis: true,
            naoValidaDados: true,
            enderecoRequerido: false,
            unavailable: true,
            bookmark_offset: 102,
            trackers: {
                google: [ 'GTM-T5CH8KZ', 'G-63N683QLW6', 'AW-872221782', 'GTM-T5CH8KZ' ],
                askSuiteChat: true
              },
            paidBillCardTypes: ["Visa", "Master"],
            checkLogin: true,
            hasExtraControllers: false,
            templateIngressos: 'app/new_ingressos/ingressos.html',
            defaultState: 'hospedagem',
            disableStates: ['passaportes', 'eventos', 'aux_ingressos', 'ingressos', 'customizados']
        });
})();

/**
 * Created by Danillo on 17/07/2016.
 */

(function () {
    'use strict';

    angular
            .module('b2c_ingressos')
            .config(_quintaConfig);

    /** @ngInject */
    function _quintaConfig(AnalyticsProvider) {
        AnalyticsProvider.logAllCalls(true);
        // Google Analitcs
        AnalyticsProvider.setAccount("UA-88749270-1");
        // Enable enhanced e-commerce module (ec.js)
        // Universal Analytics only
        AnalyticsProvider.useECommerce(true, true);
        AnalyticsProvider.setCurrency('BRL');
        //AnalyticsProvider.setPageEvent('$stateChangeSuccess');
    }

    angular
            .module('b2c_ingressos')
            .run(_quintaDefault);

    /** @ngInject */
    function _quintaDefault(Tracking, $log, $window, Analytics, MyFunctions, moment, Auth) {
        $window.dataLayer = $window.dataLayer || [];
        Tracking.addListener(Tracking.types.PageView,
                function (page) {
                    $log.debug("Tracking Page", page);
                    Analytics.trackPage();
                }
        );
        // Hospedagem
        Tracking.addListener(Tracking.types.SearchDate,
            function (data) {
                for (var i = 0; i < data.length; i++) {
                    var hotel = data[i].item;
                    Analytics.addImpression(hotel.servicePath, hotel.service, 'Lista de Hoteis', null, "Hotel", 1, hotel.value / 100);
                }
                Analytics.pageView();         
                Analytics.trackCheckout(1, 'Lista de Hoteis');   
                Analytics.pageView();
                $log.debug('SearchDate' + data);
            }
        );
        Tracking.addListener(Tracking.types.ShowHotel,
            function (data) {               
                var hotel = data.item;                    
                Analytics.addImpression(hotel.servicePath, hotel.service, 'Lista de Hoteis', null, "Hotel", 1, hotel.value / 100);
                Analytics.trackEvent('Lista de Hoteis', 'Apresenta Hotel', hotel.service);                
                $log.debug('ShowHotel' + data);
            }
        );
        Tracking.addListener(Tracking.types.SelectHotel,
            function (data) { 
                var hotel = data.item;                    
                Analytics.addProduct(hotel.servicePath, hotel.service, 'Lista de Hoteis', null, "Hotel", hotel.value / 100, 1, null, null);
                Analytics.productClick('Lista de Hoteis');              
                Analytics.trackCheckout(2, 'Selecionou o hotel');
                //Analytics.pageView();                                    
                $log.debug('SelectHotel' + data);
            }
        );        
        Tracking.addListener(Tracking.types.SelectUH,
            function (data) {
                Analytics.addProduct(data.servicePath, data.hotelName /*+ " - " + data.service*/, 'Lista de Hoteis', null, "Hotel", data.value / 100, 1, null, null, null);
                Analytics.trackCart('add');
                Analytics.pageView();
                Analytics.trackCheckout(3, 'Selecionou apto');
                Analytics.pageView();
                $log.debug('SelectUH' + data);
            }
        );
        var carrinho = [];
        Tracking.addListener(Tracking.types.BuyReservations,
            function (data) {          
                carrinho = data;
                for (var i = 0; i < data.length; i++) {
                    var hotel = data[i];
                    Analytics.addProduct(hotel.hotelPath, hotel.hotelName, 'Lista de Hoteis', null, "Hotel", hotel.value / 100, 1, null, null, null);
                }
                Analytics.trackCheckout(4, 'Informou os Hóspedes');                
                //Analytics.pageView();
                $log.debug('BuyReservations' + data);
            }
        );
        Tracking.addListener(Tracking.types.CheckoutReservations,
            function (data) {
                if(carrinho !== null && angular.isDefined(carrinho)) {
                    for (var j = 0; j < carrinho.length; j++) {
                        var hotel = carrinho[j];
                        Analytics.addProduct(hotel.hotelPath, hotel.hotelName, 'Lista de Hoteis', null, "Hotel", hotel.value / 100, 1, null, null, null);

                    }
                }

                var rs = {id:"", value:0};
                for (var i = 0; i < data.length; i++) {
                    var r = data[i];
                    if(rs.id !== "") rs.id += ",";
                    rs.id += 'R' + r.id;
                    rs.value += parseInt(r.value, 10);
                }
                Analytics.trackTransaction(rs.id, 'Reserva', rs.value / 100, '0', '0', '', '', '', '');
                Analytics.pageView();                
                $log.debug('CheckoutReservations' + data); 
            }
        );



        // Tracking Conversão Facebook
        var fbq = $window.fbq || function () {};

        Tracking.addListener(Tracking.types.ShowHotel,
                function () {
                    fbq('track', 'ShowHotel');
                }
        );
        Tracking.addListener(Tracking.types.SelectHotel,
                function () {
                    fbq('track', 'SelectHotel');
                }
        );
        Tracking.addListener(Tracking.types.SelectUH,
                function () {
                    fbq('track', 'SelectUH');
                }
        );
        Tracking.addListener(Tracking.types.Login,
                function () {
                    fbq('track', 'CompleteRegistration');
                }
        );
        Tracking.addListener(Tracking.types.Buy,
                function (data) {
                    fbq('track', 'Purchase', {value: data.value / 100, currency: 'BRL'});
                }
        );
        Tracking.addListener(Tracking.types.SearchDate,
            function (result) {
                $log.debug(result);
                var checkin = MyFunctions.stringToDate(result[0].result[0].checkin);
                var checkout =  MyFunctions.addDays(checkin, result[0].result[0].modulesAmount);
                
                // This sample assumes the FB Pixel base code is already loaded                
                fbq('track', 'Search', {
                    // Fire the 'Search' event on the search results page                
                    // IF YOU CHOOSE NOT TO USE A RECOMMENDED PARAM, THEN REMOVE IT, DON'T LEAVE IT EMPTY                
                    // REQUIRED: DO NOT change this, must be set to 'hotel'
                    content_type: 'hotel',                
                    // HIGHLY RECOMMENDED: checkin date
                    // Allows you to target people based on their travel dates (using a booking window)
                    // Improves the landing experience with travel dates filled in (using template tags)
                    // use YYYYMMDD, YYYY-MM-DD, YYYY-MM-DDThh:mmTZD or YYYY-MM-DDThh:mm:ssTZD
                    checkin_date: moment(checkin).format("YYYY-MM-DD"),                
                    // HIGHLY RECOMMENDED: checkout date
                    // use YYYYMMDD, YYYY-MM-DD, YYYY-MM-DDThh:mmTZD or YYYY-MM-DDThh:mm:ssTZD
                    checkout_date: moment(checkout).format("YYYY-MM-DD"),                
                    // RECOMMENDED: content ids - include eg top 5 search results
                    //content_ids: '["1"]',                
                    // REQUIRED: city, don't use abbreviations
                    city: 'Praia do Curuípe',                
                    // REQUIRED: region, don't use abbreviations
                    region: 'Porto Seguro',                
                    // REQUIRED: country, don't use abbreviations
                    country: 'Brasil',                
                    // RECOMMENDED: number of adults
                    //num_adults: 1,                
                    // RECOMMENDED: number of children
                    //num_children: 0
                });
            }
        );                       
        Tracking.addListener(Tracking.types.BuyReservations,
            function () {          
                fbq('track', 'CompleteRegistration');
            }
        );
        Tracking.addListener(Tracking.types.CheckoutReservations,
            function (data) {                
                var value = 0;
                var contents = [];
                for (var i = 0; i < data.length; i++) {
                    var r = data[i];
                    value += parseInt(r.value, 10);
                    contents.push({ 
                        id: 'R' + r.id , 
                        quantity: 1, 
                        item_price: parseInt(r.value, 10) / 100 
                    });
                }
                fbq('track', 'Purchase', {
                    value: value / 100, 
                    currency: 'BRL',
                    contents: contents,
                    content_type: 'product'
                });                
            }
        );

        // DataLayer - GTM/GA4
        Tracking.addListener(Tracking.types.Buy,
            function (data) {
                var dlObject = { event: 'purchase' };
                var user = Auth.getUser();
                if (user && user.email) {
                    dlObject.userEmail = user.email;
                }
                $window.dataLayer.push(dlObject);
            }
        );
        Tracking.addListener(Tracking.types.CheckoutReservations,
            function (data) {
                var dlObject = { event: 'checkout_reservations' };
                var user = Auth.getUser();
                if (user && user.email) {
                    dlObject.userEmail = user.email;
                }
                $window.dataLayer.push(dlObject);
            }
        );
        Tracking.addListener(Tracking.types.BuyReservations,
            function (data) {
                var dlObject = { event: 'buy_reservations' };
                var user = Auth.getUser();
                if (user && user.email) {
                    dlObject.userEmail = user.email;
                }
                $window.dataLayer.push(dlObject);
            }
        );
       
    }
})();
angular.module('b2c_ingressos').run(['$templateCache', function($templateCache) {$templateCache.put('quinta_do_sol/template/carrinho.html','<div class="content-car time-10 animated" ng-controller="HospedagemCarrinhoController as vm"><div class="row b2c-paymentReserva-header"><div class="col-md-12"><div class="page-header"><h2 title="Carrinho">Carrinho <i class="fa fa-shopping-cart" aria-hidden="true"></i></h2></div></div></div><div class="row b2c-carrinho-header"><div class="col-md-12"><label title="{{vm.days}} {{vm.days > 1 ? \'Di\xE1rias\' : \'Di\xE1ria\'}}">{{vm.days}} {{vm.days > 1 ?\'Di\xE1rias\' : \'Di\xE1ria\'}}</label><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{vm.checkin| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{vm.checkout| date:\'dd/MM/yyyy\'}}</span><br><label>Check-out</label></div></div><label>Op\xE7\xE3o Escolhida</label><h3 title="{{vm.selectedHotel.item.service}}">{{vm.selectedHotel.item.service}}</h3><div ng-if="vm.showCupom" class="row b2c-box-filter-cupom"><div class="col-md-12"><h3 title="Cupom de desconto"><i class="fa fa-tag" aria-hidden="true"></i> Cupom de desconto</h3><div class="row"><div class="form-group col-xs-10"><input type="text" class="form-control" placeholder="Codigo" id="chaveCumpomDesconto" ng-model="vm.cupomCode"></div><div class="form-group col-xs-2"><button uib-tooltip="Calcular Desconto" title="Calcular Desconto" class="btn btn-block btn-primary" ng-click="vm.validCupom()" ng-disabled="vm.cupomCode == null && vm.cupomCodKey == null"><i class="fa fa-check"></i></button></div></div></div></div></div></div><div class="row b2c-itens-carrinho"><div ng-if="apto.value > 0" class="col-md-12 itens" ng-repeat="apto in vm.aptos"><h3 title="{{$index + 1}}\xBA Apartamento">{{$index + 1}}\xBA Apartamento</h3><h5 ng-show="apto.service" title="Nome do Apartamento: {{apto.service}}"><i class="fa fa-check" aria-hidden="true"></i> {{apto.service}}</h5><h5 ng-show="apto.mealType" title="Tipo de Pens\xE3o: {{apto.mealType}}"><i class="fa fa-check" aria-hidden="true"></i> {{apto.mealType}}</h5><div ng-show="apto.included.length > 0"><h5 ng-repeat="adicional in apto.included" ng-hide="apto.mealType == adicional.service"><i class="fa fa-check"></i>&nbsp;{{adicional.service}}</h5></div><h5 title="Quantidade de Hospedes"><i class="fa fa-check" aria-hidden="true"></i> <span ng-if="apto._adultos > 0">Adultos: {{apto._adultos}}</span> <span ng-if="apto._chd > 0">, Crian\xE7as: {{apto._chd}}</span> <span ng-if="apto._colo > 0">, Colos: {{apto._colo}}</span> <span ng-if="apto._terceiraIdade > 0">, acima de 60 anos: {{apto._terceiraIdade}}</span></h5><h5 ng-show="apto.productsValue > 0" title="Valor do Apartamento: {{(apto.value - apto.productsValue) / 100| currency: \'R$ \'}}" class="value">Valor do Apartamento: <strong>{{(apto.value - apto.productsValue) / 100| currency: \'R$ \'}}</strong></h5><h5 ng-show="apto.productsValue > 0" title="Valor dos Ingressos: {{apto.productsValue / 100| currency: \'R$ \'}}">Valor dos ingressos: <strong>{{apto.productsValue / 100| currency: \'R$ \'}}</strong></h5><h4 ng-show="apto.oldValue > apto.value" class="value">De: <strong>{{ apto.oldValue / 100| currency: \'R$ \' }}</strong><br>Por: <strong>{{apto.value / 100| currency: \'R$ \'}}</strong></h4><h4 ng-show="apto.oldValue <= apto.value" title="Total do Apartamento: {{apto.value / 100| currency: \'R$ \'}}" class="value">Valor: <strong>{{apto.value / 100| currency: \'R$ \'}}</strong></h4></div></div><div ng-show="vm.totalPagamento > 0" class="row b2c-carrinho-footer"><div class="col-md-12"><h2 title="Valor Total: {{vm.totalPagamento| currency: \'R$ \'}}">Total: <strong>{{vm.totalPagamento| currency: \'R$ \'}}</strong></h2></div></div><div ng-show="vm.totalPagamento <= 0" class="row b2c-carrinho-footer not-itens"><div ng-show="vm.aptos.length >= 1" class="col-md-12"><h2 title="Selecione {{vm.aptos.length > 1 ? \'seus Apartamentos\' : \'seu Apartamento\'}}"><i class="fa fa-arrow-left"></i> Selecione {{vm.aptos.length > 1 ? \'seus Apartamentos\' : \'seu Apartamento\'}}</h2></div></div><div ng-if="vm.showCupom" class="row b2c-carrinho-footer not-itens buttons"><div ng-show="vm.solicitacaoReservaShow" class="col-md-12 form-group"><button title="Solicitar Reserva" uib-tooltip="Click aqui para solicitar uma pr\xE9-reserva. R\xE1pido e f\xE1cil!" class="btn btn-info btn-lg btn-block" ng-click="vm.modalSolicitacaoReserva(vm.aptos, vm.days, vm.totalPagamento)">Fazer uma Pr\xE9-Reserva <i class="fa fa-envelope"></i></button></div><div class="col-md-12 form-group"><button title="Reservar agora" uib-tooltip="Conclua sua reserva agora mesmo com tranquilidade e seguran\xE7a!" class="btn btn-warning btn-lg btn-block" ng-click="vm.reservarAgora()">Reservar Agora <i class="fa fa-calendar-check-o"></i></button></div></div></div>');
$templateCache.put('quinta_do_sol/template/dados-user.html','<form class="form row form-compra" name="dadosComprador" id="dadosComprador" role="form"><fieldset><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.nome.$touched && dadosComprador.nome.$valid, \'has-error\': dadosComprador.nome.$touched && dadosComprador.nome.$invalid}"><label class="control-label" for="nome" accesskey="E">Nome Completo do Titular * <em class="text-danger" ng-show="dadosComprador.nome.$touched && dadosComprador.nome.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input name="nome" tabindex="1" type="text" id="nome" class="form-control" ng-model="vm.user.name" placeholder="Nome como no Cart\xE3o" ui-mask-placeholder autocomplete="name" required><div ng-show="dadosComprador.nome.$touched && dadosComprador.nome.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.nome.$touched && dadosComprador.nome.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.email.$touched && dadosComprador.email.$valid, \'has-error\': dadosComprador.email.$touched && dadosComprador.email.$invalid}"><label class="control-label" for="email" accesskey="E">E-mail * <em class="text-danger" ng-show="dadosComprador.email.$touched && dadosComprador.email.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input name="email" tabindex="2" type="email" id="email" class="form-control" ng-model="vm.user.email" placeholder="Informe seu e-mail" ui-mask-placeholder autocomplete="email" required><div ng-show="dadosComprador.email.$touched && dadosComprador.email.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.email.$touched && dadosComprador.email.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div class="col-xs-6"><div class="form-group form-loja"><label class="control-label" for="nacionalidade" accesskey="E">Nacionalidade *</label> <select class="form-control" tabindex="3" id="nacionalidade" ng-model="vm.user.customData.estrangeiro" required><option value="false" selected="selected">Brasileiro</option><option value="true">Estrangeiro</option></select></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.cpf.$touched && dadosComprador.cpf.$valid, \'has-error\': dadosComprador.cpf.$touched && dadosComprador.cpf.$invalid}"><div ng-if="vm.user.customData.estrangeiro === \'false\'"><label class="control-label" for="cpf" accesskey="E">CPF do Titular * <em class="text-danger" ng-show="dadosComprador.cpf.$touched && dadosComprador.cpf.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em> <em class="text-success" ng-show="dadosComprador.cpf.$touched && dadosComprador.cpf.$valid"><i class="fa fa-check" aria-hidden="true"></i></em></label><div class="input-group"><input name="cpf" tabindex="3" type="text" id="cpf" class="form-control" ng-model="vm.user.cpf" ui-mask="999.999.999-99" placeholder="Informe o seu CPF" ui-mask-placeholder ng-required="true"><div ng-show="dadosComprador.cpf.$touched && dadosComprador.cpf.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.cpf.$touched && dadosComprador.cpf.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div><div ng-if="vm.user.customData.estrangeiro === \'true\'" ng-class="{\'has-success\': dadosComprador.documento.$touched && dadosComprador.documento.$valid, \'has-error\': dadosComprador.documento.$touched && dadosComprador.documento.$invalid}"><label class="control-label" for="documento" accesskey="E">Documento * <em class="text-danger" ng-show="dadosComprador.documento.$touched && dadosComprador.documento.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input name="documento" tabindex="3" type="text" id="documento" class="form-control" ng-model="vm.user.passporte" placeholder="Informe o seu documento" ui-mask-placeholder required><div ng-show="dadosComprador.documento.$touched && dadosComprador.documento.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.documento.$touched && dadosComprador.documento.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$valid, \'has-error\': dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$invalid}"><label class="control-label" for="cellPhone" accesskey="E">Celular * <em class="text-danger" ng-show="dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input name="cellPhone" tabindex="4" type="text" id="cellPhone" class="form-control" ng-model="vm.user.cellPhone" ui-mask="(99) 9?9999-9999" autocomplete="tel" placeholder="Informe celular para contato com DDD" ui-mask-placeholder ng-required="true"><div ng-show="dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$valid, \'has-error\': dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$invalid}"><label class="control-label" for="nasc" accesskey="E">Nascimento * <em class="text-danger" ng-show="dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em> <em class="text-success" ng-show="dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$valid"><i class="fa fa-check" aria-hidden="true"></i></em></label><div class="input-group"><input name="birthdayDate" tabindex="5" type="text" id="nasc" class="form-control" ng-model="vm.user.birth" ui-mask="99/99/9999" autocomplete="birth" placeholder="Informa a data de Nascimento" ui-mask-placeholder ng-required="true"><div ng-show="dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div class="col-xs-6" ng-if="vm.user.customData.estrangeiro == \'false\'"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.Cep.$touched && dadosComprador.Cep.$valid, \'has-error\': vm.invalidZipCode}"><label class="control-label" for="cep" accesskey="E">Cep * <em class="text-danger" ng-show="dadosComprador.Cep.$touched && dadosComprador.Cep.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em> <em class="text-danger" ng-show="vm.invalidZipCode"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> CEP Inv\xE1lido!</em></label><div class="input-group"><input name="Cep" tabindex="6" type="text" id="cep" class="form-control" ng-model="vm.user.zipCode" ui-mask="99999-999" autocomplete="postal-code" placeholder="Informe o CEP" ui-mask-placeholder ng-change="vm.countNumberCEP(true)" ng-required="true"><div ng-show="vm.invalidZipCode" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="!vm.invalidZipCode" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja form-loja-btn-promo"><label class="control-label" for="receberPromocoes" accesskey="E">Receber promo\xE7\xF5es:</label><div class="input-group" id="receberPromocoes" role="radio"><label class="btn btn-default" ng-class="{\'active\': vm.user.mailing}"><input name="sim" tabindex="7" class="active" type="radio" ng-model="vm.user.mailing" ng-value="true">Sim</label> <label class="btn btn-default" ng-class="{\'active\': !vm.user.mailing}"><input name="nao" tabindex="7" type="radio" ng-model="vm.user.mailing" ng-value="false">N\xE3o</label></div></div></div><div class="col-xs-6"><div class="form-group form-loja"><label class="control-label">&nbsp; <em class="text-danger" ng-show="dadosComprador.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Preencha todos os campos *</em> <em class="text-success" ng-show="dadosComprador.$valid"><i class="fa fa-check" aria-hidden="true"></i> Tudo correto *</em></label> <button title="Efetuar cadastro" aria-label="Efetuar cadastro" tabindex="8" type="button" role="button" class="btn btn-success btn-md ripple btn-shadow btn-block" ng-click="vm.savePerson();" ng-disabled="dadosComprador.$invalid">Confirmar <i class="fa fa-save" aria-hidden="true"></i></button></div></div></fieldset></form>');
$templateCache.put('quinta_do_sol/template/info-ingressos.html','<div id="infoIngressos" class="row info-ingressos jumbotron animated in fadeInUp time-10"><div class="col-md-3 calendar-info hidden-xs hidden-sm"><div class="col-calendar layout-calendar"><div uib-datepicker ng-model="vm.date" min-date="vm.today" class="well well-sm" ng-change="vm.search(vm.date)" custom-class="vm.getDayClass(date, mode)" date-disabled="vm.disabledDate(date,mode)"></div></div></div><div class="col-md-9" ng-if="vm.categoriasCombos.length == 0 && !vm.isSearchingProducts"><h2 title="Opa! N\xE3o temos Ingressos dispon\xEDveis para o dia {{vm.lastDate| date:\'dd/MM/yyyy\'}}"><i class="fa fa-ticket"></i>Opa! N\xE3o temos Ingressos dispon\xEDveis para o dia <strong>{{vm.lastDate| date:\'dd/MM/yyyy\'}}</strong></h2><hr><h3 title="Por favor pesquise outro dia!"><i class="fa fa-asterisk"></i> Por favor pesquise outro dia!</h3></div><div class="col-md-9 infos" ng-if="vm.categoriasCombos.length > 0"><h2 title="Produtos dispon\xEDveis"><i class="fa fa-ticket" arian-hidden="true"></i> {{vm.products.length}} {{vm.products.length > 1 ? \'produtos\' : \'produto\'}} {{vm.products.length > 1 ? \'dispon\xEDveis\' : \'dispon\xEDvel\'}} para o dia <strong>{{vm.lastDate| date:\'dd/MM/yyyy\'}}</strong> <span ng-show="vm.categoriasCombos.length > 1">distribuidos em {{vm.categoriasCombos.length}} categorias</span></h2><hr><h3 ng-if="vm.categoriasCombos.length > 1" title="Adicione Ingressos de uma ou mais categorias ao seu carrinho."><i class="fa fa-asterisk" aria-hidden="true"></i> Adicione Ingressos de <strong>uma</strong> ou <strong>mais</strong> categorias ao seu carrinho</h3><h3 ng-if="!vm.resetCarrinho" title="Voc\xEA tamb\xE9m pode comprar Ingressos para diferentes datas, basta realizar outra busca."><i class="fa fa-asterisk" aria-hidden="true"></i> Voc\xEA tamb\xE9m pode comprar Ingressos para diferentes datas, basta realizar outra busca</h3><div class="row body-info-calendario hidden-xs hidden-sm"><div class="col-md-5"><ul><li class="selecionado" uib-tooltip="Dia Selecionando"><i class="fa fa-check"></i> <strong>Dia Selecionado</strong></li><li class="disponivel" uib-tooltip="Descri\xE7\xE3o dos dias dispon\xEDveis"><i class="fa fa-ticket"></i> <strong>Dia Aberto</strong></li><li class="fechado" uib-tooltip="Descri\xE7\xE3o dos dias Fechados"><i class="fa fa-ban"></i> <strong>Dia Fechado</strong></li></ul></div></div></div></div>');
$templateCache.put('quinta_do_sol/template/layout-calendario.html','<div ng-controller="CalendarioController as vm"><div class="row calendar-details"><div class="col-md-4 col-md-offset-2 info"><div class="row header-info-calendario"><div class="col-md-12"><h2 title="Informa\xE7\xF5es Importantes"><small>Informa\xE7\xF5es</small><br><strong>Importantes</strong></h2><hr><p>Contato \xC1gua Show Park: (48) 3369-2354</p><p>E-mail: aguashowpark@aguashowpark.com.br</p></div></div><div class="row body-info-calendario"><div class="col-md-12"><ul><li class="selecionado" uib-tooltip="Dia Selecionando"><i class="fa fa-check"></i> <strong>Dia Selecionado</strong></li><li class="disponivel" uib-tooltip="Descri\xE7\xE3o dos dias dispon\xEDveis"><i class="fa fa-ticket"></i> <strong>Dias Dispon\xEDveis</strong></li><li class="fechado" uib-tooltip="Descri\xE7\xE3o dos dias Fechados"><i class="fa fa-ban"></i> <strong>Dias Fechados</strong></li></ul></div></div></div><div class="col-md-4 col-calendar layout-calendar"><div class="row"><div uib-datepicker min-date="vm.today" ng-model="vm.dt2" ng-if="vm.isLoadDates" class="well well-sm" custom-class="vm.getDayClass(date, mode)" date-disabled="vm.disabledDate(date,mode)"></div></div><div class="row"><div class="col-md-12"><button title="Pesquisar Ingressos para essa data" type="button" class="btn btn-success ripple btn-shadow btn-lg btn-pesquisar btn-block" ng-click="vm.pesquisar()">Pesquisar Ingressos <i class="fa fa-search"></i></button></div></div></div></div></div>');
$templateCache.put('quinta_do_sol/template/layout-first-person.html','<div ng-init=" hospede.customData.estrangeiro = \'false\'"><legend>Dados do {{$index + 1}}\xBA {{hospede.categoria}} <i class="fa fa-male" aria-hidden="true"></i></legend><div class="row"><div class="form-group col-md-6 padding-md-right-5"><input type="text" class="form-control" name="Nome" placeholder="Nome do {{hospede.placeholder}}" ng-model="hospede.name" required></div><div class="form-group col-md-6 padding-md-lefth-5"><input type="email" class="form-control" name="Email" placeholder="E-mail" ng-model="hospede.email" required></div><div class="form-group col-md-6 padding-md-right-5"><input type="text" class="form-control" name="Celular" ui-mask="(99) 99999-9999" placeholder="Celular" ui-mask-placeholder ng-model="hospede.cellPhone" required></div><div class="form-group col-md-6 padding-md-lefth-5"><input type="text" class="form-control" name="birthdayDate" ui-mask="99/99/9999" placeholder="Data de Nascimento" ui-mask-placeholder ng-model="hospede.birth" required></div><div class="form-group col-md-6"><select class="form-control" name="estrangeiro" ng-model="hospede.customData.estrangeiro" required><option value="false" selected="selected">Brasileiro</option><option value="true">Estrangeiro</option></select></div><div ng-if="hospede.customData.estrangeiro === \'false\'" class="form-group col-md-6 padding-md-lefth-5"><input type="text" class="form-control" name="cpf" ui-mask="999.999.999-99" placeholder="CPF" ui-mask-placeholder ng-model="hospede.cpf" required></div><div ng-if="hospede.customData.estrangeiro === \'true\'" class="form-group col-md-6 padding-md-lefth-5"><input type="text" class="form-control" name="passporte" placeholder="Documento" ui-mask-placeholder ng-model="hospede.passporte" required></div></div></div>');
$templateCache.put('quinta_do_sol/template/xsSearchBar.html','<section class="row b2c-checkin all"><div class="data-entrada col-xs-6 col-md-2 padding-xs-right-5 form-group"><label class="label">Check-in</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-change="vm.handleEndDate()" ng-model="vm.dates.date" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.today" is-open="vm.activeDate" ng-click="vm.handleDate()"> <span class="input-group-addon"><a ng-click="vm.handleDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openDatePickerModal()">{{vm.dates.date| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div><div class="data-saida col-xs-6 col-md-2 padding-xs-left-5 form-group"><label class="label">Check-out</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-model="vm.dates.endDate" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.nextDay" is-open="vm.activeEndDate" ng-click="vm.handleEndDate()"> <span class="input-group-addon"><a title="Calend\xE1rio" href="" ng-click="vm.handleEndDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openEndDatePickerModal()">{{vm.dates.endDate| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div><div class="quartos col-xs-6 col-md-2 padding-xs-right-5 form-group"><label class="label">Quantidade de Quartos</label> <select class="form-control" id="quartos" ng-model="vm.quartos" ng-change="vm.ckecksQuantidadesQuartos()"><option value="">Quartos</option><option value="1">1 Quarto</option><option value="2">2 Quartos</option><option value="3">3 Quartos</option><option value="4">4 Quartos</option><option value="5">5 Quartos</option><option value="6">6 Quartos</option></select></div><div class="pessoas col-xs-6 col-md-2 padding-xs-left-5 form-group"><label class="label">Adultos</label> <select class="form-control" id="adultos" ng-model="vm.adt" ng-disabled="vm.verificaAdultos"><option value="">Adultos</option><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option></select></div><div ng-if="vm.verificaDialogChd" class="col-xs-12 col-md-2 padding-xs-left-5 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button class="form-control btn btn-success" ng-click="vm.openChdDialog()">Crian\xE7as</button></div><div ng-if="!vm.verificaDialogChd" class="criancas col-md-2 col-xs-6 padding-xs-right-5 form-group"><label class="label">Crian\xE7as</label> <select class="form-control input-group" id="criancas" ng-model="vm.chd" ng-disabled="vm.verificaCriancas"><option value="">0 Crian\xE7as de de 2 a 12 anos</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option></select></div><div ng-if="!vm.verificaDialogChd" class="colos col-md-2 col-xs-6 padding-xs-left-5 form-group"><label class="label">Colos</label> <select class="form-control input-group" id="criancas" ng-model="vm.colo" ng-disabled="vm.verificaColos"><option value="">0 Colos de de 0 a 2 anos</option><option value="1">1 Colo de de 0 a 2 anos</option><option value="2">2 Colos de de 0 a 2 anos</option></select></div><div class="pesquisar col-xs-12 col-md-2 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button title="Pesquisar disponibilidade" type="button" class="btn time-05 btn-success btn-block ripple" ng-click="vm.search()">PESQUISAR <i class="fa fa-search" aria-hidden="true"></i></button></div></section><section class="row b2c-checkin-apto-extra" ng-show="vm.quartos > 1"><div class="col-md-12"><h2 title="Informe a quantidade de h\xF3spedes para os apartamentos">Informe a quantidade de h\xF3spedes para os apartamentos</h2><hr></div><div class="col-md-4 b2c-row-apto-extra" ng-repeat="apto in vm.aptos"><div class="row box"><div class="col-md-12"><h3 title="{{$index + 1}}\xBA Quarto">{{$index + 1}}\xBA Quarto <i class="fa fa-bed" aria-hidden="true"></i></h3></div><div class="sub-pessoas col-xs-6 padding-xs-right-5 form-group"><label class="label">Quantidade de Adultos</label> <select class="form-control input-group" id="adultos" ng-model="apto.adt"><option value="">Adultos</option><option ng-selected value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option></select></div><div ng-if="vm.verificaDialogChd" class="col-xs-6 padding-xs-right-5 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button class="form-control btn btn-success btn-chd-dialog" ng-click="vm.openChdDialog()">Crian\xE7as</button></div><div ng-if="!vm.verificaDialogChd" class="sub-criancas col-xs-6 padding-xs-left-5 form-group"><label class="label">Quantidade de Crian\xE7as</label> <select class="form-control input-group" id="criancas" ng-model="apto.chd"><option value="">Crian\xE7as de de 2 a 12 anos</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option></select></div><div ng-if="!vm.verificaDialogChd" class="sub-criancas col-xs-6 form-group"><label class="label">Quantidade de Colos</label> <select class="form-control input-group" id="criancas" ng-model="apto.colo"><option value="">Colos de de 0 a 2 anos</option><option value="1">1 Colo de de 0 a 2 anos</option><option value="2">2 Colos de de 0 a 2 anos</option></select></div></div></div></section>');
$templateCache.put('quinta_do_sol/template/xsSearchVertical.html','<div class="row b2c-filters-check-in"><div class="col-md-12 content"><div class="row dates"><div class="check-in col-xs-6 padding-right-5"><div class="form-group"><label class="label">Check-in</label><div class="input-group hidden-xs hidden-sm"><input type="text" class="form-control" ng-change="vm.handleEndDate()" ng-model="vm.dates.date" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.today" is-open="vm.activeDate" ng-click="vm.handleDate()"> <span class="input-group-addon"><a ng-click="vm.handleDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openDatePickerModal()">{{vm.dates.date| date:\'dd/MM/yyyy\'}}&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div></div><div class="check-out col-xs-6 padding-left-5"><div class="form-group"><label class="label">Check-out</label><div class="input-group hidden-xs hidden-sm"><input type="text" class="form-control" ng-model="vm.dates.endDate" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.nextDay" is-open="vm.activeEndDate" ng-click="vm.handleEndDate()"> <span class="input-group-addon"><a title="Calend\xE1rio" href="" ng-click="vm.handleEndDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openEndDatePickerModal()">{{vm.dates.endDate| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div></div></div><div class="row quartos"><div class="col-xs-12"><div class="form-group"><label class="label">Quantidade de Quartos</label> <select class="form-control" ng-model="vm.quartos"><option value="1">1 Quarto</option><option value="2">2 Quartos</option><option value="3">3 Quartos</option><option value="4">4 Quartos</option><option value="5">5 Quartos</option><option value="6">6 Quartos</option></select></div></div></div><div class="row hospedes one" ng-show="vm.quartos == 1"><div class="col-xs-4 adulto padding-right-5"><div class="form-group"><label class="label" for="adultos"><i class="fa fa-male" aria-hidden="true"></i> Adultos</label> <select class="form-control input-group" id="adultos" ng-model="vm.adt"><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option></select></div></div><div ng-if="vm.verificaDialogChd" class="col-xs-6 padding-xs-right-5 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button class="form-control btn btn-success btn-chd-dialog" ng-click="vm.openChdDialog()">Crian\xE7as</button></div><div ng-if="!vm.verificaDialogChd" class="col-xs-4 chd padding-right-5 padding-left-5"><div class="form-group"><label class="label" for="criancas"><i class="fa fa-child" aria-hidden="true"></i> Crian\xE7a</label> <select class="form-control input-group" id="criancas" ng-model="vm.chd"><option value="0">Crian\xE7as</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option></select></div></div><div ng-if="!vm.verificaDialogChd" class="col-xs-4 colos padding-left-5"><div class="form-group"><label class="label" for="colos"><i class="fa fa-child" aria-hidden="true"></i> Colos</label> <select class="form-control input-group" id="colos" ng-model="vm.colo"><option value="0">Colos</option><option value="1">1 Colo de de 0 a 2 anos</option><option value="2">2 Colos de de 0 a 2 anos</option></select></div></div></div><div class="aparts-extra" ng-show="vm.quartos > 1"><div class="row hospedes extra" ng-repeat="apto in vm.aptos"><div class="col-xs-12 title-hospedes"><h5 title="{{$index + 1}}\xBA Quarto">{{$index + 1}}\xBA Quarto <i class="fa fa-bed" aria-hidden="true"></i></h5></div><div class="col-xs-4 adulto padding-right-5"><label class="label" for="adultos{{$index}}"><i class="fa fa-male" aria-hidden="true"></i> Adultos</label> <select class="form-control input-group" id="adultos{{$index}}" ng-model="apto.adt"><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option><option value="6">6 Adultos</option></select></div><div ng-if="vm.verificaDialogChd" class="col-xs-6 padding-xs-right-5 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button class="form-control btn btn-success btn-chd-dialog" ng-click="vm.openChdDialog()">Crian\xE7as</button></div><div ng-if="!vm.verificaDialogChd" class="col-xs-4 chd padding-right-5 padding-left-5"><label class="label" for="criancas{{$index}}"><i class="fa fa-child" aria-hidden="true"></i> Crian\xE7a</label> <select class="form-control input-group" id="criancas{{$index}}" ng-model="apto.chd"><option value="0">Crian\xE7as</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option></select></div><div ng-if="!vm.verificaDialogChd" class="col-xs-4 colos padding-left-5"><label class="label" for="colos{{$index}}"><i class="fa fa-child" aria-hidden="true"></i> Colos</label> <select class="form-control input-group" id="colos{{$index}}" ng-model="apto.colo"><option value="0">Colos</option><option value="1">1 Colo de de 0 a 2 anos</option><option value="2">2 Colos de de 0 a 2 anos</option></select></div><div class="col-xs-12"><hr role="reparator"></div></div></div><div class="row function"><div class="col-xs-12"><button title="PESQUISAR" type="button" class="btn btn-warning btn-block" ng-click="vm.search()">PESQUISAR <i class="fa fa-search" aria-hidden="true"></i></button></div></div></div></div>');}]);
angular.module('b2c_ingressos').run(['$templateCache', function($templateCache) {$templateCache.put('app/index.cookies.html','<nav class="navbar navbar-default navbar-fixed-bottom cookies-bar" ng-if="index.showCookies"><div class="container-fluid"><div class="row"><div class="col-md-10"><p><br><a target="_blank" href=""></a></p></div><div class="col-md-2"><button title="Aceito" class="btn" type="button" ng-click="index.closeCookiesBar()"></button></div></div></div></nav>');
$templateCache.put('app/account/account.html','<main class="container loja-main"><section id="reservation-form" class="row loja-box-float loja-account"><div class="col-md-10 col-md-offset-1 loja-account-card loja-box-float-card"><div class="row"><div class="col-md-12"><h1 title="Informe seus dados">Informe seus dados</h1></div></div><div class="col-md-12"><xs-register xs-complete="vm.registroEfetuado()" template-url="app/components/xsRegister/xsRegister.html"></xs-register></div></div></section><xs-paid-button></xs-paid-button></main>');
$templateCache.put('app/agendarDatas/agendamento.html','<div class="container"><div class="row"><h1 class="col-xs-12">Agendamento de Ingressos e Passaportes</h1></div><div class="row"><div class="col-xs-12 col-md-6 col-lg-4" ng-if="vm.urlVoucher"><a title="VOUCHER" class="btn btn-success btn-block btn-large" target="_blank" rel="noopener" href="{{vm.urlVoucher}}"><i class="fa fa-print"></i> VOUCHER</a></div><div class="col-xs-12 col-md-6 col-lg-4" ng-if="!vm.urlVoucher"><form name="formWebCheckin" role="form"><div class="form-group"><label for="email">Campo de Identifica\xE7\xE3o</label> <select name="email" id="email" class="form-control" ng-model="vm.campo" required="required"><option value="localizador">Localizador da compra online</option><option value="externo">Ingresso f\xEDsico</option><option value="cpf">N\xFAmero do voucher e CPF do comprador</option><option value="email">N\xFAmero do voucher e email do comprador</option></select></div><div ng-if="vm.campo == \'localizador\'"><div class="form-group"><label for="localizador">Localizador da compra</label> <input type="text" class="form-control" id="localizador" placeholder="Reserva" ng-model="vm.localizador" required></div></div><div ng-if="vm.campo == \'externo\'"><div class="form-group"><label for="externo">N\xFAmero do ingresso f\xEDsico</label> <input type="text" class="form-control" id="externo" placeholder="N\xFAmero do ingresso f\xEDsico" ng-model="vm.ingresso" required></div><div class="form-group"><label for="datadeacesso">Data</label><div class="input-group"><input type="text" class="form-control" ng-model="vm.date" uib-datepicker-popup="dd/MM/yyyy" is-open="vm._activeDate" ng-click="vm.handleDate()" min-date="vm.today" custom-class="vm.getDayClass(date, mode)" date-disabled="vm.disabledDate(date, mode)" required> <span class="input-group-addon"><a ng-click="vm.handleDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div></div></div><div ng-if="vm.campo == \'cpf\' || vm.campo == \'email\'"><div class="form-group"><label for="numero">N\xFAmero do voucher</label> <input type="text" class="form-control" id="numero" placeholder="(Apenas numeros)" ng-model="vm.id" ui-mask="9999999" ui-mask-placeholder required></div><div class="form-group" ng-if="vm.campo == \'email\'"><label for="email">Email do comprador</label> <input type="email" class="form-control" id="email" placeholder="Email do comprador" ng-model="vm.email" required></div><div class="form-group" ng-if="vm.campo == \'cpf\'"><label for="">CPF do comprador</label> <input type="text" class="form-control" id="cpf" placeholder="CPF do comprador" ng-model="vm.cpf" ui-mask="999.999.999-99" ui-mask-placeholder required></div></div><div ng-if="vm.campo != \'externo\'"><button type="button" class="btn btn-primary" ng-disabled="formWebCheckin.$invalid" ng-click="vm.buscaConta()"><i class="fa fa-search"></i>&nbsp;Procurar</button></div><div ng-if="vm.campo == \'externo\'"><button type="button" class="btn btn-primary" ng-disabled="formWebCheckin.$invalid" ng-click="vm.buscaConta()"><i class="fa fa-ticket"></i>&nbsp;Agendar</button></div></form></div><div class="hidden-xs col-md-6 col-lg-6 col-lg-offset-1"><div ng-if="vm.campo == \'localizador\'"><img src="" class="img-responsible" ng-if="\'\'"></div><div ng-if="vm.campo == \'cpf\' || vm.campo == \'email\'"><img src="" class="img-responsible" ng-if="\'\'"></div><div ng-if="vm.campo == \'externo\'"><img src="" class="img-responsible" ng-if="\'\'"></div></div></div><br></div>');
$templateCache.put('app/agendarDatas/agendarDatas.html','<div class="container" style="max-width: 1368px;"><form name="formAgendarDatas" role="form" ng-if="vm.initialized" style="padding: auto 1rem;"><h3>Localizador {{vm.locator}}</h3><div ng-repeat="p in vm.products" class="agendar-datas-lista-item"><div class="info-title"><h4>{{p.codigoBarras}} - <b>{{p._name}}</b></h4><div ng-if="p._datasAgendadas.length > 0">Datas Agendadas: <b ng-repeat="ag in p._datasAgendadas">{{ag}}&nbsp;</b></div></div><div class="buton-foto" ng-if="p.needPicture"><div><label for="foto">{{p.foto==null ? "Tire uma selfie": "Selfie ok"}}</label> <button type="button" class="form-control btn" ng-class="{\'btn-success\': p.foto, \'btn-danger\': !p.foto}" ng-click="vm.openCamera(p)">Foto&nbsp;<i class="fa fa-picture-o"></i></button></div><input type="hidden" ng-if="p.needPicture" ng-model="p.foto" required></div><div class="input-1" ng-if="p.person"><div class="form-group"><label for="datadeacesso">{{$index +1}}\xAA Pessoa</label> <input type="text" class="form-control" ng-model="p.person.name" ng-disabled="p._disablePerson" placeholder="Nome Completo" required></div></div><div class="input-2" ng-repeat="d in p.dates track by $index"><div class="form-group" style="display: flex; flex-wrap: wrap;"><div class="agendar-datas_datas"><label for="datadeacesso">{{$index +1}}\xAA Data</label><div class="input-group"><input type="text" class="form-control form-input-agendar" ng-model="d._date" ng-disabled="p.deliveryDate" uib-datepicker-popup="dd/MM/yyyy" is-open="d._activeDate" ng-click="vm.handleDate(d)" min-date="vm.today" custom-class="vm.getDayClass(date, mode)" date-disabled="vm.disabledDate(date, mode, p)" ng-required="$index==0" ng-change="vm.fetchSchedules(p, d)"> <span class="input-group-addon"><a ng-click="vm.handleDate(p)"><i class="fa fa-calendar" aria-hidden="true" style="padding: 0 14px;"></i></a></span></div></div><div class="col-md-6 col-sm-10" ng-if="d.schedules && d.schedules.length > 0"><label for="datadeacesso">{{$index +1}}\xAA Hor\xE1rio:</label> <select class="form-control" ng-model="d.schedule" style="height: 42px;"><option ng-repeat="schedule in d.schedules" value="{{schedule.schedule}}">{{schedule.schedule}}</option></select></div></div></div><div class="title-2" ng-if="p.dates.length == 0"><h5 class="alert alert-warning">N\xFAmero m\xE1ximo de datas agendadas para esse passaporte.</h5></div></div><div class="col-xs-12 row" style="padding-top:10px;"><div class="col-md-4 col-md-offset-8"><div class="form-group"><button type="button" class="form-control btn btn-primary pull-right" ng-disabled="vm.invalidForm()" ng-click="vm.save()">Salvar&nbsp;<i class="fa fa-next"></i></button></div></div></div></form><br></div>');
$templateCache.put('app/agendarDatas/webcam.html','<div class="modal-header dialog-webcam"><div class="row"><h4 class="modal-title col-xs-10">Tire uma selfie</h4><button class="btn btn-danger col-xs-2 col-md-offset-1 col-md-1" ng-click="vm.close()"><i class="fa fa-close"></i></button></div></div><div class="modal-body"><div class="row"><div class="col-xs-12 text-center" ng-show="vm.item.cameraCarregada"><video autoplay="true" id="webCamera" class="img-responsive" style="max-height: 500px;"></video></div><div class="col-xs-12 col-md-8" ng-if="vm.foto"><img id="imagemConvertida" class="img-responsive" ng-src="{{vm.foto}}" style="max-height: 500px;"></div><div class="col-xs-12 col-md-4" ng-if="vm.foto"><p>Seu rosto deve estar vis\xEDvel.</p></div></div><div class="row"><div class="col-md-2 col-md-offset-5 col-xs-4 col-xs-offset-4"><button class="form-control btn btn-info" type="button" ng-click="vm.takeSnapShot(\'#webCamera\')" ng-if="!vm.foto"><i class="fa fa-camera"></i></button></div></div></div><div class="modal-footer"><button title="Tirar outra" class="btn btn-danger" type="button" ng-click="vm.resetCamera()" ng-disabled="!vm.foto">Tirar outra</button> <button title="Ficou Legal" class="btn btn-info" type="button" ng-click="vm.close()" ng-disabled="!vm.foto">Ficou Legal</button></div>');
$templateCache.put('app/checkin/checkin.html','<form name="formWebCheckin" role="form" class="container"><div class="row" ng-if="vm.checkin"><h1 class="col-xs-12">Obrigado</h1><h2 class="col-xs-12">Seu checkin ser\xE1 agilizado.</h2><div class="col-xs-12 col-md-3" ng-if="vm.voucherLink"><a class="btn btn-primary btn-block" href="{{vm.voucherLink}}" target="_blank"><i class="fa fa-print"></i>Voucher</a></div><div class="col-xs-12 col-md-3"><a class="btn btn-danger btn-block" ui-sref="webcheckin">Voltar</a></div></div><div class="row" ng-if="vm.notCheckin"><h1 class="col-xs-12">Checkin</h1><h2 class="col-xs-12">Seus dados<span class="hidden-xs hidden-sm h5 pull-right text-danger" ng-if="\'Preenchimento de todos os campos obrigat\xF3rio\'">* Preenchimento de todos os campos obrigat\xF3rio</span></h2><div class="col-md-8"><div class="form-group"><label for="name">Nome Completo *</label> <input type="text" class="form-control" id="name" placeholder="Nome Completo" ng-model="vm.traveler.name" ng-disabled="vm.lock.nome" required></div></div><div class="col-md-4"><div class="form-group"><label for="email">Email *</label> <input type="text" class="form-control" id="email" placeholder="Email" ng-model="vm.traveler.email" ng-disabled="vm.lock.email" required></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="celular">Celular *</label> <input name="Celular" type="text" id="celular" class="form-control" ng-model="vm.traveler.cellPhone" ui-mask="(99) 9 9999-9999" placeholder="(DDD) 0 0000-0000" ui-mask-placeholder ng-required="true"></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="telefone">Telefone *</label> <input name="Telefone *" type="text" id="telefone" class="form-control" ng-model="vm.traveler.homePhone" ui-mask="(99) 9999-9999" placeholder="(DDD) 0000-0000" ui-mask-placeholder autocomplete="tel" required></div></div><div class="col-md-4"><div class="form-group"><label for="profissao">Profiss\xE3o *</label> <input type="text" class="form-control" id="profissao" placeholder="Profiss\xE3o *" ng-model="vm.traveler.customData.occupation" required></div></div><div class="col-md-4"><div class="form-group"><label for="nascimento">Data Nascimento *</label> <input type="text" class="form-control" id="nascimento" ui-mask="99/99/9999" placeholder="DD/MM/AAAA" ui-mask-placeholder ng-model="vm.traveler.birth" required></div></div><div class="col-md-4"><div class="form-group"><label for="gender">G\xEAnero *</label> <select id="gender" name="gender" class="form-control" ng-model="vm.traveler.gender" required><option value="M">Masculino</option><option value="F">Feminino</option></select></div></div><div class="col-md-4"><div class="form-group"><label for="Nacionalidade">Nacionalidade *</label> <input type="text" class="form-control" id="Nacionalidade" placeholder="Nacionalidade" ng-model="vm.traveler.customData.nacionalidade" required></div></div><div class="col-md-4"><div class="form-group"><label for="CPF">CPF *</label> <input type="text" class="form-control" id="CPF" placeholder="CPF" ng-disabled="vm.lock.cpf" ui-mask="999.999.999-99" placeholder="Digite o seu CPF" ui-mask-placeholder ng-model="vm.traveler.cpf" required></div></div><div class="col-md-4"><div class="form-group"><label for="RG">RG *</label> <input type="text" class="form-control" id="RG" placeholder="RG *" ng-model="vm.traveler.rg0" required></div></div><div class="col-md-4"><div class="form-group"><label for="RG">Org\xE3o Expedidor *</label> <input type="text" class="form-control" id="Org\xE3o Expedidor" placeholder="Org\xE3o Expedidor *" ng-model="vm.traveler.rg1" required></div></div><div class="col-md-4"><div class="form-group" style="margin-bottom: 14px;"><label class="control-label" for="cep">Cep *</label><div class="input-group"><input name="Cep" type="text" id="cep" class="form-control" ng-model="vm.traveler.zipCode" ui-mask="99999-999" placeholder="_____-___" ui-mask-placeholder ng-enter="vm.findCep()" required> <span class="input-group-addon"><a href="" ng-click="vm.findCep()"><i class="fa fa-search"></i></a></span></div></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="complemento">Complemento *</label> <input name="complemento" type="text" id="complemento" class="form-control" placeholder="Complemento" ng-model="vm.traveler.address2"></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="rua">Endere\xE7o *</label> <input name="rua" type="text" id="rua" class="form-control" placeholder="Endere\xE7o" ng-model="vm.traveler.street0" required></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="bairro">Bairro *</label> <input name="bairro" type="text" id="bairro" class="form-control" placeholder="Bairro" ng-model="vm.traveler.street1" required></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="numero">N\xFAmero *</label> <input name="numero" type="text" id="numero" class="form-control" placeholder="N\xFAmero" ng-model="vm.traveler.number" required></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="cidade">Cidade *</label> <input name="cidade" type="text" id="cidade" class="form-control" placeholder="Cidade" ng-model="vm.traveler.city" required></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="estado">Estado *</label> <input name="estado" type="text" id="estado" size="2" maxlength="2" class="form-control" placeholder="UF" ng-model="vm.traveler.state" required></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="country">Pa\xEDs *</label> <input name="country" type="text" id="country" class="form-control" placeholder="Pa\xEDs" ng-model="vm.traveler.customData.country" required></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="naturalidade">Naturalidade *</label> <input name="naturalidade" type="text" id="naturalidade" class="form-control" placeholder="Naturalidade" ng-model="vm.traveler.customData.naturalidade" required></div></div><div class="col-md-4" ng-if="::true"><div class="form-group"><label class="control-label" for="procedencia">\xDAltima Proced\xEAncia *</label> <input name="procedencia" type="text" id="procedencia" class="form-control" placeholder="\xDAltima Proced\xEAncia" ng-model="vm.traveler.customData.procedencia" required></div></div><div class="col-md-4" ng-if="::true"><div class="form-group"><label class="control-label" for="destino">Pr\xF3ximo Destino *</label> <input name="destino" type="text" id="destino" class="form-control" placeholder="Pr\xF3ximo Destino" ng-model="vm.traveler.customData.destino" required></div></div><div class="col-md-4" ng-if="::true"><div class="form-group"><label class="control-label" for="motivo">Motivo da Viagem *</label> <select id="motivo" name="motivo" class="form-control" placeholder="Motivo da Viagem" ng-model="vm.traveler.customData.motivoviagem" required><option value="lazer">Lazer/Ferias</option><option>Compras</option><option value="Congresso ou Feira">Congresso/Feira</option><option>Estudos</option><option>Neg\xF3cios</option><option value="parentes">Parentes/Amigos</option><option>Religi\xE3o</option><option>Sa\xFAde</option><option>Outro</option></select></div></div><div class="col-md-4" ng-if="::true"><div class="form-group"><label class="control-label" for="transporte">Meio de Transporte *</label> <select id="gender" name="gender" class="form-control" ng-model="vm.traveler.customData.meioTransporte" required><option>Avi\xE3o</option><option>Carro</option><option>Moto</option><option>Navio</option><option>Onibus</option><option>Trem</option><option>Outro</option></select></div></div><h3 class="col-md-12" ng-if="$index > 0">Acompanhantes</h3><div ng-repeat="traveler in vm.travelers" ng-if="$index > 0"><h4 class="col-md-12">{{$index}}\xBA acompanhante: {{traveler.tag | capitalize}}</h4><div class="col-md-4"><div class="form-group"><label for="name{{::$index}}">Nome Completo *</label> <input type="text" class="form-control" id="name{{::$index}}" placeholder="Nome" ng-model="traveler.name" required></div></div><div class="col-md-4"><div class="form-group"><label for="nascimento{{::$index}}">Data Nascimento *</label> <input type="text" class="form-control" id="nascimento{{::$index}}" placeholder="Data Nascimento" ui-mask="99/99/9999" placeholder="DD/MM/AAAA" ui-mask-placeholder ng-model="traveler.birth" required></div></div><div class="col-md-4"><div class="form-group"><label for="document{{::$index}}">Documento *</label> <input type="text" class="form-control" id="document" placeholder="Documento *" ng-model="traveler.rg" required></div></div></div><div class="col-xs-12" ng-show="formWebCheckin.$invalid"><p class="pull-right text-danger">* Preencha os campos obrigat\xF3rios</p></div><div class="col-xs-12 col-md-offset-10 col-md-2"><button type="button" class="form-control btn btn-primary" ng-click="vm.salvar()" ng-disabled="formWebCheckin.$invalid">Salvar</button></div></div></form>');
$templateCache.put('app/checkin/webcheckin.html','<div class="container"><div class="row"><div class="col-xs-12 text-center"><h1>Bem vindo ao web checkin</h1></div><div class="col-md-6"><h3>Encontre sua reserva</h3></div><div class="col-md-6 hidden-xs"><h3>Ou acesse o site pelo seu smartphone</h3></div><div class="col-md-6"><form name="formWebCheckin" role="form"><div class="form-group"><label for="localizador">Reserva</label> <input type="text" class="form-control" id="localizador" placeholder="Reserva" ng-model="vm.localizador" required></div><div class="form-group" ng-init="vm.campo = \'cpf\'"><label for="email">Campo de Identifica\xE7\xE3o</label> <select name="email" id="email" class="form-control" ng-model="vm.campo" required="required"><option value="cpf">CPF</option><option value="email">Email</option></select></div><div class="form-group" ng-if="vm.campo == \'email\'"><label for="email">Email do Titular</label> <input type="email" class="form-control" id="email" placeholder="Email do Titular" ng-model="vm.email" required></div><div class="form-group" ng-if="vm.campo == \'cpf\'"><label for="">CPF do Titular</label> <input type="text" class="form-control" id="cpf" placeholder="CPF do Titular" ng-model="vm.cpf" ui-mask="999.999.999-99" ui-mask-placeholder required></div><button type="button" class="btn btn-primary" ng-disabled="formWebCheckin.$invalid" ng-click="vm.buscaReserva()"><i class="fa fa-search"></i>&nbsp;Procurar</button></form></div><div class="col-md-6 barcode hidden-xs hidden-sm"><img ng-src="{{::vm.getUrlBarcode()}}" class="img-responsive" alt="Image"></div></div></div>');
$templateCache.put('app/compras/compras.html','<div class="container"><div class="row loja-compras-influencer"><div ng-if="vm.saleInfluencerInfo"><div class="col-xs-12 col-md-8 col-md-offset-2"><h2 class="text-center">Seja um influenciador</h2></div><div class="col-md-2 text-right"><a href="{{vm.saleInfluencerInfo}}" class="btn btn-link informacoes">informa\xE7\xF5es <i class="fa fa-question"></i></a></div><div class="col-xs-12"><div class="row"><div class="col-xs-12 text-center"><h4 class="row">Link exclusivo: <button class="btn btn-link" ngclipboard data-clipboard-text="{{vm.user.influencerUrl}}" ngclipboard-success="vm.linkCopySuccess(e)">{{vm.user.influencerUrl}}</button></h4></div><div class="col-xs-12 col-md-offset-2 col-md-2"><a title="Compartilhar no WhatsApp" class="btn-block btn-whatsapp btn btn-scala btn-sm" target="_blank" rel="noopener" href="https://api.whatsapp.com/send?text={{::vm.user.influencerUrl | urlEncode}}"><i class="fa fa-whatsapp" aria-hidden="true"></i> WhatsApp</a></div><div class="col-xs-12 col-md-2"><a title="Compartilhar no Facebook" class="btn-block btn-primary btn btn-scala btn-sm" target="_blank" rel="noopener" href="https://www.facebook.com/sharer/sharer.php?u={{::vm.user.influencerUrl | urlEncode}}"><i class="fa fa-facebook" aria-hidden="true"></i> Facebook</a></div><div class="col-xs-12 col-md-2"><a title="Compartilhar no Twitter" class="btn btn-default btn-twitter btn-block btn-scala btn-sm" target="_blank" rel="noopener" href="https://twitter.com/share?url={{::vm.user.influencerUrl | urlEncode}}"><i class="fa fa-twitter" aria-hidden="true"></i> Tweet</a></div><div class="col-xs-12 col-md-2"><button class="btn-block btn btn-default btn-sm btn-scala" ng-click="vm.showSales()"><i class="fa fa-chevron-down"></i> Minhas vendas</button></div></div></div><div class="col-xs-12" ng-if="vm.mySales"><div class="col-xs-12"><div class="row"><div class="col-xs-12"><h3 title="Minhas Vendas" class="text-center">Minhas Vendas</h3></div></div><div class="row hidden-xs"><h4 class="col-md-2">Venda</h4><h4 class="col-md-2">Data</h4><h4 class="col-md-2">Visita</h4><h4 class="col-md-2">Valor</h4><h4 class="col-md-2">Nome</h4><h4 class="col-md-2">Status</h4></div><div class="row" ng-repeat="sale in vm.mySales" style="border-top: 1px solid lightgray; padding-top: 3px; padding-bottom: 3px;"><div class="col-md-2 col-xs-12"><label class="visible-xs col-xs-3">Data:&nbsp;</label>{{sale.date}}</div><div class="col-md-2 col-xs-12"><label class="visible-xs col-xs-3">Venda:&nbsp;</label>{{sale.id}}</div><div class="col-md-2 col-xs-12"><label class="visible-xs col-xs-3">Visita:&nbsp;</label>{{sale.visita}}</div><div class="col-md-2 col-xs-12"><label class="visible-xs col-xs-3">Valor:&nbsp;</label>{{sale.value | currency:"R$ "}}</div><div class="col-md-2 col-xs-12"><label class="visible-xs col-xs-3">Nome:&nbsp;</label>{{sale.person}}</div><div class="col-md-2 col-xs-12"><label class="visible-xs col-xs-3">Status:&nbsp;</label>{{sale.status}}</div></div></div></div></div></div><div class="row"><div class="col-md-12 loja-compras-card loja-box-float-card"><div class="row"><div class="col-md-12"><h3 title="Minhas Compras" class="page-header" align="center">Minhas Compras</h3></div></div><div class="tab-body"><uib-tabset class="tab-uib-tabset" active="active" justified="vm.justifiedTabs"><uib-tab index="0" select="vm.page = \'lastReservation\'"><uib-tab-heading><i class="fa fa-clock-o" aria-hidden="true"></i> \xDAltima Compra</uib-tab-heading><div class="tab-conteudo"><div ng-show="vm.page == \'lastReservation\' || $index == 0"><div class="title-conteudo-tab"><h3 title="N\xDAMERO DA COMPRA: {{vm.lastReservation.id}}" class="localizador {{vm.lastReservation.status}}">N\xDAMERO DA COMPRA: {{vm.lastReservation.localizador}}</h3><hr></div><ul class="list-group"><li class="list-group-item" ng-show="vm.lastReservation.path.indexOf(\'bills\') >= 0 && !vm.naoEscolheData"><span>Data da Visita: </span><strong>{{vm.lastReservation.periodo}}</strong></li><li class="list-group-item" ng-hide="vm.lastReservation.path.indexOf(\'bills\') >= 0"><span>Per\xEDodo: </span><strong>{{vm.lastReservation.periodo}}</strong></li><li class="list-group-item"><span>Descritivo: </span><strong>{{vm.lastReservation.descritivo}}</strong></li><li class="list-group-item"><span>Status: </span><strong ng-class="{\'text-success\':vm.lastReservation.status == \'Confirmada\',\'text-warning\':vm.lastReservation.status == \'Cancelada\'}">{{vm.lastReservation.status}}</strong></li><li class="list-group-item"><span>Valor: </span><strong>{{vm.lastReservation.valor / 100| currency:"R$ "}}</strong></li></ul><a title="VOUCHER" class="btn btn-lg btn-success btn-voucher" target="_blank" rel="noopener" href="{{vm.lastVoucherLink}}" ng-if="vm.lastReservation.voucher && !vm.lastReservation.listaEntradaUrl"><i class="fa fa-print"></i>VOUCHER </a><a title="Gerar Voucher" class="btn btn-lg btn-success btn-voucher" target="_blank" rel="noopener" href="{{vm.lastReservation.listaEntradaUrl}}" ng-if="vm.lastReservation.listaEntradaUrl"><i class="fa fa-photo"></i>Gerar Voucher </a><a title="IMPRIMIR BOLETO" class="btn btn-lg btn-success" target="_blank" rel="noopener" href="{{vm.pdfAddress}}?method=boletoAsByte&id={{vm.lastReservation.id}}&reservation=reservations/{{vm.lastReservation.id}}&boleto={{vm.lastReservation.boleto}}&token={{vm.lastReservation.boletoToken}}" ng-show="!vm.lastReservation.voucher && vm.lastReservation.boleto"><i class="fa fa-print"></i>IMPRIMIR BOLETO </a><a title="EFETUAR PAGAMENTO" class="btn btn-lg btn-success" target="_blank" rel="noopener" href="{{vm.lastReservation.paymentUrl}}" ng-show="vm.lastReservation.paymentUrl"><i class="fa fa-money"></i>EFETUAR PAGAMENTO </a><button title="Cancelar Compra" class="btn btn-lg btn-danger" ng-click="vm.cancel(vm.lastReservation)" ng-if="vm.lastReservation.userCanCancel==\'true\' || vm.lastReservation.can_cancel"><i class="fa fa-close"></i>&nbsp;Cancelar Compra</button> <button title="Reagendar" class="btn btn-lg btn-warning" ng-click="vm.reAgendar(vm.lastReservation)" ng-if="vm.lastReservation.socio != \'true\' && vm.lastReservation.permiteReagendamento && vm.lastReservation.voucher && vm.lastReservation.path.indexOf(\'bills\') == 0 && !vm.lastReservation.listaEntradaUrl"><i class="fa fa-calendar"></i>&nbsp;Reagendar</button> <button title="Reagendar" class="btn btn-lg btn-warning" ng-click="vm.reAgendarConta(vm.lastReservation)" ng-if="vm.lastReservation.socio != \'true\' && vm.lastReservation.permiteReagendamentoConta && vm.lastReservation.voucher && vm.lastReservation.path.indexOf(\'bills\') == 0 && !vm.lastReservation.listaEntradaUrl"><i class="fa fa-calendar"></i>&nbsp;Reagendar</button> <button title="Trocar Data" class="btn btn-lg btn-warning" ng-click="vm.trocarDatas(vm.lastReservation)" ng-if="vm.lastReservation.socio != \'true\' && vm.lastReservation.permiteTrocarDatas && vm.lastReservation.voucher && vm.lastReservation.path.indexOf(\'bills\') == 0 && !vm.lastReservation.listaEntradaUrl"><i class="fa fa-calendar"></i>&nbsp;Trocar Data</button> <button title="Agendar Datas" class="btn btn-lg btn-warning" ng-click="vm.agendarDatas(vm.lastReservation)" ng-if="vm.lastReservation.socio == \'true\' && vm.lastReservation.voucher && vm.lastReservation.path.indexOf(\'bills\') == 0 && !vm.lastReservation.listaEntradaUrl"><i class="fa fa-calendar"></i>&nbsp;Agendar Datas</button></div></div></uib-tab><uib-tab index="1" select="vm.page = \'reservation\'"><uib-tab-heading><i class="fa fa-bar-chart" aria-hidden="true"></i>Compras Anteriores</uib-tab-heading><div class="tab-conteudo list-compras"><div class="b2c-table-model-header"><div class="row"><div class="col-md-4 total form-group"><h3 title="Total {{vm.reservations.length}}">Total: {{vm.reservations.length}}</h3></div><div class="col-md-4 col-md-offset-4 form-group"><form tabindex="-1" name="formFilterPesquisar" role="form" id="formFilterPesquisar" class="form"><input type="text" tabindex="1" class="form-control" ng-model="vm.filterPesquisar" ng-model-options="{updateOn: \'default\', debounce: 500}" id="exampleInputAmount" placeholder="Pesquisar"> <button title="Buscar" class="btn btn-default"><i class="fa fa-search"></i></button></form></div></div></div><div class="table-responsive b2c-table-model"><table class="table table-hover table-striped"><thead><tr><th><button title="N\xFAmero" type="button" ng-click="vm.ordenarPor(\'numero\')"><i class="fa" ng-show="vm.orderByType === \'numero\'" ng-class="{\'fa-caret-down\': !vm.reverse, \'fa-caret-up\': vm.reverse}" aria-hidden="true"></i> N\xFAmero</button></th><th><button title="Per\xEDodo" type="button" ng-click="vm.ordenarPor(\'periodo\')"><i class="fa" ng-show="vm.orderByType === \'periodo\'" ng-class="{\'fa-caret-down\': !vm.reverse, \'fa-caret-up\': vm.reverse}" aria-hidden="true"></i> Per\xEDodo</button></th><th class="hidden-xs hidden-sm"><button title="Descritivo" type="button" ng-click="vm.ordenarPor(\'descritivo\')"><i class="fa" ng-show="vm.orderByType === \'descritivo\'" ng-class="{\'fa-caret-down\': !vm.reverse, \'fa-caret-up\': vm.reverse}" aria-hidden="true"></i> Descritivo</button></th><th><button title="Status" type="button" ng-click="vm.ordenarPor(\'status\')"><i class="fa" ng-show="vm.orderByType === \'status\'" ng-class="{\'fa-caret-down\': !vm.reverse, \'fa-caret-up\': vm.reverse}" aria-hidden="true"></i> Status</button></th><th class="hidden-xs hidden-sm"><button title="Valor" type="button" ng-click="vm.ordenarPor(\'valor\')"><i class="fa" ng-show="vm.orderByType === \'valor\'" ng-class="{\'fa-caret-down\': !vm.reverse, \'fa-caret-up\': vm.reverse}" aria-hidden="true"></i> Valor</button></th><th class="actions-shopping"><p>A\xE7\xF5es</p></th></tr></thead><tbody><tr ng-repeat="reservation in vm.reservations| filter:vm.filterPesquisar | limitTo:vm.limitArray | orderBy:vm.orderByType:vm.reverse"><td><p class="localizador {{::reservation.status}}">{{:: reservation.localizador || reservation.id}}</p></td><td><p>{{::reservation.periodo}}</p></td><td class="hidden-xs hidden-sm"><p><button title="Descritivo" uib-popover="{{::reservation.descritivo}}" popover-is-open="reservation.popoverIsOpen" ng-click="reservation.popoverIsOpen = !reservation.popoverIsOpen" type="button" class="btn btn-link">Descritivo</button></p></td><td><p>{{::reservation.status}}</p></td><td class="hidden-xs hidden-sm"><p>{{::reservation.valor / 100| currency:"R$ "}}</p></td><td class="actions-shopping"><a title="VOUCHER" class="btn btn-success btn-voucher" target="_blank" rel="noopener" href="{{::vm.setVoucherLink(reservation)}}" ng-if="reservation.voucher && !reservation.listaEntradaUrl"><i class="fa fa-print"></i> VOUCHER</a> <a title="VOUCHER" class="btn btn-success btn-voucher" target="_blank" rel="noopener" href="{{::reservation.listaEntradaUrl}}" ng-if="reservation.listaEntradaUrl"><i class="fa fa-photo"></i> Gerar Voucher </a><a title="Boleto" class="btn btn-danger" target="_blank" rel="noopener" href="{{vm.pdfAddress}}?method=boletoAsByte&id={{reservation.id}}&reservation=reservations/{{reservation.id}}&boleto={{reservation.boleto}}&token={{reservation.boletoToken}}" target="_self" ng-show="!reservation.voucher && reservation.boleto"><i class="fa fa-print"></i> Boleto</a> <a title="Pagar" class="btn btn-danger" target="_blank" rel="noopener" href="{{reservation.paymentUrl}}" target="_blank" ng-show="reservation.paymentUrl"><i class="fa fa-money"></i>Pagar</a> <button title="Reagendar" class="btn btn-warning" ng-click="vm.reAgendar(reservation)" ng-if="reservation.socio != \'true\' && reservation.permiteReagendamento && reservation.voucher && reservation.path.indexOf(\'bills\') == 0 && !reservation.listaEntradaUrl"><i class="fa fa-calendar"></i>&nbsp;Reagendar</button> <button title="Reagendar" class="btn btn-warning" ng-click="vm.reAgendarConta(reservation)" ng-if="reservation.socio != \'true\' && reservation.permiteReagendamentoConta && reservation.voucher && reservation.path.indexOf(\'bills\') == 0 && !reservation.listaEntradaUrl"><i class="fa fa-calendar"></i>&nbsp;Reagendar</button> <button title="Trocar Data" class="btn btn-warning" ng-click="vm.trocarDatas(reservation)" ng-if="reservation.socio != \'true\' && reservation.permiteTrocarDatas && reservation.voucher && reservation.path.indexOf(\'bills\') == 0 && !reservation.listaEntradaUrl"><i class="fa fa-calendar"></i>&nbsp;Trocar Data</button> <button title="Agendar Datas" class="btn btn-warning" ng-click="vm.agendarDatas(reservation)" ng-if="reservation.socio == \'true\' && reservation.voucher && reservation.path.indexOf(\'bills\') == 0 && !reservation.listaEntradaUrl"><i class="fa fa-calendar"></i>&nbsp;Agendar Datas</button> <button title="Cancelar Compra" class="btn btn-danger" ng-click="vm.cancel(reservation)" ng-if="reservation.userCanCancel==\'true\' || reservation.can_cancel"><i class="fa fa-close"></i>&nbsp;Cancelar</button></td></tr></tbody></table></div><div class="row table-tfoot b2c-checkin-footer"><div class="col-md-6 col-md-offset-3"><hr><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></div></div></uib-tab></uib-tabset></div></div></div><div ng-include=""></div></div>');
$templateCache.put('app/cupom/cupom.html','<div class="loja-cupom"><aside class="carrinho-flutuante animated slideInUp" ng-class="{\'carrinho-active\': vm.showCarrinho}" ng-hide="vm.step <= 1" style="display: none;"><div class="arrow"></div><div class="container"><div class="row"><button class="btn btn-default btn-carrinho-flutuante" ng-click="vm.showCarrinho = !vm.showCarrinho"><i class="fa fa-shopping-cart fa-2x"></i><div class="badge">{{vm.cart.length}}</div></button></div></div><div ng-show="vm.showCarrinho"><div class="carrinho-container col-xs-3 pull-right"><div class="row"><ul class="list-group col-xs-12"><li class="list-group-item row header-tabela-carrinho"><div class="col-xs-12"><h4 title="Carrinho de Compras" align="center">Carrinho de Compras <button class="btn btn-default pull-right btn-fechar-carrinho" ng-click="vm.showCarrinho = false"><i class="fa fa-times"></i></button></h4></div></li><li class="list-group-item row" ng-repeat="item in vm.cart"><div class="col-xs-7"><div><h5>{{item.shortName || item.name}}</h5></div></div><div class="col-xs-2"><h5>{{item.amount}}</h5></div><div class="col-xs-3"><div><h5>{{item.value > 0.01 ? (item.value / 100 | currency:\'R$ \') : ""}}</h5></div></div></li></ul><div class="col-xs-12"><h3 align="center">Subtotal: {{vm.totalGeral() / 100 | currency:\'R$ \'}}</h3></div></div></div></div></aside><section class="container-fluid" ng-show="vm.step == 1"><div class="row"><div class="container" id="step-1"><div class="row"><div class="col-xs-12 loja-titulo-principal"><h3 class="page-header" align="center"><i class="fa fa-exchange"></i>Troca de Cupons</h3></div></div><div class="row" style="text-align: center; margin: 0 0 2em 0;" ng-if="vm.couponAgencyPaths.length"><select name="\'coupon-path\'" id="coupon-path" aria-label="coupon-path" ng-options="path as path.label for path in vm.couponAgencyPaths" ng-model="couponAgency" ng-change="vm.setCouponAgencyPath(couponAgency)"><option value="" disabled="disabled" selected="selected">Selecione o parque</option></select></div><form tabindex="-1" name="formCupons" role="form" id="formCupons" class="row form"><div class="col-md-8 col-md-offset-2"><div class="row"><div class="form-group col-md-6 form-loja"><label for="quantidade">Quantidade de Cupons</label> <select tabindex="1" class="form-control" id="quantidade" ng-model="vm.qtdCupons" ng-options="a for a in vm.arr" ng-disabled="vm.disableForm()"></select></div><div class="form-group col-md-6 form-loja"><label for="data">Data de Utiliza\xE7\xE3o</label> <input tabindex="2" type="text" class="form-control" id="data" ng-model="vm.date" min-date="vm.today" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false,startingDay:0}" is-open="vm.activeDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" custom-class="vm.getDayClass(date, mode)" date-disabled="vm.disabledDate(date,mode)" ng-click="vm.activeDate = true" ng-disabled="vm.disableForm()"> <i class="inner-input fa fa-calendar"></i></div></div><div class="row"><div class="col-xs-12"><div class="row" ng-repeat="cupom in vm.cupons"><div class="form-group col-md-6 form-loja"><label for="code-{{$index}}">C\xF3digo</label> <input tabindex="3" type="text" class="form-control" ng-class="{\'input-danger\': cupom.errorMessage}" id="code-{{$index}}" ng-model="cupom.cod" ng-disabled="vm.disableForm()"></div><div class="form-group col-md-6 form-loja"><label for="key-{{$index}}">Chave</label> <input tabindex="4" type="text" class="form-control" ng-class="{\'input-danger\': cupom.errorMessage}" id="key-{{$index}}" ng-model="cupom.key" ng-disabled="vm.disableForm()"></div><div class="form-group col-xs-12" ng-show="cupom.errorMessage"><span class="text-danger"><i class="fa fa-times"></i> {{cupom.errorMessage}}</span></div></div></div></div></div><div class="col-xs-12 loja-footer-default"><div align="center"><button tabindex="5" title="Validar" type="button" class="btn btn-lg btn-info loja-btn" ng-click="vm.verifyCupons()" ng-hide="vm.isValidCupons" ng-disabled="vm.disableForm()"><i class="fa fa-check"></i> Validar</button><h4 class="text-success" ng-show="vm.isValidCupons"><i class="fa fa-check"></i> Cupons V\xE1lidos</h4></div></div></form></div></div></section><section class="container-fluid" ng-show="vm.step == 2"><div ng-include="\'app/cupom/templates/template-cross-sell.html\'"></div></section><section class="container-fluid" ng-show="vm.step == 3"><div class="row"><div class="container" id="step-3"><div class="row"><div class="col-xs-12 loja-header-default"><div class="row"><div class="col-xs-offset-3 col-xs-8 col-sm-offset-0 col-sm-4 col-md-offset-0 col-md-4 loja-div-voltar"><button title="Escolher Ingressos" class="btn btn-info btn-lg loja-btn loja-btn-voltar" ng-click="vm.backStep()"><i class="fa fa-arrow-left"></i>&nbsp;</button></div><div class="col-md-4 col-sm-12 col-xs-12"><h3 title="Resumo da Compra" align="center"><i class="fa fa-shopping-cart"></i> Resumo da Compra</h3></div></div></div><div class="col-xs-12"><ul class="list-group"><li class="list-group-item row header-tabela-carrinho"><div class="col-xs-12"><h4 title="Produtos no Carrinho" align="center">Produtos no Carrinho</h4></div></li><li class="list-group-item row header-tabela-carrinho"><div class="row"><div class="col-xs-8 col-sm-7"><h4 title="Produto">Produto</h4></div><div class="col-xs-4 col-sm-2"><h4 title="Quantidade">Quantidade</h4></div><div class="col-sm-3 hidden-xs"><h4 title="Valor">Valor</h4></div></div></li><li class="list-group-item row" ng-repeat="item in vm.cart"><div class="row"><div class="col-xs-8 col-sm-7"><h5>{{item.shortName || item.name}}</h5></div><div class="col-xs-4 col-sm-2"><h5>{{item.amount}}</h5></div><div class="col-sm-3 hidden-xs"><h5>{{item.value > 0.01 ? (item.value / 100 | currency:\'R$ \') : ""}}</h5></div></div></li></ul></div><div class="col-xs-12 loja-footer-default"><div class="col-md-4 col-md-offset-4 col-sm-offset-0 col-sm-3 col-xs-offset-3 col-xs-8"><h3 align="center" ng-if="vm.totalGeral() > 0.01">Total: {{vm.totalGeral() / 100 | currency:\'R$ \'}}</h3></div><div class="col-md-4 col-sm-6 col-xs-12"><button class="btn btn-lg btn-info loja-btn pull-right" ng-click="vm.nextStep(vm.step)">Continuar <i class="fa fa-arrow-right"></i></button></div></div></div></div></div></section><section class="container-fluid" ng-show="vm.step == 4"><div class="row"><div class="container" id="step-4"><div class="row"><div class="col-xs-12 loja-header-default"><div class="row"><div class="col-xs-offset-3 col-xs-8 col-sm-offset-0 col-sm-4 col-md-offset-0 col-md-4 loja-div-voltar"><button title="Escolher Ingressos" class="btn btn-info btn-lg loja-btn loja-btn-voltar" ng-click="vm.backStep()"><i class="fa fa-arrow-left"></i>&nbsp;</button></div><div class="col-md-4 col-sm-12 col-xs-12"><h3 title="Identifica\xE7\xE3o" align="center"><i class="fa fa-user"></i> Identifica\xE7\xE3o</h3></div></div></div></div><xs-login xs-complete="vm.finishLogin()"></xs-login></div></div></section><section class="container-fluid" ng-show="vm.step == 5"><div class="row"><div class="container" id="step-5"><div class="row"><div class="col-xs-12 loja-header-default"><div class="row"><div class="col-xs-offset-3 col-xs-8 col-sm-offset-0 col-sm-4 col-md-offset-0 col-md-4 loja-div-voltar"><button title="Escolher Ingressos" class="btn btn-info btn-lg loja-btn loja-btn-voltar" ng-click="vm.backStep()"><i class="fa fa-arrow-left"></i>&nbsp;</button></div><div class="col-md-4 col-sm-12 col-xs-12"><h3 title="Agora vamos concluir a compra" align="center">Agora vamos concluir a compra</h3></div></div></div><div class="row loja-col-pagamentos"><div class="col-md-6 loja-dados-comprador-ingressos"><div class="row header-col"><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div><div class="text col-xs-10 col-sm-10 col-md-12 col-lg-12"><i class="fa fa-user" aria-hidden="true"></i><h2 title="Dados do Comprador">Dados do Comprador</h2><hr class="hidden-xs hidden-sm"></div><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div></div><div class="border-right-md body-pag"><xs-register xs-complete="vm.finishLogin()" xs-has-registre-person="true" template-url="app/new_ingressos/models-pagamento/dados-user.html"></xs-register><div ng-include="\'app/new_ingressos/layouts/info-regras-compras-ingressos.html\'"></div></div></div><div class="col-md-6 loja-pagamento-ingressos"><div class="row header-col"><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div><div class="text col-xs-10 col-sm-10 col-md-12 col-lg-12"><i class="fa fa-money"></i><h2 title="Dados do Pagamento">Dados do Pagamento</h2><hr class="hidden-xs hidden-sm"></div><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div></div><div class="border-right-md body-pag"><br><form tabindex="-1" name="formCartao" role="form" id="formCartao" class="row form"><div class="col-md-5 col-md-offset-1" ng-if="vm.totalGeral() > 0"><div class="form-group form-loja"><label for="titularCartao">Nome do Titular</label> <input tabindex="9" type="text" class="form-control" id="titularCartao" autocomplete="off" ng-model="vm.paymentMethod.personName" ng-disabled="!vm.pagamento"></div><div class="form-group form-loja"><label for="titularCartao">CPF do Titular</label> <input tabindex="10" type="text" class="form-control" id="titularCartao" autocomplete="off" ng-model="vm.paymentMethod.personCpf" ui-mask="999.999.999-99" placeholder="CPF do Titular" ui-mask-placeholder ng-disabled="vm.paymentMethod.personName == null"></div><div class="form-group form-loja"><label for="numCartao">Numero do Cart\xE3o</label> <input tabindex="11" type="text" class="form-control" id="numCartao" autocomplete="off" ng-model="vm.paymentMethod.cardNumber" ui-mask="9999 9999 9999 9999? ?9?9?9" placeholder="N\xFAmero do Cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paymentMethod.personCpf == null"></div><div class="form-group form-loja"><label for="codeCartao">C\xF3digo do Cart\xE3o</label> <input tabindex="12" type="text" class="form-control" id="codeCartao" autocomplete="off" ng-model="vm.paymentMethod.code" ui-mask="999?9?9" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paymentMethod.cardNumber == null"></div></div><div class="col-md-5" ng-if="vm.totalGeral() > 0"><div class="form-group form-loja"><label for="bandeiraCartao">Bandeira do Cart\xE3o</label> <select tabindex="13" name="formapagto" id="bandeiraCartao" class="form-control" ng-model="vm.paymentMethod.type" ng-disabled="vm.paymentMethod.code == null"><option ng-show="vm.paymentMethods[\'amex\'] > 0" ng-disabled="!vm.paymentMethods[\'amex\']" ng-value="\'Amex\'">Amex</option><option ng-show="vm.paymentMethods[\'diners\'] > 0" ng-disabled="!vm.paymentMethods[\'diners\']" ng-value="\'Diners\'">Diners</option><option ng-show="vm.paymentMethods[\'mastercard\'] > 0" ng-disabled="!vm.paymentMethods[\'mastercard\']" ng-value="\'Mastercard\'">Mastercard</option><option ng-show="vm.paymentMethods[\'visa\'] > 0" ng-disabled="!vm.paymentMethods[\'visa\']" ng-value="\'Visa\'">Visa</option></select></div><div class="form-group form-loja"><label for="valCartao">Validade do Cart\xE3o</label> <input tabindex="14" type="text" class="form-control" id="valCartao" autocomplete="off" ng-model="vm.paymentMethod.goodThru" ui-mask="99/2099" ng-disabled="vm.paymentMethod.type == null"></div><div class="form-group form-loja"><label for="parcelasCartao">Quantidade de Parcelas</label> <select tabindex="15" class="form-control" id="parcelasCartao" ng-model="vm.paymentMethod.length" ng-options="vm.parcelas(n) group by \'Selecione\' for n in vm.financialLength()" ng-disabled="vm.paymentMethod.goodThru == null"></select></div></div></form><div class="col-md-12 col-sm-12 col-xs-12"><h3 align="center" title="Total: {{vm.totalGeral() / 100 | currency:\'R$ \'}}">Total: {{vm.totalGeral() / 100 | currency:\'R$ \'}}</h3></div><div class="col-md-12 col-sm-12 col-xs-12"><button tabindex="8" title="Finalizar Compra" class="btn btn-lg btn-info loja-btn center-block" ng-click="vm.createVoucher()" ng-disabled="vm.disableButton()"><i class="fa fa-check"></i> Finalizar Compra</button></div></div></div></div></div></div></div></section><section class="container-fluid" ng-show="vm.step == 6"><div class="row"><div class="container" id="step-6"><div class="row"><div class="col-xs-12"><h3 title="Imprima Seu Voucher" class="page-header" align="center">Imprima Seu Voucher</h3></div><div class="col-md-4 col-md-offset-4 loja-footer-default"><a title="Imprima Seu Voucher" class="btn btn-lg btn-info loja-btn center-block" target="_blank" rel="noopener" href="{{vm.voucherUrl}}">Imprima Seu Voucher</a></div></div></div></div></section></div>');
$templateCache.put('app/home/home.html','<div class="container-fluid"><div class="row"><div class="col-lg-12"><h2 class="page-header">Painel do Propriet\xE1rio</h2></div></div><div class="jumbotron text-center"><h2>Bem Vindo {{vm.user.name}}!</h2></div></div>');
$templateCache.put('app/ingressos/aux_ingressos.html','<main class="container"><div class="row"><div class="col-md-12"><xs-marcacao></xs-marcacao></div></div></main>');
$templateCache.put('app/ingressos/ingressos.html','<div class="container"><div class="body-ingressos"><div class="row breadcrumb loja-breadcumb" ng-hide="vm.step == \'selecionaData\' || vm.step == \'confirmacao\'"><div class="col-md-3 col-sm-3 col-xs-3"><div><span href="" ng-class="{\'loja-breadcumb-item-active\':vm.step == \'produtos\' || vm.step == \'selecionaData\',\'loja-breadcumb-item-checked\':vm.step != \'produtos\' && vm.step != \'selecionaData\'}"><p class="text-center"><i class="fa fa-3x" ng-class="{\'fa-circle\':vm.step == \'produtos\' || vm.step == \'selecionaData\',\'fa-check-circle-o\':vm.step != \'produtos\' || vm.step != \'selecionaData\'}"></i><br>1\xBA - Ingressos</p></span></div></div><div class="col-md-3 col-sm-3 col-xs-3"><div><span href="" ng-class="{\'loja-breadcumb-item\':vm.step == \'produtos\' || vm.step == \'selecionaData\',\'loja-breadcumb-item-active\':vm.step == \'carrinho\',\'loja-breadcumb-item-checked\':vm.step == \'identificacao\' || vm.step == \'pagamento\'}"><p class="text-center"><i class="fa fa-3x" ng-class="{\'fa-circle-o\':vm.step == \'produtos\' || vm.step == \'selecionaData\',\'fa-circle\':vm.step == \'carrinho\',\'fa-check-circle-o\':vm.step == \'identificacao\' || vm.step == \'pagamento\'}"></i><br>2\xBA - Carrinho</p></span></div></div><div class="col-md-3 col-sm-3 col-xs-3"><div><span href="" ng-class="{\'loja-breadcumb-item\':vm.step == \'produtos\' || vm.step == \'selecionaData\' || vm.step == \'carrinho\',\'loja-breadcumb-item-active\':vm.step == \'identificacao\',\'loja-breadcumb-item-checked\': vm.step == \'pagamento\'}"><p align="center"><i class="fa fa-3x" ng-class="{\'fa-circle-o\':vm.step == \'produtos\' || vm.step == \'selecionaData\' || vm.step == \'carrinho\',\'fa-circle\':vm.step == \'identificacao\',\'fa-check-circle-o\':vm.step == \'pagamento\'}"></i><br>3\xBA - <small>Identifica\xE7\xE3o</small></p></span></div></div><div class="col-md-3 col-sm-3 col-xs-3"><div><span href="" class="loja-breadcumb-item"><p align="center"><i class="fa fa-circle-o fa-3x"></i><br>4\xBA - Pagamento</p></span></div></div></div><div class="row select-tickets" ng-if="vm.step == \'selecionaData\'" id="step-0"><div class="col-md-12"><h3 title="Escolha um dia para nos visitar" class="page-header" align="center"><i class="fa fa-calendar-check-o"></i> Escolha um dia para nos visitar</h3><div ng-include="\'app/new_ingressos/layout-calendario.html\'"></div></div></div><div ng-init="vm.naoEscolheData ? vm.search(vm.date) : \'\'"></div><div class="row" ng-if="vm.step == \'produtos\'" id="step-1"><div class="col-md-12"><div class="row row-data-escolhida"><div class="col-md-12"><h3 title="Escolha os ingressos para o dia {{vm.formatedDate}}" class="page-header" align="center"><i class="fa fa-ticket"></i> Escolha os ingressos para o dia {{vm.formatedDate}} {{ vm.date | date:"dd/MM/yyyy" }}</h3></div></div><div class="row loja-header-ingressos"><div class="col-md-5 loja-div-voltar"><button title="Escolher outro dia" class="btn btn-info loja-btn-voltar btn-cliente" type="button" ng-click="vm.reset()"><i class="fa fa-arrow-left"></i>&nbsp; Escolher outro dia</button></div><div class="col-md-7"><h3 title="Nossos Produtos">Nossos Produtos</h3></div></div><div class="row row-loja-selecionar-outra-data" ng-show="vm.products == null || vm.products.length == 0"><div class="col-md-3"><button title="Selecione outra data" type="button" class="btn btn-primary btn-lg btn-loja-selecionar-outra-data" ng-click="vm.reset()"><i class="fa fa-arrow-lefth"></i> Selecione outra data.</button></div><div class="col-md-9"><h2 title="N\xE3o foram encontrados produtos para essa data" align="center">N\xE3o foram encontrados produtos para essa data</h2></div></div><div class="row"><div class="col-md-12"><div align="center"><div class="row loja-menu-ingressos" ng-hide="vm.categories.length <= 1 && vm.categories[0] == \'Outros\'"><button class="btn btn-primary btn-menu btn-justified btn-{{$index + 1}}" type="button" ng-class="{\'btn-active\': vm.indexIngressos == $index}" ng-click="vm.setMenuClass(category, $index)" ng-repeat="category in vm.categories">{{category}}</button></div><div class="row loja-painel-ingressos"><div class="col-md-12"><div class="row title hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" ng-if="vm.categories.length > 1"><span class="page-header {{vm.titleClass}}">{{vm.selectedCategory}}</span></div><div ng-include="\'app/ingressos/layout-ingresso.html\'"></div></div></div></div></div></div><div class="row"><div class="col-md-12 loja-footer-default"><div class="row"><div class="col-md-10 loja-div-voltar"><h3 title="{{vm.totalAmount | pluralize:\'Produto\'}} - Total">{{vm.totalAmount | pluralize:\'Produto\'}} - Total: {{vm.totalValue / 100 | currency:\'R$ \'}}</h3></div><div class="col-md-2"><button title="Ir para o Carrinho" class="btn btn-info pull-right loja-btn-avancar-carrinho btn-cliente" type="button" ng-click="vm.nextStep()" ng-hide="vm.cart.length <= 0">Ir para o Carrinho&nbsp; <i class="fa fa-arrow-right"></i></button></div></div></div></div></div></div><script type="text/ng-template" id="modal-content"><div class="modal-header">\n                <h3 class="modal-title">{{vm.product.shortName.length > 0 ? vm.product.shortName : vm.product.name}}</h3>\n            </div>\n            <div class="modal-body">\n                <p>\n                    <span ng-bind-html="vm.product.htmlMemo | toHtml"></span>\n                </p>\n            </div>\n            <div class="modal-footer">\n                <button class="btn btn-primary" type="button" ng-click="vm.close()">Fechar</button>\n            </div></script><div class="loja-balao-carrinho animated ripple" ng-class="{\'bounceInUp\':vm.cart.length > 0,\'bounceOutDown\':vm.cart.length <= 0 || vm.step != \'produtos\'}" ng-if="vm.cart.length > 0 && vm.step == \'produtos\'"><a href="" ng-click="vm.nextStep()"><p align="center"><i class="fa fa-shopping-cart fa-2x"></i> <span class="badge">{{vm.totalAmount}}</span></p></a></div><section class="row" ng-if="vm.step == \'carrinho\' || vm.step == \'extras\'" id="cart"><div id="extras" class="col-md-12" ng-if="vm.extraProducts.length > 0"><section class="row"><div class="col-md-12"><div class="row"><div class="col-xs-12 loja-header-default"><h3 title="Itens Adicionais" align="center"><i class="fa fa-hand-o-down"></i> Outros clientes tamb\xE9m viram estes produtos</h3></div></div><div class="row"><div ng-repeat="product in vm.extraProducts | filter : vm.filterExtras " ng-include="\'app/ingressos/layout-ingressos-extras.html\'"></div></div></div></section></div><div class="col-md-12"><div class="row"><div class="col-md-12 loja-header-default"><div class="row"><div class="col-xs-offset-3 col-xs-8 col-sm-offset-0 col-sm-4 col-md-offset-0 col-md-4 loja-div-voltar"><button title="Escolher Ingressos" class="btn btn-info loja-btn-voltar-ingressos btn-cliente" type="button" ng-click="vm.voltar()"><i class="fa fa-arrow-left"></i>&nbsp; Escolher Ingressos</button></div><div class="col-md-4 col-sm-12 col-xs-12"><h3 title="Ingressos ao Carrinho" align="center"><i class="fa fa-shopping-cart"></i> Ingressos ao Carrinho</h3></div></div></div></div><section class="b2c-cart-itens"><div class="row cart-header cart-row loja-header-tabela-carrinho"><div class="col-xs-4"><b>Passaporte(s)</b></div><div class="col-xs-4 padding-xs-left-0"><b>Quantidade</b></div><div class="col-xs-4 text-center hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><b>Valores</b></div><div class="col-xs-4 hidden-xs hidden-sm"><div class="row"><div class="col-md-4"><b>Valor Unit\xE1rio</b></div><div class="col-md-4"><b>Valor Total</b></div><div class="col-md-4"><b>...</b></div></div></div></div><div class="row cart-body"><div class="col-md-12"><div class="row cart-row" ng-class="{\'background-item\': $index % 2 == 0}" ng-repeat="item in vm.cart"><div class="col-xs-4"><h4 title="Valor">{{item.shortName.length > 0 ? item.shortName : item.name}} <small ng-if="item.isExtra">- (Produto Adicional)</small></h4><small>{{item.date | date:"dd/MM/yyyy"}}</small></div><div class="col-xs-4 padding-xs-0"><button title="Retirar" class="btn btn-mini btn-info btn-cart btn-cliente-car" type="button" ng-click="vm.removeItemInCart(item)" ng-disabled="item.amount <= item.minAmount"><i class="fa fa-minus"></i></button> <button title="Quantidade" class="btn btn-mini btn-default btn-cart"><b>{{item.amount}}</b></button> <button title="Adicionar" class="btn btn-mini btn-info btn-cart btn-cliente-car" type="button" ng-click="vm.addItemInCart(item)"><i class="fa fa-plus"></i></button><div style="margin:1rem;font-size:1rem;" ng-if="item.minAmount > 1">Quantidade m\xEDnima: {{ item.minAmount }}</div></div><div class="col-xs-4 padding-xs-left-0"><div class="row"><div class="col-md-4"><strong><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Uni.: </span>{{item.value / 100| currency:\'R$ \'}}</strong></div><div class="col-md-4"><strong><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Tot.: </span>{{(item.amount * item.value) / 100 | currency:\'R$ \'}}</strong></div><div class="col-md-4"><button title="Remover produto" class="btn btn-danger loja-btn-excluir" type="button" ng-click="vm.removeItemFromCart($index, item)"><i class="fa fa-trash"></i></button></div></div></div></div></div></div><div class="row cart-footer background-item"><div class="col-md-6"><div class="row"><div class="col-md-6 col-sm-8"><input type="text" class="form-control" placeholder="Cupom de Desconto" ng-model="vm.cupomCodKey"></div><div class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl hidden-sm col-xs-12"><br></div><div class="col-md-6 col-sm-4"><button title="Validar Cupom" class="btn btn-info hidden-xs btn-block loja-btn-cupom btn-cliente-car" type="button" ng-click="vm.validCupom()" ng-disabled="vm.cupomCodKey.length < 5"><i class="fa fa-check"></i> Validar Cupom</button> <button title="Validar Cupom" class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl hidden-sm btn btn-info btn-block loja-btn-cupom" type="button" ng-click="vm.validCupom()" ng-disabled="vm.cupomCodKey.length < 5"><i class="fa fa-check"></i> Validar Cupom</button></div><div class="col-md-12 col-sm-12"><br></div><div class="col-md-6 loja-btn-outra-data-col" ng-hide="vm.naoEscolheData"><button title="Escolher outra data" class="btn btn-info btn-block loja-btn-outra-data btn-cliente-car" type="button" ng-click="vm.reset()"><i class="fa fa-calendar"></i> Escolher outra data</button></div><div class="col-md-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" ng-hide="vm.naoEscolheData"><br></div><div class="col-md-6"><button title="Limpar Carrinho" class="btn btn-info btn-block loja-btn-limpar-carrinho btn-cliente-car" type="button" ng-click="vm.clearCart()"><i class="fa fa-eraser"></i> Limpar Carrinho</button></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-12"><h3 title="Total" class="pull-right">Total: {{vm.totalValue / 100| currency:\'R$ \'}}</h3></div></div><div class="row"><div class="col-md-6 pull-right"><button title="Comprar" class="btn btn-success btn-block loja-btn-comprar" type="button" ng-click="vm.initialPurchase()" ng-disable="vm.cart.length == 0"><i class="fa fa-shopping-cart"></i>&nbsp;&nbsp;Comprar</button></div></div></div><div class="col-xs-12 loja-carrinho-detalhes"></div></div></section></div></section><div class="row" ng-if="vm.step == \'identificacao\'" id="identificacao"><div class="col-md-12"><div class="row"><div class="col-md-12 loja-header-default"><div class="row"><div class="col-xs-offset-3 col-xs-8 col-sm-offset-0 col-sm-4 col-md-offset-0 col-md-4 loja-div-voltar"><button title="Voltar ao Carrinho" class="btn btn-info loja-btn-voltar-carrinho btn-cliente" ng-click="vm.voltar()"><i class="fa fa-arrow-left"></i>&nbsp; Voltar ao Carrinho</button></div><div class="col-md-4 col-sm-12 col-xs-12"><h3 title="Informe seus dados" align="center">Informe seus dados</h3></div></div></div></div><xs-login xs-complete="vm.nextStep()"></xs-login></div></div><section class="row" ng-if="vm.step == \'pagamento\'" id="pagamento"><div class="col-md-12"><div class="row"><div class="col-md-12 loja-header-default"><div class="row"><div class="col-xs-offset-3 col-xs-8 col-sm-offset-0 col-sm-4 col-md-offset-0 col-md-4 loja-div-voltar"><button title="Voltar ao Cadastro" class="btn btn-info loja-btn-voltar-cadastro btn-cliente" ng-click="vm.voltar()"><i class="fa fa-arrow-left"></i>&nbsp; Voltar ao Cadastro</button></div><div class="col-md-4 col-sm-12 col-xs-12"><div class="row"><h3 title="Pagamento" align="center">Pagamento</h3></div></div></div></div></div><xs-payment xs-custom-prices="vm.customPrices" xs-change="vm.isFinalStep()" xs-products="vm.cart" xs-cupom="vm.getCupom()" xs-total-value="vm.totalValue" xs-complete="vm.endPurchase"></xs-payment></div></section></div></div>');
$templateCache.put('app/ingressos/layout-calendario.html','<div class="row content-bordered content-pesquisa content-pesquisa-ingressos" ng-show="vm.step == \'selecionaData\'"><div class="col-md-2 col-md-offset-2 col-sm-4"><h4 title="Data de Utiliza\xE7\xE3o dos ingressos">Data de Utiliza\xE7\xE3o</h4></div><div class="col-md-4 col-sm-4"><div class="input-group hidden-xs"><input type="text" class="form-control" ng-model="vm.date" min-date="vm.today" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false,startingDay:0}" is-open="vm.activeDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-click="vm.activeDate = true"> <span class="input-group-addon"><a ng-click="vm.handleDate()"><i class="fa fa-calendar"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block" ng-click="vm.openDatePickerModal(vm.date)">{{vm.date | date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar"></i></button></div><div class="col-xs-12 visible-xs-block"><br></div><div class="col-md-2 col-sm-2"><button title="Buscar Ingressos" class="btn btn-info btn-block btn-cliente btn-scala" ng-click="vm.search(vm.date)"><i class="fa fa-search"></i>&nbsp; Pesquisar</button></div><div class="col-xs-12 visible-xs-block"><br></div><div class="col-md-2 col-sm-2"><button title="{{!vm.tarifario ? \'Ver Tarif\xE1rio\' : \'Ocultar Tarif\xE1rio\'}}" class="ripple btn btn-info btn-block loja-btn-tarifario btn-cliente hidden" ng-click="vm.tarifario = !vm.tarifario">{{!vm.tarifario ? \'Ver Tarif\xE1rio\' : \'Ocultar Tarif\xE1rio\'}} <i class="fa" ng-class="{\'fa-angle-down\':!vm.tarifario,\'fa-angle-up\':vm.tarifario}"></i></button></div><div class="col-md-12"><br></div><div ng-show="vm.tarifario"><div class="row"><div class="col-md-12"></div></div><div class="row"><div class="col-md-12"><img title="Imagem do Tarif\xE1rio" alt="Imagem do Tarif\xE1rio" class="img-responsive img-rounded center-block" src="assets/images/imagem-tarifario.jpg"></div></div></div></div>');
$templateCache.put('app/ingressos/layout-ingresso.html','<div class="row content-bordered content-ingressos" ng-repeat="product in vm.productsByCategory[vm.selectedCategory] track by $index"><div class="col-md-3 col-sm-3"><img title="{{product.name}}" alt="{{product.name}}" ng-src="{{product.image}}" class="img-responsive center-block"></div><div class="col-md-6 col-sm-6"><div class="row titulo-ingressos"><div class="col-md-12"><span class="text-primary"><b>{{product.shortName.length > 0 ? product.shortName : product.name}}</b></span> &nbsp; {{product.years}}</div></div><div class="row"><div class="col-md-12"><div class="descricao-ingresso"><div class="descricao-ingresso-texto">{{product.memo| ellipsis:350}}<p ng-bind-html="product.htmlMemo | toHtml"></p></div><button title="Ver mais" class="btn btn-info btn-open-ingresso-info" ng-click="vm.openInfo(product)" ng-if="product.memo.length > 400 || product.htmlMemo != null">Ver mais <i class="fa fa-plus"></i></button></div></div></div></div><div class="col-md-3 col-sm-3"><div class="row"><div class="col-md-12 col-xs-12 titulo-ingressos valor-atual"><span class="pull-right text-primary h3">{{(product.amount > 0 ? product.value * product.amount : product.value) / 100 | currency:\'R$ \'}} </span><span class="pull-left text-primary valor-antigo" ng-if="product.oldValue"><strike>De {{product.oldValue / 100| currency:\'R$ \'}} por</strike> &nbsp;</span></div></div><div class="row"><div class="col-md-5 col-sm-4 col-xs-5"><button title="Retirar" class="btn btn-info btn-block btn-sm btn-cart center-block btn-cliente" ng-click="vm.removeItem(product)"><i class="fa fa-minus"></i></button></div><div class="col-md-2 col-sm-4 col-xs-2"><h4 title="{{product.amount}}" align="center">{{product.amount}}</h4></div><div class="col-md-5 col-sm-4 col-xs-5"><button title="Adicionar" class="btn btn-info btn-block btn-sm btn-cart center-block btn-cliente" ng-click="vm.addItem(product)"><i class="fa fa-plus"></i></button></div></div><div class="row" style="margin-bottom: 12px;"><div class="col-xs-12"><button title="Adicionar ao Carrinho" class="btn btn-info btn-block btn-sm btn-cliente" ng-click="vm.addToCart(product)" ng-disabled="product.amount < 1 || product.loading || (product.amount < product.minAmount )"><i class="fa fa-spinner fa-spin" ng-show="product.loading"></i> {{ !product.loading ? \'Adicionar ao Carrinho\' : \'Adicionando...\'}}</button><div class="min-amount-cart-alert" style="margin:.5rem 0 0 0;color:#a15302;" ng-if="product.amount < product.minAmount && product.minAmount > 1 && product.amount > 0">Quantidade m\xEDnima: {{ product.minAmount }}</div></div></div></div></div>');
$templateCache.put('app/ingressos/layout-ingressos-extras.html','<div class="col-md-3 col-sm-6"><div class="col-xs-12"><div class="row card-ingressos-extras-top"><img title="{{product.shortName.length > 0 ? product.shortName : product.name}}" alt="{{product.shortName.length > 0 ? product.shortName : product.name}}" class="img-responsive" ng-src="{{product.image}}"><div class="titulo-ingressos-extras">{{product.shortName.length > 0 ? product.shortName : product.name}}</div></div><div class="row descricao-ingressos-extras"><div class="col-xs-4"><button title="Mais detalhes" class="btn btn-info" type="button" ng-click="vm.openInfo(product)"><i class="fa fa-info-circle"></i> Detalhes</button></div><div class="col-xs-8"><span class="text-primary">{{product.value / 100| currency:\'R$ \'}}</span></div></div><div class="row descricao-ingressos-extras card-ingressos-extras-bottom"><div class="col-xs-12"><button title="Adicionar ao carrinho" class="btn btn-info btn-block ripple" type="button" ng-click="vm.addExtraProduct(product)">Adicionar ao carrinho <i class="fa fa-spinner fa-spin hidden" ng-show="product.loading"></i></button></div></div></div></div>');
$templateCache.put('app/login/login.html','<main class="container loja-main"><section id="reservation-form" class="row loja-box-float loja-login"><div class="col-xs-12 loja-login-card loja-box-float-card"><xs-login xs-complete="vm.complete()" template-url="app/components/xsLogin/xsLogin.html"></xs-login></div></section><xs-paid-button></xs-paid-button></main>');
$templateCache.put('app/main/main.html','<div id="wrapper"><header></header><div id="page-wrapper" style="min-height: 561px; padding-bottom: 20px;"><div ui-view></div></div></div>');
$templateCache.put('app/pagamentogrupo/pagamentogrupo.html','<div class="container b2c-dados-compra"><div class="grupos pagar-conta"><div class="row" ng-hide="vm.isPaid"><div ng-if="!vm.esconderDetalhesPagamentoGrupo" class="col-xs-12"><h3 title="Dados da Compra" class="page-header" align="center">Dados da Compra</h3></div><div class="col-xs-12"><ul ng-if="!vm.esconderDetalhesPagamentoGrupo" class="list-group pagar-gurpo-detalhes"><li class="list-group-item background-item hidden-sm hidden-xs row"><div class="col-md-1 reserva"><strong>Reserva</strong></div><div class="col-md-1 valor"><strong>Valor do pagamento</strong></div><div class="col-md-3 hospedagem-info"><strong>Titular da Hospedagem</strong></div><div class="col-md-1"><strong>Pens\xE3o</strong></div><div class="col-md-2"><strong>Apartamento</strong></div><div class="col-md-2"><strong>Hotel</strong></div><div class="col-md-1"><strong>Per\xEDodo</strong></div><div class="col-md-1"><strong>Pessoas</strong></div></li><li class="list-group-item row" ng-repeat="reservation in vm.paid.reservations"><div class="col-md-1 reserva"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Reserva</span> <strong>{{ reservation.reservationId }}</strong></div><div class="col-md-1 valor"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Valor do pagamento</span> <strong>{{ reservation.value / 100 | currency:\'R$ \' }}</strong></div><div class="col-md-3 hospedagem-value"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Titular da Hospedagem</span> <strong>{{ reservation.responsibleName }}</strong></div><div class="col-md-1"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Pens\xE3o</span> <strong class="ng-binding">{{ reservation.meal}}</strong></div><div class="col-md-2"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Apartamento</span> <strong class="ng-binding">{{ reservation.uh }}</strong></div><div class="col-md-2"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Hotel</span> <strong class="ng-binding">{{ reservation.hotel }}</strong></div><div class="col-md-1"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Per\xEDodo</span> <strong class="ng-binding">{{ reservation.timespan }}</strong></div><div class="col-md-1"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Pessoas</span> <strong class="ng-binding">{{ vm.formatTravelersAmount(reservation.travelersAmount) }}</strong></div></li><li class="list-group-item row"><div class="col-md-4"><strong>Valor Total:</strong></div><div class="col-md-4"><p><strong class="ng-binding">{{(vm.paid.groupValue == 0 ? 0 : vm.paid.groupValue/100) | currency:\'R$ \'}}</strong></p></div></li></ul><div class="col-md-4" ng-if="vm.paid.groupValue"><div class="checkbox"><label><input type="checkbox" id="termos" ng-model="vm.aceitoTerms"> <strong><a target="_blank" rel="noopener" href="docs/termosdecompra.html">Li e aceito os termos e politicas e condi\xE7\xF5es de compra</a></strong></label></div></div></div><div class="col-xs-12 loja-separador"></div><section ng-show="vm.aceitoTerms"><div class="col-xs-12"><h3 title="Dados do Pagamento" class="page-header" align="center">Dados do Pagamento</h3></div><div class="col-xs-12"><h4 title="Selecione a sua bandeira">Selecione a sua bandeira:</h4></div><div class="col-xs-12 col-md-offset-1 col-md-10"><div class="row"><div class="col-md-2 col-sm-4 col-xs-6" ng-repeat="brand in vm.brands"><div class="checkbox"><label><input type="checkbox" ng-click="vm.selectPaidType(brand)" ng-model="vm.brands[$index].active"> <img ng-src="assets/images/logos/{{brand.name.toLowerCase()}}.png" class="img img-responsive" alt="{{brand.name}}" ng-click="vm.selectPaidType(brand)"></label></div></div></div></div><div class="col-xs-12"><form class="row form"><div class="col-md-10 col-md-offset-1"><div ng-if="vm.showPaymentCardAddress" ng-include="\'app/components/xsPayment/payment_card_address.html\'"></div></div><div class="col-md-5 col-md-offset-1"><div class="form-group form-loja"><label for="titularCartao">Informe o Nome Completo do Titular</label> <input type="text" class="form-control" id="titularCartao" placeholder="Informe o Nome Completo do Titular" autocomplete="off" ng-model="vm.paid.customer" ng-disabled="vm.paid.cardType == null"></div><div class="form-group form-loja"><label for="numCartao">N\xFAmero do Cart\xE3o</label> <input type="text" class="form-control" id="numCartao" autocomplete="off" ng-model="vm.paid.cardNumber" ui-mask="9999 9999 9999 99?9?9? ?9?9?9" placeholder="N\xFAmero do Cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paid.cardType == null" ng-keyup="vm.verificaBandeiraCartao()"></div><div class="form-group form-loja"><label for="codeCartao">C\xF3digo do Cart\xE3o</label> <input type="text" class="form-control" id="codeCartao" autocomplete="off" ng-model="vm.paid.securityCode" ui-mask="999?9?9" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paid.cardType == null"></div></div><div class="col-md-5"><div class="form-group form-loja"><label for="valCartao">Data de Validade do Cart\xE3o</label> <input type="text" class="form-control" id="valCartao" autocomplete="off" ng-model="vm.paid.goodThru" ui-mask="99/2099" ng-disabled="vm.paid.cardType == null"></div><div class="form-group form-loja" ng-if="vm.canEditValue"><label for="valorCartao">Valor a pagar</label><div class="input-group" ng-if="!vm.isEditValue"><input type="text" class="form-control" id="valorCartao" autocomplete="off" value="{{vm.paid.value /100 | currency: \'R$ \'}}" disabled="disabled"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-if="!vm.isEditValue" ng-click="vm.newValue = \'\'; vm.isEditValue=true"><i class="fa fa-pencil"></i></button></span></div><div class="input-group" ng-if="vm.isEditValue"><input type="text" class="form-control" id="valorCartao" autocomplete="off" ng-model="vm.newValue" ng-enter="vm.checkEditValue()" placeholder="Valor m\xE1ximo {{vm.unPaidValue / 100| currency:\'R$ \'}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-if="vm.isEditValue" ng-click="vm.checkEditValue()"><i class="fa fa-check"></i></button></span></div></div><div class="form-group form-loja"><label for="parcelasCartao"></label> <select class="form-control" id="parcelasCartao" ng-model="vm.paid.count" ng-options="vm.parcelas(i) group by \'Selecione\' for i in vm.arrParcelas" ng-disabled="vm.paid.cardType == null"></select></div></div></form></div><div class="col-xs-12 loja-footer-default"><div class="col-md-offset-1 col-md-2 col-sm-offset-0 col-sm-3 col-xs-offset-3 col-xs-8"><strong>Total: {{vm.paid.value / 100 | currency:\'R$ \'}}</strong></div><div class="col-md-6 col-sm-6 col-xs-12"><button title="Efetuar o Pagamento" class="btn btn-sm btn-info center-block" ng-click="vm.doSubmit()"><i class="fa fa-check"></i> Efetuar Pagamento</button></div></div></section></div><div class="row result-pagamento-reserva" id="pagar-conta2" ng-show="vm.isPaid"><div class="col-md-12"><div class="info row"><div class="info col-xs-12"><h3 title="Pagamento Efetuado Com Sucesso!" class="page-header" align="center">Pagamento Efetuado Com Sucesso!</h3><div class="col-md-4 col-md-offset-4"><a class="btn btn-info btn-block" href="{{vm.printLink}}" target="_blank" ng-if="vm.printLink">Ver comprovante</a></div></div></div></div></div></div></div>');
$templateCache.put('app/pagamentoreserva/botaovoucher.html','<div class="row function" ng-if="vm.pdfAddress"><div class="col-xs-12 col-sm-12 col-md-offset-3 col-md-6 col-lg-offset-3 col-lg-6"><a title="Imprimir Voucher" href="{{vm.pdfAddress}}?method=receiptAsByte&receipt={{vm.voucherId}}&token={{vm.voucherToken}}" class="btn btn-sm btn-info center-block" target="_blank" rel="noopener"><i class="fa fa-print"></i> Imprimir Voucher</a></div></div>');
$templateCache.put('app/pagamentoreserva/detalhes.html','<h4 title="Detalhes" class="page-header" align="center">Detalhes</h4><ul class="list-group"><li class="list-group-item background-item hidden-sm hidden-xs row"><div class="col-md-2"><strong>Per\xEDodo</strong></div><div ng-show="vm.paid.uh"><div class="col-md-2"><strong>Pens\xE3o</strong></div><div class="col-md-3"><strong>Hotel</strong></div><div class="col-md-3"><strong>Apartamento</strong></div></div><div ng-hide="vm.paid.uh"><div class="col-md-8"><strong>Itens</strong></div></div><div class="col-md-2"><strong>Pessoas</strong></div></li><li class="list-group-item row"><div class="col-md-2"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Per\xEDodo</span> <strong>{{vm.paid.timespan}}</strong></div><div ng-show="vm.paid.uh"><div class="col-md-2"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Pens\xE3o</span> <strong>{{vm.paid.pensao}}</strong></div><div class="col-md-3"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Hotel</span> <strong>{{vm.paid.hotelName}}</strong></div><div class="col-md-3"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Apartamento</span> <strong>{{vm.paid.uh}}</strong></div></div><div ng-hide="vm.paid.uh"><div class="col-md-8"><strong>{{ vm.paid.items === \'Tarifa Adicionais\' && vm.paid.itemsAdditionals ? vm.formatFlightText() : vm.paid.items }}</strong></div></div><div class="col-md-2"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Pessoas</span> <strong>{{vm.normalizePaxes()}}</strong></div></li><li class="list-group-item row"><div class="col-md-4"><strong>Valor Total:</strong></div><div class="col-md-4"><p><strong>{{vm.paid.reservationValue / 100| currency:\'R$ \'}}</strong></p></div></li></ul><h4 title="Ingressos Inclusos" class="page-header" align="center" ng-if="vm.produtos">Ingressos Inclusos</h4><ul class="list-group" ng-if="vm.produtos"><li class="list-group-item background-item hidden-sm hidden-xs row"><div class="col-md-12"><strong>Qdt. e Nome dos Ingresso</strong></div></li><li class="list-group-item row"><div class="col-md-12"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Qdt. e Nome dos Ingresso: </span><strong>{{vm.produtos}}</strong></div></li><li class="list-group-item row"><div class="col-md-4"><strong>Valor total dos ingressos:</strong></div><div class="col-md-4"><p><strong>{{vm.produtosValue / 100| currency:\'R$ \'}}</strong></p></div></li></ul>');
$templateCache.put('app/pagamentoreserva/pagamentoreserva.html','<div ng-include="\'app/pagamentoreserva/pagarReservaComponent.html\'"></div>');
$templateCache.put('app/pagamentoreserva/pagarReservaComponent.html','<div class="container b2c-dados-compra"><div class="row" id="pagar-conta" ng-if="!vm.isPaid"><div class="col-xs-12 col-md-10 col-md-offset-1"><h3 title="Dados da Compra" class="page-header" align="center">Dados da Compra<br>{{vm.paid.hotelName}}</h3></div><div class="col-xs-12 col-md-10 col-md-offset-1" ng-if="vm.paid.agency"><h4>Vendido por: {{vm.paid.agency}}</h4></div><div class="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"><ul class="list-group"><li class="list-group-item background-item hidden-sm hidden-xs row"><div class="col-md-2 codigo"><strong>C\xF3digo</strong></div><div class="col-md-3 valor"><strong>Valor do pagamento</strong></div><div class="col-md-7 hospedagem-info"><strong>Titular da Hospedagem</strong></div></li><li class="list-group-item row"><div class="col-md-2 codigo"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">C\xF3digo</span> <strong>{{vm.paid.reservationId}}</strong></div><div class="col-md-3 valor"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Valor do pagamento</span> <strong>{{vm.paid.value / 100| currency:\'R$ \'}}</strong></div><div class="col-md-7 hospedagem-value"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Titular da Hospedagem</span> <strong>{{vm.paid.responsibleName}}</strong></div></li></ul><div ng-include="\'app/pagamentoreserva/detalhes.html\'"></div><div class="col-md-4"><div class="checkbox"><label><input type="checkbox" id="termos" ng-model="vm.aceitoTerms"> <strong><a target="_blank" rel="noopener" href="docs/termosdecompra.html">Li e aceito os termos e politicas e condi\xE7\xF5es de compra</a></strong></label></div></div></div><div class="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2 loja-separador"></div><div ng-if="vm.aceitoTerms" class="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"><div class="row"><div class="col-xs-12"><h3 title="Dados do Pagamento" class="page-header" align="center">Dados do Pagamento</h3></div><div class="col-xs-12"><h4 class="page-header"></h4></div><div class="col-xs-12"><h4 title="Selecione a sua bandeira:">Selecione a sua bandeira:</h4></div><div class="col-xs-12 col-md-offset-1 col-md-10"><div class="row"><div class="col-md-2 col-sm-4 col-xs-6" ng-repeat="brand in vm.brands"><div class="checkbox"><label><input type="checkbox" ng-click="vm.selectPaidType(brand)" ng-model="vm.brands[$index].active"><br><img ng-src="assets/images/logos/{{brand.name.toLowerCase()}}.png" alt="" ng-click="vm.selectPaidType(brand)"></label></div></div></div></div><div class="col-xs-12 col-md-offset-1 col-md-10"><form name="formCartao" class="form"><div class="row"><div class="col-md-12" ng-if="vm.showPaymentCardAddress"><div ng-include="\'app/components/xsPayment/payment_card_address.html\'"></div></div><div class="col-md-6"><div class="form-group form-loja"><label for="numCartao">N\xFAmero do Cart\xE3o</label> <input type="text" class="form-control" id="numCartao" autocomplete="off" ng-model="vm.paid.cardNumber" ui-mask="9999 9999 9999 99?9?9? ?9?9?9" placeholder="N\xFAmero do Cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" ng-keyup="vm.verificaBandeiraCartao()" required></div><div class="form-group form-loja"><label for="titularCartao">Informe o Nome Completo do Titular</label> <input type="text" class="form-control" id="titularCartao" placeholder="Informe o Nome Completo do Titular" autocomplete="off" ng-model="vm.paid.customer" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="codeCartao">C\xF3digo do Cart\xE3o</label> <input type="text" class="form-control" id="codeCartao" autocomplete="off" ng-model="vm.paid.securityCode" ui-mask="999?9?9" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paid.cardType == null" required></div></div><div class="col-md-6"><div class="form-group form-loja" ng-if="!vm.noRequiredCpf"><label for="valCartao">CPF do Titular</label> <input type="text" class="form-control" id="cpftitular" ng-model="vm.paid.personCpf" ui-mask="999.999.999-99" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="valCartao">Data de Validade do Cart\xE3o</label> <input type="text" class="form-control" id="valCartao" autocomplete="off" ng-model="vm.paid.goodThru" ui-mask="99/2099" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="parcelasCartao">Quantidade de Parcelas</label> <select class="form-control" id="parcelasCartao" ng-model="vm.paid.count" ng-options="vm.parcelas(i) group by \'Selecione\' for i in vm.arrParcelas" ng-disabled="vm.paid.cardType == null" required></select></div></div></div></form></div><div class="col-xs-12 col-md-offset-1 col-md-10 loja-footer-default"><div ng-if="vm.paid.recurring !== \'true\' || !vm.paid.recurring" class="col-md-offset-0 col-md-6 col-sm-offset-0 col-sm-6 col-xs-offset-1 col-xs-8"><strong>Total: <span class="value-total">{{vm.getTotalPriceWithAdjustments(vm.paid.cardType, vm.paid.count || 1) | currency:\'R$ \'}} {{vm.hasDiscount()}}</span><br><p ng-if="vm.paid.count">Parcelado em <span style="color: forestgreen; font-size: 20px;">{{vm.parcelas(vm.paid.count)}}</span></p><p ng-if="!vm.paid.count">Selecione a quantidade de parcelas.</p></strong></div><div ng-if="vm.paid.recurring === \'true\'" class="col-md-offset-0 col-md-6 col-sm-offset-0 col-sm-6 col-xs-offset-1 col-xs-8"><strong>O valor de <span class="value-total">{{vm.getTotalPriceWithAdjustments(vm.paid.cardType, vm.paid.count || 1) | currency:\'R$ \'}}</span><br><p ng-if="vm.paid.count">Parcelado em <span style="color: forestgreen; font-size: 20px;">{{vm.parcelas(vm.paid.count)}}</span></p><p ng-if="!vm.paid.count">Selecione a quantidade de parcelas.</p></strong></div><div class="col-md-6 col-sm-6 col-xs-12"><button title="Efetuar Pagamento" class="btn btn-sm btn-info center-block" ng-click="vm.doSubmit()" ng-disabled="formCartao.$invalid"><i class="fa fa-check"></i> Efetuar Pagamento</button></div></div></div></div></div><div class="row result-pagamento-reserva" id="pagar-conta2" ng-if="vm.isPaid"><div class="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"><div class="info row"><div class="info col-xs-12"><h3 title="Pagamento Efetuado Com Sucesso!" class="page-header" align="center">Pagamento Efetuado Com Sucesso!</h3></div></div><div ng-include="\'app/pagamentoreserva/botaovoucher.html\'"></div></div></div></div>');
$templateCache.put('app/pagarconta/pagarconta.html','<div class="container" ng-if="vm.isLinkValid"><div class="row"><div class="col-xs-12 col-lg-10 col-lg-offset-1"><div class="row" id="pagar-conta" ng-hide="vm.isPaid"><div class="col-xs-12"><h3 title="Dados da Compra" class="page-header" align="center">Dados da Compra</h3></div><div class="col-xs-12"><ul class="list-group"><li class="list-group-item background-item hidden-sm hidden-xs row"><div class="col-md-1"><strong>C\xF3digo</strong></div><div class="col-md-2 text-centro-pagar-conta"><strong>Valor do Pagamento</strong></div><div class="col-md-2"><strong>Total da Conta</strong></div><div class="col-md-5"><strong>Itens da Conta</strong></div><div class="col-md-2"><strong>Data In\xEDcial</strong></div></li><li class="list-group-item row"><div class="col-md-1"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">C\xF3digo</span> <strong>{{vm.paid.id}}</strong></div><div class="col-md-2 text-centro-pagar-conta"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Valor do Pagamento</span> <strong>{{vm.paid.value / 100| currency:\'R$ \'}}</strong></div><div class="col-md-2"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Total da Conta</span> <strong>{{vm.paid.total / 100| currency:\'R$ \'}}</strong></div><div class="col-md-5"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Itens da Conta</span><span ng-init="produtosArray = vm.paid.produtos.split(\',\')"></span> <strong><span ng-repeat="produto in produtosArray">{{produto}}<br></span></strong></div><div class="col-md-2">{{vm.paid.date| date :\'dd/MM/yyyy\'}}</div></li></ul><div class="col-md-12"><div class="checkbox"><label><input type="checkbox" id="termos" ng-model="vm.aceitoTerms"> <strong>Li e aceito os</strong></label> <a title="Ver termos de uso" class="btn-link" target="_blank" rel="nofollow noopener noreferrer" href="docs/termosdecompra.html"><strong>termos e condi\xE7\xF5es de compra.</strong></a></div></div></div><div class="col-xs-12 loja-separador"></div><section ng-if="vm.aceitoTerms"><div class="col-xs-12"><h3 title="Dados de Pagamento" class="page-header" align="center">Dados de Pagamento</h3></div><div class="col-xs-12"><h4 title="Selecione a sua bandeira:">Selecione a forma de pagamento:</h4></div><div class="col-xs-12"><div class="row"><div class="col-xs-12"><div class="col-md-2 col-sm-4 col-xs-6" ng-repeat="brand in vm.brands"><div class="checkbox"><label><input type="checkbox" ng-click="vm.selectPaidType(brand)" ng-model="brand.active"><br><img ng-src="assets/images/logos/{{brand.name.toLowerCase()}}-2.png" alt="" ng-click="vm.selectPaidType(brand)"><div class="recorrente" ng-if="vm.paid.recurring == \'true\' && brand.name.toLowerCase() !== \'pix\'">Recorrente</div><div class="recorrente" ng-if="vm.hasDiscount(brand.name)">{{vm.hasDiscount({brand: brand.name})}}</div></label></div></div></div></div></div><div ng-if="vm.paid.cardType && vm.paid.cardType != \'pix\'"><div class="col-xs-12"><form name="formCartao" class="row form"><div class="col-md-10 col-md-offset-1"><div ng-if="vm.showPaymentCardAddress" ng-include="\'app/components/xsPayment/payment_card_address.html\'"></div></div><div class="col-md-5 col-md-offset-1"><div class="form-group form-loja"><label for="titularCartao">Informe o Nome Completo do Titular</label> <input type="text" class="form-control" id="titularCartao" placeholder="Ex.: Nome Sobrenome" autocomplete="off" ng-model="vm.paid.customer" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="numCartao">N\xFAmero do Cart\xE3o</label> <input type="text" class="form-control" id="numCartao" autocomplete="off" ng-model="vm.paid.cardNumber" ng-keyup="vm.verificaBandeiraCartao()" ui-mask="9999 9999 9999 99?9?9? ?9?9?9" placeholder="N\xFAmero do Cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="codeCartao">C\xF3digo do Cart\xE3o</label> <input type="text" class="form-control" id="codeCartao" autocomplete="off" ng-model="vm.paid.securityCode" ui-mask="999?9?9" placeholder="Codigo de Seguran\xE7a" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paid.cardType == null" required></div></div><div class="col-md-5"><div class="form-group form-loja" ng-if="!vm.noRequiredCpf"><label for="valCartao">CPF do Titular</label> <input type="text" class="form-control" id="cpftitular" ng-model="vm.paid.personCpf" ui-mask="999.999.999-99" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="valCartao">Data de Validade do Cart\xE3o</label> <input type="text" class="form-control" id="valCartao" autocomplete="off" ng-model="vm.paid.goodThru" ui-mask="99/2099" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="parcelasCartao">Quantidade de Parcelas</label> <select class="form-control" id="parcelasCartao" ng-model="vm.paid.count" ng-options="vm.parcelas(i) group by \'Selecione\' for i in vm.arrParcelas" ng-disabled="vm.paid.cardType == null" required></select></div></div></form></div><div class="col-xs-12 loja-footer-default"><div ng-if="vm.paid.recurring !== \'true\' || !vm.paid.recurring" class="col-md-offset-0 col-md-6 col-sm-offset-0 col-sm-6 col-xs-offset-1 col-xs-8"><strong>Total: <span class="value-total">{{vm.getTotalPriceWithAdjustments(vm.paid.cardType, vm.paid.count || 1) | currency:\'R$ \'}} {{vm.hasDiscount()}}</span><br><p ng-if="vm.paid.count">Parcelado em <span style="color: forestgreen; font-size: 20px;">{{vm.parcelas(vm.paid.count)}}</span></p><p ng-if="!vm.paid.count">Selecione a quantidade de parcelas.</p></strong></div><div ng-if="vm.paid.recurring === \'true\'" class="col-md-offset-0 col-md-6 col-sm-offset-0 col-sm-6 col-xs-offset-1 col-xs-8"><strong>O valor de <span class="value-total">{{vm.getTotalPriceWithAdjustments(vm.paid.cardType, vm.paid.count || 1) | currency:\'R$ \'}}</span><br><p ng-if="vm.paid.count">Parcelado em <span style="color: forestgreen; font-size: 20px;">{{vm.parcelas(vm.paid.count)}}</span></p><p ng-if="!vm.paid.count">Selecione a quantidade de parcelas.</p></strong></div><div class="col-md-6 col-sm-6 col-xs-12"><button title="Efetuar o Pagamento" class="btn btn-sm btn-info center-block" ng-click="vm.doSubmit()" ng-disabled="formCartao.$invalid"><i class="fa fa-check"></i> Efetuar o Pagamento</button></div></div></div><div class="col-xs-12" ng-if="vm.paid.cardType && vm.paid.cardType == \'pix\'"><div class="row"><h3 class="col-md-offset-2 col-md-8 col-xs-12">Clique no bot\xE3o abaixo para gerar o QRCode para pagamento via pix</h3><div ng-if="!vm.forceHideCpfPix" class="col-md-offset-4 col-md-4 col-xs-12" align="center"><div class="form-group form-loja"><label for="valCartao">CPF do Titular</label> <input type="text" class="form-control" id="cpftitular" ng-model="vm.paid.personCpf" ui-mask="999.999.999-99" ng-disabled="vm.paid.cardType == null" required></div></div><div class="col-xs-12 loja-footer-default"><div ng-if="vm.paid.recurring !== \'true\' || !vm.paid.recurring" class="col-md-offset-0 col-md-6 col-sm-offset-0 col-sm-6 col-xs-offset-1 col-xs-8"><strong>Total: <span class="value-total">{{vm.getTotalPriceWithAdjustments(vm.paid.cardType, vm.paid.count || 1) | currency:\'R$ \'}} {{vm.hasDiscount()}}</span></strong></div><div ng-if="vm.paid.recurring === \'true\'" class="col-md-offset-0 col-md-6 col-sm-offset-0 col-sm-6 col-xs-offset-1 col-xs-8"><strong>O valor de <span class="value-total">{{vm.getTotalPriceWithAdjustments(vm.paid.cardType, vm.paid.count || 1) | currency:\'R$ \'}} {{vm.hasDiscount()}}</span></strong></div><div class="col-md-6 col-sm-6 col-xs-12"><button title="Gerar QRCode" class="btn btn-sm btn-info center-block" ng-click="vm.createWebGateway()"><i class="fa fa-check"></i> Gerar QRCode</button></div></div></div></div></section></div><div class="row result-pagamento-conta" id="pagar-conta2" ng-show="vm.isPaid"><div class="col-md-12 col-lg-10 col-lg-offset-1"><div class="info row"><div class="info col-xs-12"><h3 title="Pagamento Efetuado Com Sucesso!" class="page-header" align="center">Pagamento Efetuado Com Sucesso!</h3></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-offset-3 col-md-6 col-lg-offset-3 col-lg-6" ng-if="vm.voucher.token"><a title="Imprimir Voucher" href="{{vm.pdfAddress}}?method=receiptAsByte&id={{vm.billId}}&receipt={{vm.voucherId}}&token={{vm.voucher.token}}&loc={{vm.voucher.locator}}" class="btn btn-sm btn-info center-block" target="_blank" rel="noopener" rel="noopener"><i class="fa fa-print"></i> Imprimir Voucher</a></div></div></div></div></div></div></div>');
$templateCache.put('app/prepagamento/prepagamento.html','<div class="container"><div class="row" id="pagar-conta" ng-hide="vm.isPaid"><div class="col-xs-12"><h3 title="Dados Pre Pagamento" class="page-header" align="center">Dados Pre Pagamento</h3></div><div class="col-xs-12"><ul class="list-group"><li class="list-group-item background-item hidden-sm hidden-xs row"><div class="col-md-2"><strong>C\xF3digo</strong></div><div class="col-md-3"><strong>Valor do pagamento</strong></div><div class="col-md-3"><strong>Quantidade Parcelas</strong></div><div class="col-md-4"><strong>Informa\xE7\xF5es</strong></div></li><li class="list-group-item row"><div class="col-md-2"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">C\xF3digo</span> <strong>{{vm.paid.id}}</strong></div><div class="col-md-3"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Valor do pagamento</span> <strong>{{vm.paid.value / 100| currency:\'R$ \'}}</strong></div><div class="col-md-3"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Quantidade Parcelas</span> <strong>{{vm.paid.count}}</strong></div><div class="col-md-4"><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Informa\xE7\xF5es</span> <strong>{{vm.paid.memo}}</strong></div></li></ul><div class="col-md-12"><div class="checkbox"><label><input type="checkbox" id="termos" ng-model="vm.aceitoTerms"> <strong>Li e aceito os</strong></label> <a title="Ver termos de uso" class="btn-link" target="_blank" rel="nofollow noopener noreferrer" href="docs/termosdecompra.html"><strong>termos e condi\xE7\xF5es de compra.</strong></a></div></div></div><div class="col-xs-12 loja-separador"></div><section ng-show="vm.aceitoTerms"><div class="col-xs-12"><h3 title="Dados de Pagamento" class="page-header" align="center">Dados de Pagamento</h3></div><div class="col-xs-12"><h4 title="Selecione a sua bandeira:">Selecione a sua bandeira:</h4></div><div class="col-xs-12"><div class="row"><div class="col-md-1"></div><div class="col-md-2 col-sm-4 col-xs-6" ng-repeat="brand in vm.brands"><div class="checkbox"><label><input type="checkbox" ng-click="vm.selectPaidType(brand)" ng-model="brand.active"><br><img ng-src="assets/images/logos/{{brand.name.toLowerCase()}}-2.png" alt="" ng-click="vm.selectPaidType(brand)"></label></div></div></div></div><div class="col-xs-12"><form name="formCartao" class="row form"><div class="col-md-5 col-md-offset-1"><div class="form-group form-loja"><label for="titularCartao">Nome completo do Titular</label> <input type="text" class="form-control" id="titularCartao" placeholder="Ex.: Nome Sobrenome" autocomplete="off" ng-model="vm.paid.customer" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="numCartao">N\xFAmero do Cart\xE3o</label> <input type="text" class="form-control" id="numCartao" autocomplete="off" ng-model="vm.paid.cardNumber" ng-keyup="vm.verificaBandeiraCartao()" ui-mask="9999 9999 9999 99?9?9? ?9?9?9" placeholder="N\xFAmero do Cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="codeCartao">C\xF3digo do Cart\xE3o</label> <input type="text" class="form-control" id="codeCartao" autocomplete="off" ng-model="vm.paid.securityCode" ui-mask="999?9?9" placeholder="Codigo de Seguran\xE7a" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paid.cardType == null" required></div></div><div class="col-md-5"><div class="form-group form-loja" ng-if="!vm.noRequiredCpf"><label for="valCartao">CPF do Titular</label> <input type="text" class="form-control" id="cpftitular" ng-model="vm.paid.personCpf" ui-mask="999.999.999-99" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="valCartao">Validade do Cart\xE3o</label> <input type="text" class="form-control" id="valCartao" autocomplete="off" ng-model="vm.paid.goodThru" ui-mask="99/2099" ng-disabled="vm.paid.cardType == null" required></div><div class="form-group form-loja"><label for="parcelasCartao">Quantidade de Parcelas</label> <select class="form-control" id="parcelasCartao" ng-model="vm.paid.count" ng-options="vm.parcelas(i) group by \'Selecione\' for i in vm.arrParcelas" ng-disabled="vm.paid.cardType == null" required></select></div></div></form></div><div class="col-xs-12 loja-footer-default"><div class="col-md-offset-1 col-md-2 col-sm-offset-0 col-sm-3 col-xs-offset-3 col-xs-8"><strong>Total: {{vm.paid.value / 100| currency:\'R$ \'}}</strong></div><div class="col-md-6 col-sm-6 col-xs-12"><button title="Efetuar o Pagamento" class="btn btn-sm btn-info center-block" ng-click="vm.doSubmit()" ng-disabled="formCartao.$invalid"><i class="fa fa-check"></i> Efetuar o Pagamento</button></div></div></section></div><div class="row result-pagamento-conta" id="pagar-conta2" ng-show="vm.isPaid"><div class="col-md-12"><div class="info row"><div class="info col-xs-12"><h3 title="Pagamento Efetuado Com Sucesso!" class="page-header" align="center">Pagamento Efetuado Com Sucesso!</h3></div></div></div></div></div>');
$templateCache.put('app/produtos/produtos.html','<section class="rooms mt50" id="step0"><div class="container"><div class="row"><div class="col-sm-12"><h2 class="lined-heading"><span>1. Escolha a quantidade de pessoas e validade</span></h2></div><div class="container"><div class="col-sm-6"><div class="form-group"><label for="pessoas" class="col-sm-3" control-label>Qtd. Pessoas</label><div class="col-sm-9"><select name="pessoas" id="pessoas" class="form-control" ng-model="search.persons"><option value=""></option><option ng-value="\'1 pessoa\'" ng-selected="true">1 Pessoa</option><option ng-value="2">2 Pessoas</option><option ng-value="3">3 Pessoas</option><option ng-value="4">4 Pessoas</option><option ng-value="5">5 Pessoas</option><option ng-value="6">6 Pessoas</option><option ng-value="7">7 Pessoas</option><option ng-value="8">8 Pessoas</option><option ng-value="9">9 Pessoas</option><option ng-value="10">10 Pessoas</option></select></div></div></div><div class="col-sm-6"><div class="form-group"><label for="anos" class="col-sm-3" control-label>Validade</label><div class="col-sm-9"><select name="anos" id="anos" class="form-control" ng-model="search.years"><option value=""></option><option ng-value="\'1 ANO\'">1 Ano</option><option ng-value="\'3 ANOS\'">3 Anos</option><option ng-value="\'5 ANOS\'">5 Anos</option></select></div></div></div></div></div></div></section><section class="rooms mt50"><div class="container" id="step1" bookmark-offset="90"><div class="row"><div class="col-sm-12"><h2 class="lined-heading"><span>2. Escolha abaixo seus Passaportes.</span></h2></div><div class="col-sm-12" ng-show="!showWait && produtos.length==0"><h2 class="lined-heading"><span>N\xE3o encontramos nenhuma op\xE7\xE3o para esse parque na data escolhida.<br>Por favor tente uma nova data.</span></h2></div><style></style><div class="col-sm-12" style="padding-top:30px; padding-bottom: 30px;"><div ng-repeat="produto in produtos | filter:search:strict" class="slide-down" ng-animate="{enter: \'ng-enter\',leave: \'ng-leave\', move: \'ng-leave\'}" ng-include="\'passaporte.html\'" ng-class="{\'div-destaque\': ($index +1) / 3 == 0}"></div></div></div></div></section><section class="rooms mt50" ng-show="step>=2"><div class="container" id="step2" bookmark-offset="90"><div class="row"><div class="col-sm-12"><h2 class="lined-heading"><span>Falta pouco, agora \xE9 s\xF3 finalizar</span></h2></div><section id="reservation-form"><div class="col-sm-12 col-md-4"><form class="reservation-vertical clearfix" role="form" method="post" action="#" name="reservationform" id="reservationform"><h2 class="lined-heading"><span>Resumo da compra</span></h2><div class="price-tre"><h4>{{productName(produtoSelecionado)}}</h4><br>{{ produtoSelecionado.amount}} <span>{{ pluralize(\'unidade\', produtoSelecionado.amount) }} </span>&nbsp; {{(produtoSelecionado.value * produtoSelecionado.amount) / 100 | currency:\'R$ \' }}</div><div class="price-two"><h4>TOTAL GERAL</h4><br><span ng-show="totalComCupom"><strike>{{totalGeralSemDesconto() / 100 | currency: \'R$ \'}} </strike></span>{{totalGeral() / 100 | currency: \'R$ \'}} <span>{{quantidadeTotal}} unidade(s)</span></div><div ng-include="\'passaportetermos.html\'"></div><br><input name="concordo" type="checkbox" id="concordo" class="form-control-static" ng-model="aceitoTerms"><span style="font-size:12px; font-weight: bold;">Li e aceito os termos e politicas e condi\xE7\xF5es de compra.</span> <button type="button" class="btn btn-block btn-success" ng-click="showLoginForm=true; showNewUserForm=false; step=3;trackTerms();" scroll-to-bookmark="step3" ng-disabled="!aceitoTerms">SOU CLIENTE</button> <button type="button" class="btn btn-block btn-info" ng-click="showLoginForm=false; showNewUserForm=true; step=3;trackTerms();" scroll-to-bookmark="step3" ng-disabled="!aceitoTerms">N\xC3O SOU CLIENTE</button> <span class="col-md-4 hidden-md hidden-sm"></span><span class="alert-warning pull-right" ng-hide="aceitoTerms">Voc\xEA ainda n\xE3o aceitou os termos.</span>&nbsp;<div><span>&nbsp;</span><div class="col-md-12" ng-include="\'waitBar.html\'" ng-show="showWait"></div></div></form></div></section><section id="reservation-form" ng-show="step>=3"><div class="col-sm-12 col-md-4" id="step3" bookmark-offset="90"><form class="reservation-vertical clearfix" role="form" name="reservationform" id="reservationform" ng-show="showNewUserForm"><h2 class="lined-heading"><span>N\xE3o sou cliente</span></h2><div class="form-group"><label for="email" accesskey="E">E-mail</label> <input name="email" type="email" id="email" class="form-control" placeholder="Preencha com um e-mail" ng-model="user.email"></div><div class="form-group"><label for="password" accesskey="E">Senha</label> <input name="password" type="password" id="password" class="form-control" placeholder="Crie uma senha" ng-model="user.password"></div><div class="form-group"><label for="password2" accesskey="E">Confirme a senha</label> <input name="password" type="password" id="password2" class="form-control" placeholder="Confirme a senha" ng-model="password"></div><div class="form-group"><label for="nome" accesskey="E">Nome completo</label> <input name="nome" type="text" id="nome" class="form-control" placeholder="Digite o seu nome" ng-model="user.name"></div><div class="form-group"><label for="cpf" accesskey="E">CPF</label> <input name="cpf" type="text" id="cpf" class="form-control" ng-model="user.cpf" ui-mask="999.999.999-99" placeholder="Digite o seu CPF" ui-mask-placeholder></div><div class="form-group"><label for="nasc" accesskey="E">Data de Nascimento</label> <input name="nasc" type="text" id="nasc" class="form-control" ng-model="user.birth" ui-mask="99/99/9999" placeholder="DD/MM/AAAA" ui-mask-placeholder></div><div class="form-group"><label for="celular" accesskey="E">Celular</label> <input name="celular" type="text" id="celular" class="form-control" ng-model="user.cellPhone" ui-mask="(99) 9 9999-9999" autocomplete="tel" placeholder="(DDD) 0 0000-0000" ui-mask-placeholder></div><div class="form-group"><label for="telefone" accesskey="E">Telefone</label> <input name="telefone" type="text" id="telefone" class="form-control" ng-model="user.homePhone" ui-mask="(99) 9999-9999" autocomplete="tel" placeholder="(DDD) 0000-0000" ui-mask-placeholder></div><div class="form-group"><label for="sexo" accesskey="E">Sexo</label> <select id="sexo" class="form-control" ng-model="user.gender"><option value="M">Masculino</option><option value="F">Feminino</option></select></div><div class="form-group"><label for="cep" accesskey="E">Cep</label><div class="input-group"><input name="cep" type="text" id="cep" class="form-control" ng-model="user.zipCode" ui-mask="99999-999" ng-enter="findCep()"> <span class="btn btn-default input-group-btn" ng-click="findCep()"><i class="fa fa-search"></i></span></div></div><div class="form-group"><label for="rua" accesskey="E">Endere\xE7o</label> <input name="rua" type="text" id="rua" class="form-control" placeholder="Avenida/Rua" ng-model="user.street0"></div><div class="form-group"><label for="complemento" accesskey="E">Complemento</label> <input name="complemento" type="text" id="complemento" class="form-control" placeholder="Complemento" ng-model="user.address2"></div><div class="form-group"><label for="bairro" accesskey="E">Bairro</label> <input name="bairro" type="text" id="bairro" class="form-control" placeholder="Bairro" ng-model="user.street1"></div><div class="form-group"><label for="numero" accesskey="E">N\xFAmero</label> <input name="numero" type="text" id="numero" class="form-control" placeholder="00" ng-model="user.number"></div><div class="form-group"><label for="cidade" accesskey="E">Cidade</label> <input name="cidade" type="text" id="cidade" class="form-control" placeholder="Cidade" ng-model="user.city"></div><div class="form-group"><label for="estado" accesskey="E">Estado</label> <input name="estado" type="text" id="estado" maxlength="2" size="2" class="form-control" placeholder="UF" ng-model="user.state"></div><button type="button" class="btn btn-primary btn-block" ng-click="savePerson()">Confirmar <i class="fa fa-arrow-down"></i></button><div><span>&nbsp;</span><div class="col-md-12" ng-include="\'waitBar.html\'" ng-show="showWait"></div></div></form><form class="reservation-vertical clearfix" role="form" name="reservationform" id="reservationform" ng-show="showLoginForm"><h2 class="lined-heading"><span>Sou cliente</span></h2><div class="form-group"><label for="email" accesskey="E">E-mail</label> <input name="email" type="email" id="email" class="form-control" placeholder="Preencha com um e-mail" ng-model="email"></div><div class="form-group"><label for="password" accesskey="E">Senha</label> <input name="password" type="password" id="password" class="form-control" placeholder="Crie uma senha" ng-model="password" ng-enter="login()"></div><button type="button" class="btn btn-primary btn-block btn-info" ng-click="login();">Confirmar <i class="fa fa-arrow-down"></i></button> <button type="button" class="btn-link" ng-click="forgetPass()">Esqueci a senha</button><div><span>&nbsp;</span><div class="col-md-12" ng-include="\'waitBar.html\'" ng-show="showWait"></div></div></form><form class="reservation-vertical clearfix" role="form" name="reservationform" id="reservationform" ng-show="showClienteLogado"><h2 class="lined-heading"><span>Cliente</span></h2><div class="form-group"><label for="password" accesskey="E">Nome</label> <input name="password" type="text" id="name2" class="form-control" ng-model="user.name" disabled="disabled"></div><div class="form-group"><label for="email" accesskey="E">E-mail</label> <input name="email" type="email" id="email2" class="form-control" ng-model="user.email" disabled="disabled"></div></form></div></section><script language="Javascript">//<!--\n    function isNumberKey(evt)\n    {\n        var charCode = (evt.which) ? evt.which : event.keyCode\n        if (charCode > 31 && (charCode < 48 || charCode > 57))\n            return false;\n\n        return true;\n    }\n    // --></script><section id="reservation-form"><div id="step4" bookmark-offset="90"><div class="col-sm-12 col-md-4" ng-show="step>=4"><form class="reservation-vertical clearfix" role="form" name="reservationform" id="reservationform"><h2 class="lined-heading"><span>Pagamento</span></h2><div class="form-group"><label for="formapagto">Forma de Pagamento</label><div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="Cart\xE3o de cr\xE9dito"><i class="fa fa-info-circle fa-lg"></i></div><select name="formapagto" id="formapagto" class="form-control" ng-model="paymentMethod.type"><option ng-show="paymentMethods[\'boleto\'] > 0" ng-disabled="!paymentMethods[\'boleto\']" ng-value="\'Boleto\'">Boleto</option><option ng-show="paymentMethods[\'paypal\'] > 0" ng-disabled="!paymentMethods[\'paypal\']" ng-value="\'PayPal\'">PayPal</option><option ng-show="paymentMethods[\'amex\'] > 0" ng-disabled="!paymentMethods[\'amex\']" ng-value="\'Amex\'">Amex</option><option ng-show="paymentMethods[\'diners\'] > 0" ng-disabled="!paymentMethods[\'diners\']" ng-value="\'Diners\'">Diners</option><option ng-show="paymentMethods[\'mastercard\'] > 0" ng-disabled="!paymentMethods[\'mastercard\']" ng-value="\'Mastercard\'">Mastercard</option><option ng-show="paymentMethods[\'visa\'] > 0" ng-disabled="!paymentMethods[\'visa\']" ng-value="\'Visa\'">Visa</option></select></div><div class="form-group"><label for="parcelas">Qtd. Parcelas</label><div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right"></div><select name="parcelas" id="parcelas" class="form-control" ng-model="paymentMethod.length" ng-options="parcelas(n) group by \'Selecione\' for n in financialLength()"></select></div><div class="Paypal" ng-show="paymentMethod.type==\'PayPal\'"><p>A compra ser\xE1 conclu\xEDda apenas ap\xF3s o PayPal aprovar o pagamento.</p></div><div class="Boleto" ng-show="paymentMethod.type==\'Boleto\'"><p>A compra ser\xE1 conclu\xEDda apenas ap\xF3s o pagamento do boleto.</p></div><div class="Deposito" ng-show="paymentMethod.type==\'Deposito\'"><p>A compra ser\xE1 conclu\xEDda apenas ap\xF3s o a verifica\xE7\xE3o do d\xE9posito.</p></div><div class="credicard" ng-hide="paymentMethod.type==\'Boleto\' || paymentMethod.type==\'PayPal\'"><div class="form-group"><label for="numbercard" accesskey="E">N\xFAmero do Cart\xE3o</label><div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="Somente n\xFAmeros"><i class="fa fa-info-circle fa-lg"></i></div><input name="numbercard" type="text" id="numbercard" class="form-control" placeholder="____ ____ ____ ____" ng-model="paymentMethod.cardNumber" onkeypress="return isNumberKey(event)"></div><div class="form-group"><label for="secureCode" accesskey="E">C\xF3d. Seguran\xE7a</label><div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="3 \xFAltimos d\xEDgitos no verso do cart\xE3o"><i class="fa fa-info-circle fa-lg"></i></div><input name="secureCode" type="text" id="secureCode" class="form-control" placeholder="___" ng-model="paymentMethod.code" onkeypress="return isNumberKey(event)"></div><div class="form-group"><label for="validade" accesskey="E">Validade</label> <input name="validade" type="text" id="validade" ng-model="paymentMethod.goodThru" ui-mask="99/2099" class="form-control" placeholder="MM/AA"></div><div class="form-group"><label for="nometitular" accesskey="E">Nome T\xEDtular</label> <input name="nometitular" type="text" id="nometitular" class="form-control" placeholder="Conforme impresso no cart\xE3o" ng-model="paymentMethod.personName"></div><div class="form-group"><label for="cpftitular" accesskey="E">CPF T\xEDtular</label> <input name="cpftitular" type="text" id="cpftitular" class="form-control" ui-mask="999.999.999-99" placeholder="CPF T\xEDtular do cart\xE3o" ui-mask-placeholder ng-model="paymentMethod.personCpf"></div></div><button type="button" class="btn btn-primary btn-block" ng-click="comprar()" ng-disabled="showWait">Finalizar Compra <i class="fa fa-arrow-right"></i></button><div><span>&nbsp;</span><div class="col-md-12" ng-include="\'waitBar.html\'" ng-show="showWait"></div></div></form></div></div></section></div></div></section><script type="text/ng-template" id="passaporte.html"><!-- template Produto -->\n    <div class="col-md-4">\n        <img src="{{produto.image}}" class="img-responsive" />\n        <div class="room-thumb" style="width: 100%;">\n            <div class="main">\n                <h5>{{productName(produto)}}</h5>\n                <div class="price">R$ {{produto.value / 100 | currency:""}}<span>{{produto.years}}</span></div>\n            </div>\n            <div class="col-sm-12" style="padding-top: 10px;" ng-bind-html-unsafe="produto.htmlMemo"></div>\n            <div class="col-sm-12 text-right" style="bottom: 10px; position: absolute;">\n                <button type="button" class="btn btn-info btn-block" ng-click="selectProduto(produto)">comprar</button>\n            </div>\n        </div>\n    </div>\n    <!-- FIM template Produto --></script>');
$templateCache.put('app/promocao/promocao.html','<section class="container loading-oferta"><div class="row"><figure class="col-md-4 col-md-offset-1"><img title="Esperando o pr\xF3ximo passo" alt="Esperando o pr\xF3ximo passo" class="img-responsive" ng-src="assets/gifs/casal-esperando.gif"></figure><aside class="col-md-6"><h3 title="Oba! Estamos preparando sua viagem!">Oba! Estamos preparando sua viagem!</h3><h4 title="Por favor aguarde um momentinho...">Por favor aguarde um momentinho...</h4><h5 title="Carregando a oferta"><i class="fa fa-spinner fa-w-16 fa-spin fa-lg" aria-hidden="true"></i></h5></aside></div></section>');
$templateCache.put('app/promocoes/promocoes.html','<div class="container" ng-show="vm.promocoes.length > 0"><div class="row"><div class="col-md-12"><h2 title="Pacotes e Promo\xE7\xF5es">Pacotes e Promo\xE7\xF5es</h2></div><div class="col-md-12 text-center"><h4 title="Selecione o m\xEAs desejado">Selecione o m\xEAs desejado</h4></div></div><div class="row row-meses"><button class="col-xs-3 col-sm-3 col-md-1 col-lg-1 btn time-05 hover-zuum ripple btn-default col-mes" ng-repeat="date in vm.dates" ng-click="vm.toogleMonth(date)" ng-class="{\'active\': vm.mesEscolhido == date}" ng-disabled="!vm.hasPromocao(date)"><h3 title="Selecionar per\xEDodo: {{date| date:\'MMMM\'| capitalize}} - {{date| date:\'yyyy\'}}">{{date| date: \'MMM\'| capitalize}} <small>{{date| date:\'yyyy\' }}</small></h3><i class="fa fa-check" ng-if="vm.mesEscolhido == date"></i></button></div><div class="mansory row" ng-repeat="l in vm.promocoesGroup"><div class="col-md-3 padding-top-25" ng-repeat="p in l" ng-hide="p.erro"><div class="card card-inverse card-info"><img title="{{::p.promoCall}}" alt="Imagem Ilustrativa: {{::p.promoCall}}" class="card-img-top img-responsive" ng-src="{{vm.picture(p)}}" ng-click="vm.modalGaleria(p)"><div class="card-img-modal"><button title="Abrir Galeria de Imagens" class="btn btn-default" ng-click="vm.modalGaleria(p)"><i class="fa fa-image fa-2x"></i></button></div><div class="card-block"><figure class="profile"><img title="{{::p.promoCall}}" alt="Imagem Ilustrativa: {{::p.promoCall}}" class="profile-avatar" src="assets/images/logos/logo-cliente.png"></figure><h4 title="{{p.promoCall}}" class="card-title mt-3">{{p.promoCall}}</h4><div class="meta card-text"><h5 class="memo" ng-if="p.memo" ng-bind-html="p.memo"></h5><h4 title="{{p.hotel}}" ng-click="vm.openModalMaisDetalhesHotel(hotel)">{{::p.hotel}}</h4><h5 title="De {{::p._checkin | date:\'dd/MM\' }} a {{::p.checkout}}">De {{::p._checkin | date:"dd/MM" }} a {{::p.checkout}}</h5><h5 title="{{::p.uh}}" ng-click="vm.openModalMaisDetalhesHotel(hotel)">{{::p.uh}}</h5><div class="row"><div class="col-xs-12" ng-class="{\'col-xs-7\': p.item.oldValue && p.item.oldValue != p.item.value}" ng-if="p.meal"><p><i class="fa fa-check"></i>&nbsp;{{p.meal}}</p></div></div><div class="row" ng-if="p.item.allIncluded.length > 0 || p.item.included.length > 0"><div class="col-xs-12"><button type="button" class="btn btn-xs btn-link pull-right" ng-click="p._showIncluded = !!!p._showIncluded"><i class="fa" ng-class="{\'fa-arrow-up\': p._showIncluded, \'fa-arrow-down\': !p._showIncluded}"></i>&nbsp;inclusos</button></div></div><div class="row" ng-if="p._showIncluded"><div class="col-xs-12" ng-repeat="included in p.item.allIncluded"><i class="fa fa-check"></i>&nbsp;{{included.service}}</div><div class="col-xs-12" ng-repeat="included in p.item.included"><i class="fa fa-check"></i>&nbsp;{{included.service}}</div></div><div class="row"><div class="col-xs-12"><button title="{{p.travelersAmount}}" class="btn-default btn" ng-click="vm.openModalCountAdultosCriancas(p)">{{p.travelersAmount}} <i class="fa fa-edit"></i></button></div></div><div class="row"><div class="col-xs-12" ng-hide="p.item"><span>...</span></div><div class="col-xs-12" ng-if="!p.item.unavailable && p.item.value"><div class="pull-right"><span class="priceOld"><small><del ng-if="p.item.oldValue && p.item.oldValue != p.item.value">de {{p.item.oldValue / 100| currency: "R$ "}}</del> &nbsp;</small> </span><span class="price"><small ng-show="p.item.oldValue && p.item.oldValue != p.item.value">por</small> {{p.item.value / 100| currency: "R$ "}}</span></div></div></div></div></div><div class="card-footer"><div class="row"><div class="col-xs-12 col-md-12"><span ng-show="p.item.unavailable || p.item.amount == 0" class="btn btn-info btn-danger float-right">Esgotado</span> <button title="Comprar {{p.promoCall}}" ng-show="!p.item.unavailable && p.item.value" class="btn btn-success float-right btn-sm" ng-click="vm.select(p)">Comprar <i class="fa fa-shopping-cart"></i></button></div></div></div></div></div></div></div>');
$templateCache.put('app/reagendamento/reagendamento.html','<div class="container"><div class="row"><div class="col-xs-12 col-lg-4 col-lg-offset-4"><div class="row"><div class="col-md-offset-1 col-md-10"><div class="row" ng-if="!vm.urlVoucher"><h3 class="col-xs-12">Localizador {{vm.id}}</h3><div class="col-xs-12"><h4>itens:</h4><span>{{vm.productsSummary}}</span></div><div class="col-xs-12"><h4>Data da visita: <b>{{vm.originalDate}}</b></h4></div><div class="col-xs-12"><div class="form-group"><label for="datadeacesso">Nova data da visita</label> <button class="btn btn-default btn-block btn-datepicker" ng-click="vm.openDatePickerModal()">{{vm.date | date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div></div><div ng-if="vm.diffPrice > 0"><div class="col-xs-12"><h4>Valor atual: {{vm.bill.value /100 | currency: "R$ "}}</h4><h4>Valor nova data: {{vm.newPrice.value / 100 | currency: "R$ "}}</h4><h3>Diferen\xE7a a pagar: {{vm.diffPrice / 100 | currency: "R$ "}}</h3></div></div><div class="col-xs-12"><div class="row"><div class="col-md-4 col-md-offset-8"><div class="form-group"><button type="button" class="form-control btn btn-primary pull-right" ng-click="vm.save()">Salvar&nbsp;<i class="fa fa-next"></i></button></div></div></div></div></div><div class="row" ng-if="vm.urlVoucher"><br><br><div class="col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3"><a title="VOUCHER" class="btn btn-success btn-block btn-large" target="_blank" rel="noopener" href="{{vm.urlVoucher}}"><i class="fa fa-print"></i> VOUCHER</a></div><br><br></div></div></div></div></div><br></div>');
$templateCache.put('app/reservarorcamento/orcamentoConfirmacao.html','<section class="row loja-box-float loja-agradecimento"><div class="col-md-8 col-md-offset-2 loja-agradecimento-card loja-box-float-card"><div class="row"><img class="img-responsive" ng-src="assets/images/layout/imagem-confirmacao-ingressos.jpg"></div><div class="col-md-12 text-information"><div><p>Or\xE7amento solicitado. Voc\xEA est\xE1 a um passo da sua viagem! Em breve entraremos em contato!</p><div class="col-md-12 pagamento-ingresso"><a ng-click="vm.dismiss()" href="">Verifique e-mail</a></div></div></div></div></section>');
$templateCache.put('app/reservarorcamento/reservarorcamento.html','<div class="container"><div class="row"><div class="col-xs-12 text-center"><h2 title="Aguarde. Carregando Or\xE7amento.">Aguarde. Carregando Or\xE7amento.</h2></div></div></div>');
$templateCache.put('app/new_ingressos/banner.html','');
$templateCache.put('app/new_ingressos/bannerIngressos.html','<header ng-if="vm.headerImageBanner" class="header-image-banner" style="margin-top: {{ vm.headerImageBanner.marginTop + \'em\' || 0 }};"><a href="{{ vm.headerImageBanner.href || \'#\'}}" target="_blank" referrerpolicy="no-referrer" rel="nofollow"><picture><source srcset="{{vm.headerImageBanner.mobile}}" media="(max-width:{{vm.headerImageBanner.breakPoint || 960}}px)"><img ng-src="{{vm.headerImageBanner.desktop}}" alt="{{vm.headerImageBanner.alt}}"></picture></a></header><div class="ingressos-banner-text"></div>');
$templateCache.put('app/new_ingressos/ing-child-price.html','<div class="action-shopping crianca row"><div ng-class="{\'old\': child.oldValue}" class="col-xs-6 prices"><label class="label" for="valor_child_{{::child.id}}">Valor Ingresso</label><h6 title="De {{::child.oldValue / 100| currency:\'R$ \'}}" ng-if="::child.oldValue">De {{::child.oldValue / 100| currency:\'R$ \'}}</h6><h5 title="{{ ::child.select_date ? \'Pre\xE7o pode alterar de acordo com as datas escolhidas\' : ((child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \')}}" id="valor_child_{{::child.id}}">{{(child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \'}}<span ng-if="::child.select_date">*</span></h5></div><div class="col-xs-6 padding-left-0"><label for="typeIngressoChild_{{::child.id}}" class="label">{{::child.years}}</label><br ng-if="::!child.years"><button title="Adicionar mais um produto {{::child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" aria-label="Adicionar mais um produto {{::child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" ng-if="!child.esgotado" uib-tooltip="{{child.years == null ? \'Ingressos\': child.years}}" type="button" role="button" class="btn time-05 ripple btn-success btn-block plus" ng-click="vm.addProductDirect(child)">Comprar <i class="fa fa-plus" aria-hidden="true"></i></button> <button title="Esgotado {{::child.shortName}}" aria-label="Esgotado {{::child.shortName}}" type="button" role="button" class="btn time-05 ripple btn-danger btn-block plus" disabled="disabled" ng-if="child.esgotado">Esgotado <i class="fa fa-ban" aria-hidden="true"></i></button></div><div class="col-xs-12"><hr role="separator"></div></div>');
$templateCache.put('app/new_ingressos/ing-parent-price.html','<div class="action-shopping adulto row"><div ng-class="{\'old\': ingresso.oldValue}" class="col-xs-6 prices"><label class="label" for="valor_{{::ingresso.id}}">Valor Ingresso</label><h6 title="De {{::ingresso.oldValue / 100| currency:\'R$ \'}}" ng-if="::ingresso.oldValue">De {{ingresso.oldValue / 100| currency:\'R$ \'}}</h6><h5 title="{{::ingresso.select_date ? \'Pre\xE7o pode alterar de acordo com as datas escolhidas\' : ((ingresso.amount > 0 ? ingresso.value * ingresso.amount : ingresso.value) / 100 | currency:\'R$ \') }}" id="valor_{{::ingresso.id}}">{{(ingresso.amount > 0 ? ingresso.value * ingresso.amount : ingresso.value) / 100 | currency:\'R$ \'}}<span ng-if="::ingresso.select_date">*</span></h5></div><div class="col-xs-6 padding-left-0"><label ng-if="::ingresso.years" for="typeIngresso_{{::ingresso.id}}" class="label">{{::ingresso.years}}</label><br ng-if="::!ingresso.years"><button title="Adicionar esse produto {{::ingresso.shortName}} tipo {{child.years == null ? \'Ingresso\': child.years}} ao carrinho" aria-label="Adicionar esse produto {{::ingresso.shortName}} tipo {{child.years == null ? \'\n        Ingressos\': child.years}} ao carrinho" uib-tooltip="{{ingresso.years == null ? \'\n            Ingressos\': ingresso.years}}" type="button" role="button" class="btn time-05 ripple btn-success btn-block plus" ng-click="vm.addProductDirect(ingresso)" ng-if="!ingresso.esgotado">Comprar <i class="fa fa-plus" aria-hidden="true"></i></button> <button title="Esgotado {{::ingresso.shortName}}" aria-label="Esgotado {{::ingresso.shortName}}" type="button" role="button" class="btn time-05 ripple btn-danger btn-block plus" disabled="disabled" ng-if="ingresso.esgotado">Esgotado <i class="fa fa-ban" aria-hidden="true"></i></button></div><div ng-if="::ingresso.children.length > 0" class="col-xs-12"><hr role="separator"></div></div>');
$templateCache.put('app/new_ingressos/ingressos.html','<main id="showMainLoja" class="loja-ingressos main-ingressos"><div class="box-banner-ingressos" ng-include="\'app/new_ingressos/bannerIngressos.html\'" ng-controller="bannerController as vm"></div><section id="showTelaCalendario" ng-show="vm.step == \'selecionaData\' && vm.firstSearch" class="container loja-calendario"><div class="row"><div class="col-md-10 col-md-offset-1 header-ingressos-main"><h3>Escolha um dia para nos visitar <i class="fa fa-calendar-check-o" aria-hidden="true"></i></h3><hr></div></div><div ng-include="\'app/new_ingressos/layout-calendario.html\'"></div></section><div ng-init="vm.naoEscolheData ? vm.search(vm.date) : \'\'"></div><section id="showProdutos" ng-show="(vm.step === \'produtos\' || !vm.firstSearch) && vm.step !== \'carrinho\' && vm.step !== \'pagamento\' && vm.step !== \'carrinho\' && vm.step != \'extras\' && vm.step != \'identificacao\'" class="container-fluid loja-produtos"><div ng-include="\'app/new_ingressos/layouts/header-ingressos.html\'"></div><div class="row b2c-body-produtos"><section class="col-md-9 col-ingressos"><div ng-if="!vm.Properties.esconderInfoIngressos" ng-include="\'app/new_ingressos/layouts/info-ingressos.html\'"></div><div ng-include="\'app/new_ingressos/layout-ingressos.html\'"></div></section><aside class="col-md-3 col-carrinho" ng-include="\'app/new_ingressos/layouts/carrinho-aside-ingressos.html\'"></aside></div></section><section id="showExtras" ng-show="vm.step == \'extras\'" class="container-fluid loja-extras"><div class="row b2c-header-extra"><div class="col-md-3 col-lg-2 voltar form-group"><button title="Voltar para os ingressos" type="button" role="button" class="btn btn-danger btn-block" ng-click="vm.activeStep(\'produtos\')"><i class="fa fa-arrow-left" aria-hidden="true"></i> Voltar para os ingressos</button></div><div class="col-md-6 col-lg-8 text form-group"><h2 title="Que tal adicionar extras ao carrinho"><i class="fa fa-tags" aria-hidden="true"></i> Que tal adicionar extras ao carrinho</h2></div><div class="col-md-3 col-lg-2 not form-group"><button title="N\xE3o quero extras" type="button" role="button" class="btn btn-warning btn-block" ng-click="vm.activeStep(\'carrinho\')">N\xE3o quero extras<i class="fa fa-arrow-right" aria-hidden="true"></i></button></div></div><div class="row b2c-body-produtos extras"><section class="col-md-9 col-ingressos extra"><div ng-include="\'app/new_ingressos/layout-ingressos-extras.html\'" class="ingressos.layout_produtos_extras"></div><div ng-show="vm.cart.length > 0" class="row hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><div class="col-md-12"><br><button title="Ver Carrinho" type="button" role="button" class="btn-success btn btn-lg btn-block" ng-click="vm.initialPurchase()">Ver Carrinho <i class="fa fa-shopping-cart" aria-hidden="true"></i></button><br></div></div></section><aside class="col-md-3 col-carrinho extra" ng-include="\'app/new_ingressos/layouts/carrinho-aside-ingressos.html\'"></aside></div></section><section ng-show="(vm.step == \'identificacao\' || vm.step == \'pagamento\' || vm.step == \'carrinho\') && vm.step != \'extras\'" id="showPagamento" class="container-fluid loja-pagamento"><div class="row loja-pagamento-header hidden-xs hidden-sm"><div class="col-md-12"><div class="row"><div class="padding-xs-right-0 col-xs-2 col-sm-2 col-md-3 col-lg-3 function"><button ng-if="vm.extraProducts.length > 0" title="Voltar para os extras" type="button" role="button" class="btn btn-danger btn-block" ng-click="vm.voltar()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Voltar para os extras</button> <button ng-if="vm.extraProducts.length == 0" title="Voltar para os ingressos" type="button" role="button" class="btn btn-danger btn-block" ng-click="vm.voltar()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Voltar para os ingressos</button></div><div class="col-xs-10 col-sm-10 col-md-6 col-lg-6 text"><h2 title="Agora vamos concluir a compra">Agora vamos concluir a compra</h2></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div></div></div></div><div class="row loja-ingressos-breadcrumb hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><div class="col-md-12"><ul role="listbox"><li class="compra" ng-class="{\'active\': vm.step == \'carrinho\', \'check\': vm.step == \'pagamento\' || vm.step == \'identificacao\'}"><i class="fa fa-arrow-down hidden" aria-hidden="true"></i> <i class="fa fa-check hidden" aria-hidden="true"></i> <button title="Meu Carrinho" type="button" role="button" class="btn btn-default time-05" ng-click="vm.activeStep(\'carrinho\')"><i class="fa fa-shopping-cart" aria-hidden="true"></i> <span>Meu Carrinho</span></button><hr></li><li class="comprador" ng-class="{\'active\': vm.step == \'identificacao\', \'check\': vm.step == \'pagamento\', \'off\': vm.step == \'carrinho\'}"><i class="fa fa-arrow-down hidden" aria-hidden="true"></i> <i class="fa fa-check hidden" aria-hidden="true"></i> <button title="Dados Titular do Cart\xE3o" type="button" role="button" class="btn btn-default time-05" ng-click="vm.activeStep(\'identificacao\')" ng-disabled="vm.step == \'carrinho\'"><i class="fa fa-user" aria-hidden="true"></i> <span>Dados Titular do Cart\xE3o</span></button><hr></li><li class="pagamento" ng-class="{\'active\': vm.step == \'pagamento\', \'off\': vm.step == \'carrinho\' || vm.step == \'identificacao\'}"><i class="fa fa-arrow-down hidden" aria-hidden="true"></i> <i class="fa fa-check hidden" aria-hidden="true"></i> <button title="Dados Pagamento" type="button" role="button" class="btn btn-default time-05"><i class="fa fa-credit-card" aria-hidden="true"></i> <span>Dados Pagamento</span></button><hr></li></ul></div></div><div class="row loja-col-pagamentos"><div ng-show="( (vm.step === \'carrinho\' && vm.step !== \'identificacao\' && vm.step !== \'pagamento\') &&  vm.containerWidth <= 1024 ) || vm.containerWidth > 1024" id="dadosMeuCarrinho" class="col-md-4 loja-carrinho-ingressos"><div class="container-box"><div class="row header-col"><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div><div class="col-xs-2 col-sm-2 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><button ng-if="vm.extraProducts.length > 0" title="Comprar mais Extras" type="button" role="button" class="btn btn-info btn-block btn-back" ng-click="vm.activeStep(\'extras\')"><i class="fa fa-arrow-left" aria-hidden="true"></i></button> <button ng-if="vm.extraProducts.length == 0" title="Voltar" type="button" role="button" class="btn btn-info btn-block btn-back" ng-click="vm.activeStep(\'produtos\')"><i class="fa fa-arrow-left" aria-hidden="true"></i></button></div><div class="text col-xs-5 col-sm-5 col-md-12 col-lg-12"><i class="fa fa-shopping-cart" aria-hidden="true"></i><h2 title="Meu Carrinho">Meu Carrinho</h2><hr class="hidden-xs hidden-sm"></div><div class="col-xs-5 col-sm-5 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><button title="Concluir a compra" type="button" role="button" class="btn btn-success btn-block btn-next" ng-click="vm.nextStep()" ng-disabled="(vm.totalValue / 100) <= 0">Concluir a compra <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><span ng-if="(vm.totalValue / 100) <= 0 && vm.cart.length > 0" class="msg-ingresso-pagante">Adicione um Ingresso Pagante para prosseguir!</span></div><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div></div><div class="body-pag border-right-md"><div ng-include="\'app/new_ingressos/layouts/lista-ingressos-carrinhos.html\'"></div><div class="total-carrinho"><div class="row"><div class="col-xs-4"><h2 ng-if="vm.totalValue > 0" title="Valor total para {{vm.totalAmount}} {{vm.totalAmount > 1 ? \'Produtos\' : \'Produto\'}}: {{vm.totalValue / 100| currency:\'R$ \'}}">{{vm.totalAmount}} prod.<br><small ng-show="vm.extraProducts.length == 0"><i class="fa fa-ticket" aria-hidden="true"></i> Ingressos</small> <small ng-show="vm.extraProducts.length > 0"><i class="fa fa-ticket" aria-hidden="true"></i> Ingressos e <i class="fa fa-tags" aria-hidden="true"></i> Extras</small></h2></div><div class="col-xs-8 padding-0"><div ng-include="\'app/new_ingressos/layouts/cupom-desconto-key.html\'"></div></div></div></div><div class="row valor-total" ng-class="{\'remarcacao\': vm.oldBill.id>0}"><div class="col-xs-3 text"><h3 title="Total">Total</h3></div><div class="col-xs-9 preco" ng-class="{\'descontos\': vm.oldValue > 0 && vm.oldValue != vm.totalValue}"><strong ng-if="vm.oldValue > 0 && vm.oldValue != vm.totalValue" title="{{ vm.oldValue / 100 | currency:\'R$ \'}}">de {{ vm.oldValue / 100 | currency:"R$ "}}</strong><h3 title="{{ vm.totalValue / 100 | currency:\'R$ \'}}"><small ng-if="vm.oldValue > 0 && vm.oldValue != vm.totalValue">por </small><span ng-if="vm.totalValue != null">{{ vm.totalValue / 100 | currency:"R$ "}}</span></h3></div><div ng-if="vm.oldBill.id>0" class="totalapagar"><div class="col-xs-6 text"><h3 title="Total a pagar" ng-if="vm.oldBill.value <= vm.totalValue">Total a pagar</h3><h3 title="Saldo restante" ng-if="vm.oldBill.value > vm.totalValue">Saldo restante</h3></div><div class="col-xs-6 preco" class="descontos"><h3 title="{{ (vm.totalValue - vm.oldBill.value) / 100 | currency:\'R$ \'}}">{{ (vm.totalValue - vm.oldBill.value) / 100 | currency:"R$ "}}</h3></div></div><div class="col-md-12" ng-if="vm.oldBill.id>0 && vm.oldBill.value > vm.totalValue"><div class="regras-compra"><h5>O credito ser\xE1 ajustado para <strong>R$ 0,00</strong>. Aproveite e adquira mais produtos.</h5></div></div><div ng-show="vm.paymentMethodsAdjustments.length && !vm.oldBill.id"><ul ng-if="vm.conditionsArray.length"><li ng-repeat="item in vm.conditionsArray track by $index"><span>{{item.value}} </span>{{item.paymentMethod}} <span ng-if="item.type === \'desconto\'" ng-class="item.percent + \'discount phrase-discount\'">({{item.percent}} de desconto)</span></li></ul></div></div><div class="row box-economizou"><div class="col-xs-12 prices descontos" ng-if="vm.oldValue > 0 && vm.oldValue != vm.totalValue"><h5 title="Voc\xEA economizou {{(vm.oldValue - vm.totalValue) / 100 | currency:\'R$ \'}}" aria-hidden="false">Voc\xEA economizou {{(vm.oldValue - vm.totalValue) / 100 | currency:\'R$ \'}}</h5></div></div><div ng-include=""></div><span ng-if="(vm.totalValue / 100) <= 0 && vm.cart.length > 0" class="msg-ingresso-pagante">Adicione um Ingresso Pagante para prosseguir!</span><div class="row loja-pagamento-header hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><div class="col-xs-6 function"><button ng-if="vm.extraProducts.length > 0" title="Comprar mais Extras" type="button" role="button" class="btn btn-info btn-block" ng-click="vm.activeStep(\'extras\')"><i class="fa fa-arrow-left" aria-hidden="true"></i> Comprar mais Extras</button> <button ng-if="vm.extraProducts.length == 0" title="Voltar" type="button" role="button" class="btn btn-info btn-block" ng-click="vm.activeStep(\'produtos\')"><i class="fa fa-arrow-left" aria-hidden="true"></i> Voltar</button></div><div class="col-xs-6 text"><button title="Concluir a compra" type="button" role="button" class="btn btn-success btn-block" ng-click="vm.nextStep()" ng-disabled="(vm.totalValue / 100) <= 0">Concluir a compra <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div></div></div></div></div><div ng-show="( (vm.step === \'identificacao\' && vm.step !== \'pagamento\' && vm.step !== \'carrinho\') && vm.containerWidth <= 1024 ) || vm.containerWidth > 1024" id="dadosComprador" class="col-md-4 loja-dados-comprador-ingressos"><div class="container-box"><div class="row header-col"><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div><div class="col-xs-2 col-sm-2 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><button title="Voltar para dados de identifica\xE7\xE3o" type="button" role="button" class="btn btn-info btn-block btn-back" ng-click="vm.activeStep(\'carrinho\')"><i class="fa fa-arrow-left" aria-hidden="true"></i></button></div><div class="text col-xs-10 col-sm-10 col-md-12 col-lg-12"><i class="fa fa-user" aria-hidden="true"></i><h2 title="Dados Titular do Cart\xE3o">Dados Titular do Cart\xE3o</h2><hr class="hidden-xs hidden-sm"></div><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div></div><div class="border-right-md body-pag"><xs-register xs-complete="vm.registroEfetuado()" xs-has-registre-person="true" template-url="app/new_ingressos/models-pagamento/dados-user.html"></xs-register><div ng-include="\'app/new_ingressos/layouts/info-regras-compras-ingressos.html\'"></div></div></div></div><div ng-show="( (vm.step === \'pagamento\' && vm.step !== \'identificacao\' && vm.step !== \'carrinho\') &&  vm.containerWidth <= 1024 ) || vm.containerWidth > 1024" id="dadosPagamento" class="col-md-4 loja-pagamento-ingressos"><div class="container-box"><div class="row header-col"><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div><div class="col-xs-2 col-sm-2 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><button title="Voltar para dados de identifica\xE7\xE3o" type="button" role="button" class="btn btn-info btn-block btn-back" ng-click="vm.activeStep(\'identificacao\')"><i class="fa fa-arrow-left" aria-hidden="true"></i></button></div><div class="text col-xs-10 col-sm-10 col-md-12 col-lg-12"><i class="fa fa-credit-card" aria-hidden="true"></i><h2 title="Dados Pagamento">Dados Pagamento</h2><hr class="hidden-xs hidden-sm"></div><div class="col-xs-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><hr></div></div><div ng-if="vm.step !== \'selecionaData\'" ng-show="vm.step === \'pagamento\'"><xs-payment class="body-pag" xs-custom-prices="vm.customPrices" xs-complete="vm.endPurchase" xs-change="vm.isFinalStep()" xs-products="vm.cart" xs-cupom="vm.getCupom()" xs-total-value="vm.totalValue" xs-paid-value="vm.oldBill.value" template-url="app/new_ingressos/models-pagamento/xs-direct-payment.html"></xs-payment></div></div></div></div></section></main>');
$templateCache.put('app/new_ingressos/layout-cadastro-ingressos.html','<form name="accountForm" class="form form-cadastro-ingressos" role="form"><div class="row"><legend class="col-xs-12">Preencha todos os campos com *</legend><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="nome" accesskey="E">Nome completo *</label> <input tabindex="1" name="nome" type="text" id="nome" class="form-control" placeholder="Digite o seu nome" ng-model="vm.user.name" autocomplete="name" required ng-disabled="vm.disableInputIfUserExists(\'nome\')"></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="email" accesskey="E">E-mail *</label> <input tabindex="2" name="email" type="email" id="email" class="form-control" placeholder="Preencha com um e-mail" ng-model="vm.user.email" required ng-disabled="vm.disableInputIfUserExists(\'email\')"></div></div><div class="col-md-6"><div class="row"><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="password" accesskey="E">Senha *</label> <input tabindex="3" name="password" type="password" id="password" class="form-control" placeholder="Crie uma senha" ng-model="vm.user.password" required ng-disabled="vm.disableInputIfUserExists(\'password\')"></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="password2" accesskey="E">Confirme a senha *</label> <input tabindex="4" name="password" type="password" id="password2" class="form-control" placeholder="Confirme a senha" ng-model="vm.password" required ng-disabled="vm.disableInputIfUserExists(\'password2\')"></div></div></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="celular" accesskey="E">Celular *</label> <input tabindex="5" name="Celular" type="text" id="celular" class="form-control" ng-model="vm.user.cellPhone" ui-mask="(99) 9 9999-9999" placeholder="(DDD) 0 0000-0000" ui-mask-placeholder required ng-disabled="vm.disableInputIfUserExists(\'celular\')"></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="nacionalidade" accesskey="E">Nacionalidade *</label> <select tabindex="6" class="form-control" id="nacionalidade" ng-model="vm.user.customData.estrangeiro" required ng-disabled="vm.disableInputIfUserExists(\'nacionalidade\')"><option value="false">Brasileiro</option><option value="true">Estrangeiro</option></select></div></div><div class="col-md-6"><div class="form-group form-loja"><div ng-if="vm.user.customData.estrangeiro == \'false\'"><label class="control-label" for="cpf" accesskey="E">CPF *</label> <input tabindex="7" name="cpf" type="text" id="cpf" class="form-control" ng-model="vm.user.cpf" ui-mask="999.999.999-99" cpf-validator placeholder="Digite o seu CPF" ui-mask-placeholder required ng-disabled="vm.disableInputIfUserExists(\'cpf\')"></div><div ng-if="vm.user.customData.estrangeiro == \'true\'"><label class="control-label" for="documento" accesskey="E">Documento *</label> <input tabindex="7" name="documento" type="text" id="documento" class="form-control" placeholder="Digite o seu documento" ng-model="vm.user.passporte" required ng-disabled="vm.disableInputIfUserExists(\'documento\')"></div></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="nasc" accesskey="E">Data de Nascimento *</label> <input tabindex="8" name="birthdayDate" type="text" id="nasc" class="form-control" ng-model="vm.user.birth" ui-mask="99/99/9999" placeholder="DD/MM/AAAA" ui-mask-placeholder required ng-change="vm.verifyDate()" ng-disabled="vm.disableInputIfUserExists(\'nasc\')"></div></div><div class="col-md-6"><div class="form-group form-loja cep" ng-hide="vm.user.customData.estrangeiro == \'true\'"><label for="cep">Cep</label> <input tabindex="9" name="Cep" type="text" class="form-control input-pag" id="cep" placeholder="Informa o CEP" ui-mask="99999-999" ng-model="vm.user.zipCode" ui-mask-placeholder ng-change="vm.countNumberCEP()" required ng-disabled="vm.disableInputIfUserExists(\'cep\')"></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="sexo" accesskey="E">Sexo</label> <select tabindex="10" id="sexo" class="form-control" ng-model="vm.user.gender" ng-disabled="vm.disableInputIfUserExists(\'sexo\')"><option value="M">Masculino <i class="fa fa-male"></i></option><option value="F">Feminino <i class="fa fa-female"></i></option></select></div></div><div class="col-md-6"><div class="form-group form-loja form-loja-btn-promo"><label class="control-label" for="Promo\xE7\xF5es" accesskey="E">Receber promo\xE7\xF5es</label><div class="input-group"><label class="btn btn-default" ng-class="{\'active\':vm.user.mailing}"><input tabindex="11" name="sim" class="active" type="radio" ng-model="vm.user.mailing" ng-value="true">Sim</label> <label class="btn btn-default" ng-class="{\'active\':!vm.user.mailing}"><input tabindex="12" name="nao" type="radio" ng-model="vm.user.mailing" ng-value="false">N\xE3o</label></div></div></div><div class="col-md-12 form-group form-loja border-top-simples"><button tabindex="13" title="Efetuar cadastro" aria-label="Efetuar cadastro" type="button" class="btn btn-success btn-lg ripple btn-shadow btn-block" scroll-to-bookmark="step4" ng-click="vm.savePerson()" ng-disabled="accountForm.$invalid">Confirmar <i class="fa fa-user-plus" aria-hidden="true"></i></button></div></div></form>');
$templateCache.put('app/new_ingressos/layout-calendario-dates.html','<div class="row content-search-dates" ng-controller="TimespanController as vm"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="col-md-4 form-group check-out"><label for="dataChegada">Data de Chegada</label><div class="input-group"><input type="text" class="form-control" id="dataChegada" ng-model="vm.date" min-date="vm.today" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false,startingDay:0}" is-open="vm.activeDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-click="vm.activeDate = true"> <span class="input-group-addon"><button title="Abrir calend\xE1rio da data de in\xEDcial" aria-label="Abrir calend\xE1rio da data de in\xEDcial" class="ripple" type="button" role="button" ng-click="vm.activeDate = true"><i class="fa fa-calendar-check-o" aria-hidden="true"></i></button></span></div><button class="hidden btn btn-default btn-block ripple" type="button" role="button" ng-click="vm.openDatePickerModal(vm.date)">{{vm.date| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar" aria-hidden="true"></i></button></div><div class="col-md-4 form-group check-out"><label for="dataPartida">Data de Partida</label><div class="input-group"><input type="text" class="form-control" id="dataPartida" ng-model="vm.endDate" min-date="vm.date" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false,startingDay:0}" is-open="vm.activeEndDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-click="vm.activeEndDate = true"> <span class="input-group-addon"><button title="Abrir calend\xE1rio da data de final" aria-label="Abrir calend\xE1rio da data de final" type="button" role="button" class="ripple" ng-click="vm.activeEndDate = true"><i class="fa fa-calendar-times-o" aria-hidden="true"></i></button></span></div><button class="hidden btn btn-default btn-block ripple" type="button" role="button" ng-click="vm.openDatePickerModal(vm.endDate)">{{vm.endDate| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar"></i></button></div><div class="col-md-4 form-group search"><label for="buttonPesquisar">Buscar</label> <button title="Buscar Per\xEDodo" aria-label="Buscar Per\xEDodo" type="button" role="button" id="buttonPesquisar" class="btn btn-success ripple btn-block" ng-click="vm.pesquisar()">Pesquisar Per\xEDodo <i class="fa fa-search" aria-hidden="true"></i></button></div></div><div class="row"><figure class="col-md-4 col-md-offset-4"><img title="Imagem ilustrativa calend\xE1rio" alt="Imagem Ilustrativa de Calend\xE1rio" class="img-responsive" src="assets/images/layout/paper-calendar-check.jpg"></figure></div></div></div>');
$templateCache.put('app/new_ingressos/layout-calendario.html','<div ng-controller="CalendarioController as vm"><div class="row calendar-details"><div class="col-md-4 col-md-offset-2 info"><div class="row header-info-calendario"><div class="col-md-12"><p title="Informa\xE7\xF5es Importantes"><small>Informa\xE7\xF5es</small><br><strong>Importantes</strong></p><hr></div></div><div class="row body-info-calendario"><div class="col-md-12" ng-include="\'app/new_ingressos/layouts/legenda-calendario.html\'"></div><div class="col-md-12"><address class="hidden-xs hidden-sm"><h3 class="title-address"></h3><p ng-if="\'\'"><i class="fa fa-phone-square" aria-hidden="true"></i></p><p ng-if="\'(73) 3268-8500\'"><i class="fa fa-mobile" aria-hidden="true"></i> (73) 3268-8500</p><p ng-if="\'info@hoteisquintadosol.com\'"><i class="fa fa-envelope" aria-hidden="true"></i> E-mail: info@hoteisquintadosol.com</p><p></p></address><p class="frase-calendario"></p><figure class="banner-calendario"><img class="img-responsive" src=""></figure><div></div></div></div></div><div class="col-md-4 col-calendar layout-calendar"><div class="row"><div uib-datepicker min-date="vm.today" ng-model="vm.dt2" ng-if="vm.isLoadDates" class="well well-sm" custom-class="vm.getDayClass(date, mode)" date-disabled="vm.disabledDate(date,mode)"></div></div><div class="row"><div class="col-md-12"><button title="Pesquisar Ingressos para essa data" aria-label="Pesquisar Ingressos para essa data" type="button" role="button" class="btn btn-info btn-lg btn-pesquisar ripple btn-shadow btn-block" ng-click="vm.pesquisar()" ng-disabled="vm.disabledDate(vm.dt2, \'day\')">Pesquisar Ingressos <i class="fa fa-search"></i></button></div></div><div class="row hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><div class="col-md-12"><address><p><i class="fa fa-phone-square" aria-hidden="true"></i></p><p><i class="fa fa-mobile" aria-hidden="true"></i> (73) 3268-8500</p><p><i class="fa fa-envelope" aria-hidden="true"></i> E-mail: info@hoteisquintadosol.com</p><p></p></address></div></div></div></div></div><figure class="mascote-home-calendario"><img ng-src=""></figure>');
$templateCache.put('app/new_ingressos/layout-carrinho.html','');
$templateCache.put('app/new_ingressos/layout-ingresso-parksnet.html','<section class="layout-ingresso-parksnet"><header style="position: relative; background-image: url(\'{{ ::ingresso.image }}\'); background-size: cover; aspect-ratio: 4/3;" ng-click="vm.verMaisDetalhesProduto(ingresso)"><div style="position: absolute; bottom: 1rem; right: 1rem; font-size: 1.3rem;"><div style="background-color: #ffffffaa; backdrop-filter: blur(2px); border-radius: 999px; padding: .25rem 1.25rem;"><i class="fa fa-plus"></i> Detalhes</div></div></header><main style="padding: 0 1.5rem 2rem 1.5rem; display: flex; flex-direction: column; gap: 2rem;"><header style="padding: .5rem 1rem; text-align: center; cursor: pointer; background-color: #333; color: #fff; border-radius: 999px; text-overflow: pretty;" ng-click="vm.verMaisDetalhesProduto(ingresso)">{{ ingresso.campoadicional1 || ingresso.shortName }}</header><div ng-if="vm.temSeletorDeHora(ingresso)" style="text-align: center;">Selecione a sess\xE3o: <label style="user-select: none; background-color: #fff; border: solid #ccc 2px; border-radius: .75rem; padding: .25rem .75rem;"><i class="fa fa-clock-o" style="margin-right: -2rem;"></i> <select ng-model="ingresso.selectedHour" style="padding-left: 2rem; border: none; background: transparent; cursor: pointer;"><option value="" disabled="disabled" selected="selected">Hora</option><option ng-repeat="schedule in vm.getAllSchedulesByProduct(ingresso)" value="{{schedule}}">{{ schedule }}</option></select></label></div><ul style="display: flex; flex-direction: column; gap: 1.4rem;"><li><div style="display: grid; place-items: stretch; align-items: center; grid-template-columns: repeat(3, 1fr); gap: .5rem;"><div style="font-size: 1.25rem; text-overflow: pretty;">{{ ingresso.years || "Valor Ingresso" }}</div><div style="place-self: center;"><div ng-if="ingresso.oldValue" style="text-decoration: line-through; font-size: 1.1rem;">{{ ingresso.oldValue / 100 | currency:\'R$ \' }}</div><div style="font-size: 1.4rem;">{{ ingresso.value / 100 | currency:\'R$ \' }}</div></div><div><div ng-if="vm.tipoBotaoIngresso(ingresso) === \'comprar\'" class="layout-ingresso-parksnet_adicionar-ao-carrinho"><button ng-disabled="vm.temSeletorDeHora(ingresso) && !vm.productHasHora(ingresso, ingresso.selectedHour)" ng-click="vm.addProductDirect(ingresso)">Comprar</button></div><div ng-if="vm.tipoBotaoIngresso(ingresso) === \'seletor-qnt\'" class="layout-ingresso-parksnet_qnt-buttons" data-active="{{ ingresso.amount > 0 ? \'true\' : \'false\' }}"><button ng-disabled="ingresso.amount === 0 || (vm.temSeletorDeHora(ingresso) && !vm.productHasHora(ingresso, ingresso.selectedHour))" ng-click="vm.removeItem(ingresso)"><i class="fa fa-minus"></i></button><div>{{ ingresso.amount }}</div><button ng-disabled="Number(ingresso.maxAmount) >= ingresso.amount || (vm.temSeletorDeHora(ingresso) && !vm.productHasHora(ingresso, ingresso.selectedHour))" ng-click="vm.addItem(ingresso)"><i class="fa fa-plus"></i></button></div></div></div></li><li ng-repeat="child in ingresso.children"><div style="display: grid; place-items: stretch; align-items: center; grid-template-columns: repeat(3, 1fr); gap: .5rem;"><div style="font-size: 1.25rem; text-overflow: pretty;">{{ child.years }}</div><div style="place-self: center;"><div ng-if="child.oldValue" style="text-decoration: line-through; font-size: 1.1rem;">{{ child.oldValue / 100 | currency:\'R$ \' }}</div><div style="font-size: 1.4rem;">{{ child.value / 100 | currency:\'R$ \' }}</div></div><div><div ng-if="vm.tipoBotaoIngresso(child) === \'comprar\'" class="layout-ingresso-parksnet_adicionar-ao-carrinho"><button ng-disabled="vm.temSeletorDeHora(child) && !vm.productHasHora(child, ingresso.selectedHour)" ng-click="vm.addProductDirect(child)">Comprar</button></div><div ng-if="vm.tipoBotaoIngresso(child) === \'seletor-qnt\'" class="layout-ingresso-parksnet_qnt-buttons" data-active="{{ child.amount > 0 ? \'true\' : \'false\' }}"><button ng-disabled="child.amount === 0 || (vm.temSeletorDeHora(child) && !vm.productHasHora(child, ingresso.selectedHour))" ng-click="vm.removeItem(child)"><i class="fa fa-minus"></i></button><div>{{ child.amount }}</div><button ng-disabled="Number(child.maxAmount) >= child.amount || (vm.temSeletorDeHora(child) && !vm.productHasHora(child, ingresso.selectedHour))" ng-click="vm.addItem(child)"><i class="fa fa-plus"></i></button></div></div></div></li></ul><footer ng-if="!vm.productAndChildrenAreAllCombos(ingresso)" style="display: flex; flex-direction: column; gap: 1.25rem; background: transparent; color: #333;"><div style="display: flex; justify-content: space-between; gap: 1.5rem;"><div>{{ vm.valorTotalBox(ingresso) | currency:\'R$ \' }}</div><div>{{ vm.countTotalBox(ingresso) }} {{ vm.countTotalBox(ingresso) > 1 ? \'Ingressos\' : \'Ingresso\' }}</div></div><div style="text-align: center;"><button style="padding: .5rem 1.5rem; border: none; border-radius: 999px" ng-click="vm.addToCart(ingresso, true)" ng-disabled="vm.verificaAmountSeniorAdultoIncluso(ingresso)"><span ng-show="!ingresso.loading">{{ vm.verificaAmountSeniorAdultoIncluso(ingresso) ? \'Nenhum produto escolhido\' : \'Adicionar ao Carrinho\' }} <i class="fa fa-shopping-cart" aria-hidden="true"></i> </span><span ng-show="ingresso.loading"><i class="spinner-timer-2 fa fa-spinner" aria-hidden="true"></i> Adicionando ao Carrinho...</span></button></div></footer></main></section>');
$templateCache.put('app/new_ingressos/layout-ingresso.html','<div class="ingressos-col-item {{ingresso.nivelDestaque}}" ng-class="{\'active-ingresso\': vm.valorTotalBox(ingresso) > 0}"><hr class="hover-show"><div class="row combo-header" ng-click="vm.verMaisDetalhesProduto(ingresso)" style="background-image: url(\'{{::vm.loadImage(ingresso)}}\')"><button uib-tooltip="Mais detalhes {{::ingresso.shortName}}" title="Mais Detalhes: {{::ingresso.shortName}}" type="button" role="button" class="btn time-05 ripple btn-warning"><i class="fa fa-plus" aria-hidden="true"></i> Detalhes</button><div class="info-destaque-ticket plus"><h4 title="Mais Vendidos">Mais Vendidos <i class="fa fa-tags" aria-hidden="true"></i></h4></div><div class="info-destaque-ticket medium"><h4 title="Experimente">Experimente <i class="fa fa-plus-circle" aria-hidden="true"></i></h4></div><div class="info-destaque-ticket minus"><h4 title="#Dica">#Dica <i class="fa fa-thumbs-up" aria-hidden="true"></i></h4></div><div class="info-destaque-ticket destaque"><h4 title="Em Destaque">Em Destaque <i class="fa fa-bell" aria-hidden="true"></i></h4></div><div class="info-few-avaliable-ticket few-tickets" ng-if="!!vm.verificaPoucasUnidade(ingresso)"><h4 title="Poucas Unidades">\xDAltimas {{vm.verificaPoucasUnidade(ingresso) | number:0}} unidades dispon\xEDveis!</h4></div></div><div class="row box-atracoes"><div class="col-xs-12"><h4 title="{{::ingresso.shortName}}" uib-tooltip="{{::ingresso.shortName}}" ng-click="vm.verMaisDetalhesProduto(ingresso)">{{::ingresso.shortName}}</h4><hr></div></div><div class="row actions-shopping"><div class="action-shopping pessoas"><div class="action-shopping dates row" ng-if="ingresso.dates.length > 1"><div class="col-xs-12"><small>Selecione a data de uso</small><div class="btn-group"><button title="{{date| date:\'dd/MM\'}}" aria-label="{{date| date:\'dd/MM\'}}" type="button" role="button" class="btn btn-default ripple" ng-class="{\'btn-success\': ingresso.date == date && ingresso.hasSelectedDate}" ng-repeat="date in ingresso.dates" ng-click="vm.selectDate(ingresso, date)">{{date| date:\'dd/MM\'}}</button></div></div><div class="col-xs-12"><hr role="separator"></div></div><div ng-include="\'app/new_ingressos/ing-parent-price.html\'"></div><div ng-include="\'app/new_ingressos/ing-child-price.html\'" ng-repeat="child in ingresso.children"></div></div></div></div>');
$templateCache.put('app/new_ingressos/layout-ingressos-dates.html','<section class="tabs-categorias-ingressos dates animated in fadeInUp time-15" ng-class="{\'one-cat\': vm.categoriasCombos.length === 1}" ng-init="vm.amountByLine = 3"><div ng-init="vm.naoEscolheData ? vm.search(vm.date) : \'\'"></div><uib-tabset ng-if="vm.categoriasCombos.length > 0" justified="true"><uib-tab index="categoria.id" tabindex="categoria.id" active="categoria.active" class="{{categoria.category}}" ng-repeat="categoria in vm.categoriasCombos"><uib-tab-heading><i class="hidden fa fa-thumbs-up" aria-hidden="true"></i> <i class="hidden fa fa-check" aria-hidden="true"></i><h3 title="{{categoria.category}}">{{categoria.category}}</h3></uib-tab-heading><div id="categoria_prod_{{categoria.id}}" class="row ingressos-row"><div class="col-md-12 title-tabs hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><h3 title="{{categoria.category}}">Categoria <strong>{{categoria.category}}</strong></h3><hr></div><div class="all-ingressos-tab" ng-if="categoria.active"><div class="row" ng-repeat="linha in categoria.linhas"><div id="idProduto_{{ingresso.id}}" class="col-xs-12 col-sm-6 col-md-4 col-lg-4 ingresso-col" ng-repeat="ingresso in linha | orderBy:\'order\'"><div class="ingressos-col-item {{ingresso.nivelDestaque}}" ng-class="{\'active-ingresso\': vm.valorTotalBox(ingresso) > 0}"><hr class="hover-show"><div class="row combo-header" style="background-image: url(\'{{::ingresso.image}}\')" ng-click="vm.verMaisDetalhesIngresso(ingresso)"><button title="Mais detalhes: {{::ingresso.shortName}}" ng-click="vm.verMaisDetalhesProduto(ingresso)" aria-label="Mais detalhes {{::ingresso.shortName}}" role="button" uib-tooltip="Mais detalhes {{::ingresso.shortName}}" type="button" class="btn time-05 ripple btn-warning"><i class="fa fa-plus" aria-hidden="true"></i> Detalhes</button><h3 title="{{::ingresso.category}}" class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Ingresso tipo {{::ingresso.category}}</h3><div class="info-destaque-ticket plus"><h4 title="Mais Vendidos">Mais Vendidos <i class="fa fa-tags" aria-hidden="true"></i></h4></div><div class="info-destaque-ticket medium"><h4 title="Experimente">Experimente <i class="fa fa-plus-circle" aria-hidden="true"></i></h4></div><div class="info-destaque-ticket minus"><h4 title="#Dica">#Dica <i class="fa fa-thumbs-up" aria-hidden="true"></i></h4></div><div class="info-destaque-ticket destaque"><h4 title="Em Destaque">Em Destaque <i class="fa fa-bell" aria-hidden="true"></i></h4></div></div><div class="row box-atracoes"><div class="col-xs-12"><h4 title="{{::ingresso.shortName}}" uib-tooltip="{{::ingresso.shortName}}" ng-click="vm.verMaisDetalhesProduto(ingresso)">{{::ingresso.shortName}}</h4></div></div><div class="row actions-shopping dates"><uib-tabset justified="true"><uib-tab index="{{$index}}{{::ingresso.id}}" tabindex="{{$index}}{{::ingresso.id}}" ng-repeat="date in ingresso.dates"><uib-tab-heading><i class="fa fa-check hidden" aria-hidden="true"></i><h3 title="{{date| date:\'dd/MM/yyyy\'}}" ng-click="vm.selectDate(ingresso, date)"><span class="fa fa-calendar" aria-hidden="true"></span> <b class="hidden-xs hidden-sm">{{date| date:\'dd/MM\'}}</b><b class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">{{date| date:\'dd/MM/yyyy\'}}</b></h3></uib-tab-heading><div id="categoria_prod_{{categoria.id}}" class="row ingressos-row"><div class="col-md-12 title-tabs" ng-if="ingresso.dates.length >= 1"><h3 title="Ingressos para o dia: {{::ingresso.date| date :\'dd/MM/yyyy\'}}">Ingressos: {{ingresso.date| date :\'dd/MM/yyyy\'}} <i class="fa fa-calendar" aria-hidden="true"></i></h3><hr></div><div class="all-ingressos-tab col-md-12"><div class="action-shopping adulto row"><div class="col-xs-7 padding-right-0"><label uib-tooltip="{{ingresso.years == null ? \'Ingressos\' : ingresso.years}}" for="typeIngresso_{{ingresso.id}}" class="label">{{ingresso.years == null ? \'Ingressos\' : ingresso.years}}</label><div class="btn-group" id="typeIngresso_{{::ingresso.id}}" role="group"><button title="Retirar um produto {{::ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" aria-label="Retirar um produto {{::ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" type="button" role="button" class="btn time-05 ripple btn-default minus" ng-click="vm.removeItem(ingresso)"><i class="fa fa-minus" aria-hidden="true"></i></button> <button title="N\xFAmero de produtos {{::ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}: {{child.amount}}" aria-label="N\xFAmero de produtos {{::ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}: {{child.amount}}" role="tooltip" type="button" role="button" class="btn time-05 btn-default value">{{ingresso.amount}}</button> <button title="Adicionar mais um produto {{::ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" aria-label="Adicionar mais um produto {{::ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" type="button" role="button" class="btn time-05 ripple btn-default plus" ng-click="vm.addItem(ingresso)"><i class="fa fa-plus" aria-hidden="true"></i></button></div></div><div ng-if="!ingresso.oldValue" class="col-xs-5 padding-left-0 prices"><label class="label" for="valor_{{::ingresso.id}}">Valor Ingresso</label><h5 title="{{(ingresso.amount > 0 ? ingresso.value * ingresso.amount : ingresso.value) / 100 | currency:\'R$ \'}}" id="valor_{{::ingresso.id}}">{{(ingresso.amount > 0 ? ingresso.value * ingresso.amount : ingresso.value) / 100 | currency:\'R$ \'}}</h5></div><div ng-if="ingresso.oldValue" class="col-xs-5 padding-left-0 prices old"><label class="label" for="valor_{{ingresso.id}}">Valor Ingresso</label><h6 title="De {{ingresso.oldValue / 100| currency:\'R$ \'}}">De {{ingresso.oldValue / 100| currency:\'R$ \'}}</h6><h5 title="{{(ingresso.amount > 0 ? ingresso.value * ingresso.amount : ingresso.value) / 100 | currency:\'R$ \'}}" id="valor_{{::ingresso.id}}">{{(ingresso.amount > 0 ? ingresso.value * ingresso.amount : ingresso.value) / 100 | currency:\'R$ \'}}</h5></div><div class="col-xs-12"><hr role="separator"></div></div><div class="action-shopping crianca row" ng-repeat="child in ingresso.children"><div class="col-xs-7 padding-right-0"><label uib-tooltip="{{child.years == null ? \'Ingressos\': child.years}}" for="typeIngressoChild_{{child.id}}" class="label">{{child.years == null ? \'Ingressos\': child.years}}</label><div class="btn-group" id="typeIngressoChild_{{child.id}}" role="group"><button title="Retirar um produto {{::child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" aria-label="Retirar um produto {{::child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" type="button" role="button" class="btn time-05 ripple btn-default minus" ng-click="vm.removeItem(child)"><i class="fa fa-minus" aria-hidden="true"></i></button> <button title="N\xFAmero de produtos {{::child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}: {{child.amount}}" aria-label="N\xFAmero de produtos {{::child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}: {{child.amount}}" role="tooltip" type="button" role="button" class="btn time-05 btn-default value">{{child.amount}}</button> <button title="Adicionar mais um produto {{::child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" aria-label="Adicionar mais um produto {{::child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" type="button" role="button" class="btn time-05 ripple btn-default plus" ng-click="vm.addItem(child)"><i class="fa fa-plus" aria-hidden="true"></i></button></div></div><div ng-if="child.oldValue" class="col-xs-5 padding-left-0 prices old"><label class="label" for="valor_child_{{::child.id}}">Valor Ingresso</label><h6 title="De {{child.oldValue / 100| currency:\'R$ \'}}">De {{child.oldValue / 100| currency:\'R$ \'}}</h6><h5 title="{{(child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \'}}" id="valor_child_{{child.id}}">{{(child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \'}}</h5></div><div ng-if="!child.oldValue" class="col-xs-5 padding-left-0 prices"><label class="label" for="valor_child_{{::child.id}}">Valor Ingresso</label><h5 title="{{(child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \'}}" id="valor_child_{{child.id}}">{{(child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \'}}</h5></div><div class="col-xs-12"><hr role="separator"></div></div><div class="row shopping-cart"><div class="col-xs-6 count-ticket"><h5 title="{{vm.countTotalBox(ingresso) > 1 ? \'Ingressos\' : \'Ingresso\'}} {{vm.countTotalBox(ingresso)}}">{{vm.countTotalBox(ingresso)}} {{vm.countTotalBox(ingresso) > 1 ? \' Ingressos\' : \' Ingresso\'}}</h5></div><div class="col-xs-6 value-ticket"><h5 title="Total {{vm.valorTotalBox(ingresso) | currency:\'R$ \'}}">{{vm.valorTotalBox(ingresso) | currency:\'R$ \'}}</h5></div><div class="col-xs-12"><button title="Adicionar {{vm.countTotalBox(ingresso)}} {{vm.countTotalBox(ingresso) > 1 ? \'produtos\':\'produto\'}}: {{ingresso.shortName|| ingresso.name}} ao carrinho" aria-label="Adicionar {{vm.countTotalBox(ingresso)}} {{vm.countTotalBox(ingresso) > 1 ? \'produtos\':\'produto\'}}: {{ingresso.shortName|| ingresso.name}} ao carrinho" type="button" role="button" class="btn time-05 ripple btn-shadow btn-sucess btn-block comprar" ng-click="vm.addToCart(ingresso)" ng-disabled="vm.verificaAmountSeniorAdultoIncluso(ingresso)"><b ng-show="!ingresso.loading">{{vm.verificaAmountSeniorAdultoIncluso(ingresso) ? \'Nenhum produto escolhido\' : \'Adicionar ao Carrinho\' }} <i class="fa fa-shopping-cart" aria-hidden="true"></i></b> <b ng-show="ingresso.loading" class="loanding"><i class="spinner-timer-2 fa fa-spinner" aria-hidden="true"></i> Adicionando ao Carrinho...</b></button></div></div></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></uib-tab></uib-tabset><div ng-if="vm.categoriasCombos.length == 0" class="row not-ingressos"><figure class="col-md-12"><img title="Ingressos n\xE3o dispon\xEDveis" alt="Ilustra\xE7\xE3o de Ingressos n\xE3o dispon\xEDveis" class="img-responsive" ng-src="assets/gifs/casal-esperando.gif"></figure></div></section>');
$templateCache.put('app/new_ingressos/layout-ingressos-extras-scroll.html','<section class="row b2c-recommendations b2c-ofertas animated time-05 fadeIn"><div class="col-md-12"><button title="Mais ofertas" id="scrollEsquerda_extras" class="btn btn-default b2c-handle handlePrev" onclick="scrollEsquerda()"><i class="fa fa-caret-left" aria-hidden="true"></i></button><div class="content-recommendations" id="scrollHorizontal_extras"><div class="row b2c-scroll-horizontal"><div class="col-md-3 col b2c-col-ofertas" ng-repeat="product in vm.extraProducts"><div class="box-img background-cover" style="background-image: url(\'{{product.image}}\')"><button title="Ver mais detalhes do ingresso: {{product.shortName|| product.name}}" type="button" role="button" aria-label="Ver mais detalhes do ingresso: {{product.shortName|| product.name}}" class="btn btn-warning btn-min btn-detalhes" ng-click="vm.onpenModalInfoSimple(product)"><i class="fa fa-plus" aria-hidden="true"></i> Detalhes</button><div class="valores"><h2 title="{{product.value / 100| currency:\'R$ \'}}">{{product.value / 100| currency:\'R$ \'}}</h2></div><div class="nome"><h2 title="{{product.shortName|| product.name}}">{{product.shortName|| product.name}}</h2></div></div><div class="body"><div class="footer"><button title="Adicionar ao Carrinho" type="button" role="button" class="btn btn-success btn-block" ng-click="vm.addExtraProduct(product)"><i class="fa fa-spinner fa-spin hidden" aria-hidden="true" ng-show="product.loading"></i> <i class="fa fa-plus" aria-hidden="true"></i> Adicionar ao Carrinho</button></div></div></div></div></div><button title="Mais Ofertas" id="scrollDireita_extras" type="button" role="button" class="btn btn-default b2c-handle handleNext" onclick="scrollDireita()"><i class="fa fa-caret-right" aria-hidden="true"></i></button></div></section><script type="text/javascript">var scrollHorizontal_extras = document.getElementById("scrollHorizontal_extras");\n    function scrollDireita () {\n        scrollHorizontal_extras.scrollLeft += 430;\n    }\n    function scrollEsquerda() {\n        scrollHorizontal_extras.scrollLeft -= 430;\n    }</script>');
$templateCache.put('app/new_ingressos/layout-ingressos-extras.html','<section class="row b2c-extras animated time-05 fadeIn"><div class="col-md-3 col b2c-col-ofertas" ng-repeat="product in vm.extraProducts | filter : vm.filterExtras"><div class="box-img background-cover" style="background-image: url(\'{{product.image}}\')" ng-click="vm.verMaisDetalhesProduto(product)"><button title="Ver mais detalhes do ingresso: {{product.shortName|| product.name}}" aria-label="Ver mais detalhes do ingresso: {{product.shortName|| product.name}}" type="button" role="button" class="btn btn-warning btn-min btn-detalhes" ng-click="vm.verMaisDetalhesProduto(product)"><i class="fa fa-plus" aria-hidden="true"></i> Detalhes</button><div class="valores" ng-if="product.esgotado !== \'true\'"><span title="{{(product.amount > 0 ? product.oldValue * product.amount : product.oldValue) / 100 | currency:\'R$ \'}}" id="valor_{{::product.id}}" style="color: white; font-size: 1.35rem; text-decoration: line-through;">{{(product.amount > 0 ? product.oldValue * product.amount : product.oldValue) / 100 | currency:\'R$ \'}}</span><h2 title="{{product.value / 100| currency:\'R$ \'}}">{{product.value / 100| currency:\'R$ \'}}</h2></div><div class="nome"><h2 title="{{product.shortName|| product.name}}">{{product.shortName|| product.name}}</h2></div></div><div class="body"><div class="footer"><button title="Adicionar ao Carrinho" type="button" role="button" class="btn btn-success btn-block" ng-disabled="product.esgotado === \'true\'" ng-click="vm.addExtraProduct(product)"><i class="fa fa-spinner fa-spin hidden" aria-hidden="true" ng-show="product.loading"></i> <i class="fa fa-plus" aria-hidden="true"></i> {{product.esgotado === "true" ? \'Esgotado\': \'Adicionar ao carrinho\' }}</button></div></div></div><div ng-if="vm.extraProducts.length === 0" class="col-md-12 warning-void-extras"><div ng-if="vm.cart.length === 1">N\xE3o Possui Extras dispon\xEDvel para esse produto.</div><div ng-if="vm.cart.length > 1">N\xE3o Possui Extras dispon\xEDvel para esses produtos.</div></div></section>');
$templateCache.put('app/new_ingressos/layout-ingressos.html','<section class="tabs-categorias-ingressos animated in fadeInUp time-15" ng-class="{\'one-cat\': vm.categoriasCombos.length === 1}"><div ng-init="vm.naoEscolheData ? vm.search(vm.date) : \'\'"></div><h4 class="title-escolha-ingresso"></h4><uib-tabset ng-if="vm.categoriasCombos.length > 0" justified="true"><uib-tab index="categoria.id" tabindex="categoria.id" active="categoria.active" class="{{categoria.category | noSpace}}" ng-repeat="categoria in vm.categoriasCombos"><uib-tab-heading><i class="hidden fa fa-thumbs-up" aria-hidden="true"></i> <i class="hidden fa fa-check" aria-hidden="true"></i><h3 title="{{categoria.category}}">{{categoria.category}}</h3></uib-tab-heading><div id="categoria_prod_{{categoria.id}}" class="row ingressos-row"><div class="all-ingressos-tab col-md-12"><div class="row" ng-repeat="linha in categoria.linhas"><div id="idProduto_{{ingresso.id}}" class="col-xs-12 col-sm-6 col-md-3 col-lg-3 ingresso-col" ng-repeat="ingresso in linha"><div ng-include="\'app/new_ingressos/layout-ingresso.html\'"></div></div></div></div></div></uib-tab></uib-tabset><div ng-if="vm.step === \'produtos\' && vm.categoriasCombos.length == 0" class="row not-ingressos"><figure class="col-md-12"><img title="Ingressos n\xE3o dispon\xEDveis" alt="Ilustra\xE7\xE3o de Ingressos n\xE3o dispon\xEDveis" class="img-responsive" src="assets/gifs/casal-esperando.gif"></figure></div><div ng-if="vm.cart.length > 0" class="row hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><div class="col-md-12"><br><button title="Ver Carrinho" type="button" role="button" class="btn-success btn btn-lg btn-block" ng-click="vm.nextStep()">Ver Carrinho <i class="fa fa-shopping-cart"></i></button><br></div></div></section><div class="message-notification-ticket"><p></p></div>');
$templateCache.put('app/trocarDatas/trocarDatas.html','<div class="container"><div class="row" ng-if="!vm.urlVoucher"><h3 class="col-xs-10 col-xs-offset-1">Localizador {{vm.locator}}</h3><div class="col-xs-10 col-xs-offset-1 row" ng-repeat="p in vm.products"><div class="col-md-6"><div class="form-group"><label for="datadeacesso">Item</label> <input type="text" class="form-control" disabled="true" ng-model="p._name"></div></div><div class="col-md-6" ng-if="!p.produtos || !p.select_date"><div class="form-group"><label for="datadeacesso">Data</label><div class="input-group"><input type="text" class="form-control" ng-model="p._date" datepicker-template-url="template/datepicker/datepicker.html" ng-disabled="p.deliveryDate" uib-datepicker-popup="dd/MM/yyyy" readonly="readonly" is-open="p._activeDate" ng-click="vm.handleDate(p)" min-date="p._minDate" custom-class="vm.getDayClass(date, mode, p)" date-disabled="vm.disabledDate(date, mode, p)" required> <span class="input-group-addon"><a ng-click="vm.handleDate(p)"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div></div></div><div class="col-md-6" ng-if="p.produtos && p.select_date"><div class="form-group" ng-repeat="p2 in p.produtos"><label for="datadeacesso">{{$index + 1}}\xAA Data</label><div class="input-group"><input type="text" class="form-control" ng-model="p2._date" datepicker-template-url="template/datepicker/datepicker.html" ng-disabled="p2.deliveryDate" uib-datepicker-popup="dd/MM/yyyy" readonly="readonly" is-open="p2._activeDate" ng-click="vm.handleDate(p2)" min-date="p._minDate" max-date="p._maxDate" ng-change="vm.adjustDates(p)" custom-class="vm.getDayClass(date, mode, p2)" date-disabled="vm.disabledDate(date, mode, p2) || vm.disabledDate(date, mode, p)" required> <span class="input-group-addon"><a ng-click="vm.handleDate(p2)"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div></div></div></div><div class="col-xs-10 col-xs-offset-1 row"><div class="col-md-4 col-md-offset-8"><div class="form-group"><button type="button" class="form-control btn btn-primary pull-right" ng-click="vm.save()">Salvar&nbsp;<i class="fa fa-next"></i></button></div></div></div></div><div class="row" ng-if="vm.urlVoucher"><br><br><div class="col-xs-10 col-xs-offset-1 col-md-2 col-md-offset-5"><a title="VOUCHER" class="btn btn-success btn-block btn-large" target="_blank" rel="noopener" href="{{vm.urlVoucher}}"><i class="fa fa-print"></i> VOUCHER</a></div><br><br></div><br></div>');
$templateCache.put('app/components/auth/socialLogin.html','<div class="row"><div class="col-xs-12"><span class="h4">Selecione a forma de acesso:</span></div></div><div class="row"><div class="col-xs-12 text-center social-button"><button type="button" class="btn btn-primary left-icon-holder" ng-click="vm.resetUser();vm.tipo=\'Email\';" style="width: 189px; height: 28px; padding-top: 4px;font-size: 15px; font-weight: bold;"><i class="fa fa-envelope-o"></i>&nbsp;Entrar com Email&nbsp;</button></div></div><div class="row"><div class="col-xs-12 social-button" onload="googleload()"><div class="g-signin2" data-height="28" data-width="189" data-theme="dark" data-onsuccess="onGoogleSignIn"></div></div></div><div class="row"><div class="col-xs-12 text-center social-button"><div class="fb-login-button" scope="public_profile,email" data-size="medium" data-button-type="login_with" data-layout="default" data-auto-logout-link="false" data-use-continue-as="false" onlogin="checkLoginState();"></div></div></div><style>.social-button{\n        padding-bottom: 5px;\n    }\n    .g-signin2{\n      width: 100%;\n    }\n\n    .g-signin2 > div{\n        margin: 0 auto;\n    }\n    .abcRioButtonContents{\n        font-size: 14px !important;\n        font-weight: bold;\n    }\n    .left-icon-holder {\n        position:relative;\n    }\n    .left-icon-holder .fa {\n        position:absolute;\n        line-height: 24px;\n        top:50%;\n        margin-top: -12px; /* Half of line height to keep left middle postion of container */\n        left: 7px;\n    }</style><script>function onGoogleSignIn(googleUser) {\n        if (_canGoogleSignIn) _onGoogleSignIn(googleUser);        \n    }</script><script src="https://apis.google.com/js/platform.js" async defer="defer"></script><script>function googleload() {\n        console.log("googleload");\n    }\n    //abcRioButtonContentWrapper</script><script>function checkLoginState() {\n        FB.getLoginStatus(function(response) {                \n            console.log(response);\n            if (response.status == \'connected\') {\n                FB.api(\'/me?fields=name,email\', function(me) {\n                    console.log(me);\n                    me.accessToken = response.authResponse.accessToken;\n                    console.log(\'Good to see you, \' + me.name + \'.\');\n                    _onFacebookSignIn(me);\n                });                    \n            }\n        });\n    }   \n    window.fbAsyncInit = function() {\n        window._onFacebookInit(FB);\n    };  \n    (function(d, s, id){\n       var js, fjs = d.getElementsByTagName(s)[0];\n       if (d.getElementById(id)) {return;}\n       js = d.createElement(s); js.id = id;\n       js.src = "https://connect.facebook.net/pt_BR/sdk.js";\n       fjs.parentNode.insertBefore(js, fjs);\n    }(document, \'script\', \'facebook-jssdk\'));</script>');
$templateCache.put('app/components/productDialog/productDialog.html','<div class="b2b-modal-product-form"><div class="modal-header"><h3 title="Dados Adicionais">Dados Adicionais</h3></div><div class="modal-body"><div class="row"><form tabindex="-1" name="formProductDialog" class="form" role="form"><div xs-form-input ng-repeat="input in vm.inputs" class="col-md-12"></div></form></div></div><div class="modal-footer"><button title="Cancelar" class="btn btn-warning" type="button" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-primary" type="button" ng-click="vm.close()" ng-disabled="vm.isInValid()">OK</button></div></div>');
$templateCache.put('app/components/dialogs/again.html','<div class="dialog-header-again-travel"><div class="modal-header dialog-header-again"><h4 title="{{vm.title}}" class="modal-title"><i class="fa fa-retweet" aria-hidden="true"></i> {{vm.title}}</h4></div><div class="modal-body"><div class="row"><figure class="col-md-6 text-center"><img title="Tentar Novamente" alt="Tentar Novamente" class="img-responsive" src="assets/images/layout/img-suitcases-collection-travel.png"></figure><aside class="col-md-6"><h2 ng-if="!vm.message" title="Nenhum item encontrado. Por favor tente outra data ou altere a quantidade de h\xF3spedes!">Nenhum item encontrado. Por favor tente outra data ou altere a quantidade de h\xF3spedes!</h2><h2 ng-if="vm.message" title="{{vm.message}}"><i class="fa fa-warning"></i>&nbsp;{{vm.message}}</h2></aside></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><button title="Tentar Novamente" class="btn btn-success btn-lg radius-0" ng-click="vm.dismiss()" type="button">Tentar Novamente <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div></div></div></div>');
$templateCache.put('app/components/dialogs/answer.html','<div class="modal-header dialog-header-answer"><h4 class="modal-title">{{vm.title || vm.question}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12">{{vm.question}}</div><div class="col-xs-12"><input type="text" class="form-control" ng-model="vm.answer"></div></div></div><div class="modal-footer"><button title="Cancelar" class="btn btn-warning" type="button" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-primary" type="button" ng-click="vm.close()">OK</button></div>');
$templateCache.put('app/components/dialogs/confirm.html','<div class="modal-header dialog-header-confirm"><h4 title="{{vm.title}}" class="modal-title">{{vm.title}}<i class="fa fa-question fa-invert"></i></h4></div><div class="modal-body"><div class="row"><div class="col-md-12 text-center"><p class="text-center" ng-bind-html="vm.message"></p></div></div></div><div class="modal-footer"><div class="row" style="display: flex; gap: 2rem; align-items: center; justify-content: end;"><div><a title="N\xE3o" class="btn btn-default pull-right" ng-click="vm.dismiss()">N\xE3o</a></div><div><a title="Sim" class="btn btn-success" ng-click="vm.close()">Sim</a></div></div></div>');
$templateCache.put('app/components/dialogs/datePickerDialog.html','<div class="dialog-datepicker"><div class="modal-header"><h2 title="{{vm.title}}" class="modal-title">{{vm.title}}</h2></div><div class="modal-body layout-calendar"><div class="well well-sm" uib-datepicker ng-model="vm.date" datepicker-options="{showWeeks:false, startingDay:0}" init-date="vm.options.minDate" min-date="vm.options.minDate" max-date="vm.options.maxDate" custom-class="vm.options.customClass(date, mode)" date-disabled="vm.options.dateDisabled(date, mode)"></div></div><div class="modal-footer"><a title="Fechar" class="btn btn-default" ng-click="vm.dismiss()">Fechar</a> <a title="OK" class="btn btn-success" ng-click="vm.close()">OK</a></div></div>');
$templateCache.put('app/components/dialogs/error.html','<div class="modal-header dialog-header-error"><h4 title="Importante" class="modal-title">Importante</h4></div><div class="modal-body dialog-body-error"><div class="row"><div class="col-md-2"><i class="fa fa-times-circle fa-invert fa-3x" aria-hidden="true"></i></div><div class="col-md-10"><p ng-bind-html="vm.message"></p></div></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><button title="OK" class="btn btn-default btn-danger" type="button" ng-click="vm.dismiss()">OK</button></div></div></div>');
$templateCache.put('app/components/dialogs/foto.html','<div class="b2c-modal-galeria"><div class="modal-header"><div class="row"><div class="col-md-11"><h2 title="{{vm.title}}" class="modal-title">{{vm.title}}</h2></div><div class="col-md-1"><a title="Fechar" class="float-right" ng-click="vm.dismiss()"><i class="fa fa-times fa-3x" aria-hidden="true"></i></a></div></div></div><div class="modal-body"><div class="row"><div class="col-md-12"><div uib-carousel active="$index" interval="5000" no-wrap="true" ng-show="vm.fotos.length > 0"><div uib-slide ng-repeat="foto in vm.fotos track by $index" index="$index"><img title="Imagem {{vm.title}}" alt="Imagem do empreendimento {{vm.title}}" ng-src="{{foto}}" width="100%"><div class="carousel-caption"><h4 title="{{vm.title}}">{{vm.title}}</h4></div></div></div><h4 title="N\xE3o h\xE1 fotos!" align="center" ng-show="vm.fotos.length <= 0">N\xE3o h\xE1 fotos!</h4></div></div></div><div class="modal-footer"></div></div>');
$templateCache.put('app/components/dialogs/iframe.html','<div class="b2c-modal-iframe"><div class="modal-header text-center"><h3>Concluir pagamento</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-10 col-sm-offset-1 text-center"><img title="Parab\xE9ns pela compra realizada" class="img-responsive" alt="Parab\xE9ns pela compra realizada" ng-src="assets/images/layout/imagem-confirmacao-ingressos.jpg"><h4 title="Parab\xE9ns! Compra realizada com sucesso"><i class="fa fa-ticket"></i>Parab\xE9ns! Compra realizada com sucesso</h4></div><div class="col-xs-12 col-sm-10 col-sm-offset-1" ng-if="vm.url"><a class="col-xs-12 btn btn-success" href="{{vm.url}}" target="_blank">Clique aqui para efetuar pagamento.</a></div></div></div></div>');
$templateCache.put('app/components/dialogs/iframe_authenticate.html','<div class="b2c-modal-iframe"><div class="modal-header text-center"><h3>Concluir pagamento</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-10 col-sm-offset-1 text-center"><img title="Parab\xE9ns pela compra realizada" class="img-responsive" alt="Para concluir o pagamento \xE9 necess\xE1rio fazer autentica\xE7\xE3o junto ao banco" ng-src="assets/images/layout/imagem-confirmacao-ingressos.jpg"><h4 title="Para concluir o pagamento \xE9 necess\xE1rio fazer autentica\xE7\xE3o junto ao banco"><i class="fa fa-ticket"></i>Para concluir o pagamento \xE9 necess\xE1rio fazer autentica\xE7\xE3o junto ao banco</h4></div><div class="col-xs-12 col-sm-10 col-sm-offset-1" ng-if="vm.url"><a class="col-xs-12 btn btn-success" href="{{vm.url}}" target="_blank">Clique aqui para efetuar pagamento.</a></div></div></div></div>');
$templateCache.put('app/components/dialogs/info.html','<div class="modal-header dialog-header-message"><h4 title="{{vm.title}}" class="modal-title"><i class="fa fa-exclamation-triangle fa-invert" aria-hidden="true"></i> {{vm.title}}</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 text-center"><p class="text-center" ng-bind-html="vm.message"></p></div></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><a title="OK" class="btn btn-default" ng-click="vm.dismiss()">OK</a></div></div></div>');
$templateCache.put('app/components/dialogs/modal-cliente.html','<div class="b2b-modal-orcamento-mail"><div class="modal-header"><h3 title="Email do Cliente">{{vm.title}}</h3></div><div class="modal-body"><form tabindex="-1" name="formCliente" class="form" role="form"><div class="form-group has-feedback" ng-class="{\'has-success\': formCliente.nome.$touched && formCliente.nome.$valid, \'has-error\': formCliente.nome.$touched && formCliente.nome.$invalid}"><label class="control-label" for="nome">Digite o nome completo <em class="text-danger" ng-show="formCliente.nome.$touched && formCliente.nome.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input id="nome" name="nome" type="text" class="form-control" placeholder="Digite o nome completo" ng-model="vm.cliente.name" required><div ng-show="formCliente.nome.$touched && (formCliente.nome.$invalid || vm.cliente.name.indexOf(\' \')<0)" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="formCliente.nome.$touched && formCliente.nome.$valid && vm.cliente.name.indexOf(\' \')>0" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div><div class="form-group has-feedback" ng-class="{\'has-success\': formCliente.email.$touched && formCliente.email.$valid, \'has-error\': formCliente.email.$touched && formCliente.email.$invalid}"><label class="control-label" for="email">Email *<em class="text-danger" ng-show="formCliente.email.$touched && formCliente.email.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input id="email" name="email" type="email" class="form-control" placeholder="Email" ng-model="vm.cliente.email" required><div ng-show="formCliente.email.$touched && formCliente.email.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="formCliente.email.$touched && formCliente.email.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div><div class="form-group has-feedback"><label class="control-label" for="celular">Celular * <em class="text-danger" ng-show="formCliente.telefone.$touched && formCliente.telefone.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input name="Celular" type="text" id="celular" class="form-control" ng-model="vm.cliente.cellPhone" ui-mask="(99) 9?9999-9999" placeholder="(DDD) 0 0000-0000" ui-mask-placeholder ng-required="true"><div ng-show="formCliente.telefone.$touched && formCliente.telefone.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="formCliente.telefone.$touched && formCliente.telefone.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></form></div><div class="modal-footer"><button title="Cancelar" class="btn btn-warning" type="button" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-primary" type="button" ng-click="vm.close()" ng-disabled="!(formCliente.$valid && vm.cliente.name.indexOf(\' \')>0)">OK</button></div></div>');
$templateCache.put('app/components/dialogs/modal_address.html','<div class="b2b-modal-orcamento-mail"><div class="modal-header"><h3 title="Email do Cliente">{{vm.title}}</h3></div><div class="modal-body"><form tabindex="-1" name="formAddress" class="form" role="form"><div><div class="row"><div class="form-group col-md-6"><input type="text" class="form-control" placeholder="Logradouro" ng-model="vm.user.street0" id="street0" ng-required="true"></div><div class="form-group col-md-6"><input type="text" class="form-control" placeholder="Complemento" ng-model="vm.user.address" id="address"></div><div class="form-group col-md-6"><input type="text" class="form-control" placeholder="Bairro" ng-model="vm.user.street1" id="street1" ng-required="true"></div><div class="form-group col-md-6"><input type="text" class="form-control" placeholder="Cidade" ng-model="vm.user.city" id="city" ng-required="true"></div><div class="form-group col-md-6"><select class="form-control" ng-model="vm.user.state" id="state" ng-required="true"><option value="">Selecione o Estado</option><option value="ac">Acre</option><option value="al">Alagoas</option><option value="am">Amazonas</option><option value="ap">Amap\xE1</option><option value="ba">Bahia</option><option value="ce">Cear\xE1</option><option value="df">Distrito Federal</option><option value="es">Esp\xEDrito Santo</option><option value="go">Goi\xE1s</option><option value="ma">Maranh\xE3o</option><option value="mt">Mato Grosso</option><option value="ms">Mato Grosso do Sul</option><option value="mg">Minas Gerais</option><option value="pa">Par\xE1</option><option value="pb">Para\xEDba</option><option value="pr">Paran\xE1</option><option value="pe">Pernambuco</option><option value="pi">Piau\xED</option><option value="rj">Rio de Janeiro</option><option value="rn">Rio Grande do Norte</option><option value="ro">Rond\xF4nia</option><option value="rs">Rio Grande do Sul</option><option value="rr">Roraima</option><option value="sc">Santa Catarina</option><option value="se">Sergipe</option><option value="sp">S\xE3o Paulo</option><option value="to">Tocantins</option></select></div></div></div></form></div><div class="modal-footer"><button title="Cancelar" class="btn btn-warning" type="button" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-primary" type="button" ng-click="vm.close()" ng-disabled="formAddress.$invalid">OK</button></div></div>');
$templateCache.put('app/components/dialogs/modal_chd.html','<div class="b2c-modal-iframe"><div class="modal-header text-center"><h3>Crian\xE7as</h3></div><div class="modal-body"><div class="row"><div class="chd" ng-class="{\'col-md-12\': vm.notUseTerId, \'col-md-6\': !vm.notUseTerId}"><div class="form-group"><label>Quantidade de Crian\xE7as</label> <select class="form-control" ng-model="vm.chd"><option value="" disabled="disabled">Crian\xE7as</option><option value="0">0 Crian\xE7as</option><option value="1">1 Crian\xE7a</option><option value="2">2 Crian\xE7as</option><option value="3">3 Crian\xE7as</option><option value="4">4 Crian\xE7as</option></select></div><div class="form-group" ng-repeat="chd in vm.chds"><label>Idade da {{$index + 1}}\xBA Crian\xE7a</label> <select class="form-control select-idade-chd" ng-model="chd.idade" ng-options="i as i for i in vm.idades"><option value="" disabled="disabled">{{chd.idade}}</option></select></div></div><div class="col-md-6 terceiraIdade" ng-if="!vm.notUseTerId"><div class="form-group"><label>Quantidade de Melhor Idade</label> <select class="form-control" ng-model="vm.terceiraidade"><option value="" disabled="disabled">Melhor Idade</option><option value="0">0 Melhor Idade</option><option value="1">1 Melhor Idade</option><option value="2">2 Melhor Idade</option><option value="3">3 Melhor Idade</option><option value="4">4 Melhor Idade</option><option value="5">5 Melhor Idade</option><option value="6">6 Melhor Idade</option></select></div><div class="form-group" ng-repeat="terceiraidade in vm.terceiraidades"><label>Idade do {{$index + 1}}\xBA Melhor Idade</label> <select class="form-control select-idade-mid" ng-model="terceiraidade.idade" ng-options="i as i for i in vm.idades2"><option value="" disabled="disabled">{{terceiraidade.idade}}</option></select></div></div></div><div class="modal-footer"><button class="btn btn-warning" type="button" ng-click="vm.dismiss()">Cancelar</button> <button class="btn btn-primary" type="button" ng-click="vm.ok()">OK</button></div></div></div>');
$templateCache.put('app/components/dialogs/remarcacao.html','<div class="modal-header dialog-header-confirm"><h4 title="Pol\xEDtica para Altera\xE7\xE3o da data de Visita" class="modal-title">Pol\xEDtica para Altera\xE7\xE3o da data de Visita</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12"><p>O reagendamento possibilita que nossos clientes alterem suas compras, recebendo o cr\xE9dito do valor pago para utilizar na compra de novos produtos.<br>Siga os passos abaixo:<br>1. Verifique antecipadamente, no calend\xE1rio do site, a disponibilidade dos produtos.<br>2. No menu "Minhas Compras", clique no bot\xE3o de "REAGENDAR".<br>3. Clicando no bot\xE3o "Li e aceito", siga o mesmo processo da compra.<br>4.O carrinho de compras apresenta o valor "Total" da compra e no "Total a pagar" est\xE1 creditado o valor pago pelo cliente.<br><br>Aten\xE7\xE3o:<br>Caso o valor da compra atual seja menor que o valor pago, a diferen\xE7a n\xE3o ser\xE1 devolvida, nem creditado valor para uso futuro. Caso seja conclu\xEDda a opera\xE7\xE3o o valor da compra ser\xE1 ajustada e o Voucher emitido.</p></div></div></div><div class="modal-footer"><div class="row"><div class="col-xs-2 pull-right"><a title="Li e aceito" class="btn btn-success" ng-click="vm.close()">Li e aceito</a></div><div class="col-xs-10 pull-right"><a title="N\xE3o concordo" class="btn btn-default" ng-click="vm.dismiss()">N\xE3o concordo</a></div></div></div>');
$templateCache.put('app/components/dialogs/wait.html','<div ng-include="\'app/components/dialogs/wait_template.html\'"></div>');
$templateCache.put('app/components/dialogs/wait_template.html','<div class="modal-header dialog-header-wait"><h4 title="Por Favor Aguarde" class="modal-title"><i class="fa fa-clock-o" aria-hidden="true"></i> Por Favor Aguarde</h4></div><div class="modal-body spinner-container"><span class="spinner-inline" aria-hidden="true"><svg viewBox="-1.76 -1.76 19.52 19.52" xmlns="http://www.w3.org/2000/svg" class="spinner-svg" fill="none"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z" opacity=".2"/><path d="M7.25.75A.75.75 0 018 0a8 8 0 018 8 .75.75 0 01-1.5 0A6.5 6.5 0 008 1.5a.75.75 0 01-.75-.75z"/></g></svg></span><p class="spinner-text" ng-bind-html="vm.message" ng-if="vm.message"></p><p class="spinner-text" ng-if="!vm.message">Aguarde</p></div>');
$templateCache.put('app/components/search/xsPaidButton.html','<div class="loja-balao-carrinho animated ripple pulse-button" ng-class="{\'bounceInUp\':vm.show}" ng-if="vm.show" uib-tooltip="Concluir Compra" tooltip-placement="left" tooltip-append-to-body><a ui-sref="hospedagemPagamento({ids: vm.ids})"><p align="center"><i class="fa fa-shopping-cart fa-2x" aria-hidden="true"></i> <span class="badge">{{vm.amount}}</span></p></a></div>');
$templateCache.put('app/components/xsBreadcrumb/xsBreadcrumb.html','<section ng-if="!vm.verificaSinglehotel" class="row b2c-breadcrumb"><ol class="col-md-12" style="max-width: {{vm.sizeWidthMobileBreadcrumb}};"><li ng-class="{\'check\': $index < vm.xsStep, \'check-active\': $index == vm.xsStep, \'no-check\': $index > vm.xsStep}" ng-repeat="step in vm.reservationSteps"><a title="{{step.title}}" ui-sref="{{step.route}}" ng-disabled="{{$index > vm.xsStep}}"><i class="fa" ng-class="{\'fa-check-circle-o\': $index < vm.xsStep, \'fa-circle\': $index == vm.xsStep, \'fa-circle-o\': $index > vm.xsStep}" aria-hidden="true"></i> <span>{{$index + 1}}\xAA {{step.title}}</span></a></li></ol></section>');
$templateCache.put('app/components/xsConfirm/botoesCompartilhamento.html','<div class="row loja-agradecimento-social"><div class="col-xs-12 col-md-10 col-md-offset-1"><div class="row"><div class="col-xs-12"><h3 title="Conte aos seus amigos onde voc\xEA vai!" class="text-bold">Conte aos seus amigos onde voc\xEA vai!</h3></div><div class="col-md-4 col-xs-12 box-whatsapp"><a title="Compartilhar no Whatsapp" href="https://api.whatsapp.com/send?text={{vm.host | urlEncode}}" class="btn btn-default btn-whatsapp btn-block btn-scala btn-sm" target="_blank" rel="noopener" data-size="large" data-dnt="true"><i class="fa fa-whatsapp" aria-hidden="true"></i> Whatsapp</a></div><div class="col-md-4 col-xs-12 box-facebook"><div class="fb-share-button"><a title="Compartilhar no Facebook" class="fb-xfbml-parse-ignore btn btn-default btn-facebook btn-block btn-scala btn-sm" target="_blank" rel="noopener" rel="noopener" href="https://www.facebook.com/sharer/sharer.php?u={{ vm.host | urlEncode }}"><i class="fa fa-facebook-official" aria-hidden="true"></i> Facebook</a></div></div><div class="col-md-4 col-xs-12 box-twitter"><a title="Compartilhar no Twitter" href="https://twitter.com/share?url={{vm.host | urlEncode}}" class="btn btn-default btn-twitter btn-block btn-scala btn-sm" target="_blank" rel="noopener" data-size="large" data-dnt="true"><i class="fa fa-twitter" aria-hidden="true"></i> Tweet</a></div></div></div></div>');
$templateCache.put('app/components/xsConfirm/xsConfirm.html','<section class="row loja-box-float loja-agradecimento" ng-if="vm.reservation.id > 0"><div class="col-md-8 col-md-offset-2 loja-agradecimento-card loja-box-float-card"><div class="row linha-img-agradecimento" ng-if="!vm.reservation.qrcode"><img title="Parab\xE9ns pela compra realizada" alt="Parab\xE9ns pela compra realizada" class="img-responsive" ng-src="assets/images/layout/imagem-confirmacao-ingressos.jpg"></div><div class="row"><div class="col-md-12"><h1 title="Parab\xE9ns! Compra realizada com sucesso" ng-if="vm.reservation.voucher">Parab\xE9ns! Compra realizada com sucesso</h1><h1 title="Aguardando conclus\xE3o do Pagamento" ng-if="!vm.reservation.voucher">Aguardando conclus\xE3o do Pagamento*</h1><h5 style="text-align: center;"></h5><h5 title="Compra Segura" class="text-center frases_compra_segura">Por favor verifique seu e-mail <i class="fa fa-envelope" aria-hidden="true"></i></h5><div class="row separator"><div class="col-md-6"><h3 class="num-localizador" title="Pedido" class="text-left"><strong class="text-left">Pedido: <span id="idVenda" class="idVenda">{{vm.reservation.localizador || vm.reservation.id}}</span></strong></h3></div><div class="col-md-6"><h3 title="Pre\xE7o Final" class="text-right"><strong class="text-right">Pre\xE7o Final: <span id="valorVenda" class="valorVenda">{{vm.reservation.value / 100| currency:"R$ "}}</span></strong></h3></div></div><div class="row"><div class="col-md-12"><h3 title="{{vm.reservation.descritivo}}" class="text-center"><strong class="text-left"><i class="fa fa-ticket" aria-hidden="true"></i> {{vm.reservation.descritivo}}</strong></h3></div></div><div class="row"><div class="col-md-6 col-md-offset-3 agradecimento_msg" ng-if="!vm.reservation.qrcode || vm.reservation.voucher"><p ng-if="vm.reservation.voucher"></p><p ng-if="!vm.reservation.voucher">Ap\xF3s a conclus\xE3o do pagamento o voucher ser\xE1 enviado no seu e-mail.</p><p ng-if="!vm.reservation.voucher && vm.reservation.boleto">Imprima seu boleto no bot\xE3o abaixo!</p></div><div ng-if="vm.reservation.qrcode && !vm.reservation.voucher && vm.reservation.paymentType == \'Pix\'"><p class="frase-tempo-pagamento-pix"></p><p>Efetue o pagamento PIX usando o "PIX com QRCODE" ou o "PIX Copia e Cola"</p><div class="col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4"><img ng-src="{{vm.qrcode}}?method=qrcode&code=qr&hidenumbers=true&text={{vm.reservation.qrcode | urlEncode}}" class="img-responsive" alt="Image"> <button type="button" class="btn btn-success btn-block ripple" ngclipboard data-clipboard-text="{{vm.reservation.qrcode}}" ngclipboard-success="vm.linkCopySuccess(e)">Pix Copia e Cola &nbsp;<i class="fa fa-copy"></i></button> <button type="button" class="btn btn-info btn-block ripple" ng-click="vm.verifyPayment()">J\xE1 conclui o pagamento</button></div></div><div ng-if="vm.reservation.qrcode && !vm.reservation.voucher && vm.reservation.paymentType == \'PicPay\'"><p>Efetue o pagamento com o PicPay clicando no bot\xE3o abaixo ou lendo o qrcode pelo camera do seu celular</p><div class="col-md-6 col-md-offset-3"><a class="btn btn-success btn-block ripple" target="_blank" href="{{vm.reservation.qrcode}}">Efetuar pagamento &nbsp;<i class="fa fa-money"></i> </a><img ng-src="{{vm.qrcode}}?method=qrcode&code=qr&hidenumbers=true&text={{vm.reservation.qrcode | urlEncode}}" class="img-responsive" alt="Image"></div></div></div></div></div><div class="row loja-tabela-total"><div class="voucher imprimir col-xs-12 col-sm-10 col-sm-offset-1" ng-show="vm.reservation.voucher"><a title="Imprimir Voucher" class="btn btn-success btn-block btn-shadow btn-voucher ripple" target="_blank" rel="noopener" href="{{vm.voucherLink}}">Imprimir Voucher <i class="fa fa-print" aria-hidden="true"></i></a></div><br><p class="frase-compra-realizada col-md-12"></p><div class="boleto imprimir col-xs-12 col-sm-10 col-sm-offset-1" ng-show="!vm.reservation.voucher && vm.reservation.boleto"><a title="Imprimir Boleto" class="btn btn-default btn-block btn-shadow ripple" target="_blank" rel="noopener" href="{{vm.pdfAddress}}?method=boletoAsByte&id={{vm.reservation.id}}&reservation=reservations/{{vm.reservation.id}}&boleto={{vm.reservation.boleto}}&token={{vm.reservation.boletoToken}}">Imprimir Boleto <i class="fa fa-print color-loja" aria-hidden="true"></i></a></div><div class="pagamento imprimir col-xs-12 col-sm-10 col-sm-offset-1" ng-show="!vm.reservation.voucher && !vm.reservation.qrcode && vm.reservation.paymentUrl"><a title="Efetuar Pagamento" class="btn btn-success btn-block btn-shadow ripple" target="_blank" rel="noopener" href="{{vm.reservation.paymentUrl}}">Efetuar Pagamento <i class="fa fa-money" aria-hidden="true"></i></a></div><div class="frase voucher text-center col-xs-12 col-sm-10 col-sm-offset-1" ng-if="\'\'"><h4></h4></div></div><div ng-show="vm.xsNewbuy" ng-include=""></div><div ng-include="\'app/components/xsConfirm/botoesCompartilhamento.html\'"></div></div></section>');
$templateCache.put('app/components/xsBarraFooter/xsBarraFooter.html','<section class="row b2c-checkin b2c-checkin-fixed-footer navbar-fixed-bottom"><div id="navbar_bottom" class="animated fadeInUp container"><nav class="navbar navbar-default" uib-tooltip="Use essa barra para nova pesquisa!" tooltip-placement="top" tooltip-is-open="vm.tooltipIsOpen" tooltip-append-to-body role="navigation"><div class="navbar-header"><button title="Efetuar nova busca" ng-click="vm.openModalEditarDadosHospedagem(\'Editar Checkin Completo\')" class="navbar-toggle ripple btn" type="button"><i class="fa fa-search" aria-hidden="true"></i></button><ul class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><li class="data"><i class="fa fa-calendar" aria-hidden="true"></i> <em>{{vm.search.date | date:"dd"}} a {{vm.search.endDate | date:"dd/MM"}}</em></li><li><i class="fa fa-bed" aria-hidden="true"></i> <em>{{vm.search.quartos}}</em></li><li><i class="fa fa-male" aria-hidden="true"></i> <em>{{vm.adt}}</em></li><li ng-if="vm.chd > 0"><i class="fa fa-child" aria-hidden="true"></i> <em>{{vm.chd}}</em></li><li ng-if="vm.colo > 0"><i class="fa fa-child" aria-hidden="true"></i> <em>{{vm.colo}}</em></li><li ng-if="vm.terceiraIdade > 0"><i class="fa fa-male" aria-hidden="true"></i> <em>{{vm.terceiraIdade}}</em></li></ul></div><div class="collapse navbar-collapse" uib-collapse="!isNavCollapsed"><div class="row options-reserva"><div class="col-md-3 hotel form-group"><button title="Mais detalhes do Hotel" class="btn time-05 btn-block" ng-click="vm.openModalMaisDetalhesHotel()" ng-if="vm.selectHotel" type="button"><i class="fa fa-building-o" aria-hidden="true"></i> {{vm.selectHotel.item.service}}</button> <button title="Selecione sua acomoda\xE7\xE3o" class="btn time-05 btn-block" ng-if="!vm.selectHotel" type="button"><i class="fa fa-building-o" aria-hidden="true"></i>Selecione sua acomoda\xE7\xE3o</button></div><div class="col-md-3 data form-group"><button title="Data da Hospedagem" class="btn ripple time-05 btn-block" ng-click="vm.openModalDataHospedagem(\'Data de Hospedagem\')" type="button"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{vm.search.date | date:"dd/MM"}} &nbsp; | <i class="fa fa-calendar-times-o" aria-hidden="true"></i> {{vm.search.endDate | date:"dd/MM"}} &nbsp; | &nbsp; {{vm.search.noites}} noites</button></div><div class="col-md-2 quartos form-group"><button title=" Apartamento(s)" class="btn ripple time-05 btn-block" ng-click="vm.openModalEditarDadosHospedagem(\'Quantidade de Quartos\')" type="button"><i class="fa fa-bed" aria-hidden="true"></i> {{vm.search.quartos}} Apartamento(s)</button></div><div class="col-md-3 adultos form-group"><button title=" Adulto" class="btn ripple time-05 btn-block" ng-click="vm.openModalEditarDadosHospedagem(\'Quantidade de Adultos e Crian\xE7as\')" type="button"><i class="fa fa-male" aria-hidden="true"></i> {{vm.adt}} Adulto(s) &nbsp;<span ng-if="vm.chd > 0">| <i class="fa fa-child" aria-hidden="true"></i> {{vm.chd}} Chd</span> &nbsp;<span ng-if="vm.colo > 0"> | <i class="fa fa-child" aria-hidden="true"></i> {{vm.colo}} Colos</span> &nbsp;<span ng-if="vm.terceiraIdade > 0"> | <i class="fa fa-male" aria-hidden="true"></i> {{vm.terceiraIdade}} acima de 60 anos</span></button></div><div class="col-md-1 search-full form-group"><button title="Editar Check-in Completo" class="btn ripple time-05 btn-block" ng-click="vm.openModalEditarDadosHospedagem(\'Editar Checkin Completo\')" type="button"><i class="fa fa-search" aria-hidden="true"></i><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Editar</span></button></div></div></div></nav></div><xs-paid-button></xs-paid-button></section>');
$templateCache.put('app/components/xsMarcacao/xsMarcacao.html','<section class="loja-escolha-mesas" id="lojaEscolhaMesas"><section class="row loja-posicao color-loja"><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 loja-on-check"><i class="fa fa fa-circle" aria-hidden="true"></i><p>1\xAA - Escolha<br>de quiosque</p><hr class="hidden-xs hidden-sm"></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 loja-off-check"><i class="fa fa-circle-o" aria-hidden="true"></i><p>2\xAA - Confirme<br>ingressos</p><hr class="hidden-xs hidden-sm"></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 loja-off-check"><i class="fa fa-circle-o" aria-hidden="true"></i><p>3\xAA - Dados<br>de acesso</p><hr class="hidden-xs hidden-sm"></div><div class="col-xs-3 col-sm-3 col-md-2 col-lg-2 loja-off-check"><i class="fa fa-circle-o" aria-hidden="true"></i><p>4\xAA - Forma<br>de pagamento</p></div></section><section class="row loja-indentificacao-header"><aside class="col-md-2"><button title="Valtar aos ingressos" type="submit" class="loja-background-color btn btn-success loja-btn btn-lg btn-scala btn-block" ng-click="vm.voltarTabelaIngressos()"><i class="fa fa-caret-left" aria-hidden="true"></i> <i class="fa fa-shopping-cart" aria-hidden="true"></i> Voltar</button></aside><section class="col-md-10"><h2 title="Falta pouco! Escolha sua mesa." align="center">Falta pouco! Escolha sua mesa.</h2><h5 title="* As cores das \xE1reas s\xE3o somente para facilitar a compra, n\xE3o diferem uma da outra no ambiente.">* As cores das \xE1reas s\xE3o somente para facilitar a compra, n\xE3o diferem uma da outra no ambiente.</h5></section></section><section class="row loja-escolha-mesas-mapa"><img title="Mapa das Mesas" alt="Mapa das Mesas" class="img-responsive" ng-src="assets/images/layout/reveillon-na-selva-mesas.jpg"></section><section class="loja-escolha-mesas-all"><aside class="row"><div class="col-md-12"><h1 title="Est\xE1 chegando o grande dia!">Est\xE1 chegando o grande dia!</h1><h3 title="Agora escolha a \xE0rea e depois sua mesa clicando nela.">Agora escolha a \xE0rea e depois sua mesa clicando nela.</h3><h4 title="* As cores das \xE1reas s\xE3o somente para facilitar a compra, n\xE3o diferem uma da outra no ambiente.">* As cores das \xE1reas s\xE3o somente para facilitar a compra, n\xE3o diferem uma da outra no ambiente.</h4></div></aside><section><uib-tabset active="activeJustified" justified="true"><uib-tab index="0" class="loja-escolha-mesas-color-MA" heading="\xC1rea Laranja"><article class="loja-escolha-mesasl-MA animated fadeIn"><div class="row"><div class="col-md-12"><h2 title="Mesas">Mesas \xE1rea Laranja <i class="fa fa-circle" aria-hidden="true"></i></h2><img alt="" class="img-responsive" ng-src="assets/images/icons/home_vpn_sep.jpg"></div></div><div class="row"><ul class="col-md-12"><li ng-repeat="mesaA in vm.mesasA" class="animated fadeIn"><label tooltip-placement="top" uib-tooltip="{{mesaA.shortName}}" class="style-icon-chek" ng-class="{\'activeSold\': mesaA.sold, \'fa fa-check\': mesaA.select}"><img title="{{mesaA.nome}}" alt="{{mesaA.nome}}" class="img-responsive activeOpacity" ng-class="{\'activeCheck\': mesaA.select}" ng-src="{{mesaA.image}}"> <span>{{mesaA.id}}</span> <input type="checkbox" ng-model="mesaA.select" class="hidden" ng-disabled="mesaA.sold"></label></li></ul></div></article></uib-tab><uib-tab index="1" class="loja-escolha-mesas-color-MB" heading="\xC1rea Roxa"><article class="loja-escolha-mesas-MB animated fadeIn"><div class="row"><div class="col-md-12"><h2 title="Mesas">Mesas \xE1rea Roxa <i class="fa fa-circle" aria-hidden="true"></i></h2><img alt="" class="img-responsive" ng-src="assets/images/icons/home_vpn_sep.jpg"></div></div><div class="row"><ul class="col-md-12"><li ng-repeat="mesaB in vm.mesasB" class="animated fadeIn"><label tooltip-placement="top" uib-tooltip="{{mesaB.shortName}}" class="style-icon-chek" ng-class="{\'activeSold\': mesaB.sold, \'fa fa-check\': mesaB.select}"><img title="{{mesaB.nome}}" alt="{{mesaB.nome}}" class="img-responsive activeOpacity" ng-class="{\'activeCheck\': mesaB.select}" ng-src="{{mesaB.image}}"> <span>{{mesaB.id}}</span> <input type="checkbox" ng-model="mesaB.select" class="hidden" ng-disabled="mesaB.sold"></label></li></ul></div></article></uib-tab><uib-tab index="2" class="loja-escolha-mesas-color-MC" heading="\xC1rea Amarela"><article class="loja-escolha-mesas-MC animated fadeIn"><div class="row"><div class="col-md-12"><h2 title="Mesas">Mesas \xE1rea Amarela <i class="fa fa-circle" aria-hidden="true"></i></h2><img alt="" class="img-responsive" ng-src="assets/images/icons/home_vpn_sep.jpg"></div></div><div class="row"><ul class="col-md-12"><li ng-repeat="mesaC in vm.mesasC" class="animated fadeIn"><label tooltip-placement="top" uib-tooltip="{{mesaC.shortName}}" class="style-icon-chek" ng-class="{\'activeSold\': mesaC.sold, \'fa fa-check\': mesaC.select}"><img title="{{mesaC.nome}}" alt="{{mesaC.nome}}" class="img-responsive activeOpacity" ng-class="{\'activeCheck\': mesaC.select}" ng-src="{{mesaC.image}}"> <span>{{mesaC.id}}</span> <input type="checkbox" ng-model="mesaC.select" class="hidden" ng-disabled="mesaC.sold"></label></li></ul></div></article></uib-tab><uib-tab index="3" class="loja-escolha-mesas-color-MD" heading="\xC1rea Azul"><article class="loja-escolha-mesas-MD animated fadeIn"><div class="row"><div class="col-md-12"><h2 title="Mesas">Mesas \xE1rea Azul <i class="fa fa-circle" aria-hidden="true"></i></h2><img alt="" class="img-responsive" ng-src="assets/images/icons/home_vpn_sep.jpg"></div></div><div class="row"><ul class="col-md-12"><li ng-repeat="mesaD in vm.mesasD" class="animated fadeIn"><label tooltip-placement="top" uib-tooltip="{{mesaD.shortName}}" class="style-icon-chek" ng-class="{\'activeSold\': mesaD.sold, \'fa fa-check\': mesaD.select}"><img title="{{mesaD.nome}}" alt="{{mesaD.nome}}" class="img-responsive activeOpacity" ng-class="{\'activeCheck\': mesaD.select}" ng-src="{{mesaD.image}}"> <span>{{mesaD.id}}</span> <input type="checkbox" ng-model="mesaD.select" class="hidden" ng-disabled="mesaD.sold"></label></li></ul></div></article></uib-tab></uib-tabset></section></section><section class="row loja-tabela-total"><div class="col-md-10 col-md-offset-1"><div class="row"><section class="col-xs-12 col-sm-12 col-md-2 col-lg-2"><br><i class="fa fa-lock color-loja" aria-hidden="true"></i><h5 title="Compra Segura">Compra segura</h5></section><section class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><address class="loja-central-atendimento"><h5 title="Central de Relacionamento com o Cliente">Central de Relacionamento com o Cliente</h5><abbr title="Telefone"><i class="fa fa-phone" aria-hidden="true"></i></abbr><br><abbr title="Telefone" ng-hide="\'(73) 3268-8500\' == \'\'"><i class="fa fa-mobile" aria-hidden="true"></i> (73) 3268-8500</abbr></address></section><aside class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><h4 title="Tatal de Ingressos">2 mesas</h4><h4 title="Valor da compra">S. Total: R$ 5000,00</h4><button title="Continuar Compra" type="submit" class="loja-background-color btn btn-success loja-btn btn-lg btn-scala btn-block" ng-click="vm.mostrarTelaConfirmacaoIngresso()">Continuar <i class="fa fa-shopping-cart" aria-hidden="true"></i> <i class="fa fa-caret-right" aria-hidden="true"></i></button></aside></div></div></section></section>');
$templateCache.put('app/components/xsLogin/xsLogin.html','<div class="row functions-login"><div class="col-xs-12 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4"><div class="yes-client client"><form tabindex="-1" name="reservationform" role="form" id="reservationform" class="reservation-vertical clearfix" ng-show="vm.user"><h3 title="Sou cliente" class="lined-heading"><span>Ol\xE1 {{vm.user.name}}</span></h3><div class="row"><div class="col-md-6 form-group"><button title="N\xE3o \xE9 voc\xEA? Sair" type="button" class="btn btn-lg btn-scala btn-danger btn-block" ng-click="vm.logout();">N\xE3o \xE9 voc\xEA? Sair <i class="fa fa-sign-out" aria-hidden="true"></i></button></div><div class="col-md-6 form-group"><button title="Continuar" type="button" class="loja-background-color btn btn-success loja-btn btn-cliente btn-lg btn-scala btn-block" ng-click="vm.next();">Continuar <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div></div></form><form tabindex="-1" name="reservationform" role="form" id="reservationform" class="reservation-vertical clearfix" ng-hide="vm.user"><h3 title="Sou cliente" class="lined-heading"><span>Sou cliente</span></h3><div class="form-group form-loja"><label for="email" accesskey="E">E-mail / Cpf</label> <input name="email" type="text" id="email1" class="form-control" placeholder="Informe seu e-mail ou cpf" ng-model="vm.email" ng-change="vm.updateMask()" ui-mask="{{vm.maskPattern}}" model-view-value="true"></div><div class="form-group form-loja"><label for="password" accesskey="E">C\xF3digo de acesso</label> <input name="password" type="password" id="passwordLogin" class="form-control" placeholder="Informe seu c\xF3digo de acesso" ng-model="vm.password" ng-enter="vm.login()"></div><div class="row buttons"><div class="col-md-12"><button style="border: none; text-decoration: underline;" title="Receber c\xF3digo de acesso" type="button" class="btn-default btn-basic btn btn-scala btn-block" ng-click="vm.forgetPass()">Receber c\xF3digo de acesso <i class="fa fa-chevron-right" aria-hidden="true"></i></button></div><div class="col-md-12"><button title="Continuar" type="button" class="loja-background-color btn btn-success loja-btn btn-cliente btn-lg btn-scala btn-block" ng-click="vm.login();">Continuar <i class="fa fa-sign-in" aria-hidden="true"></i></button></div></div></form></div></div><div class="col-xs-12 hidden"><div class="not-client client"><h3 title="Voc\xEA n\xE3o \xE9 cliente?">Voc\xEA n\xE3o \xE9 cliente?</h3><button title="Continuar" type="button" class="loja-background-color btn btn-success btn-cliente loja-btn btn-lg btn-scala btn-block" ng-click="vm.showCadastro()">Fa\xE7a seu cadastro <i class="fa fa-user-plus" aria-hidden="true"></i></button><address class="loja-central-atendimento"><h5></h5><h5 title="Central de Relacionamento com o Cliente">Central de Relacionamento com o Cliente<br></h5><abbr title="Telefone" ng-hide="\'\' == \'\'"><i class="fa fa-phone" aria-hidden="true"></i></abbr><br><abbr title="Telefone" ng-hide="\'(73) 3268-8500\' == \'\'"><i class="fa fa-mobile" aria-hidden="true"></i> (73) 3268-8500</abbr></address></div></div></div><div class="row"><div class="col-md-12"><div class="loja-separador"></div></div></div><div class="row margin-auto mostra-cadastro" ng-show="vm.mostraCadastro"><div class="col-md-12"><h1 title="Informe seus dados">Informe seus dados</h1><hr></div><div id="cadastro" class="col-md-12"><xs-register xs-complete="vm.cadastrar()" template-url="app/components/xsRegister/xsRegister.html"></xs-register></div></div>');
$templateCache.put('app/components/xsLogin/xsLoginByEmail.html','<div class="row"><div class="col-xs-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3"><div class="row margin-auto mostra-cadastro"><form tabindex="-1" name="emailForm" role="form" id="emailForm" class="reservation-vertical clearfix"><h3 title="Sou cliente" class="lined-heading"><span>Informe seu e-mail ou cpf</span></h3><div class="form-group form-loja"><label for="email" accesskey="E">E-mail / Cpf</label> <input name="email" type="email" id="email" class="form-control" placeholder="Informe seu e-mail" ng-model="vm.email" ng-disable="vm.showCode" required></div><div ng-if="!vm.showCode"><button type="button" class="btn btn-success btn-block loja-btn" ng-click="vm.sendMailToLogin()" ng-disabled="emailForm.$invalid">Enviar</button></div><div ng-if="vm.showCode"><div class="form-group form-loja"><label for="password" accesskey="E">C\xF3digo de acesso</label> <input name="password" type="password" id="passwordLogin" class="form-control" placeholder="Informe seu c\xF3digo de acesso" ng-model="vm.password" ng-enter="vm.login()"></div><div class="row buttons"><div class="col-xs-6"><button title="Voltar" type="button" class="btn-default btn-basic btn btn-scala btn-block" ng-click="vm.showCode=false">Voltar</button></div><div class="col-xs-6"><button title="Continuar" type="button" class="loja-background-color btn btn-success loja-btn btn-cliente btn-lg btn-scala btn-block" ng-click="vm.login();">Continuar <i class="fa fa-sign-in" aria-hidden="true"></i></button></div></div></div></form></div></div></div>');
$templateCache.put('app/components/xsPayment/payment_card_address.html','<div><label>Dados de cobran\xE7a da fatura</label><div class="row"><div class="col-md-6" ng-if="!vm.personEstrangeiro()"><div class="form-group"><input type="text" class="form-control" name="Celular" ui-mask="(99) 99999-9999" placeholder="Celular" ui-mask-placeholder ng-model="vm.userCard.cellPhone" id="cellPhone" ng-required="true"></div></div><div class="col-md-6"><div class="form-group"><input type="email" class="form-control" name="Email" placeholder="Email" ng-model="vm.userCard.email" id="email" ng-required="true"></div></div><div class="form-group col-md-6" ng-if="!vm.personEstrangeiro()"><input type="text" class="form-control" placeholder="CEP" ng-model="vm.userCard.zipCode" id="zipCode" ui-mask="99999-999" ui-mask-placeholder ng-required="true" ng-change="vm.findZipCodeAddress(vm.userCard)"></div><div class="form-group col-md-6" ng-if="!vm.personEstrangeiro()"><input type="text" class="form-control" placeholder="Logradouro" ng-model="vm.userCard.street0" id="street0" ng-required="true"></div><div class="form-group col-md-6" ng-if="!vm.personEstrangeiro()"><input type="text" class="form-control" placeholder="Complemento" ng-model="vm.userCard.address" id="address" ng-required="true"></div><div class="form-group col-md-6" ng-if="!vm.personEstrangeiro()"><input type="text" class="form-control" placeholder="Bairro" ng-model="vm.userCard.street1" id="street1" ng-required="true"></div><div class="form-group col-md-6" ng-if="!vm.personEstrangeiro()"><input type="text" class="form-control" placeholder="Cidade" ng-model="vm.userCard.city" id="city" ng-required="true"></div><div class="form-group col-md-6" ng-if="!vm.personEstrangeiro()"><select class="form-control" ng-model="vm.userCard.state" id="state" ng-required="true"><option value="">Selecione o Estado</option><option value="ac">Acre</option><option value="al">Alagoas</option><option value="am">Amazonas</option><option value="ap">Amap\xE1</option><option value="ba">Bahia</option><option value="ce">Cear\xE1</option><option value="df">Distrito Federal</option><option value="es">Esp\xEDrito Santo</option><option value="go">Goi\xE1s</option><option value="ma">Maranh\xE3o</option><option value="mt">Mato Grosso</option><option value="ms">Mato Grosso do Sul</option><option value="mg">Minas Gerais</option><option value="pa">Par\xE1</option><option value="pb">Para\xEDba</option><option value="pr">Paran\xE1</option><option value="pe">Pernambuco</option><option value="pi">Piau\xED</option><option value="rj">Rio de Janeiro</option><option value="rn">Rio Grande do Norte</option><option value="ro">Rond\xF4nia</option><option value="rs">Rio Grande do Sul</option><option value="rr">Roraima</option><option value="sc">Santa Catarina</option><option value="se">Sergipe</option><option value="sp">S\xE3o Paulo</option><option value="to">Tocantins</option></select></div></div></div>');
$templateCache.put('app/components/xsPayment/xsPayment.html','<section class="row"><div class="payment-header col-xs-12 col-sm-6 col-md-11 col-md-offset-1 col-lg-11 col-lg-offset-1"><div class="row"><div class="col-md-6 col-sm-6 col-xs-12"><h4 title="Selecione a sua bandeira">Selecione a sua bandeira</h4><h5 title="para efetuar a compra."><small>para efetuar a compra.</small></h5></div><div class="col-md-6 col-sm-6 col-xs-12"><h5></h5></div></div></div><div class="col-xs-12 col-sm-6 col-md-11 col-md-offset-1 col-lg-11 col-lg-offset-1"><div class="row"><div class="col-md-2 col-sm-4 col-xs-6" ng-hide="key === \'gerencianet\'" ng-repeat="(key, value) in vm.paymentMethods"><div class="checkbox"><label ng-click="vm.selectType(key, $index)"><input type="checkbox" ng-model="vm.brands[$index].active"><br><img title="{{key}}" alt="{{key}}" class="img-responsive activeOpacity" ng-class="{activeCheck: vm.paymentMethod.type == key}" ng-src="assets/images/logos/{{key}}.png" alt=""></label></div></div></div></div></section><div class="row"><div class="col-md-12"><div class="loja-separador" style="margin-bottom: 15px;"></div></div></div><form tabindex="-1" name="formPayment" id="formPayment" role="form" class="row form" ng-hide="vm.paymentMethod.type === \'pix\' || vm.paymentMethod.type == \'boleto\' || vm.paymentMethod.type == \'gerencianetBoleto\' || vm.paymentMethod.type == \'remarcacao\' || vm.paymentMethod.type == \'mercadopagotransparente\' || vm.paymentMethod.type == \'picpay\'"><div class="col-md-5 col-md-offset-1"><div class="form-group form-loja credit-card"><label for="titularCartao">Informe o Nome Completo do Titular <i class="fa fa-question-circle-o" uib-tooltip="Informe o mesmo nome que est\xE1 no cart\xE3o do comprador" aria-label="Informe o mesmo nome que est\xE1 no cart\xE3o do comprador"></i></label> <input type="text" class="form-control" id="titularCartao" placeholder="Informe o Nome Completo do Titular" ng-model="vm.paymentMethod.personName" ng-disabled="vm.paymentMethod.type == null"></div><div class="form-group form-loja" ng-if="!vm.ignoreCpf()"><label for="cpfCartao">CPF do Titular</label> <input type="text" class="form-control" id="cpfCartao" ng-model="vm.paymentMethod.personCpf" ui-mask="999.999.999-99" placeholder="Cpf" ui-mask-placeholder ng-disabled="vm.paymentMethod.personName == null || vm.paymentMethod.personName.length < 2"></div><div class="form-group form-loja credit-card"><label for="numCartao">N\xFAmero do Cart\xE3o <i class="fa fa-question-circle-o" uib-tooltip="Informe o n\xFAmero do seu cart\xE3o de cr\xE9dito" aria-label="Informe o n\xFAmero do seu cart\xE3o de cr\xE9dito"></i></label> <input type="text" class="form-control" id="numCartao" ng-model="vm.paymentMethod.cardNumber" ui-mask="9999 9999 9999 99?9?9? ?9?9?9" placeholder="N\xFAmero do Cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled=" (!vm.ignoreCpf() && (vm.paymentMethod.personCpf == null || vm.paymentMethod.personCpf.length < 11)) || (vm.ignoreCpf() && (vm.paymentMethod.personName == null || vm.paymentMethod.personName.length < 2))"></div></div><div class="col-md-5"><div class="form-group form-loja credit-card"><label for="codeCartao">C\xF3digo de Seguran\xE7a do Cart\xE3o <i class="fa fa-question-circle-o" uib-tooltip="Informe o C\xF3digo na parte de tr\xE1s do cart\xE3o. Ex.: 000"></i></label> <input type="text" class="form-control" id="codeCartao" ng-model="vm.paymentMethod.code" placeholder="Informe o C\xF3digo na parte de tr\xE1s do cart\xE3o. Ex.: 000" ui-mask="999?9?9" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paymentMethod.cardNumber == null || vm.paymentMethod.cardNumber.length < 12"></div><div class="form-group form-loja credit-card"><label for="valCartao">Data de Validade do Cart\xE3o <i class="fa fa-question-circle-o" uib-tooltip="Informe da data de valdiade do cart\xE3o: mes e ano" aria-label="Informe da data de valdiade do cart\xE3o: mes e ano"></i></label> <input type="text" class="form-control" id="valCartao" ng-model="vm.paymentMethod.goodThru" ui-mask="99/2099" ng-disabled="vm.paymentMethod.code == null || vm.paymentMethod.code.length < 3"></div><div class="form-group form-loja"><label for="parcelasCartao">Quantidade de Parcelas</label> <select class="form-control" id="parcelasCartao" ng-hide="vm.paymentMethod.type == \'pagsegurotransparente\' || vm.paymentMethod.type == \'gerencianetVisa\' || vm.paymentMethod.type == \'gerencianetMaster\'" ng-model="vm.paymentMethod.length" ng-options="vm.parcelas(i) group by \'Selecione\' for i in vm.financialLength" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4"></select> <select class="form-control" id="parcelasCartao" ng-show="vm.paymentMethod.type == \'pagsegurotransparente\'" ng-model="vm.paymentMethod.length" ng-options="vm.installmentText(i) group by \'Selecione\' for i in vm.pagseguroInstallments" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4"></select> <select class="form-control" id="parcelasCartao" ng-show="vm.paymentMethod.type == \'gerencianetVisa\' || vm.paymentMethod.type == \'gerencianetMaster\'" ng-model="vm.paymentMethod.length" ng-options="vm.gerencianetInstallmentText(i) group by \'Selecione\' for i in vm.gerencianetInstallments" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4"></select></div></div></form><div ng-if="vm.paymentMethod.type == \'mercadopagotransparente\'" ng-include=""></div><div class="Pix" ng-if="vm.paymentMethod.type === \'pix\'"><h2><p class="text-center">Ser\xE1 gerado um qrcode para pagamento na pr\xF3xima tela</p></h2></div><div class="Pix" ng-if="vm.paymentMethod.type === \'picpay\'"><h2><p class="text-center">Clique em continuar para ser direcionado ao pagamento PicPay</p></h2></div><section class="row loja-tabela-total compra"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="seguranca col-xs-6 col-sm-6 col-md-3 col-lg-3"><i class="fa fa-lock color-loja" aria-hidden="true"></i><h5 title="Compra Segura">Compra Segura</h5><div class="checkbox col-md-12"><label><input type="checkbox" ng-model="vm.terms"> Li e aceito os termos e politicas</label></div><a title="Visualizar termos" class="btn btn-default btn-termos btn-link" target="_blank" rel="nofollow noopener noreferrer" href="docs/termosdecompra.html">Visualizar <i class="fa fa-info" aria-hidden="true"></i></a></div><div class="central-atendimento col-xs-6 col-sm-6 col-md-5 col-lg-5"><h5 title="Central de Relacionamento com o Cliente">Central de Relacionamento com o Cliente</h5><h5 title="Telefone para contato: "><i class="fa fa-phone" aria-hidden="true"></i></h5><h5 title="Telefone para contato: (73) 3268-8500" ng-hide="\'(73) 3268-8500\' == \'\'"><i class="fa fa-mobile" aria-hidden="true"></i> (73) 3268-8500</h5></div><div class="buttons-comprar col-xs-12 col-sm-12 col-md-4 col-lg-4"><h4 title="Valor da compra" ng-hide="vm.paymentMethod.type == \'pagsegurotransparente\' || vm.gerencianetTotalValue > 0">Total: {{ vm.totalGeral() / 100 | currency:"R$ "}}</h4><h4 title="Valor da compra" ng-show="vm.paymentMethod.type == \'pagsegurotransparente\'">Total: {{ vm.pagseguroTotalValue | currency:"R$ "}} <span ng-show="vm.installmentQuantity > 1">(Com Juros)</span></h4><h4 title="Valor da compra" ng-show="vm.gerencianetTotalValue > 0">Total: {{ vm.gerencianetTotalValue / 100 | currency:"R$ "}} <span ng-show="vm.installmentQuantity > 1">(Com Juros)</span></h4><button title="Continuar" type="submit" class="loja-background-color btn btn-success loja-btn btn-md btn-scala btn-block" ng-disabled="vm.isInvalidCard()" ng-click="vm.purchase()" ng-if="vm.paymentMethod.type != \'mercadopagotransparente\'">Continuar <i class="fa fa-shopping-cart" aria-hidden="true"></i> <i class="fa fa-caret-right" aria-hidden="true"></i></button> <button title="Continuar" type="submit" class="loja-background-color btn btn-success loja-btn btn-md btn-scala btn-block" ng-disabled="vm.isInvalidCard()" ng-click="vm.purchaseMercadoPago()" ng-if="vm.paymentMethod.type == \'mercadopagotransparente\'">Continuar <i class="fa fa-shopping-cart" aria-hidden="true"></i> <i class="fa fa-caret-right" aria-hidden="true"></i></button> <span class="span error-message" ng-show="!vm.isProcessing && vm.isInvalidCard()"><i class="fa fa-warning"></i>&nbsp;{{vm.isInvalidCard()}}&nbsp;<i class="fa fa-warning"></i></span> <span class="span wait-message" ng-show="vm.isProcessing"><i class="fa fa-warning"></i>&nbsp;Por Favor Aguarde...&nbsp;<i class="fa fa-warning"></i></span></div></div></div><div id="pagseruro"></div></section><script src="scripts/bpmpi_config.js" type="text/javascript"></script><script src="scripts/BP.Mpi.3ds20.min.js" type="text/javascript"></script>');
$templateCache.put('app/components/xsPerson/xsPerson.html','<div class="row content-bordered content-cadastro"><br><div class="col-md-6 form-group"><label for="name"></label> <input type="text" class="form-control" id="name" ng-model="person.name" ng-minlength="10"></div><div class="col-md-6 form-group"><label for="mail">E-mail</label> <input type="email" class="form-control" id="mail" ng-model="person.email" ng-required="true"></div><div class="col-md-6 form-group"><label for="pass">Senha</label> <input type="password" class="form-control" id="pass" ng-model="person.password" ng-minlength="4"></div><div class="col-md-6 form-group"><label for="pass2">Confirme a senha</label> <input type="password" class="form-control" id="pass2" ng-model="person.password2" ng-minlength="4"></div><div class="col-md-6 form-group"><label for="born">Data Nascimento</label> <input type="text" class="form-control" id="born" name="birthdayDate" ng-model="person.birth" ui-mask="99/99/9999" placeholder="Data Nascimento" ui-mask-placeholder></div><div class="col-md-6 form-group"><label for="CPF">CPF</label> <input type="text" class="form-control" id="CPF" ng-model="person.cpf" ui-mask="999.999.999-99" placeholder="CPF" ui-mask-placeholder></div><div class="col-md-12"><br><br></div><div class="form-group" align="center"><button title="Cadastrar" class="btn btn-info" ng-click="savePerson()">Cadastrar</button></div><div class="col-md-12"><br></div></div>');
$templateCache.put('app/components/xsSavePerson/xsSavePerson.html','<div class="panel panel-default"><div class="panel-heading"><span class="fa fa-user"></span>&nbsp; Identifica\xE7\xE3o do Comprador</div><div class="panel-body"><div class="row"><div class="col-md-6"><form tabindex="-1" name="formSavePerson" role="form" id="formSavePerson" class="form-horizontal"><div class="form-group"><div class="col-md-3"><label class="control-label">CPF</label></div><div class="col-md-9"><div class="input-group"><input type="text" class="form-control" ng-model="vm.xsPerson.cpf" ng-enter="vm.findByCpf(vm.xsPerson.cpf)" ui-br-cpf-mask> <span class="input-group-addon"><a href=""><span class="fa fa-search" ng-click="vm.findByCpf(vm.xsPerson.cpf)"></span></a></span></div></div></div><div class="form-group"><div class="col-md-3"><label class="control-label">Nome Completo</label></div><div class="col-md-9"><input type="text" class="form-control" ng-model="vm.xsPerson.name" ng-minlength="12"></div></div><div class="form-group"><div class="col-md-3"><label class="control-label">E-mail</label></div><div class="col-md-9"><input type="email" class="form-control" ng-model="vm.xsPerson.email"></div></div><div class="form-group"><div class="col-md-3"><label class="control-label">Data Nascimento</label></div><div class="col-md-9"><input type="text" class="form-control" ng-model="vm.xsPerson.birth" ui-mask="99/99/9999" placeholder="DD/MM/AAAA" ui-mask-placeholder></div></div><div class="form-group"><div class="col-md-3"><label class="control-label">Telefone</label></div><div class="col-md-9"><input type="text" class="form-control" ng-model="vm.xsPerson.cellPhone" ui-mask="(99) 9 9999-9999" placeholder="(DDD) 9 0000-0000" ui-mask-placeholder></div></div></form></div><div class="col-md-6"><form tabindex="-1" name="formRegisterEnd" role="form" id="formRegisterEnd" class="form-horizontal"><div class="form-group"><div class="col-md-3"><label class="control-label">Cep</label></div><div class="col-md-9"><div class="input-group"><input type="text" class="form-control" ng-model="vm.xsPerson.zipCode" ng-enter="vm.findZipCode(vm.xsPerson.zipCode)" ui-mask="99999-999" placeholder="00000-000" ui-mask-placeholder> <span class="input-group-addon"><a href=""><span class="fa fa-search" ng-click="vm.findZipCode(vm.xsPerson.zipCode)"></span></a></span></div></div></div><div class="form-group"><div class="col-md-3"><label class="control-label">Endere\xE7o</label></div><div class="col-md-9"><input type="text" class="form-control" ng-model="vm.xsPerson.street0"></div></div><div class="form-group"><div class="col-md-3"><label class="control-label">Complemento</label></div><div class="col-md-9"><input type="text" class="form-control" ng-model="vm.xsPerson.address2"></div></div><div class="form-group"><div class="col-md-3"><label class="control-label">Bairro</label></div><div class="col-md-5"><input type="text" class="form-control" ng-model="vm.xsPerson.street1"></div><div class="col-md-2"><label class="control-label">N\xFAmero</label></div><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.xsPerson.number"></div></div><div class="form-group"><div class="col-md-3"><label class="control-label">Cidade</label></div><div class="col-md-5"><input type="text" class="form-control" ng-model="vm.xsPerson.city"></div><div class="col-md-2"><label class="control-label"></label></div><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.xsPerson.state" ng-maxlength="2" ng-required="true"></div></div></form></div><div class="col-md-12"><div class="row"><div class="col-md-2 pull-right"><button title="Salvar" class="btn btn-block btn-success" ng-click="vm.xsSave(vm.xsPerson)"><span class="fa fa-save"></span>&nbsp;Salvar</button></div></div></div></div></div></div>');
$templateCache.put('app/components/xsRegister/xsRegister.html','<form tabindex="-1" name="formRegister" role="form" id="formRegister" class="form row"><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="nome" accesskey="E">Nome Completo *</label> <input tabindex="1" name="nome" type="text" id="nome" class="form-control" placeholder="Digite o seu nome" ng-model="vm.user.name" ng-required="true"></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="email" accesskey="E">E-mail *</label> <input tabindex="2" name="email" type="email" id="email" class="form-control" placeholder="Preencha com um e-mail" ng-model="vm.user.email" ng-required="true"></div></div><div class="col-md-6 password" ng-if="!vm.noPassword"><div class="form-group form-loja"><label class="control-label" for="password" accesskey="E">Senha *</label> <input tabindex="3" name="password" type="password" id="password" class="form-control" placeholder="Crie uma senha" ng-model="vm.user.password" ng-required="true"></div></div><div class="col-md-6 password" ng-if="!vm.noPassword"><div class="form-group form-loja"><label class="control-label" for="password2" accesskey="E">Confirme a senha *</label> <input tabindex="4" name="password" type="password" id="password2" class="form-control" placeholder="Confirme a senha" ng-model="vm.password" ng-required="true"></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="nacionalidade" accesskey="E">Nacionalidade *</label> <select tabindex="5" class="form-control" id="nacionalidade" ng-model="vm.user.customData.estrangeiro" ng-required="true"><option value="false">Brasileiro</option><option value="true">Estrangeiro</option></select></div></div><div class="col-md-6"><div class="form-group form-loja" ng-if="vm.user.customData.estrangeiro == \'false\'"><label class="control-label" for="cpf" accesskey="E">CPF *</label> <input tabindex="6" name="cpf" type="text" id="cpf" class="form-control" ng-model="vm.user.cpf" ui-mask="999.999.999-99" placeholder="Digite o seu CPF" ui-mask-placeholder ng-required="true"></div><div class="form-group form-loja" ng-if="vm.user.customData.estrangeiro == \'true\'"><label class="control-label" for="documento" accesskey="E">Documento *</label> <input tabindex="7" name="documento" type="text" id="documento" class="form-control" placeholder="Digite o documento" ng-model="vm.user.passporte" ng-required="true"></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="nasc" accesskey="E">Data Nascimento *</label> <input tabindex="8" name="birthdayDate" type="text" id="nasc" class="form-control" ng-model="vm.user.birth" ui-mask="99/99/9999" placeholder="DD/MM/AAAA" ui-mask-placeholder ng-required="true" ng-change="vm.verifyDate()"></div></div><div class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="sexo" accesskey="E">Sexo</label> <select tabindex="9" id="sexo" class="form-control" ng-model="vm.user.gender"><option value="M">Masculino</option><option value="F">Feminino</option></select></div></div><div class="col-xs-3" ng-if="vm.user.customData.estrangeiro === \'true\'"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.countryPhoneCode.$touched && dadosComprador.countryPhoneCode.$valid, \'has-error\': dadosComprador.countryPhoneCode.$touched && dadosComprador.countryPhoneCode.$invalid}"><label class="control-label" for="countryPhoneCode" accesskey="E">DDI * <em class="text-danger" ng-show="dadosComprador.countryPhoneCode.$touched && dadosComprador.countryPhoneCode.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><br><div class="btn-group" uib-dropdown dropdown-append-to-body is-open="vm.openDropdownBrands" ng-init="vm.init()"><button id="btn-append-to-body" class="brands-dropdown-button" type="button" class="btn btn-primary" uib-dropdown-toggle style="display: block;"><img ng-src="{{ vm.brandUrl+vm.DDIbrandSelected.img }}" alt="Bandeira de {{ vm.DDIbrandSelected.pais }}" width="20" ng-if="!vm.DDIbrandSelected.needLabel" style="width: 20px;"> <span style="margin-left: 5px;">+{{ vm.DDIbrandSelected.ddi }}</span> <span class="caret icon-brands-dropdown"></span></button><ul class="uib-dropdown-menu" role="menu" aria-labelledby="btn-append-to-body" style="width: fit-content; user-select: none; cursor: pointer;"><li ng-repeat="(key, pais) in vm.paisesBrandNoTopo track by key" role="menuitem" ng-click="vm.selectCountry(pais)" class="brand-item"><img ng-src="{{ vm.brandUrl+pais.img }}" alt="Bandeira de {{ pais.pais }}" width="20" ng-if="!pais.needLabel" style="width: 20px;"> <span>{{pais.pais}} (+{{pais.ddi}})</span></li><hr><li ng-repeat="(key, pais) in vm.paisesBrand track by key" role="menuitem" ng-click="vm.selectCountry(pais)" class="brand-item"><img ng-src="{{ vm.brandUrl+pais.img }}" alt="Bandeira de {{ pais.pais }}" width="20" ng-if="!pais.needLabel" style="width: 20px;"> <span>{{pais.pais}} (+{{pais.ddi}})</span></li></ul></div></div></div><div ng-class="{\n      \'col-xs-12\': vm.user.customData.estrangeiro === \'false\',\n      \'col-xs-9\': vm.user.customData.estrangeiro === \'true\'\n    }"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$valid, \'has-error\': dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$invalid}"><label class="control-label" for="cellPhone" accesskey="E"><span>WhatsApp *</span><span ng-if="vm.DDIbrandSelected.ddi !== 55"> (without country code)</span> <em class="text-danger" ng-show="dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input name="cellPhone" tabindex="4" type="text" inputmode="tel" id="cellPhone" class="form-control" ng-model="vm.user.cellPhone" ui-mask="{{ vm.getWhatsappMask() }}" autocomplete="tel-national" placeholder="{{ vm.DDIbrandSelected && vm.DDIbrandSelected.ddi !== 55 ? \'without country code\' : \'Celular com DDD\' }}" ui-mask-placeholder ng-required="true"><div ng-show="dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div ng-if="false" class="col-md-6"><div class="form-group form-loja"><label class="control-label" for="telefone" accesskey="E">Telefone</label> <input tabindex="11" name="telefone" type="text" id="telefone" class="form-control" ng-model="vm.user.homePhone" ui-mask="(99) 9999-9999" autocomplete="tel" placeholder="(DDD) 0000-0000" ui-mask-placeholder></div></div><div class="col-md-6"><div class="row"><div class="col-md-4"><div class="form-group form-loja" ng-hide="vm.user.customData.estrangeiro == \'true\'"><label class="control-label" for="cep" accesskey="E">Cep</label><div class="input-group"><input tabindex="14" name="Cep" type="text" id="cep" class="form-control" ng-model="vm.user.zipCode" ui-mask="99999-999" placeholder="_____-___" ui-mask-placeholder ng-enter="vm.findCep()"> <span class="input-group-addon"><a href="" ng-click="vm.findCep()"><i class="fa fa-search"></i></a></span></div></div></div><div class="col-md-8"><div class="form-group form-loja" ng-hide="vm.user.customData.estrangeiro == \'true\'"><label class="control-label" for="complemento" accesskey="E">Complemento</label> <input tabindex="13" name="complemento" type="text" id="complemento" class="form-control" placeholder="Complemento" ng-model="vm.user.address2"></div></div></div></div><div class="col-md-6"><div class="form-group form-loja" ng-hide="vm.user.customData.estrangeiro == \'true\'"><label class="control-label" for="rua" accesskey="E">Endere\xE7o</label> <input tabindex="12" name="rua" type="text" id="rua" class="form-control" placeholder="Avenida/Rua" ng-model="vm.user.street0"></div></div><div class="col-md-6"><div class="row"><div class="form-group form-loja col-md-8" ng-hide="vm.user.customData.estrangeiro == \'true\'"><label class="control-label" for="bairro" accesskey="E">Bairro</label> <input tabindex="15" name="bairro" type="text" id="bairro" class="form-control" placeholder="Bairro" ng-model="vm.user.street1"></div><div class="form-group form-loja col-md-4" ng-hide="vm.user.customData.estrangeiro == \'true\'"><label class="control-label" for="numero" accesskey="E">N\xFAmero</label> <input tabindex="16" name="numero" type="text" id="numero" class="form-control" placeholder="N\xFAmero" ng-model="vm.user.number"></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-8"><div class="form-group form-loja" ng-hide="vm.user.customData.estrangeiro == \'true\'"><label class="control-label" for="cidade" accesskey="E">Cidade</label> <input tabindex="17" name="cidade" type="text" id="cidade" class="form-control" placeholder="Cidade" ng-model="vm.user.city"></div></div><div class="col-md-4"><div class="form-group form-loja" ng-hide="vm.user.customData.estrangeiro == \'true\'"><label class="control-label" for="estado" accesskey="E">Estado</label> <input tabindex="18" name="estado" type="text" id="estado" size="2" maxlength="2" class="form-control" placeholder="UF" ng-model="vm.user.state"></div></div></div></div><div class="col-md-6"><div class="form-group form-loja form-loja-btn-promo"><div class="row"><label class="col-xs-5 col-sm-5 col-md-8 col-lg-8 control-label" for="Promo\xE7\xF5es" accesskey="E">Receber promo\xE7\xF5es exclusivas:</label><div class="col-xs-7 col-sm-7 col-md-4 col-lg-4 input-group"><label class="btn btn-default" ng-class="{\'active\':vm.user.mailing}"><input tabindex="19" name="sim" class="active" type="radio" ng-model="vm.user.mailing" ng-value="true">Sim</label> <label class="btn btn-default" ng-class="{\'active\':!vm.user.mailing}"><input name="nao" type="radio" ng-model="vm.user.mailing" ng-value="false">N\xE3o</label></div></div></div></div><div class="col-md-4 col-md-offset-4 form-group form-loja border-top-simples"><label class="control-label">&nbsp;</label> <button tabindex="20" title="Efetuar Cadastro" type="button" class="loja-background-color btn btn-success loja-btn btn-lg btn-scala btn-block btn-cliente" ng-click="vm.savePerson();" scroll-to-bookmark="step4">Efetuar Cadastro <i class="fa fa-user-plus" aria-hidden="true"></i> <i class="fa fa-caret-right" aria-hidden="true"></i></button></div></form>');
$templateCache.put('app/components/xsSearchBar/xsSearchBar.html','<section class="row b2c-checkin all"><div class="quartos col-md-2 col-xs-12 padding-xs-right-5 form-group" ng-if="vm.showHotelFilter"><label class="label">Hoteis</label> <select class="form-control" id="selectHoteis" ng-options="currentHotel as currentHotel.name for currentHotel in vm.currentHoteis track by currentHotel.id" ng-model="vm.selectedHotel"><option value="0">Todos Hoteis</option></select></div><div class="data-entrada col-xs-6 col-md-2 padding-xs-right-5 form-group"><label class="label">Check-in</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-change="vm.handleEndDate()" ng-model="vm.dates.date" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.today" is-open="vm.activeDate" ng-click="vm.handleDate()"> <span class="input-group-addon"><a ng-click="vm.handleDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openDatePickerModal()">{{vm.dates.date| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div><div class="data-saida col-xs-6 col-md-2 padding-xs-left-5 form-group"><label class="label">Check-out</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-model="vm.dates.endDate" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.nextDay" is-open="vm.activeEndDate" ng-click="vm.handleEndDate()"> <span class="input-group-addon"><a title="Calend\xE1rio" href="" ng-click="vm.handleEndDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openEndDatePickerModal()">{{vm.dates.endDate| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div><div class="quartos col-xs-6 col-md-2 padding-xs-right-5 form-group"><label class="label">Quantidade de Quartos</label> <select class="form-control" id="quartos" ng-model="vm.quartos" ng-change="vm.ckecksQuantidadesQuartos()"><option value="">Quartos</option><option value="1">1 Quarto</option><option value="2">2 Quartos</option><option value="3">3 Quartos</option><option value="4">4 Quartos</option><option value="5">5 Quartos</option><option value="6">6 Quartos</option></select></div><div class="pessoas col-xs-6 col-md-2 padding-xs-left-5 form-group"><label class="label">Adultos</label> <select class="form-control" id="adultos" ng-model="vm.adt" ng-disabled="vm.verificaAdultos"><option value="">Adultos</option><option value="1">1 Adulto</option><option value="2" ng-if="vm.maxAdultos>=2">2 Adultos</option><option value="3" ng-if="vm.maxAdultos>=3">3 Adultos</option><option value="4" ng-if="vm.maxAdultos>=4">4 Adultos</option><option value="5" ng-if="vm.maxAdultos>=5">5 Adultos</option><option value="6" ng-if="vm.maxAdultos>=6">6 Adultos</option><option value="7" ng-if="vm.maxAdultos>=7">7 Adultos</option><option value="8" ng-if="vm.maxAdultos>=8">8 Adultos</option><option value="9" ng-if="vm.maxAdultos>=9">9 Adultos</option><option value="10" ng-if="vm.maxAdultos>=10">10 Adultos</option></select></div><div ng-if="vm.verificaDialogChd" class="col-xs-12 col-md-2 padding-xs-left-5 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button class="form-control btn btn-success" ng-click="vm.openChdDialog()">Crian\xE7as</button></div><div ng-if="!vm.verificaDialogChd" class="criancas col-md-2 col-xs-6 padding-xs-right-5 form-group"><label class="label">Crian\xE7as</label> <select class="form-control input-group" id="criancas" ng-model="vm.chd" ng-disabled="vm.verificaCriancas"><option value="">0 Crian\xE7as de de 2 a 12 anos</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option><option value="5">5 Crian\xE7as de de 2 a 12 anos</option><option value="5">6 Crian\xE7as de de 2 a 12 anos</option></select></div><div ng-if="!vm.verificaDialogChd" class="colos col-md-2 col-xs-6 padding-xs-left-5 form-group"><label class="label">Colos</label> <select class="form-control input-group" id="criancas" ng-model="vm.colo" ng-disabled="vm.verificaColos"><option value="">0 Colos de de 0 a 2 anos</option><option value="1">1 Colo de de 0 a 2 anos</option><option value="2">2 Colos de de 0 a 2 anos</option><option value="3">3 Colos de de 0 a 2 anos</option><option value="4">4 Colos de de 0 a 2 anos</option><option value="5">5 Colos de de 0 a 2 anos</option><option value="6">6 Colos de de 0 a 2 anos</option></select></div><div class="pesquisar col-xs-12 col-md-2 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button title="Pesquisar disponibilidade" type="button" class="btn time-05 btn-success btn-block ripple" ng-click="vm.search()">PESQUISAR <i class="fa fa-search" aria-hidden="true"></i></button></div></section><section class="row b2c-checkin-apto-extra" ng-show="vm.quartos > 1"><div class="col-md-12"><h2 title="Informe a quantidade de h\xF3spedes para os apartamentos">Informe a quantidade de h\xF3spedes para os apartamentos</h2><hr></div><div class="col-md-4 b2c-row-apto-extra" ng-repeat="apto in vm.aptos"><div class="row box"><div class="col-md-12"><h3 title="{{$index + 1}}\xBA Quarto">{{$index + 1}}\xBA Quarto <i class="fa fa-bed" aria-hidden="true"></i></h3></div><div class="sub-pessoas col-xs-6 padding-xs-right-5 form-group"><label class="label">Quantidade de Adultos</label> <select class="form-control input-group" id="adultos" ng-model="apto.adt"><option value="">Adultos</option><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option><option value="6">6 Adultos</option><option value="7">7 Adultos</option><option value="8">8 Adultos</option><option value="9">9 Adultos</option><option value="10">10 Adultos</option></select></div><div ng-if="vm.verificaDialogChd" class="col-xs-6 padding-xs-right-5 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button class="form-control btn btn-success btn-chd-dialog" ng-click="vm.openChdDialog()">Crian\xE7as</button></div><div ng-if="!vm.verificaDialogChd" class="sub-criancas col-xs-6 padding-xs-left-5 form-group"><label class="label">Quantidade de Crian\xE7as</label> <select class="form-control input-group" id="criancas" ng-model="apto.chd"><option value="">Crian\xE7as de de 2 a 12 anos</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option><option value="5">5 Crian\xE7as de de 2 a 12 anos</option><option value="6">6 Crian\xE7as de de 2 a 12 anos</option></select></div><div ng-if="!vm.verificaDialogChd" class="sub-criancas col-xs-6 form-group"><label class="label">Quantidade de Colos</label> <select class="form-control input-group" id="criancas" ng-model="apto.colo"><option value="">Colos de de 0 a 2 anos</option><option value="1">1 Colo de de 0 a 2 anos</option><option value="2">2 Colos de de 0 a 2 anos</option><option value="3">3 Colos de de 0 a 2 anos</option><option value="4">4 Colos de de 0 a 2 anos</option><option value="5">5 Colos de de 0 a 2 anos</option><option value="6">6 Colos de de 0 a 2 anos</option></select></div></div></div></section>');
$templateCache.put('app/components/xsSearchBar/xsSearchVertical.html','<div class="row b2c-filters-check-in"><div class="col-md-12 content"><div class="row hoteis" ng-if="vm.showHotelFilter"><div class="col-xs-12"><label class="label">Hoteis</label> <select class="form-control" id="selectHoteis" ng-options="currentHotel as currentHotel.name for currentHotel in vm.currentHoteis track by currentHotel.id" ng-model="vm.selectedHotel"><option value="0">Todos Hoteis</option></select></div></div><div class="row dates"><div class="check-in col-xs-6 padding-right-5"><div class="form-group"><label class="label">Check-in</label><div class="input-group hidden-xs hidden-sm"><input type="text" class="form-control" ng-change="vm.handleEndDate()" ng-model="vm.dates.date" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.today" is-open="vm.activeDate" ng-click="vm.handleDate()"> <span class="input-group-addon"><a ng-click="vm.handleDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openDatePickerModal()">{{vm.dates.date| date:\'dd/MM/yyyy\'}}&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div></div><div class="check-out col-xs-6 padding-left-5"><div class="form-group"><label class="label">Check-out</label><div class="input-group hidden-xs hidden-sm"><input type="text" class="form-control" ng-model="vm.dates.endDate" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.nextDay" is-open="vm.activeEndDate" ng-click="vm.handleEndDate()"> <span class="input-group-addon"><a title="Calend\xE1rio" href="" ng-click="vm.handleEndDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openEndDatePickerModal()">{{vm.dates.endDate| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div></div></div><div class="row quartos"><div class="col-xs-12"><div class="form-group"><label class="label">Quantidade de Quartos</label> <select class="form-control" ng-model="vm.quartos"><option value="1">1 Quarto</option><option value="2">2 Quartos</option><option value="3">3 Quartos</option><option value="4">4 Quartos</option><option value="5">5 Quartos</option><option value="6">6 Quartos</option></select></div></div></div><div class="row hospedes one" ng-show="vm.quartos == 1"><div class="col-xs-4 adulto padding-right-5"><div class="form-group"><label class="label" for="adultos"><i class="fa fa-male" aria-hidden="true"></i> Adultos</label> <select class="form-control input-group" id="adultos" ng-model="vm.adt"><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option></select></div></div><div ng-if="vm.verificaDialogChd" class="col-xs-6 padding-xs-right-5 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button class="form-control btn btn-success btn-chd-dialog" ng-click="vm.openChdDialog()">Crian\xE7as</button></div><div ng-if="!vm.verificaDialogChd" class="col-xs-4 chd padding-right-5 padding-left-5"><div class="form-group"><label class="label" for="criancas"><i class="fa fa-child" aria-hidden="true"></i> Crian\xE7a</label> <select class="form-control input-group" id="criancas" ng-model="vm.chd"><option value="0">Crian\xE7as</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option><option value="5">5 Crian\xE7as de de 2 a 12 anos</option></select></div></div><div ng-if="!vm.verificaDialogChd" class="col-xs-4 colos padding-left-5"><div class="form-group"><label class="label" for="colos"><i class="fa fa-child" aria-hidden="true"></i> Colos</label> <select class="form-control input-group" id="colos" ng-model="vm.colo"><option value="0">Colos</option><option value="1">1 Colo de de 0 a 2 anos</option><option value="2">2 Colos de de 0 a 2 anos</option><option value="3">3 Colos de de 0 a 2 anos</option><option value="4">4 Colos de de 0 a 2 anos</option><option value="5">5 Colos de de 0 a 2 anos</option></select></div></div></div><div class="aparts-extra" ng-show="vm.quartos > 1"><div class="row hospedes extra" ng-repeat="apto in vm.aptos"><div class="col-xs-12 title-hospedes"><h5 title="{{$index + 1}}\xBA Quarto">{{$index + 1}}\xBA Quarto <i class="fa fa-bed" aria-hidden="true"></i></h5></div><div class="col-xs-4 adulto padding-right-5"><label class="label" for="adultos{{$index}}"><i class="fa fa-male" aria-hidden="true"></i> Adultos</label> <select class="form-control input-group" id="adultos{{$index}}" ng-model="apto.adt"><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option><option value="6">6 Adultos</option></select></div><div ng-if="vm.verificaDialogChd" class="col-xs-6 padding-xs-right-5 form-group"><label class="label hidden-xs hidden-sm">&nbsp;</label> <button class="form-control btn btn-success btn-chd-dialog" ng-click="vm.openChdDialog()">Crian\xE7as</button></div><div ng-if="!vm.verificaDialogChd" class="col-xs-4 chd padding-right-5 padding-left-5"><label class="label" for="criancas{{$index}}"><i class="fa fa-child" aria-hidden="true"></i> Crian\xE7a</label> <select class="form-control input-group" id="criancas{{$index}}" ng-model="apto.chd"><option value="0">Crian\xE7as</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option><option value="5">5 Crian\xE7as de de 2 a 12 anos</option></select></div><div ng-if="!vm.verificaDialogChd" class="col-xs-4 colos padding-left-5"><label class="label" for="colos{{$index}}"><i class="fa fa-child" aria-hidden="true"></i> Colos</label> <select class="form-control input-group" id="colos{{$index}}" ng-model="apto.colo"><option value="0">Colos</option><option value="1">1 Colo de de 0 a 2 anos</option><option value="2">2 Colos de de 0 a 2 anos</option><option value="3">3 Colos de de 0 a 2 anos</option><option value="4">4 Colos de de 0 a 2 anos</option><option value="5">5 Colos de de 0 a 2 anos</option></select></div><div class="col-xs-12"><hr role="reparator"></div></div></div><div class="row function"><div class="col-xs-12"><button title="PESQUISAR" type="button" class="btn btn-warning btn-block" ng-click="vm.search()">PESQUISAR <i class="fa fa-search" aria-hidden="true"></i></button></div></div></div></div>');
$templateCache.put('app/components/xsSearchBar/xsSearchVerticalAC.html','<div class="row b2c-filters-check-in"><div class="col-md-12 content"><div class="row dates"><div class="check-in col-xs-6 padding-right-5"><div class="form-group"><label class="label">Check-in</label><div class="input-group hidden-xs hidden-sm"><input type="text" class="form-control" ng-change="vm.handleEndDate()" ng-model="vm.dates.date" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.today" is-open="vm.activeDate" ng-click="vm.handleDate()"> <span class="input-group-addon"><a ng-click="vm.handleDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openDatePickerModal()">{{vm.dates.date| date:\'dd/MM/yyyy\'}}&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div></div><div class="check-out col-xs-6 padding-left-5"><div class="form-group"><label class="label">Check-out</label><div class="input-group hidden-xs hidden-sm"><input type="text" class="form-control" ng-model="vm.dates.endDate" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.nextDay" is-open="vm.activeEndDate" ng-click="vm.handleEndDate()"> <span class="input-group-addon"><a title="Calend\xE1rio" href="" ng-click="vm.handleEndDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openEndDatePickerModal()">{{vm.dates.endDate| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div></div></div><div class="row quartos"><div class="col-xs-12"><div class="form-group"><label class="label">Quantidade de Quartos</label> <select class="form-control" ng-model="vm.quartos"><option value="1">1 Quarto</option><option value="2">2 Quartos</option><option value="3">3 Quartos</option><option value="4">4 Quartos</option><option value="5">5 Quartos</option><option value="6">6 Quartos</option></select></div></div></div><div class="row hospedes one" ng-show="vm.quartos == 1"><div class="col-xs-6 adulto padding-right-5"><div class="form-group"><label class="label" for="adultos"><i class="fa fa-male" aria-hidden="true"></i> Adultos</label> <select class="form-control input-group" id="adultos" ng-model="vm.adt"><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option><option value="6">6 Adultos</option></select></div></div><div class="col-xs-6 chd padding-left-5"><div class="form-group"><label class="label" for="criancas"><i class="fa fa-child" aria-hidden="true"></i> Crian\xE7a</label> <select class="form-control input-group" id="criancas" ng-model="vm.chd"><option value="0">Crian\xE7as</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option><option value="5">5 Crian\xE7as de de 2 a 12 anos</option></select></div></div></div><div class="aparts-extra" ng-show="vm.quartos > 1"><div class="row hospedes extra" ng-repeat="apto in vm.aptos"><div class="col-xs-12 title-hospedes"><h5 title="{{$index + 1}}\xBA Quarto">{{$index + 1}}\xBA Quarto <i class="fa fa-bed" aria-hidden="true"></i></h5></div><div class="col-xs-6 adulto padding-right-5"><label class="label" for="adultos{{$index}}"><i class="fa fa-male" aria-hidden="true"></i> Adultos</label> <select class="form-control input-group" id="adultos{{$index}}" ng-model="apto.adt"><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option><option value="6">6 Adultos</option></select></div><div class="col-xs-6 chd padding-left-5"><label class="label" for="criancas{{$index}}"><i class="fa fa-child" aria-hidden="true"></i> Crian\xE7as</label> <select class="form-control input-group" id="criancas{{$index}}" ng-model="apto.chd"><option value="0">Crian\xE7as</option><option value="1">1 Crian\xE7a de de 2 a 12 anos</option><option value="2">2 Crian\xE7as de de 2 a 12 anos</option><option value="3">3 Crian\xE7as de de 2 a 12 anos</option><option value="4">4 Crian\xE7as de de 2 a 12 anos</option><option value="5">5 Crian\xE7as de de de 2 a 12 anos</option></select></div><div class="col-xs-12"><hr role="reparator"></div></div></div><div class="row function"><div class="col-xs-12"><button title="PESQUISAR" type="button" class="btn btn-warning btn-block" ng-click="vm.search()">PESQUISAR <i class="fa fa-search" aria-hidden="true"></i></button></div></div></div></div>');
$templateCache.put('app/components/xsSearchBar/xsSearchVerticalP.html','<div class="row b2c-filters-check-in"><div class="col-md-12 content"><div class="row dates"><div class="check-in col-xs-6 padding-right-5"><div class="form-group"><label class="label">Check-in</label><div class="input-group hidden-xs hidden-sm"><input type="text" class="form-control" ng-change="vm.handleEndDate()" ng-model="vm.dates.date" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.today" is-open="vm.activeDate" ng-click="vm.handleDate()"> <span class="input-group-addon"><a ng-click="vm.handleDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openDatePickerModal()">{{vm.dates.date| date:\'dd/MM/yyyy\'}}&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div></div><div class="check-out col-xs-6 padding-left-5"><div class="form-group"><label class="label">Check-out</label><div class="input-group hidden-xs hidden-sm"><input type="text" class="form-control" ng-model="vm.dates.endDate" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.nextDay" is-open="vm.activeEndDate" ng-click="vm.handleEndDate()"> <span class="input-group-addon"><a title="Calend\xE1rio" href="" ng-click="vm.handleEndDate()"><i class="fa fa-calendar" aria-hidden="true"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block btn-datepicker" ng-click="vm.openEndDatePickerModal()">{{vm.dates.endDate| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<span class="pull-right"><i class="fa fa-calendar"></i></span></button></div></div></div><div class="row quartos"><div class="col-xs-12"><div class="form-group"><label class="label">Quantidade de Quartos</label> <select class="form-control" ng-model="vm.quartos"><option value="1">1 Quarto</option><option value="2">2 Quartos</option><option value="3">3 Quartos</option><option value="4">4 Quartos</option><option value="5">5 Quartos</option><option value="6">6 Quartos</option></select></div></div></div><div class="row hospedes one" ng-show="vm.quartos == 1"><div class="col-xs-12 adulto pessoa"><div class="form-group"><label class="label" for="adultos"><i class="fa fa-male" aria-hidden="true"></i> Adultos</label> <select class="form-control input-group" id="adultos" ng-model="vm.adt"><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option><option value="6">6 Adultos</option></select></div></div></div><div class="aparts-extra" ng-show="vm.quartos > 1"><div class="row hospedes extra" ng-repeat="apto in vm.aptos"><div class="col-xs-12 title-hospedes"><h5 title="{{$index + 1}}\xBA Quarto">{{$index + 1}}\xBA Quarto <i class="fa fa-bed" aria-hidden="true"></i></h5></div><div class="col-xs-12 adulto pessoa"><label class="label" for="adultos{{$index}}"><i class="fa fa-male" aria-hidden="true"></i> Adultos</label> <select class="form-control input-group" id="adultos{{$index}}" ng-model="apto.adt"><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option></select></div><div class="col-xs-12"><hr role="reparator"></div></div></div><div class="row function"><div class="col-xs-12"><button title="PESQUISAR" type="button" class="btn btn-warning btn-block" ng-click="vm.search()">PESQUISAR <i class="fa fa-search" aria-hidden="true"></i></button></div></div></div></div>');
$templateCache.put('app/components/xsVitrine/xsVitrine.html','<section style="max-width: 960px; margin: auto; padding-top: 2rem;"><ul style="margin: 0; padding: 0; display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 2rem;"><li ng-repeat="product in vm.productsVitrine" style="background-color: #eee; border-radius: 3rem;"><div ng-click="vm.verMaisDetalhesProduto(product)" style="position: relative;"><img src="{{product.image}}" alt="{{product.campoadicional1}}" style="width: 100%; border-radius: 3rem 3rem 0 0; aspect-ratio: 4/3;"><div style="position: absolute; bottom: 1rem; right: 1rem; font-size: 1.5rem; font-weight: 700;"><button style="border: none; border-radius: 999px; padding: .25rem 1rem; background-color: #eee; color: #323232;box-shadow: 1px 1px 2px rgba(0, 0, 0, .4);">+ Detalhes</button></div></div><div style="padding: 0 2rem 2rem 2rem"><div style="margin: 1rem 0 2rem 0; display: flex; flex-direction: column; align-items: center;"><button style="width: fit-content; border: none; text-wrap: pretty; text-align: center; padding: .5rem 2rem; border-radius: 999px; background-color: #323232; color: #fff;" ng-click="vm.selecionarDataPeloProdutoVitrine(product)">{{product.campoadicional2 || product.campoadicional1 || product.supplierName}}</button></div><div style="display: flex; flex-direction: column; align-items: center; gap: 1.5rem; font-size: 1.5rem;"><div style="display: -webkit-box; -webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-align: center;">{{product.memo}}</div><div ng-if="!!product.memo" style="color: forestgreen; font-weight: 700; text-align: center;" ng-click="vm.verMaisDetalhesProduto(product)">Leia mais</div><div>A partir de: <span style="font-weight: 700;">{{(product.minimalValue || product.value)/100 | currency:\'R$ \'}}</span></div><div style="font-size: 1.5rem; font-weight: 700;"><button style="box-shadow: 0 1px 2px rgba(0, 0, 0, .4); padding: .5rem 2rem; border-radius: 999px; background-color: #CEFF71; color:#323232; border: none;" ng-click="vm.selecionarDataPeloProdutoVitrine(product)">Escolha uma data</button></div></div></div></li></ul><div ng-if="vm.loadingProducts" style="text-align: center;">carregando...</div><footer ng-if="!vm.loadingProducts" style="text-align: center; padding: 3rem 1rem;"><div style="margin: auto; max-width: 380px; cursor: pointer;" ng-click="vm.ingressosController.openDatePickerModalMobile(vm.lastDate)"><div style="text-wrap: pretty; font-size: 1.5rem; margin: 0 auto 1rem auto;">N\xE3o encontrou o que deseja? <span style="color: forestgreen; font-weight: 700;">Clique aqui </span>e conhe\xE7a todos os atrativos.</div><button class="button-xs-vitrine">+ Atra\xE7\xF5es</button></div></footer></section>');
$templateCache.put('app/cupom/templates/template-cross-sell.html','<div class="row"><div class="container" id="step-2"><div class="row"><div class="col-xs-12 loja-header-default"><div class="row"><div class="col-xs-offset-3 col-xs-8 col-sm-offset-0 col-sm-4 col-md-offset-0 col-md-4 loja-div-voltar"><button title="Escolher Ingressos" class="btn btn-info btn-lg loja-btn loja-btn-voltar" ng-click="vm.backStep()"><i class="fa fa-arrow-left"></i>&nbsp; Voltar</button></div><div class="col-md-4 col-sm-12 col-xs-12"><h3 title="Escolha seus adicionais" align="center"><i class="fa fa-ticket"></i>Escolha seus adicionais</h3></div></div></div><div class="col-xs-12"><ul class="list-group"><li class="list-group-item row" ng-repeat="product in vm.produtosExtras"><div class="col-md-5"><h4>{{product.shortName ? product.shortName : product.name}}</h4></div><div class="col-md-4"><div class="row"><div class="col-xs-4"><button class="btn btn-info" ng-click="vm.addRemoveProduto( - 1, product)"><i class="fa fa-minus"></i></button></div><div class="col-xs-4"><button class="btn btn-default">{{product.amount}}</button></div><div class="col-xs-4"><button class="btn btn-info" ng-click="vm.addRemoveProduto( + 1, product)"><i class="fa fa-plus"></i></button></div></div></div><div class="col-md-3"><h4>Valor: {{vm.extraProductValue(product) / 100 | currency:\'R$ \'}}</h4></div></li></ul></div><div class="col-xs-12 loja-footer-default"><div class="row"><div class="col-md-4 col-md-offset-4"><h3 title="Valor: {{vm.totalGeral() / 100 | currency:\'R$ \'}}">Valor: {{vm.totalGeral() / 100 | currency:\'R$ \'}}</h3></div><div class="col-md-4"><button title="Continuar" class="btn btn-info btn-lg loja-btn pull-right" ng-click="vm.nextStep(vm.step)">Continuar <i class="fa fa-arrow-right"></i></button></div></div></div></div></div></div>');
$templateCache.put('app/hospedagem/carrinho/carrinho.html','<div class="content-car time-10 animated" ng-controller="HospedagemCarrinhoController as vm"><div class="row b2c-paymentReserva-header"><div class="col-md-12"><div class="page-header"><h2 title="Carrinho">Carrinho <i class="fa fa-shopping-cart" aria-hidden="true"></i></h2></div></div></div><div class="row b2c-carrinho-header"><div class="col-md-12"><label title="{{vm.days}} {{vm.days > 1 ? \'Di\xE1rias\' : \'Di\xE1ria\'}}">{{vm.days}} {{vm.days > 1 ?\'Di\xE1rias\' : \'Di\xE1ria\'}}</label><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{vm.checkin| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{vm.checkout| date:\'dd/MM/yyyy\'}}</span><br><label>Check-out</label></div></div><label>Op\xE7\xE3o Escolhida</label><h3 title="{{vm.selectedHotel.item.service}}">{{vm.selectedHotel.item.service}}</h3><div ng-if="vm.showCupom" class="row b2c-box-filter-cupom"><div class="col-md-12"><h3 title="Cupom de desconto"><i class="fa fa-tag" aria-hidden="true"></i> Cupom de desconto</h3><div class="row"><div class="form-group col-xs-10"><input type="text" class="form-control" placeholder="Codigo" id="chaveCumpomDesconto" ng-model="vm.cupomCode" ng-disabled="vm.cupomIsValid"></div><div class="form-group col-xs-2"><button class="btn btn-block btn-primary" title="Calcular Desconto" ng-click="vm.validCupom()" ng-disabled="vm.cupomCode == null && vm.cupomCodKey == null" ng-if="!vm.cupomIsValid"><i class="fa fa-check"></i></button> <button class="btn btn-block btn-danger" ng-click="vm.clearCupom()" ng-disabled="vm.cupomCode == null && vm.cupomCodKey == null" ng-if="vm.cupomIsValid"><i class="fa fa-close"></i></button></div></div></div></div></div></div><div class="row b2c-itens-carrinho"><div ng-if="apto.value > 0" class="col-md-12 itens" ng-repeat="apto in vm.aptos"><h3 title="{{$index + 1}}\xBA Apartamento">{{$index + 1}}\xBA Apartamento</h3><h5 ng-show="apto.service" title="Nome do Apartamento: {{apto.service}}"><i class="fa fa-check" aria-hidden="true"></i> {{apto.service}}</h5><h5 ng-show="apto.mealType" title="Tipo de Pens\xE3o: {{apto.mealType}}"><i class="fa fa-check" aria-hidden="true"></i> {{apto.mealType}}</h5><div ng-show="apto.included.length > 0"><h5 ng-repeat="adicional in apto.included" ng-hide="apto.mealType == adicional.service"><i class="fa fa-check"></i>&nbsp;{{adicional.service}}</h5></div><h5 title="Quantidade de Hospedes"><i class="fa fa-check" aria-hidden="true"></i><span>{{::vm.personsAsString(apto.persons)}}</span></h5><h5 ng-show="apto.productsValue > 0" title="Valor do Apartamento: {{(apto.value - apto.productsValue) / 100| currency: \'R$ \'}}" class="value">Valor do Apartamento: <strong>{{(apto.value - apto.productsValue) / 100| currency: \'R$ \'}}</strong></h5><h5 ng-show="apto.productsValue > 0" title="Valor dos Ingressos: {{apto.productsValue / 100| currency: \'R$ \'}}">Valor dos ingressos: <strong>{{apto.productsValue / 100| currency: \'R$ \'}}</strong></h5><h4 title="Total do Apartamento: {{apto.value / 100| currency: \'R$ \'}}" class="value">Valor: <strong>{{apto.value / 100| currency: \'R$ \'}}</strong></h4></div></div><div ng-if="vm.totalPagamento > 0" class="row b2c-carrinho-footer"><div class="col-md-12"><h2 title="Valor Total: {{vm.totalPagamento| currency: \'R$ \'}}">Total: <strong>{{vm.totalPagamento| currency: \'R$ \'}}</strong></h2></div></div><div ng-if="vm.totalPagamento > 0 && vm.descount" class="row b2c-carrinho-footer"><div class="col-md-12"><h4 style="text-align: right;" class="textoDescontoPix">{{vm.descount.percent}} de desconto {{vm.descount.paymentType}}</h4></div><div class="col-md-12"><h2 title="Valor Total no PIX: {{vm.descount.total| currency: \'R$ \'}}">Pague: <strong>{{vm.descount.total| currency: \'R$ \'}}</strong> {{vm.descount.paymentType}}</h2></div></div><div ng-if="vm.totalPagamento <= 0" class="row b2c-carrinho-footer not-itens"><div ng-show="vm.aptos.length >= 1" class="col-md-12"><h2 title="Selecione {{vm.aptos.length > 1 ? \'seus Apartamentos\' : \'seu Apartamento\'}}"><i class="fa fa-arrow-left"></i> Selecione {{vm.aptos.length > 1 ? \'seus Apartamentos\' : \'seu Apartamento\'}}</h2></div></div><div ng-if="vm.showCupom" class="row b2c-carrinho-footer not-itens buttons"><div ng-show="vm.solicitacaoReservaShow" class="col-md-12 form-group"><button title="Solicitar Reserva" uib-tooltip="Click aqui para solicitar uma pr\xE9-reserva. R\xE1pido e f\xE1cil!" class="btn btn-info btn-lg btn-block" ng-click="vm.modalSolicitacaoReserva(vm.aptos, vm.days, vm.totalPagamento)">Fazer uma Pr\xE9-Reserva <i class="fa fa-envelope"></i></button></div></div></div>');
$templateCache.put('app/hospedagem/apartamentos/header-apartamento-banner.html','<header role="banner" class="row b2c-header-apto b2c-header-banner" style="background-image: url(\'assets/images/layout/img-header-apartamento.jpg\')"><div class="col-md-12"><div class="row b2c-row-header"><div class="col-md-3 hidden-xs hidden-sm"><button title="Retornar a lista de hot\xE9is" ui-sref="hospedagemHoteis" class="btn time-05 btn-danger btn-block"><i class="fa fa-arrow-left" aria-hidden="true"></i></button></div><div class="col-md-6"><h3 title="{{vm.selectedHotel.item.service}}">{{vm.selectedHotel.item.service}}</h3></div><div class="col-md-3"><button title=" Apartamentos" class="btn time-05 btn-sm btn-warning btn-block" ng-click="vm.directScroll(\'lista_apartamentos\')">Apartamentos <i class="fa fa-arrow-down" aria-hidden="true"></i></button></div></div><div class="row b2c-header-faixa" ng-show="vm.selectedHotel.item.comodidades.length"><div class="col-md-8 col-md-offset-2"><h2 title="Servi\xE7os e itens do {{vm.selectedHotel.item.service}}">Servi\xE7os e itens</h2></div><div class="container-icons col-md-8 col-md-offset-2"><div class="icone" ng-repeat="comodidade in vm.selectedHotel.item.comodidades| limitTo: 6" ng-if="comodidade.imagem"><img uib-tooltip="{{comodidade.nome}}" title="{{comodidade.nome}}" alt="Comodidade: {{comodidade.nome}}" class="img-responsive" ng-src="assets/images/icons/{{comodidade.imagem}}"></div></div></div></div></header>');
$templateCache.put('app/hospedagem/apartamentos/header-apartamento.html','<header role="banner" class="row info-empreendimento {{vm.selectedHotel.item.customData.nivelDestaque}}"><aside class="col-md-4 b2c-img-box img-hotel-header" style="background-image: url(\'{{::vm.foto(vm.selectedHotel.item)}}\')"><img ng-show="vm.selectedHotel.item.customData.nivelDestaque" title="{{vm.selectedHotel.item.customData.nivelDestaque}}" alt="{{vm.selectedHotel.item.customData.nivelDestaque}}" class="img-responsive anchor {{vm.selectedHotel.item.customData.nivelDestaque}}" ng-src="assets/images/layout/{{vm.selectedHotel.item.customData.nivelDestaque}}.png"> <button uib-tooltip=" " type="button" class="retornar time-05 btn btn-danger" ng-click="vm.toPreviousState()"><i class="fa fa-arrow-left" aria-hidden="true"></i></button> <button ng-if="vm.selectedHotel.item.foto" uib-tooltip="Ver galeria de fotos" title="Ver galeria de fotos" type="button" class="galeria btn-icon btn-gallery-icon btn btn-default" ng-click="vm.modalGaleria(vm.selectedHotel.item)"><i class="fa fa-camera" aria-hidden="true"></i> <label>Fotos</label></button> <button uib-tooltip="Mais detalhes do {{vm.selectedHotel.item.service}}" title="Mais detalhes do {{vm.selectedHotel.item.service}}" type="button" class="btn btn-icon btn-mais btn btn-default" ng-click="vm.modalInformativoHotel(vm.selectedHotel.item)"><i class="fa fa-plus-circle" aria-hidden="true"></i> <label>Detalhes</label></button> <button uib-tooltip="Compartilhar" title="Compartilhar" type="button" class="btn btn-icon btn-share btn-default" ng-click="vm.modalCompartilhar(vm.selectedHotel.item)"><i class="fa fa-share-alt" aria-hidden="true"></i> <label>Compart.</label></button> <a ng-if="vm.selectedHotel.item.linkmap" uib-tooltip="Abrir Google Maps" title="Abrir Google Maps" class="btn btn-icon btn-maps btn-default" target="_blank" rel="noopener" href="{{vm.selectedHotel.item.linkmap}}"><i class="fa fa-map-marker" aria-hidden="true"></i> <label>maps</label></a></aside><article class="col-md-8 description-hotel"><div class="row description-hotel-header"><div class="col-xs-12 padding-0"><h1 title="{{vm.selectedHotel.item.service}}">{{vm.selectedHotel.item.service}}</h1><h2 title="Data da hospedagem: {{vm.consulta.noites}} {{vm.consulta.noites > 1 ? \'Noites\' : \'Noite\'}} - {{vm.consulta.checkin| date:\'dd/MM/yyyy\'}} a {{vm.consulta.checkout|date:\'dd/MM/yyyy\'}}">{{vm.consulta.noites}} {{vm.consulta.noites > 1 ? \'Noites\' : \'Noite\'}} - <i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{vm.consulta.checkin| date:\'dd/MM/yyyy\'}}&nbsp; a &nbsp;<i class="fa fa-calendar-times-o" aria-hidden="true"></i> {{vm.consulta.checkout|date:\'dd/MM/yyyy\'}}</h2></div></div><div class="row"><div class="col-md-12"><em>{{vm.selectedHotel.item.customData.endereco|| vm.selectedHotel.item.customData.destino}} - Check-in: {{vm.selectedHotel.item.politicas.checkin}} - Check-out: {{vm.selectedHotel.item.politicas.checkout}}</em><p class="text" ng-bind-html="vm.selectedHotel.item.memo | toHtml"></p></div></div><div class="row b2c-faixa-icons" ng-show="vm.selectedHotel.item.comodidades.length"><div class="container-icons col-md-12"><div class="icone" ng-if="comodidade.imagem" ng-repeat="comodidade in vm.selectedHotel.item.comodidades| limitTo: 8"><img uib-tooltip="{{comodidade.nome}}" title="{{comodidade.nome}}" alt="Comodidade: {{comodidade.nome}}" class="img-responsive" ng-src="assets/images/icons/{{comodidade.imagem}}"></div></div></div></article></header>');
$templateCache.put('app/hospedagem/apartamentos/hospedagem-apartamentos-template.html','<div class="container-fluid b2c-container"><div id="hospedagem-main" bookmark-offset="55"><xs-breadcrump xs-step="1" class="hidden-xs"></xs-breadcrump><div id="escolhaApartamento" class="usuario b2c-header-apto"><div ng-include="\'app/hospedagem/apartamentos/header-apartamento.html\'"></div><main role="main"><div class="row navbar-search-bar-horizontal"><section id="navbarSearchBarHorizontal" class="col-md-12"></section><xs-search-bar-holder xs-id-holder="navbarSearchBarHorizontal" xs-search="vm.searchHorizontal" template-url="quinta_do_sol/template/xsSearchBar.html"></xs-search-bar-holder></div><section class="row content-apartamentos {{vm.selectedHotel.item.customData.nivelDestaque}}"><div class="col-md-9"><div class="row lista-filtros-apto"><div class="col-md-12"><div class="row b2c-apto-filters"><div class="col-md-12"><div class="row"><div class="col-xs-6 col-md-6 form-group"><h3 title="vm.uhs.length {{vm.uhs.length > 1 ? \'Apartamentos dispon\xEDveis\' : \'Apartamento dispon\xEDvel\'}}">{{vm.uhs.length}} {{vm.uhs.length > 1 ? \'Apartamentos dispon\xEDveis\' : \'Apartamento dispon\xEDvel\'}}</h3></div><div class="col-xs-6 col-md-3 form-group"><button title="Ver filtros dos Apartamentos" ng-click="rowFiltersAptoIsOpen = !rowFiltersAptoIsOpen" class="pull-right btn btn-block time-05 btn-danger ripple"><i class="fa fa-filter" aria-hidden="true"></i> Filtros <i ng-class="{ \'fa-chevron-down\': !rowFiltersAptoIsOpen, \'fa-chevron-up\': rowFiltersAptoIsOpen  }" class="fa" aria-hidden="true"></i></button></div><div class="col-xs-12 col-md-3 form-group"><select class="form-control" ng-model="vm.ordenarPorValor" ng-change="vm.ordernarPrecos(vm.ordenarPorValor)"><option value="" selected="selected">Ordenar por valor</option><option value="MenorParaMaior">Menor para maior</option><option value="MaiorParaMenor">Maior para menor</option></select></div></div></div></div><div class="row b2c-box-filter b2c-row-apto-filters-itens animated" uib-collapse="!rowFiltersAptoIsOpen"><div class="col-md-3 b2c-box-filter-preco b2c-filter-acomodacao"><h3 title="Filtro de Pre\xE7os">Filtro de Pre\xE7os</h3><div class="form-group hidden"><label>Intervalo de pre\xE7o</label> <input type="range" min="{{vm.aptoValueMin}}" max="{{vm.aptoValueMax}}" ng-model="vm.valueApto" data-slider-step="5" value="[10,5000]"></div><div class="row"><div class="form-group col-xs-12 filter-preco-intervalo"><label>Intervalo de pre\xE7o</label><slider slider-id="ss" ng-model="vm.rangePrecoApto" min="vm.aptoValueMin" max="vm.aptoValueMax" step="5" range="true" precision="0">Nao Disponivel.</slider></div></div></div><div class="col-md-9 b2c-filter-acomodacao"><div class="row"><div class="col-md-12"><h3 title="Filtro de Servicos e Acomoda\xE7\xF5es">Filtro de Servicos e Acomoda\xE7\xF5es</h3></div></div><div class="row" ng-show="vm.arrayFiltrosAptos.length"><div class="col-md-12"><div class="form-group b2c-filtros-ativos"><div class="label-ativos"><label>Filtros Ativos</label> <button uib-tooltip="Limpar filtros" title="Limpar filtros" type="button" ng-click="vm.limparFiltrosAptos()"><small>Limpar Filtros</small> <i class="fa fa-trash" aria-hidden="true"></i></button></div><div class="btn-group"><button uib-tooltip="Retirar filtro {{filtro.nome}}" title="Retirar filtro {{filtro.nome}}" type="button" ng-click="vm.limparFiltroApto(filtro)" ng-repeat="filtro in vm.arrayFiltrosAptos"><img title="Retirar filtro {{filtro.nome}}" alt="Retirar filtro {{filtro.nome}}" class="img-responsive" src="assets/images/icons/{{filtro.imagem}}"> <small>{{filtro.nome| ellipsis:8}}</small> <i class="fa fa-trash" aria-hidden="true"></i></button></div></div></div></div><div class="row"><div class="col-md-12" ng-show="allItem.length" ng-repeat="allItem in vm.allItens"><div ng-if="allItem.length" class="form-group b2c-filtros-disp"><label>{{allItem[0].categoria}}</label><div class="btn-group"><button uib-tooltip="Filtrar por {{item.nome}}" title="Filtrar por possuir {{item.nome}}" type="button" ng-click="vm.addfiltroAptos(item)" ng-repeat="item in allItem"><img title="Filtrar por {{item.nome}}" alt="Filtrar por {{item.nome}}" class="img-responsive" src="assets/images/icons/{{item.imagem}}"> <small>{{item.nome| ellipsis:15}}</small></button></div></div></div></div></div></div></div></div><div class="row text-description-action"><div class="col-md-12"><h3 title="Selecione o Apartamento">Selecione o Apartamento para<span>&nbsp;{{::vm.personsAsString(vm.selectedHotel.result[0].persons)}}</span></h3></div></div><div class="row lista-apartamentos"><div class="col-md-12 b2c-box-info b2c-box-apto"><div class="row b2c-list-box time-05 b2c-row-apto" ng-class="{\'unavailable\': apto.customData.unavailableDates != null && apto.customData.unavailableDates != \'\' }" ng-if="apto.amount > 0 && !apto.hide" ng-repeat="apto in vm.uhs| filter:vm.filtrarAptos | filter:vm.precoApto"><aside class="col-md-3 b2c-img-box" style="background-image: url(\'{{::vm.foto(apto)}}\')"><button ng-if="apto.foto" title="Ver galeria de fotos" type="button" class="galeria btn-icon btn-gallery-icon btn btn-default" ng-click="vm.modalGaleria(apto)"><i class="fa fa-camera" aria-hidden="true"></i> <label>Fotos</label></button> <button title="Detalhes do Hotel" class="btn btn-icon btn-mais btn btn-default" ng-click="vm.openModalMaisDetalhesApartamento(apto)"><i class="fa fa-plus" aria-hidden="true"></i> <label>Detalhes</label></button></aside><section class="col-md-6 b2c-caracteristicas"><div class="row b2c-section-header"><div class="col-md-12"><div class="b2c-page-header"><h2 class="col-xs-12"><span title="{{apto.service}}" ng-click="vm.openModalMaisDetalhesApartamento(apto)">{{apto.service}}</span>&nbsp; <span class="hidden-xs hidden-sm b2c-description" title="Capacidade m\xE1xima: {{apto.customData.capacity}}"><div><i class="fa fa-users" style="margin-right: 4px; margin-top: 10px;"></i> Capacidade: {{ apto.customData.capacity && apto.customData.capacity.length > 20 ? apto.customData.capacity.slice(0, 14) + \'...\' : apto.customData.capacity }}</div></span>&nbsp;</h2><h2 ng-if="apto.customData.customMessages"><span class="b2c-uh-message" title="{{apto.customData.customMessages}}"><b>Aten\xE7\xE3o: </b>{{apto.customData.customMessages}} </span>&nbsp;</h2><br></div></div></div><div class="row b2c-section-promos" ng-if="apto.promos"><div class="col-md-12" ng-repeat="promo in apto.promos"><span class="promo-item color-red"><i class="fa fa-heart" aria-hidden="true"></i> {{::promo}}</span></div></div><div class="row b2c-section-promos" ng-if="apto.unavailableMsg"><div class="col-md-12"><span class="promo-item color-red"><i class="fa fa-warning" aria-hidden="true"></i> {{::apto.unavailableMsg}}</span></div></div><div class="row box-extras" ng-show="apto.extrasByTag.length"><div class="col-md-12"><div class="row"><div class="col-md-12" ng-repeat="extrasByTag in apto.extrasByTag"><div class="row"><span class="col-md-12 extrasByTag" title="{{::extrasByTag.tag}}" ng-if="extrasByTag.extras.length > 1">{{::extrasByTag.tag}}</span><div ng-class="{\'col-md-12\': extrasByTag.extras.length == 1, \'col-md-6\': extrasByTag.extras.length == 2, \'col-md-4\': extrasByTag.extras.length >= 3}" ng-repeat="extra in extrasByTag.extras"><div class="checkbox"><label uib-tooltip="{{::extra.memo}}"><input type="checkbox" ng-model="extra.checked" ng-change="vm.toggleExtra(apto, extra)"> {{::extra.service}}&nbsp;&nbsp;<i class="fa fa-info-circle" ng-click="vm.infoExtras(extra.memo)"></i></label></div></div></div></div></div></div></div><div class="row b2c-apt-meals" ng-show="apto.meals.length"><div class="col-md-12"><h5 title="Selecione a pens\xE3o">Selecione a pens\xE3o</h5><hr><div class="customMessage" ng-if="apto.meal.customData.customMessage">{{apto.meal.customData.customMessage}}</div><div class="row apt-meal" ng-class="{\'one\': apto.meals.length === 1,\'two\': apto.meals.length === 2,\'three\': apto.meals.length === 3,\'four\': apto.meals.length === 4, \'five\': apto.meals.length === 5}"><button uib-tooltip="{{meal.service}}:  {{ meal.value / 100 | currency: \'R$ \'}}" title="{{meal.service}}" class="btn btn-default" ng-class="{\'active\': apto.mealType === meal.service}" ng-click="vm.selectMeal(apto, meal)" ng-repeat="meal in apto.meals"><i class="fa" ng-class="{\'fa-check-square-o\': apto.mealType === meal.service, \'fa-square-o\': apto.mealType !== meal.service}" aria-hidden="true"></i> <span>{{meal.service}}</span> <strong title="Valor da Pens\xE3o" ng-if="apto.meals.length > 1"><span ng-if="meal.value <= 0">Aguarde...</span> <span ng-if="meal.value > 0" class="value">{{ meal.value / 100 | currency: "R$ "}}</span> </strong><strong title="Valor da Pens\xE3o" ng-if="apto.meals.length === 1 && meal.value > 0"><span>Incluso</span></strong></button></div></div></div></section><div class="col-md-3 injection-class-box" ng-include="\'app/hospedagem/apartamentos/includes/aside-apartamentos-box.html\'"></div></div></div></div></div><div class="hidden-xs hidden-sm time-05 col-md-3 padding-md-right-0 b2c-carrinho apts" ng-include="\'quinta_do_sol/template/carrinho.html\'"></div></section></main></div></div></div><xs-barra-footer></xs-barra-footer><div ng-if="false" class="row"><div ng-if="true" class="col-md-6 box-price one"><i class="fa icon fa-suitcase"></i><h4 ng-show="apto.oldValue" title="De {{apto.oldValue / 100| currency:\'R$ \'}}">De {{apto.oldValue / 100| currency:\'R$ \'}}</h4><h2 ng-show="apto.value" title="Por {{apto.value / 100| currency:\'R$ \'}}">{{apto.value / 100| currency:\'R$ \'}}*</h2><h6><span>{{::vm.personsAsString(apto.persons)}}</span></h6><h6 ng-show="apto.value" title="Em at\xE9 {{vm.pagamentoParcelado(apto.paymentMethods, apto.value)}}  no\xA0cart\xE3o\xA0de\xA0cr\xE9dito"><i class="fa fa-credit-card" aria-hidden="true"></i>Em at\xE9 {{vm.pagamentoParcelado(apto.paymentMethods, apto.value)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small>SEM JUROS</small><hr role="separator"><button ng-if="!apto.unavailable" title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple" ng-click="vm.selectUh(apto)">Quero Este <i class="fa fa-check"></i></button><div class="promo" ng-show="apto.oldValue"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-show="apto.oldValue"><p>-{{100 - ((apto.value * 100) / (apto.oldValue)) | number:\'0\'}}%</p></div></div><div ng-if="false" class="col-md-6 box-price"><h3 title="Tarifa Normal">Tarifa Normal</h3><h4 ng-show="apto.oldValue" title="De {{apto.oldValue / 100| currency:\'R$ \'}}">De {{apto.oldValue / 100| currency:\'R$ \'}}</h4><h2 ng-show="apto.value" title="Por {{apto.value / 100| currency:\'R$ \'}}" ng-class="{\'padding-top-25\': !apto.oldValue}">{{apto.value / 100| currency:\'R$ \'}}</h2><h6 ng-show="apto.value" title="Em at\xE9 {{vm.pagamentoParcelado(apto.paymentMethods, apto.value) }}  no\xA0cart\xE3o\xA0de\xA0cr\xE9dito"><i class="fa fa-credit-card" aria-hidden="true"></i>Em at\xE9 {{vm.pagamentoParcelado(apto.paymentMethods, apto.value)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small>SEM JUROS</small><hr role="separator"><button ng-if="!apto.unavailable" title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple" ng-click="vm.selectUh(apto)">Quero Este <i class="fa fa-check"></i></button><div class="promo" ng-show="apto.oldValue"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-show="apto.oldValue"><p>-{{100 - ((apto.value * 100) / (apto.oldValue)) | number:\'0\'}}%</p></div></div><div ng-if="false" class="col-md-6 box-price b2c-aside-box-tarifas-especial"><h3 title="Tarifa Especial">Tarifa Especial</h3><h4 ng-show="apto.oldValue" title="De {{apto.oldValue / 100| currency:\'R$ \'}}">De {{apto.oldValue / 100| currency:\'R$ \'}}</h4><h2 ng-show="apto.value" title="Por {{apto.value / 100| currency:\'R$ \'}}" ng-class="{\'padding-top-25\': !apto.oldValue}">{{apto.value / 100| currency:\'R$ \'}}</h2><h6 ng-show="apto.value" title="Em at\xE9 {{vm.pagamentoParcelado(apto.paymentMethods, apto.value)}}  no\xA0cart\xE3o\xA0de\xA0cr\xE9dito"><i class="fa fa-credit-card" aria-hidden="true"></i>Em at\xE9 {{vm.pagamentoParcelado(apto.paymentMethods, apto.value)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small>SEM JUROS</small><hr role="separator"><button ng-if="!apto.unavailable" title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple" ng-click="vm.selectUh(apto)">Quero Este <i class="fa fa-check"></i></button><div class="promo" ng-show="apto.oldValue"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-show="apto.oldValue"><p>-{{100 - ((apto.value * 100) / (apto.oldValue)) | number:\'0\'}}%</p></div></div><div ng-if="false" class="b2c-box-tarifas-cards"><div class="col-md-10 col-md-offset-2 b2c-box-tarifas-card" ng-repeat="i in [0, 1, 2]"><div class="row"><div class="col-xs-3 col-sm-2 col-md-2 col-lg-2"><button ng-if="!apto.unavailable" title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple" ng-click="vm.selectUh(apto)"><i class="fa fa-check"></i></button></div><div class="col-xs-9 col-sm-10 col-md-10 col-lg-10 text-tarifas-card"><h4 title="...">Tarifa Especial | <span ng-show="apto.oldValue">De {{apto.oldValue / 100| currency:\'R$ \'}}</span> <small>SEM JUROS</small></h4><h3 title="Por {{apto.value / 100| currency:\'R$ \'}}">{{apto.value / 100| currency:\'R$ \'}} <small><i class="fa fa-credit-card" aria-hidden="true"></i>Em at\xE9 {{vm.pagamentoParcelado(apto.paymentMethods, apto.value)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</small></h3></div><div class="promo" ng-show="apto.oldValue"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-show="apto.oldValue"><p>-{{::100 - ((apto.value * 100) / (apto.oldValue)) | number:\'0\'}}%</p></div></div></div></div></div>');
$templateCache.put('app/hospedagem/apartamentos/hospedagem-apartamentos.html','<div ng-include="\'app/hospedagem/apartamentos/hospedagem-apartamentos-template.html\'"></div>');
$templateCache.put('app/hospedagem/hotel/hopedagem-hotel.html','<header role="banner" class="row info-empreendimento"><aside class="col-md-5 b2c-img-box" style="background-image: url(\'{{::vm.foto(vm.selectedHotel.item)}}\')"><a title="Ver galeria de fotos" href="" class="btn-gallery-icon btn btn-icon" ng-click="vm.modalGaleria(vm.selectedHotel.item)"><i class="fa fa-camera" aria-hidden="true"></i></a></aside><div class="col-md-7 description-hotel"><div class="row description-hotel-header"><div class="col-xs-9 col-md-10 padding-xs-left-0 padding-xs-right-5"><h1 title="{{vm.selectedHotel.item.service}}">{{vm.selectedHotel.item.service}}</h1><span>{{vm.selectedHotel.item.customData.endereco}}</span> <span>Check-in: {{vm.selectedHotel.item.politicas.checkin}} - Check-out: {{vm.selectedHotel.item.politicas.checkout}}</span></div><div ng-if="vm.selectedHotel.item.linkmap" class="col-xs-3 col-md-2 padding-xs-0"><a title="Ir para Google Maps" class="btn btn-default ripple hover-zuum" target="_blank" rel="noopener" href="{{vm.selectedHotel.item.linkmap}}"><i class="fa fa-map-marker" aria-hidden="true"></i> <span>{{vm.selectedHotel.item.customData.destino}}</span></a></div></div><div class="row"><div class="col-md-12"><p class="text" ng-bind-html="vm.selectedHotel.item.memo | toHtml"></p></div></div><div class="row actions"><div class="col-md-4 form-group"><button uib-tooltip="Mais detalhes do {{vm.selectedHotel.item.service}}" title="Mais detalhes do {{vm.selectedHotel.item.service}}" class="btn ripple hover-zuum btn-default btn-block" ng-click="vm.modalInformativoHotel(vm.selectedHotel.item)"><i class="fa fa-plus"></i> Mais Detalhes</button></div></div><div class="row b2c-faixa-icons" ng-show="vm.selectedHotel.item.comodidades.length"><div class="container-icons col-md-12"><div class="icone" ng-if="comodidade.imagem" ng-repeat="comodidade in vm.selectedHotel.item.comodidades| limitTo: 6"><img uib-tooltip="{{comodidade.nome}}" title="{{comodidade.nome}}" alt="Comodidade: {{comodidade.nome}}" class="img-responsive" ng-src="assets/images/icons/{{comodidade.imagem}}"></div></div></div></div></header>');
$templateCache.put('app/hospedagem/confirmacaopagamento/confirmacao.html','<div ng-controller="PaymentConfirmationController as vm" class="payment-confirmation-page"><div ng-if="vm.payment"><div class="title">Confirma\xE7\xE3o de Pagamento</div><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;"><span style="color: #5e7a8a;"><strong>ID:</strong> {{ vm.payment.id }}</span></div><div class="info-grid"><div class="info-card"><div class="info-label">Status</div><span class="status-badge" ng-class="vm.getStatusClass()">{{ vm.payment.status | uppercase }}</span></div><div class="info-card"><div class="info-label">Pagamento</div><div class="info-value">{{ vm.payment.pagamento }}</div></div><div class="info-card"><div class="info-label">Tipo</div><div class="info-value">{{ vm.payment.paymentType || \'\u2014\' }}</div></div><div class="info-card"><div class="info-label">Valor total</div><div class="info-value">R$ {{ (vm.payment.valor / 100) | number:2 }}</div></div><div class="info-card"><div class="info-label">Valor pago</div><div class="info-value">R$ {{ (vm.payment.valorPago / 100) | number:2 }}</div><div class="info-sub" ng-if="vm.payment.valorPago < vm.payment.valor">*pendente</div></div></div><div><div class="info-card" ng-if="vm.payment.voucher"><div class="info-label">Voucher</div><div class="info-value">{{ vm.payment.voucher }}</div><div class="info-sub">Token: {{ vm.payment.voucherToken }}</div></div></div><div ng-if="vm.payment.paymentType === \'Pix\'" class="qrcode-section"><img title="Pix" alt="Logo: Pix" class="img-responsive" src="assets/images/logos/pix.png"><div style="margin-bottom: 25px;"><div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px;"><span class="info-label">C\xF3digo PIX (copia e cola)</span> <button ng-click="vm.copiarCodigoPix(vm.payment.qrcode)" style="background: transparent; border: 1px solid #00a86b; color: #00a86b; padding: 6px 16px; border-radius: 30px; font-size: 0.85rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: 0.2s;">\uD83D\uDCCB Copiar c\xF3digo</button></div><div class="qrcode-text" id="pix-code" style="background: #f4f9fc; padding: 12px; border-radius: 8px; font-family: monospace; word-break: break-all;">{{ vm.payment.qrcode }}</div><span ng-show="vm.copiado" style="display: block; color: #00a86b; font-size: 0.8rem; margin-top: 5px;">\u2705 C\xF3digo copiado!</span></div><div style="text-align: center;" ng-if="vm.payment.qrcodeUrl"><span class="info-label">Prefere gerar o QR Code?</span> <a href="{{ vm.payment.qrcodeUrl }}" target="_blank" rel="noopener noreferrer" style="display: inline-block; margin-top: 8px; padding: 12px 28px; background: #00a86b; color: white; text-decoration: none; border-radius: 50px; font-weight: 600; box-shadow: 0 4px 12px rgba(0,168,107,0.3); transition: 0.2s;">\uD83D\uDD17 Acessar p\xE1gina do QR Code</a></div><div ng-if="!vm.payment.qrcodeUrl" style="text-align: center;"><qr-code value="{{vm.qrCodeText}}"></qr-code></div></div><div ng-if="vm.payment.paymentType !== \'Pix\'" style="margin: 20px 0; padding: 15px; background: #f0f7fa; border-radius: 12px;"><span style="font-weight: 600;">Forma de pagamento:</span> {{ vm.payment.paymentType || \'N\xE3o informado\' }}</div><hr><div style="text-align: center; color: #5e7a8a; font-size: 0.85rem;">Token da transa\xE7\xE3o: {{ vm.payment.token }} | Payment ID: {{ vm.payment.paymentId }}</div></div></div><script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"></script>');
$templateCache.put('app/hospedagem/hoteis/hospedagem-hoteis.html','<div class="box-searchbar-top"><div class="container"><div class="row"><div class="col-md-12"><div class="navbar-search-bar-horizontal"><section id="navbarSearchBarHorizontal"></section><xs-search-bar-holder xs-id-holder="navbarSearchBarHorizontal" xs-search="vm.searchHorizontal" template-url="quinta_do_sol/template/xsSearchBar.html"></xs-search-bar-holder></div></div></div></div></div><div class="container-fluid b2c-container" ng-cloak><div id="hospedagem-main" bookmark-offset="55"><xs-breadcrump xs-step="0" class="hidden-xs"></xs-breadcrump><main id="escolhaHospedagem" class="b2c-painel-hoteis"><section class="row"><div ng-include="\'app/hospedagem/hoteis/includes/asidefilter.html\'"></div><div ng-include="\'app/hospedagem/hoteis/includes/boxhoteis.html\'"></div></section></main></div></div><div ng-include="\'app/hospedagem/hoteis/includes/sendBudgetButton.html\'"></div><xs-barra-footer></xs-barra-footer>');
$templateCache.put('app/hospedagem/confirmacao/hospedagem-confirmacao.html','<div class="container-fluid b2c-container"><div id="hospedagem-main" bookmark-offset="55"><section class="b2c-tela-parabens"><header role="banner" class="row b2c-header-finalizacao b2c-header-banner" style="background-image: url(\'assets/images/layout/img-header-confirmacao.jpg\')"><div class="col-md-12"><div class="row b2c-row-header"><div class="col-md-12" ng-if="vm.voucherUrl"><h3 title="Parab\xE9ns! Reserva realizada com sucesso.">Parab\xE9ns! Reserva garantida com sucesso.</h3></div><div class="col-md-12" ng-if="vm.boletoUrl || vm.paymentUrl || vm.qrcode"><h3 title="Reserva Aguardando conclus\xE3o do pagamento.">Reserva Aguardando conclus\xE3o do pagamento.</h3></div><div class="col-md-12" ng-if="vm.koin && vm.koinWait"><h3 title="Seu pedido est\xE1 em an\xE1lise pela koin.">Seu pedido est\xE1 sendo analisado pela Koin.</h3></div></div><div class="row b2c-tela-parabens-time" ng-if="vm.koin"><div class="col-md-6 col-md-offset-3" ng-if="!vm.koinWait"><h2 title="Compra efetuada com a Koin. Os dados para pagamento ser\xE3o enviados por e-mail." class="time-05">Compra efetuada com a Koin. Os dados para pagamento ser\xE3o enviados por e-mail.</h2></div><div class="col-md-6 col-md-offset-3" ng-if="vm.koinWait"><h2 ng-if="vm.voucher.resultKoin.Code != \'314\'" title="A Koin entrar\xE1 em contato via e-mail ao finalizar a an\xE1lise. Esse processo pode levar at\xE9 48 horas." class="time-05">A Koin entrar\xE1 em contato via e-mail ao finalizar a an\xE1lise. Esse processo pode levar at\xE9 48 horas.</h2><h2 ng-if="vm.voucher.resultKoin.Code == \'314\'" title="Seu pedido foi recebido pela Koin, e, para prosseguirem com a an\xE1lise, ser\xE1 necess\xE1rio que voc\xEA valide o endere\xE7o de email utilizado na compra, clicando no link do email enviado pela Koin." class="time-05">Seu pedido foi recebido pela Koin, e, para prosseguirem com a an\xE1lise, ser\xE1 necess\xE1rio que voc\xEA valide o endere\xE7o de email utilizado na compra, clicando no link do email enviado pela Koin.</h2></div></div><div class="row b2c-tela-parabens-time" ng-if="vm.voucherUrl"><div class="col-md-6 col-md-offset-3"><h2 title="Reserva garantida vamos agora para a parte de pagamento!" class="time-05">Imprima seu voucher no bot\xE3o abaixo e boa viagem.</h2></div><div class="form-group col-md-4 col-md-offset-4"><a class="btn time-05 btn-lg btn-default btn-block" target="_blank" rel="noopener" href="{{vm.voucherUrl}}"><i class="fa fa-print"></i> Voucher</a></div></div><div class="row b2c-tela-parabens-time" ng-if="vm.boletoUrl"><div class="col-md-6 col-md-offset-3"><h2 title="Reserva garantida vamos agora para a parte de pagamento!" class="time-05">Imprima seu Boleto no bot\xE3o abaixo. O voucher ser\xE1 emitido ap\xF3s o pagamento do boleto.</h2></div><div class="form-group col-md-4 col-md-offset-4"><a class="btn time-05 btn-lg btn-default btn-block" target="_blank" rel="noopener" href="{{vm.boletoUrl}}"><i class="fa fa-print"></i> Boleto</a></div></div><div class="row b2c-tela-parabens-time" ng-if="vm.paymentUrl"><div class="col-md-6 col-md-offset-3"><h2 title="Reserva garantida vamos agora para a parte de pagamento!" class="time-05">Conclua seu pagamento pelo link:</h2></div><div class="form-group col-md-4 col-md-offset-4"><a class="btn time-05 btn-lg btn-default btn-block" target="_blank" rel="noopener" href="{{vm.paymentUrl}}"><i class="fa fa-money"></i> Efetuar pagamento</a></div></div><div class="row b2c-tela-parabens-time" ng-if="vm.qrcode"><div class="col-md-6 col-md-offset-3" ng-repeat="code in vm.multiCodes"><h2 title="Reserva garantida vamos agora para a parte de pagamento!" class="time-05">Efetue o pagamento PIX usando o "PIX com QRCODE" ou o "PIX Copia e Cola":</h2><img ng-src="{{vm.qrcodeUrlBase}}?method=qrcode&code=qr&hidenumbers=true&text={{code | urlEncode}}" class="center-block img-responsive" alt="Image"> <button type="button" class="btn btn-success btn-block ripple" ngclipboard data-clipboard-text="{{code}}" ngclipboard-success="vm.linkCopySuccess(e)">Pix Copia e Cola &nbsp;<i class="fa fa-copy"></i></button><br><button type="button" class="btn btn-info btn-block ripple" ng-click="vm.verifyPayment()">J\xE1 conclui o pagamento</button></div></div><div ng-include=""></div></div></header></section></div></div>');
$templateCache.put('app/hospedagem/ingressos/hospedagem-ingressos.html','<div class="container-fluid b2c-container"><div id="hospedagem-main" bookmark-offset="55"><xs-breadcrump xs-step="3" class="hidden-xs"></xs-breadcrump><main id="dados_ingressos" class="row b2c-section-ticket"><div class="col-md-12"><div class="row box-ticket-info"><div class="col-md-12 ticket-header"><h1 title="Vamos garantir os ingressos do Hot Beach!">Vamos garantir os ingressos do Hot Beach!</h1><hr></div></div><div class="row"><div class="col-md-9"><div id="ingresso_pergunta" class="row box-ticket-pergunta"><div class="col-md-12"><div class="row box-ticket-header-title"><div class="col-md-12"><h2 title="Escolha o primeiro dia de divers\xE3o.">Escolha o primeiro dia de divers\xE3o.</h2><h3 title="Lembrando que quanto maior a divers\xE3o maior o desconto!">Lembrando que quanto maior a divers\xE3o maior o desconto!</h3></div></div><div class="row"><div class="col-md-10 box-ticket-uso"><div class="row box-button-dias pai-flex-xs"><div class="box-button-dia filho-flex-xs" ng-repeat="dia in vm.diariasDisponiveis"><h3 title="Dia de uso: {{dia.date| date:\'dd/MM/yyyy\'}}">{{dia.date| date:\'dd/MM\'}} <i class="fa fa-calendar" aria-hidden="true"></i></h3><button title="Quero este" class="btn btn-block btn-default time-05 ripple {{dia.status}}" ng-click="vm.validarPrimeiroDia(dia)" ng-disabled="{{dia.disabled}}">{{dia.date| date:\'EEEE\'}} <i class="fa fa-check" aria-hidden="true"></i></button></div></div><div ng-show="vm.msgInfoCompra" class="row economia-info"><div class="col-md-8 col-md-offset-2 alert alert-info radius-0"><h4 title="Divirta-se o m\xE1ximo e economize tamb\xE9m.">Divirta-se o m\xE1ximo e economize tamb\xE9m. <i class="fa fa-thumbs-up" aria-hidden="true"></i></h4></div></div><div ng-show="vm.msgParabens" class="row economia-info"><div class="col-md-8 col-md-offset-2 alert alert-success radius-0"><h4 title="Parab\xE9ns! Voc\xEA j\xE1 est\xE1 economizando.">Parab\xE9ns! Voc\xEA j\xE1 est\xE1 economizando. <i class="fa fa-thumbs-up" aria-hidden="true"></i></h4><button title="Escolher Ingresso" class="btn btn-warning radius-0 time-05 ripple">Escolher Ingresso <i class="fa fa-arrow-down" aria-hidden="true"></i></button></div></div></div><div class="col-md-2 box-ticket-sem-diversao"><i class="fa fa-frown-o" aria-hidden="true"></i><h4 title="N\xE3o quero me divertir">N\xE3o quero me divertir</h4><button title="Sem Divers\xE3o de Ingressos" class="btn btn-block radius-0 time-05 ripple" ng-click="vm.semDiversaoDeIngressos()">Sem Divers\xE3o <i class="fa fa-frown-o" aria-hidden="true"></i></button><h5 title="Sem economia *">Sem economia *</h5></div></div></div></div><div ng-show="vm.combos" id="ingressos_disponiveis" class="row box-ticket-lists"><div class="col-md-12"><div class="row"><div class="col-md-12 b2c-header-ticket-list"><h2 title="Escolha o tamanho da sua divers\xE3o.*">Escolha o tamanho da sua divers\xE3o.</h2><h4 title="Lembrando que os dias de uso s\xE3o consecutivos.*">Lembrando que os dias de uso dos ingressos s\xE3o consecutivos.*</h4><hr></div></div><div class="row"><div class="col-md-3 box-ticket-list" ng-if="combo.value != 0" ng-repeat="combo in vm.combos"><div class="content-ticket"><div class="imagem" style="background-image: url(\'{{combo.imagem}}\')"></div><div class="info"><h4 title="Ingresso: {{combo.name}}"><i class="fa fa-ticket" aria-hidden="true"></i> {{combo.name}}</h4><blockquote><h5 title="Ingressos Adultos" ng-if="combo.adultos > 0"><i class="fa fa-ticket" aria-hidden="true"></i> {{combo.adultos > 1 ? combo.adultos + \' ingressos\' : combo.adultos + \' ingresso\'}} Adulto</h5><h5 title="Ingressos Crian\xE7as" ng-if="combo.chd > 0"><i class="fa fa-ticket" aria-hidden="true"></i> {{combo.chd > 1 ? combo.chd + \' ingressos\' : combo.chd + \' ingresso\'}} Crian\xE7as</h5></blockquote></div><div class="select-radion"><h4 ng-if="combo.days > 1" title="+ ECONOMIA" class="economia-porcentagem desconto-float">+ ECONOMIA</h4><h3 title="Comprando no parque"><small>no parque</small> {{ ((combo.desconto * - 1) + combo.value) / 100 | currency:\'R$ \'}}</h3><h2 title="Comprando junto a hospedagem"><small>junto a hospedagem</small> {{combo.value / 100| currency:\'R$ \'}}</h2><button title="Quero estes ingressos" ng-click="vm.openModalConfirmacaoIngressos(combo)" class="btn btn-default btn-block radius-0 time-05 ripple">Quero Este <i class="fa fa-ticket" aria-hidden="true"></i></button><h4 ng-if="combo.days > 1" title="Economia em reais" class="economia-reais desconto-float">{{combo.desconto / 100| currency:\'R$ \'}}</h4></div></div></div></div></div></div></div><div class="hidden-xs hidden-sm time-05 col-md-3 b2c-carrinho apts" ng-include="\'quinta_do_sol/template/carrinho.html\'"></div></div></div></main></div></div><xs-barra-footer></xs-barra-footer>');
$templateCache.put('app/hospedagem/identificacao/hospedagem-identificacao.html','<div ng-if="vm.showDestaque" class="fade modal-backdrop destaque in"></div><div class="container-fluid b2c-container"><div id="hospedagem-main" bookmark-offset="55"><xs-breadcrump xs-step="2" class="hidden-xs"></xs-breadcrump><header role="banner" class="row b2c-header-nomeacao"><div class="col-md-12"><div class="row b2c-row-header" ng-class="{\'destaque\': vm.showDestaque}"><div class="col-md-3 padding-md-right-30"><button title="Retornar a lista de apartamentos" class="btn time-05 btn-danger btn-block ripple btn-retornar" ui-sref="hospedagemApartamentos"><i class="fa fa-arrow-left" aria-hidden="true"></i> Retornar</button></div><div class="col-md-9"><h3 title="Quase l\xE1, falta pouco agora">Quase l\xE1, falta pouco agora</h3></div></div></div></header><main id="dados_hospedes" class="row b2c-section-nomeacao"><div id="showCarrinho" class="time-05 col-md-3 b2c-carrinho apts" ng-mouseover="vm.offDestaqueCarrinho()" ng-class="{\'destaque\': vm.showDestaque}" ng-include="\'quinta_do_sol/template/carrinho.html\'"></div><div class="col-md-9 time-10 fadeIn animated"><div id="telaApresentacao" ng-show="!vm.reservarAgoraShow" class="row"><div class="col-md-12"></div></div><div id="reservarAgoraShow" ng-show="vm.reservarAgoraShow" class="row"><div class="col-md-12 b2c-nomeacao" ng-repeat="uh in vm.uhs" ng-show="uh.show"><div class="row title-main"><div class="col-md-12 text-center"><h2 title="Informe os dados para: Apartamentos para {{::vm.personsAsString(uh.persons)}} ">Informe os dados para: Apartamentos para {{::vm.personsAsString(uh.persons)}}</h2></div></div><div ng-include="\'app/hospedagem/identificacao/label-identification.html\'"></div><div class="row b2c-breadcrumb"><ol style="max-width: {{vm.sizeWidthMobileBreadcrumb}}"><li class="{{hospede.status}}" ng-repeat="hospede in uh.allHospedes"><a class="col-md-4" title="{{vm.firstName(hospede)}}" href=""><i class="{{hospede.icon}}" aria-hidden="true"></i></a><div class="breadcrumb-hospede stap-text col-md-8"><small>{{hospede.categoria}}</small><br><span>{{vm.firstName(hospede)}}</span></div></li></ol></div><div class="row"><div class="col-md-12"><div class="row b2c-panel-nomeacao"><div class="b2c-panel-nomeacao-hospede primeiro-hospede col-md-6 animated fadeIn" ng-show="hospede.status === \'check-active\'" ng-repeat="hospede in uh.allHospedes"><form name="form" role="form"><fieldset class="row"><section class="col-md-12" ng-if="vm.verificaFormHospedeFirst(uh, $index)"><div ng-include="\'quinta_do_sol/template/layout-first-person.html\'"></div></section><section class="col-md-12" ng-if="vm.verificaFormHospede(uh, $index) && uh.persons.length <= 2"><div ng-include="\'app/hospedagem/identificacao/layout-other-persons.html\'"></div></section><section class="col-md-12" ng-if="vm.verificaFormHospede(uh, $index) && uh.persons.length > 2 && vm.showOtherPersons"><div ng-include="\'app/hospedagem/identificacao/layout-other-persons.html\'"></div></section><section class="col-md-12" ng-if="vm.verificaFormHospede(uh, $index) && uh.persons.length > 2 && !vm.showOtherPersons && $index <= 1"><div ng-include="\'app/hospedagem/identificacao/layout-show-other-persons.html\'"></div></section><aside class="col-md-12" ng-if="vm.verificaFormHospedeFirst(uh, $index) || (vm.verificaFormHospede(uh, $index) && uh.persons.length <= 2) || \n                                                (vm.verificaFormHospede(uh, $index) && uh.persons.length > 2 && vm.showOtherPersons)"><div class="row"><div class="col-md-6"><h5 ng-show="hospede.verificInputs" title="Preencha os campos e tente novamente" class="animated in fadeInDown time-5">Preencha os campos e tente novamente</h5></div><div class="col-md-6"><div class="form-group"><button title="Salvar" type="button" class="btn time-05 btn-warning btn-block ripple pull-right" ng-click="vm.formSalvarHospedes(uh, hospede)" ng-disabled="form.$invalid">{{hospede.statusButton == \'no-check\' ? \'Salvar\' : \'Concluido\'}} <i class="fa {{hospede.statusButton == \'no-check\' ? \'fa-save\' : \'fa-check\'}}"></i></button></div></div></div></aside></fieldset></form></div><div ng-include="\'app/hospedagem/identificacao/layout-person-memo.html\'" ng-if="vm.showInputMemo"></div></div></div></div></div></div></div></main></div></div><xs-barra-footer></xs-barra-footer>');
$templateCache.put('app/hospedagem/identificacao/label-identification.html','<div class="row b2c-header-infos"><div class="col-md-4 padding-md-right-0"><div class="box-default"><h5 title="Dados do primeiro hospede s\xE3o obrig\xE1torios"><i class="fa fa-info-circle text-warning" aria-hidden="true" popover-placement="{{vm.containerWidth >= 1024 ? \'top\': \'right\'}}" uib-popover="Apos preencher clique em Salvar para prosseguir."></i> Dados do primeiro hospede s\xE3o <strong>obrig\xE1torios</strong></h5></div></div><div class="col-md-4 padding-md-right-0"><div class="box-default"><h5 title="Preencha com os dados do comprador"><i class="fa fa-info-circle text-warning" aria-hidden="true" popover-placement="{{vm.containerWidth >= 1024 ? \'top\': \'right\'}}" uib-popover="Lembre-se de conferir seus dados na pr\xF3xima parte, pagamento."></i> Preencha com os dados do <strong>comprador</strong></h5></div></div><div class="col-md-4"><div class="box-default"><h5 title="Dados dos demais hospedes s\xE3o opcionais"><i class="fa fa-info-circle text-default" aria-hidden="true" popover-placement="{{vm.containerWidth >= 1024 ? \'top\': \'right\'}}" uib-popover="S\xE3o para faciliar o checkin no hotel."></i> Dados dos demais hospedes s\xE3o <strong>opcionais</strong></h5></div></div></div>');
$templateCache.put('app/hospedagem/identificacao/layout-first-person.html','<div class="form-indentificacao" ng-init="hospede.mailing=\'false\'"><legend>Dados do {{$index + 1}}\xBA {{hospede.categoria}} <i class="fa fa-male" aria-hidden="true"></i></legend><div class="row"><div class="form-group col-md-6 padding-md-right-5"><input type="text" class="form-control" name="Nome" placeholder="Nome do {{hospede.placeholder}}" ng-model="hospede.name" required></div><div class="form-group col-md-6 padding-md-lefth-5"><input type="email" class="form-control" name="Email" placeholder="E-mail" ng-model="hospede.email" required></div><div class="form-group col-md-6 padding-md-right-5"><input type="text" class="form-control" name="Celular" ui-mask="(99) 99999-9999" placeholder="Celular" ui-mask-placeholder ng-model="hospede.cellPhone" required></div><div class="form-group col-md-6 padding-md-right-5"><input type="text" class="form-control" name="birthdayDate" age-validator ui-mask="99/99/9999" placeholder="Data de Nascimento" ui-mask-placeholder ng-model="hospede.birth" ng-required="true"> <label ng-if="form.birthdayDate.$invalid" class="label-error">A Pessoa precisa ser maior de idade!</label></div><div class="form-group col-md-12"><select class="form-control" name="Promocoes" ng-model="hospede.mailing"><option value="true">Receber Promo\xE7\xF5es: Sim</option><option value="false">Receber Promo\xE7\xF5es: N\xE3o</option></select></div></div></div><style>.red-input {\n    border: 2px solid red;\n  }</style>');
$templateCache.put('app/hospedagem/identificacao/layout-other-persons.html','<div><legend>Dados do {{$index + 1}}\xBA {{hospede.categoria}} <i class="fa fa-male" aria-hidden="true"></i></legend><div class="form-group"><label>Campo opcional - clique em salvar para prosseguir</label> <input type="text" class="form-control" name="Nome" id="nomeHospede{{$index}}" placeholder="Nome" ng-model="hospede.name"></div></div>');
$templateCache.put('app/hospedagem/identificacao/layout-person-memo.html','<div class="b2c-panel-nomeacao-hospede col-md-6 animated fadeIn"><form name="form" role="form"><fieldset class="row"><section class="col-md-12"><legend>Alguma observa\xE7\xE3o importante? Digite aqui!</legend><div class="form-group"><textarea type="text" class="form-control" style="resize: none;" name="note" ng-model="vm.memoText" rows="5" maxlength="200" placeholder="M\xE1ximo de 200 caracteres"></div></section><aside class="col-md-12"><div class="row"><div class="col-md-6"><div class="form-group"><button title="Salvar" type="button" class="btn time-05 btn-warning btn-block ripple pull-right" ng-click="vm.concluirReserva()" ng-disabled="form.$invalid">Concluir <i class="fa fa-check"></i></button></div></div></div></aside></fieldset></form></div>');
$templateCache.put('app/hospedagem/identificacao/layout-show-other-persons.html','<div><legend>Deseja Preencher os dados dos outros Hospedes ?</legend><div class="col-md-6"><button title="Salvar" type="button" class="btn time-05 btn-success btn-block ripple pull-right" ng-click="vm.setShowOtherPersons(true)">Sim</button></div><div class="col-md-6"><button title="N\xE3o" type="button" class="btn time-05 btn-danger btn-block ripple pull-right" ng-click="vm.concluirAgora(uh)">N\xE3o</button></div></div>');
$templateCache.put('app/hospedagem/pagamento/pagamento.html','<div class="container-fluid b2c-container"><div id="hospedagem-main" bookmark-offset="55"><section class="row b2c-identificacao"><div class="col-md-12"><div class="row b2c-paymentReserva"><aside class="col-md-3 b2c-carrinho"><div class="row b2c-paymentReserva-header"><div class="col-md-12"><div class="page-header"><h2 title="Carrinho">Carrinho <i class="fa fa-shopping-cart" aria-hidden="true"></i></h2></div></div></div><div class="row b2c-carrinho-header"><div class="col-md-12"><label title="{{vm.paid.days}} {{vm.paid.days > 1 ? \'Di\xE1rias\' : \'Di\xE1ria\'}}">{{vm.paid.days}} {{vm.paid.days > 1 ?\'Di\xE1rias\' : \'Di\xE1ria\'}}</label><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{vm.paid.checkin| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{vm.paid.checkout| date:\'dd/MM/yyyy\'}}</span><br><label>Check-out</label></div></div><label>Op\xE7\xE3o Escolhida</label><h3 title="{{vm.apartamentos[0].hotelName}}">{{vm.apartamentos[0].hotelName}}</h3><label>N\xFAmero de Apartamentos</label><h3 title="Lista de Apartamentos" class="apts-title">{{vm.apartamentos.length}} {{vm.apartamentos.length > 1 ? \'Apartamentos\' : \'Apartamento\'}}</h3><div ng-if="vm.apartamentos[0].responsibleName"><label>Nome do Comprador</label><h3 title="{{vm.apartamentos[0].responsibleName}}">{{vm.apartamentos[0].responsibleName}}</h3></div></div></div><div class="row b2c-itens-carrinho"><div class="col-md-12 itens" ng-repeat="apto in vm.apartamentos"><h5 title="Nome do Apartamento: {{apto.uh}}"><i class="fa fa-check" aria-hidden="true"></i> {{apto.uh}}</h5><h5 ng-if="apto.pensao" title="Tipo de Pens\xE3o: {{apto.pensao}}"><i class="fa fa-check" aria-hidden="true"></i> {{apto.pensao}}</h5><h5 title="Quantidade de Hospedes"><i class="fa fa-check" aria-hidden="true"></i> <span ng-if="apto.adulto > 0">Adultos: {{apto.adulto}},</span> <span ng-if="apto.crianca > 0">Crian\xE7as: {{apto.crianca}}</span> <span ng-if="apto.colo > 0">Colos: {{apto.colo}}</span> <span ng-if="apto.terceiraIdade > 0">acima de 60 anos: {{apto.terceiraIdade}}</span></h5><h5 ng-if="apto.produtosValue > 0 && apto.reservationValue > 0" title="Valor do Apartamento: {{apto.reservationValue  / 100| currency: \'R$ \'}}" class="value padding-top-15">Valor do Apartamento: <strong>{{apto.reservationValue / 100| currency: \'R$ \'}}</strong></h5><h5 ng-if="apto.produtosValue > 0" title="Valor dos Ingressos: {{apto.produtosValue / 100| currency: \'R$ \'}}">Valor dos ingressos: <strong>{{apto.produtosValue / 100| currency: \'R$ \'}}</strong></h5><h4 ng-if="apto.reservationValue > 0" title="Valor do Apartamento: {{apto.reservationValue / 100| currency:\'R$ \'}}" class="value">Valor do Apartamento <strong>{{apto.reservationValue / 100| currency:\'R$ \'}}</strong></h4><h4 ng-if="apto.reservationPaidValue > 0" class="value">Valor pago <strong>{{apto.reservationPaidValue / 100| currency:\'R$ \'}}</strong></h4></div></div><div class="row b2c-carrinho-footer"><div class="col-md-12"><h2 title="Valor Total: {{vm.totalPagamento| currency:\'R$ \'}}">Total: <strong>{{vm.totalPagamento| currency:\'R$ \'}}</strong></h2></div></div><div ng-if="vm.discount" class="row b2c-carrinho-footer"><div class="col-md-12 text-right"><div>De: {{vm.totalPagamento| currency:\'R$ \'}}</div><div>Por: {{vm.discount.total| currency: \'R$ \'}}</div></div><div class="col-md-12"><h4 style="text-align: right;" class="textoDescontoPix">{{vm.discount.percent}} de desconto {{vm.discount.paymentType}}</h4></div><div class="col-md-12"><h2 title="Valor Total Com Desconto: {{vm.discount.total| currency: \'R$ \'}}">Pague: <strong>{{vm.discount.total| currency: \'R$ \'}}</strong> {{vm.discount.paymentType}}</h2></div></div></aside><section class="col-md-9 b2c-payment-tabs"><div class="row b2c-paymentReserva-header"><div class="col-md-12"><div class="page-header"><h2 title="Formas de pagamento">Formas de pagamento</h2></div></div></div><uib-tabset justified="false"><uib-tab index="0" ng-show="vm.paymentMethods[\'visa\'] > 0" select="vm.selectTab(\'cartaodecredito\')"><uib-tab-heading><img title="Compra via Cart\xE3o" alt="Compra via Cart\xE3o" class="img-responsive" src="assets/images/icons/icon-credit-card.png"><span>Cart\xE3o</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn" ng-show="vm.paymentMethods[\'visa\'] > 0"><div class="col-md-12"><h3 title="Compra via Cart\xE3o">Pagamento via Cart\xE3o</h3><button title="Informa\xE7\xF5es sobre pagamento via Cart\xE3o" class="btn time-05 btn-min btn-default ripple" ng-click="vm.openModalInfoCartao()">Informa\xE7\xF5es <span class="hidden-xs hidden-sm">Cart\xE3o</span> <i class="fa fa-exclamation-circle" aria-hidden="true"></i></button><hr role="separator"></div></div><div class="row b2c-tabs-content b2c-form-cartao animated fadeIn" ng-show="vm.paymentMethods[\'visa\'] > 0"><div class="col-md-12"><form class="form"><fieldset class="b2c-cartao-front"><div class="row value-bandeira"><div class="col-xs-8 col-sm-8 col-md-9 col-lg-9 value form-group"><em>Valor: {{vm.totalPagamento| currency: \'R$ \'}}</em></div><div class="col-xs-4 col-sm-4 col-md-3 col-lg-3 bandeira imagem form-group"><img title="Bandeira Cart\xE3o: {{vm.paid.cardType}}" alt="Bandeira Cart\xE3o: {{vm.paid.cardType}}" class="img-responsive" ng-show="vm.paid.cardType" ng-src="assets/images/logos/{{vm.paid.cardType}}.png"></div></div><div class="row numero"><div class="col-xs-7 form-group padding-xs-right-5"><label for="numero_cartao">N\xFAmero do cart\xE3o</label> <input type="text" name="N\xFAmero Cartao" class="form-control" ng-model="vm.paid.cardNumber" ui-mask="9999 9999 9999 99?9?9? ?9?9?9" placeholder="N\xFAmero do Cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" id="numero_cartao" ng-required="true"></div></div><div class="row name-date"><div class="col-xs-7 col-sm-8 col-md-8 col-lg-8 padding-xs-right-10 form-group value-name"><label for="titular">Nome</label> <input type="text" name="Titular" class="form-control" placeholder="Titular do Cart\xE3o" ng-model="vm.paid.customer" id="titular" ng-required="true" ng-disabled="!vm.paid.cardType"></div><div class="col-xs-5 col-sm-4 col-md-4 col-lg-4 padding-xs-left-10 form-group vencimento"><label>Vencimento</label><div class="input-daterange input-group"><input type="text" class="form-control" ui-mask="99" ng-model="vm.paid.vencimentoCartaoMes" placeholder="00" ui-mask-placeholder ng-required="true" ng-disabled="!vm.paid.cardType"> <span class="input-group-addon">/</span> <input type="text" class="form-control" ui-mask="2099" ng-model="vm.paid.vencimentoCartaoAno" placeholder="2000" ui-mask-placeholder ng-required="true" ng-disabled="!vm.paid.cardType"></div></div></div></fieldset><br><fieldset class="b2c-cartao-back"><div class="row faixa-cartao"></div><div class="row codigo-seguranca"><label class="hidden-xs hidden-sm">C\xF3digo Seguran\xE7a</label><div class="input-assinatura"><p class="stripe-1" title="C\xF3digo Seguran\xE7a">C\xF3digo Seguran\xE7a</p></div><div class="input-codigo"><input id="codigoSeguranca" type="text" name="Codigo Seguranca" class="form-control" ng-model="vm.paid.securityCode" ui-mask="999?9?9" placeholder="000" ui-mask-placeholder ui-mask-placeholder-char="space" ng-required="true" ng-disabled="!vm.paid.cardType"></div></div></fieldset><fieldset class="b2c-cartao-extra"><legend>Informa\xE7\xF5es Complementares</legend><div class="col-md-6 form-group"><label for="parcelaCartao">N\xFAmero de Parcelas</label> <select class="form-control" id="parcelaCartao" ng-model="vm.paid.count" ng-required="true" ng-disabled="!vm.paid.cardType"><option value="">Parcelas</option><option value="{{p.parcelas}}" ng-repeat="p in vm.quantidadeDeParcelas">{{p.parcelas}}x {{p.valor| currency: \'R$ \'}}</option></select></div><div class="col-md-6 form-group"><label for="dataNascimento">Data Nascimento</label> <input id="dataNascimento" type="text" name="Data Nascimento" class="form-control" ng-model="vm.paid.birth" ui-mask="99/99/9999" placeholder="00/00/0000" ui-mask-placeholder ng-required="true"></div><div class="col-md-12 form-group" ng-if="!vm.paid.estrangeiro && !vm.reservaPagoComCPFouCPNJ"><label for="cpf">CPF Titular</label> <input id="cpf" type="text" name="CPF" class="form-control" ng-model="vm.paid.personCpf" ui-mask="999.999.999-99" placeholder="CPF do Titular" ui-mask-placeholder ng-required="true"></div><div class="col-md-6 form-group" ng-if="!vm.paid.estrangeiro && vm.reservaPagoComCPFouCPNJ" ng-init="vm.paid.document = \'false\'"><div class="form-group form-loja"><label class="control-label" for="nacionalidade" accesskey="E">Tipo de Documento *</label> <select class="form-control" tabindex="3" id="nacionalidade" ng-model="vm.paid.document" required><option value="false">CPF</option><option value="true">CNPJ</option></select></div></div><div class="col-md-6 form-group" ng-if="!vm.paid.estrangeiro && vm.reservaPagoComCPFouCPNJ"><div ng-if="vm.paid.document == \'false\'"><label class="control-label" for="nacionalidade" accesskey="E">CPF Titular *</label> <input id="cpf" type="text" name="CPF" class="form-control" ng-model="vm.paid.personCpf" ui-mask="999.999.999-99" placeholder="CPF do Titular" ui-mask-placeholder ng-required="true"></div><div ng-if="vm.paid.document == \'true\'"><label class="control-label" for="nacionalidade" accesskey="E">CNPJ Titular *</label> <input id="cnpj" type="text" name="CNPJ" class="form-control" ng-model="vm.paid.personCpf" ui-mask="99.999.999/9999-99" placeholder="CNPJ do Titular" ui-mask-placeholder ng-required="true"></div></div></fieldset><fieldset class="b2c-cartao-extra"><div ng-if="vm.showPaymentCardAddress" ng-include="\'app/components/xsPayment/payment_card_address.html\'"></div></fieldset></form><hr class="footer"></div></div></uib-tab><uib-tab index="1" ng-show="vm.paymentMethods[\'boleto\'] > 0" select="vm.selectTab(\'boleto\')"><uib-tab-heading><img title="Compra via Boleto" alt="Compra via Boleto" class="img-responsive" src="assets/images/icons/icon-bar-code.png"><span>Boleto</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra via Boleto">Pagamento via Boleto</h3><button title="Informa\xE7\xF5es sobre a Compra Via Boleto" type="button" class="btn time-05 btn-min btn-default ripple" ng-click="vm.openModalInfoBoleto()">Informa\xE7\xF5es <span class="hidden-xs hidden-sm">Boleto</span> <i class="fa fa-exclamation-circle" aria-hidden="true"></i></button><hr role="separator"></div></div><div class="row b2c-form-boleto b2c-form-payment-reserva animated fadeIn"><aside class="col-md-5 col-md-offset-1 co-sm-12"><h3 title="O pagamento ser\xE1 realizado via Boleto">O pagamento ser\xE1 realizado via Boleto.</h3><div ng-repeat="apto in vm.apartamentos"><h2 title="Reserva {{apto.reservationId}}">Reserva {{apto.reservationId}}</h2><h2 ng-if="apto.boletoDescontoValue" title="{{apto.boletoDescontoValue}}% DE DESCONTO.">{{apto.boletoDescontoValue}}% DE DESCONTO.</h2><h2 ng-if="apto.boletoValue" title="Total: {{apto.boletoValue / 100 | currency:\'R$ \'}}" class="border-style-bottom">Total<span ng-if="apto.boletoDescontoValue"> com desconto</span>: {{apto.boletoValue / 100 | currency:\'R$ \'}}</h2><form class="form"><fieldset><div class="row"><div class="col-xs-12 form-group"><label for="CPF_titular_boleto">CPF do Titular</label> <input id="CPF_titular_boleto" type="text" ng-model="apto.personCpf" ui-mask="999.999.999-99" placeholder="000.000.000-00" ui-mask-placeholder class="form-control" ng-required="true"></div></div></fieldset></form></div></aside><section class="col-md-6 hidden-xs"></section></div></uib-tab><uib-tab index="2" ng-show="vm.paymentMethods[\'fastcash\'] > 0" select="vm.selectTab(\'fastcash\')"><uib-tab-heading><img title="Pagamento via Transfer\xEAncia Bancaria, Dep\xF3sito pela FatsCash" alt="Pagamento via Transfer\xEAncia Bancaria, Dep\xF3sito pela FatsCash" class="img-responsive" src="assets/images/icons/icon-transfer.png"><span>Transf./Dep\xF3s.</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra via Transfer\xEAncia Bancaria">Transfer\xEAncia Bancaria</h3><button title="Informa\xE7\xF5es sobre a transfer\xEAncia" class="btn time-05 btn-min btn-default ripple" ng-click="vm.openModalInfoTransferencia()">Informa\xE7\xF5es <span class="hidden-xs hidden-sm">Transfer\xEAncia</span> <i class="fa fa-exclamation-circle" aria-hidden="true"></i></button><hr role="separator"></div></div><div class="row b2c-form-transferencia b2c-form-payment-reserva animated fadeIn"><div class="b2c-form-cartao"><div class="col-md-12"><div class="row"><section class="col-md-12"><form class="form b2c-form-dados-conta"><fieldset class="b2c-cartao-front"><div class="row value-bandeira"><div class="value col-xs-9 form-group"><em>Valor <span class="hidden-xs" ng-if="vm.paid.tipoPagamento==\'transferencia\'">da Transfer\xEAncia</span><span class="hidden-xs" ng-if="vm.paid.tipoPagamento==\'deposito\'">do Dep\xF3sito</span>: {{vm.totalPagamento| currency:\'R$ \'}}</em></div></div><div class="row agencia-conta"><div class="col-xs-7 form-group agencia padding-xs-left-10"><label for="tipo">Dep\xF3sito/Transfer\xEAncia:</label> <select name="tipo" id="tipo" class="form-control" ng-model="vm.paid.tipoPagamento" required="required"><option value="deposito">Dep\xF3sito</option><option value="transferencia">Transfer\xEAncia</option></select></div><div class="col-xs-5 form-group agencia padding-xs-left-10"><label for="banco">Banco:</label> <select id="banco" class="form-control" name="banco" ng-model="vm.paid.banco"><option ng-value="1">Banco do Brasil</option><option ng-value="2">Bradesco</option><option ng-value="3">Caixa</option><option ng-value="4">Itau</option><option ng-value="5">Santander</option><option ng-value="7">Banrisul</option><option ng-value="8" ng-show="vm.paid.tipoPagamento == \'deposito\'" ng-disabled="vm.paid.tipoPagamento != \'deposito\'">Correios</option><option ng-value="9" ng-show="vm.paid.tipoPagamento == \'deposito\'" ng-disabled="vm.paid.tipoPagamento != \'deposito\'">Loterica</option></select></div><div class="col-xs-12 col-md-7 form-group agencia padding-xs-right-10" ng-if="vm.paid.tipoPagamento==\'transferencia\'"><label for="numero_agencia">Ag\xEAncia:</label> <input id="numero_agencia" type="text" name="N\xFAmero Agencia" class="form-control" placeholder="Digite sua Ag\xEAncia" ng-model="vm.paid.agency" ng-required="true"></div><div class="col-xs-12 col-md-5 form-group conta padding-xs-left-10" ng-if="vm.paid.tipoPagamento==\'transferencia\'"><label for="numero_conta">Conta</label> <input id="numero_conta" type="text" name="N\xFAmero Conta" class="form-control" placeholder="Digite sua Conta" ng-model="vm.paid.account" ng-required="true"></div><div class="col-xs-12 col-md-7 form-group"><label for="Nome">Nome Depositante</label> <input id="Nome" type="text" ng-model="vm.paid.name" class="form-control" ng-required="true"></div><div class="col-xs-12 col-md-5 form-group"><label for="Email_depositante">Email</label> <input id="Email_depositante" type="email" ng-model="vm.paid.email" class="form-control" ng-required="true"></div><div class="col-xs-12 col-md-7 form-group"><label for="Doc_depositante">Documento</label> <input id="Doc_depositante" type="text" ng-model="vm.paid.document" ui-mask="999.999.999-99" placeholder="000.000.000-00" ui-mask-placeholder class="form-control" ng-required="true"></div><div class="col-xs-12 col-md-5 form-group"><label for="Phone_depositante">Celular</label> <input id="Phone_depositante" type="text" class="form-control" name="Celular" ui-mask="(99) 99999-9999" placeholder="Celular" ui-mask-placeholder ng-model="vm.paid.phone" required></div></div></fieldset></form></section></div></div></div></div></uib-tab><uib-tab index="4" ng-show="vm.paymentMethods[\'pagamentoHotel\'] > 0" select="vm.selectTab(\'pagamentoHotel\')"><uib-tab-heading><img title="Compra via Pagamento Hotel" alt="Compra via Pagamento Hotel" class="img-responsive" src="assets/images/icons/icon-reception.png"><span>Pagamento Hotel</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra Via Pagamento Hotel">Pagamento Hotel</h3><button title="Informa\xE7\xF5es sobre o pagamento Hotel" type="button" class="btn time-05 btn-min btn-default ripple" ng-click="vm.openModalInfoPagamentoHotel()">Informa\xE7\xF5es <span class="hidden-xs hidden-sm">Pagamento Hotel</span> <i class="fa fa-exclamation-circle" aria-hidden="true"></i></button><hr role="separator"></div></div><div class="row b2c-form-pagamento-hotel animated fadeIn"><aside class="col-md-4 col-md-offset-1"><h3 title="O pagamento ser\xE1 realizado no atendimento do Hotel">O pagamento ser\xE1 realizado no atendimento do Hotel.</h3><h2 title="Total: {{vm.totalPagamento| currency:\'R$ \'}}" class="border-style-bottom">Total: {{vm.totalPagamento| currency:\'R$ \'}}</h2></aside><section class="col-md-7"></section></div></uib-tab><uib-tab index="5" ng-show="vm.paymentMethods[\'pagseguro\'] > 0" select="vm.selectTab(\'pagseguro\')"><uib-tab-heading><img title="Compra via PagSeguro" alt="Compra via PagSeguro" class="img-responsive" src="assets/images/icons/icon-pagseguro.png"><span>PagSeguro</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra Via Pagamento Hotel">PagSeguro</h3><button title="Informa\xE7\xF5es sobre pagamento via PagSeguro" type="button" class="btn time-05 btn-min btn-default ripple" ng-click="vm.openModalInfoPagSeguro()">Informa\xE7\xF5es <span class="hidden-xs hidden-sm">PagSeguro</span> <i class="fa fa-exclamation-circle" aria-hidden="true"></i></button><hr role="separator"></div></div><div class="row b2c-form-pagSeguro animated fadeIn"><aside class="col-md-4 col-md-offset-1"><h3 title="O pagamento ser\xE1 realizado via PagSeguro">O pagamento ser\xE1 realizado via PagSeguro.</h3><h2 title="Total: {{vm.totalPagamento| currency:\'R$ \'}}" class="border-style-bottom">Total: {{vm.totalPagamento| currency:\'R$ \'}}</h2></aside><section class="col-md-7"></section></div></uib-tab><uib-tab index="6" ng-show="vm.paymentMethods[\'deposito\'] > 0" select="vm.selectTab(\'deposito\')" active="vm.tabs[\'deposito\'].active"><uib-tab-heading><img title="Compra com Dep\xF3sito" alt="Compra com Dep\xF3sito" class="img-responsive" src="assets/images/icons/icon-deposit.png"><span>Dep\xF3sito</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra com Dep\xF3sito">Deposito</h3><hr role="separator"></div></div><div class="row b2c-form-deposito animated fadeIn"><aside class="col-md-7 col-md-offset-1"><h2 title="Total: {{vm.totalPagamento| currency:\'R$ \'}}" class="border-style-bottom">Total: {{vm.totalPagamento| currency:\'R$ \'}}</h2><h3>Bancos aceitos</h3><div ng-repeat="account in vm.depositAccounts">{{account.banco}}</div><hr role="separator"><span>* Os dados para deposito ser\xE3o enviados para seu email ap\xF3s voc\xEA aceitar os termos e clicar no bot\xE3o finalizar abaixo.</span></aside><section class="col-md-4"></section></div></uib-tab><uib-tab index="7" ng-show="vm.paymentMethods[\'gerencianetBoleto\'] > 0" select="vm.selectTab(\'gerencianetBoleto\')"><uib-tab-heading><img title="Compra via Boleto" alt="Compra via Boleto" class="img-responsive" src="assets/images/icons/icon-bar-code.png"><span>Boleto</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra via Boleto">Pagamento via Boleto</h3><button title="Informa\xE7\xF5es sobre a Compra Via Boleto" type="button" class="btn time-05 btn-min btn-default ripple" ng-click="vm.openModalInfoBoleto()">Informa\xE7\xF5es <span class="hidden-xs hidden-sm">Boleto</span> <i class="fa fa-exclamation-circle" aria-hidden="true"></i></button><hr role="separator"></div></div><div class="row b2c-form-boleto b2c-form-payment-reserva animated fadeIn"><aside class="col-md-5 col-md-offset-1 co-sm-12"><h3 title="O pagamento ser\xE1 realizado via Boleto">O pagamento ser\xE1 realizado via Boleto.</h3><div ng-repeat="apto in vm.apartamentos"><h2 title="Reserva {{apto.reservationId}}">Reserva {{apto.reservationId}}</h2><h2 title="Total: {{apto.value / 100 | currency:\'R$ \'}}" class="border-style-bottom">Total: {{apto.value / 100 | currency:\'R$ \'}}</h2><form class="form"><fieldset><div class="row"><div class="col-xs-12 form-group"><label for="CPF_titular_boleto">CPF do Titular</label> <input id="CPF_titular_boleto" type="text" ng-model="apto.personCpf" ui-mask="999.999.999-99" placeholder="000.000.000-00" ui-mask-placeholder class="form-control" ng-required="true"></div></div></fieldset></form></div></aside><section class="col-md-6 hidden-xs"></section></div></uib-tab><uib-tab index="8" ng-show="vm.paymentMethods[\'granitoCredito\'] > 0" select="vm.selectTab(\'granitoCredito\')"><uib-tab-heading><img title="Compra Cartao de Debito/Credito" alt="Compra Cart\xE3o de Cr\xE9dito" class="img-responsive" src="assets/images/icons/icon-credit-card.png"><span>Cart\xE3o Cr\xE9dito</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Cartao de Cr\xE9dito">Cart\xE3o de Cr\xE9dito</h3><hr role="separator"></div></div><div class="row animated fadeIn"><aside class="col-xs-12 col-md-5 col-md-offset-1" ng-if="vm.granitoType == \'granitoCredito\'"><div class="form-group"><label for="parcelaCartao">N\xFAmero de Parcelas</label> <select class="form-control" id="parcelaCartao" ng-model="vm.paid.count" ng-required="true"><option value="">Parcelas</option><option value="{{p.parcelas}}" ng-repeat="p in vm.quantidadeDeParcelas">{{p.parcelas}}x {{p.valor| currency: \'R$ \'}}</option></select></div><iframe id="pago_iframe" src="about:blank" style="border:none; min-height:425px; min-width: 260px;"></iframe></aside><section class="hidden-xs col-md-6"><div class="alert alert-danger" role="alert"><h3>Importante:</h3><br>Os campos N\xDAMERO DO CART\xC3O, VALIDADE E CVV s\xE3o num\xE9ricos, n\xE3o utilize espa\xE7o entre os n\xFAmeros.<br>Todos os campos s\xE3o obrigat\xF3rios.</div></section></div></uib-tab><uib-tab index="9" ng-show="vm.paymentMethods[\'granitoDebito\'] > 0" select="vm.selectTab(\'granitoDebito\')"><uib-tab-heading><img title="Compra Cartao de Debito" alt="Compra Cart\xE3o de D\xE9bito" class="img-responsive" src="assets/images/icons/icon-credit-card.png"><span>Cart\xE3o D\xE9bito</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Cartao de D\xE9bito">Cart\xE3o de D\xE9bito</h3><hr role="separator"></div></div><div class="row b2c-form-pagSeguro animated fadeIn"><aside class="col-md-5 col-md-offset-1" ng-if="vm.granitoType == \'granitoDebito\'"><iframe id="pago_iframe" src="about:blank" style="border:none; min-height:425px; min-width: 260px;"></iframe></aside><section class="col-md-6"></section></div></uib-tab><uib-tab index="10" ng-show="vm.paymentMethods[\'paypal\'] > 0" select="vm.selectTab(\'paypal\')"><uib-tab-heading><img title="Compra via PayPal" alt="Compra via PayPal" class="img-responsive" src="assets/images/icons/icon-pagseguro.png"><span>PayPal</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra Via Pagamento Hotel">PayPal</h3><hr role="separator"></div></div><div class="row animated fadeIn"><aside class="col-md-4 col-md-offset-1"><h3 title="O pagamento ser\xE1 realizado via PayPal">O pagamento ser\xE1 realizado via PayPal.</h3><h2 title="Total: {{vm.totalPagamento| currency:\'R$ \'}}" class="border-style-bottom">Total: {{vm.totalPagamento| currency:\'R$ \'}}</h2></aside><section class="col-md-7"></section></div></uib-tab><uib-tab index="10" ng-show="vm.paymentMethods[\'koin\'] > 0 && vm.apartamentos.length == 1" select="vm.selectTab(\'koin\')"><uib-tab-heading><img title="Compra via Boleto Koin" alt="Compra via Boleto Koin" class="img-responsive" src="assets/images/icons/icon-koin.png"><span>Boleto Parcelado</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra Via Koin">Boleto Parcelado Koin</h3><button title="Informa\xE7\xF5es Koin" type="button" class="btn time-05 btn-min btn-default ripple" ng-click="vm.openModal(\'Koin\',\'app/hospedagem/pagamento/modais/openModalInfoKoin.html\')">Informa\xE7\xF5es <span class="hidden-xs hidden-sm">Koin</span> <i class="fa fa-exclamation-circle" aria-hidden="true"></i></button><hr role="separator"></div></div><div class="row animated fadeIn koin"><form name="koin-form" role="form" class="col-md-12"><legend>Dados do Pagador</legend><div class="col-md-6"><div class="form-group"><label for="">Nome Completo</label> <input type="text" class="form-control" ng-model="vm.apartamentos[0].responsibleName" readonly="readonly"></div></div><div class="col-md-6"><div class="form-group"><label for="">Email</label> <input type="text" class="form-control" ng-model="vm.apartamentos[0].responsibleEmail" readonly="readonly"></div></div><div class="col-md-6"><div class="form-group"><label for="">CPF</label> <input type="text" class="form-control" ng-model="vm.apartamentos[0].responsibleCPF" ui-mask="999.999.999-99" readonly="readonly"></div></div><div class="col-md-6"><div class="form-group"><label for="">Ao consultar parcelas voc\xEA aceita os <a href="https://www.koin.com.br/termos-e-condicoes/" target="_blank">Termos de Uso da Koin</a></label> <button type="button" class="btn btn-primary btn-block" ng-click="vm.koin.terms=true">Consultar Parcelas <i class="fa fa-check"></i></button></div></div></form><form name="koin-pagamento" role="form" class="col-md-12" ng-if="vm.koin.terms"><legend>Op\xE7\xF5es de pagamento</legend><div class="col-md-6"><div class="form-group"><label for="">N\xFAmero de Parcelas</label> <select class="form-control" id="parcelaCartao" ng-model="vm.koin.installment" ng-options="p.description for p in vm.koinParcelas track by p.paymentType" ng-required="true"></select></div></div><div class="col-md-6"><table class="table table-striped table-bordered table-condensed" ng-if="vm.koin.installment"><thead><tr><th colspan="2">Detalhes do pagamento</th></tr></thead><tbody><tr ng-if="vm.koin.installment.originalValue != vm.koin.installment.orderValue"><td>Valor Original</td><td><span class="pull-right">{{vm.koin.installment.originalValue | currency: "R$ "}}</span></td></tr><tr><td>Parcelas</td><td><span class="pull-right">{{vm.koin.installment.installments}}x</span></td></tr><tr ng-if="vm.koin.installment.rates"><td>Taxa de juros a.m</td><td><span class="pull-right">{{vm.koin.installment.rates | number}}%</span></td></tr><tr ng-if="vm.koin.installment.iof"><td>IOF</td><td><span class="pull-right">{{vm.koin.installment.iof | number}}%</span></td></tr><tr ng-if="vm.koin.installment.originalValue != vm.koin.installment.orderValue"><td>CET a.m</td><td><span class="pull-right">{{vm.koin.installment.cetAM | number}}%</span></td></tr><tr><td>Data 1\xBA Vencimento</td><td><span class="pull-right">{{vm.koin.installment.firstDueDate | date: "dd/MM/yyyy"}}</span></td></tr><tr><td>Valor Total<span ng-if="vm.koin.installment.originalValue != vm.koin.installment.orderValue">&nbsp;\xE0 Prazo</span></td><td><span class="pull-right">{{vm.koin.installment.orderValue | currency: "R$ "}}</span></td></tr></tbody></table></div></form></div></uib-tab><uib-tab index="11" ng-show="vm.paymentMethods[\'pix\'] > 0" active="vm.tabs.pix.active" select="vm.selectTab(\'pix\')"><uib-tab-heading><img title="Compra via PIX" alt="Compra via PIX" class="img-responsive" src="assets/images/icons/icon-pix.png"><span>PIX</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra Via Pagamento Hotel">PIX</h3><button title="Informa\xE7\xF5es sobre pagamento via Pix" type="button" class="btn time-05 btn-min btn-default ripple" ng-click="vm.openModalInfoPix()">Informa\xE7\xF5es <span class="hidden-xs hidden-sm">Pix</span> <i class="fa fa-exclamation-circle" aria-hidden="true"></i></button><hr role="separator"></div></div><div class="row b2c-form-PIX animated fadeIn"><aside class="col-md-4 col-md-offset-1"><h3 title="O pagamento ser\xE1 realizado via PagSeguro">O pagamento ser\xE1 realizado via Pix.</h3><div ng-if="vm.discount && vm.discount.total" class="col-md-12" style="margin-bottom: 2rem;"><div>De: {{vm.totalPagamento| currency:\'R$ \'}}</div><div>Por: {{vm.discount.total| currency: \'R$ \'}}</div></div><h2 title="Total: {{vm.getTotalPriceWithAdjustments(\'pix\',1) | currency:\'R$ \'}}" class="border-style-bottom">Total: {{vm.getTotalPriceWithAdjustments(\'pix\',1) | currency:\'R$ \'}}</h2></aside><section class="col-md-7"></section></div></uib-tab><uib-tab index="11" ng-show="vm.paymentMethods[\'picpay\'] > 0" select="vm.selectTab(\'picpay\')"><uib-tab-heading><img title="Compra via PicPay" alt="Compra via PicPay" class="img-responsive" src="assets/images/icons/icon-picpay.png"><span>PicPay</span></uib-tab-heading><div class="row b2c-tabs-header animated fadeIn"><div class="col-md-12"><h3 title="Compra Via Pagamento Hotel">PicPay</h3><button title="Informa\xE7\xF5es sobre pagamento via PicPay" type="button" class="btn time-05 btn-min btn-default ripple" ng-click="vm.openModalInfoPicPay()">Informa\xE7\xF5es <span class="hidden-xs hidden-sm">PicPay</span> <i class="fa fa-exclamation-circle" aria-hidden="true"></i></button><hr role="separator"></div></div><div class="row b2c-form-PIX animated fadeIn"><aside class="col-md-4 col-md-offset-1"><h3 title="O pagamento ser\xE1 realizado via PicPay">O pagamento ser\xE1 realizado via PicPay.</h3><h2 title="Total: {{vm.totalPagamento| currency:\'R$ \'}}" class="border-style-bottom">Total: {{vm.totalPagamento| currency:\'R$ \'}}</h2></aside><section class="col-md-7"></section></div></uib-tab></uib-tabset><div class="row b2c-form-finalizar-compra"><div ng-if="vm.activeTab==\'pix\'"></div><div ng-if="vm.activeTab!=\'pix\'"><div style="padding-left:15px;padding-right:15px;" class="col-md-12"><h6>*AVISO PARA RESERVA DE M\xDALTIPLOS APARTAMENTOS:</h6><h6>1- Para m\xFAltiplos apartamentos, a reserva s\xF3 \xE9 poss\xEDvel para A MESMA DATA em todos. Para datas diferentes, fa\xE7a outra opera\xE7\xE3o desde o in\xEDcio;</h6><h6>2- \xC9 obrigat\xF3rio que o dono do cart\xE3o de cr\xE9dito seja titular de uma das reservas, efetue o check-in e apresente, na recep\xE7\xE3o, o cart\xE3o utilizado na compra. O n\xE3o comparecimento acarretar\xE1 em necessidade de cobran\xE7a individual e presencial do titular de cada apartamento.</h6></div></div><div class="col-md-12"><h5 ng-if="vm.activeTab!=\'koin\'" title="Aten\xE7\xE3o: Antes de finalizar por favor, revise os dados inseridos e leia os termos e condi\xE7\xF5es de compra">Antes de finalizar por favor, revise os dados inseridos e leia os termos e condi\xE7\xF5es de compra</h5><h5 ng-if="vm.activeTab==\'koin\'" title="Aten\xE7\xE3o: Antes de finalizar por favor, revise os dados inseridos e leia os termos e condi\xE7\xF5es de compra">Antes de finalizar por favor, revise os dados inseridos e leia os <a href="https://www.koin.com.br/termos-e-condicoes/" target="_blank">termos e condi\xE7\xF5es de compra e de Uso da Koin.</a></h5></div><div class="box-termos"><section class="col-md-7" style="height: 180px;"><iframe uib-tooltip="Voc\xEA precisa concordar com os termos para prosseguir" tooltip-is-open="vm.tooltipIsOpenTermos" src="docs/termosdecompra.html" scrolling="auto" frameborder="0" height="100%" width="100%"></iframe></section></div><aside class="col-md-5 box-buttons-termos"><div class="container-checkbox"><input id="tooltipIsOpenPoliticas" type="checkbox" ng-model="vm.politicas"> <label for="tooltipIsOpenPoliticas" class="{{vm.activeTab}}"><a title="Ver termos de uso" class="btn-politicas" target="_blank" rel="nofollow noopener noreferrer" href="https://novaxs.com.br/docs/politica_de_privacidade.pdf"><span>Concordar com as politicas <i class="fa fa-eye" aria-hidden="true"></i></span></a></label></div><div class="container-checkbox" ng-if="vm.activeTab!=\'koin\' || (vm.activeTab==\'koin\' && vm.koin.installment)" ng-class="{ \'\': vm.politicas, \'politicas-inativa\': !vm.politicas }"><input id="tooltipIsOpenTermos" type="checkbox" ng-model="vm.termosCompra" ng-disabled="!vm.politicas"> <label for="tooltipIsOpenTermos" class="{{vm.activeTab}}"><span ng-if="vm.activeTab!=\'koin\'">Concordo com os termos</span> <span ng-if="vm.activeTab==\'koin\'">Concordo com os termos de compra e de Uso da Koin</span></label></div><button title="Finalizar compra" type="button" class="btn time-05 btn-success btn-lg btn-block" ng-click="vm.comprar()" ng-disabled="!vm.termosCompra">Finalizar <i class="fa fa-check" aria-hidden="true"></i></button></aside></div></section></div><div class="row b2c-paymentReserva-termos"></div><div class="row b2c-paymentReserva-confirme"></div></div></section></div></div>');
$templateCache.put('app/hospedagem/pesquisa/hospedagem-pesquisa.html','<div class="container-fluid b2c-container" ng-cloak><div id="hospedagem-main" bookmark-offset="55"><section class="b2c-tela-checkin"><section class="row b2c-checkin-header"><div class="col-md-12"><h1 title="Sua felicidade a poucos cliques">Sua felicidade a poucos cliques</h1><h4 title="F\xE1cil, r\xE1pido e com seguran\xE7a. Sua reserva est\xE1 aqui, garanta j\xE1!">F\xE1cil, r\xE1pido e com seguran\xE7a. Sua reserva est\xE1 aqui, garanta j\xE1!</h4><hr role="separator"></div></section><div id="navbar2"></div><xs-search-bar-holder xs-id-holder="navbar2" xs-search="vm.search" template-url="quinta_do_sol/template/xsSearchBar.html"></xs-search-bar-holder><section class="promocoes" ng-include="\'app/promocoes/promocoes.html\'" ng-controller="PromocoesController as vm"></section><section class="row b2c-checkin-img" ng-if="assets/images/layout/img-promocional-barra-ckeck-in.jpg"><figure class="col-md-8 col-md-offset-2"><img title="Nome do Grupo ou Empreendimento" alt="Nome do Grupo ou Empreendimento" class="img-responsive" src="assets/images/layout/img-promocional-barra-ckeck-in.jpg"><figcaption></figcaption></figure></section><section class="row b2c-checkin-footer"><div class="col-md-4 col-md-offset-4"><hr role="separator"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></section></div><xs-paid-button></xs-paid-button></div>');
$templateCache.put('app/ingressos/confirmacao/confirmacao.html','<main class="container loja-main"><xs-confirm xs-ordered="vm.billId" xs-newbuy="vm.newBill()" template-url="app/components/xsConfirm/xsConfirm.html"></xs-confirm></main>');
$templateCache.put('app/ingressos/modais/dialog-aceitar-termos.html','<div class="modal-header dialog-header-info"><h4 title="Selecione as datas" class="modal-title">Leia e aceite os termos</h4></div><div class="form modal-body"><div ng-if="vm.product.termosAceite" class="termos-aceite" id="termosAceite"><div ng-bind-html="vm.product.termosAceite"></div></div><div ng-if="!vm.product.linkAceite" class="checkbox"><label><input type="checkbox" ng-model="vm.terms" ng-disabled="!vm.scrollAtBottom"> Li e aceito os termos e politicas.</label></div><div ng-if="vm.product.linkAceite"><div class="col checkbox"><label><input type="checkbox" ng-model="vm.terms"> <a ng-href="{{vm.product.linkAceite}}" target="_blank">Li e aceito os termos e politicas.</a></label></div></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><button title="Cancelar" class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-success" ng-click="vm.close()" ng-disabled=" (vm.product.linkAceite && !vm.terms) || (vm.product.termosAceite && !vm.terms) ">OK</button></div></div></div><style>.checkbox label, .checkbox label a{\n    font-size: 16px;\n    color: black;\n   }\n\n\n   .termos-aceite {\n    max-height: 300px;\n    overflow: auto;\n    border: 1px solid darkgray;\n   }</style>');
$templateCache.put('app/ingressos/modais/dialog-combo-dates-hour.html','<div class="modal-header dialog-header-info"><h4 title="Selecione as datas" class="modal-title">Selecione as datas</h4></div><div style="min-height: 400px; overflow-y: auto;" ng-include="\'app/ingressos/modais/templates/template-date-hour.html\'"></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><label class="prices" ng-if="vm.price && formSelectDates.$valid">Valor {{vm.price / 100 | currency: "R$ "}}&nbsp;</label> <button title="Cancelar" class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-success" ng-click="vm.close()" ng-disabled="vm.invalidSchedule() || formSelectDates.$invalid">OK</button></div></div></div>');
$templateCache.put('app/ingressos/modais/dialog-combo-dates.html','<div class="modal-header dialog-header-info"><h4 title="Selecione as datas" class="modal-title">Selecione as datas</h4></div><div class="modal-body"><div class="row"><form name="formSelectDates" class="col-md-12 formSelectDates" role="form"><div ng-controller="SelectComboDatesController as vm"><div class="row"><div class="col-xs-12 col-md-6"><div class="form-group quantidade"><label for="">Quantidade</label> <input type="number" class="form-control" ng-model="vm.product.amount" min="{{vm.product.minAmount || 1}}" max="{{vm.product.available}}" required></div></div><div class="col-xs-12 col-md-6" ng-repeat="p in vm.product._children"><div class="form-group"><label for="">Data do {{p.name}}</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-model="p._date" init-date="vm.minDate" min-date="vm.minDate" max-date="vm.maxDate" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false,startingDay:0}" is-open="p.activeDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-click="p.activeDate = true" custom-class="vm.customClass(date, mode)" date-disabled="vm.dateDisabled(date, mode)" ng-disabled="$index==0" required> <span class="input-group-addon"><a ng-click="p.activeDate = true" ng-disabled="$index==0"><i class="fa fa-calendar"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block" ng-click="vm.openDatePickerModal(p, \'date\')" ng-disabled="$index==0">{{p._date | date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar"></i></button> <input type="hidden" ng-model="p._date" required></div></div></div></div></form></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><button title="Cancelar" class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-success" ng-click="vm.close()" ng-disabled="formSelectDates.$invalid">OK</button></div></div></div>');
$templateCache.put('app/ingressos/modais/dialog-confirm-whatsapp.html','<div class="modal-header confirm-whats-header"><h4>ATEN\xC7\xC3O!!</h4></div><div class="modal-body confirm-whats"><p>Ap\xF3s a compra, os ingressos ser\xE3o enviado para o email ou whatsapp cadastrados. O Email <b>{{vm.userDetails.email}} </b>e o whatsapp <b>{{vm.userDetails.cellPhone}}</b> est\xE3o corretos?</p></div><div class="modal-footer confirm-whats-footer"><div class="up-sell-footer"><button class="button-cancel-confirm-whats" ng-click="vm.close()">Corrigir</button> <button class="button-confirm-whats" ng-click="vm.dismiss()">Est\xE1 correto <i class="fa fa-check" aria-hidden="true"></i></button></div></div>');
$templateCache.put('app/ingressos/modais/dialog-ingresso-extrainfo.html','<div class="modal-header dialog-header-info"><h4 title="{{vm.title}}" class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><div class="row"><form name="formDados" class="col-md-12" role="form"><div class="row"><div class="col-md-6"><div class="form-group"><label for="">Data Inicial</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-model="vm.data.date" min-date="vm.today" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false,startingDay:0}" is-open="vm.activeDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-click="vm.activeDate = true" required> <span class="input-group-addon"><a ng-click="vm.activeDate = true"><i class="fa fa-calendar"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block" ng-click="vm.openDatePickerModal(vm.data.date, \'date\')">{{vm.data.date | date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar"></i></button></div></div><div class="col-md-6"><div class="form-group"><label for="">Data Final</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-model="vm.data.endDate" min-date="vm.data.date" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false,startingDay:0}" is-open="vm.activeEndDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-click="vm.activeEndDate = true" required> <span class="input-group-addon"><a ng-click="vm.activeEndDate = true"><i class="fa fa-calendar"></i></a></span></div><button class="visible-xs-inline-block btn btn-default btn-block" ng-click="vm.openDatePickerModal(vm.data.endDate, \'endDate\')">{{vm.data.endDate | date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar"></i></button></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="">N\xFAmero de pessoas</label> <input type="number" class="form-control" placeholder="numero de pessoas" ng-model="vm.data.pessoas" required></div></div><div class="col-md-6"><div class="form-group"><label for="">Nome do Hotel/Pousada</label> <input type="text" class="form-control" placeholder="Nome do Hotel ou Pousada" ng-model="vm.data.hotel" required></div></div></div></form></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><a title="Cancelar" class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</a> <a title="OK" class="btn btn-success" ng-click="vm.close()" ng-disabled="formDados.$invalid">OK</a></div></div></div>');
$templateCache.put('app/ingressos/modais/dialog-ingresso-frete.html','<div class="modal-header dialog-header-info"><h4 title="{{vm.title}}" class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><div class="row"><form name="formDados" class="col-md-12" role="form"><div ng-controller="FreteController as vm"><div class="row" ng-init="vm.product.amount = 1;"><div class="col-md-6"><div class="form-group"><label for="">Quantidade</label> <input type="number" value="10" class="form-control" ng-model="vm.product.amount" required></div></div><div class="col-md-6"><div class="form-group"><label for="">Cep</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-model="vm.cep" ui-mask="99999-999" required> <span class="input-group-addon"><a ng-click="vm.searchFrete()"><i class="fa fa-search"></i></a></span></div></div></div></div><div class="row" ng-repeat="frete in vm.fretes"><div class="col-xs-12"><div class="radio select frete"><label><input type="radio" name="frete" id="input" ng-model="vm.product.frete" ng-value="frete"> {{frete.tipo}}: aproximadamente {{frete.days}} dias, <span>valor: {{frete.price / 100 | currency: "R$ "}}</span></label></div></div></div><div style="display:none"><input type="text" ng-model="vm.product.frete.tipo" required></div></div></form></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><a title="Cancelar" class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</a> <a title="OK" class="btn btn-success" ng-click="vm.close()" ng-disabled="formDados.$invalid">OK</a></div></div></div>');
$templateCache.put('app/ingressos/modais/dialog-ingresso-hora.html','<div class="modal-header dialog-header-info ingresso-hora"><h4 title="{{vm.title}}" class="modal-title">{{vm.title}}</h4></div><div class="ingresso-hora" ng-include="\'\'"></div><div class="modal-body ingresso-hora"><div class="row"><form name="formDados" class="col-md-12" role="form"><div ng-controller="SelectHourController as vm"><div class="row quantidade"><div class="col-md-12 col-xs-12 form-quatidade"><div class="col-md-3"><label for="">Quantidade</label> <input type="number" class="form-control" ng-model="vm.product.amount" min="{{vm.product.minAmount}}" max="{{vm.product.maxAmount > vm.product.available ? vm.product.available : vm.product.maxAmount}}" required></div><p class="frase-quantidade"></p></div><div ng-include="\'\'"></div></div><br><div class="row" class="style-horario"><div ng-if="vm.product.schedules.length>0"><div class="col-xs-12"><div class="form-group"><label for="">Hor\xE1rio</label></div></div><div class="col-md-3 col-xs-6 size-relative" ng-repeat="hour in vm.product.schedules"><div class="form-group"><button class="btn btn-block" ng-disabled="hour.available <= 0" ng-click="vm.selectHour(vm.product, hour)" ng-class="{\'btn-link\': vm.product.schedule != hour.schedule, \'btn-info\': vm.product.schedule == hour.schedule, \'btn-strike\': hour.available <= 0}">{{hour.schedule}} {{vm.verifyHourAvaliable(hour)}}</button></div></div><div style="display:none"><input type="text" ng-model="vm.product.schedule" required></div></div><div ng-repeat="p in vm.products" ng-if="p.schedules.length>0 && !vm.showOnlyOneSchedule"><div class="col-xs-12"><div class="form-group"><label for="">Hor\xE1rio {{p.name}}</label></div></div><div class="col-md-3 col-xs-4" ng-repeat="hour in p.schedules"><div class="form-group"><button class="btn btn-block" ng-disabled="hour.available <= 0" ng-click="vm.selectHour(p, hour)" ng-class="{\'btn-link\': p.schedule != hour.schedule, \'btn-info\': p.schedule == hour.schedule, \'btn-strike\': hour.available <= 0}">{{hour.schedule}} {{vm.verifyHourAvaliable(hour)}}</button></div></div><div style="display:none"><input type="text" ng-model="p.schedule" required></div></div><div ng-if="vm.pSchedule.schedules.length>0 && vm.showOnlyOneSchedule"><div class="col-xs-12"><div class="form-group"><label for="">Hor\xE1rio {{vm.product.name}}</label></div></div><div class="col-md-3 col-xs-4" ng-repeat="hour in vm.pSchedule.schedules"><div class="form-group"><button class="btn btn-block" ng-disabled="hour.available <= 0" ng-click="vm.selectHour(vm.pSchedule, hour); vm.updateProductsSchedule();" ng-class="{\'btn-link\': vm.pSchedule.schedule != hour.schedule, \'btn-info\': vm.pSchedule.schedule == hour.schedule, \'btn-strike\': hour.available <= 0}">{{hour.schedule}} {{vm.verifyHourAvaliable(hour)}}</button></div></div><div style="display:none"><input type="text" ng-model="vm.pSchedule.schedule" required></div></div></div>{{vm.showFewProducts ? \' * Poucas unidades \' : \'\'}}</div></form></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><button title="Cancelar" class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-success" ng-click="vm.close()" ng-disabled="formDados.$invalid">OK</button></div></div></div>');
$templateCache.put('app/ingressos/modais/dialog-ingresso-primeirodia.html','<div class="modal-header dialog-header-info ingresso-hora"><h4 title="{{vm.title}}" class="modal-title">{{vm.title}}</h4></div><div class="modal-body ingresso-primeirodia"><div class="row"><form name="formDados" class="col-md-12" role="form"><div ng-controller="SelectFirstDayController as vm"><div class="row quantidade"><div class="col-md-12 col-xs-12 form-quatidade"><div class="col-md-3"><label for="">Quantidade</label> <input type="number" class="form-control" ng-model="vm.product.amount" min="1" max="{{vm.product.available}}" required></div><p class="frase-quantidade"></p></div></div><input type="hidden" ng-model="vm.product.date" required></div></form></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><button title="Cancelar" class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-success" ng-click="vm.close()" ng-disabled="formDados.$invalid">OK</button></div></div></div>');
$templateCache.put('app/ingressos/modais/dialog-ingresso-proxima-hora.html','<div class="modal-header dialog-header-info ingresso-hora"><h4 title="{{vm.title}}" class="modal-title">{{vm.title}}</h4></div><div class="ingresso-hora" ng-include="\'\'"></div><div class="modal-body ingresso-hora"><div class="row"><form name="formDados" class="col-md-12" role="form"><div ng-controller="SelectNextHourController as vm"><div class="row quantidade"><div class="col-md-12 col-xs-12 form-quatidade"><div class="col-md-3"><label for="">Quantidade</label> <input type="number" class="form-control" ng-model="vm.product.amount" min="{{vm.product.minAmount}}" max="{{vm.product.maxAmount > vm.product.available ? vm.product.available : vm.product.maxAmount}}" required></div><p class="frase-quantidade"></p></div><div ng-include="\'\'"></div></div><br><div class="row" class="style-horario"><div ng-repeat="(keyP, p) in vm.products" ng-if="p.schedules.length>0 && !vm.showOnlyOneSchedule"><div class="col-xs-12"><div class="form-group"><label for="">Hor\xE1rio {{p.name}}</label></div></div><div class="col-md-3 col-xs-4" ng-repeat="(keyS, hour) in p.schedules"><div class="form-group"><button class="btn btn-block" ng-disabled="hour.available <= 0 || keyP !== 0 || keyS === p.schedules.length - 1" ng-click="vm.selectHour(p, hour, keyS, keyP)" ng-class="{\'btn-link\': p.schedule != hour.schedule, \'btn-info\': p.schedule == hour.schedule, \'btn-strike\': hour.available <= 0}">{{hour.schedule}} {{vm.verifyHourAvaliable(hour)}}</button></div></div><div style="display:none"><input type="text" ng-model="p.schedule" required></div></div></div>{{vm.showFewProducts ? \' * Poucas unidades \' : \'\'}}</div></form></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><button title="Cancelar" class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-success" ng-click="vm.close()" ng-disabled="formDados.$invalid">OK</button></div></div></div>');
$templateCache.put('app/ingressos/modais/dialog-politicas.html','<div class="modal-header dialog-header-info"><h4 class="modal-title"><span ng-if="vm.Properties.obrigatorioModalPoliticasNaoAceitar">Leia e aceite os termos </span><span ng-if="!vm.Properties.obrigatorioModalPoliticasNaoAceitar">Importante!</span></h4></div><div class="form modal-body"><div class="termos-aceite" id="termosAceite"><div ng-include="\'\'"></div></div><div ng-if="vm.Properties.obrigatorioModalPoliticasNaoAceitar" class="checkbox"><label><input ng-model="vm.terms" type="checkbox"> Li e aceito os termos e politicas.</label></div></div><div class="modal-footer"><div class="row"><div ng-if="vm.Properties.obrigatorioModalPoliticasNaoAceitar" class="col-xs-12 pull-right"><button class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</button> <button class="btn btn-success" ng-click="vm.close()" ng-disabled="!vm.terms">OK</button></div><div ng-if="!vm.Properties.obrigatorioModalPoliticasNaoAceitar" class="col-xs-12 pull-right"><button class="btn btn-success" ng-click="vm.close()">OK</button></div></div></div><style>.checkbox label, .checkbox label a {\n    font-size: 16px;\n    color: black;\n  }\n  .termos-aceite {\n    padding: 1.5rem;\n    max-height: 300px;\n    overflow: auto;\n    border: 1px solid darkgray;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen, Ubuntu, Cantarell, \'Open Sans\', \'Helvetica Neue\', sans-serif;\n    color: #000;\n    font-size: 1.4rem;\n  }</style>');
$templateCache.put('app/ingressos/modais/dialog-upsell-ticket.html','<div class="modal-header up-sell-header"><h4>Temos itens mais interessante para voc\xEA:</h4></div><div class="modal-body upsell"><div id="{{product.path}}" class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ingresso-col" ng-repeat="product in vm.upsellproducts"><div class="box-img background-cover" style="background-image: url(\'{{product.image}}\')" ng-click="vm.verMaisDetalhesProduto(product)"><div class="valores" ng-if="product.esgotado !== \'true\'"><h2 title="{{product.value / 100| currency:\'R$ \'}}">{{product.value / 100| currency:\'R$ \'}}</h2></div><div class="nome"><h2 title="{{product.shortName|| product.name}}">{{product.shortName|| product.name}}</h2></div></div><div class="body"><div class="footer"><button title="Adicionar ao Carrinho" type="button" role="button" class="btn btn-success btn-block" ng-disabled="product.esgotado === \'true\'" ng-click="vm.addProduct(product)"><i class="fa fa-spinner fa-spin hidden" aria-hidden="true" ng-show="product.loading"></i> <i class="fa fa-plus" aria-hidden="true"></i> {{product.esgotado === "true" ? \'Esgotado\': \'Adicionar ao Carrinho\' }}</button></div></div></div></div><div class="modal-footer upsell-footer"><div class="up-sell-footer"><button class="button-cancel-upsell" ng-click="vm.close()">Cancelar</button> <button class="button-upsell" ng-click="vm.dismiss()">N\xE3o tenho interesse <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div></div>');
$templateCache.put('app/ingressos/modais/dialogSameHour.html','<div class="modal-header dialog-header-info ingresso-hora"><h4 title="{{vm.title}}" class="modal-title">{{vm.title}}</h4></div><div class="ingresso-hora" ng-include="\'\'"></div><div class="modal-body ingresso-hora"><div class="row"><form name="formDados" class="col-md-12" role="form"><div ng-controller="SelectSameHourController as vm"><div class="row quantidade"><div class="col-md-12 col-xs-12 form-quatidade"><div class="col-md-3"><label for="">Quantidade</label> <input type="number" class="form-control" ng-model="vm.product.amount" min="1" max="{{vm.product.available}}" required></div><p class="frase-quantidade"></p></div><div ng-include="\'\'"></div></div><br><div class="row" class="style-horario"><div ng-if="vm.pSchedule.schedules.length>0"><div class="col-xs-12"><div class="form-group"><label for="">Hor\xE1rio {{vm.product.name}}</label></div><h1>teste-1 teste teste teste teste</h1></div><div class="col-md-3 col-xs-4" ng-repeat="hour in vm.pSchedule.schedules"><div class="form-group"><button class="btn btn-block" ng-disabled="hour.available <= 0" ng-click="vm.selectHour(vm.pSchedule, hour);" ng-class="{\'btn-link\': vm.pSchedule.schedule != hour.schedule, \'btn-info\': vm.pSchedule.schedule == hour.schedule, \'btn-strike\': hour.available <= 0}">{{hour.schedule}}</button></div></div><div style="display:none"><input type="text" ng-model="vm.pSchedule.schedule" required></div></div></div></div></form></div></div><div class="modal-footer"><div class="row"><div class="col-xs-12 pull-right"><button title="Cancelar" class="btn btn-danger" ng-click="vm.dismiss()">Cancelar</button> <button title="OK" class="btn btn-success" ng-click="vm.close()" ng-disabled="formDados.$invalid">OK</button></div></div></div>');
$templateCache.put('app/ingressos/modais/info-simple.html','<div class="b2c-modal b2c-info-ingressos"><div class="modal-header"><div class="row"><div class="col-xs-10"><h3 class="modal-title">{{vm.product.shortName.length > 0 ? vm.product.shortName : vm.product.name}}</h3></div><div class="col-xs-2"><button class="btn time-05 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><figure><img title="{{vm.product.name}}" alt="Imagem Ilustrativa: {{vm.product.name}}" class="img-responsive" src="{{vm.product.image}}"></figure><p><span ng-bind-html="vm.product.htmlMemo | toHtml"></span></p></div></div>');
$templateCache.put('app/new_ingressos/layouts/carrinho-aside-ingressos.html','<div id="bodyCarrinhoIngressos" class="carrinho-ingressos fixed animated in fadeInUp time-md-10 hidden-xs hidden-sm" ng-class="{\'show-mobile\': vm.showCarMobile, \'fixed\': vm.fixedCart}"><div class="row" ng-if="vm.step != \'confirmacao\'"><div class="header-cart col-md-12"><button title="Fechar Carrinho" aria-label="Fechar Carrinho" type="button" role="button" class="btn btn-min btn-warning ripple hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" ng-click="vm.showHiddenCarMobile()"><i class="fa fa-arrow-left" aria-hidden="true"></i> voltar</button><h2 title="Meu Carrinho"><i class="fa fa-shopping-cart" aria-hidden="true"></i> Meu Carrinho</h2><button title="Limpar Ingressos do carrinho" aria-label="Limpar Ingressos do carrinho" type="button" role="button" ng-show="vm.cart.length > 0" class="btn ripple btn-min btn-danger" ng-click="vm.clearCart()">Limpar <i class="fa fa-trash" aria-hidden="true"></i></button><hr></div></div><div class="row"><div class="body-cart col-md-12"><section ng-show="vm.cart.length <= 0" class="row row-produscts not"><div class="col-md-12"><h2 title="Carrinho vazio!"><i class="fa fa-ticket" aria-hidden="true"></i> Carrinho vazio!</h2><h3 title="Adicione itens ao seu carrinho"><i class="fa fa-arrow-left hidden-xs hidden-sm"></i> Adicione itens ao seu carrinho</h3></div></section><section id="xs_produtos_carrinho" ng-if="vm.cart.length > 0 && vm.step != \'confirmacao\'" class="row row-products"><div class="col-md-12"><div ng-include="\'app/new_ingressos/layouts/lista-ingressos-carrinhos.html\'"></div><div ng-if="vm.oldBill.id>0" class="row"><div class="col-xs-12 valor-total" ng-class="{\'remarcacao\': vm.oldBill.id>0}"><div class="totalapagar row"><div class="col-xs-6 text"><h3 title="Total a pagar" ng-if="vm.oldBill.value < vm.totalValue">Total a pagar</h3><h3 title="Saldo restante" ng-if="vm.oldBill.value >= vm.totalValue">Saldo restante</h3></div><div class="col-xs-6 preco" class="descontos"><h3 title="{{ (vm.totalValue - vm.oldBill.value) / 100 | currency:\'R$ \'}}">{{ (vm.totalValue - vm.oldBill.value) / 100 | currency:"R$ "}}</h3></div></div></div></div><div ng-include="\'app/new_ingressos/layouts/models-buttons-compra-cupons.html\'"></div></div></section></div></div></div><figure class="mascote-carrinhos"><img ng-src=""></figure><button title="Ir para Carrinho" aria-label="Ir para Carrinho" type="button" role="button" ng-if="vm.cart.length > 0" class="btn ripple btn-default button-carrinho float-top hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" ng-disabled="(vm.totalValue / 100) <= 0" ng-click="vm.nextStep()"><i class="fa fa-shopping-cart" aria-hidden="true"></i><span class="badge">{{vm.totalAmount}}</span></button><nav ng-if="vm.cart.length > 0" class="row hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl animated in slideInUp msg-ingressos-footer" ng-class="{\n    \'remove-padding\': ((vm.totalValue / 100) <= 0 && vm.cart.length > 0),\n  }"><span ng-if="(vm.totalValue / 100) <= 0 && vm.cart.length > 0" class="msg-ingresso-pagante">Adicione um Ingresso Pagante para prosseguir!</span><div class="col-xs-6"><h3 title="{{vm.totalAmount}} {{vm.totalAmount > 1 ? \'Produtos\' : \'Produto\'}}">{{vm.totalValue / 100| currency:\'R$ \'}} <small><i class="fa animated" ng-class="fa-ticket" aria-hidden="true"></i> {{vm.totalAmount}} {{vm.totalAmount != 1 ? \'Produtos\' : \'Produto\'}}</small></h3></div><div class="col-xs-6"><button title="Carrinho" type="button" role="button" class="btn btn-success btn-block btn-lg" ng-click="vm.nextStep()" ng-disabled="(vm.totalValue / 100) <= 0">Carrinho <i class="fa fa-shopping-cart" aria-hidden="hidden"></i></button></div></nav>');
$templateCache.put('app/new_ingressos/layouts/carrinho-section-ingressos.html','<section class="row" ng-if="vm.step == \'carrinho\'" id="cart"><div id="extras" class="col-md-12" ng-if="vm.extraProducts.length > 0"><section class="row"><div class="col-md-12"><div class="row"><div class="col-xs-12 loja-header-default"><h3 title="Itens Adicionais" align="center"><i class="fa fa-hand-o-down" aria-hidden="true"></i> Outros clientes tamb\xE9m viram estes produtos</h3></div></div><div class="row"><div ng-repeat="product in vm.extraProducts" ng-include="\'app/new_ingressos/layout-ingressos-extras.html\'"></div></div></div></section></div><div class="col-md-12"><div class="row"><div class="col-md-12 loja-header-default"><div class="row"><div class="col-xs-offset-3 col-xs-8 col-sm-offset-0 col-sm-4 col-md-offset-0 col-md-4 loja-div-voltar"><button title="Escolher Ingressos" aria-label="" type="button" role="button" class="btn btn-info ripple loja-btn-voltar-ingressos btn-cliente" ng-click="vm.voltar()"><i class="fa fa-arrow-left"></i>&nbsp; Escolher Ingressos</button></div><div class="col-md-4 col-sm-12 col-xs-12"><h3 title="Ingressos ao Carrinho" align="center"><i class="fa fa-shopping-cart"></i> Ingressos ao Carrinho</h3></div></div></div></div><section class="b2c-cart-itens"><div class="row cart-header cart-row loja-header-tabela-carrinho"><div class="col-xs-4"><b>Passaporte(s)</b></div><div class="col-xs-4 padding-xs-left-0"><b>Quantidade</b></div><div class="col-xs-4 text-center hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><b>Valores</b></div><div class="col-xs-4 hidden-xs hidden-sm"><div class="row"><div class="col-md-4"><b>Valor Unit\xE1rio</b></div><div class="col-md-4"><b>Valor Total</b></div><div class="col-md-4"><b>...</b></div></div></div></div><div class="row cart-body"><div class="col-md-12"><div class="row cart-row" ng-class="{\'background-item\': $index % 2 == 0}" ng-repeat="item in vm.cart track by $index"><div class="col-xs-4"><h4 title="Valor">{{item.shortName.length > 0 ? item.shortName : item.name}} <small ng-if="item.isExtra">- (Produto Adicional)</small></h4><small>{{item.date | date:"dd/MM/yyyy"}}</small></div><div class="col-xs-4 padding-xs-0"><button title="Retirar" aria-label="Retirar" type="button" role="button" class="btn btn-mini ripple btn-info btn-cart btn-cliente-car" ng-click="vm.removeItemInCart($index)"><i class="fa fa-minus"></i></button> <button title="Quantidade" aria-label="Quantidade" type="button" role="button" class="btn btn-mini ripple btn-default btn-cart"><b>{{item.amount}}</b></button> <button title="Adicionar" aria-label="Adicionar" type="button" role="button" class="btn btn-mini ripple btn-info btn-cart btn-cliente-car" ng-click="vm.addItemInCart($index)"><i class="fa fa-plus"></i></button></div><div class="col-xs-4 padding-xs-left-0"><div class="row"><div class="col-md-4"><strong><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Uni.: </span>{{item.value / 100| currency:\'R$ \'}}</strong></div><div class="col-md-4"><strong><span class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl">Tot.: </span>{{(item.amount * item.value) / 100 | currency:\'R$ \'}}</strong></div><div class="col-md-4"><button title="Remover produto" aria-label="Remover produto" type="button" role="button" class="btn btn-danger ripple loja-btn-excluir" ng-click="vm.removeItemFromCart($index, item)"><i class="fa fa-trash"></i></button></div></div></div></div></div></div><div class="row cart-footer background-item"><div class="col-md-6"><div class="row"><div class="col-md-6 col-sm-8"><input type="text" class="form-control" placeholder="Cupom de Desconto" ng-model="vm.cupomCodKey"></div><div class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl hidden-sm col-xs-12"><br></div><div class="col-md-6 col-sm-4"><button title="Validar Cupom" aria-label="Validar Cupom" type="button" role="button" class="btn btn-info ripple hidden-xs btn-block loja-btn-cupom btn-cliente-car" ng-click="vm.validCupom()" ng-disabled="vm.cupomCodKey.length < 5"><i class="fa fa-check"></i> Validar Cupom</button> <button title="Validar Cupom" aria-label="Validar Cupom" type="button" role="button" class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl hidden-sm btn btn-info ripple btn-block loja-btn-cupom" ng-click="vm.validCupom()" ng-disabled="vm.cupomCodKey.length < 5"><i class="fa fa-check"></i> Validar Cupom</button></div><div class="col-md-12 col-sm-12"><br></div><div class="col-md-6 loja-btn-outra-data-col" ng-hide="vm.naoEscolheData"><button title="Escolher outra data" aria-label="Escolher outra data" type="button" role="button" class="btn btn-info ripple btn-block loja-btn-outra-data btn-cliente-car" ng-click="vm.reset()"><i class="fa fa-calendar"></i> Escolher outra data</button></div><div class="col-md-12 col-sm-12 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" ng-hide="vm.naoEscolheData"><br></div><div class="col-md-6"><button title="Limpar Carrinho" aria-label="Limpar Carrinho" type="button" role="button" class="btn btn-info ripple btn-block loja-btn-limpar-carrinho btn-cliente-car" ng-click="vm.clearCart()"><i class="fa fa-eraser"></i> Limpar Carrinho</button></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-12"><h3 title="Total" class="pull-right">Total: {{vm.totalValue / 100| currency:\'R$ \'}}</h3></div></div><div class="row"><div class="col-md-6 pull-right"><button title="Comprar" aria-label="Comprar" type="button" class="btn btn-success ripple btn-block loja-btn-comprar" ng-click="vm.initialPurchase()" ng-disabled="vm.cart.length == 0"><i class="fa fa-shopping-cart"></i>&nbsp;&nbsp;Comprar</button></div></div></div><div class="col-xs-12 loja-carrinho-detalhes"></div></div></section></div></section>');
$templateCache.put('app/new_ingressos/layouts/cupom-desconto-key.html','<div class="cupom-desconto-key" ng-if="!vm.disableCupom"><form tabindex="-1" class="form row" name="cupomDesconto" id="cupomDesconto" role="form"><div class="has-feedback cupom-key padding-0 col-xs-offset-2 col-xs-8" ng-class="{\'has-success\': cupomDesconto.cupomCodKey.$touched && cupomDesconto.cupomCodKey.$valid, \'has-error\': cupomDesconto.cupomCodKey.$touched && cupomDesconto.cupomCodKey.$invalid}" ng-if="vm.naoUtilizaKey"><label class="control-label" for="cupomCod">Cupom * <em class="text-danger" ng-show="cupomDesconto.cupomCodKey.$touched && cupomDesconto.cupomCodKey.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></em></label><div class="input-group"><input type="text" name="cupomCodKey" class="form-control input-pag" id="cupomCodKey" placeholder="Cupom" ng-model="vm.cupomCodKey" ng-required="true"><div class="form-control-feedback" role="alert"><i class="fa fa-tags" aria-hidden="true"></i></div></div></div><div class="has-feedback cupom-key padding-0 col-xs-5" ng-class="{\'has-success\': cupomDesconto.cupomCod.$touched && cupomDesconto.cupomCod.$valid, \'has-error\': cupomDesconto.cupomCod.$touched && cupomDesconto.cupomCod.$invalid}" ng-if="!vm.naoUtilizaKey"><label class="control-label" for="cupomCod">Cupom * <em class="text-danger" ng-show="cupomDesconto.cupomCod.$touched && cupomDesconto.cupomCod.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></em></label><div class="input-group"><input type="text" name="cupomCod" class="form-control input-pag" id="cupomCod" placeholder="Cupom" ng-model="vm.cupomCod" ng-required="true"><div class="form-control-feedback" role="alert"><i class="fa fa-tags" aria-hidden="true"></i></div></div></div><div class="has-feedback cupom-cod col-xs-5 padding-0" ng-class="{\'has-success\': cupomDesconto.cupomKey.$touched && cupomDesconto.cupomKey.$valid, \'has-error\': cupomDesconto.cupomKey.$touched && cupomDesconto.cupomKey.$invalid}" ng-if="!vm.naoUtilizaKey"><label class="control-label" for="cupomKey">C\xF3digo * <em class="text-danger" ng-show="cupomDesconto.cupomKey.$touched && cupomDesconto.cupomKey.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></em></label><div class="input-group"><input type="text" name="cupomKey" class="form-control input-pag" id="cupomKey" placeholder="C\xF3digo" ng-model="vm.cupomKey" ng-required="true"><div class="form-control-feedback" role="alert"><i class="fa fa-key" aria-hidden="true"></i></div></div></div><div class="padding-left-0 col-xs-2 cupom-button"><label class="control-label col-xs-12" aria-hidden="true">&nbsp;</label> <button title="Aplicar o cupom de desconto" aria-label="Aplicar o cupom de desconto" type="button" role="button" style="max-height:32px;" class="btn ripple btn-primary input-pag" ng-click="vm.validCupom()" ng-disabled="cupomDesconto.$invalid"><i class="fa fa-check" aria-hidden="true"></i></button></div></form></div>');
$templateCache.put('app/new_ingressos/layouts/extras.html','<div id="extras" class="col-md-12" ng-if="vm.extraProducts.length > 0"><section class="row"><div class="col-md-12"><div class="row"><div class="col-xs-12 loja-header-default"><h3 title="Itens Adicionais" align="center"><i class="fa fa-hand-o-down" aria-hidden="true"></i> Outros clientes tamb\xE9m viram estes produtos</h3></div></div><div class="row"><div ng-repeat="product in vm.extraProducts" ng-include="\'app/new_ingressos/layout-ingressos-extras.html\'"></div></div></div></section></div>');
$templateCache.put('app/new_ingressos/layouts/form-pagamento.html','');
$templateCache.put('app/new_ingressos/layouts/header-ingressos-dates.html','<div class="row header-ingressos dates animated in fadeIn"><div class="container-fluid"><div class="row"><div class="col-xs-10 col-sm-10 col-md-8 col-lg-8 input-data"><div class="row"><div class="col-md-3 padding-right-0 col-info hidden-xs hidden-sm"><h2 title="Buscar outro Per\xEDodo">Buscar outro Per\xEDodo <i class="fa fa-arrow-right" aria-hidden="true"></i></h2></div><div class="col-md-7 col-input"><div id="calendarChangeData" class="row calendario-input"><div class="col-xs-10 col-sm-10 col-md-8 col-lg-8 padding-right-0"><div class="input-group"><input type="text" class="form-control check-in" ng-model="vm.date" min-date="vm.today" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false, startingDay:0}" is-open="vm.activeDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-disabled="vm.buttonChangeData" ng-click="vm.activeDate = true"> <span class="input-group-addon"><button title="Abril calend\xE1rio de data in\xEDcial" aria-label="Abril calend\xE1rio de data in\xEDcial" type="button" role="button" ng-click="vm.handleDate()"><i class="fa fa-calendar-check-o" aria-hidden="true"></i></button> </span><input type="text" class="form-control check-out" ng-model="vm.endDate" min-date="vm.date" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false, startingDay:0}" is-open="vm.activeEndDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-disabled="vm.buttonChangeData" ng-click="vm.activeEndDate = true"> <span class="input-group-addon"><button title="Abril calend\xE1rio de data final" aria-label="bril calend\xE1rio de data final" type="button" role="button" ng-click="vm.activeEndDate = true"><i class="fa fa-calendar-times-o" aria-hidden="true"></i></button></span></div><button title="Nova Busca" aria-label="Nova Busca" type="button" role="button" class="hidden btn btn-default btn-block pesquisar" ng-click="vm.openDatePickerModalMobile(vm.date, vm.endDate)">Nova Busca &nbsp; <i class="fa fa-calendar" aria-hidden="true"></i></button></div><div class="col-xs-2 col-sm-2 col-md-4 col-lg-4 padding-left-0"><button title="Buscar Ingressos" aria-label="Buscar Ingressos" type="button" role="button" class="btn btn-search pesquisar btn-success btn-block btn-cliente btn-scala" ng-click="vm.search(vm.date, vm.endDate)"><b><span class="hidden-xs hidden-sm">Nova Busca </span><i class="fa fa-search" aria-hidden="true"></i></b></button></div></div></div></div></div></div></div></div>');
$templateCache.put('app/new_ingressos/layouts/header-ingressos.html','');
$templateCache.put('app/new_ingressos/layouts/info-ingressos.html','<div id="infoIngressos" class="row info-ingressos jumbotron animated in fadeInUp time-10"><div class="col-md-3 calendar-info hidden-xs hidden-sm"><div class="col-calendar layout-calendar"><div uib-datepicker ng-model="vm.lastDate" min-date="vm.today" class="well well-sm" ng-change="vm.searchInReset(vm.lastDate)" custom-class="vm.getDayClass(date, mode)" date-disabled="vm.disabledDate(date,mode)"></div></div></div><div class="col-md-9" ng-if="vm.categoriasCombos.length === 0 && !vm.isSearchingProducts"><h2 title="Opa! N\xE3o temos Ingressos dispon\xEDveis para o dia {{vm.lastDate| date:\'dd/MM/yyyy\'}}"><i class="fa fa-ticket" aria-hidden="true"></i>Opa! N\xE3o temos Ingressos dispon\xEDveis para o dia <button class="btn btn-default calendar-mobile" ng-click="vm.openDatePickerModalMobile(vm.lastDate)">{{vm.lastDate| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar"></i></button></h2><hr><h3 title="Por favor pesquise outro dia!"><i class="fa fa-asterisk"></i> Por favor pesquise outro dia!</h3></div><div class="col-md-9 infos" ng-if="vm.categoriasCombos.length > 0"><h2 title="Produtos para o dia {{vm.lastDate| date:\'dd/MM/yyyy\'}}"><i class="fa fa-ticket" arian-hidden="true"></i> Produtos para o dia <button class="btn btn-default" ng-click="vm.openDatePickerModalMobile(vm.lastDate)">{{vm.lastDate| date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar"></i></button></h2><hr><h3 ng-if="vm.categoriasCombos.length > 1" title="Adicione Ingressos de uma ou mais categorias ao seu carrinho."><i class="fa fa-asterisk" aria-hidden="true"></i> Adicione Ingressos de <strong>uma</strong> ou <strong>mais</strong> categorias ao seu carrinho</h3><h3 class="frase-combo-date" ng-if="vm.infoSelectDate" title="O pre\xE7o dos combos pode variar de acordo com a data dos Ingressos selecionados."><i class="fa fa-asterisk" aria-hidden="true"></i> O pre\xE7o dos combos pode variar de acordo com a data dos Ingressos selecionados.</h3><h3 ng-if="!vm.resetCarrinho" title="Voc\xEA pode comprar Ingressos para diferentes datas, basta realizar outra busca."><i class="fa fa-asterisk" aria-hidden="true"></i> Voc\xEA pode comprar Ingressos para diferentes datas, basta realizar outra busca.</h3><h3 ng-if="false"><i class="fa fa-asterisk" aria-hidden="false"></i></h3><div ng-include=""></div><div class="row body-info-calendario hidden-xs hidden-sm"><div class="col-md-10" ng-include="\'app/new_ingressos/layouts/legenda-calendario.html\'"></div></div></div></div>');
$templateCache.put('app/new_ingressos/layouts/info-regras-compras-ingressos.html','<div class="row"><div class="col-md-12"><div class="regras-compra"><h5 title="Os dados devem ser os mesmos do cart\xE3o">Dados do <strong>comprador</strong> devem ser os mesmos do cart\xE3o</h5><h5 title="N\xE3o \xE9 aceito cart\xE3o de terceiros">N\xE3o \xE9 aceito cart\xE3o de terceiros</h5></div></div></div>');
$templateCache.put('app/new_ingressos/layouts/legenda-calendario.html','<ul><li class="selecionado" uib-tooltip=""><i class="fa fa-check"></i> <strong>Dia<br>Selecionado</strong></li><li class="disponivel" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'aberto\')"><i class="fa fa-ticket"></i> <strong>Dia<br>Aberto</strong></li><li class="promocao" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'promo\')"><i class="fa fa-ticket"></i> <strong>Dia<br>Promocional</strong></li><li class="especial" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'alta\')"><i class="fa fa-ticket"></i> <strong>Alta<br>Temporada</strong></li><li class="disponivel" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'baixa\')"><i class="fa fa-ticket"></i> <strong>Baixa<br>Temporada</strong></li><li class="especial" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'especial\')"><i class="fa fa-ticket"></i> <strong>Data<br>Especial</strong></li><li class="black" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'black\')"><i class="fa fa-ticket"></i> <strong>Black<br>Friday</strong></li><li class="reduzido" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'reduzido\')"><i class="fa fa-ticket"></i> <strong>Hor\xE1rio<br>Reduzido</strong></li><li class="fechado" uib-tooltip=""><i class="fa fa-ban"></i> <strong>Dia<br>Fechado</strong></li><li class="restrito" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'restrito\')"><i class="fa fa-ban"></i> <strong>Dia<br>Restrito</strong></li><li class="media" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'media\')"><i class="fa fa-tag" aria-hidden="true"></i> <strong>M\xE9dia<br>Temporada</strong></li><li class="super" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'super\')"><i class="fa fa-certificate" aria-hidden="true"></i> <strong>Super<br>Temporada</strong></li><li class="esgotado" uib-tooltip="" ng-if="vm.diferenciaTemporadas(\'esgotado\')"><i class="fa fa-times" aria-hidden="true"></i> <strong>Dia<br>Esgotado</strong></li></ul>');
$templateCache.put('app/new_ingressos/layouts/lista-ingressos-carrinhos.html','<div class="container-produsct"><div class="row header hidden-xs hidden-sm"><div ng-show="vm.extraProducts.length == 0" class="col-md-12"><h3 title="Meus Ingressos"><i class="fa fa-ticket" aria-hidden="true"></i> Meus Ingressos</h3></div><div ng-show="vm.extraProducts.length > 0" class="col-md-12"><h3 title="Meus Ingressos">Meus Produtos <small><i class="fa fa-ticket" aria-hidden="true"></i> Ingressos e <i class="fa fa-tags" aria-hidden="true"></i> Extras</small></h3></div></div><div ng-show="vm.cart.length >= 1" class="row clean-cart hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><div class="col-xs-12"><button title="Limpar Ingressos do carrinho" aria-label="Limpar Ingressos do carrinho" type="button" role="button" class="btn ripple btn-min btn-danger clear" ng-click="vm.clearCart()">Limpar <i class="fa fa-trash" aria-hidden="true"></i></button></div></div><div class="row row-produsct {{ingresso.category | noSpace: \'_\'}}" ng-class="{\'extra\': ingresso.isExtra}" ng-repeat="ingresso in vm.cart"><div class="col-md-12"><div class="row"><div class="col-xs-10 padding-right-0"><h3 title="{{ingresso.shortName || ingresso.name}} - {{ingresso.category}} - {{ingresso.date| date :\'dd/MM/yyyy\'}}"><i class="fa" ng-class="{\'fa-tags\': ingresso.isExtra, \'fa-ticket\': !ingresso.isExtra}" aria-hidden="true"></i> {{ingresso.shortName || ingresso.name}}<br><small class="date">{{ingresso.isExtra ? \'Extra\' : \'Produto\'}} - {{ingresso.date| date :\'dd/MM/yyyy\'}}</small></h3></div><div class="col-xs-2 padding-left-0"><button title="Retirar do carrinho o Produto {{ingresso.shortName || ingresso.name}}" aria-label="Retirar do carrinho o Produto {{ingresso.shortName || ingresso.name}}" type="button" role="button" class="btn time-05 ripple trash" ng-click="vm.removeItemFromCart($index, ingresso)"><i class="fa fa-trash" aria-hidden="true"></i></button></div></div><hr role="separator"><div class="row action-shopping"><div class="col-xs-5 padding-xs-right-5"><div class="btn-group" role="group" ng-if="!ingresso.form"><button title="Retirar um Produto {{ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}} do carrinho" aria-label="Retirar um Produto {{ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}} do carrinho" type="button" role="button" class="btn time-05 ripple btn-default minus" ng-click="vm.removeItemInCart(ingresso)"><i class="fa fa-minus" aria-hidden="true"></i></button> <button title="N\xFAmero de Produtos {{ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}: {{child.amount}} no carrinho" aria-label="N\xFAmero de Produtos {{ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}: {{child.amount}} no carrinho" type="button" role="tooltip" class="btn time-05 btn-default value">{{ingresso.amount}}</button> <button title="Adicionar mais um Produto {{ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}} do carrinho" aria-label="Adicionar mais um Produto {{ingresso.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}} do carrinho" type="button" role="button" class="btn time-05 ripple btn-default plus" ng-click="vm.addItemInCart(ingresso)"><i class="fa fa-plus" aria-hidden="true"></i></button></div></div><div class="col-xs-4 comprador"><h5 ng-if="ingresso.years" title="{{ingresso.years}}">{{ingresso.years}}</h5></div><div class="col-xs-3 prices padding-left-5"><h5 title="Valor {{(ingresso.amount * ingresso.value) / 100 | currency:\'R$ \'}}">{{(ingresso.amount * ingresso.value) / 100 | currency:\'R$ \'}}</h5></div></div></div></div><div class="row row-produsct conveniencia" ng-if="vm.feeValue > 0"><div class="col-xs-6"><h5>Taxa de conveni\xEAncia</h5></div><div class="col-xs-6 prices text-right"><h5>{{vm.feeValue / 100 | currency: \'R$ \'}}</h5></div></div><div class="row row-produsct frete" ng-if="vm.freteValue > 0"><div class="col-xs-6"><h5>Frete</h5></div><div class="col-xs-6 prices text-right"><h5>{{vm.freteValue / 100 | currency: \'R$ \'}}</h5></div></div></div>');
$templateCache.put('app/new_ingressos/layouts/models-buttons-compra-cupons.html','<div class="row"><div class="footer-cart key col-md-12"><div class="row"><div class="col-xs-4"><h2 ng-show="vm.totalValue > 0" title="Valor total para {{vm.totalAmount}} {{vm.totalAmount > 1 ? \'Produtos\' : \'Produto\'}}: {{vm.totalValue / 100| currency:\'R$ \'}}">{{vm.totalAmount}} prod.<br><small ng-show="vm.extraProducts.length == 0"><i class="fa fa-ticket" aria-hidden="true"></i> Ingressos </small><small ng-show="vm.extraProducts.length > 0"><i class="fa fa-ticket" aria-hidden="true"></i> Ingressos e <i class="fa fa-tags" aria-hidden="true"></i> Extras</small></h2></div><div class="col-xs-8 padding-0"><div ng-include="\'app/new_ingressos/layouts/cupom-desconto-key.html\'"></div></div></div><div class="row"><div class="col-md-12"><hr></div></div><div class="row"><div class="col-md-12"><button id="initialButtonPurchase" title="Prosseguir com a compra" type="button" class="btn btn-success btn-lg btn-shadow btn-block btn-lg time-05 ripple" ng-class="{\'descontos\': vm.oldValue > 0 && vm.oldValue != vm.totalValue}" ng-click="vm.nextStep()" ng-disabled="vm.cart.length == 0"><span ng-if="vm.totalValue>0 && (vm.oldBill == null || vm.oldBill == \'undefined\' || vm.oldBill.id == null || vm.oldBill.id <=0)"><small ng-show="vm.oldValue > 0 && vm.oldValue != vm.totalValue" title="{{vm.oldValue / 100 | currency:\'R$ \'}}">de {{vm.oldValue / 100 | currency:"R$ "}}</small> <strong><em ng-show="vm.oldValue > 0 && vm.oldValue != vm.totalValue">por </em>{{vm.totalValue / 100| currency:\'R$ \'}}</strong> &nbsp; - &nbsp; Prosseguir <i class="fa fa-shopping-cart" aria-hidden="true"></i> </span><span ng-if="vm.oldBill.id"><strong ng-if="vm.totalValue > vm.oldBill.value">Total {{ (vm.totalValue - vm.oldBill.value) / 100 | currency:"R$ "}}</strong> <strong ng-if="vm.totalValue <= vm.oldBill.value">Total R$ 0,00</strong> - Prosseguir <i class="fa fa-shopping-cart"></i></span></button></div></div></div></div><div id="models_buttons_compra"></div>');
$templateCache.put('app/new_ingressos/layouts/models-buttons-compra.html','<div class="row"><div class="footer-cart col-md-12"><div class="row"><div class="col-xs-5"><h2 ng-show="vm.totalValue > 0" title="Valor total para {{vm.totalAmount}} {{vm.totalAmount > 1 ? \'Produtos\' : \'Produto\'}}: {{vm.totalValue / 100| currency:\'R$ \'}}">{{vm.totalAmount}} {{vm.totalAmount > 1 ? \'produtos\': \'produto\'}}<br><small ng-show="vm.extraProducts.length == 0"><i class="fa fa-ticket" aria-hidden="true"></i> Ingressos </small><small ng-show="vm.extraProducts.length > 0"><i class="fa fa-ticket" aria-hidden="true"></i> Ingressos e <i class="fa fa-tags" aria-hidden="true"></i> Extras</small></h2></div><div class="col-xs-7 cupom-desconto"><form class="form"><div class="input-group"><input type="text" name="Cupom" class="form-control input-pag" placeholder="Cupom" ng-model="vm.cupomCodKey" ng-required="true" ng-enter="vm.validCupom()"> <span class="input-group-addon input-pag"><button title="Aplicar o cupom de desconto" aria-label="Aplicar o cupom de desconto" type="button" role="button" class="btn ripple btn-primary input-pag" ng-click="vm.validCupom()" ng-disabled="!vm.cupomCodKey"><i class="fa fa-check"></i></button></span></div></form></div></div><div class="row"><div class="col-md-12"><hr></div></div><div class="row"><div class="col-xs-12 prices descontos" ng-if="vm.oldValue > 0 && vm.oldValue != vm.totalValue"><h5 title="Voc\xEA economizou {{(vm.oldValue - vm.totalValue) / 100 | currency:\'R$ \'}}" aria-hidden="false">Voc\xEA economizou {{(vm.oldValue - vm.totalValue) / 100 | currency:\'R$ \'}}</h5></div><div class="col-md-12"><span ng-if="(vm.totalValue / 100) <= 0 && vm.cart.length > 0" class="msg-ingresso-pagante">Adicione um Ingresso Pagante para prosseguir!</span> <button id="initialButtonPurchase" title="Prosseguir com a compra" type="button" role="button" class="btn btn-success btn-shadow btn-block btn-lg time-05 ripple" ng-click="vm.initialPurchase()" ng-disabled="(vm.totalValue / 100) <= 0 || vm.step == \'identificacao\' || vm.step == \'pagamento\'"><strong ng-if="vm.cart.length > 0 && (vm.oldBill == null || vm.oldBill == \'undefined\' || vm.oldBill.id == null || vm.oldBill.id <= 0)">Total {{vm.totalValue / 100 | currency:\'R$ \'}}</strong> <span ng-if="vm.oldBill.id"><strong ng-if="vm.totalValue > vm.oldBill.value">Total {{ (vm.totalValue - vm.oldBill.value) / 100 | currency:"R$ "}}</strong> <strong ng-if="vm.totalValue <= vm.oldBill.value ">Total R$ 0,00</strong> </span>- Prosseguir <i class="fa fa-shopping-cart"></i></button></div></div></div></div><div id="models_buttons_compra"></div>');
$templateCache.put('app/new_ingressos/modais/ajuda-ingressos.html','<div class="b2c-modal-ingressos help modal-combo-made"><div class="modal-header"><div class="row"><div class="col-xs-9 padding-right-0"><h3 title="Oi! Precisa de ajuda?" class="modal-title"><i class="fa fa-question-circle" aria-hidden="true"></i> Oi! Precisa de ajuda?</h3></div><div class="col-xs-3"><button title="Fechar op\xE7\xE3o de ajuda" aria-label="Fechar op\xE7\xE3o de ajuda" type="button" role="button" class="btn time-05 ripple btn-danger pull-right" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="row helps-intro"><div class="col-md-7"><h3 title="Estamos aqui para ajudar! Siga essas orienta\xE7\xF5es e caso precise, pode nos ligar ou mandar um e-mail.">Estamos aqui para ajudar!<br><small>Siga essas orienta\xE7\xF5es e caso precise, pode nos ligar ou mandar um e-mail.</small></h3></div><div class="col-md-5"><address><p><i class="fa fa-phone-square" aria-hidden="true"></i></p><p><i class="fa fa-whatsapp" aria-hidden="true"></i> (73) 3268-8500</p><p><i class="fa fa-envelope" aria-hidden="true"></i> info@hoteisquintadosol.com</p></address></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/new_ingressos/modais/mais-detalhes-ingresso.html','<div class="b2c-modal-ingressos modal-combo-made"><div class="modal-header"><div class="row"><div class="col-xs-9 padding-right-0"><h3 title="Mais detalhes do {{vm.product.shortName}}" class="modal-title">{{vm.product.shortName}}</h3></div><div class="col-xs-3"><button title="Fechar mais detalhes do {{vm.product.shortName}}" aria-label="Fechar mais detalhes do {{vm.product.shortName}}" type="button" role="button" class="btn time-05 ripple btn-danger pull-right" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="row introducao-modal"><div class="col-md-3 img-ilustrativa"><img title="{{vm.product.shortName}}" alt="Imagem Ilustrativa: {{vm.product.shortName}}" class="img-responsive" src="{{vm.product.image}}"></div><div class="col-md-9"><div class="row"><div class="col-md-12"><h3 title="Informativo do {{vm.product.shortName}}">Informativo do {{vm.product.shortName}}</h3><hr role="separator"></div></div><div ng-if="vm.product.memo" class="row descriptions-modal"><div class="col-md-12"><p ng-bind-html="vm.product.memo | toHtml"></p></div><div class="col-md-12" ng-if="vm.product.memo === vm.product.htmlMemo"><div ng-include="<p></p>"></div></div></div><div class="row introducao-modal-compra"><div class="col-md-6 actions-shopping"><div class="action-shopping adulto row"><div ng-if="!vm.product.oldValue" class="col-xs-6 prices"><label class="label" for="valor_{{vm.product.id}}">Valor Ingresso</label><h5 title="{{(vm.product.amount > 0 ? vm.product.value * vm.product.amount : vm.product.value) / 100 | currency:\'R$ \'}}" id="valor_{{vm.product.id}}">{{(vm.product.amount > 0 ? vm.product.value * vm.product.amount : vm.product.value) / 100 | currency:\'R$ \'}}</h5></div><div ng-if="vm.product.oldValue" class="col-xs-6 prices old"><label class="label" for="valor_{{vm.product.id}}">Valor Ingresso</label><h6 title="De {{vm.product.oldValue / 100| currency:\'R$ \'}}">De {{vm.product.oldValue / 100| currency:\'R$ \'}}</h6><h5 title="{{(vm.product.amount > 0 ? vm.product.value * vm.product.amount : vm.product.value) / 100 | currency:\'R$ \'}}" id="valor_{{vm.product.id}}">{{(vm.product.amount > 0 ? vm.product.value * vm.product.amount : vm.product.value) / 100 | currency:\'R$ \'}}</h5></div><div class="col-xs-6 padding-left-0" ng-if="!vm.product.esgotado"><label for="typeIngresso_{{vm.product.id}}" class="span-label">{{vm.product.years == null ? \'Ingressos\': vm.product.years}}</label> <button title="Adicionar esse produto {{vm.product.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}} ao carrinho" aria-label="Adicionar esse produto {{vm.product.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}} ao carrinho" uib-tooltip="{{vm.product.years == null ? \'Ingressos\': vm.product.years}}" type="button" role="button" class="btn time-05 ripple btn-success btn-block plus" ng-click="vm.parent.addProductDirect(vm.product);vm.close();">Comprar <i class="fa fa-plus" aria-hidden="true"></i></button></div><div class="col-xs-6 padding-left-0" ng-if="vm.product.esgotado"><label for="typeIngresso_{{vm.product.id}}" class="span-label">{{vm.product.years == null ? \'Ingressos\': vm.product.years}}</label> <button title="ESGOTADO" aria-label="ESGOTADO" uib-tooltip="ESGOTADO" type="button" role="button" class="btn time-05 ripple btn-success btn-block plus" disabled="disabled">ESGOTADO <i class="fa fa-close" aria-hidden="true"></i></button></div><div ng-if="vm.product.children.length > 0" class="col-xs-12"><hr role="separator"></div></div><div class="action-shopping crianca children row" ng-repeat="child in vm.product.children"><div ng-if="child.oldValue" class="col-xs-6 prices old"><label class="label" for="valor_child_{{child.id}}">Valor Ingresso</label><h6 title="De {{child.oldValue / 100| currency:\'R$ \'}}">De {{child.oldValue / 100| currency:\'R$ \'}}</h6><h5 title="{{(child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \'}}" id="valor_child_{{child.id}}">{{(child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \'}}</h5></div><div ng-if="!child.oldValue" class="col-xs-6 prices"><label class="label" for="valor_child_{{child.id}}">Valor Ingresso</label><h5 title="{{(child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \'}}" id="valor_child_{{child.id}}">{{(child.amount > 0 ? child.value * child.amount : child.value) / 100 | currency:\'R$ \'}}</h5></div><div class="col-xs-6 padding-left-0" ng-if="!child.esgotado"><label for="typeIngressoChild_{{child.id}}" class="span-label">{{child.years == null ? \'Ingressos\': child.years}}</label> <button title="Adicionar mais um produto {{child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" aria-label="Adicionar mais um produto {{child.shortName}} tipo {{child.years == null ? \'Ingressos\': child.years}}" uib-tooltip="{{child.years == null ? \'Ingressos\': child.years}}" type="button" role="button" class="btn time-05 ripple btn-success btn-block plus" ng-click="vm.parent.addProductDirect(child)">Comprar <i class="fa fa-plus" aria-hidden="true"></i></button></div><div class="col-xs-6 padding-left-0" ng-if="child.esgotado"><label for="typeIngressoChild_{{child.id}}" class="span-label">{{child.years == null ? \'Ingressos\': child.years}}</label> <button title="ESGOTADO" aria-label="ESGOTADO" uib-tooltip="ESGOTADO" type="button" role="button" class="btn time-05 ripple btn-success btn-block plus" disabled="disabled">ESGOTADO <i class="fa fa-close" aria-hidden="true"></i></button></div><div class="col-xs-12"><hr role="separator"></div></div></div></div></div></div><div ng-if="vm.product.htmlMemo != vm.product.memo" class="row introducao-modal-htmlMemo"><div class="col-md-12"><div class="row"><div class="col-md-12"><h3 title="Descritivo do {{vm.product.shortName}}">Descritivo do {{vm.product.shortName}}</h3><hr role="separator"></div></div><div class="row descriptions-modal"><div class="col-md-12 description-shopping"><p ng-bind-html="vm.product.htmlMemo | toHtml"></p><div ng-include="<p></p>"></div></div></div></div></div><div class="row"><div class="col-md-12"><div ng-include=""></div></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/new_ingressos/models-pagamento/dados-user.html','<form class="form row form-compra" name="dadosComprador" id="dadosComprador" role="form"><fieldset><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.nome.$touched && dadosComprador.nome.$valid, \'has-error\': dadosComprador.nome.$touched && dadosComprador.nome.$invalid}"><label class="control-label" for="nome" accesskey="E">Nome Completo * <em class="text-danger" ng-show="dadosComprador.nome.$touched && dadosComprador.nome.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input name="nome" tabindex="1" type="text" id="nome" class="form-control" ng-model="vm.user.name" placeholder="Informe o seu nome completo" ui-mask-placeholder autocomplete="name" required><div ng-show="dadosComprador.nome.$touched && dadosComprador.nome.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.nome.$touched && dadosComprador.nome.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.email.$touched && dadosComprador.email.$valid, \'has-error\': dadosComprador.email.$touched && dadosComprador.email.$invalid}"><label class="control-label" for="email" accesskey="E">E-mail * <em class="text-danger" ng-show="dadosComprador.email.$touched && dadosComprador.email.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input name="email" tabindex="2" type="email" id="email" class="form-control" ng-model="vm.user.email" placeholder="Informe seu e-mail" ui-mask-placeholder autocomplete="email" required><div ng-show="dadosComprador.email.$touched && dadosComprador.email.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.email.$touched && dadosComprador.email.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div ng-if="false" class="col-xs-6"><div class="form-group form-loja"><label class="control-label" for="nacionalidade" accesskey="E">Nacionalidade *</label> <select class="form-control" tabindex="3" id="nacionalidade" ng-model="vm.user.customData.estrangeiro" required><option value="false" selected="selected">Brasileiro</option><option value="true">Estrangeiro</option></select></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.cpf.$touched && dadosComprador.cpf.$valid, \'has-error\': dadosComprador.cpf.$touched && dadosComprador.cpf.$invalid}"><div ng-if="vm.user.customData.estrangeiro !== \'true\'"><label class="control-label" for="cpf" accesskey="E">CPF * <em class="text-danger" ng-if="dadosComprador.cpf.$touched && dadosComprador.cpf.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{dadosComprador.cpf.$error.cpf ? \'Inv\xE1lido\' : \'Obrigat\xF3rio!\' }} </em><em class="text-success" ng-if="dadosComprador.cpf.$touched && dadosComprador.cpf.$valid"><i class="fa fa-check" aria-hidden="true"></i></em></label><div class="input-group"><input inputmode="numeric" name="cpf" tabindex="3" type="text" id="cpf" class="form-control" ng-model="vm.user.cpf" ui-mask="999.999.999-99" placeholder="Informe o seu CPF" ui-mask-placeholder ng-required="true"><div ng-show="dadosComprador.cpf.$touched && dadosComprador.cpf.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.cpf.$touched && dadosComprador.cpf.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div><div ng-if="vm.user.customData.estrangeiro === \'true\'" ng-class="{\'has-success\': dadosComprador.documento.$touched && dadosComprador.documento.$valid, \'has-error\': dadosComprador.documento.$touched && dadosComprador.documento.$invalid}"><label class="control-label" for="documento" accesskey="E">Documento * <em class="text-danger" ng-show="dadosComprador.documento.$touched && dadosComprador.documento.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input inputmode="numeric" name="documento" tabindex="3" type="text" id="documento" class="form-control" ng-model="vm.user.passporte" placeholder="Informe o seu documento" ui-mask-placeholder required><div ng-show="dadosComprador.documento.$touched && dadosComprador.documento.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.documento.$touched && dadosComprador.documento.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$valid, \'has-error\': dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$invalid}"><label class="control-label" for="cellPhone" accesskey="E">Celular * <em class="text-danger" ng-show="dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em></label><div class="input-group"><input inputmode="numeric" name="cellPhone" tabindex="4" type="text" id="cellPhone" class="form-control" ng-model="vm.user.cellPhone" ui-mask="(99) 9?9999-9999" autocomplete="tel" placeholder="Informe Celular para contato com DDD" ui-mask-placeholder ng-required="true"><div ng-show="dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.cellPhone.$touched && dadosComprador.cellPhone.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$valid, \'has-error\': dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$invalid}"><label class="control-label" for="nasc" accesskey="E">Nascimento * <em class="text-danger" ng-show="dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em> <em class="text-success" ng-show="dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$valid"><i class="fa fa-check" aria-hidden="true"></i></em></label><div class="input-group"><input inputmode="numeric" name="birthdayDate" tabindex="5" type="text" id="nasc" class="form-control" ng-model="vm.user.birth" ui-mask="99/99/9999" autocomplete="birth" placeholder="Informa a data de Nascimento" ui-mask-placeholder ng-required="true"><div ng-show="dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="dadosComprador.birthdayDate.$touched && dadosComprador.birthdayDate.$valid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div class="col-xs-6" ng-if="vm.user.customData.estrangeiro == \'false\'"><div class="form-group has-feedback form-loja" ng-class="{\'has-success\': dadosComprador.Cep.$touched && dadosComprador.Cep.$valid, \'has-error\': vm.invalidZipCode && dadosComprador.Cep.$touched && dadosComprador.Cep.$invalid}"><label class="control-label" for="cep" accesskey="E">Cep * <em class="text-danger" ng-show="dadosComprador.Cep.$touched && dadosComprador.Cep.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Obrigat\xF3rio!</em> <em class="text-danger" ng-show="vm.invalidZipCode && dadosComprador.Cep.$touched && dadosComprador.Cep.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> CEP Inv\xE1lido!</em></label><div class="input-group"><input inputmode="numeric" name="Cep" tabindex="6" type="text" id="cep" class="form-control" ng-model="vm.user.zipCode" ui-mask="99999-999" autocomplete="postal-code" placeholder="Informe o CEP" ui-mask-placeholder ng-change="vm.countNumberCEP(false)" ng-required="true"><div ng-show="vm.invalidZipCode && dadosComprador.Cep.$touched && dadosComprador.Cep.$invalid" class="form-control-feedback text-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div ng-show="!vm.invalidZipCode && !dadosComprador.Cep.$touched && !dadosComprador.Cep.$invalid" class="form-control-feedback text-success" role="alert"><i class="fa fa-check" aria-hidden="true"></i></div></div></div></div><div class="col-xs-6"><div class="form-group has-feedback form-loja form-loja-btn-promo"><label class="control-label" for="receberPromocoes" accesskey="E">Receber promo\xE7\xF5es:</label><div class="input-group" id="receberPromocoes" role="radio"><label class="btn btn-default" ng-class="{\'active\': vm.user.mailing}"><input name="sim" tabindex="7" class="active" type="radio" ng-model="vm.user.mailing" ng-value="true">Sim</label> <label class="btn btn-default" ng-class="{\'active\': vm.user.mailing==false}"><input name="nao" tabindex="7" type="radio" ng-model="vm.user.mailing" ng-value="false">N\xE3o</label></div></div></div><div class="col-xs-6"><div class="form-group form-loja"><label class="control-label">&nbsp; <em class="text-danger" ng-show="dadosComprador.$invalid"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Preencha todos os campos *</em> <em class="text-success" ng-show="dadosComprador.$valid"><i class="fa fa-check" aria-hidden="true"></i> Tudo correto *</em></label> <button title="Efetuar cadastro" aria-label="Efetuar cadastro" tabindex="8" type="button" role="button" class="btn btn-success btn-md ripple btn-shadow btn-block" ng-click="vm.savePerson();" ng-disabled="dadosComprador.$invalid">Confirmar <i class="fa fa-save" aria-hidden="true"></i></button></div></div></fieldset></form>');
$templateCache.put('app/new_ingressos/models-pagamento/resumo-compra.html','<h2>Resumo da compra</h2>');
$templateCache.put('app/new_ingressos/models-pagamento/xs-direct-payment.html','<div class="row col-direct-compra pagamento"><div class="col-md-12 body"><div id="direct-pagamento" class="row form-pagamento content"><div tabindex="-1" name="formDirectPayment" id="formDirectPayment" role="form" class="form col-md-12"><div ng-show="vm.paymentMethods" class="bandeiras"><div class="legenda-bandeiras"><h4 title="Selecione a sua bandeira">Selecione a forma de pagamento</h4><hr></div><div class="bandeira"><div class="row brands"><label class="col-xs-12"></label><div class="brands-direction"><div class="col-xs-3 col" ng-hide="key === \'gerencianet\' || key === \'recorrencia\'" ng-if="vm._ccutils.list.indexOf(key) < 0 && vm.showPaymentMethod(key)" ng-repeat="(key, value) in vm.paymentMethods"><div class="checkbox" ng-init="vm._ccutils.hasNotCC=true" ng-click="vm.selectType(key, $index)"><label><input type="checkbox" ng-model="vm.brands[$index].active"> <img title="{{key}}" class="img-responsive activeOpacity" ng-class="{activeCheck: vm.paymentMethod.type == key}" ng-src="assets/images/logos/{{key}}.png"> <span class="frase-bonus-pix" ng-if="vm.allPaymentMethods().length > 0">{{vm.findPaymentMethodByType(vm.allPaymentMethods(), key) }}</span></label></div></div><h4 class="col-xs-12" ng-if="vm.verifyCardActive()"><span ng-if="_ccutils.hasNotCC">Ou&nbsp;</span><span>Cart\xE3o de cr\xE9dito</span></h4><div class="brands-card brands-card-2" ng-if="vm.verifyCardActive()"><div><input type="checkbox" ng-model="vm.paymentTypeCard"> <span class="frase-parcelado">Parcelado <span class="frase-parcelas" ng-if="vm.allPaymentMethods().length > 0">{{vm.findPaymentMethodByType(vm.allPaymentMethods(), \'visa\')}}</span></span></div><div class="row"><div class="col-xs-2 col" ng-hide="key === \'gerencianet\'" ng-if="vm._ccutils.list.indexOf(key)>=0" ng-repeat="(key, value) in vm.paymentMethods"><div class="checkbox"><label ng-click="vm.bloqueiaClickNasBandeiras(key) && vm.selectType(key, $index);"><img title="{{key}}" class="img-responsive activeOpacity" ng-class="{activeCheck: vm.paymentMethod.type == key}" ng-src="assets/images/logos/{{key}}.png"></label></div></div></div><div class="brands-card recorrencia-pad" ng-if="vm.paymentMethods.recorrencia"><div><input type="checkbox" ng-model="vm.paymentTypeCard_r"> <span class="frase-parcelado">Recorr\xEAncia <span class="frase-parcelas">{{\' em ate \'+ vm.paymentMethods.recorrencia + \'x\'}}</span></span></div><div class="row"><div class="col-xs-2 col" ng-hide="key === \'gerencianet\'" ng-if="vm._ccutils.list_recurring.indexOf(key+\'_r\')>=0" ng-repeat="(key, value) in vm.paymentMethods"><div class="checkbox"><label ng-click="vm.bloqueiaClickNasBandeiras(key) && vm.selectType(key+\'_r\', $index);"><img title="{{key+\'_r\'}}" class="img-responsive activeOpacity" ng-class="{activeCheck: vm.paymentMethod.type == key+\'_r\'}" ng-src="assets/images/logos/{{key}}.png"></label></div></div></div></div></div></div></div></div></div><div ng-if="vm.paymentMethod.type === \'remarcacao\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>Nenhum valor ser\xE1 cobrado pela remarca\xE7\xE3o.</div></div><div ng-show="vm.paymentMethod.type === \'pagseguro\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>Efetue o pagamento com total seguran\xE7a com o PagSeguro. Na pr\xF3xima tela voc\xEA tera o link para pagamento diretamente no ambiente do Pag Seguro.Voucher enviado ap\xF3s 30 minutos da conclus\xE3o do pagamento.</div></div><div ng-show="vm.paymentMethod.type === \'boleto\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>O voucher ser\xE1 gerado apenas ap\xF3s o pagamento do boleto.</div></div><div ng-show="vm.paymentMethod.type === \'gerencianetBoleto\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>O voucher ser\xE1 gerado apenas ap\xF3s o pagamento do boleto. Para garantir sua compra o boleto deve ser pago at\xE9 a data de vencimento.</div></div><div ng-show="vm.paymentMethod.type === \'debito\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>Apenas Cart\xF5es Visa Electron e Mastercard Maestro s\xE3o aceitos.</div></div><div class="Paypal" ng-show="vm.paymentMethod.type === \'PayPal\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>Efetue o pagamento com total seguran\xE7a com o PayPal.</div></div><div class="Parque" ng-show="vm.paymentMethod.type === \'Parque\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>Efetue o pagamento diretamente na retirada dos produtos.</div></div><div class="Deposito" ng-show="vm.paymentMethod.type === \'deposito\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>A compra ser\xE1 conclu\xEDda apenas ap\xF3s o a verifica\xE7\xE3o do d\xE9posito.<br>Bancos Aceitos: NENHUM</div></div><div class="Pix" ng-show="vm.paymentMethod.type === \'pix\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>Ser\xE1 gerado um QR Code para pagamento na pr\xF3xima tela</div></div><div class="PicPay" ng-show="vm.paymentMethod.type === \'picpay\'"><div>Valor: <strong>{{ vm.totalGeral() / 100 | currency:\'R$ \' }}</strong></div><div>Ser\xE1 gerado um QR Code para pagamento na pr\xF3xima tela</div></div><div class="campos-pagamento"><div ng-hide="vm.paymentMethod.type === null || vm.paymentMethod.type === \'pix\' || vm.paymentMethod.type === \'picpay\' || vm.paymentMethod.type === \'deposito\' || vm.paymentMethod.type === \'pagseguro\' || vm.paymentMethod.type == \'boleto\' || vm.paymentMethod.type == \'gerencianetBoleto\' || vm.paymentMethod.type === \'PayPal\' || vm.paymentMethod.type === \'Parque\' || vm.paymentMethod.type === \'remarcacao\' || vm.paymentMethod.type === \'mercadopagotransparente\'"><div ng-if="vm.showPaymentCardAddress" ng-include="\'app/components/xsPayment/payment_card_address.html\'"></div><div ng-if="false" class="form-group credit-card"><label for="numCartao">N\xFAmero do Cart\xE3o <img uib-tooltip="Informe o n\xFAmero do seu cart\xE3o de cr\xE9dito" title="Numero do Cart\xE3o de Cr\xE9dito" class="img-responsive" src="assets/images/icons/credit-cart-number.png"></label> <input type="text" class="form-control input-pag" id="numCartao" ng-model="vm.paymentMethod.cardNumber" ng-keyup="vm.verificaBandeiraCartao()" ng-paste="vm.verificaBandeiraCartao()" ui-mask="9999 9999 9999 99?9?9? ?9?9?9" placeholder="N\xFAmero do cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paymentMethod.type == null" ng-required="true" inputmode="numeric" ng-blur="vm.verificaBandeiraCartao()"></div><div ng-hide="vm.paymentMethod.type === \'pagseguro\' || vm.paymentMethod.type === \'boleto\' || vm.paymentMethod.type === \'gerencianetBoleto\' || vm.paymentMethod.type === \'Parque\'"><div class="form-group credit-card"><label for="numCartao">N\xFAmero do Cart\xE3o</label><div class="input-group"><input type="text" class="form-control input-pag" id="numCartao" ng-model="vm.paymentMethod.cardNumber" ng-keyup="vm.verificaBandeiraCartao()" ng-blur="vm.verificaBandeiraCartao()" ui-mask="9999 9999 9999 99?9?9? ?9?9?9" placeholder="N\xFAmero do cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paymentMethod.type == null" ng-required="true" inputmode="numeric" ng-paste="vm.verificaBandeiraCartao()"><div class="form-control-feedback" role="alert"><img uib-tooltip="Informe o n\xFAmero do seu cart\xE3o de cr\xE9dito" title="Numero do Cart\xE3o de Cr\xE9dito" class="img-responsive" src="assets/images/icons/credit-cart-number.png"></div></div><div ng-show="vm.paymentMethod.type == \'gerencianetVisa\' || vm.paymentMethod.type == \'gerencianetMaster\'"><label for="gerencianetInstallmentText">Quantidade de Parcelas</label> <select class="form-control" id="gerencianetInstallmentText" ng-model="vm.paymentMethod.length" ng-options="vm.gerencianetInstallmentText(i) group by \'Selecione\' for i in vm.gerencianetInstallments" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4">--></select></div></div><div class="row info-card"><div class="form-group col-xs-6 credit-card"><label for="codeCartao">C\xF3digo de Seguran\xE7a</label><div class="input-group"><input type="text" class="form-control input-pag" id="codeCartao" ng-model="vm.paymentMethod.code" placeholder="C\xF3digo na parte de tr\xE1s do cart\xE3o. Ex.: 000" ui-mask="999?9?9" ui-mask-placeholder ui-mask-placeholder-char="space" ng-disabled="vm.paymentMethod.cardNumber == null || vm.paymentMethod.cardNumber.length < 12" ng-required="true" inputmode="numeric" ng-blur="vm.verificaBandeiraCartao()"><div class="form-control-feedback" role="alert"><img uib-tooltip="Informe o C\xF3digo na parte de tr\xE1s do cart\xE3o. Ex.: 000" title="C\xF3digo de Seguran\xE7a do Cart\xE3o" class="img-responsive" src="assets/images/icons/credit-cart-code.png"></div></div></div><div class="form-group col-xs-6 credit-card"><label for="valCartao">Validade do Cart\xE3o</label><div class="input-group"><input type="text" class="form-control input-pag" id="valCartao" ng-model="vm.paymentMethod.goodThru" ui-mask="99/2099" ng-disabled="vm.paymentMethod.code == null || vm.paymentMethod.code.length < 3" ng-required="true"><div class="form-control-feedback" role="alert"><img uib-tooltip="Informe da data de valdiade do cart\xE3o: mes e ano" title="Validade do Cart\xE3o" class="img-responsive" src="assets/images/icons/credit-cart-valid.png"></div></div></div></div><div class="form-group"><div class="row"><div class="col-xs-6"><div ng-hide="vm.paymentMethod.type == \'pagsegurotransparente\' || vm.paymentMethod.type == \'gerencianetVisa\' || vm.paymentMethod.type == \'gerencianetMaster\'"><label for="parcelasCartao">Quantidade de Parcelas</label> <select class="form-control" id="parcelasCartao" ng-model="vm.paymentMethod.length" ng-options="vm.parcelas(i) for i in vm.financialLength | filter:vm.showParcels" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4"></select></div><div ng-if="vm.paymentMethod.type == \'pagsegurotransparente\'"><label for="installmentText">Quantidade de Parcelas</label> <select class="form-control" id="installmentText" ng-model="vm.paymentMethod.length" ng-options="vm.installmentText(i) group by \'Selecione\' for i in vm.pagseguroInstallments" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4"></select></div><div ng-show="vm.paymentMethod.type == \'gerencianetVisa\' || vm.paymentMethod.type == \'gerencianetMaster\'"><label for="gerencianetInstallmentText">Quantidade de Parcelas</label> <select class="form-control" id="gerencianetInstallmentText" ng-model="vm.paymentMethod.length" ng-options="vm.gerencianetInstallmentText(i) group by \'Selecione\' for i in vm.gerencianetInstallments" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4"></select></div></div><div class="col-xs-6 valores-compra"><div ng-hide="vm.paymentMethod.type == \'pagsegurotransparente\' || vm.gerencianetTotalValue > 0"><h4 title="Valor da compra" class="animated fadeIn">Total: {{ vm.totalGeral() / 100 | currency:"R$ "}}</h4></div><div ng-show="vm.paymentMethod.type == \'pagsegurotransparente\'"><h4 title="Valor da compra" class="animated fadeIn">Total: {{ vm.pagseguroTotalValue | currency:"R$ "}} <span ng-show="vm.installmentQuantity > 1">(Com Juros)</span></h4></div><div ng-show="vm.gerencianetTotalValue > 0"><h4 title="Valor da compra" class="animated fadeIn">Total: {{ vm.gerencianetTotalValue / 100 | currency:"R$ "}} <span ng-show="vm.installmentQuantity > 1">(Com Juros)</span></h4></div></div></div></div></div></div><div ng-if="vm.paymentMethod.type === \'mercadopagotransparente\'" ng-include src=""></div></div><div class="row"><div class="col-md-12"><div class="validacao-compra"><div class="row"><div class="form-group col-xs-6 padding-right-5 seguranca"><h5 title="Compra Segura"><i class="fa fa-lock" aria-hidden="true"></i> Compra Segura</h5><div class="checkbox"><label><input type="checkbox" ng-model="vm.terms"> Li e aceito os termos e politicas.</label></div><a title="Ver termos de uso" class="btn btn-default btn-min ripple btn-termos" target="_blank" rel="nofollow noopener noreferrer" href="docs/termosdecompra.html">Visualizar termos <i class="fa fa-eye" aria-hidden="true"></i></a> <a title="Ver termos de uso" class="btn btn-default btn-min ripple btn-termos" target="_blank" rel="nofollow noopener noreferrer" href="https://novaxs.com.br/docs/politica_de_privacidade.pdf">Visualizar politicas <i class="fa fa-eye" aria-hidden="true"></i></a></div><div class="form-group col-xs-6 padding-left-5 central-atendimento"><h5 title="Central de Relacionamento com o Cliente">Central de Relacionamento com o Cliente</h5><h6 title="Telefone para contato: " ng-hide="\'\' == \'\'"><i class="fa fa-phone" aria-hidden="true"></i></h6><h6 title="Telefone para contato: (73) 3268-8500" ng-hide="\'(73) 3268-8500\' == \'\'"><i class="fa fa-mobile" aria-hidden="true"></i> (73) 3268-8500</h6></div></div><div><h6 title="E-mail para contato: info@hoteisquintadosol.com" ng-hide="\'info@hoteisquintadosol.com\' == \'\'"><i class="fa fa-envelope" aria-hidden="true"></i> info@hoteisquintadosol.com</h6></div></div></div></div><div class="form-group final"><span class="span error-message" ng-show="!vm.isProcessing && vm.paymentMethods && vm.isInvalidCard()"><i class="fa fa-warning" aria-hidden="true"></i>&nbsp;{{vm.isInvalidCard()}}&nbsp;<i class="fa fa-warning"></i></span> <span class="span wait-message" ng-show="vm.isProcessing && vm.paymentMethods"><i class="fa fa-warning"></i>&nbsp;Por Favor Aguarde...&nbsp;<i class="fa fa-warning"></i></span><button title="Efetuar pagamento" aria-label="Efetuar pagamento" type="button" role="button" class="btn btn-success btn-md ripple btn-shadow btn-block" ng-click="vm.purchaseMercadoPago()" ng-disabled="vm.isInvalidCard()" ng-if="vm.paymentMethod.type === \'mercadopagotransparente\'">Finalizar Compra <i class="fa fa-check" aria-hidden="true"></i></button> <button title="Efetuar pagamento" aria-label="Efetuar pagamento" type="button" role="button" class="btn btn-success btn-md ripple btn-shadow btn-block" ng-click="vm.purchase()" ng-disabled="vm.isInvalidCard()" ng-if="vm.paymentMethod.type !== \'mercadopagotransparente\'">Finalizar Compra <i class="fa fa-check" aria-hidden="true"></i></button></div></div></div></div></div>');
$templateCache.put('app/new_ingressos/models-pagamento/xs-payment.html','<div class="col-direct-compra pagamento"><i class="fa fa-chevron-right indicador-pass hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" ng-click="vm.directScroll(\'direct-_pagamento\')"></i><div class="direct-formas-pagamento body"><div class="row"><div class="col-md-12"><div class="direct-breadcrumb"><div class="hexagon" ng-click="vm.directScroll(\'direct-_pagamento\')"><i class="fa fa-credit-card"></i></div><div class="info-breadcrumb"><h3 title="Dados de pagamento">Dados de<br>pagamento</h3></div></div></div></div><div id="direct-_pagamento" class="row form-pagamento content"><form class="form col-md-12 padding-md-left-0"><div class="legenda-bandeiras"><label>Selecione sua bandeira</label><hr></div><div class="form-group bandeiras-cartao"><div class="form-loja" ng-repeat="(key, value) in vm.paymentMethods"><div class="checkbox"><label ng-click="vm.selectType(key, $index)"><input type="checkbox" ng-model="vm.brands[$index].active"> <img title="{{key}}" alt="{{key}}" class="img-responsive activeOpacity" ng-class="{activeCheck: vm.paymentMethod.type == key}" ng-src="assets/images/logos/{{key}}.png" alt=""></label></div></div></div><div class="form-group form-loja credit-card"><label for="numCartao">N\xFAmero do Cart\xE3o <img uib-tooltip="Informe o n\xFAmero do seu cart\xE3o de cr\xE9dito" title="Numero do Cart\xE3o de Cr\xE9dito" alt="Numero do Cart\xE3o de Cr\xE9dito" class="img-responsive" src="assets/images/icons/credit-cart-number.png"></label> <input type="text" class="form-control input-pag" id="numCartao" ng-model="vm.paymentMethod.cardNumber" ng-keyup="vm.verificaBandeiraCartao()" ui-mask="9999 9999 9999 99?9?9? ?9?9?9" placeholder="N\xFAmero do cart\xE3o" ui-mask-placeholder ui-mask-placeholder-char="space" ng-required="true" ng-disabled="vm.paymentMethod.type == null"></div><div class="row info-card"><div class="form-group col-md-6 padding-md-right-0 form-loja credit-card"><label for="codeCartao">C\xF3digo de Seguran\xE7a do Cart\xE3o <img uib-tooltip="Informe o C\xF3digo na parte de tr\xE1s do cart\xE3o. Ex.: 000" title="C\xF3digo de Seguran\xE7a do Cart\xE3o" alt="C\xF3digo de Seguran\xE7a do Cart\xE3o" class="img-responsive" src="assets/images/icons/credit-cart-code.png"></label> <input type="text" class="form-control input-pag" id="codeCartao" ng-model="vm.paymentMethod.code" placeholder="C\xF3digo na parte de tr\xE1s do cart\xE3o. Ex.: 000" ui-mask="999?9?9" ui-mask-placeholder ui-mask-placeholder-char="space" ng-required="true" ng-disabled="vm.paymentMethod.cardNumber == null || vm.paymentMethod.cardNumber.length < 12"></div><div class="form-group col-md-6 form-loja credit-card"><label for="valCartao">Validade do Cart\xE3o <img uib-tooltip="Informe da data de valdiade do cart\xE3o: mes e ano" title="Validade do Cart\xE3o" alt="Validade do Cart\xE3o" class="img-responsive" src="assets/images/icons/credit-cart-valid.png"></label> <input type="text" class="form-control input-pag" id="valCartao" ng-model="vm.paymentMethod.goodThru" ui-mask="99/2099" ng-required="true" ng-disabled="vm.paymentMethod.code == null || vm.paymentMethod.code.length < 3"></div></div><div class="form-group form-loja"><div ng-hide="vm.paymentMethod.type == \'pagsegurotransparente\' || vm.paymentMethod.type == \'gerencianetVisa\' || vm.paymentMethod.type == \'gerencianetMaster\'"><label for="parcelasCartao">Quantidade de Parcelas</label> <select class="form-control" id="parcelasCartao" ng-model="vm.paymentMethod.length" ng-options="vm.parcelas(i) group by \'Selecione\' for i in vm.financialLength" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4"></select></div><div ng-show="vm.paymentMethod.type == \'pagsegurotransparente\'"><label for="installmentText">Quantidade de Parcelas y</label> <select class="form-control" id="installmentText" ng-model="vm.paymentMethod.length" ng-options="vm.installmentText(i) group by \'Selecione\' for i in vm.pagseguroInstallments" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4"></select></div><div ng-show="vm.paymentMethod.type == \'gerencianetVisa\' || vm.paymentMethod.type == \'gerencianetMaster\'"><label for="gerencianetInstallmentText">Quantidade de Parcelas z</label> <select class="form-control" id="gerencianetInstallmentText" ng-model="vm.paymentMethod.length" ng-options="vm.gerencianetInstallmentText(i) group by \'Selecione\' for i in vm.gerencianetInstallments" ng-disabled="vm.paymentMethod.goodThru == null || vm.paymentMethod.goodThru.length < 4"></select></div></div><div class="row valores-compra"><div class="col-md-12"><div ng-hide="vm.paymentMethod.type == \'pagsegurotransparente\' || vm.gerencianetTotalValue > 0"><h4 title="Valor da compra" class="animated fadeIn">Total: {{ vm.totalGeral() / 100 | currency:"R$ "}}</h4></div><div ng-show="vm.paymentMethod.type == \'pagsegurotransparente\'"><h4 title="Valor da compra" class="animated fadeIn">Total: {{ vm.pagseguroTotalValue | currency:"R$ "}} <span ng-show="vm.installmentQuantity > 1">(Com Juros)</span></h4></div><div ng-show="vm.gerencianetTotalValue > 0"><h4 title="Valor da compra" class="animated fadeIn">Total: {{ vm.gerencianetTotalValue / 100 | currency:"R$ "}} <span ng-show="vm.installmentQuantity > 1">(Com Juros)</span></h4></div><hr></div></div><div class="row"><div class="col-md-12"><div class="validacao-compra"><div class="row"><div class="form-group col-xs-6 padding-right-5 seguranca"><h5 title="Compra Segura">Compra segura</h5><div class="checkbox"><label><input type="checkbox" ng-model="vm.terms"> Li e aceito os termos e pol\xEDticas de compras.</label></div><a title="Ver termos de uso" class="btn btn-default ripple btn-termos btn-link" href="docs/termosdecompra.html" target="_blank" rel="nofollow noopener noreferrer">Visualizar <i class="fa fa-info" aria-hidden="true"></i></a> <a title="Ver termos de uso" class="btn btn-default btn-min ripple btn-termos" target="_blank" rel="nofollow noopener noreferrer" href="https://novaxs.com.br/docs/politica_de_privacidade.pdf">Visualizar politicas <i class="fa fa-eye" aria-hidden="true"></i></a></div><div class="form-group col-xs-6 padding-left-5 central-atendimento"><h5 title="Central de Relacionamento com o Cliente">Central de Relacionamento</h5><h5 title="Telefone para contato: " class="phones"><i class="fa fa-phone" aria-hidden="true"></i></h5><h5 title="Telefone para contato: (73) 3268-8500" class="phones" ng-hide="\'(73) 3268-8500\' == \'\'"><i class="fa fa-mobile" aria-hidden="true"></i> (73) 3268-8500</h5></div></div></div></div></div><div class="form-group"><button title="Efetuar pagamento" aria-label="Efetuar pagamento" type="button" role="button" class="btn btn-success btn-md ripple btn-shadow btn-block" ng-disabled="vm.isInvalidCard()" ng-click="vm.purchase()">Total: {{ vm.gerencianetTotalValue / 100 | currency:"R$ "}} Finalizar Compra <i class="fa fa-check" aria-hidden="true"></i></button> <span class="span error-message" ng-show="!vm.isProcessing && vm.isInvalidCard()"><i class="fa fa-warning"></i>&nbsp;{{vm.isInvalidCard()}}&nbsp;<i class="fa fa-warning"></i></span> <span class="span wait-message" ng-show="vm.isProcessing"><i class="fa fa-warning"></i>&nbsp;Por Favor Aguarde...&nbsp;<i class="fa fa-warning"></i></span></div></form></div></div></div>');
$templateCache.put('app/components/xsBarraFooter/modais/modalCarrinho.html','<div><div class="modal-header"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Carrinho" class="modal-title">Carrinho <i class="fa fa-shopping-cart" aria-hidden="true"></i></h3></div><div class="col-xs-2"><button title="Fechar Carrinho" type="button" ng-click="vm.close()" class="btn ripple btn-danger radius-0 hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><i class="fa fa-close" aria-hidden="true"></i></button></div></div><div class="modal-body" ng-include="\'quinta_do_sol/template/carrinho.html\'"></div><div class="modal-footer hidden"></div></div>');
$templateCache.put('app/components/xsBarraFooter/modais/openModalCountAdultosCriancas.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 class="modal-title" align="center">Adultos e crian\xE7as <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><h3 class="modal-title" align="center">{{::vm.noites}} Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{::vm.dates.date| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{::vm.dates.endDate| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button title="Data" class="btn time-05 radius-0 btn-danger" type="button" ng-click="vm.dismiss()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><section class="row b2c-checkin"><div class="col-md-3 col-xs-6 padding-xs-right-5"><label class="label">Quantidade de Adultos</label> <select class="form-group form-control input-group" id="adultos" ng-model="vm.adt" ng-options="i as i + \' Adultos\' for i in [1,2,3,4,5]"></select></div><div class="col-md-3 col-xs-6 padding-xs-left-5 input-chds"><label class="label">Quantidade de Crian\xE7as</label> <select class="form-group form-control input-group" id="criancas" ng-model="vm.chd" ng-options="i as i + \' Crian\xE7a de  de 2 a 12 anos\' for i in [0,1,2,3,4]"></select></div><div class="col-md-3 col-xs-6 padding-xs-left-5 input-colos"><label class="label">Quantidade de Colos</label> <select class="form-group form-control input-group" id="criancas" ng-model="vm.colo" ng-options="i as i + \' Colo de de 0 a 2 anos\' for i in [0,1,2,3,4]"></select></div><div class="col-md-3 col-xs-12 form-group"><label class="label hidden-xs">&nbsp;</label> <button title="Pesquisar disponibilidade" type="button" class="btn time-05 radius-0 btn-success btn-block" id="search" ng-click="vm.search()">{{vm.searchButtonText ? vm.searchButtonText : \'PESQUISAR\'}} <i class="fa fa-search"></i></button></div></section></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5></h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/components/xsBarraFooter/modais/openModalCountQuartos.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 class="modal-title" align="center">Quantidade de Quartos <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><h3 class="modal-title" align="center">{{::vm.noites}} Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{::vm.dates.date| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{::vm.dates.endDate| date:\'dd/MM/yyyy\'}}</span><br><label>Check-out</label></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button title="Data" class="btn time-05 radius-0 btn-danger" type="button" ng-click="vm.dismiss()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><section class="row b2c-checkin"><div class="col-md-6 col-xs-6 padding-xs-right-5"><label class="label">Quantidade de Quartos</label> <select class="form-group form-control input-group" id="quartosModal" ng-model="vm.quartosModal"><option value="">Quartos</option><option value="1">1 Quarto</option><option value="2">2 Quartos</option><option value="3">3 Quartos</option><option value="4">4 Quartos</option><option value="5">5 Quartos</option><option value="6">6 Quartos</option></select></div><div class="col-md-6 col-xs-6 padding-xs-left-5 form-group"><button title="Pesquisar disponibilidade" class="btn time-05 radius-0 btn-success btn-block" id="searchModalQuartos" ng-click="vm.search()" type="button">PESQUISAR <i class="fa fa-search"></i></button></div></section><section class="row b2c-checkin-apto-extra" ng-show="vm.quartosModal > 1"><div class="col-md-12"><h3 title="Informe a quantidade de h\xF3spedes para os apartamentos" class="text-center">Informe a quantidade de h\xF3spedes para os apartamentos</h3><hr></div><div class="col-md-4 b2c-row-apto-extra" ng-repeat="apto in vm.quartosModal"><div class="row box"><div class="col-md-12"><h3 title="{{$index + 1}}\xBA Quarto">{{$index + 1}}\xBA Quarto <i class="fa fa-bed" aria-hidden="true"></i></h3></div><div class="col-md-6 col-xs-6 padding-xs-right-5"><label class="label">Quantidade de Adulto</label> <select class="form-group form-control input-group" id="adultos" ng-model="vm.adt"><option value="">Adultos</option><option value="1">1 Adulto</option><option value="2">2 Adultos</option><option value="3">3 Adultos</option><option value="4">4 Adultos</option><option value="5">5 Adultos</option><option value="6">6 Adultos</option><option value="7">7 Adultos</option><option value="8">8 Adultos</option></select></div><div class="col-md-6 col-xs-6 padding-xs-left-5"><label class="label">Quantidade de Crian\xE7as</label> <select class="form-group form-control input-group" id="criancas" ng-model="apto.chd"><option value="">Crian\xE7as de 2 a 12 anos</option><option value="1">1 Crian\xE7a de 2 a 12 anos</option><option value="2">2 Crian\xE7as de 2 a 12 anos</option><option value="3">3 Crian\xE7as de 2 a 12 anos</option><option value="4">4 Crian\xE7as de 2 a 12 anos</option><option value="5">5 Crian\xE7as de 2 a 12 anos</option><option value="6">6 Crian\xE7as de 2 a 12 anos</option></select></div></div></div></section></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/components/xsBarraFooter/modais/openModalDataHospedagem.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 class="modal-title" align="center">Data da Hospedagem <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><h3 class="modal-title" align="center">{{::vm.noites}} Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{::vm.dates.date| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{::vm.dates.endDate| date:\'dd/MM/yyyy\'}}</span><br><label>Check-out</label></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button title="Data" class="btn time-05 radius-0 btn-danger" ng-click="vm.dismiss()" type="button"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><section class="row b2c-checkin"><div class="col-md-4 col-xs-6 padding-xs-right-5"><label class="label">Check-in</label><div class="form-group input-group"><input type="text" class="form-control" id="checkinModal" ng-change="vm.handleEndDate()" ng-model="vm.dates.date" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.today" is-open="vm.activeDate" ng-click="vm.handleDate()"><span ng-click="vm.handleDate()" class="input-group-addon"><i class="fa fa-calendar-check-o"></i></span></div></div><div class="col-md-4 col-xs-6 padding-xs-left-5"><label class="label">Check-out</label><div class="form-group input-group"><input type="text" class="form-control" id="checkoutModal" ng-model="vm.dates.endDate" uib-datepicker-popup="dd/MM/yyyy" min-date="vm.nextDay" is-open="vm.activeEndDate" ng-click="vm.handleEndDate()"><span ng-click="vm.handleDate()" class="input-group-addon"><i class="fa fa-calendar-times-o"></i></span></div></div><div class="col-md-4 form-group"><label class="label">&nbsp;</label> <button title="PESQUISAR" class="btn time-05 radius-0 btn-success btn-block" id="search" ng-click="vm.search()" type="button">PESQUISAR <i class="fa fa-search"></i></button></div></section></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/components/xsBarraFooter/modais/openModalEditarDadosHospedagem.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 class="modal-title" align="center">Nova pesquisa <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><h3 class="modal-title" align="center">{{::vm.noites}} Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{::vm.dates.date| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{::vm.dates.endDate| date:\'dd/MM/yyyy\'}}</span><br><label>Check-out</label></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button title="Data" class="btn time-05 radius-0 btn-danger" type="button" ng-click="vm.dismiss()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div id="navbar3"></div><xs-search-bar-holder xs-id-holder="navbar3" xs-search="vm.search2" template-url="quinta_do_sol/template/xsSearchBar.html"></xs-search-bar-holder></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/components/xsBarraFooter/modais/openModalNomeHotel.html','<div class="b2c-modal b2c-modal-escolha-hotel b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Hospedagem" class="modal-title" align="center">Hospedagem <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><h3 title="{{::vm.noites}} Di\xE1rias" class="modal-title" align="center">{{::vm.noites}} Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{::vm.dates.date| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{::vm.dates.endDate| date:\'dd/MM/yyyy\'}}</span><br><label>Check-out</label></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button title="Data" class="btn time-05 radius-0 btn-danger" type="button" ng-click="vm.dismiss()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="cart-list"><div class="row b2c-list-box b2c-row-apto"><aside class="col-md-4 b2c-img-box" style="background-image: url(\'assets/images/atrium-flat-service_1.jpg\')"></aside><section class="col-md-8 b2c-caracteristicas"><div class="row b2c-section-header"><div class="col-md-12"><div class="b2c-page-header"><h3 title="Nome do Hotel Exemplo">Nome do Hotel Exemplo</h3></div></div></div><div class="row b2c-section-description"><div class="col-md-12"><p><i class="fa fa-bomb" aria-hidden="true"></i> At\xE9 8 pessoas</p><p><i class="fa fa-car" aria-hidden="true"></i> 2 vagas</p></div></div><div class="row b2c-list-box-icons"><div class="col-md-12"><h5 title="Detalhes do Hotel">Detalhes do Hotel</h5><hr><div class="icones"><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/laundry-machine.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/super-luxo-stars.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/wifi.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/pool.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/restaurant.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/academia.png"></div></div></div></div></section></div><div class="b2c-modal-confirme-footer"><div class="row box"><aside class="hidden-xs hidden-sm col-md-5"><figure class="row"><img title="Confirmar compra" alt="Confirmar compra" class="img-responsive" src="assets/images/layout/img-modal-confirme-compra.jpg"></figure></aside><section class="col-md-7"><h2 title="..." class="clear-fix">Nome do Hotel Exemplo</h2><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>01/03/2017</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>01/05/2017</span><br><label>Check-out</label></div></div><br><div class="row"><div class="col-md-6 form-group"><button title="Escolher outro hotel" class="btn time-05 radius-0 btn-warning btn-reservar bnt-lg btn-block" type="button"><i class="fa fa-arrow-left" aria-hidden="true"></i>Escolher outro hotel</button></div><div class="col-md-6 form-group"><button title="Continuar reservar" class="btn time-05 radius-0 btn-success btn-reservar bnt-lg btn-block" type="button" ng-click="vm.dismiss()">Continuar reservar <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div></div></section></div></div><div class="b2c-modal-confirme-footer"><div class="row box"><aside class="col-md-5 hidden-xs hidden-sm"><figure class="row"><img title="Confirmar Compra" alt="Confirmar Compra" class="img-responsive" src="assets/images/layout/img-modal-retornar-aos-hoteis.jpg"></figure></aside><section class="col-md-7"><h2 title="..." class="clear-fix text-danger">Voc\xEA a\xEDnda n\xE3o escolheu o hotel</h2><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>01/03/2017</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>01/05/2017</span><br><label>Check-out</label></div></div><button title="Escolher hotel agora" class="btn time-05 radius-0 btn-success btn-reservar bnt-lg" type="button" ng-click="vm.dismiss()">Escolher hotel agora <i class="fa fa-arrow-right" aria-hidden="true"></i></button></section></div></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/components/xsRegister/modals/cep_confirm.html','<div class="modal-header dialog-header-confirm"><h4 title="{{vm.title}}" class="modal-title">{{vm.title}}<i class="fa fa-exclamation-triangle fa-invert"></i></h4></div><div class="row"><div class="col-md-12 text-center"><p class="text-center" ng-bind-html="vm.message"></p></div></div><div class="modal-footer"><div class="row"><div class="col-xs-9 col-md-9"><a title="N\xE3o" class="btn btn-default pull-right" ng-click="vm.dismiss()">N\xE3o</a></div><div class="col-xs-3 col-md-3"><a title="Sim" class="btn btn-success" ng-click="vm.close()">Sim</a></div></div></div>');
$templateCache.put('app/hospedagem/carrinho/modais/openModalSolicitacaoReserva.html','<div class="b2c-modal b2c-modal-solicitacao-reserva"><div class="modal-header"><div class="row"><div class="col-xs-11"><h3 title="Entraremos em contato com voc\xEA em at\xE9 24 h" class="modal-title" align="center"><strong>Entraremos em contato com voc\xEA em at\xE9 24 h</strong></h3></div><div class="col-xs-1"><button class="btn time-05 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="cart-list"><div class="row"><div class="col-md-6 dados-reserva"><div class="row b2c-paymentReserva-header hidden-xs hidden-sm"><div class="col-md-12"><div class="page-header"><h2 title="Dados da Reserva">Dados da Reserva <i class="fa fa-suitcase" aria-hidden="true"></i></h2></div></div></div><div class="row b2c-carrinho-header"><div class="col-md-12"><label title="{{vm.item.days}} {{vm.item.days > 1 ? \'Di\xE1rias\' : \'Di\xE1ria\'}}">{{vm.item.days}} {{vm.item.days > 1 ?\'Di\xE1rias\' : \'Di\xE1ria\'}}</label><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{vm.item.checkin| date:\'dd/MM/yyyy\'}}</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{vm.item.checkout| date:\'dd/MM/yyyy\'}}</span><br><label>Check-out</label></div></div><label>Op\xE7\xE3o Escolhida</label><h3 title="{{vm.item.hotelName}}">{{vm.item.hotelName}}</h3></div></div><div class="row b2c-itens-carrinho"><div ng-if="apto.value > 0" class="col-md-12 itens" ng-repeat="apto in vm.item.apts"><h3 title="{{$index + 1}}\xBA Apartamento">{{$index + 1}}\xBA Apartamento</h3><h5 ng-show="apto.service" title="Nome do Apartamento: {{apto.service}}"><i class="fa fa-check" aria-hidden="true"></i> {{apto.service}}</h5><h5 ng-show="apto.mealType" title="Tipo de Pens\xE3o: {{apto.mealType}}"><i class="fa fa-check" aria-hidden="true"></i> {{apto.mealType}}</h5><h5 title="Quantidade de Hospedes"><i class="fa fa-check" aria-hidden="true"></i> <span ng-if="apto._adultos > 0">Adultos: {{apto._adultos}}</span> <span ng-if="apto._chd > 0">, Crian\xE7as: {{apto._chd}}</span> <span ng-if="apto._colo > 0">, Colos: {{apto._colo}}</span></h5><h5 ng-show="apto.productsValue > 0" title="Valor do Apartamento: {{(apto.value - apto.productsValue) / 100| currency: \'R$ \'}}" class="value">Valor do Apartamento: <strong>{{(apto.value - apto.productsValue) / 100| currency: \'R$ \'}}</strong></h5><h5 ng-show="apto.productsValue > 0" title="Valor dos Ingressos: {{apto.productsValue / 100| currency: \'R$ \'}}">Valor dos ingressos: <strong>{{apto.productsValue / 100| currency: \'R$ \'}}</strong></h5><h4 title="Total do Apartamento: {{apto.value / 100| currency: \'R$ \'}}" class="value">Valor: <strong>{{apto.value / 100| currency: \'R$ \'}}</strong></h4></div></div><div ng-show="vm.item.totalPagamento > 0" class="row b2c-carrinho-footer"><div class="col-md-12"><h2 title="Valor Total: {{vm.item.totalPagamento| currency: \'R$ \'}}">Total: <strong>{{vm.item.totalPagamento| currency: \'R$ \'}}</strong></h2></div></div></div><div class="col-md-6 form-pre-reserva"><form tabindex="-1" name="formModalSolicitacaoReser" role="form" id="formModalSolicitacaoReser" class="form"><div class="form-group"><label class="control-label">Nome completo do Comprador</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-user"></i></span> <input tabindex="1" type="text" class="form-control" ng-model="vm.user.name" placeholder="Informe seu nome Completo" required></div></div><div class="form-group"><label class="control-label">E-mail</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-envelope-o"></i></span> <input tabindex="2" type="email" class="form-control" name="Email" placeholder="Informe seu E-mail" ng-model="vm.user.email" required></div></div><div class="form-group"><label class="control-label">Telefone</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-mobile-phone"></i></span> <input tabindex="3" type="text" class="form-control" name="Celular" ui-mask="(99) 99999-9999" placeholder="Celular" ui-mask-placeholder ng-model="vm.user.cellPhone" required></div></div><div class="form-group"><label>Entraremos em contato com voc\xEA em at\xE9 24 h</label> <button tabindex="4" title="Solicitar Reserva" type="submit" class="btn btn-block btn-success btn-lg" ng-click="vm.criarSolicitacaoReserva(vm.user)" ng-disabled="vm.user.name == null || vm.user.email == null || vm.user.cellPhone == null || vm.checkCarregandoSolicitacao"><em ng-show="!vm.checkCarregandoSolicitacao">Solicitar Reserva <i class="fa fa-suitcase"></i></em> <em ng-show="vm.checkCarregandoSolicitacao">Solicitando... <i class="fa fa-spinner fa-w-16 fa-spin fa-lg"></i></em></button></div></form></div></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/carrinho/modais/openModalSucessoSolicitacaoReserva.html','<div class="b2c-modal b2c-modal-solicitacao-reserva sucesso"><div class="modal-header"><div class="row"><div class="col-xs-12"><h3 title="Ol\xE1, {{vm.item.cliente.name}}!" class="modal-title" align="center">Ol\xE1, {{vm.item.cliente.name}}!</h3></div></div></div><div class="modal-body"><div class="cart-list"><div class="row"><div class="col-md-12"><h2 title="Obrigado por reserva com a gente!">Obrigado por reservar com a gente!</h2><h2 title="Sua reserva j\xE1 est\xE1 garantida. Entraremos em contato em at\xE9 24 h.">Sua reserva j\xE1 est\xE1 garantida. <b>Entraremos em contato em at\xE9 24 h.</b></h2><hr><h4 title="Mas qualquer d\xFAdiva pode nos chamar a qualquer momento:">Mas qualquer d\xFAdiva pode nos chamar a qualquer momento:</h4><address><h5 title="E-mail para contato">E-mail: <i class="fa fa-envelope"></i> email: <a href="mailto:info@hoteisquintadosol.com">info@hoteisquintadosol.com</a></h5><h5 title="Telefone para contanto: ">Telefone: <i class="fa fa-phone" aria-hidden="true"></i></h5><h5 title="Telefone para contanto: (73) 3268-8500">WhatsApp: <i class="fa fa-mobile" aria-hidden="true"></i> (73) 3268-8500</h5></address><hr role="separator"><button title="Retornar a in\xEDcio" class="btn time-05 btn-warning btn-block ripple btn-retornar" ng-click="vm.close()" ui-sref="hospedagemPesquisa"><i class="fa fa-arrow-left" aria-hidden="true"></i> Retornar ao in\xEDcio</button></div></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/apartamentos/includes/aside-apartamentos-box.html','<aside class="box-price one"><i class="fa icon fa-suitcase"></i><h2 title="{{vm.getMelhorDesconto(apto)}}" ng-if="apto.value" aria-label="Pre\xE7o com desconto pela forma de pagamento"><div ng-if="vm.getMelhorDesconto(apto)">{{vm.getMelhorDesconto(apto)}}</div></h2><h6 title="Pens\xE3o" ng-if="apto.meal">* {{apto.meal.service}}</h6><h6><span>{{::vm.personsAsString(apto.persons)}}</span></h6><div ng-if="apto.paymentMethods.pagseguro > 0"><h6 title="Pagamento PagSeguro"><i class="fa fa-credit-card" aria-hidden="true"></i> Pagamento via</h6><small>PagSeguro</small></div><div style="margin-top: 10px; margin-bottom: 10px;"><span ng-if="apto.oldValue" title="De {{apto.oldValue / 100| currency:\'R$ \'}}" style="width: 100%;">De {{apto.oldValue / 100| currency:\'R$ \'}} </span><span ng-if="apto.value" title="Por {{apto.value / 100| currency:\'R$ \'}}" style="width: 100%;" aria-label="Pre\xE7o do apartamento">{{apto.value / 100| currency:\'R$ \'}}*</span></div><div class="info-desconto-price" ng-if="apto.value && apto.paymentMethods.visa > 0"><h6 title="Em at\xE9 {{vm.getMaiorPagamentoParcelado(apto)}}  no\xA0cart\xE3o\xA0de\xA0cr\xE9dito"><i class="fa fa-credit-card" aria-hidden="true"></i> *Em at\xE9 {{vm.getMaiorPagamentoParcelado(apto)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small ng-if="!vm.temJurosParcelado(apto)">SEM JUROS</small></div><hr role="separator"><button ng-if="!apto.unavailable" title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple" ng-click="vm.selectUh(apto)">Quero Este <i class="fa fa-check"></i></button> <button ng-if="apto.unavailable" title="N\xE3o dispon\xEDvel" class="btn time-05 btn-block btn-default btn-lg ripple" disabled="disabled">N\xE3o dispon\xEDvel <i class="fa fa-check"></i></button><div class="promo" ng-if="apto.oldValue"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-if="apto.oldValue"><p>-{{100 - ((apto.value * 100) / (apto.oldValue)) | number:\'0\'}}%</p></div></aside>');
$templateCache.put('app/hospedagem/apartamentos/modais/openModalCompartilhar.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10"><h3 title="Compartilhe com seu amigos sua viagem" class="modal-title" align="center">Compartilhe com seus amigos sua viagem</h3></div><div class="col-xs-2"><button class="btn time-05 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="cart-list"><div class="row b2c-list-box b2c-row-apto"><aside class="col-md-4 b2c-img-box" style="background-image: url(\'{{::vm.parent.foto(vm.item)}}\')"></aside><section class="col-md-8 b2c-caracteristicas"><div class="row b2c-section-header"><div class="col-md-12"><div class="b2c-page-header"><h3 title="Servi\xE7os">{{vm.item.service}}</h3></div></div></div><div class="row b2c-section-description"><div class="col-md-6 form-group"><div class="fb-share-button" data-layout="button" data-size="large" data-mobile-iframe="true"><div class="fb-share-button" data-href="{{::vm.parent.selectedHotel.perm}}" data-layout="button" data-size="large" data-mobile-iframe="true"><a title="Compartilhar na sua Linha do Tempo" class="fb-xfbml-parse-ignore btn-block btn-primary btn" target="_blank" rel="noopener" href="https://www.facebook.com/sharer/sharer.php?u={{::vm.parent.selectedHotel.perm}}">Compartilhar <i class="fa fa-facebook" aria-hidden="true"></i></a></div></div></div><div class="col-md-6 form-group"><a class="twitter-share-button btn-block btn-info btn" target="_blank" rel="noopener" href="https://twitter.com/intent/tweet?text=Indo para {{vm.item.service}} {{vm.item.customData.destino ? \'em \' + vm.item.customData.destino : \'\'}}" data-size="large">Tweet <i class="fa fa-twitter" aria-hidden="true"></i></a></div><div class="col-md-6 form-group"><button title="Copiar Link" class="btn btn-block btn-warning" ngclipboard data-clipboard-text="{{::vm.parent.selectedHotel.perm}}">Copiar Link <i class="fa fa-clone" aria-hidden="true"></i></button></div><div class="col-md-6 form-group"><a title="WhatsApp" class="btn btn-block btn-warning btn-whatsapp" target="_blank" href="{{vm.parent.whatsappSearchLink}}">WhatsApp <i class="fa fa-whatsapp" aria-hidden="true"></i></a></div></div></section></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div><div id="fb-root"></div><script>(function (d, s, id) {\n        var js, fjs = d.getElementsByTagName(s)[0];\n        if (d.getElementById(id))\n            return;\n        js = d.createElement(s);\n        js.id = id;\n        js.src = \'https://connect.facebook.net/pt_BR/sdk.js#xfbml=1&version=v2.11&appId=103545163310412\';\n        fjs.parentNode.insertBefore(js, fjs);\n    }(document, \'script\', \'facebook-jssdk\'));</script>');
$templateCache.put('app/hospedagem/apartamentos/modais/openModalMaisDetalhesApartamento.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Hospedagem" class="modal-title" align="center">Hospedagem <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><h3 title="N\xFAmero de Di\xE1rias" class="modal-title" align="center">{{vm.parent.consulta.noites}} Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{vm.parent.consulta.checkin| date:\'dd/MM/yyyy\'}}</span></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{vm.parent.consulta.checkout| date:\'dd/MM/yyyy\'}}</span></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn time-05 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="cart-list"><div class="row b2c-list-box b2c-row-apto"><aside class="col-md-4 b2c-img-box" style="background-image: url(\'{{::vm.parent.foto(vm.item)}}\')"></aside><section class="col-md-8 b2c-caracteristicas"><div class="row b2c-section-header"><div class="col-md-12"><div class="b2c-page-header"><h3 title="Servi\xE7os">{{vm.item.service}} &nbsp;<span class="capacity"><i class="fa fa-users"></i> At\xE9 {{vm.item.capacity}} {{vm.item.capacity > 1 ? \'pessoas\' : \'pessoa\'}}</span></h3></div></div></div><div class="row b2c-section-description"><div class="col-md-12"><p ng-bind-html="vm.item.memo | toHtml"></p></div></div><div class="row b2c-list-box-icons modal" ng-show="vm.item.comodidades.length"><div class="col-md-12"><h5 title="Mais comodidades do apartamento"><i class="fa fa-plus" aria-hidden="true"></i> Mais comodidades do apartamento</h5><hr><div class="icones"><div uib-tooltip="{{comodidade.nome}}" class="icone" ng-repeat="comodidade in vm.item.comodidades"><img title="{{comodidade.nome}}" alt="Comodidade: {{comodidade.nome}}" class="img-responsive" ng-src="assets/images/icons/{{comodidade.imagem}}"></div></div></div></div></section></div><div class="b2c-description-modal"><div class="row" ng-show="vm.item.politicas.politicadecompra"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas de Compras" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas de Compras</h3><p ng-bind-html="vm.item.politicas.politicadecompra | toHtml"></p></div></div><div class="row" ng-show="vm.item.politicas.politicadecancelamento"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas de Cancelamento" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas de Cancelamento</h3><p ng-bind-html="vm.item.politicas.politicadecancelamento | toHtml"></p></div></div><div class="row" ng-show="vm.item.politicas.politicadepagamento"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas Pagamento" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas Pagamento</h3><p ng-bind-html="vm.item.politicas.politicadepagamento | toHtml"></p></div></div></div><div class="b2c-modal-confirme-footer detalhes-apartamento"><div class="row box"><div class="col-md-8"><div class="row b2c-apt-meals modal" ng-show="vm.item.meals.length"><div class="col-md-12"><h3 title="Selecione a pens\xE3o">Selecione a pens\xE3o</h3><hr><div class="row apt-meal"><button uib-tooltip="{{meal.service}}:  {{ meal.value / 100 | currency: \'R$ \'}}" title="{{meal.service}}" class="btn btn-default" ng-class="{\'active\': vm.item.mealType === meal.service}" ng-click="vm.parent.selectMeal(vm.item, meal)" ng-repeat="meal in vm.item.meals"><i class="fa" ng-class="{\'fa-check-square-o\': vm.item.mealType === meal.service, \'fa-square-o\': vm.item.mealType !== meal.service}" aria-hidden="true"></i> <span>{{meal.service}}</span> <strong title="Valor da Pens\xE3o" ng-init="vm.calculateValueWithMeal(apto, meal)">{{ meal.value / 100 | currency: "R$ "}}</strong></button></div></div></div></div><section class="col-md-4 box-price one"><i class="fa icon fa-suitcase"></i><h4 title="De {{vm.item.oldValue / 100| currency:\'R$ \'}}" ng-show="{{vm.item.oldValue}}">De {{vm.item.oldValue / 100| currency:\'R$ \'}}</h4><h2 title="Por {{vm.item.value / 100| currency:\'R$ \'}}">{{vm.item.value / 100| currency:\'R$ \'}}</h2><h6 title="Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value)}} Em at\xE9"><i class="fa fa-credit-card" aria-hidden="true"></i>Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small>SEM JUROS</small><hr role="separator"><button title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple" ng-click="vm.ok()">Quero Este <i class="fa fa-check"></i></button><div class="promo" ng-show="{{::vm.item.oldValue}}"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-show="{{::vm.item.oldValue}}"><p>-{{::100 - ((vm.item.value * 100) / (vm.item.oldValue)) | number:\'0\'}}%</p></div></section></div></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div><div ng-if="false" class="row margin-auto"><div ng-if="false" class="col-md-6 box-price one"><i class="fa icon fa-suitcase"></i><h4 ng-show="{{vm.item.oldValue}}" title="De {{vm.item.oldValue / 100| currency:\'R$ \'}}">De {{vm.item.oldValue / 100| currency:\'R$ \'}}</h4><h2 title="Por {{vm.item.value / 100| currency:\'R$ \'}}">{{vm.item.value / 100| currency:\'R$ \'}}</h2><h6 title="Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value)}}  no\xA0cart\xE3o\xA0de\xA0cr\xE9dito"><i class="fa fa-credit-card" aria-hidden="true"></i>Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small>SEM JUROS</small><hr role="separator"><button title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple" ng-click="vm.ok()">Quero Este <i class="fa fa-check"></i></button><div class="promo" ng-show="{{::vm.item.oldValue}}"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-show="{{::vm.item.oldValue}}"><p>-{{::100 - ((vm.item.value * 100) / (vm.item.oldValue)) | number:\'0\'}}%</p></div></div><div ng-if="false" class="col-md-6 box-price"><h3 title="...">Tarifa Normal</h3><h4 ng-show="{{vm.item.oldValue}}" title="De {{vm.item.oldValue / 100| currency:\'R$ \'}}">De {{vm.item.oldValue / 100| currency:\'R$ \'}}</h4><h2 title="Por {{vm.item.value / 100| currency:\'R$ \'}}">{{vm.item.value / 100| currency:\'R$ \'}}</h2><h6 title="Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value / 100)}}  no\xA0cart\xE3o\xA0de\xA0cr\xE9dito"><i class="fa fa-credit-card" aria-hidden="true"></i>Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value / 100)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small>SEM JUROS</small><hr role="separator"><button title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple" ng-click="vm.ok()">Quero Este <i class="fa fa-check"></i></button><div class="promo" ng-show="{{::vm.item.oldValue}}"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-show="{{::vm.item.oldValue}}"><p>-{{::100 - ((vm.item.value * 100) / (vm.item.oldValue)) | number:\'0\'}}%</p></div></div><div ng-if="false" class="col-md-6 box-price b2c-aside-box-tarifas-especial"><h3 title="...">Tarifa Especial</h3><h4 ng-show="{{vm.item.oldValue}}" title="De {{vm.item.oldValue / 100| currency:\'R$ \'}}">De {{vm.item.oldValue / 100| currency:\'R$ \'}}</h4><h2 title="Por {{vm.item.value / 100| currency:\'R$ \'}}">{{vm.item.value / 100| currency:\'R$ \'}}</h2><h6 title="Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value)}}  no\xA0cart\xE3o\xA0de\xA0cr\xE9dito"><i class="fa fa-credit-card" aria-hidden="true"></i>Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small>SEM JUROS</small><hr role="separator"><button title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple" ng-click="vm.ok()">Quero Este <i class="fa fa-check"></i></button><div class="promo" ng-show="{{::vm.item.oldValue}}"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-show="{{::vm.item.oldValue}}"><p>-{{::100 - ((vm.item.value * 100) / (vm.item.oldValue)) | number:\'0\'}}%</p></div></div><div ng-if="false" class="b2c-box-tarifas-cards"><div class="col-md-12 b2c-box-tarifas-card" ng-repeat="i in [0, 1, 2]"><div class="row"><div class="col-xs-3 col-sm-2 col-md-2 col-lg-2"><button title="Quero este" class="btn time-05 btn-block btn-default btn-lg ripple"><i class="fa fa-check"></i></button></div><div class="col-xs-9 col-sm-10 col-md-10 col-lg-10 text-tarifas-card"><h4 title="...">Tarifa Especial | <span>DE R$ 0000,00</span></h4><h3 title="Por ...">R$ 0000,00 <small><i class="fa fa-credit-card" aria-hidden="true"></i> Em at\xE9 3x de R$ 0000,000</small> <small>SEM JUROS</small></h3></div><div class="promo" ng-show="{{::vm.item.oldValue}}"><p>PROMO\xC7\xC3O</p></div><div class="desconto apt" ng-show="{{::vm.item.oldValue}}"><p>-{{::100 - ((vm.item.value * 100) / (vm.item.oldValue)) | number:\'0\'}}%</p></div></div></div></div></div>');
$templateCache.put('app/hospedagem/hotel/modais/openModalInformativo.html','<div class="b2c-modal b2c-modal-hoteis b2c-modal-escolha-hotel"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="{{vm.item.politica}}" class="modal-title" align="center">{{vm.item.politica}}</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn time-05 radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="row"><div class="col-md-12"><p class="text" ng-bind-html="vm.item.text | toHtml"></p></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/hotel/modais/openModalInformativoHotel.html','<div class="b2c-modal b2c-modal-hoteis b2c-modal-escolha-hotel"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Hospedagem" class="modal-title" align="center">Hospedagem <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><h3 title="N\xFAmero de Di\xE1rias" class="modal-title" align="center">{{vm.parent.consulta.noites}} Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{vm.parent.consulta.checkin| date:\'dd/MM/yyyy\'}}</span></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{vm.parent.consulta.checkout| date:\'dd/MM/yyyy\'}}</span></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn time-05 radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="cart-list"><div class="row b2c-list-box b2c-row-apto"><aside class="col-md-4 b2c-img-box" style="background-image: url(\'{{::vm.parent.foto(vm.item)}}\')"></aside><section class="col-md-8 b2c-caracteristicas"><div class="row b2c-section-header"><div class="col-md-12"><div class="b2c-page-header"><h3 title="{{vm.item.service}}">{{vm.item.service}}</h3></div></div></div><div class="row b2c-section-description"><div class="col-md-12"><p ng-show="vm.unidadesShow" ng-class="{\'color-red\': vm.unidadesShowClass}"><i class="fa fa-bomb" aria-hidden="true"></i> {{::vm.ultimasUnidades(vm.item)}}</p><p ng-show="vm.item.pontodereferencia"><i class="fa fa-map-marker" aria-hidden="true"></i> {{vm.item.pontodereferencia}}</p></div></div><div class="row b2c-list-box-icons modal" ng-show="vm.item.comodidades.length"><div class="col-md-12"><h5 title="Mais comodidades do hotel"><i class="fa fa-plus" aria-hidden="true"></i> Mais comodidades do hotel</h5><hr><div class="icones"><div uib-tooltip="{{comodidade.nome}}" class="icone" ng-repeat="comodidade in vm.item.comodidades" ng-if="comodidade.imagem"><img title="{{comodidade.nome}}" alt="Comodidade: {{comodidade.nome}}" class="img-responsive" ng-src="assets/images/icons/{{comodidade.imagem}}"></div></div></div></div></section></div><div class="b2c-description-modal"><div class="row" ng-show="vm.item.memo"><div class="col-md-12 politicas"><h3 title="Descritivo" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Descritivo</h3><p ng-bind-html="vm.item.memo | toHtml"></p></div></div><div class="row" ng-if="vm.item.politicas.politicadecompra"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas de Compras" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas de Compras</h3><p ng-bind-html="vm.item.politicas.politicadecompra  | toHtml"></p></div></div><div class="row" ng-if="vm.item.politicas.politicadecancelamento"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas de Cancelamento" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas de Cancelamento</h3><p ng-bind-html="vm.item.politicas.politicadecancelamento | toHtml"></p></div></div><div class="row" ng-if="vm.item.politicas.politicadepagamento"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas Pagamento" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas Pagamento</h3><p ng-bind-html="vm.item.politicas.politicadepagamento  | toHtml"></p></div></div></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/hoteis/includes/asidefilter.html','<aside class="col-md-3 b2c-box-filter b2c-box-filter-hoteis"><div class="b2c-box-filter-box"><div id="navbarVertical"></div><xs-search-bar-holder xs-id-holder="navbarVertical" xs-search="vm.searchVertical" template-url="quinta_do_sol/template/xsSearchVertical.html"></xs-search-bar-holder><div class="hidden-xs hidden-sm" ng-show="vm.isSearching()"><p class="alert bg-warning" style="text-align: center"><i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i> <b>Aguarde...</b></p></div><div class="row b2c-box-filter-mobile hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><div class="col-xs-6"><h5 title="{{vm.hoteis.length}} itens">{{vm.hoteis.length}} itens</h5></div><div class="col-xs-6"><button title="Ver filtros dos apartamentos" ng-click="vm.rowFiltersHoteisIsOpen_mobile = !vm.rowFiltersHoteisIsOpen_mobile" class="btn time-05 btn-danger btn-block ripple" type="button"><i class="fa fa-filter" aria-hidden="true"></i> Filtros <i ng-class="{ \'fa-chevron-up\': !vm.rowFiltersHoteisIsOpen_mobile, \'fa-chevron-down\': vm.rowFiltersHoteisIsOpen_mobile  }" class="fa" aria-hidden="true"></i></button></div></div><div class="animated" uib-collapse="vm.rowFiltersHoteisIsOpen_mobile"><nav class="row b2c-info-navbar nav navbar hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" role="navigation"><div class="col-md-6 form-group"><h3 title="Data Hospedagem"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{vm.consulta.checkin| date:\'dd/MM/yyyy\'}} a &nbsp; <i class="fa fa-calendar-times-o" aria-hidden="true"></i> {{vm.consulta.checkout| date:\'dd/MM/yyyy\'}}</h3></div><div class="col-md-4 form-group"><form tabindex="-1" name="formFilterPesquisarHotel" role="search" id="formFilterPesquisarHotel" class="navbar-form"><div class="form-group input-group"><input type="text" tabindex="1" class="form-control" ng-model="vm.filterPesquisar" ng-model-options="{updateOn: \'default\', debounce: 500}" name="" placeholder="Pesquisar..."> <span ng-click="" class="input-group-addon"><i class="fa fa-search" aria-hidden="true"></i></span></div></form></div><div class="col-md-2 form-group"><select class="form-control" ng-model="vm.ordenarPorValor" ng-change="vm.ordernarPrecos(vm.ordenarPorValor)"><option value="" selected="selected">Ordenar por Valor</option><option value="MenorParaMaior">Menor para maior</option><option value="MaiorParaMenor">Maior para menor</option></select></div></nav><div ng-if="false" class="row b2c-box-filter-preco hidden"><div class="col-md-12"><h3 title="Filtro de Pre\xE7os">Filtro de Pre\xE7os</h3><div class="form-group filter-preco-intervalo"><label>Intervalo de pre\xE7os</label><slider slider-id="ss" ng-model="vm.rangePrecoHotel" min="vm.hotelValueMin" max="vm.hotelValueMax" step="5" range="true" precision="0">N\xE3o Disponivel.</slider></div><div class="row hidden"><div class="form-group col-xs-6"><label class="sr-only" for="precoHotelMin">Valor Minimo</label><div class="input-group"><div class="input-group-addon">R$</div><input type="number" class="form-control" id="precoHotelMin" ng-model="vm.vm.rangePrecoHotel[0]" min="{{vm.hotelValueMin}}" max="{{vm.hotelValueMax}}" value="{{vm.hotelValueMin}}"><div class="input-group-addon">.00</div></div></div><div class="form-group col-xs-6"><label class="sr-only" for="precoHotelMax">Valor M\xE1ximo</label><div class="input-group"><div class="input-group-addon">R$</div><input type="number" class="form-control" id="precoHotelMax" ng-model="vm.vm.rangePrecoHotel[1]" min="{{vm.hotelValueMin}}" max="{{vm.hotelValueMax}}" value="{{vm.hotelValueMax}}"><div class="input-group-addon">.00</div></div></div></div></div></div><div ng-if="false" class="row b2c-box-filter-cupom"><div class="col-md-12"><h3 title="Cupom de desconto"><i class="fa fa-tag" aria-hidden="true"></i> Cupom de desconto</h3><div class="row"><div class="form-group col-xs-5"><input type="text" class="form-control" placeholder="Chave Promocional" id="chaveCumpomDesconto" ng-value="vm.cupomKey"></div><div class="form-group col-xs-5"><input type="text" class="form-control" placeholder="Cupom Promocional" id="valorCupomDesconto" ng-value="vm.cupomCode"></div><div class="form-group col-xs-2"><button uib-tooltip="Calcular Desconto" title="Calcular Desconto" class="btn btn-block" ng-value="vm.verifyCupom()"><i class="fa fa-check"></i></button></div></div></div></div><div ng-if="vm.allDestinos.length > 1" class="row b2c-box-filter-destino"><div class="col-md-12"><h3 title="Filtros de destinos">Filtros de destinos</h3><div class="form-group b2c-filtros-ativos" ng-show="vm.arrayFiltrosDestinos.length"><div class="label-ativos"><label>Filtros Ativos</label> <button uib-tooltip="Limpar filtros de Destinos" title="Limpar filtros de Destinos" ng-click="vm.limparFiltrosDestinos()"><small>Limpar</small> <i class="fa fa-trash" aria-hidden="true"></i></button></div><div class="btn-group"><button uib-tooltip="Retirar filtro {{filtro.nome}}" title="Retirar filtro {{filtro.nome}}" ng-click="vm.limparFiltroDestino(filtro)" ng-repeat="filtro in vm.arrayFiltrosDestinos"><img title="Retirar filtro {{filtro.nome}}" alt="Retirar filtro {{filtro.nome}}" class="img-responsive" ng-src="assets/images/icons/{{filtro.imagem}}"> <small>{{filtro.nome| ellipsis:8}}</small> <i class="fa fa-trash" aria-hidden="true"></i></button></div></div><div class="form-group b2c-filtros-disp"><label>Destinos</label><div class="btn-group"><button uib-tooltip="Filtrar por {{destino.nome}}" title="Filtrar por {{destino.nome}}" ng-click="vm.addfiltroDestinos(destino)" ng-repeat="destino in vm.allDestinos"><img title="Filtrar por {{destino.nome}}" alt="Filtrar por {{destino.nome}}" class="img-responsive" src="assets/images/icons/{{destino.imagem}}"><small>{{destino.nome}}</small></button></div></div></div></div><div ng-show="vm.allTiposEmpreendimentos.length > 1" class="row b2c-filter-acomodacao-hoteis"><div class="col-md-12"><h3 title="Filtro de empreendimento">Filtro de empreendimento</h3><div class="form-group b2c-filtros-ativos" ng-show="vm.arrayFiltrosEmpreendimentos.length"><div class="label-ativos"><label>Filtros Ativos</label> <button uib-tooltip="Limpar filtros de Categorias" title="Limpar filtros de Categorias" ng-click="vm.limparFiltrosEmpreendimentos()"><small>Limpar</small> <i class="fa fa-trash" aria-hidden="true"></i></button></div><div class="btn-group"><button uib-tooltip="Retirar filtro {{filtro.nome}}" title="Retirar filtro {{filtro.nome}}" ng-click="vm.limparFiltroEmpreendimento(filtro)" ng-repeat="filtro in vm.arrayFiltrosEmpreendimentos"><img title="Retirar filtro {{filtro.nome}}" alt="Retirar filtro {{filtro.nome}}" class="img-responsive" ng-src="assets/images/icons/{{filtro.imagem}}"> <small>{{filtro.nome| ellipsis:8}}</small> <i class="fa fa-trash" aria-hidden="true"></i></button></div></div><div class="form-group b2c-filtros-disp"><label>Tipos</label><div class="btn-group"><button uib-tooltip="Filtrar por {{categoria.nome}}" title="Filtrar por {{categoria.nome}}" ng-click="vm.addfiltroEmpreendimentos(categoria)" ng-repeat="categoria in vm.allTiposEmpreendimentos"><img title="Filtrar por {{categoria.nome}}" alt="Filtrar por {{categoria.nome}}" class="img-responsive" src="assets/images/icons/{{categoria.imagem}}"><small>{{categoria.nome}}</small></button></div></div></div></div><div ng-if="vm.allItens.length > 1" class="row b2c-box-filter-servicos"><div class="col-md-12"><h3 title="Filtrar por:">Filtrar por:</h3><div class="form-group b2c-filtros-ativos" ng-if="vm.arrayFiltrosHoteis.length"><div class="label-ativos"><label>Filtros Ativos</label> <button uib-tooltip="Limpar filtros" title="Limpar filtros" ng-click="vm.limparFiltrosHoteis()"><small>Limpar</small> <i class="fa fa-trash" aria-hidden="true"></i></button></div><div class="btn-group"><button uib-tooltip="Retirar filtro {{filtro.nome}}" title="Retirar filtro {{filtro.nome}}" ng-click="vm.limparFiltroHoteis(filtro)" ng-repeat="filtro in vm.arrayFiltrosHoteis"><img title="Retirar filtro {{filtro.nome}}" alt="Retirar filtro {{filtro.nome}}" class="img-responsive" src="assets/images/icons/{{filtro.imagem}}"> <small>{{filtro.nome| ellipsis:8}}</small> <i class="fa fa-trash" aria-hidden="true"></i></button></div></div><div class="form-group b2c-filtros-disp" ng-if="allItem.length" ng-repeat="allItem in vm.allItens"><label>{{allItem[0].categoria}}</label><div class="btn-group"><button uib-tooltip="Filtrar por {{item.nome}}" title="Filtrar por possuir {{item.nome}}" type="button" ng-click="vm.addfiltroHoteis(item)" ng-repeat="item in allItem"><img title="Filtrar por {{item.nome}}" alt="Filtrar por {{item.nome}}" class="img-responsive" src="assets/images/icons/{{item.imagem}}"> <small>{{item.nome| ellipsis:8}}</small></button></div></div></div></div></div></div></aside>');
$templateCache.put('app/hospedagem/hoteis/includes/boxhoteis.html','<section class="col-md-9 b2c-box-info b2c-box-hoteis"><nav class="row b2c-info-navbar nav navbar hidden-xs hidden-sm" role="navigation"><div class="col-md-5 hidden-xs hidden-sm form-group"><button title="{{vm.hoteis.length}} {{vm.hoteis.length > 1 ? \'Empreendimentos\' : \'Empreendimento\'}}" class="empreendimentos btn btn-link" ng-click="vm.openModalEditarDadosHospedagem()" type="button"><span>Foi encontrado: </span><i class="fa fa-building-o" aria-hidden="true"></i> {{vm.hoteis.length}} {{vm.hoteis.length > 1 ? \'Empreendimentos\' : \'Empreendimento\'}}</button></div><div class="col-xs-12 col-md-4 form-group"><form tabindex="-1" name="formBoxPesquisarHotel" role="search" id="formBoxPesquisarHotel" class="navbar-form float-right"><div class="form-group input-group"><input tabindex="1" type="text" class="form-control" ng-model="vm.filterPesquisar" ng-model-options="{updateOn: \'default\', debounce: 500}" name="" placeholder="Pesquisar..."> <span ng-click="" class="input-group-addon"><i class="fa fa-search" aria-hidden="true"></i></span></div></form></div><div class="col-xs-12 col-md-3 form-group"><select class="form-control" ng-model="vm.ordenarPorValor" ng-change="vm.ordernarPrecos(vm.ordenarPorValor)"><option value="" selected="selected">Ordenar por valor</option><option value="MenorParaMaior">Menor para maior</option><option value="MaiorParaMenor">Maior para menor</option></select></div></nav><div class="row not-result-hotels" ng-if="vm.isSearching() == false && vm.hoteis.length == null || vm.hoteis.length <= 0"><figure class="col-md-4"><img title="Nenhum resultado para essa pesquisa" alt="Nenhum resultado para essa pesquisa" class="img-responsive" src="assets/images/layout/img-modal-tentar-novamente-travel.jpg"></figure><div class="col-md-8"><div class="row title-not"><div class="col-md-12"><h4 title="Nenhum hotel encontrado.">Nenhum hotel encontrado.</h4><h3 title="Mas n\xE3o fique triste, pois encontraremos a melhor op\xE7\xE3o para voc\xEA.">Mas n\xE3o fique triste, pois <b>encontraremos</b> a melhor op\xE7\xE3o para voc\xEA.</h3><hr></div></div><div class="row options-not-result"><div class="col-md-12"><div class="row title-not"><div class="col-md-12"><h3 title="N\xE3o desfa\xE7a as <b>malas</b> e sim <b>refa\xE7a sua pesquisa</b>.">N\xE3o desfa\xE7a as <b>malas</b> e sim <b>refa\xE7a sua pesquisa</b>.</h3><hr><h3 title="Telefone" ng-hide="\'\' == \'\'"><i class="fa fa-mobile" aria-hidden="true"></i> Ou ent\xE3o nos ligue:</h3></div></div></div></div></div></div><div class="row b2c-list-box timer-05 hotel {{hotel.item.customData.nivelDestaque}}" ng-repeat="hotel in vm.hoteis| filter:vm.filterPesquisar | filter:vm.filtrarHoteis | filter:vm.filtrarEmpreendimentos | filter:vm.filtrarDestinos | filter:vm.verificaUnidades"><img ng-show="hotel.item.customData.nivelDestaque" title="{{hotel.item.service}}" alt="{{hotel.item.service}}" class="img-responsive anchor {{hotel.item.customData.nivelDestaque}}" ng-src="assets/images/layout/{{hotel.item.customData.nivelDestaque}}.png"><aside class="col-md-3 b2c-img-box" style="background-image: url(\'{{::vm.foto(hotel.item)}}\')"><button ng-if="hotel.item.foto" type="button" title="Ver galeria de fotos" class="galeria btn-icon btn-gallery-icon btn btn-default" ng-click="vm.modalGaleria(hotel.item)"><i class="fa fa-camera" aria-hidden="true"></i> <label>Fotos</label></button> <button title="Detalhes do Hotel: {{hotel.item.service}}" class="btn btn-icon btn-mais btn btn-default" ng-click="vm.openModalMaisDetalhesHotel(hotel)"><i class="fa fa-plus" aria-hidden="true"></i> <label>Detalhes</label></button></aside><section class="col-md-6 col-lg-6 b2c-caracteristicas"><div class="row b2c-section-header"><div class="col-md-12"><div class="b2c-page-header"><h2 title="{{hotel.item.service}}" ng-click="vm.openModalMaisDetalhesHotel(hotel)">{{hotel.item.service}} <small ng-if="hotel.item.customData.destino">{{hotel.item.customData.destino}}</small></h2></div></div></div><div class="row b2c-section-description"><div class="col-md-12"><p class="description-item" ng-if="hotel.item.pontodereferencia"><i class="fa fa-map-marker" aria-hidden="true"></i> {{hotel.item.pontodereferencia}}</p><p class="description-item" ng-if="hotel.item.localizacao && !hotel.item.linkmap"><a class="btn btn-link" target="_blank" rel="noopener" href="http://maps.google.com/?q={{hotel.item.localizacao}}"><i class="fa fa-map-marker" aria-hidden="true"></i> Mapa</a></p><p class="description-item" ng-if="hotel.item.linkmap"><a class="btn btn-link" target="_blank" rel="noopener" href="{{hotel.item.linkmap}}"><i class="fa fa-map-marker" aria-hidden="true"></i> Mapa</a></p><p class="description-item" ng-if="hotel.unidadesShow" ng-class="{\'color-red\': hotel.unidadesShowClass}"><i class="fa fa-bomb" aria-hidden="true"></i> {{::vm.ultimasUnidades(hotel)}}</p></div></div><div class="row b2c-section-promos" ng-if="hotel.item.promos"><div class="col-md-12" ng-repeat="promo in hotel.item.promos"><span class="promo-item color-red"><i class="fa fa-heart" aria-hidden="true"></i> {{::promo}}</span></div></div><div class="row b2c-section-promos" ng-if="hotel.item.unavailableMsg"><div class="col-md-12"><span class="promo-item color-red"><i class="fa fa-warning" aria-hidden="true"></i> {{::hotel.item.unavailableMsg}}</span></div></div><div class="row b2c-list-box-icons icons-hotel" ng-show="hotel.item.comodidades.length"><div class="col-md-12"><h5 title="Comodidades do Hotel: {{hotel.item.service}}">Comodidades do Hotel</h5><hr><div class="icones"><div uib-tooltip="{{comodidade.nome}}" class="icone" ng-repeat="comodidade in hotel.item.comodidades | limitTo:6" ng-if="comodidade.imagem"><img title="{{comodidade.nome}}" alt="Comodidade: {{comodidade.nome}}" class="img-responsive" ng-src="assets/images/icons/{{comodidade.imagem}}"></div></div></div></div></section><aside ng-if="hotel.onlyBudget && !hotel.item.unavailable" class="col-md-3 col-lg-3 box-price orcamento"><div class="row"><h6><span>{{ ::vm.personsAsString(hotel.result[0].persons) }}</span></h6></div><hr><div class="row infos"><div class="col-xs-12 date"><h5 title="Check-in" class="modal-title"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{vm.consulta.checkin| date:\'dd/MM/yyyy\'}} &nbsp;&nbsp; <i class="fa fa-calendar-times-o" aria-hidden="true"></i> {{vm.consulta.checkout| date:\'dd/MM/yyyy\'}}</h5></div><div class="col-xs-12 days"><h4 title="N\xFAmero de Di\xE1rias" class="modal-title">{{vm.consulta.noites}} {{vm.consulta.noites > 1 ? \'Di\xE1rias\':\'Di\xE1ria\'}}</h4></div></div><div class="container-checkbox"><input id="hotel{{::$index}}" type="checkbox" ng-model="hotel._selected" ng-change="vm.updateHasBudget()"> <label for="hotel{{::$index}}"><span>Solicitar Or\xE7amento <i class="fa fa-handshake-o" aria-hidden="true"></i></span></label></div></aside><aside ng-if="!hotel.onlyBudget && !hotel.item.unavailable" class="col-md-3 col-lg-3 box-price"><h4 ng-show="hotel.item.oldValue" title="De {{hotel.item.oldValue / 100| currency:\'R$ \'}}">De {{hotel.item.oldValue / 100| currency:\'R$ \'}}</h4><h6 title="A partir">A partir de:</h6><h2 title="{{vm.getMelhorDesconto(hotel)}}"><div ng-if="vm.getMelhorDesconto(hotel)">{{vm.getMelhorDesconto(hotel)}}</div></h2><span title="Pens\xE3o" ng-if="hotel.item.mealType">Pens\xE3o: {{hotel.item.mealType}}</span><h6><span>( {{ ::vm.personsAsString(hotel.result[0].persons) }} )</span></h6><div ng-show="hotel.item.paymentMethods.pagseguro > 0"><h6 title="Pagamento PagSeguro"><i class="fa fa-credit-card" aria-hidden="true"></i> Pagamento via</h6><small>PagSeguro</small></div><div class="normal-value" style="margin-top: 10px; margin-bottom: 10px;">Ou {{hotel.item.value / 100| currency:\'R$ \'}}*</div><div class="box-frasecomplementar1" aria-hidden="true"></div><div class="box-frasecomplementar" ng-show="hotel.item.paymentMethods.visa > 0"><h6 title="Em at\xE9 {{vm.getMaiorPagamentoParcelado(hotel)}}  no\xA0cart\xE3o\xA0de\xA0cr\xE9dito"><i class="fa fa-credit-card" aria-hidden="true"></i> *Em at\xE9 {{vm.getMaiorPagamentoParcelado(hotel)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small ng-if="!vm.temJurosParcelado(hotel)">SEM JUROS</small></div><div class="promo" ng-show="hotel.item.oldValue"><p>PROMO\xC7\xC3O</p></div><div class="desconto" ng-show="hotel.item.oldValue"><p>-{{::100 - ((hotel.item.value * 100) / (hotel.item.oldValue)) | number:\'0\'}}%</p></div><button title="Selecionar" class="btn time-05 btn-sm btn-warning btn-block btn-reservar bnt-lg ripple" ng-click="vm.selectHotel(hotel)" style="margin-top: 10px;">Selecionar <i class="fa fa-arrow-right" aria-hidden="true"></i></button></aside><aside ng-if="hotel.item.unavailable" class="col-md-3 col-lg-3 box-price unavailable" style="min-height:198px;"><hr><button type="button" class="btn time-05 btn-sm btn-warning btn-block btn-reservar bnt-lg ripple" disabled="disabled">N\xE3o dispon\xEDvel</button></aside></div><div class="row" ng-if="vm.hasBudget"><div class="col-md-12"><button type="button" class="pull-right btn btn-lg btn-success" ng-click="vm.sendBudgets()">Enviar Or\xE7amento <i class="fa fa-envelope"></i></button></div></div><div class="row" ng-show="vm.isSearching()"><p class="alert bg-warning" style="text-align: center"><i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i> <b>Procurando mais propriedades...</b> <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i></p></div></section>');
$templateCache.put('app/hospedagem/hoteis/includes/sendBudgetButton.html','<div class="loja-balao-orcamento animated ripple pulse-button" ng-if="vm.hasBudget" uib-tooltip="Receber Or\xE7amento" tooltip-placement="left" tooltip-append-to-body><a ng-click="vm.sendBudgets()"><p align="center">Enviar <i class="fa fa-envelope fa-2x" aria-hidden="true"></i></p></a></div>');
$templateCache.put('app/hospedagem/hoteis/modais/openModalMaisDetalhesHotel.html','<div class="b2c-modal b2c-modal-hoteis b2c-modal-escolha-hotel"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Hospedagem" class="modal-title" align="center">Hospedagem <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><h3 title="N\xFAmero de Di\xE1rias" class="modal-title" align="center">{{vm.parent.consulta.noites}} Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>{{vm.parent.consulta.checkin| date:\'dd/MM/yyyy\'}}</span></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>{{vm.parent.consulta.checkout| date:\'dd/MM/yyyy\'}}</span></div></div><h3 title="Valor" ng-if="!vm.hotel.onlyBudget" class="modal-title preco hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" align="center">Valor: {{vm.item.value / 100| currency:\'R$ \'}}</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn time-05 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="cart-list"><div class="row b2c-list-box b2c-row-apto"><aside class="col-md-4 b2c-img-box" style="background-image: url(\'{{::vm.parent.foto(vm.item)}}\')"></aside><section class="col-md-8 b2c-caracteristicas"><div class="row b2c-section-header"><div class="col-md-12"><div class="b2c-page-header"><h3 title="{{vm.item.service}}">{{vm.item.service}}.</h3></div></div></div><div class="row b2c-section-description"><div class="col-md-12"><p ng-show="vm.unidadesShow" ng-class="{\'color-red\': vm.unidadesShowClass}"><i class="fa fa-bomb" aria-hidden="true"></i> {{::vm.ultimasUnidades(vm.item)}}</p><p ng-show="vm.item.pontodereferencia"><i class="fa fa-map-marker" aria-hidden="true"></i> {{vm.item.pontodereferencia}}</p></div></div><div class="row b2c-list-box-icons modal" ng-show="vm.item.comodidades.length"><div class="col-md-12"><h5 title="Mais comodidades do hotel"><i class="fa fa-plus" aria-hidden="true"></i> Mais comodidades do hotel</h5><hr><div class="icones"><div uib-tooltip="{{comodidade.nome}}" class="icone" ng-repeat="comodidade in vm.item.comodidades" ng-if="comodidade.imagem"><img title="{{comodidade.nome}}" alt="Comodidade: {{comodidade.nome}}" class="img-responsive" ng-src="assets/images/icons/{{comodidade.imagem}}"></div></div></div></div></section></div><div class="b2c-description-modal"><div class="row" ng-show="vm.item.memo"><div class="col-md-12 politicas"><h3 title="Descritivo" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Descritivo</h3><p ng-bind-html="vm.item.memo  | toHtml"></p></div></div><div class="row" ng-if="vm.item.politicas.politicadohotel"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas Do Hotel" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas do Hotel</h3><p ng-bind-html="vm.item.politicas.politicadohotel  | toHtml"></p></div></div><div class="row" ng-if="vm.item.politicas.politicadecompra"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas de Compras" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas de Compras</h3><p ng-bind-html="vm.item.politicas.politicadecompra | toHtml"></p></div></div><div class="row" ng-if="vm.item.politicas.politicadecancelamento"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas de Cancelamento" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas de Cancelamento</h3><p ng-bind-html="vm.item.politicas.politicadecancelamento | toHtml"></p></div></div><div class="row" ng-if="vm.item.politicas.politicadepagamento"><div class="col-md-12 politicas"><h3 title="Pol\xEDticas Pagamento" class="b2c-page-header"><i class="fa fa-file-text-o" aria-hidden="true"></i> Pol\xEDticas Pagamento</h3><p ng-bind-html="vm.item.politicas.politicadepagamento  | toHtml"></p></div></div></div><div ng-if="!vm.verificaHotelUnico && !vm.hotel.onlyBudget" class="b2c-modal-confirme-footer detalhes-hotel"><div class="row box"><aside class="hidden-xs hidden-sm col-md-5"><figure class="row"><img title="Confirmar Reserva de Hotel" alt="Confirmar Reserva de Hotel" class="img-responsive" src="assets/images/layout/img-modal-confirme-compra.jpg"></figure></aside><section class="col-md-7"><div class="row infos"><div class="col-md-12"><h4 ng-show="{{vm.item.oldValue}}" title="De {{vm.item.oldValue / 100| currency:\'R$ \'}}">De {{vm.item.oldValue / 100| currency:\'R$ \'}}</h4><h6 title="A partir!">A partir!</h6><h2 title="{{vm.item.value / 100| currency:\'R$ \'}}">{{vm.item.value / 100| currency:\'R$ \'}}</h2><hr><h6 title="Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value)}}  no\xA0cart\xE3o\xA0de\xA0cr\xE9dito"><i class="fa fa-credit-card" aria-hidden="true"></i>Em at\xE9 {{vm.parent.pagamentoParcelado(vm.item.paymentMethods, vm.item.value)}} no\xA0cart\xE3o\xA0de\xA0cr\xE9dito</h6><small>SEM JUROS</small></div></div><div class="row buttons"><div class="col-md-6 form-group"><button title="Escolher outro Hotel" class="btn time-05 btn-warning btn-reservar bnt-lg btn-block ripple" ng-click="vm.close()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Escolher outro hotel</button></div><div class="col-md-6 form-group"><button title="Reservar Esse Hotel" class="btn time-05 btn-success btn-reservar bnt-lg btn-block ripple" ng-click="vm.ok()">Reservar Este <i class="fa fa-suitcase" aria-hidden="true"></i></button></div></div><div class="promo" ng-show="{{vm.item.oldValue}}"><p>PROMO\xC7\xC3O</p></div><div class="desconto" ng-show="{{vm.item.oldValue}}"><p>-{{::100 - ((vm.item.value*100) / (vm.item.oldValue)) | number:\'0\'}}%</p></div></section></div></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/confirmacao/views/view-ingressos.html','<div class="row b2c-views-ingressos-confirmacao"><div class="form-group col-md-4 col-md-offset-4"><a class="btn time-05 btn-lg btn-warning btn-block" target="_blank" rel="noopener" href="">Veja tamb\xE9m nossas experi\xEAncia <i class="fa fa-ticket" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/hospedagem/confirmacao/modais/openModalCarrinhoApartamentos.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 class="modal-title" align="center">Seus Apartamentos <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><hr class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><h3 class="modal-title" align="center">2 Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>01/03/2017</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>01/05/2017</span><br><label>Check-out</label></div></div><h3 class="modal-title hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" align="center">Total: R$ 0,000,00</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn time-05 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="cart-list"><div class="row b2c-list-box b2c-row-apto" ng-repeat="i in [0,1,2]"><aside class="col-md-4 b2c-img-box" style="background-image: url(\'assets/images/atrium-flat-service_1.jpg\')"></aside><section class="col-md-7 b2c-caracteristicas"><div class="row b2c-section-header"><div class="col-md-12"><div class="b2c-page-header"><h3 title="...">Nome do Hotel Exemplo</h3></div></div></div><div class="row b2c-section-description"><div class="col-md-12"><p><i class="fa fa-male" aria-hidden="true"></i> 6 Adultos</p><p><i class="fa fa-child" aria-hidden="true"></i> 3 Crian\xE7as</p></div></div><div class="row b2c-list-box-icons"><div class="col-md-12"><h5 title="Detalhes do Hotel">Detalhes do apartamento</h5><hr><div class="icones"><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/laundry-machine.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/super-luxo-stars.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/wifi.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/pool.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/restaurant.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/academia.png"></div></div></div></div></section><aside class="col-md-2 box-price"><h5 title="...">Nome do apartamento exemplo</h5><h3 title="Valor do apartamento: R$ ...">R$ 1.200,00</h3><button title="Retirar apartamento" class="btn time-05 btn-sm btn-warning btn-block btn-reservar bnt-lg" ng-click="">Retirar <i class="fa fa-trash-o" aria-hidden="true"></i></button><h6 title="...">Tarifa normal</h6></aside></div><div class="b2c-modal-confirme-footer"><div class="row box"><aside class="hidden-xs hidden-sm col-md-6"><figure class="row"><img title="Confirmar Compra" alt="Confirmar Compra" class="img-responsive" src="assets/images/layout/img-modal-confirme-compra.jpg"></figure></aside><section class="col-md-6"><h3 title="..." class="clear-fix">Valor total: <strong>R$ 00.000,00</strong></h3><h4 title="...">Nome hotel exemplo</h4><h2 title="...">2 di\xE1rias | 2 Apartamentos</h2><h4 title="...">Falta escolher mais 2 apartamentos</h4><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>01/03/2017</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>01/05/2017</span><br><label>Check-out</label></div></div><button title="Escolher Pr\xF3ximo Apartamento" class="btn time-05 btn-success btn-reservar bnt-lg" ng-click="vm.close()">Escolher Pr\xF3ximo Apto <i class="fa fa-search" aria-hidden="true"></i></button> <button title="Ir para pr\xF3xima Estapa" class="btn time-05 btn-success btn-reservar bnt-lg" ng-click="">Pr\xF3xima Estapa <i class="fa fa-arrow-right" aria-hidden="true"></i></button></section></div></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/confirmacao/modais/openModalMaisDetalhesApartamento.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 class="modal-title" align="center">Seus Apartamentos <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><hr class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl"><h3 class="modal-title" align="center">2 Di\xE1rias <span class="hidden-xs hidden-sm">&nbsp; |&nbsp;</span></h3><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>01/03/2017</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>01/05/2017</span><br><label>Check-out</label></div></div><h3 class="modal-title hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" align="center">Total: R$ 0,000,00</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn time-05 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="cart-list"><div class="row b2c-list-box b2c-row-apto" ng-repeat="i in [0,1,2]"><aside class="col-md-4 b2c-img-box" style="background-image: url(\'assets/images/atrium-flat-service_1.jpg\')"></aside><section class="col-md-7 b2c-caracteristicas"><div class="row b2c-section-header"><div class="col-md-12"><div class="b2c-page-header"><h3 title="...">Nome do Hotel Exemplo</h3></div></div></div><div class="row b2c-section-description"><div class="col-md-12"><p><i class="fa fa-male" aria-hidden="true"></i> 6 Adultos</p><p><i class="fa fa-child" aria-hidden="true"></i> 3 Crian\xE7as</p></div></div><div class="row b2c-list-box-icons"><div class="col-md-12"><h5 title="Detalhes do Hotel">Detalhes do apartamento</h5><hr><div class="icones"><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/laundry-machine.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/super-luxo-stars.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/wifi.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/pool.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/restaurant.png"></div><div uib-tooltip="..." class="icone"><img title="..." alt="..." class="img-responsive" src="assets/images/icons/services/academia.png"></div></div></div></div></section><aside class="col-md-2 box-price"><h5 title="...">Nome do apartamento exemplo</h5><h3 title="Valor do apartamento: R$ ...">R$ 1.200,00</h3><button title="Retirar apartamento" class="btn time-05 btn-sm btn-warning btn-block btn-reservar bnt-lg" ng-click="">Retirar <i class="fa fa-trash-o" aria-hidden="true"></i></button><h6 title="...">Tarifa normal</h6></aside></div><div class="b2c-modal-confirme-footer"><div class="row box"><aside class="hidden-xs hidden-sm col-md-6"><figure class="row"><img title="Confirmar Compra" alt="Confirmar Compra" class="img-responsive" src="assets/images/layout/img-modal-confirme-compra.jpg"></figure></aside><section class="col-md-6"><h3 title="..." class="clear-fix">Valor total: <strong>R$ 00.000,00</strong></h3><h4 title="...">Nome hotel exemplo</h4><h2 title="...">2 di\xE1rias | 2 Apartamentos</h2><h4 title="...">Falta escolher mais 2 apartamentos</h4><div class="b2c-check-data"><div class="check-in"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> <span>01/03/2017</span><br><label>Check-in</label></div><div class="check-out"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> <span>01/05/2017</span><br><label>Check-out</label></div></div><button title="Escolher Pr\xF3ximo Apartamento" class="btn time-05 btn-success btn-reservar bnt-lg" ng-click="vm.close()">Escolher Pr\xF3ximo Apto <i class="fa fa-search" aria-hidden="true"></i></button> <button title="Ir para pr\xF3xima Estapa" class="btn time-05 btn-success btn-reservar bnt-lg" ng-click="">Pr\xF3xima Estapa <i class="fa fa-arrow-right" aria-hidden="true"></i></button></section></div></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/ingressos/modais/openModalConfirmacaoIngressos.html','<div class="b2c-modal b2c-modal-ticket"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="{{vm.comboDayUse.name}}" class="modal-title">{{vm.comboDayUse.name}}</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><div class="row"><figure class="col-md-4 hidden-xs hidden-sm"><img title="Vamos a parte de pagamento" alt="Vamos a parte de pagamento" class="img-responsive" src="assets/images/layout/man-travel.png"></figure><div class="col-md-8"><div class="row box-ticket-uso"><div ng-if="vm.comboDayUse.days > 1 ? true : false" class="col-md-12"><h3 title="Dias de divers\xE3o">{{vm.comboDayUse.days > 1 ? vm.comboDayUse.days + \' dias\' : vm.comboDayUse.days + \' dia\'}} de divers\xE3o<br><small><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{vm.comboDayUse.firstDay | date:\'dd/MM/yyyy\'}} a <i class="fa fa-calendar-times-o" aria-hidden="true"></i> {{vm.comboDayUse.lastDay | date:\'dd/MM/yyyy\'}}</small></h3><div class="box-button-dias pai-flex-md"><div class="box-button-dia filho-flex-md" ng-repeat="dayUse in vm.comboDayUse.arrayDaysUse"><i class="fa fa-calendar" aria-hidden="true"></i><h3 title="Dia de uso: {{dayUse.date| date:\'dd/MM/yyyy\'}}">{{dayUse.date| date:\'dd/MM/yyyy\'}}</h3><h4 title="{{dayUse.date| date:\'EEEE\'}}">{{dayUse.date| date:\'EEEE\'}}</h4></div></div></div><div ng-if="vm.comboDayUse.days <= 1 ? true : false" class="col-md-12"><h2 title="Dia da divers\xE3o">Dia da divers\xE3o</h2><div class="diversao-unica" ng-repeat="dayUse in vm.comboDayUse.arrayDaysUse"><i class="fa fa-calendar" aria-hidden="true"></i><h3 title="Dia de uso: {{dayUse.date| date:\'dd/MM/yyyy\'}}">{{dayUse.date| date:\'dd/MM/yyyy\'}}</h3><h3 title="{{dayUse.date| date:\'EEEE\'}}">{{dayUse.date| date:\'EEEE\'}}</h3></div></div></div><div class="row info-valores"><div class="col-md-12"><h3 title="Valores e quantidade de ingressos">Valores e quantidade de ingressos</h3><blockquote><h5 title="Ingressos Adultos" ng-if="vm.comboDayUse.adultos > 0"><i class="fa fa-ticket" aria-hidden="true"></i> {{vm.comboDayUse.adultos > 1 ? vm.comboDayUse.adulto + \' ingressos tipo\' : vm.comboDayUse.adultos + \' ingresso tipo\'}} Adulto</h5><h5 title="Ingressos Crian\xE7as" ng-if="vm.comboDayUse.chd > 0"><i class="fa fa-ticket" aria-hidden="true"></i> {{vm.comboDayUse.chd > 1 ? vm.comboDayUse.chd + \' ingressos tipo\' : vm.comboDayUse.chd + \' ingresso tipo\'}} Crian\xE7a</h5><h3 title="Valor total para">Valor total: {{ vm.comboDayUse.value / 100 | currency:\'R$ \'}}</h3><h4 ng-if="vm.comboDayUse.days != 1">Desconto de {{ vm.comboDayUse.desconto / 100 | currency:\'R$ \'}}</h4></blockquote></div></div><button title="Ir para tela de pagamento" uib-tooltip="Ir para tela de pagamento" class="btn btn-block btn-success btn-lg time-03" ng-click="vm.ok()"><i class="fa fa-suitcase" aria-hidden="true"></i> Continuar Reserva <i class="fa fa-arrow-right"></i></button></div></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/identificacao/modais/openModalIndentificacaoConclusao.html','<div class="b2c-modal b2c-modal-identificacao"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Todos os h\xF3spedes preenchidos!" class="modal-title">Reserva #{{vm.item.id}} Garantida por 20 minutos!</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div></div></div><div class="modal-body"><div class="row"><figure class="col-md-6"><img title="Vamos a parte de pagamento" alt="Vamos a parte de pagamento" class="img-responsive" src="assets/images/layout/img-suitcases-collection-travel.png"></figure><aside class="col-md-6"><h2 title="Reserva garantida vamos agora para a parte de pagamento!" class="time-05">Reserva garantida vamos agora para a parte de pagamento!</h2><button title="Ir para tela de pagamento" uib-tooltip="Ir para tela de pagamento" class="btn btn-block btn-success btn-lg radius-0 time-03 ripple" ng-click="vm.irParaTelaPagamento()"><i class="fa fa-suitcase" aria-hidden="true"></i> Pagar Agora <i class="fa fa-arrow-right"></i></button><div class="buttonSuport"><a ng-if="\'\'" href="" target="_blank"></a></div></aside></div></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/modais/openModalInfoBoleto.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Informa\xE7\xF5es - Transfer\xEAncia Bancaria" class="modal-title">Informa\xE7\xF5es - Boleto</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><dl><dt>\u2022 Sua reserva estar\xE1 garantida ap\xF3s o pagamento do boleto.</dt><dt>\u2022 Caso voc\xEA n\xE3o confirme o pagamento seu pedido ser\xE1 cancelado.</dt><dt>\u2022 O Voucher ser\xE1 enviado apenas ap\xF3s o reconhecimento do pagamento do boleto pela institui\xE7\xE3o Bancaria. Esse reconhecimento ocorre no primeiro dia \xFAtil ap\xF3s o pagamento</dt></dl></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/modais/openModalInfoCartao.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Informa\xE7\xF5es - Transfer\xEAncia Bancaria" class="modal-title">Informa\xE7\xF5es - Pagamento via Cart\xE3o</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><dl><dt>\u2022 \xC9 OBRIGAT\xD3RIA A APRESENTA\xC7\xC3O DO CART\xC3O DE CR\xC9DITO ULTILIZADO PARA PAGAMENTO DA RESERVA E DOS DOCUMENTOS DE TODOS OS H\xD3SPEDES NO ATO DA ENTRADA DO HOTEL.</dt><dt>\u2022 Caso o cliente n\xE3o esteja de posse do cart\xE3o a compra ser\xE1 cancelada.</dt><dt>\u2022 O cart\xE3o de cr\xE9dito utilizado na compra deve pertencer ao comprador.</dt><dt>\u2022 Ap\xF3s a conclus\xE3o do pagamento o Voucher ser\xE1 liberado.</dt><dt>\u2022 Junto com o voucher ser\xE1 gerado um termo de aceite de compra que dever\xE1 ser entregue assinado na recep\xE7\xE3o do hotel.</dt></dl></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/modais/openModalInfoDeposito.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Informa\xE7\xF5es - Transfer\xEAncia Bancaria" class="modal-title">Informa\xE7\xF5es - Pagamento via Deposito Bancario</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><dl><dt>\u2022 Lorem ipsum dolor sit amet, consectetur adipiscing elit..</dt><dt>\u2022 Phasellus eu ante at metus imperdiet cursus a eu nunc. Integer varius iaculis felis, a egestas est placerat et interdum porta purus..</dt><dt>\u2022 Cras eleifend magna mattis nulla laoreet finibus. Nullam euismod rutrum odio ac pellentesque..</dt></dl></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/modais/openModalInfoKoin.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Informa\xE7\xF5es - Transfer\xEAncia Bancaria" class="modal-title">Informa\xE7\xF5es - Pagamento Koin</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><dl><dt>\u2022 Aten\xE7\xE3o, a Koin n\xE3o \xE9 um boleto tradicional! Comprando com Koin voc\xEA assume um compromisso e deixar de pagar o boleto gera multas e encargos financeiros.</dt><dt>\u2022 Em caso de desist\xEAncia, o cancelamento dever\xE1 ser realizado diretamente com a Enjoy. O valor da multa ser\xE1 estipulado de acordo com a Pol\xEDtica de Cancelamento prevista em nossa Pol\xEDtica de Compra;</dt><dt>\u2022 Em caso de inadimpl\xEAncia, a Koin poder\xE1 solicitar o cancelamento de sua reserva. Portanto, fique atento aos vencimentos dos boletos.</dt><dt>\u2022 \xC9 obrigat\xF3ria a apresenta\xE7\xE3o dos documentos de todos os h\xF3spedes no ato da entrada do hotel.</dt><dt>\u2022 \xC9 obrigat\xF3ria a apresenta\xE7\xE3o do documento original do pagador.</dt><dt>\u2022 Caso o cliente n\xE3o esteja de posse do documento original ou c\xF3pia do pagador, a compra ser\xE1 cancelada.</dt></dl></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/modais/openModalInfoPagSeguro.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Informa\xE7\xF5es - Transfer\xEAncia Bancaria" class="modal-title">Informa\xE7\xF5es - Pagamento via PagSeguro</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><dl><dt>\u2022 Com o sistema de pagamento Online PagSeguro voc\xEA pode dividir sua compra em 2 vezes sem juros, ou se preferir pode parcelar em at\xE9 10 vezes com taxa de parcelamento de 2,99% ao m\xEAs cobrado do comprador a parir da terceira parcela.</dt><dt><br></dt><dt>\u2022 A reserva \xE9 garantida assim que o pagamento estiver com status de "Aprovado", depois de analise do PagSeguro que geralmente acontece em tempo real.</dt></dl></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/modais/openModalInfoPagamentoHotel.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Informa\xE7\xF5es - Transfer\xEAncia Bancaria" class="modal-title">Informa\xE7\xF5es - Pagamento via Pagamento no Hotel</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><dl><dt>\u2022 Lorem ipsum dolor sit amet, consectetur adipiscing elit..</dt><dt>\u2022 Phasellus eu ante at metus imperdiet cursus a eu nunc. Integer varius iaculis felis, a egestas est placerat et interdum porta purus..</dt><dt>\u2022 Cras eleifend magna mattis nulla laoreet finibus. Nullam euismod rutrum odio ac pellentesque..</dt></dl></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/modais/openModalInfoPicPay.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Informa\xE7\xF5es - Pagamento via PicPay" class="modal-title">Informa\xE7\xF5es - Pagamento via PicPay</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><dl><dt>\u2022 Ao selecionar PicPay ser\xE1 gerado um qrcode para pagamento na pr\xF3xima tela.</dt><dt><br></dt></dl></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/modais/openModalInfoPix.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Informa\xE7\xF5es - Pagamento via Pix" class="modal-title">Informa\xE7\xF5es - Pagamento via Pix</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><dl><dt>\u2022 Ao selecionar Pix ser\xE1 gerado um qrcode para pagamento na pr\xF3xima tela.</dt><dt><br></dt><dt>\u2022 Ap\xF3s o pagamento do qrcode, clique no bot\xE3o de verifica\xE7\xE3o do pagamento para que imediatamente o sistema confirme com o banco o recebimento da compra.</dt></dl></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/modais/openModalInfoTransferencia.html','<div class="b2c-modal b2c-modal-apartamentos"><div class="modal-header"><div class="row"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10"><h3 title="Informa\xE7\xF5es - Transfer\xEAncia Bancaria" class="modal-title">Informa\xE7\xF5es - Transfer\xEAncia Bancaria</h3></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><button class="btn radius-0 btn-danger" type="button" ng-click="vm.close()"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div><div class="modal-body"><dl><dt>\u2022 Sua transa\xE7\xE3o \xE9 conclu\xEDda em at\xE9 30 min, a partir da comprova\xE7\xE3o do pagamento.</dt><dt>\u2022 Caso voc\xEA n\xE3o confirme o pagamento seu pedido ser\xE1 cancelado.</dt><dt>\u2022 Aten\xE7\xE3o: n\xE3o aceitamos cheques. Pagamentos feitos via dep\xF3sito em terminais eletr\xF4nicos podem ser autorizados apenas no final do dia \xFAtil.</dt><dt>\u2022 Este servi\xE7o \xE9 realizado pela Empresa Fastcash Processamento de pagamentos.</dt></dl></div><div class="modal-footer"><section class="row b2c-checkin-footer"><div class="col-md-12"><div class="row"><div class="col-md-1 hidden-xs hidden-sm col-md-offset-1"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div><div class="col-md-8"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!">SEGURAN\xC7A E CONFIABILIDADE EM QUALQUER LUGAR!</h5></div><div class="col-md-1 hidden-xs hidden-sm"><h5 title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i class="fa fa-lock" aria-hidden="true"></i></h5></div></div><h5 class="hidden-md hidden-lg hidden-xl hidden-xxl hidden-xxxl" title="Seguran\xE7a e confiabilidade em qualquer lugar!"><i style="font-size: 3em;" class="fa fa-lock" aria-hidden="true"></i></h5></div></section></div></div>');
$templateCache.put('app/hospedagem/pagamento/popovers/PopoverTemplateAgencia.html','<div class="b2c-list-box-icons"><ul class="b2c-payment-methods icones"><li class="b2c-payment-method"><input name="Agencia" type="radio" ng-model="vm.agenciaDeposito" ng-value="AgenciaBancoDoBrasil" id="agencia_do_brasil"> <label uib-tooltip="Banco do Brasil" title="Banco do Brasil" for="agencia_do_brasil" style="background-image: url(../assets/images/logos/icon-banco-do-brasil.png);"></label></li><li class="b2c-payment-method"><input name="Agencia" type="radio" ng-model="vm.agenciaDeposito" ng-value="AgenciaBradesco" id="agencia_bradesco"> <label uib-tooltip="Bradesco" title="Bradesco" for="agencia_bradesco" style="background-image: url(../assets/images/logos/icon-banco-bradesco.png);"></label></li><li class="b2c-payment-method"><input name="Agencia" type="radio" ng-model="vm.agenciaDeposito" ng-value="AgenciaCaixa" id="agencia_caixa"> <label uib-tooltip="Caixa" title="Caixa" for="agencia_caixa" style="background-image: url(../assets/images/logos/icon-banco-caixa.png);"></label></li><li class="b2c-payment-method"><input name="Agencia" type="radio" ng-model="vm.agenciaDeposito" ng-value="AgenciaItau" id="agencia_itau"> <label uib-tooltip="Ita\xFA" title="Ita\xFA" for="agencia_itau" style="background-image: url(../assets/images/logos/icon-banco-itau.png);"></label></li><li class="b2c-payment-method"><input name="Agencia" type="radio" ng-model="vm.agenciaDeposito" ng-value="AgenciaSantander" id="agencia_santander"> <label uib-tooltip="Santander" title="Santander" for="agencia_santander" style="background-image: url(../assets/images/logos/icon-banco-santander.png);"></label></li><li class="b2c-payment-method"><input name="Agencia" type="radio" ng-model="vm.agenciaDeposito" ng-value="AgenciaBanrisul" id="agencia_banrisul"> <label uib-tooltip="Banrisul" title="Banrisul" for="agencia_banrisul" style="background-image: url(../assets/images/logos/icon-banco-banrisul.png);"></label></li><li class="b2c-payment-method"><input name="Agencia" type="radio" ng-model="vm.agenciaDeposito" ng-value="AgenciaCorreios" id="agencia_correiros"> <label uib-tooltip="Correios" title="Correios" for="agencia_correios" style="background-image: url(../assets/images/logos/icon-correios.png);"></label></li><li class="b2c-payment-method"><input name="Agencia" type="radio" ng-model="vm.agenciaDeposito" ng-value="AgenciaTolericas" id="agencia_loterias"> <label uib-tooltip="Loterias" title="Loterias" for="agencia_loterias" style="background-image: url(../assets/images/logos/icon-loterias.png);"></label></li></ul></div>');
$templateCache.put('app/hospedagem/pagamento/popovers/PopoverTemplateBancos.html','<div class="b2c-list-box-icons"><ul class="b2c-payment-methods icones"><li class="b2c-payment-method"><input name="Banco" type="radio" ng-model="vm.bancoTransferencia" ng-value="BancoDoBrasil" id="banco_do_brasil"> <label uib-tooltip="Banco do Brasil" title="Banco do Brasil" for="banco_do_brasil" style="background-image: url(../assets/images/logos/icon-banco-do-brasil.png);"></label></li><li class="b2c-payment-method"><input name="Banco" type="radio" ng-model="vm.bancoTransferencia" ng-value="BancoBradesco" id="banco_bradesco"> <label uib-tooltip="Bradesco" title="Bradesco" for="banco_bradesco" style="background-image: url(../assets/images/logos/icon-banco-bradesco.png);"></label></li><li class="b2c-payment-method"><input name="Banco" type="radio" ng-model="vm.bancoTransferencia" ng-value="BancoCaixa" id="banco_caixa"> <label uib-tooltip="Caixa" title="Caixa" for="banco_caixa" style="background-image: url(../assets/images/logos/icon-banco-caixa.png);"></label></li><li class="b2c-payment-method"><input name="Banco" type="radio" ng-model="vm.bancoTransferencia" ng-value="BancoItau" id="banco_itau"> <label uib-tooltip="Ita\xFA" title="Ita\xFA" for="banco_itau" style="background-image: url(../assets/images/logos/icon-banco-itau.png);"></label></li><li class="b2c-payment-method"><input name="Banco" type="radio" ng-model="vm.bancoTransferencia" ng-value="BancoSantander" id="banco_santander"> <label uib-tooltip="Santander" title="Santander" for="banco_santander" style="background-image: url(../assets/images/logos/icon-banco-santander.png);"></label></li><li class="b2c-payment-method"><input name="Banco" type="radio" ng-model="vm.bancoTransferencia" ng-value="BancoBanrisul" id="banco_banrisul"> <label uib-tooltip="Banrisul" title="Banrisul" for="banco_banrisul" style="background-image: url(../assets/images/logos/icon-banco-banrisul.png);"></label></li></ul></div>');
$templateCache.put('app/hospedagem/pagamento/popovers/PopoverTemplateBandeiraCartao.html','<div class="b2c-list-box-icons"><ul class="b2c-payment-methods icones"><li class="b2c-payment-method"><input name="bandeiraCartao" type="radio" ng-model="vm.bandeiraCartao" ng-value="bandeiraVisa" id="bandeiraVisa"> <label uib-tooltip="Visa" title="American Express" for="bandeiraVisa" style="background-image: url(../assets/images/logos/visa.png);"></label></li><li class="b2c-payment-method"><input name="bandeiraCartao" type="radio" ng-model="vm.bandeiraCartao" ng-value="bandeiraMaster" id="bandeiraMaster"> <label uib-tooltip="Master" title="American Express" for="bandeiraMaster" style="background-image: url(../assets/images/logos/master.png);"></label></li><li class="b2c-payment-method"><input name="bandeiraCartao" type="radio" ng-model="vm.bandeiraCartao" ng-value="bandeiraDiners" id="bandeiraDiners"> <label uib-tooltip="Diners Club Internacional" for="bandeiraDiners" style="background-image: url(../assets/images/logos/diners.png);"></label></li><li class="b2c-payment-method"><input name="bandeiraCartao" type="radio" ng-model="vm.bandeiraCartao" ng-value="bandeiraElo" id="bandeiraElo"> <label uib-tooltip="ELO" title="American Express" for="bandeiraElo" style="background-image: url(../assets/images/logos/elo.png);"></label></li><li class="b2c-payment-method"><input name="bandeiraCartao" type="radio" ng-model="vm.bandeiraCartao" ng-value="bandeiraAmerican" id="bandeiraAmerican"> <label uib-tooltip="American Express" title="American Express" for="bandeiraAmerican" style="background-image: url(../assets/images/logos/amex.png);"></label></li></ul></div>');
$templateCache.put('app/ingressos/modais/templates/template-date-hour.html','<div class="modal-body"><div class="row"><form name="formSelectDates" class="col-md-12 formSelectDates" role="form"><div ng-controller="SelectComboDatesHourController as vm"><div class="row" style="display: flex; flex-direction: column;"><div class="col-xs-12 col-md-6"><div class="form-group quantidade"><label for="">Quantidade</label> <input type="number" class="form-control" ng-model="vm.product.amount" min="{{vm.product.minAmount || 1}}" max="{{vm.product.available}}" ng-change="vm.calculatePrice()" required></div></div><div class="col-xs-12 col-md-12" ng-if="vm.product.type == \'Produto\'"><div class="form-group"><div ng-if="::vm.product.park"><span class="productParkName label label-primary">{{vm.product.park}}</span></div><label for="">{{vm.product.shortName || vm.product.name}}</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-model="vm.product.date" init-date="vm.minDate" min-date="vm.minDate" max-date="vm.maxDate" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false,startingDay:0}" is-open="vm.product.activeDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-click="vm.product.activeDate = true" custom-class="vm.customClass(date, mode, p)" date-disabled="vm.dateDisabled(date, mode, vm.product)" ng-change="vm.product.schedule = null; vm.calculatePrice()" required> <span class="input-group-addon"><button ng-click="vm.product.activeDate = true"><i class="fa fa-calendar"></i></button></span></div><button class="visible-xs-inline-block btn btn-default btn-block" ng-click="vm.openDatePickerModal(vm.product, \'date\')">{{vm.product.date | date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar"></i></button> <input type="hidden" ng-model="vm.product.date" required><div ng-if="vm.product.schedules.length > 0" style="margin: 10px;"><div class="col-md-3 col-xs-4" ng-repeat="hour in vm.product.schedules" ng-if="vm.product._searchSchedules"><div class="form-group"><button class="btn btn-block" ng-disabled="hour.available <= 0" ng-click="vm.selectHour(vm.product, hour); vm.calculatePrice()" ng-class="{\'btn-link\': vm.product.schedule != hour.schedule, \'btn-info\': vm.product.schedule == hour.schedule, \'btn-strike\': hour.available <= 0}">{{hour.schedule}}</button></div></div></div></div></div><div class="col-xs-12 col-md-12" ng-repeat="(i, p) in vm.product.products"><div class="form-group"><div ng-if="::p.park"><span class="productParkName label label-primary">{{p.park}}</span></div><label for="">{{p.shortName || p.name}}</label><div class="input-group hidden-xs"><input type="text" class="form-control" ng-model="p._date" init-date="vm.minDate" min-date="vm.minDate" max-date="vm.maxDate" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="{showWeeks:false,startingDay:0}" is-open="p.activeDate" clear-text="Limpar" close-text="Fechar" current-text="Hoje" ng-click="p.activeDate = true" custom-class="vm.customClass(date, mode, p)" date-disabled="vm.dateDisabled(date, mode, p)" ng-change="p.schedule = null; vm.calculatePrice()" ng-disabled="vm.firstDateDisabled && i === 0" required> <span class="input-group-addon"><button ng-click="p.activeDate = true" ng-disabled="vm.firstDateDisabled && i === 0"><i class="fa fa-calendar" ng-disabled="vm.firstDateDisabled && i === 0"></i></button></span></div><button class="visible-xs-inline-block btn btn-default btn-block" ng-click="vm.openDatePickerModal(p, \'date\')">{{p._date | date:\'dd/MM/yyyy\'}}&nbsp;&nbsp;<i class="fa fa-calendar"></i></button> <input type="hidden" ng-model="p._date" required><div ng-if="p.schedules.length > 0" style="margin: 10px;"><div class="col-md-3 col-xs-4" ng-repeat="hour in p.schedules" ng-if="p._searchSchedules"><div class="form-group"><button class="btn btn-block" ng-disabled="hour.available <= 0" ng-click="vm.selectHour(p, hour); vm.calculatePrice()" ng-class="{\'btn-link\': p.schedule != hour.schedule, \'btn-info\': p.schedule == hour.schedule, \'btn-strike\': hour.available <= 0}">{{hour.schedule}}</button></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><span class="pull-right label label-danger" style="white-space:normal">{{vm.errorMessage()}}</span></div></div></div></form></div></div>');}]);